/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as ClientTypes from './client-scalars';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AiAutocompleteEntities: {
    input: ClientTypes.AiAutocompleteEntities;
    output: ClientTypes.AiAutocompleteEntities;
  };
  AiAutocompleteEntityOutputExtra: {
    input: ClientTypes.AiAutocompleteEntityOutputExtra;
    output: ClientTypes.AiAutocompleteEntityOutputExtra;
  };
  AiCreateEntityActionType: {
    input: ClientTypes.AiCreateEntityActionType;
    output: ClientTypes.AiCreateEntityActionType;
  };
  AiCreateEntityInput: {
    input: ClientTypes.AiCreateEntityInput;
    output: ClientTypes.AiCreateEntityInput;
  };
  AuditTableActions: {
    input: ClientTypes.AuditTableActions;
    output: ClientTypes.AuditTableActions;
  };
  AuditTableHasuraUser: {
    input: ClientTypes.AuditTableHasuraUser;
    output: ClientTypes.AuditTableHasuraUser;
  };
  ClientQquestionMetadata: {
    input: ClientTypes.ClientQquestionMetadata;
    output: ClientTypes.ClientQquestionMetadata;
  };
  ColumnFiltersState: {
    input: ClientTypes.ColumnFiltersState;
    output: ClientTypes.ColumnFiltersState;
  };
  CommentsFragment: { input: any; output: any };
  ControlChangedFields: {
    input: ClientTypes.ControlChangedFields;
    output: ClientTypes.ControlChangedFields;
  };
  ControlDetails: { input: any; output: any };
  ControlEvidenceStatus: {
    input: ClientTypes.ControlEvidenceStatus;
    output: ClientTypes.ControlEvidenceStatus;
  };
  ControlHistoryMetadata: {
    input: ClientTypes.ControlHistoryMetadata;
    output: ClientTypes.ControlHistoryMetadata;
  };
  ControlHistoryTables: {
    input: ClientTypes.ControlHistoryTables;
    output: ClientTypes.ControlHistoryTables;
  };
  ControlRowData: { input: ClientTypes.ControlRowData; output: ClientTypes.ControlRowData };
  ControlStatus: { input: ClientTypes.ControlStatus; output: ClientTypes.ControlStatus };
  ControlTags: { input: ClientTypes.ControlTags; output: ClientTypes.ControlTags };
  ControlsTextSearchDetails: { input: any; output: any };
  DateFieldValue: { input: any; output: any };
  EmailFieldValue: { input: any; output: any };
  Evidence: { input: any; output: any };
  EvidenceChangedFields: {
    input: ClientTypes.EvidenceChangedFields;
    output: ClientTypes.EvidenceChangedFields;
  };
  EvidenceHistoryMetadata: {
    input: ClientTypes.EvidenceHistoryMetadata;
    output: ClientTypes.EvidenceHistoryMetadata;
  };
  EvidenceHistoryTables: {
    input: ClientTypes.EvidenceHistoryTables;
    output: ClientTypes.EvidenceHistoryTables;
  };
  EvidenceProgram: { input: any; output: any };
  EvidenceRowData: { input: ClientTypes.EvidenceRowData; output: ClientTypes.EvidenceRowData };
  EvidenceStatus: { input: ClientTypes.EvidenceStatus; output: ClientTypes.EvidenceStatus };
  EvidenceTextSearchDetails: { input: any; output: any };
  EvidenceVersionType: {
    input: ClientTypes.EvidenceVersionType;
    output: ClientTypes.EvidenceVersionType;
  };
  FieldConfig: { input: any; output: any };
  FieldValue: { input: any; output: any };
  FileInfoFragment: { input: any; output: any };
  FindingTypesEnum: { input: ClientTypes.FindingTypesEnum; output: ClientTypes.FindingTypesEnum };
  FormConfig: { input: ClientTypes.FormConfig; output: ClientTypes.FormConfig };
  IpAddress: { input: ClientTypes.IpAddress; output: ClientTypes.IpAddress };
  LinkedVqCustomField: { input: any; output: any };
  NotificationItem: { input: any; output: any };
  NotificationParams: {
    input: ClientTypes.NotificationParams;
    output: ClientTypes.NotificationParams;
  };
  NumberFieldValue: { input: any; output: any };
  PolicyChangedFields: {
    input: ClientTypes.PolicyChangedFields;
    output: ClientTypes.PolicyChangedFields;
  };
  PolicyDrawerFragment: { input: any; output: any };
  PolicyHistoryMetadata: {
    input: ClientTypes.PolicyHistoryMetadata;
    output: ClientTypes.PolicyHistoryMetadata;
  };
  PolicyHistoryTables: {
    input: ClientTypes.PolicyHistoryTables;
    output: ClientTypes.PolicyHistoryTables;
  };
  PolicyRowData: { input: ClientTypes.PolicyRowData; output: ClientTypes.PolicyRowData };
  QuestionnaireUpload: { input: any; output: any };
  ReviewDetails: { input: any; output: any };
  Risk: { input: any; output: any };
  RiskAssessmentStatus: {
    input: ClientTypes.RiskAssessmentStatus;
    output: ClientTypes.RiskAssessmentStatus;
  };
  RiskChangedFields: {
    input: ClientTypes.RiskChangedFields;
    output: ClientTypes.RiskChangedFields;
  };
  RiskHistoryMetadata: {
    input: ClientTypes.RiskHistoryMetadata;
    output: ClientTypes.RiskHistoryMetadata;
  };
  RiskHistoryTables: {
    input: ClientTypes.RiskHistoryTables;
    output: ClientTypes.RiskHistoryTables;
  };
  RiskRowData: { input: ClientTypes.RiskRowData; output: ClientTypes.RiskRowData };
  RoleDetails: { input: any; output: any };
  SearchControlsOutputData: {
    input: ClientTypes.SearchControlsOutputData;
    output: ClientTypes.SearchControlsOutputData;
  };
  SearchOutputData: { input: ClientTypes.SearchOutputData; output: ClientTypes.SearchOutputData };
  SelectFieldConfig: { input: any; output: any };
  SelectFieldOption: { input: any; output: any };
  SelectFieldValue: { input: any; output: any };
  SortingState: { input: ClientTypes.SortingState; output: ClientTypes.SortingState };
  TaskChangedFields: {
    input: ClientTypes.TaskChangedFields;
    output: ClientTypes.TaskChangedFields;
  };
  TaskDrawerFragment: { input: any; output: any };
  TaskHistoryMetadata: {
    input: ClientTypes.TaskHistoryMetadata;
    output: ClientTypes.TaskHistoryMetadata;
  };
  TaskHistoryTables: {
    input: ClientTypes.TaskHistoryTables;
    output: ClientTypes.TaskHistoryTables;
  };
  TaskRowData: { input: ClientTypes.TaskRowData; output: ClientTypes.TaskRowData };
  TaskStatus: { input: ClientTypes.TaskStatus; output: ClientTypes.TaskStatus };
  TaskTableFragment: { input: any; output: any };
  TasksTextSearchDetails: { input: any; output: any };
  TextFieldValue: { input: any; output: any };
  TrustPortalTheme: { input: ClientTypes.TrustPortalTheme; output: ClientTypes.TrustPortalTheme };
  UrlFieldValue: { input: any; output: any };
  UserMetaData: { input: ClientTypes.UserMetaData; output: ClientTypes.UserMetaData };
  UserNameEmailFragment: { input: any; output: any };
  UserRole: { input: ClientTypes.UserRole; output: ClientTypes.UserRole };
  VendorAssessmentStatus: {
    input: ClientTypes.VendorAssessmentStatus;
    output: ClientTypes.VendorAssessmentStatus;
  };
  VendorChangedFields: {
    input: ClientTypes.VendorChangedFields;
    output: ClientTypes.VendorChangedFields;
  };
  VendorHistoryMetadata: {
    input: ClientTypes.VendorHistoryMetadata;
    output: ClientTypes.VendorHistoryMetadata;
  };
  VendorHistoryTables: {
    input: ClientTypes.VendorHistoryTables;
    output: ClientTypes.VendorHistoryTables;
  };
  VendorQuestionnaireFormAnswerValue: {
    input: ClientTypes.VendorQuestionnaireFormAnswerValue;
    output: ClientTypes.VendorQuestionnaireFormAnswerValue;
  };
  VendorRowData: { input: ClientTypes.VendorRowData; output: ClientTypes.VendorRowData };
  bigint: { input: number; output: number };
  citext: { input: string; output: string };
  float8: { input: number; output: number };
  json: { input: any; output: any };
  jsonb: { input: any; output: any };
  numeric: { input: number; output: number };
  sparsevec: { input: any; output: any };
  timestamp: { input: string; output: string };
  timestamptz: { input: string; output: string };
  uuid: { input: string; output: string };
  vector: { input: any; output: any };
};

export type AcknowledgementReminderInput = {
  acknowledgerId: Scalars['uuid']['input'];
};

export type AcknowledgementReminderOutput = {
  __typename?: 'AcknowledgementReminderOutput';
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type AiAutocompleteEntityInput = {
  entity: Scalars['AiAutocompleteEntities']['input'];
  entityId: Scalars['String']['input'];
  modifier?: InputMaybe<AiAutocompleteModifier>;
};

export type AiAutocompleteEntityOutput = {
  __typename?: 'AiAutocompleteEntityOutput';
  autocomplete: Scalars['String']['output'];
  extra?: Maybe<Scalars['AiAutocompleteEntityOutputExtra']['output']>;
};

export enum AiAutocompleteModifier {
  Improve = 'Improve',
  Lengthen = 'Lengthen',
  Shorten = 'Shorten',
  Simplify = 'Simplify',
}

export type AiControlEvidenceSuggestion = {
  __typename?: 'AiControlEvidenceSuggestion';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AiControlEvidenceSuggestionsInput = {
  controlId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
};

export type AiControlEvidenceSuggestionsOutput = {
  __typename?: 'AiControlEvidenceSuggestionsOutput';
  evidences?: Maybe<Array<AiControlEvidenceSuggestion>>;
};

export type AiCreateEntityOutput = {
  __typename?: 'AiCreateEntityOutput';
  actionType?: Maybe<Scalars['AiCreateEntityActionType']['output']>;
  entityId: Scalars['String']['output'];
  internalId?: Maybe<Scalars['String']['output']>;
  isGeneratedByAI?: Maybe<Scalars['Boolean']['output']>;
};

export type AiEvidenceControlSuggestionsInput = {
  evidenceId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
};

export type AiEvidenceControlSuggestionsOutput = {
  __typename?: 'AiEvidenceControlSuggestionsOutput';
  data: Array<Scalars['SearchControlsOutputData']['output']>;
};

export type AiRiskControlSuggestionsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  riskId: Scalars['uuid']['input'];
  threshold?: InputMaybe<Scalars['Float']['input']>;
};

export type AiRiskControlSuggestionsOutput = {
  __typename?: 'AiRiskControlSuggestionsOutput';
  data: Array<Scalars['SearchControlsOutputData']['output']>;
};

export type ApprovalReminderInput = {
  approverId: Scalars['uuid']['input'];
};

export type ApprovalReminderOutput = {
  __typename?: 'ApprovalReminderOutput';
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BulkSetSelectFieldValuesInput = {
  addValues: Array<Scalars['String']['input']>;
  entityIds: Array<Scalars['String']['input']>;
  fieldConfigId: Scalars['String']['input'];
  removeValues: Array<Scalars['String']['input']>;
  replaceValues: Array<Scalars['String']['input']>;
};

export type BulkUploadPoliciesInput = {
  files: Array<BulkUploadPolicyFileInput>;
  organizationId: Scalars['uuid']['input'];
};

export type BulkUploadPoliciesOutput = {
  __typename?: 'BulkUploadPoliciesOutput';
  ids: Array<Scalars['String']['output']>;
};

export type BulkUploadPolicyFileInput = {
  fileId: Scalars['uuid']['input'];
  fileName: Scalars['String']['input'];
};

export type CreateApiKeyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  ipAllowlist?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  serviceAccountId: Scalars['String']['input'];
};

export type CreateApiKeyOutput = {
  __typename?: 'CreateApiKeyOutput';
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  keyPrefix: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreateControlInput = {
  framework_id?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['String']['input'];
  program_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateControlOutput = {
  __typename?: 'CreateControlOutput';
  id: Scalars['String']['output'];
};

export type CreateCustomProgramRequestInput = {
  fileId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  programDescription: Scalars['String']['input'];
  programName: Scalars['String']['input'];
};

export type CreateCustomProgramRequestOutput = {
  __typename?: 'CreateCustomProgramRequestOutput';
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type CreateManualFindingInput = {
  controlId?: InputMaybe<Scalars['uuid']['input']>;
  description: Scalars['String']['input'];
  manualFindingId?: InputMaybe<Scalars['uuid']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['FindingTypesEnum']['input'];
  vendorQuestionnaireId?: InputMaybe<Scalars['uuid']['input']>;
};

export type CreateManualFindingOutput = {
  __typename?: 'CreateManualFindingOutput';
  findingId: Scalars['uuid']['output'];
};

export type CreateManualIntegrationConnectorInput = {
  authName: Integration_Auth_Names_Enum;
  config: Scalars['json']['input'];
  connectorName: Scalars['String']['input'];
  encryptedConfig: Scalars['json']['input'];
  organizationId: Scalars['uuid']['input'];
  providerId: Scalars['uuid']['input'];
};

export type CreatePolicyVersionSnapshotOutput = {
  __typename?: 'CreatePolicyVersionSnapshotOutput';
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateProgramInput = {
  assignee_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  frameworkType: FrameworkType;
  framework_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organization_id: Scalars['String']['input'];
};

export type CreateServiceAccountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};

export type CreateServiceAccountOutput = {
  __typename?: 'CreateServiceAccountOutput';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CreateVendorFindingTaskInput = {
  /**
   * What to do, why, and what done looks like, used only when the question
   * defines no task.
   */
  description: Scalars['String']['input'];
  findingId: Scalars['uuid']['input'];
  /** Short imperative task name, used only when the question defines no task. */
  name: Scalars['String']['input'];
};

export type CreateVendorFindingTaskOutput = {
  __typename?: 'CreateVendorFindingTaskOutput';
  internalId?: Maybe<Scalars['String']['output']>;
  source: VendorFindingTaskSource;
  taskId: Scalars['uuid']['output'];
};

export type DeleteServiceAccountInput = {
  organizationId: Scalars['String']['input'];
  serviceAccountId: Scalars['String']['input'];
};

export type DeleteServiceAccountOutput = {
  __typename?: 'DeleteServiceAccountOutput';
  id: Scalars['String']['output'];
};

export type DisconnectIntegrationInput = {
  orgIntegrationId: Scalars['uuid']['input'];
};

export type DisconnectMcpConnectionInput = {
  organizationGrantId: Scalars['uuid']['input'];
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
};

export type DisconnectMcpConnectionOutput = {
  __typename?: 'DisconnectMcpConnectionOutput';
  revokedOrganizationGrantIds: Array<Scalars['uuid']['output']>;
};

export type DisconnectTrustPortalNdaGateInput = {
  continuingConnectionId?: InputMaybe<Scalars['uuid']['input']>;
  pageId: Scalars['uuid']['input'];
};

export type DuplicateControlsOutput = {
  __typename?: 'DuplicateControlsOutput';
  evidence_links_skipped: Scalars['Boolean']['output'];
  ids: Array<Scalars['String']['output']>;
  program_links_skipped: Scalars['Boolean']['output'];
};

export type DuplicateEvidencesOutput = {
  __typename?: 'DuplicateEvidencesOutput';
  ids: Array<Scalars['String']['output']>;
};

export type DuplicatePoliciesOutput = {
  __typename?: 'DuplicatePoliciesOutput';
  ids: Array<Scalars['String']['output']>;
};

export type DuplicateProgramInput = {
  name: Scalars['String']['input'];
  programId: Scalars['String']['input'];
};

export type DuplicateQuestionnairesOutput = {
  __typename?: 'DuplicateQuestionnairesOutput';
  ids: Array<Scalars['String']['output']>;
};

export type DuplicateRisksOutput = {
  __typename?: 'DuplicateRisksOutput';
  control_links_skipped: Scalars['Boolean']['output'];
  ids: Array<Scalars['String']['output']>;
};

export type DuplicateTaskOutput = {
  __typename?: 'DuplicateTaskOutput';
  id: Scalars['String']['output'];
};

export type DuplicateTaskParentInput = {
  entityId: Scalars['String']['input'];
  entityType: TaskParentEntityEnum;
};

export type DuplicateTasksOutput = {
  __typename?: 'DuplicateTasksOutput';
  ids: Array<Scalars['String']['output']>;
};

export type DuplicateVendorsOutput = {
  __typename?: 'DuplicateVendorsOutput';
  ids: Array<Scalars['String']['output']>;
  risk_links_skipped: Scalars['Boolean']['output'];
};

export type EmailSenderOrgInput = {
  orgId: Scalars['uuid']['input'];
};

export type EmailSenderSetupOutput = {
  __typename?: 'EmailSenderSetupOutput';
  status: Scalars['String']['output'];
};

export type EmailSenderStatusOutput = {
  __typename?: 'EmailSenderStatusOutput';
  status: Scalars['String']['output'];
};

export type EncryptedConfigFieldState = {
  __typename?: 'EncryptedConfigFieldState';
  configured: Scalars['Boolean']['output'];
  path: Array<Scalars['String']['output']>;
};

export enum EvidenceCheckVerdict {
  /** Nothing to record. */
  Cancel = 'cancel',
  /** The check could not be completed: record a finding, and no evidence version. */
  Error = 'error',
  /** The criteria are not met: record a finding, and no evidence version. */
  NotSatisfied = 'not_satisfied',
  /** The criteria are met: record an evidence version and clear prior AI findings. */
  Satisfied = 'satisfied',
}

export type ExceptionReminderInput = {
  approverId: Scalars['uuid']['input'];
};

export type ExceptionReminderOutput = {
  __typename?: 'ExceptionReminderOutput';
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type ExportClientQuestionnaireInput = {
  client_questionnaire_id: Scalars['uuid']['input'];
};

export type ExportClientQuestionnaireOutput = {
  __typename?: 'ExportClientQuestionnaireOutput';
  file?: Maybe<Files>;
  file_id: Scalars['uuid']['output'];
};

export type ExportPolicyInput = {
  format?: InputMaybe<PolicyExportFormat>;
  policyId: Scalars['uuid']['input'];
  withAcknowledgementsChapter?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovalsChapter?: InputMaybe<Scalars['Boolean']['input']>;
  withApproverDate?: InputMaybe<Scalars['Boolean']['input']>;
  withCompanyLogo?: InputMaybe<Scalars['Boolean']['input']>;
  withRevisionDetails?: InputMaybe<Scalars['Boolean']['input']>;
  withVersionsChapter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExportPolicyOutput = {
  __typename?: 'ExportPolicyOutput';
  fileId: Scalars['uuid']['output'];
};

export type ExportPolicyVersionInput = {
  format?: InputMaybe<PolicyExportFormat>;
  policyVersionId: Scalars['uuid']['input'];
  withAcknowledgementsChapter?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovalsChapter?: InputMaybe<Scalars['Boolean']['input']>;
  withApproverDate?: InputMaybe<Scalars['Boolean']['input']>;
  withCompanyLogo?: InputMaybe<Scalars['Boolean']['input']>;
  withRevisionDetails?: InputMaybe<Scalars['Boolean']['input']>;
  withVersionsChapter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExportVendorInput = {
  organizationId: Scalars['uuid']['input'];
  vendorId: Scalars['uuid']['input'];
  withAiScoring?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovalsChapter?: InputMaybe<Scalars['Boolean']['input']>;
  withFindingsChapter?: InputMaybe<Scalars['Boolean']['input']>;
  withRisksChapter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExportVendorOutput = {
  __typename?: 'ExportVendorOutput';
  fileId: Scalars['uuid']['output'];
};

export type FindingBatchCommandArgs = {
  items: Scalars['jsonb']['input'];
  org_id: Scalars['uuid']['input'];
};

export type FindingCommandOutput = {
  __typename?: 'FindingCommandOutput';
  id: Scalars['uuid']['output'];
  result: Scalars['jsonb']['output'];
};

export type FindingSingleCommandArgs = {
  input: Scalars['jsonb']['input'];
  org_id: Scalars['uuid']['input'];
};

export type FrameworkRequestInput = {
  additionalComments: Scalars['String']['input'];
  frameworkName: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type FrameworkRequestOutput = {
  __typename?: 'FrameworkRequestOutput';
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export enum FrameworkType {
  Custom = 'CUSTOM',
  Template = 'TEMPLATE',
}

export type GenIntegrationRunReportInput = {
  integrationRunId: Scalars['uuid']['input'];
};

export type GenIntegrationRunReportOutput = {
  __typename?: 'GenIntegrationRunReportOutput';
  reportFileId: Scalars['uuid']['output'];
};

export type GeneralActionOutput = {
  __typename?: 'GeneralActionOutput';
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GenerateVendorQuestionnaireLinkInput = {
  vendorQuestionnaireId: Scalars['uuid']['input'];
};

export type GenerateVendorQuestionnaireLinkOutput = {
  __typename?: 'GenerateVendorQuestionnaireLinkOutput';
  link: Scalars['String']['output'];
};

export type GenerateWorkosAdminLinkInput = {
  intent: WorkosAdminPortalIntent;
  orgId: Scalars['String']['input'];
};

export type GenerateWorkosAdminLinkOutput = {
  __typename?: 'GenerateWorkosAdminLinkOutput';
  link?: Maybe<Scalars['String']['output']>;
};

export type GrantEvidenceAccessInput = {
  evidence_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};

export type GrantEvidenceAccessOutput = {
  __typename?: 'GrantEvidenceAccessOutput';
  evidence_acl_id: Scalars['uuid']['output'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['Int']['input']>>;
  _eq?: InputMaybe<Array<Scalars['Int']['input']>>;
  _gt?: InputMaybe<Array<Scalars['Int']['input']>>;
  _gte?: InputMaybe<Array<Scalars['Int']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['Int']['input']>>;
  _lte?: InputMaybe<Array<Scalars['Int']['input']>>;
  _neq?: InputMaybe<Array<Scalars['Int']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InviteUserInput = {
  email: Scalars['String']['input'];
  invitingUserId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  overrideSSOEnforcement?: InputMaybe<Scalars['Boolean']['input']>;
  roleId: Scalars['String']['input'];
};

export type InviteUserOutput = {
  __typename?: 'InviteUserOutput';
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  type?: Maybe<UserInviteResult>;
};

export type JoinOrganizationInput = {
  invitationId: Scalars['uuid']['input'];
};

export type ManualIntegrationConnectorOutput = {
  __typename?: 'ManualIntegrationConnectorOutput';
  connectorId: Scalars['uuid']['output'];
};

export type OrgIntegrationConfigState = {
  __typename?: 'OrgIntegrationConfigState';
  config: Scalars['json']['output'];
  encryptedFields: Array<EncryptedConfigFieldState>;
  orgIntegrationId: Scalars['uuid']['output'];
};

export enum PolicyExportFormat {
  Markdown = 'MARKDOWN',
  Pdf = 'PDF',
}

export type ProgramOutput = {
  __typename?: 'ProgramOutput';
  id: Scalars['String']['output'];
};

export type ReconfigureManualIntegrationConnectorInput = {
  authName: Integration_Auth_Names_Enum;
  config: Scalars['json']['input'];
  connectorId: Scalars['uuid']['input'];
  encryptedConfigPatch: Scalars['json']['input'];
  expectedAuthName: Integration_Auth_Names_Enum;
};

export type RecordEvidenceCheckInput = {
  /** The rendered document. Required when the verdict is satisfied. */
  artifactId?: InputMaybe<Scalars['uuid']['input']>;
  controlId: Scalars['uuid']['input'];
  /**
   * Satisfied only, one of the two: the control's existing evidence this check
   * refreshed with a new version.
   */
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  /**
   * Satisfied only, one of the two: a name for the new evidence this check
   * produced, when none of the control's existing evidence matches what was
   * found.
   */
  evidenceName?: InputMaybe<Scalars['String']['input']>;
  /** The agent's reasoning, shown on the finding it produces. */
  summary: Scalars['String']['input'];
  verdict: EvidenceCheckVerdict;
};

export type RecordEvidenceCheckOutput = {
  __typename?: 'RecordEvidenceCheckOutput';
  /** The evidence the check landed on: the one refreshed, or the one created. */
  evidenceId?: Maybe<Scalars['uuid']['output']>;
  evidenceVersionId?: Maybe<Scalars['uuid']['output']>;
  findingId?: Maybe<Scalars['uuid']['output']>;
  /** How many prior AI findings this check resolved. */
  resolvedFindings: Scalars['Int']['output'];
};

export type RenameIntegrationConnectorInput = {
  connectorId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
};

export type RenameIntegrationConnectorOutput = {
  __typename?: 'RenameIntegrationConnectorOutput';
  connectorId: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
};

export type ResendRiskApprovalRequestInput = {
  approverId: Scalars['uuid']['input'];
  reason: Scalars['String']['input'];
};

export type ResendVendorApprovalRequestInput = {
  approverId: Scalars['uuid']['input'];
  reason: Scalars['String']['input'];
};

export type RevokeEvidenceAccessInput = {
  evidence_acl_id: Scalars['uuid']['input'];
};

export type RevokeEvidenceAccessOutput = {
  __typename?: 'RevokeEvidenceAccessOutput';
  evidence_acl_id: Scalars['uuid']['output'];
};

export type RiskApprovalReminderInput = {
  approverId: Scalars['uuid']['input'];
};

export type RotateApiKeyInput = {
  apiKeyId: Scalars['String']['input'];
  gracePeriodSeconds?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};

export type RotateApiKeyOutput = {
  __typename?: 'RotateApiKeyOutput';
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  keyPrefix: Scalars['String']['output'];
};

export type SaveTrustPortalNdaGateConfigurationInput = {
  organizationIntegrationId: Scalars['uuid']['input'];
  pageId: Scalars['uuid']['input'];
  providerConfiguration: Scalars['json']['input'];
};

export enum SearchEntitiesEnum {
  Controls = 'controls',
  Evidences = 'evidences',
  Policies = 'policies',
  Risks = 'risks',
  Tasks = 'tasks',
  Vendors = 'vendors',
}

export type SearchInput = {
  entities: Array<InputMaybe<SearchEntitiesEnum>>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['uuid']['input'];
  text: Scalars['String']['input'];
};

export type SearchOutput = {
  __typename?: 'SearchOutput';
  data: Array<Scalars['SearchOutputData']['output']>;
};

export type SendPolicyAcknowledgementsInput = {
  allAcknowledgers?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  policyVersionIds: Array<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userIds: Array<Scalars['String']['input']>;
};

export type SendPolicyAcknowledgementsOutput = {
  __typename?: 'SendPolicyAcknowledgementsOutput';
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type SendVendorQuestionnaireInput = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['String']['input'];
  frequency?: InputMaybe<Frequencies_Enum>;
  questionnaireId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  vendors?: InputMaybe<Array<SendVendorQuestionnaireVendorInput>>;
};

export type SendVendorQuestionnaireOutput = {
  __typename?: 'SendVendorQuestionnaireOutput';
  workflowId: Scalars['String']['output'];
};

export type SendVendorQuestionnaireVendorInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type SetEvidenceConfidentialInput = {
  evidence_id: Scalars['uuid']['input'];
  is_confidential: Scalars['Boolean']['input'];
};

export type SetEvidenceConfidentialOutput = {
  __typename?: 'SetEvidenceConfidentialOutput';
  evidence_id: Scalars['uuid']['output'];
};

export type SetOrgIntegrationConfigInput = {
  config: Scalars['json']['input'];
  encryptedConfigPatch: Scalars['json']['input'];
  orgIntegrationId: Scalars['uuid']['input'];
};

export type SetScalarFieldValuesInput = {
  clear?: InputMaybe<Scalars['Boolean']['input']>;
  entityIds: Array<Scalars['uuid']['input']>;
  fieldConfigId: Scalars['uuid']['input'];
  value?: InputMaybe<Scalars['jsonb']['input']>;
};

export type SetSelectFieldValuesInput = {
  entityId: Scalars['String']['input'];
  fieldConfigId: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type SetSelectFieldValuesOutput = {
  __typename?: 'SetSelectFieldValuesOutput';
  deletedFieldValueIds: Array<Scalars['String']['output']>;
  insertedFieldValueIds: Array<Scalars['String']['output']>;
};

export type SetupEmailSenderInput = {
  domain: Scalars['String']['input'];
  fromLocalPart?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['uuid']['input'];
};

export type SetupTrustPortalDomainInput = {
  domain: Scalars['String']['input'];
  orgId: Scalars['uuid']['input'];
};

export type SharepointFileMetadata = {
  __typename?: 'SharepointFileMetadata';
  error?: Maybe<SpFileMetadataError>;
  success?: Maybe<SpFileMetadataSuccess>;
};

export type SpFileMetadataError = {
  __typename?: 'SpFileMetadataError';
  message?: Maybe<Scalars['String']['output']>;
  type: SpFileMetadataErrorType;
};

export enum SpFileMetadataErrorType {
  Forbidden = 'FORBIDDEN',
  InvalidInput = 'INVALID_INPUT',
  NotFound = 'NOT_FOUND',
}

export type SpFileMetadataSuccess = {
  __typename?: 'SpFileMetadataSuccess';
  driveId: Scalars['String']['output'];
  driveName: Scalars['String']['output'];
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export enum TaskParentEntityEnum {
  Control = 'control',
  Evidence = 'evidence',
  Policy = 'policy',
  Risk = 'risk',
  Vendor = 'vendor',
}

export type ToggleRiskCloseOutOutput = {
  __typename?: 'ToggleRiskCloseOutOutput';
  id: Scalars['String']['output'];
};

export type ToggleRisksCloseOutOutput = {
  __typename?: 'ToggleRisksCloseOutOutput';
  ids: Array<Scalars['String']['output']>;
};

export type ToggleTerminateVendorOutput = {
  __typename?: 'ToggleTerminateVendorOutput';
  id: Scalars['String']['output'];
};

export type ToggleTerminateVendorsOutput = {
  __typename?: 'ToggleTerminateVendorsOutput';
  ids: Array<Scalars['String']['output']>;
};

export enum TrustPortalAccessBlockScope {
  Domain = 'domain',
  Requester = 'requester',
}

export type TrustPortalAccessDecisionInput = {
  accessRequestId: Scalars['uuid']['input'];
};

export type TrustPortalAccessDecisionOutput = {
  __typename?: 'TrustPortalAccessDecisionOutput';
  nda_gate_processing_status?: Maybe<Trust_Portal_Nda_Gate_Processing_Statuses_Enum>;
  requestId: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
};

export type TrustPortalAccessLinkOutput = {
  __typename?: 'TrustPortalAccessLinkOutput';
  url: Scalars['String']['output'];
};

export type TrustPortalDomainOrgInput = {
  orgId: Scalars['uuid']['input'];
};

export type TrustPortalDomainStatusOutput = {
  __typename?: 'TrustPortalDomainStatusOutput';
  status: Scalars['String']['output'];
};

export type TrustPortalGrantAccessInput = {
  accessRequestId: Scalars['uuid']['input'];
  durationDays: Scalars['Int']['input'];
};

export type TrustPortalLiftAccessBlockInput = {
  accessBlockId: Scalars['uuid']['input'];
};

export type TrustPortalLiftAccessBlockOutput = {
  __typename?: 'TrustPortalLiftAccessBlockOutput';
  accessBlockId: Scalars['uuid']['output'];
};

export type TrustPortalManualGrantInput = {
  durationDays: Scalars['Int']['input'];
};

export type TrustPortalNdaGateConnectionOutput = {
  __typename?: 'TrustPortalNdaGateConnectionOutput';
  organizationIntegrationId?: Maybe<Scalars['uuid']['output']>;
  pageId: Scalars['uuid']['output'];
};

export type TrustPortalNdaGateDisconnectOutput = {
  __typename?: 'TrustPortalNdaGateDisconnectOutput';
  pageId: Scalars['uuid']['output'];
  status: TrustPortalNdaGateDisconnectStatus;
};

export enum TrustPortalNdaGateDisconnectStatus {
  Disconnected = 'disconnected',
  Draining = 'draining',
}

export type TrustPortalNdaGateLifecycleOutput = {
  __typename?: 'TrustPortalNdaGateLifecycleOutput';
  details?: Maybe<Scalars['json']['output']>;
  pageId: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
};

export type TrustPortalNdaGateProviderDataOutput = {
  __typename?: 'TrustPortalNdaGateProviderDataOutput';
  data: Scalars['json']['output'];
  organizationIntegrationId: Scalars['uuid']['output'];
  provider: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type TrustPortalRevokeAndBlockAccessInput = {
  accessRequestId: Scalars['uuid']['input'];
  reason: Scalars['String']['input'];
  scope: TrustPortalAccessBlockScope;
};

export type TrustPortalRevokeAndBlockAccessOutput = {
  __typename?: 'TrustPortalRevokeAndBlockAccessOutput';
  accessBlockId: Scalars['uuid']['output'];
  requestId: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
};

export type TrustPortalShareAccessInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  manualGrant?: InputMaybe<TrustPortalManualGrantInput>;
  pageId: Scalars['uuid']['input'];
  reason: Trust_Portal_Access_Request_Reasons_Enum;
  requestId: Scalars['uuid']['input'];
};

export type UpdateMcpClientPolicyInput = {
  organizationId: Scalars['uuid']['input'];
  policy: Scalars['jsonb']['input'];
};

export type UpdateMcpClientPolicyOutput = {
  __typename?: 'UpdateMcpClientPolicyOutput';
  organizationId: Scalars['uuid']['output'];
  policy: Scalars['jsonb']['output'];
};

export enum UserInviteResult {
  UserInvited = 'USER_INVITED',
  UserJoined = 'USER_JOINED',
}

export type VendorApprovalReminderInput = {
  approverId: Scalars['uuid']['input'];
};

export enum VendorFindingTaskSource {
  /** The finding already had a task; nothing was created. */
  Existing = 'existing',
  /** The question links an existing task; the finding now points at it. */
  Linked = 'linked',
  /** Created from the proposed name and description. */
  Proposed = 'proposed',
  /** Created from the question's own task name and description. */
  Template = 'template',
}

export enum WorkosAdminPortalIntent {
  AuditLogs = 'audit_logs',
  LogStreams = 'log_streams',
}

/** Per-organization customization for Grove agents. The agent runtime reads this row on every LLM call to compose additional system-prompt instructions (e.g. required intake fields, approval workflows, custom prose). Absent row = no override = run uses static yaml mission. */
export type Agent_Instances = {
  __typename?: 'agent_instances';
  /** An object relationship */
  agent: Grove_Agents;
  /** FK to grove.agents.id. ON DELETE RESTRICT on purpose: dropping a catalog row that has live customer config should fail loudly, never silently cascade. */
  agent_id: Scalars['uuid']['output'];
  /** Schemaless jsonb. Each agent owns its own config shape, validated by a per-agent Zod schema in the corresponding handler. Same precedent as vendor_questionnaire_forms.config_snapshot and forms.config. */
  config: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  enabled: Scalars['Boolean']['output'];
  enabled_at?: Maybe<Scalars['timestamptz']['output']>;
  enabled_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  enabled_by_user?: Maybe<Users>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Per-organization customization for Grove agents. The agent runtime reads this row on every LLM call to compose additional system-prompt instructions (e.g. required intake fields, approval workflows, custom prose). Absent row = no override = run uses static yaml mission. */
export type Agent_InstancesConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "agent_instances" */
export type Agent_Instances_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agent_Instances_Max_Order_By>;
  min?: InputMaybe<Agent_Instances_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Agent_Instances_Append_Input = {
  /** Schemaless jsonb. Each agent owns its own config shape, validated by a per-agent Zod schema in the corresponding handler. Same precedent as vendor_questionnaire_forms.config_snapshot and forms.config. */
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "agent_instances". All fields are combined with a logical 'AND'. */
export type Agent_Instances_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_Instances_Bool_Exp>>;
  _not?: InputMaybe<Agent_Instances_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_Instances_Bool_Exp>>;
  agent?: InputMaybe<Grove_Agents_Bool_Exp>;
  agent_id?: InputMaybe<Uuid_Comparison_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  enabled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  enabled_by?: InputMaybe<Uuid_Comparison_Exp>;
  enabled_by_user?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "agent_instances" */
export enum Agent_Instances_Constraint {
  /** unique or primary key constraint on columns "organization_id", "agent_id" */
  AgentInstancesAgentIdOrganizationIdKey = 'agent_instances_agent_id_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  AgentInstancesPkey = 'agent_instances_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Agent_Instances_Delete_At_Path_Input = {
  /** Schemaless jsonb. Each agent owns its own config shape, validated by a per-agent Zod schema in the corresponding handler. Same precedent as vendor_questionnaire_forms.config_snapshot and forms.config. */
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Agent_Instances_Delete_Elem_Input = {
  /** Schemaless jsonb. Each agent owns its own config shape, validated by a per-agent Zod schema in the corresponding handler. Same precedent as vendor_questionnaire_forms.config_snapshot and forms.config. */
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Agent_Instances_Delete_Key_Input = {
  /** Schemaless jsonb. Each agent owns its own config shape, validated by a per-agent Zod schema in the corresponding handler. Same precedent as vendor_questionnaire_forms.config_snapshot and forms.config. */
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "agent_instances" */
export type Agent_Instances_Insert_Input = {
  /** FK to grove.agents.id. ON DELETE RESTRICT on purpose: dropping a catalog row that has live customer config should fail loudly, never silently cascade. */
  agent_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Schemaless jsonb. Each agent owns its own config shape, validated by a per-agent Zod schema in the corresponding handler. Same precedent as vendor_questionnaire_forms.config_snapshot and forms.config. */
  config?: InputMaybe<Scalars['jsonb']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "agent_instances" */
export type Agent_Instances_Max_Order_By = {
  /** FK to grove.agents.id. ON DELETE RESTRICT on purpose: dropping a catalog row that has live customer config should fail loudly, never silently cascade. */
  agent_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  enabled_at?: InputMaybe<Order_By>;
  enabled_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "agent_instances" */
export type Agent_Instances_Min_Order_By = {
  /** FK to grove.agents.id. ON DELETE RESTRICT on purpose: dropping a catalog row that has live customer config should fail loudly, never silently cascade. */
  agent_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  enabled_at?: InputMaybe<Order_By>;
  enabled_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agent_instances" */
export type Agent_Instances_Mutation_Response = {
  __typename?: 'agent_instances_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Agent_Instances>;
};

/** on_conflict condition type for table "agent_instances" */
export type Agent_Instances_On_Conflict = {
  constraint: Agent_Instances_Constraint;
  update_columns?: Array<Agent_Instances_Update_Column>;
  where?: InputMaybe<Agent_Instances_Bool_Exp>;
};

/** Ordering options when selecting data from "agent_instances". */
export type Agent_Instances_Order_By = {
  agent?: InputMaybe<Grove_Agents_Order_By>;
  agent_id?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  enabled_at?: InputMaybe<Order_By>;
  enabled_by?: InputMaybe<Order_By>;
  enabled_by_user?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agent_instances */
export type Agent_Instances_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Agent_Instances_Prepend_Input = {
  /** Schemaless jsonb. Each agent owns its own config shape, validated by a per-agent Zod schema in the corresponding handler. Same precedent as vendor_questionnaire_forms.config_snapshot and forms.config. */
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "agent_instances" */
export enum Agent_Instances_Select_Column {
  /** column name */
  AgentId = 'agent_id',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  EnabledAt = 'enabled_at',
  /** column name */
  EnabledBy = 'enabled_by',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "agent_instances" */
export type Agent_Instances_Set_Input = {
  /** Schemaless jsonb. Each agent owns its own config shape, validated by a per-agent Zod schema in the corresponding handler. Same precedent as vendor_questionnaire_forms.config_snapshot and forms.config. */
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "agent_instances" */
export type Agent_Instances_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_Instances_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_Instances_Stream_Cursor_Value_Input = {
  /** FK to grove.agents.id. ON DELETE RESTRICT on purpose: dropping a catalog row that has live customer config should fail loudly, never silently cascade. */
  agent_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Schemaless jsonb. Each agent owns its own config shape, validated by a per-agent Zod schema in the corresponding handler. Same precedent as vendor_questionnaire_forms.config_snapshot and forms.config. */
  config?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "agent_instances" */
export enum Agent_Instances_Update_Column {
  /** column name */
  Config = 'config',
}

export type Agent_Instances_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Agent_Instances_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Agent_Instances_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Agent_Instances_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Agent_Instances_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Agent_Instances_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agent_Instances_Set_Input>;
  /** filter the rows which have to be updated */
  where: Agent_Instances_Bool_Exp;
};

export type Ai_Control_Evidences_Suggestions_Args = {
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  search_vector?: InputMaybe<Scalars['vector']['input']>;
  semantic_weight?: InputMaybe<Scalars['float8']['input']>;
  sparse_vector?: InputMaybe<Scalars['sparsevec']['input']>;
};

export type Ai_Control_Evidences_Suggestions_With_Chunks_Args = {
  chunks_per_evidence?: InputMaybe<Scalars['Int']['input']>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  search_vector?: InputMaybe<Scalars['vector']['input']>;
  semantic_weight?: InputMaybe<Scalars['float8']['input']>;
  sparse_vector?: InputMaybe<Scalars['sparsevec']['input']>;
};

export type Ai_Controls_Text_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_query?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ai.controls_vector_store" */
export type Ai_Controls_Vector_Store = {
  __typename?: 'ai_controls_vector_store';
  /** An object relationship */
  control: Controls;
  controls_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  embedding?: Maybe<Scalars['vector']['output']>;
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  next_id?: Maybe<Scalars['String']['output']>;
  node_id?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['String']['output']>;
  previous_id?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  sparse?: Maybe<Scalars['sparsevec']['output']>;
  text: Scalars['String']['output'];
};

/** columns and relationships of "ai.controls_vector_store" */
export type Ai_Controls_Vector_StoreMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "ai.controls_vector_store" */
export type Ai_Controls_Vector_Store_Aggregate_Order_By = {
  avg?: InputMaybe<Ai_Controls_Vector_Store_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ai_Controls_Vector_Store_Max_Order_By>;
  min?: InputMaybe<Ai_Controls_Vector_Store_Min_Order_By>;
  stddev?: InputMaybe<Ai_Controls_Vector_Store_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ai_Controls_Vector_Store_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ai_Controls_Vector_Store_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ai_Controls_Vector_Store_Sum_Order_By>;
  var_pop?: InputMaybe<Ai_Controls_Vector_Store_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ai_Controls_Vector_Store_Var_Samp_Order_By>;
  variance?: InputMaybe<Ai_Controls_Vector_Store_Variance_Order_By>;
};

/** order by avg() on columns of table "ai.controls_vector_store" */
export type Ai_Controls_Vector_Store_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ai.controls_vector_store". All fields are combined with a logical 'AND'. */
export type Ai_Controls_Vector_Store_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Controls_Vector_Store_Bool_Exp>>;
  _not?: InputMaybe<Ai_Controls_Vector_Store_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Controls_Vector_Store_Bool_Exp>>;
  control?: InputMaybe<Controls_Bool_Exp>;
  controls_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  next_id?: InputMaybe<String_Comparison_Exp>;
  node_id?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<String_Comparison_Exp>;
  previous_id?: InputMaybe<String_Comparison_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  sparse?: InputMaybe<Sparsevec_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ai.controls_vector_store" */
export type Ai_Controls_Vector_Store_Max_Order_By = {
  controls_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ai.controls_vector_store" */
export type Ai_Controls_Vector_Store_Min_Order_By = {
  controls_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ai.controls_vector_store". */
export type Ai_Controls_Vector_Store_Order_By = {
  control?: InputMaybe<Controls_Order_By>;
  controls_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  sparse?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

export type Ai_Controls_Vector_Store_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_vector?: InputMaybe<Scalars['vector']['input']>;
  semantic_weight?: InputMaybe<Scalars['float8']['input']>;
  sparse_vector?: InputMaybe<Scalars['sparsevec']['input']>;
};

/** select columns of table "ai.controls_vector_store" */
export enum Ai_Controls_Vector_Store_Select_Column {
  /** column name */
  ControlsId = 'controls_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextId = 'next_id',
  /** column name */
  NodeId = 'node_id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Sparse = 'sparse',
  /** column name */
  Text = 'text',
}

/** order by stddev() on columns of table "ai.controls_vector_store" */
export type Ai_Controls_Vector_Store_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ai.controls_vector_store" */
export type Ai_Controls_Vector_Store_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ai.controls_vector_store" */
export type Ai_Controls_Vector_Store_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "ai.controls_vector_store" */
export type Ai_Controls_Vector_Store_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ai.controls_vector_store" */
export type Ai_Controls_Vector_Store_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ai.controls_vector_store" */
export type Ai_Controls_Vector_Store_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ai.controls_vector_store" */
export type Ai_Controls_Vector_Store_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

export type Ai_Documents_Text_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_query?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ai.documents_vector_store" */
export type Ai_Documents_Vector_Store = {
  __typename?: 'ai_documents_vector_store';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  document: Documents;
  documents_id: Scalars['uuid']['output'];
  embedding?: Maybe<Scalars['vector']['output']>;
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  next_id?: Maybe<Scalars['String']['output']>;
  node_id?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['String']['output']>;
  previous_id?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  sparse?: Maybe<Scalars['sparsevec']['output']>;
  text: Scalars['String']['output'];
};

/** columns and relationships of "ai.documents_vector_store" */
export type Ai_Documents_Vector_StoreMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "ai.documents_vector_store" */
export type Ai_Documents_Vector_Store_Aggregate_Order_By = {
  avg?: InputMaybe<Ai_Documents_Vector_Store_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ai_Documents_Vector_Store_Max_Order_By>;
  min?: InputMaybe<Ai_Documents_Vector_Store_Min_Order_By>;
  stddev?: InputMaybe<Ai_Documents_Vector_Store_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ai_Documents_Vector_Store_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ai_Documents_Vector_Store_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ai_Documents_Vector_Store_Sum_Order_By>;
  var_pop?: InputMaybe<Ai_Documents_Vector_Store_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ai_Documents_Vector_Store_Var_Samp_Order_By>;
  variance?: InputMaybe<Ai_Documents_Vector_Store_Variance_Order_By>;
};

/** order by avg() on columns of table "ai.documents_vector_store" */
export type Ai_Documents_Vector_Store_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ai.documents_vector_store". All fields are combined with a logical 'AND'. */
export type Ai_Documents_Vector_Store_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Documents_Vector_Store_Bool_Exp>>;
  _not?: InputMaybe<Ai_Documents_Vector_Store_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Documents_Vector_Store_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Documents_Bool_Exp>;
  documents_id?: InputMaybe<Uuid_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  next_id?: InputMaybe<String_Comparison_Exp>;
  node_id?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<String_Comparison_Exp>;
  previous_id?: InputMaybe<String_Comparison_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  sparse?: InputMaybe<Sparsevec_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ai.documents_vector_store" */
export type Ai_Documents_Vector_Store_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  documents_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ai.documents_vector_store" */
export type Ai_Documents_Vector_Store_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  documents_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ai.documents_vector_store". */
export type Ai_Documents_Vector_Store_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Documents_Order_By>;
  documents_id?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  sparse?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

export type Ai_Documents_Vector_Store_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_vector?: InputMaybe<Scalars['vector']['input']>;
  semantic_weight?: InputMaybe<Scalars['float8']['input']>;
  sparse_vector?: InputMaybe<Scalars['sparsevec']['input']>;
};

/** select columns of table "ai.documents_vector_store" */
export enum Ai_Documents_Vector_Store_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentsId = 'documents_id',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextId = 'next_id',
  /** column name */
  NodeId = 'node_id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Sparse = 'sparse',
  /** column name */
  Text = 'text',
}

/** order by stddev() on columns of table "ai.documents_vector_store" */
export type Ai_Documents_Vector_Store_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ai.documents_vector_store" */
export type Ai_Documents_Vector_Store_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ai.documents_vector_store" */
export type Ai_Documents_Vector_Store_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ai_documents_vector_store" */
export type Ai_Documents_Vector_Store_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ai_Documents_Vector_Store_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ai_Documents_Vector_Store_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  documents_id?: InputMaybe<Scalars['uuid']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  next_id?: InputMaybe<Scalars['String']['input']>;
  node_id?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['String']['input']>;
  previous_id?: InputMaybe<Scalars['String']['input']>;
  similarity?: InputMaybe<Scalars['float8']['input']>;
  sparse?: InputMaybe<Scalars['sparsevec']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "ai.documents_vector_store" */
export type Ai_Documents_Vector_Store_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ai.documents_vector_store" */
export type Ai_Documents_Vector_Store_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ai.documents_vector_store" */
export type Ai_Documents_Vector_Store_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ai.documents_vector_store" */
export type Ai_Documents_Vector_Store_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

export type Ai_Evidence_Controls_Suggestions_Args = {
  evidence_id?: InputMaybe<Scalars['uuid']['input']>;
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  search_vector?: InputMaybe<Scalars['vector']['input']>;
  semantic_weight?: InputMaybe<Scalars['float8']['input']>;
  sparse_vector?: InputMaybe<Scalars['sparsevec']['input']>;
};

/** columns and relationships of "ai.evidence_suggestion_chunk" */
export type Ai_Evidence_Suggestion_Chunk = {
  __typename?: 'ai_evidence_suggestion_chunk';
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  evidence: Evidences;
  evidence_id: Scalars['uuid']['output'];
  internal_id?: Maybe<Scalars['String']['output']>;
  matched_chunks?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
};

/** Boolean expression to filter rows from the table "ai.evidence_suggestion_chunk". All fields are combined with a logical 'AND'. */
export type Ai_Evidence_Suggestion_Chunk_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Evidence_Suggestion_Chunk_Bool_Exp>>;
  _not?: InputMaybe<Ai_Evidence_Suggestion_Chunk_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Evidence_Suggestion_Chunk_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  evidence?: InputMaybe<Evidences_Bool_Exp>;
  evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_id?: InputMaybe<String_Comparison_Exp>;
  matched_chunks?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
};

/** Ordering options when selecting data from "ai.evidence_suggestion_chunk". */
export type Ai_Evidence_Suggestion_Chunk_Order_By = {
  description?: InputMaybe<Order_By>;
  evidence?: InputMaybe<Evidences_Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  matched_chunks?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
};

/** select columns of table "ai.evidence_suggestion_chunk" */
export enum Ai_Evidence_Suggestion_Chunk_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  EvidenceId = 'evidence_id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  MatchedChunks = 'matched_chunks',
  /** column name */
  Name = 'name',
  /** column name */
  Similarity = 'similarity',
}

export type Ai_Evidences_Text_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_query?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ai.evidences_vector_store" */
export type Ai_Evidences_Vector_Store = {
  __typename?: 'ai_evidences_vector_store';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  embedding?: Maybe<Scalars['vector']['output']>;
  /** An object relationship */
  evidence: Evidences;
  evidences_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  next_id?: Maybe<Scalars['String']['output']>;
  node_id?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['String']['output']>;
  previous_id?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  sparse?: Maybe<Scalars['sparsevec']['output']>;
  text: Scalars['String']['output'];
};

/** columns and relationships of "ai.evidences_vector_store" */
export type Ai_Evidences_Vector_StoreMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "ai.evidences_vector_store" */
export type Ai_Evidences_Vector_Store_Aggregate_Order_By = {
  avg?: InputMaybe<Ai_Evidences_Vector_Store_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ai_Evidences_Vector_Store_Max_Order_By>;
  min?: InputMaybe<Ai_Evidences_Vector_Store_Min_Order_By>;
  stddev?: InputMaybe<Ai_Evidences_Vector_Store_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ai_Evidences_Vector_Store_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ai_Evidences_Vector_Store_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ai_Evidences_Vector_Store_Sum_Order_By>;
  var_pop?: InputMaybe<Ai_Evidences_Vector_Store_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ai_Evidences_Vector_Store_Var_Samp_Order_By>;
  variance?: InputMaybe<Ai_Evidences_Vector_Store_Variance_Order_By>;
};

/** order by avg() on columns of table "ai.evidences_vector_store" */
export type Ai_Evidences_Vector_Store_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ai.evidences_vector_store". All fields are combined with a logical 'AND'. */
export type Ai_Evidences_Vector_Store_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Evidences_Vector_Store_Bool_Exp>>;
  _not?: InputMaybe<Ai_Evidences_Vector_Store_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Evidences_Vector_Store_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  evidence?: InputMaybe<Evidences_Bool_Exp>;
  evidences_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  next_id?: InputMaybe<String_Comparison_Exp>;
  node_id?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<String_Comparison_Exp>;
  previous_id?: InputMaybe<String_Comparison_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  sparse?: InputMaybe<Sparsevec_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ai.evidences_vector_store" */
export type Ai_Evidences_Vector_Store_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidences_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ai.evidences_vector_store" */
export type Ai_Evidences_Vector_Store_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidences_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ai.evidences_vector_store". */
export type Ai_Evidences_Vector_Store_Order_By = {
  created_at?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  evidence?: InputMaybe<Evidences_Order_By>;
  evidences_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  sparse?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

export type Ai_Evidences_Vector_Store_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_vector?: InputMaybe<Scalars['vector']['input']>;
  semantic_weight?: InputMaybe<Scalars['float8']['input']>;
  sparse_vector?: InputMaybe<Scalars['sparsevec']['input']>;
};

/** select columns of table "ai.evidences_vector_store" */
export enum Ai_Evidences_Vector_Store_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  EvidencesId = 'evidences_id',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextId = 'next_id',
  /** column name */
  NodeId = 'node_id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Sparse = 'sparse',
  /** column name */
  Text = 'text',
}

/** order by stddev() on columns of table "ai.evidences_vector_store" */
export type Ai_Evidences_Vector_Store_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ai.evidences_vector_store" */
export type Ai_Evidences_Vector_Store_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ai.evidences_vector_store" */
export type Ai_Evidences_Vector_Store_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "ai.evidences_vector_store" */
export type Ai_Evidences_Vector_Store_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ai.evidences_vector_store" */
export type Ai_Evidences_Vector_Store_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ai.evidences_vector_store" */
export type Ai_Evidences_Vector_Store_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ai.evidences_vector_store" */
export type Ai_Evidences_Vector_Store_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

export type Ai_Policies_Text_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_query?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ai.policies_vector_store" */
export type Ai_Policies_Vector_Store = {
  __typename?: 'ai_policies_vector_store';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  embedding?: Maybe<Scalars['vector']['output']>;
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  next_id?: Maybe<Scalars['String']['output']>;
  node_id?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['String']['output']>;
  policies_id: Scalars['uuid']['output'];
  /** An object relationship */
  policy: Policies;
  previous_id?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  sparse?: Maybe<Scalars['sparsevec']['output']>;
  text: Scalars['String']['output'];
};

/** columns and relationships of "ai.policies_vector_store" */
export type Ai_Policies_Vector_StoreMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "ai.policies_vector_store" */
export type Ai_Policies_Vector_Store_Aggregate_Order_By = {
  avg?: InputMaybe<Ai_Policies_Vector_Store_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ai_Policies_Vector_Store_Max_Order_By>;
  min?: InputMaybe<Ai_Policies_Vector_Store_Min_Order_By>;
  stddev?: InputMaybe<Ai_Policies_Vector_Store_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ai_Policies_Vector_Store_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ai_Policies_Vector_Store_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ai_Policies_Vector_Store_Sum_Order_By>;
  var_pop?: InputMaybe<Ai_Policies_Vector_Store_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ai_Policies_Vector_Store_Var_Samp_Order_By>;
  variance?: InputMaybe<Ai_Policies_Vector_Store_Variance_Order_By>;
};

/** order by avg() on columns of table "ai.policies_vector_store" */
export type Ai_Policies_Vector_Store_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ai.policies_vector_store". All fields are combined with a logical 'AND'. */
export type Ai_Policies_Vector_Store_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Policies_Vector_Store_Bool_Exp>>;
  _not?: InputMaybe<Ai_Policies_Vector_Store_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Policies_Vector_Store_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  next_id?: InputMaybe<String_Comparison_Exp>;
  node_id?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<String_Comparison_Exp>;
  policies_id?: InputMaybe<Uuid_Comparison_Exp>;
  policy?: InputMaybe<Policies_Bool_Exp>;
  previous_id?: InputMaybe<String_Comparison_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  sparse?: InputMaybe<Sparsevec_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ai.policies_vector_store" */
export type Ai_Policies_Vector_Store_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  policies_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ai.policies_vector_store" */
export type Ai_Policies_Vector_Store_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  policies_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ai.policies_vector_store". */
export type Ai_Policies_Vector_Store_Order_By = {
  created_at?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  policies_id?: InputMaybe<Order_By>;
  policy?: InputMaybe<Policies_Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  sparse?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

export type Ai_Policies_Vector_Store_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_vector?: InputMaybe<Scalars['vector']['input']>;
  semantic_weight?: InputMaybe<Scalars['float8']['input']>;
  sparse_vector?: InputMaybe<Scalars['sparsevec']['input']>;
};

/** select columns of table "ai.policies_vector_store" */
export enum Ai_Policies_Vector_Store_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextId = 'next_id',
  /** column name */
  NodeId = 'node_id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PoliciesId = 'policies_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Sparse = 'sparse',
  /** column name */
  Text = 'text',
}

/** order by stddev() on columns of table "ai.policies_vector_store" */
export type Ai_Policies_Vector_Store_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ai.policies_vector_store" */
export type Ai_Policies_Vector_Store_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ai.policies_vector_store" */
export type Ai_Policies_Vector_Store_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ai_policies_vector_store" */
export type Ai_Policies_Vector_Store_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ai_Policies_Vector_Store_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ai_Policies_Vector_Store_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  next_id?: InputMaybe<Scalars['String']['input']>;
  node_id?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['String']['input']>;
  policies_id?: InputMaybe<Scalars['uuid']['input']>;
  previous_id?: InputMaybe<Scalars['String']['input']>;
  similarity?: InputMaybe<Scalars['float8']['input']>;
  sparse?: InputMaybe<Scalars['sparsevec']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "ai.policies_vector_store" */
export type Ai_Policies_Vector_Store_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ai.policies_vector_store" */
export type Ai_Policies_Vector_Store_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ai.policies_vector_store" */
export type Ai_Policies_Vector_Store_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ai.policies_vector_store" */
export type Ai_Policies_Vector_Store_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

export type Ai_Programs_Text_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_query?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ai.programs_vector_store" */
export type Ai_Programs_Vector_Store = {
  __typename?: 'ai_programs_vector_store';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  embedding?: Maybe<Scalars['vector']['output']>;
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  next_id?: Maybe<Scalars['String']['output']>;
  node_id?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['String']['output']>;
  previous_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  program: Programs;
  programs_id: Scalars['uuid']['output'];
  similarity?: Maybe<Scalars['float8']['output']>;
  sparse?: Maybe<Scalars['sparsevec']['output']>;
  text: Scalars['String']['output'];
};

/** columns and relationships of "ai.programs_vector_store" */
export type Ai_Programs_Vector_StoreMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "ai.programs_vector_store" */
export type Ai_Programs_Vector_Store_Aggregate_Order_By = {
  avg?: InputMaybe<Ai_Programs_Vector_Store_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ai_Programs_Vector_Store_Max_Order_By>;
  min?: InputMaybe<Ai_Programs_Vector_Store_Min_Order_By>;
  stddev?: InputMaybe<Ai_Programs_Vector_Store_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ai_Programs_Vector_Store_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ai_Programs_Vector_Store_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ai_Programs_Vector_Store_Sum_Order_By>;
  var_pop?: InputMaybe<Ai_Programs_Vector_Store_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ai_Programs_Vector_Store_Var_Samp_Order_By>;
  variance?: InputMaybe<Ai_Programs_Vector_Store_Variance_Order_By>;
};

/** order by avg() on columns of table "ai.programs_vector_store" */
export type Ai_Programs_Vector_Store_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ai.programs_vector_store". All fields are combined with a logical 'AND'. */
export type Ai_Programs_Vector_Store_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Programs_Vector_Store_Bool_Exp>>;
  _not?: InputMaybe<Ai_Programs_Vector_Store_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Programs_Vector_Store_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  next_id?: InputMaybe<String_Comparison_Exp>;
  node_id?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<String_Comparison_Exp>;
  previous_id?: InputMaybe<String_Comparison_Exp>;
  program?: InputMaybe<Programs_Bool_Exp>;
  programs_id?: InputMaybe<Uuid_Comparison_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  sparse?: InputMaybe<Sparsevec_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ai.programs_vector_store" */
export type Ai_Programs_Vector_Store_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  programs_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ai.programs_vector_store" */
export type Ai_Programs_Vector_Store_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  programs_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ai.programs_vector_store". */
export type Ai_Programs_Vector_Store_Order_By = {
  created_at?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  program?: InputMaybe<Programs_Order_By>;
  programs_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  sparse?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

export type Ai_Programs_Vector_Store_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_vector?: InputMaybe<Scalars['vector']['input']>;
  semantic_weight?: InputMaybe<Scalars['float8']['input']>;
  sparse_vector?: InputMaybe<Scalars['sparsevec']['input']>;
};

/** select columns of table "ai.programs_vector_store" */
export enum Ai_Programs_Vector_Store_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextId = 'next_id',
  /** column name */
  NodeId = 'node_id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  ProgramsId = 'programs_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Sparse = 'sparse',
  /** column name */
  Text = 'text',
}

/** order by stddev() on columns of table "ai.programs_vector_store" */
export type Ai_Programs_Vector_Store_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ai.programs_vector_store" */
export type Ai_Programs_Vector_Store_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ai.programs_vector_store" */
export type Ai_Programs_Vector_Store_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "ai.programs_vector_store" */
export type Ai_Programs_Vector_Store_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ai.programs_vector_store" */
export type Ai_Programs_Vector_Store_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ai.programs_vector_store" */
export type Ai_Programs_Vector_Store_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ai.programs_vector_store" */
export type Ai_Programs_Vector_Store_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

export type Ai_Relevant_Policy_Controls_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  search_vector?: InputMaybe<Scalars['vector']['input']>;
  semantic_weight?: InputMaybe<Scalars['float8']['input']>;
  sparse_vector?: InputMaybe<Scalars['sparsevec']['input']>;
};

export type Ai_Risk_Controls_Suggestions_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
  search_vector?: InputMaybe<Scalars['vector']['input']>;
  semantic_weight?: InputMaybe<Scalars['float8']['input']>;
  sparse_vector?: InputMaybe<Scalars['sparsevec']['input']>;
};

export type Ai_Risks_Text_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_query?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ai.risks_vector_store" */
export type Ai_Risks_Vector_Store = {
  __typename?: 'ai_risks_vector_store';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  embedding?: Maybe<Scalars['vector']['output']>;
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  next_id?: Maybe<Scalars['String']['output']>;
  node_id?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['String']['output']>;
  previous_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  risk: Risks;
  risks_id: Scalars['uuid']['output'];
  similarity?: Maybe<Scalars['float8']['output']>;
  sparse?: Maybe<Scalars['sparsevec']['output']>;
  text: Scalars['String']['output'];
};

/** columns and relationships of "ai.risks_vector_store" */
export type Ai_Risks_Vector_StoreMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "ai.risks_vector_store" */
export type Ai_Risks_Vector_Store_Aggregate_Order_By = {
  avg?: InputMaybe<Ai_Risks_Vector_Store_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ai_Risks_Vector_Store_Max_Order_By>;
  min?: InputMaybe<Ai_Risks_Vector_Store_Min_Order_By>;
  stddev?: InputMaybe<Ai_Risks_Vector_Store_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ai_Risks_Vector_Store_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ai_Risks_Vector_Store_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ai_Risks_Vector_Store_Sum_Order_By>;
  var_pop?: InputMaybe<Ai_Risks_Vector_Store_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ai_Risks_Vector_Store_Var_Samp_Order_By>;
  variance?: InputMaybe<Ai_Risks_Vector_Store_Variance_Order_By>;
};

/** order by avg() on columns of table "ai.risks_vector_store" */
export type Ai_Risks_Vector_Store_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ai.risks_vector_store". All fields are combined with a logical 'AND'. */
export type Ai_Risks_Vector_Store_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Risks_Vector_Store_Bool_Exp>>;
  _not?: InputMaybe<Ai_Risks_Vector_Store_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Risks_Vector_Store_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  next_id?: InputMaybe<String_Comparison_Exp>;
  node_id?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<String_Comparison_Exp>;
  previous_id?: InputMaybe<String_Comparison_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risks_id?: InputMaybe<Uuid_Comparison_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  sparse?: InputMaybe<Sparsevec_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ai.risks_vector_store" */
export type Ai_Risks_Vector_Store_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  risks_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ai.risks_vector_store" */
export type Ai_Risks_Vector_Store_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  risks_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ai.risks_vector_store". */
export type Ai_Risks_Vector_Store_Order_By = {
  created_at?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risks_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  sparse?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

export type Ai_Risks_Vector_Store_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_vector?: InputMaybe<Scalars['vector']['input']>;
  semantic_weight?: InputMaybe<Scalars['float8']['input']>;
  sparse_vector?: InputMaybe<Scalars['sparsevec']['input']>;
};

/** select columns of table "ai.risks_vector_store" */
export enum Ai_Risks_Vector_Store_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextId = 'next_id',
  /** column name */
  NodeId = 'node_id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  RisksId = 'risks_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Sparse = 'sparse',
  /** column name */
  Text = 'text',
}

/** order by stddev() on columns of table "ai.risks_vector_store" */
export type Ai_Risks_Vector_Store_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ai.risks_vector_store" */
export type Ai_Risks_Vector_Store_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ai.risks_vector_store" */
export type Ai_Risks_Vector_Store_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "ai.risks_vector_store" */
export type Ai_Risks_Vector_Store_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ai.risks_vector_store" */
export type Ai_Risks_Vector_Store_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ai.risks_vector_store" */
export type Ai_Risks_Vector_Store_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ai.risks_vector_store" */
export type Ai_Risks_Vector_Store_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

export type Ai_Tasks_Text_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_query?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ai.tasks_vector_store" */
export type Ai_Tasks_Vector_Store = {
  __typename?: 'ai_tasks_vector_store';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  embedding?: Maybe<Scalars['vector']['output']>;
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  next_id?: Maybe<Scalars['String']['output']>;
  node_id?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['String']['output']>;
  previous_id?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  sparse?: Maybe<Scalars['sparsevec']['output']>;
  /** An object relationship */
  task: Tasks;
  tasks_id: Scalars['uuid']['output'];
  text: Scalars['String']['output'];
};

/** columns and relationships of "ai.tasks_vector_store" */
export type Ai_Tasks_Vector_StoreMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "ai.tasks_vector_store" */
export type Ai_Tasks_Vector_Store_Aggregate_Order_By = {
  avg?: InputMaybe<Ai_Tasks_Vector_Store_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ai_Tasks_Vector_Store_Max_Order_By>;
  min?: InputMaybe<Ai_Tasks_Vector_Store_Min_Order_By>;
  stddev?: InputMaybe<Ai_Tasks_Vector_Store_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ai_Tasks_Vector_Store_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ai_Tasks_Vector_Store_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ai_Tasks_Vector_Store_Sum_Order_By>;
  var_pop?: InputMaybe<Ai_Tasks_Vector_Store_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ai_Tasks_Vector_Store_Var_Samp_Order_By>;
  variance?: InputMaybe<Ai_Tasks_Vector_Store_Variance_Order_By>;
};

/** order by avg() on columns of table "ai.tasks_vector_store" */
export type Ai_Tasks_Vector_Store_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ai.tasks_vector_store". All fields are combined with a logical 'AND'. */
export type Ai_Tasks_Vector_Store_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Tasks_Vector_Store_Bool_Exp>>;
  _not?: InputMaybe<Ai_Tasks_Vector_Store_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Tasks_Vector_Store_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  next_id?: InputMaybe<String_Comparison_Exp>;
  node_id?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<String_Comparison_Exp>;
  previous_id?: InputMaybe<String_Comparison_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  sparse?: InputMaybe<Sparsevec_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  tasks_id?: InputMaybe<Uuid_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ai.tasks_vector_store" */
export type Ai_Tasks_Vector_Store_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  tasks_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ai.tasks_vector_store" */
export type Ai_Tasks_Vector_Store_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  tasks_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ai.tasks_vector_store". */
export type Ai_Tasks_Vector_Store_Order_By = {
  created_at?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  sparse?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  tasks_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

export type Ai_Tasks_Vector_Store_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_vector?: InputMaybe<Scalars['vector']['input']>;
  semantic_weight?: InputMaybe<Scalars['float8']['input']>;
  sparse_vector?: InputMaybe<Scalars['sparsevec']['input']>;
};

/** select columns of table "ai.tasks_vector_store" */
export enum Ai_Tasks_Vector_Store_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextId = 'next_id',
  /** column name */
  NodeId = 'node_id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Sparse = 'sparse',
  /** column name */
  TasksId = 'tasks_id',
  /** column name */
  Text = 'text',
}

/** order by stddev() on columns of table "ai.tasks_vector_store" */
export type Ai_Tasks_Vector_Store_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ai.tasks_vector_store" */
export type Ai_Tasks_Vector_Store_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ai.tasks_vector_store" */
export type Ai_Tasks_Vector_Store_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "ai.tasks_vector_store" */
export type Ai_Tasks_Vector_Store_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ai.tasks_vector_store" */
export type Ai_Tasks_Vector_Store_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ai.tasks_vector_store" */
export type Ai_Tasks_Vector_Store_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ai.tasks_vector_store" */
export type Ai_Tasks_Vector_Store_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

export type Ai_Vendors_Text_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_query?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ai.vendors_vector_store" */
export type Ai_Vendors_Vector_Store = {
  __typename?: 'ai_vendors_vector_store';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  embedding?: Maybe<Scalars['vector']['output']>;
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  next_id?: Maybe<Scalars['String']['output']>;
  node_id?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['String']['output']>;
  previous_id?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  sparse?: Maybe<Scalars['sparsevec']['output']>;
  text: Scalars['String']['output'];
  /** An object relationship */
  vendor: Vendors;
  vendors_id: Scalars['uuid']['output'];
};

/** columns and relationships of "ai.vendors_vector_store" */
export type Ai_Vendors_Vector_StoreMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "ai.vendors_vector_store" */
export type Ai_Vendors_Vector_Store_Aggregate_Order_By = {
  avg?: InputMaybe<Ai_Vendors_Vector_Store_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ai_Vendors_Vector_Store_Max_Order_By>;
  min?: InputMaybe<Ai_Vendors_Vector_Store_Min_Order_By>;
  stddev?: InputMaybe<Ai_Vendors_Vector_Store_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ai_Vendors_Vector_Store_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ai_Vendors_Vector_Store_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ai_Vendors_Vector_Store_Sum_Order_By>;
  var_pop?: InputMaybe<Ai_Vendors_Vector_Store_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ai_Vendors_Vector_Store_Var_Samp_Order_By>;
  variance?: InputMaybe<Ai_Vendors_Vector_Store_Variance_Order_By>;
};

/** order by avg() on columns of table "ai.vendors_vector_store" */
export type Ai_Vendors_Vector_Store_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ai.vendors_vector_store". All fields are combined with a logical 'AND'. */
export type Ai_Vendors_Vector_Store_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Vendors_Vector_Store_Bool_Exp>>;
  _not?: InputMaybe<Ai_Vendors_Vector_Store_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Vendors_Vector_Store_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  next_id?: InputMaybe<String_Comparison_Exp>;
  node_id?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<String_Comparison_Exp>;
  previous_id?: InputMaybe<String_Comparison_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  sparse?: InputMaybe<Sparsevec_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendors_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "ai.vendors_vector_store" */
export type Ai_Vendors_Vector_Store_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  vendors_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ai.vendors_vector_store" */
export type Ai_Vendors_Vector_Store_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  vendors_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ai.vendors_vector_store". */
export type Ai_Vendors_Vector_Store_Order_By = {
  created_at?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  node_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  sparse?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendors_id?: InputMaybe<Order_By>;
};

export type Ai_Vendors_Vector_Store_Search_Args = {
  limit_number?: InputMaybe<Scalars['Int']['input']>;
  metadata_filter?: InputMaybe<Scalars['jsonb']['input']>;
  offset_number?: InputMaybe<Scalars['Int']['input']>;
  search_vector?: InputMaybe<Scalars['vector']['input']>;
  semantic_weight?: InputMaybe<Scalars['float8']['input']>;
  sparse_vector?: InputMaybe<Scalars['sparsevec']['input']>;
};

/** select columns of table "ai.vendors_vector_store" */
export enum Ai_Vendors_Vector_Store_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextId = 'next_id',
  /** column name */
  NodeId = 'node_id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Sparse = 'sparse',
  /** column name */
  Text = 'text',
  /** column name */
  VendorsId = 'vendors_id',
}

/** order by stddev() on columns of table "ai.vendors_vector_store" */
export type Ai_Vendors_Vector_Store_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ai.vendors_vector_store" */
export type Ai_Vendors_Vector_Store_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ai.vendors_vector_store" */
export type Ai_Vendors_Vector_Store_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "ai.vendors_vector_store" */
export type Ai_Vendors_Vector_Store_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ai.vendors_vector_store" */
export type Ai_Vendors_Vector_Store_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ai.vendors_vector_store" */
export type Ai_Vendors_Vector_Store_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ai.vendors_vector_store" */
export type Ai_Vendors_Vector_Store_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Audit log of every API request made with an API key. Used for usage analytics, security auditing, and rate limit monitoring. */
export type Api_Key_Usage_Logs = {
  __typename?: 'api_key_usage_logs';
  /** An object relationship */
  api_key?: Maybe<Api_Keys>;
  api_key_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  endpoint: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  ip_address?: Maybe<Scalars['IpAddress']['output']>;
  method: Scalars['String']['output'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  request_id?: Maybe<Scalars['String']['output']>;
  response_time_ms?: Maybe<Scalars['Int']['output']>;
  status_code: Scalars['Int']['output'];
  user_agent?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Aggregate = {
  __typename?: 'api_key_usage_logs_aggregate';
  aggregate?: Maybe<Api_Key_Usage_Logs_Aggregate_Fields>;
  nodes: Array<Api_Key_Usage_Logs>;
};

export type Api_Key_Usage_Logs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Api_Key_Usage_Logs_Aggregate_Bool_Exp_Count>;
};

export type Api_Key_Usage_Logs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Api_Key_Usage_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Api_Key_Usage_Logs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Aggregate_Fields = {
  __typename?: 'api_key_usage_logs_aggregate_fields';
  avg?: Maybe<Api_Key_Usage_Logs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Api_Key_Usage_Logs_Max_Fields>;
  min?: Maybe<Api_Key_Usage_Logs_Min_Fields>;
  stddev?: Maybe<Api_Key_Usage_Logs_Stddev_Fields>;
  stddev_pop?: Maybe<Api_Key_Usage_Logs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Api_Key_Usage_Logs_Stddev_Samp_Fields>;
  sum?: Maybe<Api_Key_Usage_Logs_Sum_Fields>;
  var_pop?: Maybe<Api_Key_Usage_Logs_Var_Pop_Fields>;
  var_samp?: Maybe<Api_Key_Usage_Logs_Var_Samp_Fields>;
  variance?: Maybe<Api_Key_Usage_Logs_Variance_Fields>;
};

/** aggregate fields of "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Api_Key_Usage_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Aggregate_Order_By = {
  avg?: InputMaybe<Api_Key_Usage_Logs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Api_Key_Usage_Logs_Max_Order_By>;
  min?: InputMaybe<Api_Key_Usage_Logs_Min_Order_By>;
  stddev?: InputMaybe<Api_Key_Usage_Logs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Api_Key_Usage_Logs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Api_Key_Usage_Logs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Api_Key_Usage_Logs_Sum_Order_By>;
  var_pop?: InputMaybe<Api_Key_Usage_Logs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Api_Key_Usage_Logs_Var_Samp_Order_By>;
  variance?: InputMaybe<Api_Key_Usage_Logs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Api_Key_Usage_Logs_Avg_Fields = {
  __typename?: 'api_key_usage_logs_avg_fields';
  response_time_ms?: Maybe<Scalars['Float']['output']>;
  status_code?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Avg_Order_By = {
  response_time_ms?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "api_key_usage_logs". All fields are combined with a logical 'AND'. */
export type Api_Key_Usage_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Api_Key_Usage_Logs_Bool_Exp>>;
  _not?: InputMaybe<Api_Key_Usage_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Api_Key_Usage_Logs_Bool_Exp>>;
  api_key?: InputMaybe<Api_Keys_Bool_Exp>;
  api_key_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  endpoint?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ip_address?: InputMaybe<String_Comparison_Exp>;
  method?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  request_id?: InputMaybe<String_Comparison_Exp>;
  response_time_ms?: InputMaybe<Int_Comparison_Exp>;
  status_code?: InputMaybe<Int_Comparison_Exp>;
  user_agent?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Api_Key_Usage_Logs_Max_Fields = {
  __typename?: 'api_key_usage_logs_max_fields';
  api_key_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  request_id?: Maybe<Scalars['String']['output']>;
  response_time_ms?: Maybe<Scalars['Int']['output']>;
  status_code?: Maybe<Scalars['Int']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Max_Order_By = {
  api_key_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  endpoint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  response_time_ms?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
  user_agent?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Api_Key_Usage_Logs_Min_Fields = {
  __typename?: 'api_key_usage_logs_min_fields';
  api_key_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  request_id?: Maybe<Scalars['String']['output']>;
  response_time_ms?: Maybe<Scalars['Int']['output']>;
  status_code?: Maybe<Scalars['Int']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Min_Order_By = {
  api_key_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  endpoint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  response_time_ms?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
  user_agent?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "api_key_usage_logs". */
export type Api_Key_Usage_Logs_Order_By = {
  api_key?: InputMaybe<Api_Keys_Order_By>;
  api_key_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  endpoint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  response_time_ms?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
  user_agent?: InputMaybe<Order_By>;
};

/** select columns of table "api_key_usage_logs" */
export enum Api_Key_Usage_Logs_Select_Column {
  /** column name */
  ApiKeyId = 'api_key_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Endpoint = 'endpoint',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  Method = 'method',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  ResponseTimeMs = 'response_time_ms',
  /** column name */
  StatusCode = 'status_code',
  /** column name */
  UserAgent = 'user_agent',
}

/** aggregate stddev on columns */
export type Api_Key_Usage_Logs_Stddev_Fields = {
  __typename?: 'api_key_usage_logs_stddev_fields';
  response_time_ms?: Maybe<Scalars['Float']['output']>;
  status_code?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Stddev_Order_By = {
  response_time_ms?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Api_Key_Usage_Logs_Stddev_Pop_Fields = {
  __typename?: 'api_key_usage_logs_stddev_pop_fields';
  response_time_ms?: Maybe<Scalars['Float']['output']>;
  status_code?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Stddev_Pop_Order_By = {
  response_time_ms?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Api_Key_Usage_Logs_Stddev_Samp_Fields = {
  __typename?: 'api_key_usage_logs_stddev_samp_fields';
  response_time_ms?: Maybe<Scalars['Float']['output']>;
  status_code?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Stddev_Samp_Order_By = {
  response_time_ms?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Api_Key_Usage_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Api_Key_Usage_Logs_Stream_Cursor_Value_Input = {
  api_key_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  request_id?: InputMaybe<Scalars['String']['input']>;
  response_time_ms?: InputMaybe<Scalars['Int']['input']>;
  status_code?: InputMaybe<Scalars['Int']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Api_Key_Usage_Logs_Sum_Fields = {
  __typename?: 'api_key_usage_logs_sum_fields';
  response_time_ms?: Maybe<Scalars['Int']['output']>;
  status_code?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Sum_Order_By = {
  response_time_ms?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Api_Key_Usage_Logs_Var_Pop_Fields = {
  __typename?: 'api_key_usage_logs_var_pop_fields';
  response_time_ms?: Maybe<Scalars['Float']['output']>;
  status_code?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Var_Pop_Order_By = {
  response_time_ms?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Api_Key_Usage_Logs_Var_Samp_Fields = {
  __typename?: 'api_key_usage_logs_var_samp_fields';
  response_time_ms?: Maybe<Scalars['Float']['output']>;
  status_code?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Var_Samp_Order_By = {
  response_time_ms?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Api_Key_Usage_Logs_Variance_Fields = {
  __typename?: 'api_key_usage_logs_variance_fields';
  response_time_ms?: Maybe<Scalars['Float']['output']>;
  status_code?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "api_key_usage_logs" */
export type Api_Key_Usage_Logs_Variance_Order_By = {
  response_time_ms?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
};

/** Client-facing API keys for external integrations. Each key is linked to a service account, not a human user. */
export type Api_Keys = {
  __typename?: 'api_keys';
  created_at: Scalars['timestamptz']['output'];
  /** The human user who created this key (audit trail only — NOT used for RLS). */
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** JSON array of CIDR strings, e.g. ["10.0.0.0/8", "192.168.1.0/24"]. NULL = allow all IPs. */
  ip_allowlist?: Maybe<Array<Scalars['IpAddress']['output']>>;
  /** First 12 chars of key (e.g. ck_live_a1b2) for display purposes. Never contains enough entropy to reconstruct the key. */
  key_prefix: Scalars['String']['output'];
  last_used_at?: Maybe<Scalars['timestamptz']['output']>;
  name: Scalars['String']['output'];
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit: Scalars['Int']['output'];
  revoked_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Optional free-text reason stored when a key is revoked. Visible in audit UI. */
  revoked_reason?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  rotated_from?: Maybe<Api_Keys>;
  /** If this key was created via rotation, points to the key it replaced. NULL for keys created directly. SET NULL on parent delete to avoid cascades. */
  rotated_from_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  service_account: Service_Accounts;
  /** The service account this key authenticates as. The service account's user_id is used for Hasura RLS. */
  service_account_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  usage_logs: Array<Api_Key_Usage_Logs>;
  /** An aggregate relationship */
  usage_logs_aggregate: Api_Key_Usage_Logs_Aggregate;
};

/** Client-facing API keys for external integrations. Each key is linked to a service account, not a human user. */
export type Api_KeysIp_AllowlistArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Client-facing API keys for external integrations. Each key is linked to a service account, not a human user. */
export type Api_KeysUsage_LogsArgs = {
  distinct_on?: InputMaybe<Array<Api_Key_Usage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Key_Usage_Logs_Order_By>>;
  where?: InputMaybe<Api_Key_Usage_Logs_Bool_Exp>;
};

/** Client-facing API keys for external integrations. Each key is linked to a service account, not a human user. */
export type Api_KeysUsage_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Api_Key_Usage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Key_Usage_Logs_Order_By>>;
  where?: InputMaybe<Api_Key_Usage_Logs_Bool_Exp>;
};

/** aggregated selection of "api_keys" */
export type Api_Keys_Aggregate = {
  __typename?: 'api_keys_aggregate';
  aggregate?: Maybe<Api_Keys_Aggregate_Fields>;
  nodes: Array<Api_Keys>;
};

export type Api_Keys_Aggregate_Bool_Exp = {
  count?: InputMaybe<Api_Keys_Aggregate_Bool_Exp_Count>;
};

export type Api_Keys_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Api_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Api_Keys_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "api_keys" */
export type Api_Keys_Aggregate_Fields = {
  __typename?: 'api_keys_aggregate_fields';
  avg?: Maybe<Api_Keys_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Api_Keys_Max_Fields>;
  min?: Maybe<Api_Keys_Min_Fields>;
  stddev?: Maybe<Api_Keys_Stddev_Fields>;
  stddev_pop?: Maybe<Api_Keys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Api_Keys_Stddev_Samp_Fields>;
  sum?: Maybe<Api_Keys_Sum_Fields>;
  var_pop?: Maybe<Api_Keys_Var_Pop_Fields>;
  var_samp?: Maybe<Api_Keys_Var_Samp_Fields>;
  variance?: Maybe<Api_Keys_Variance_Fields>;
};

/** aggregate fields of "api_keys" */
export type Api_Keys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Api_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "api_keys" */
export type Api_Keys_Aggregate_Order_By = {
  avg?: InputMaybe<Api_Keys_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Api_Keys_Max_Order_By>;
  min?: InputMaybe<Api_Keys_Min_Order_By>;
  stddev?: InputMaybe<Api_Keys_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Api_Keys_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Api_Keys_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Api_Keys_Sum_Order_By>;
  var_pop?: InputMaybe<Api_Keys_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Api_Keys_Var_Samp_Order_By>;
  variance?: InputMaybe<Api_Keys_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Api_Keys_Append_Input = {
  /** JSON array of CIDR strings, e.g. ["10.0.0.0/8", "192.168.1.0/24"]. NULL = allow all IPs. */
  ip_allowlist?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Api_Keys_Avg_Fields = {
  __typename?: 'api_keys_avg_fields';
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "api_keys" */
export type Api_Keys_Avg_Order_By = {
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "api_keys". All fields are combined with a logical 'AND'. */
export type Api_Keys_Bool_Exp = {
  _and?: InputMaybe<Array<Api_Keys_Bool_Exp>>;
  _not?: InputMaybe<Api_Keys_Bool_Exp>;
  _or?: InputMaybe<Array<Api_Keys_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ip_allowlist?: InputMaybe<Jsonb_Comparison_Exp>;
  key_prefix?: InputMaybe<String_Comparison_Exp>;
  last_used_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  rate_limit?: InputMaybe<Int_Comparison_Exp>;
  revoked_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  revoked_reason?: InputMaybe<String_Comparison_Exp>;
  rotated_from?: InputMaybe<Api_Keys_Bool_Exp>;
  rotated_from_id?: InputMaybe<Uuid_Comparison_Exp>;
  service_account?: InputMaybe<Service_Accounts_Bool_Exp>;
  service_account_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  usage_logs?: InputMaybe<Api_Key_Usage_Logs_Bool_Exp>;
  usage_logs_aggregate?: InputMaybe<Api_Key_Usage_Logs_Aggregate_Bool_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Api_Keys_Delete_At_Path_Input = {
  /** JSON array of CIDR strings, e.g. ["10.0.0.0/8", "192.168.1.0/24"]. NULL = allow all IPs. */
  ip_allowlist?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Api_Keys_Delete_Elem_Input = {
  /** JSON array of CIDR strings, e.g. ["10.0.0.0/8", "192.168.1.0/24"]. NULL = allow all IPs. */
  ip_allowlist?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Api_Keys_Delete_Key_Input = {
  /** JSON array of CIDR strings, e.g. ["10.0.0.0/8", "192.168.1.0/24"]. NULL = allow all IPs. */
  ip_allowlist?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Api_Keys_Max_Fields = {
  __typename?: 'api_keys_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The human user who created this key (audit trail only — NOT used for RLS). */
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** First 12 chars of key (e.g. ck_live_a1b2) for display purposes. Never contains enough entropy to reconstruct the key. */
  key_prefix?: Maybe<Scalars['String']['output']>;
  last_used_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: Maybe<Scalars['Int']['output']>;
  revoked_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Optional free-text reason stored when a key is revoked. Visible in audit UI. */
  revoked_reason?: Maybe<Scalars['String']['output']>;
  /** If this key was created via rotation, points to the key it replaced. NULL for keys created directly. SET NULL on parent delete to avoid cascades. */
  rotated_from_id?: Maybe<Scalars['uuid']['output']>;
  /** The service account this key authenticates as. The service account's user_id is used for Hasura RLS. */
  service_account_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "api_keys" */
export type Api_Keys_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  /** The human user who created this key (audit trail only — NOT used for RLS). */
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** First 12 chars of key (e.g. ck_live_a1b2) for display purposes. Never contains enough entropy to reconstruct the key. */
  key_prefix?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: InputMaybe<Order_By>;
  revoked_at?: InputMaybe<Order_By>;
  /** Optional free-text reason stored when a key is revoked. Visible in audit UI. */
  revoked_reason?: InputMaybe<Order_By>;
  /** If this key was created via rotation, points to the key it replaced. NULL for keys created directly. SET NULL on parent delete to avoid cascades. */
  rotated_from_id?: InputMaybe<Order_By>;
  /** The service account this key authenticates as. The service account's user_id is used for Hasura RLS. */
  service_account_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Api_Keys_Min_Fields = {
  __typename?: 'api_keys_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The human user who created this key (audit trail only — NOT used for RLS). */
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** First 12 chars of key (e.g. ck_live_a1b2) for display purposes. Never contains enough entropy to reconstruct the key. */
  key_prefix?: Maybe<Scalars['String']['output']>;
  last_used_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: Maybe<Scalars['Int']['output']>;
  revoked_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Optional free-text reason stored when a key is revoked. Visible in audit UI. */
  revoked_reason?: Maybe<Scalars['String']['output']>;
  /** If this key was created via rotation, points to the key it replaced. NULL for keys created directly. SET NULL on parent delete to avoid cascades. */
  rotated_from_id?: Maybe<Scalars['uuid']['output']>;
  /** The service account this key authenticates as. The service account's user_id is used for Hasura RLS. */
  service_account_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "api_keys" */
export type Api_Keys_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  /** The human user who created this key (audit trail only — NOT used for RLS). */
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** First 12 chars of key (e.g. ck_live_a1b2) for display purposes. Never contains enough entropy to reconstruct the key. */
  key_prefix?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: InputMaybe<Order_By>;
  revoked_at?: InputMaybe<Order_By>;
  /** Optional free-text reason stored when a key is revoked. Visible in audit UI. */
  revoked_reason?: InputMaybe<Order_By>;
  /** If this key was created via rotation, points to the key it replaced. NULL for keys created directly. SET NULL on parent delete to avoid cascades. */
  rotated_from_id?: InputMaybe<Order_By>;
  /** The service account this key authenticates as. The service account's user_id is used for Hasura RLS. */
  service_account_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "api_keys" */
export type Api_Keys_Mutation_Response = {
  __typename?: 'api_keys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Api_Keys>;
};

/** Ordering options when selecting data from "api_keys". */
export type Api_Keys_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  description?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip_allowlist?: InputMaybe<Order_By>;
  key_prefix?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rate_limit?: InputMaybe<Order_By>;
  revoked_at?: InputMaybe<Order_By>;
  revoked_reason?: InputMaybe<Order_By>;
  rotated_from?: InputMaybe<Api_Keys_Order_By>;
  rotated_from_id?: InputMaybe<Order_By>;
  service_account?: InputMaybe<Service_Accounts_Order_By>;
  service_account_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usage_logs_aggregate?: InputMaybe<Api_Key_Usage_Logs_Aggregate_Order_By>;
};

/** primary key columns input for table: api_keys */
export type Api_Keys_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Api_Keys_Prepend_Input = {
  /** JSON array of CIDR strings, e.g. ["10.0.0.0/8", "192.168.1.0/24"]. NULL = allow all IPs. */
  ip_allowlist?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "api_keys" */
export enum Api_Keys_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  IpAllowlist = 'ip_allowlist',
  /** column name */
  KeyPrefix = 'key_prefix',
  /** column name */
  LastUsedAt = 'last_used_at',
  /** column name */
  Name = 'name',
  /** column name */
  RateLimit = 'rate_limit',
  /** column name */
  RevokedAt = 'revoked_at',
  /** column name */
  RevokedReason = 'revoked_reason',
  /** column name */
  RotatedFromId = 'rotated_from_id',
  /** column name */
  ServiceAccountId = 'service_account_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "api_keys" */
export type Api_Keys_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** JSON array of CIDR strings, e.g. ["10.0.0.0/8", "192.168.1.0/24"]. NULL = allow all IPs. */
  ip_allowlist?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  revoked_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Optional free-text reason stored when a key is revoked. Visible in audit UI. */
  revoked_reason?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Api_Keys_Stddev_Fields = {
  __typename?: 'api_keys_stddev_fields';
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "api_keys" */
export type Api_Keys_Stddev_Order_By = {
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Api_Keys_Stddev_Pop_Fields = {
  __typename?: 'api_keys_stddev_pop_fields';
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "api_keys" */
export type Api_Keys_Stddev_Pop_Order_By = {
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Api_Keys_Stddev_Samp_Fields = {
  __typename?: 'api_keys_stddev_samp_fields';
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "api_keys" */
export type Api_Keys_Stddev_Samp_Order_By = {
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Api_Keys_Sum_Fields = {
  __typename?: 'api_keys_sum_fields';
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "api_keys" */
export type Api_Keys_Sum_Order_By = {
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: InputMaybe<Order_By>;
};

export type Api_Keys_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Api_Keys_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Api_Keys_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Api_Keys_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Api_Keys_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Api_Keys_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Api_Keys_Set_Input>;
  /** filter the rows which have to be updated */
  where: Api_Keys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Api_Keys_Var_Pop_Fields = {
  __typename?: 'api_keys_var_pop_fields';
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "api_keys" */
export type Api_Keys_Var_Pop_Order_By = {
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Api_Keys_Var_Samp_Fields = {
  __typename?: 'api_keys_var_samp_fields';
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "api_keys" */
export type Api_Keys_Var_Samp_Order_By = {
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Api_Keys_Variance_Fields = {
  __typename?: 'api_keys_variance_fields';
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "api_keys" */
export type Api_Keys_Variance_Order_By = {
  /** Maximum requests per hour for this key. Default 1000. */
  rate_limit?: InputMaybe<Order_By>;
};

/** columns and relationships of "audit.control_history" */
export type Audit_Control_History = {
  __typename?: 'audit_control_history';
  action: Scalars['AuditTableActions']['output'];
  action_timestamp: Scalars['timestamptz']['output'];
  changed_fields?: Maybe<Scalars['ControlChangedFields']['output']>;
  /** An object relationship */
  control: Controls;
  control_id: Scalars['uuid']['output'];
  hasura_user: Scalars['AuditTableHasuraUser']['output'];
  metadata?: Maybe<Scalars['ControlHistoryMetadata']['output']>;
  row_data: Scalars['ControlRowData']['output'];
  table_name: Scalars['ControlHistoryTables']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "audit.control_history" */
export type Audit_Control_HistoryChanged_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.control_history" */
export type Audit_Control_HistoryHasura_UserArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.control_history" */
export type Audit_Control_HistoryMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.control_history" */
export type Audit_Control_HistoryRow_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "audit.control_history". All fields are combined with a logical 'AND'. */
export type Audit_Control_History_Bool_Exp = {
  _and?: InputMaybe<Array<Audit_Control_History_Bool_Exp>>;
  _not?: InputMaybe<Audit_Control_History_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Control_History_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  action_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  changed_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  hasura_user?: InputMaybe<Jsonb_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  row_data?: InputMaybe<Jsonb_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "audit.control_history". */
export type Audit_Control_History_Order_By = {
  action?: InputMaybe<Order_By>;
  action_timestamp?: InputMaybe<Order_By>;
  changed_fields?: InputMaybe<Order_By>;
  control?: InputMaybe<Controls_Order_By>;
  control_id?: InputMaybe<Order_By>;
  hasura_user?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  row_data?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "audit.control_history" */
export enum Audit_Control_History_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ActionTimestamp = 'action_timestamp',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  ControlId = 'control_id',
  /** column name */
  HasuraUser = 'hasura_user',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RowData = 'row_data',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UserId = 'user_id',
}

/** Streaming cursor of the table "audit_control_history" */
export type Audit_Control_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Control_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Control_History_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  action_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  changed_fields?: InputMaybe<Scalars['jsonb']['input']>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  hasura_user?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  row_data?: InputMaybe<Scalars['jsonb']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "audit.evidence_history" */
export type Audit_Evidence_History = {
  __typename?: 'audit_evidence_history';
  action: Scalars['AuditTableActions']['output'];
  action_timestamp: Scalars['timestamptz']['output'];
  changed_fields?: Maybe<Scalars['EvidenceChangedFields']['output']>;
  /** An object relationship */
  evidence: Evidences;
  evidence_id: Scalars['uuid']['output'];
  hasura_user: Scalars['AuditTableHasuraUser']['output'];
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['EvidenceHistoryMetadata']['output']>;
  row_data: Scalars['EvidenceRowData']['output'];
  table_name: Scalars['EvidenceHistoryTables']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "audit.evidence_history" */
export type Audit_Evidence_HistoryChanged_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.evidence_history" */
export type Audit_Evidence_HistoryHasura_UserArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.evidence_history" */
export type Audit_Evidence_HistoryMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.evidence_history" */
export type Audit_Evidence_HistoryRow_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "audit.evidence_history". All fields are combined with a logical 'AND'. */
export type Audit_Evidence_History_Bool_Exp = {
  _and?: InputMaybe<Array<Audit_Evidence_History_Bool_Exp>>;
  _not?: InputMaybe<Audit_Evidence_History_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Evidence_History_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  action_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  changed_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  evidence?: InputMaybe<Evidences_Bool_Exp>;
  evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  hasura_user?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  row_data?: InputMaybe<Jsonb_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "audit.evidence_history". */
export type Audit_Evidence_History_Order_By = {
  action?: InputMaybe<Order_By>;
  action_timestamp?: InputMaybe<Order_By>;
  changed_fields?: InputMaybe<Order_By>;
  evidence?: InputMaybe<Evidences_Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  hasura_user?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  row_data?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "audit.evidence_history" */
export enum Audit_Evidence_History_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ActionTimestamp = 'action_timestamp',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  EvidenceId = 'evidence_id',
  /** column name */
  HasuraUser = 'hasura_user',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RowData = 'row_data',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UserId = 'user_id',
}

/** Streaming cursor of the table "audit_evidence_history" */
export type Audit_Evidence_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Evidence_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Evidence_History_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  action_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  changed_fields?: InputMaybe<Scalars['jsonb']['input']>;
  evidence_id?: InputMaybe<Scalars['uuid']['input']>;
  hasura_user?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  row_data?: InputMaybe<Scalars['jsonb']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "audit.finding_history" */
export type Audit_Finding_History = {
  __typename?: 'audit_finding_history';
  action: Scalars['String']['output'];
  action_timestamp: Scalars['timestamptz']['output'];
  /** An object relationship */
  detail?: Maybe<Finding_History_Details>;
  /** An object relationship */
  finding: Findings;
  finding_id: Scalars['uuid']['output'];
  hasura_user?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id: Scalars['uuid']['output'];
  table_name: Scalars['String']['output'];
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "audit.finding_history" */
export type Audit_Finding_HistoryHasura_UserArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "audit.finding_history" */
export type Audit_Finding_History_Aggregate = {
  __typename?: 'audit_finding_history_aggregate';
  aggregate?: Maybe<Audit_Finding_History_Aggregate_Fields>;
  nodes: Array<Audit_Finding_History>;
};

export type Audit_Finding_History_Aggregate_Bool_Exp = {
  count?: InputMaybe<Audit_Finding_History_Aggregate_Bool_Exp_Count>;
};

export type Audit_Finding_History_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Audit_Finding_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Audit_Finding_History_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "audit.finding_history" */
export type Audit_Finding_History_Aggregate_Fields = {
  __typename?: 'audit_finding_history_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Audit_Finding_History_Max_Fields>;
  min?: Maybe<Audit_Finding_History_Min_Fields>;
};

/** aggregate fields of "audit.finding_history" */
export type Audit_Finding_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Audit_Finding_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "audit.finding_history" */
export type Audit_Finding_History_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Audit_Finding_History_Max_Order_By>;
  min?: InputMaybe<Audit_Finding_History_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "audit.finding_history". All fields are combined with a logical 'AND'. */
export type Audit_Finding_History_Bool_Exp = {
  _and?: InputMaybe<Array<Audit_Finding_History_Bool_Exp>>;
  _not?: InputMaybe<Audit_Finding_History_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Finding_History_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  action_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  detail?: InputMaybe<Finding_History_Details_Bool_Exp>;
  finding?: InputMaybe<Findings_Bool_Exp>;
  finding_id?: InputMaybe<Uuid_Comparison_Exp>;
  hasura_user?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Audit_Finding_History_Max_Fields = {
  __typename?: 'audit_finding_history_max_fields';
  action?: Maybe<Scalars['String']['output']>;
  action_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  finding_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  table_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "audit.finding_history" */
export type Audit_Finding_History_Max_Order_By = {
  action?: InputMaybe<Order_By>;
  action_timestamp?: InputMaybe<Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Audit_Finding_History_Min_Fields = {
  __typename?: 'audit_finding_history_min_fields';
  action?: Maybe<Scalars['String']['output']>;
  action_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  finding_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  table_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "audit.finding_history" */
export type Audit_Finding_History_Min_Order_By = {
  action?: InputMaybe<Order_By>;
  action_timestamp?: InputMaybe<Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "audit.finding_history". */
export type Audit_Finding_History_Order_By = {
  action?: InputMaybe<Order_By>;
  action_timestamp?: InputMaybe<Order_By>;
  detail?: InputMaybe<Finding_History_Details_Order_By>;
  finding?: InputMaybe<Findings_Order_By>;
  finding_id?: InputMaybe<Order_By>;
  hasura_user?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "audit.finding_history" */
export enum Audit_Finding_History_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ActionTimestamp = 'action_timestamp',
  /** column name */
  FindingId = 'finding_id',
  /** column name */
  HasuraUser = 'hasura_user',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UserId = 'user_id',
}

/** Streaming cursor of the table "audit_finding_history" */
export type Audit_Finding_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Finding_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Finding_History_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  action_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  finding_id?: InputMaybe<Scalars['uuid']['input']>;
  hasura_user?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "audit.policy_history" */
export type Audit_Policy_History = {
  __typename?: 'audit_policy_history';
  action: Scalars['AuditTableActions']['output'];
  action_timestamp: Scalars['timestamptz']['output'];
  changed_fields?: Maybe<Scalars['PolicyChangedFields']['output']>;
  hasura_user: Scalars['AuditTableHasuraUser']['output'];
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['PolicyHistoryMetadata']['output']>;
  /** An object relationship */
  policy: Policies;
  policy_id: Scalars['uuid']['output'];
  row_data: Scalars['PolicyRowData']['output'];
  table_name: Scalars['PolicyHistoryTables']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "audit.policy_history" */
export type Audit_Policy_HistoryChanged_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.policy_history" */
export type Audit_Policy_HistoryHasura_UserArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.policy_history" */
export type Audit_Policy_HistoryMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.policy_history" */
export type Audit_Policy_HistoryRow_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "audit.policy_history". All fields are combined with a logical 'AND'. */
export type Audit_Policy_History_Bool_Exp = {
  _and?: InputMaybe<Array<Audit_Policy_History_Bool_Exp>>;
  _not?: InputMaybe<Audit_Policy_History_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Policy_History_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  action_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  changed_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  hasura_user?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  policy?: InputMaybe<Policies_Bool_Exp>;
  policy_id?: InputMaybe<Uuid_Comparison_Exp>;
  row_data?: InputMaybe<Jsonb_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "audit.policy_history". */
export type Audit_Policy_History_Order_By = {
  action?: InputMaybe<Order_By>;
  action_timestamp?: InputMaybe<Order_By>;
  changed_fields?: InputMaybe<Order_By>;
  hasura_user?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  policy?: InputMaybe<Policies_Order_By>;
  policy_id?: InputMaybe<Order_By>;
  row_data?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "audit.policy_history" */
export enum Audit_Policy_History_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ActionTimestamp = 'action_timestamp',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  HasuraUser = 'hasura_user',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PolicyId = 'policy_id',
  /** column name */
  RowData = 'row_data',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UserId = 'user_id',
}

/** Streaming cursor of the table "audit_policy_history" */
export type Audit_Policy_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Policy_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Policy_History_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  action_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  changed_fields?: InputMaybe<Scalars['jsonb']['input']>;
  hasura_user?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  policy_id?: InputMaybe<Scalars['uuid']['input']>;
  row_data?: InputMaybe<Scalars['jsonb']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "audit.risk_history" */
export type Audit_Risk_History = {
  __typename?: 'audit_risk_history';
  action: Scalars['AuditTableActions']['output'];
  action_timestamp: Scalars['timestamptz']['output'];
  changed_fields?: Maybe<Scalars['RiskChangedFields']['output']>;
  hasura_user: Scalars['AuditTableHasuraUser']['output'];
  metadata?: Maybe<Scalars['RiskHistoryMetadata']['output']>;
  /** An object relationship */
  risk: Risks;
  risk_id: Scalars['uuid']['output'];
  row_data: Scalars['RiskRowData']['output'];
  table_name: Scalars['RiskHistoryTables']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "audit.risk_history" */
export type Audit_Risk_HistoryChanged_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.risk_history" */
export type Audit_Risk_HistoryHasura_UserArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.risk_history" */
export type Audit_Risk_HistoryMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.risk_history" */
export type Audit_Risk_HistoryRow_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "audit.risk_history". All fields are combined with a logical 'AND'. */
export type Audit_Risk_History_Bool_Exp = {
  _and?: InputMaybe<Array<Audit_Risk_History_Bool_Exp>>;
  _not?: InputMaybe<Audit_Risk_History_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Risk_History_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  action_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  changed_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  hasura_user?: InputMaybe<Jsonb_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  row_data?: InputMaybe<Jsonb_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "audit.risk_history". */
export type Audit_Risk_History_Order_By = {
  action?: InputMaybe<Order_By>;
  action_timestamp?: InputMaybe<Order_By>;
  changed_fields?: InputMaybe<Order_By>;
  hasura_user?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risk_id?: InputMaybe<Order_By>;
  row_data?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "audit.risk_history" */
export enum Audit_Risk_History_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ActionTimestamp = 'action_timestamp',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  HasuraUser = 'hasura_user',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RiskId = 'risk_id',
  /** column name */
  RowData = 'row_data',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UserId = 'user_id',
}

/** Streaming cursor of the table "audit_risk_history" */
export type Audit_Risk_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Risk_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Risk_History_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  action_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  changed_fields?: InputMaybe<Scalars['jsonb']['input']>;
  hasura_user?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
  row_data?: InputMaybe<Scalars['jsonb']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "audit.task_history" */
export type Audit_Task_History = {
  __typename?: 'audit_task_history';
  action: Scalars['AuditTableActions']['output'];
  action_timestamp: Scalars['timestamptz']['output'];
  changed_fields?: Maybe<Scalars['TaskChangedFields']['output']>;
  hasura_user: Scalars['AuditTableHasuraUser']['output'];
  metadata?: Maybe<Scalars['TaskHistoryMetadata']['output']>;
  row_data: Scalars['TaskRowData']['output'];
  table_name: Scalars['TaskHistoryTables']['output'];
  /** An object relationship */
  task: Tasks;
  task_id: Scalars['uuid']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "audit.task_history" */
export type Audit_Task_HistoryChanged_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.task_history" */
export type Audit_Task_HistoryHasura_UserArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.task_history" */
export type Audit_Task_HistoryMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.task_history" */
export type Audit_Task_HistoryRow_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "audit.task_history". All fields are combined with a logical 'AND'. */
export type Audit_Task_History_Bool_Exp = {
  _and?: InputMaybe<Array<Audit_Task_History_Bool_Exp>>;
  _not?: InputMaybe<Audit_Task_History_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Task_History_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  action_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  changed_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  hasura_user?: InputMaybe<Jsonb_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  row_data?: InputMaybe<Jsonb_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "audit.task_history". */
export type Audit_Task_History_Order_By = {
  action?: InputMaybe<Order_By>;
  action_timestamp?: InputMaybe<Order_By>;
  changed_fields?: InputMaybe<Order_By>;
  hasura_user?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  row_data?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "audit.task_history" */
export enum Audit_Task_History_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ActionTimestamp = 'action_timestamp',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  HasuraUser = 'hasura_user',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RowData = 'row_data',
  /** column name */
  TableName = 'table_name',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  UserId = 'user_id',
}

/** Streaming cursor of the table "audit_task_history" */
export type Audit_Task_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Task_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Task_History_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  action_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  changed_fields?: InputMaybe<Scalars['jsonb']['input']>;
  hasura_user?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  row_data?: InputMaybe<Scalars['jsonb']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "audit.vendor_history" */
export type Audit_Vendor_History = {
  __typename?: 'audit_vendor_history';
  action: Scalars['AuditTableActions']['output'];
  action_timestamp: Scalars['timestamptz']['output'];
  changed_fields?: Maybe<Scalars['VendorChangedFields']['output']>;
  hasura_user: Scalars['AuditTableHasuraUser']['output'];
  metadata?: Maybe<Scalars['VendorHistoryMetadata']['output']>;
  row_data: Scalars['VendorRowData']['output'];
  table_name: Scalars['VendorHistoryTables']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  vendor: Vendors;
  vendor_id: Scalars['uuid']['output'];
};

/** columns and relationships of "audit.vendor_history" */
export type Audit_Vendor_HistoryChanged_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.vendor_history" */
export type Audit_Vendor_HistoryHasura_UserArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.vendor_history" */
export type Audit_Vendor_HistoryMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.vendor_history" */
export type Audit_Vendor_HistoryRow_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "audit.vendor_history". All fields are combined with a logical 'AND'. */
export type Audit_Vendor_History_Bool_Exp = {
  _and?: InputMaybe<Array<Audit_Vendor_History_Bool_Exp>>;
  _not?: InputMaybe<Audit_Vendor_History_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Vendor_History_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  action_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  changed_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  hasura_user?: InputMaybe<Jsonb_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  row_data?: InputMaybe<Jsonb_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "audit.vendor_history". */
export type Audit_Vendor_History_Order_By = {
  action?: InputMaybe<Order_By>;
  action_timestamp?: InputMaybe<Order_By>;
  changed_fields?: InputMaybe<Order_By>;
  hasura_user?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  row_data?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** select columns of table "audit.vendor_history" */
export enum Audit_Vendor_History_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ActionTimestamp = 'action_timestamp',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  HasuraUser = 'hasura_user',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RowData = 'row_data',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VendorId = 'vendor_id',
}

/** Streaming cursor of the table "audit_vendor_history" */
export type Audit_Vendor_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Vendor_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Vendor_History_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  action_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  changed_fields?: InputMaybe<Scalars['jsonb']['input']>;
  hasura_user?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  row_data?: InputMaybe<Scalars['jsonb']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

export enum AuthPrincipalTypes_Enum {
  /** Interactive human user */
  Human = 'human',
  /** Non-interactive service account */
  ServiceAccount = 'service_account',
}

/** Boolean expression to compare columns of type "authPrincipalTypes_enum". All fields are combined with logical 'AND'. */
export type AuthPrincipalTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<AuthPrincipalTypes_Enum>;
  _in?: InputMaybe<Array<AuthPrincipalTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AuthPrincipalTypes_Enum>;
  _nin?: InputMaybe<Array<AuthPrincipalTypes_Enum>>;
};

export enum AuthRefreshTokenTypes_Enum {
  /** Personal access token */
  Pat = 'pat',
  /** Regular refresh token */
  Regular = 'regular',
}

/** Boolean expression to compare columns of type "authRefreshTokenTypes_enum". All fields are combined with logical 'AND'. */
export type AuthRefreshTokenTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  _in?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  _nin?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>;
};

/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokens = {
  __typename?: 'authRefreshTokens';
  createdAt: Scalars['timestamptz']['output'];
  expiresAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  type: AuthRefreshTokenTypes_Enum;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokensMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthRefreshTokens_Max_Order_By>;
  min?: InputMaybe<AuthRefreshTokens_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokens_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>;
  _not?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.refresh_tokens" */
export type AuthRefreshTokens_Mutation_Response = {
  __typename?: 'authRefreshTokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokens>;
};

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type AuthRefreshTokens_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId',
}

/** Streaming cursor of the table "authRefreshTokens" */
export type AuthRefreshTokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokens_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "categories" */
export type Categories = {
  __typename?: 'categories';
  /** An array relationship */
  control_categories: Array<Control_Categories>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "categories" */
export type CategoriesControl_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Control_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Categories_Order_By>>;
  where?: InputMaybe<Control_Categories_Bool_Exp>;
};

/** order by aggregate values of table "categories" */
export type Categories_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Categories_Max_Order_By>;
  min?: InputMaybe<Categories_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "categories". All fields are combined with a logical 'AND'. */
export type Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Categories_Bool_Exp>>;
  _not?: InputMaybe<Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Categories_Bool_Exp>>;
  control_categories?: InputMaybe<Control_Categories_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "categories" */
export enum Categories_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  CategoriesNameOrganizationIdKey = 'categories_name_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  CategoriesPkey = 'categories_pkey',
}

/** input type for inserting data into table "categories" */
export type Categories_Insert_Input = {
  control_categories?: InputMaybe<Control_Categories_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "categories" */
export type Categories_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "categories" */
export type Categories_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "categories" */
export type Categories_Mutation_Response = {
  __typename?: 'categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Categories>;
};

/** input type for inserting object relation for remote table "categories" */
export type Categories_Obj_Rel_Insert_Input = {
  data: Categories_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};

/** on_conflict condition type for table "categories" */
export type Categories_On_Conflict = {
  constraint: Categories_Constraint;
  update_columns?: Array<Categories_Update_Column>;
  where?: InputMaybe<Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "categories". */
export type Categories_Order_By = {
  control_categories_aggregate?: InputMaybe<Control_Categories_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: categories */
export type Categories_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "categories" */
export enum Categories_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "categories" */
export type Categories_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "categories" */
export type Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Categories_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "categories" */
export enum Categories_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Categories_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Categories_Set_Input>;
  /** filter the rows which have to be updated */
  where: Categories_Bool_Exp;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']['input']>;
  _gt?: InputMaybe<Scalars['citext']['input']>;
  _gte?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']['input']>;
  _in?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']['input']>;
  _lt?: InputMaybe<Scalars['citext']['input']>;
  _lte?: InputMaybe<Scalars['citext']['input']>;
  _neq?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']['input']>;
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']['input']>;
};

/** Answers to a given Client Questionnaire Question */
export type Client_Questionnaire_Answers = {
  __typename?: 'client_questionnaire_answers';
  answer: Scalars['String']['output'];
  /** An object relationship */
  client_questionnaire_question: Client_Questionnaire_Questions;
  client_questionnaire_question_id: Scalars['uuid']['output'];
  comment: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_ai_generated: Scalars['Boolean']['output'];
  updated_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
};

/** order by aggregate values of table "client_questionnaire_answers" */
export type Client_Questionnaire_Answers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Client_Questionnaire_Answers_Max_Order_By>;
  min?: InputMaybe<Client_Questionnaire_Answers_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "client_questionnaire_answers". All fields are combined with a logical 'AND'. */
export type Client_Questionnaire_Answers_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Questionnaire_Answers_Bool_Exp>>;
  _not?: InputMaybe<Client_Questionnaire_Answers_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Questionnaire_Answers_Bool_Exp>>;
  answer?: InputMaybe<String_Comparison_Exp>;
  client_questionnaire_question?: InputMaybe<Client_Questionnaire_Questions_Bool_Exp>;
  client_questionnaire_question_id?: InputMaybe<Uuid_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_ai_generated?: InputMaybe<Boolean_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "client_questionnaire_answers" */
export enum Client_Questionnaire_Answers_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientQuestionnaireAnswersPkey = 'client_questionnaire_answers_pkey',
  /** unique or primary key constraint on columns "created_at", "client_questionnaire_question_id" */
  ClientQuestionnaireAnswersQuestionIdCreatedAtIdx = 'client_questionnaire_answers_question_id_created_at_idx',
}

/** input type for inserting data into table "client_questionnaire_answers" */
export type Client_Questionnaire_Answers_Insert_Input = {
  answer?: InputMaybe<Scalars['String']['input']>;
  client_questionnaire_question_id?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  is_ai_generated?: InputMaybe<Scalars['Boolean']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "client_questionnaire_answers" */
export type Client_Questionnaire_Answers_Max_Order_By = {
  answer?: InputMaybe<Order_By>;
  client_questionnaire_question_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "client_questionnaire_answers" */
export type Client_Questionnaire_Answers_Min_Order_By = {
  answer?: InputMaybe<Order_By>;
  client_questionnaire_question_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "client_questionnaire_answers" */
export type Client_Questionnaire_Answers_Mutation_Response = {
  __typename?: 'client_questionnaire_answers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Questionnaire_Answers>;
};

/** on_conflict condition type for table "client_questionnaire_answers" */
export type Client_Questionnaire_Answers_On_Conflict = {
  constraint: Client_Questionnaire_Answers_Constraint;
  update_columns?: Array<Client_Questionnaire_Answers_Update_Column>;
  where?: InputMaybe<Client_Questionnaire_Answers_Bool_Exp>;
};

/** Ordering options when selecting data from "client_questionnaire_answers". */
export type Client_Questionnaire_Answers_Order_By = {
  answer?: InputMaybe<Order_By>;
  client_questionnaire_question?: InputMaybe<Client_Questionnaire_Questions_Order_By>;
  client_questionnaire_question_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_ai_generated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "client_questionnaire_answers" */
export enum Client_Questionnaire_Answers_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  ClientQuestionnaireQuestionId = 'client_questionnaire_question_id',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAiGenerated = 'is_ai_generated',
  /** column name */
  UpdatedBy = 'updated_by',
}

/** placeholder for update columns of table "client_questionnaire_answers" (current role has no relevant permissions) */
export enum Client_Questionnaire_Answers_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

export enum Client_Questionnaire_Question_Status_Enum {
  Approved = 'Approved',
  Pending = 'Pending',
  Processing = 'Processing',
  ProcessingFailed = 'Processing_failed',
  ReadyForReview = 'Ready_for_review',
}

/** Boolean expression to compare columns of type "client_questionnaire_question_status_enum". All fields are combined with logical 'AND'. */
export type Client_Questionnaire_Question_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Client_Questionnaire_Question_Status_Enum>;
  _in?: InputMaybe<Array<Client_Questionnaire_Question_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Client_Questionnaire_Question_Status_Enum>;
  _nin?: InputMaybe<Array<Client_Questionnaire_Question_Status_Enum>>;
};

/** Set of questions extracted from a given Client Questionnaire */
export type Client_Questionnaire_Questions = {
  __typename?: 'client_questionnaire_questions';
  /** An object relationship */
  client_questionnaire: Client_Questionnaires;
  /** An array relationship */
  client_questionnaire_answers: Array<Client_Questionnaire_Answers>;
  client_questionnaire_id: Scalars['uuid']['output'];
  /** An array relationship */
  comments: Array<Comments>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['ClientQquestionMetadata']['output']>;
  question: Scalars['String']['output'];
  status: Client_Questionnaire_Question_Status_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** Set of questions extracted from a given Client Questionnaire */
export type Client_Questionnaire_QuestionsClient_Questionnaire_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Client_Questionnaire_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Questionnaire_Answers_Order_By>>;
  where?: InputMaybe<Client_Questionnaire_Answers_Bool_Exp>;
};

/** Set of questions extracted from a given Client Questionnaire */
export type Client_Questionnaire_QuestionsCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** Set of questions extracted from a given Client Questionnaire */
export type Client_Questionnaire_QuestionsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "client_questionnaire_questions" */
export type Client_Questionnaire_Questions_Aggregate = {
  __typename?: 'client_questionnaire_questions_aggregate';
  aggregate?: Maybe<Client_Questionnaire_Questions_Aggregate_Fields>;
  nodes: Array<Client_Questionnaire_Questions>;
};

export type Client_Questionnaire_Questions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Client_Questionnaire_Questions_Aggregate_Bool_Exp_Count>;
};

export type Client_Questionnaire_Questions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Client_Questionnaire_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Client_Questionnaire_Questions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "client_questionnaire_questions" */
export type Client_Questionnaire_Questions_Aggregate_Fields = {
  __typename?: 'client_questionnaire_questions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Client_Questionnaire_Questions_Max_Fields>;
  min?: Maybe<Client_Questionnaire_Questions_Min_Fields>;
};

/** aggregate fields of "client_questionnaire_questions" */
export type Client_Questionnaire_Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Questionnaire_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "client_questionnaire_questions" */
export type Client_Questionnaire_Questions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Client_Questionnaire_Questions_Max_Order_By>;
  min?: InputMaybe<Client_Questionnaire_Questions_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "client_questionnaire_questions". All fields are combined with a logical 'AND'. */
export type Client_Questionnaire_Questions_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Questionnaire_Questions_Bool_Exp>>;
  _not?: InputMaybe<Client_Questionnaire_Questions_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Questionnaire_Questions_Bool_Exp>>;
  client_questionnaire?: InputMaybe<Client_Questionnaires_Bool_Exp>;
  client_questionnaire_answers?: InputMaybe<Client_Questionnaire_Answers_Bool_Exp>;
  client_questionnaire_id?: InputMaybe<Uuid_Comparison_Exp>;
  comments?: InputMaybe<Comments_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  question?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Client_Questionnaire_Question_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Client_Questionnaire_Questions_Max_Fields = {
  __typename?: 'client_questionnaire_questions_max_fields';
  client_questionnaire_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "client_questionnaire_questions" */
export type Client_Questionnaire_Questions_Max_Order_By = {
  client_questionnaire_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Client_Questionnaire_Questions_Min_Fields = {
  __typename?: 'client_questionnaire_questions_min_fields';
  client_questionnaire_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "client_questionnaire_questions" */
export type Client_Questionnaire_Questions_Min_Order_By = {
  client_questionnaire_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "client_questionnaire_questions" */
export type Client_Questionnaire_Questions_Mutation_Response = {
  __typename?: 'client_questionnaire_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Questionnaire_Questions>;
};

/** Ordering options when selecting data from "client_questionnaire_questions". */
export type Client_Questionnaire_Questions_Order_By = {
  client_questionnaire?: InputMaybe<Client_Questionnaires_Order_By>;
  client_questionnaire_answers_aggregate?: InputMaybe<Client_Questionnaire_Answers_Aggregate_Order_By>;
  client_questionnaire_id?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_questionnaire_questions */
export type Client_Questionnaire_Questions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "client_questionnaire_questions" */
export enum Client_Questionnaire_Questions_Select_Column {
  /** column name */
  ClientQuestionnaireId = 'client_questionnaire_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Question = 'question',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "client_questionnaire_questions" */
export type Client_Questionnaire_Questions_Set_Input = {
  status?: InputMaybe<Client_Questionnaire_Question_Status_Enum>;
};

/** Streaming cursor of the table "client_questionnaire_questions" */
export type Client_Questionnaire_Questions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Client_Questionnaire_Questions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Client_Questionnaire_Questions_Stream_Cursor_Value_Input = {
  client_questionnaire_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Client_Questionnaire_Question_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type Client_Questionnaire_Questions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Client_Questionnaire_Questions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Client_Questionnaire_Questions_Bool_Exp;
};

export enum Client_Questionnaire_Status_Enum {
  Complete = 'Complete',
  Expiring = 'Expiring',
  ExtractingCompleted = 'Extracting_completed',
  ExtractingQuestions = 'Extracting_questions',
  ExtractionFailed = 'Extraction_failed',
  InProgress = 'In_progress',
  Overdue = 'Overdue',
  Pending = 'Pending',
  ReadyForExtraction = 'Ready_for_extraction',
}

/** Boolean expression to compare columns of type "client_questionnaire_status_enum". All fields are combined with logical 'AND'. */
export type Client_Questionnaire_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Client_Questionnaire_Status_Enum>;
  _in?: InputMaybe<Array<Client_Questionnaire_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Client_Questionnaire_Status_Enum>;
  _nin?: InputMaybe<Array<Client_Questionnaire_Status_Enum>>;
};

/** Set of Security Questionnaires sent to businessess using Complyance for answering */
export type Client_Questionnaires = {
  __typename?: 'client_questionnaires';
  /** An array relationship */
  client_questionnaire_questions: Array<Client_Questionnaire_Questions>;
  /** An aggregate relationship */
  client_questionnaire_questions_aggregate: Client_Questionnaire_Questions_Aggregate;
  company: Scalars['String']['output'];
  created_at: Scalars['timestamp']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date: Scalars['timestamptz']['output'];
  /** An object relationship */
  export_file?: Maybe<Files>;
  export_file_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  owner?: Maybe<Users>;
  owner_id?: Maybe<Scalars['uuid']['output']>;
  status: Client_Questionnaire_Status_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** Set of Security Questionnaires sent to businessess using Complyance for answering */
export type Client_QuestionnairesClient_Questionnaire_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Client_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Client_Questionnaire_Questions_Bool_Exp>;
};

/** Set of Security Questionnaires sent to businessess using Complyance for answering */
export type Client_QuestionnairesClient_Questionnaire_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Client_Questionnaire_Questions_Bool_Exp>;
};

/** order by aggregate values of table "client_questionnaires" */
export type Client_Questionnaires_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Client_Questionnaires_Max_Order_By>;
  min?: InputMaybe<Client_Questionnaires_Min_Order_By>;
};

/** input type for inserting array relation for remote table "client_questionnaires" */
export type Client_Questionnaires_Arr_Rel_Insert_Input = {
  data: Array<Client_Questionnaires_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Client_Questionnaires_On_Conflict>;
};

/** Boolean expression to filter rows from the table "client_questionnaires". All fields are combined with a logical 'AND'. */
export type Client_Questionnaires_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Questionnaires_Bool_Exp>>;
  _not?: InputMaybe<Client_Questionnaires_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Questionnaires_Bool_Exp>>;
  client_questionnaire_questions?: InputMaybe<Client_Questionnaire_Questions_Bool_Exp>;
  client_questionnaire_questions_aggregate?: InputMaybe<Client_Questionnaire_Questions_Aggregate_Bool_Exp>;
  company?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  export_file?: InputMaybe<Files_Bool_Exp>;
  export_file_id?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  owner?: InputMaybe<Users_Bool_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Client_Questionnaire_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_questionnaires" */
export enum Client_Questionnaires_Constraint {
  /** unique or primary key constraint on columns "file_id" */
  ClientQuestionnairesFileIdKey = 'client_questionnaires_file_id_key',
  /** unique or primary key constraint on columns "organization_id", "internal_id" */
  ClientQuestionnairesOrganizationIdInternalIdKey = 'client_questionnaires_organization_id_internal_id_key',
  /** unique or primary key constraint on columns "id" */
  ClientQuestionnairesPkey = 'client_questionnaires_pkey',
}

/** input type for inserting data into table "client_questionnaires" */
export type Client_Questionnaires_Insert_Input = {
  company?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  export_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  export_file_id?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "client_questionnaires" */
export type Client_Questionnaires_Max_Order_By = {
  company?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  export_file_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "client_questionnaires" */
export type Client_Questionnaires_Min_Order_By = {
  company?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  export_file_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "client_questionnaires" */
export type Client_Questionnaires_Mutation_Response = {
  __typename?: 'client_questionnaires_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Questionnaires>;
};

/** input type for inserting object relation for remote table "client_questionnaires" */
export type Client_Questionnaires_Obj_Rel_Insert_Input = {
  data: Client_Questionnaires_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Client_Questionnaires_On_Conflict>;
};

/** on_conflict condition type for table "client_questionnaires" */
export type Client_Questionnaires_On_Conflict = {
  constraint: Client_Questionnaires_Constraint;
  update_columns?: Array<Client_Questionnaires_Update_Column>;
  where?: InputMaybe<Client_Questionnaires_Bool_Exp>;
};

/** Ordering options when selecting data from "client_questionnaires". */
export type Client_Questionnaires_Order_By = {
  client_questionnaire_questions_aggregate?: InputMaybe<Client_Questionnaire_Questions_Aggregate_Order_By>;
  company?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  export_file?: InputMaybe<Files_Order_By>;
  export_file_id?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Users_Order_By>;
  owner_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_questionnaires */
export type Client_Questionnaires_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "client_questionnaires" */
export enum Client_Questionnaires_Select_Column {
  /** column name */
  Company = 'company',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExportFileId = 'export_file_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "client_questionnaires" */
export type Client_Questionnaires_Set_Input = {
  company?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "client_questionnaires" */
export type Client_Questionnaires_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Client_Questionnaires_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Client_Questionnaires_Stream_Cursor_Value_Input = {
  company?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  export_file_id?: InputMaybe<Scalars['uuid']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Client_Questionnaire_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "client_questionnaires" */
export enum Client_Questionnaires_Update_Column {
  /** column name */
  Company = 'company',
  /** column name */
  Description = 'description',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
}

export type Client_Questionnaires_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Client_Questionnaires_Set_Input>;
  /** filter the rows which have to be updated */
  where: Client_Questionnaires_Bool_Exp;
};

/** columns and relationships of "comment_uploads" */
export type Comment_Uploads = {
  __typename?: 'comment_uploads';
  comment_id: Scalars['uuid']['output'];
  /** An object relationship */
  comment_uploads_comment: Comments;
  /** An object relationship */
  comment_uploads_file: Files;
  created_at: Scalars['timestamptz']['output'];
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "comment_uploads" */
export type Comment_Uploads_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Comment_Uploads_Max_Order_By>;
  min?: InputMaybe<Comment_Uploads_Min_Order_By>;
};

/** input type for inserting array relation for remote table "comment_uploads" */
export type Comment_Uploads_Arr_Rel_Insert_Input = {
  data: Array<Comment_Uploads_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Comment_Uploads_On_Conflict>;
};

/** Boolean expression to filter rows from the table "comment_uploads". All fields are combined with a logical 'AND'. */
export type Comment_Uploads_Bool_Exp = {
  _and?: InputMaybe<Array<Comment_Uploads_Bool_Exp>>;
  _not?: InputMaybe<Comment_Uploads_Bool_Exp>;
  _or?: InputMaybe<Array<Comment_Uploads_Bool_Exp>>;
  comment_id?: InputMaybe<Uuid_Comparison_Exp>;
  comment_uploads_comment?: InputMaybe<Comments_Bool_Exp>;
  comment_uploads_file?: InputMaybe<Files_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "comment_uploads" */
export enum Comment_Uploads_Constraint {
  /** unique or primary key constraint on columns "file_id" */
  CommentUploadsFileIdKey = 'comment_uploads_file_id_key',
  /** unique or primary key constraint on columns "id" */
  CommentUploadsPkey = 'comment_uploads_pkey',
}

/** input type for inserting data into table "comment_uploads" */
export type Comment_Uploads_Insert_Input = {
  comment_id?: InputMaybe<Scalars['uuid']['input']>;
  comment_uploads_comment?: InputMaybe<Comments_Obj_Rel_Insert_Input>;
  comment_uploads_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "comment_uploads" */
export type Comment_Uploads_Max_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "comment_uploads" */
export type Comment_Uploads_Min_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "comment_uploads" */
export type Comment_Uploads_Mutation_Response = {
  __typename?: 'comment_uploads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Comment_Uploads>;
};

/** input type for inserting object relation for remote table "comment_uploads" */
export type Comment_Uploads_Obj_Rel_Insert_Input = {
  data: Comment_Uploads_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Comment_Uploads_On_Conflict>;
};

/** on_conflict condition type for table "comment_uploads" */
export type Comment_Uploads_On_Conflict = {
  constraint: Comment_Uploads_Constraint;
  update_columns?: Array<Comment_Uploads_Update_Column>;
  where?: InputMaybe<Comment_Uploads_Bool_Exp>;
};

/** Ordering options when selecting data from "comment_uploads". */
export type Comment_Uploads_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  comment_uploads_comment?: InputMaybe<Comments_Order_By>;
  comment_uploads_file?: InputMaybe<Files_Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "comment_uploads" */
export enum Comment_Uploads_Select_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
}

/** placeholder for update columns of table "comment_uploads" (current role has no relevant permissions) */
export enum Comment_Uploads_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "comments" */
export type Comments = {
  __typename?: 'comments';
  /** An object relationship */
  client_questionnaire_question?: Maybe<Client_Questionnaire_Questions>;
  client_questionnaire_question_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  comments_comment_uploads: Array<Comment_Uploads>;
  /** An object relationship */
  comments_control?: Maybe<Controls>;
  /** An object relationship */
  comments_evidence?: Maybe<Evidences>;
  /** An array relationship */
  comments_notifications: Array<Notifications>;
  /** An object relationship */
  comments_policy?: Maybe<Policies>;
  /** An object relationship */
  comments_risk?: Maybe<Risks>;
  /** An object relationship */
  comments_task?: Maybe<Tasks>;
  /** An object relationship */
  comments_user: Users;
  /** An object relationship */
  comments_vendor?: Maybe<Vendors>;
  control_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  evidence_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  finding?: Maybe<Findings>;
  finding_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  policy_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  questionnaire?: Maybe<Questionnaires>;
  risk_id?: Maybe<Scalars['uuid']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  text: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
  vendor_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  vendor_questionnaire?: Maybe<Vendor_Questionnaires>;
};

/** columns and relationships of "comments" */
export type CommentsComments_Comment_UploadsArgs = {
  distinct_on?: InputMaybe<Array<Comment_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comment_Uploads_Order_By>>;
  where?: InputMaybe<Comment_Uploads_Bool_Exp>;
};

/** columns and relationships of "comments" */
export type CommentsComments_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** order by aggregate values of table "comments" */
export type Comments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Comments_Max_Order_By>;
  min?: InputMaybe<Comments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "comments" */
export type Comments_Arr_Rel_Insert_Input = {
  data: Array<Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "comments". All fields are combined with a logical 'AND'. */
export type Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Comments_Bool_Exp>>;
  _not?: InputMaybe<Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Comments_Bool_Exp>>;
  client_questionnaire_question?: InputMaybe<Client_Questionnaire_Questions_Bool_Exp>;
  client_questionnaire_question_id?: InputMaybe<Uuid_Comparison_Exp>;
  comments_comment_uploads?: InputMaybe<Comment_Uploads_Bool_Exp>;
  comments_control?: InputMaybe<Controls_Bool_Exp>;
  comments_evidence?: InputMaybe<Evidences_Bool_Exp>;
  comments_notifications?: InputMaybe<Notifications_Bool_Exp>;
  comments_policy?: InputMaybe<Policies_Bool_Exp>;
  comments_risk?: InputMaybe<Risks_Bool_Exp>;
  comments_task?: InputMaybe<Tasks_Bool_Exp>;
  comments_user?: InputMaybe<Users_Bool_Exp>;
  comments_vendor?: InputMaybe<Vendors_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  finding?: InputMaybe<Findings_Bool_Exp>;
  finding_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  policy_id?: InputMaybe<Uuid_Comparison_Exp>;
  questionnaire?: InputMaybe<Questionnaires_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_questionnaire?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
};

/** unique or primary key constraints on table "comments" */
export enum Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommentsPkey = 'comments_pkey',
}

/** input type for inserting data into table "comments" */
export type Comments_Insert_Input = {
  client_questionnaire_question_id?: InputMaybe<Scalars['uuid']['input']>;
  comments_comment_uploads?: InputMaybe<Comment_Uploads_Arr_Rel_Insert_Input>;
  comments_control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  comments_evidence?: InputMaybe<Evidences_Obj_Rel_Insert_Input>;
  comments_policy?: InputMaybe<Policies_Obj_Rel_Insert_Input>;
  comments_risk?: InputMaybe<Risks_Obj_Rel_Insert_Input>;
  comments_task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  comments_vendor?: InputMaybe<Vendors_Obj_Rel_Insert_Input>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  evidence_id?: InputMaybe<Scalars['uuid']['input']>;
  finding_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  policy_id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire?: InputMaybe<Questionnaires_Obj_Rel_Insert_Input>;
  questionnaire_id?: InputMaybe<Scalars['uuid']['input']>;
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_questionnaire_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "comments" */
export type Comments_Max_Order_By = {
  client_questionnaire_question_id?: InputMaybe<Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "comments" */
export type Comments_Min_Order_By = {
  client_questionnaire_question_id?: InputMaybe<Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "comments" */
export type Comments_Mutation_Response = {
  __typename?: 'comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Comments>;
};

/** input type for inserting object relation for remote table "comments" */
export type Comments_Obj_Rel_Insert_Input = {
  data: Comments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};

/** on_conflict condition type for table "comments" */
export type Comments_On_Conflict = {
  constraint: Comments_Constraint;
  update_columns?: Array<Comments_Update_Column>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "comments". */
export type Comments_Order_By = {
  client_questionnaire_question?: InputMaybe<Client_Questionnaire_Questions_Order_By>;
  client_questionnaire_question_id?: InputMaybe<Order_By>;
  comments_comment_uploads_aggregate?: InputMaybe<Comment_Uploads_Aggregate_Order_By>;
  comments_control?: InputMaybe<Controls_Order_By>;
  comments_evidence?: InputMaybe<Evidences_Order_By>;
  comments_notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  comments_policy?: InputMaybe<Policies_Order_By>;
  comments_risk?: InputMaybe<Risks_Order_By>;
  comments_task?: InputMaybe<Tasks_Order_By>;
  comments_user?: InputMaybe<Users_Order_By>;
  comments_vendor?: InputMaybe<Vendors_Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  finding?: InputMaybe<Findings_Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  questionnaire?: InputMaybe<Questionnaires_Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_questionnaire?: InputMaybe<Vendor_Questionnaires_Order_By>;
};

/** primary key columns input for table: comments */
export type Comments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "comments" */
export enum Comments_Select_Column {
  /** column name */
  ClientQuestionnaireQuestionId = 'client_questionnaire_question_id',
  /** column name */
  ControlId = 'control_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EvidenceId = 'evidence_id',
  /** column name */
  FindingId = 'finding_id',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyId = 'policy_id',
  /** column name */
  RiskId = 'risk_id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VendorId = 'vendor_id',
}

/** input type for updating data in table "comments" */
export type Comments_Set_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "comments" */
export enum Comments_Update_Column {
  /** column name */
  Text = 'text',
}

export type Comments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Comments_Bool_Exp;
};

/** Set of assessments resulting for given criteria during the execution of AI review runs */
export type Control_Ai_Review_Assessments = {
  __typename?: 'control_ai_review_assessments';
  assessment: Scalars['String']['output'];
  /** An object relationship */
  control?: Maybe<Controls>;
  control_ai_review_criteria_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  control_findings: Array<Control_Findings>;
  created_at: Scalars['timestamptz']['output'];
  criteria_content: Scalars['String']['output'];
  criteria_heading: Scalars['String']['output'];
  criteria_suggestion: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  meets_criteria: Scalars['Boolean']['output'];
  run_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Set of assessments resulting for given criteria during the execution of AI review runs */
export type Control_Ai_Review_AssessmentsControl_FindingsArgs = {
  distinct_on?: InputMaybe<Array<Control_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Findings_Order_By>>;
  where?: InputMaybe<Control_Findings_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "control_ai_review_assessments". All fields are combined with a logical 'AND'. */
export type Control_Ai_Review_Assessments_Bool_Exp = {
  _and?: InputMaybe<Array<Control_Ai_Review_Assessments_Bool_Exp>>;
  _not?: InputMaybe<Control_Ai_Review_Assessments_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Ai_Review_Assessments_Bool_Exp>>;
  assessment?: InputMaybe<String_Comparison_Exp>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_ai_review_criteria_id?: InputMaybe<Uuid_Comparison_Exp>;
  control_findings?: InputMaybe<Control_Findings_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  criteria_content?: InputMaybe<String_Comparison_Exp>;
  criteria_heading?: InputMaybe<String_Comparison_Exp>;
  criteria_suggestion?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  meets_criteria?: InputMaybe<Boolean_Comparison_Exp>;
  run_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "control_ai_review_assessments". */
export type Control_Ai_Review_Assessments_Order_By = {
  assessment?: InputMaybe<Order_By>;
  control?: InputMaybe<Controls_Order_By>;
  control_ai_review_criteria_id?: InputMaybe<Order_By>;
  control_findings_aggregate?: InputMaybe<Control_Findings_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  criteria_content?: InputMaybe<Order_By>;
  criteria_heading?: InputMaybe<Order_By>;
  criteria_suggestion?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meets_criteria?: InputMaybe<Order_By>;
  run_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Set of criteria elements to be added to a control for AI review */
export type Control_Ai_Review_Criteria = {
  __typename?: 'control_ai_review_criteria';
  content: Scalars['String']['output'];
  /** An object relationship */
  control: Controls;
  control_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  heading: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  suggestion: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "control_ai_review_criteria" */
export type Control_Ai_Review_Criteria_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Control_Ai_Review_Criteria_Max_Order_By>;
  min?: InputMaybe<Control_Ai_Review_Criteria_Min_Order_By>;
};

/** input type for inserting array relation for remote table "control_ai_review_criteria" */
export type Control_Ai_Review_Criteria_Arr_Rel_Insert_Input = {
  data: Array<Control_Ai_Review_Criteria_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Control_Ai_Review_Criteria_On_Conflict>;
};

/** Boolean expression to filter rows from the table "control_ai_review_criteria". All fields are combined with a logical 'AND'. */
export type Control_Ai_Review_Criteria_Bool_Exp = {
  _and?: InputMaybe<Array<Control_Ai_Review_Criteria_Bool_Exp>>;
  _not?: InputMaybe<Control_Ai_Review_Criteria_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Ai_Review_Criteria_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  heading?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  suggestion?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "control_ai_review_criteria" */
export enum Control_Ai_Review_Criteria_Constraint {
  /** unique or primary key constraint on columns "id" */
  ControlAiReviewCriteriaPkey = 'control_ai_review_criteria_pkey',
}

/** input type for inserting data into table "control_ai_review_criteria" */
export type Control_Ai_Review_Criteria_Insert_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "control_ai_review_criteria" */
export type Control_Ai_Review_Criteria_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  suggestion?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "control_ai_review_criteria" */
export type Control_Ai_Review_Criteria_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  suggestion?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "control_ai_review_criteria" */
export type Control_Ai_Review_Criteria_Mutation_Response = {
  __typename?: 'control_ai_review_criteria_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control_Ai_Review_Criteria>;
};

/** on_conflict condition type for table "control_ai_review_criteria" */
export type Control_Ai_Review_Criteria_On_Conflict = {
  constraint: Control_Ai_Review_Criteria_Constraint;
  update_columns?: Array<Control_Ai_Review_Criteria_Update_Column>;
  where?: InputMaybe<Control_Ai_Review_Criteria_Bool_Exp>;
};

/** Ordering options when selecting data from "control_ai_review_criteria". */
export type Control_Ai_Review_Criteria_Order_By = {
  content?: InputMaybe<Order_By>;
  control?: InputMaybe<Controls_Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  suggestion?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: control_ai_review_criteria */
export type Control_Ai_Review_Criteria_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "control_ai_review_criteria" */
export enum Control_Ai_Review_Criteria_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  ControlId = 'control_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Heading = 'heading',
  /** column name */
  Id = 'id',
  /** column name */
  Suggestion = 'suggestion',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "control_ai_review_criteria" */
export type Control_Ai_Review_Criteria_Set_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  suggestion?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "control_ai_review_criteria" */
export enum Control_Ai_Review_Criteria_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Heading = 'heading',
  /** column name */
  Suggestion = 'suggestion',
}

export type Control_Ai_Review_Criteria_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Control_Ai_Review_Criteria_Set_Input>;
  /** filter the rows which have to be updated */
  where: Control_Ai_Review_Criteria_Bool_Exp;
};

/** columns and relationships of "control_categories" */
export type Control_Categories = {
  __typename?: 'control_categories';
  /** An object relationship */
  category: Categories;
  category_id: Scalars['uuid']['output'];
  /** An object relationship */
  control: Controls;
  control_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "control_categories" */
export type Control_Categories_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Control_Categories_Max_Order_By>;
  min?: InputMaybe<Control_Categories_Min_Order_By>;
};

/** input type for inserting array relation for remote table "control_categories" */
export type Control_Categories_Arr_Rel_Insert_Input = {
  data: Array<Control_Categories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Control_Categories_On_Conflict>;
};

/** Boolean expression to filter rows from the table "control_categories". All fields are combined with a logical 'AND'. */
export type Control_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Control_Categories_Bool_Exp>>;
  _not?: InputMaybe<Control_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Categories_Bool_Exp>>;
  category?: InputMaybe<Categories_Bool_Exp>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "control_categories" */
export enum Control_Categories_Constraint {
  /** unique or primary key constraint on columns "category_id", "control_id" */
  ControlCategoriesPkey = 'control_categories_pkey',
}

/** input type for inserting data into table "control_categories" */
export type Control_Categories_Insert_Input = {
  category?: InputMaybe<Categories_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "control_categories" */
export type Control_Categories_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  control_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "control_categories" */
export type Control_Categories_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  control_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "control_categories" */
export type Control_Categories_Mutation_Response = {
  __typename?: 'control_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control_Categories>;
};

/** on_conflict condition type for table "control_categories" */
export type Control_Categories_On_Conflict = {
  constraint: Control_Categories_Constraint;
  update_columns?: Array<Control_Categories_Update_Column>;
  where?: InputMaybe<Control_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "control_categories". */
export type Control_Categories_Order_By = {
  category?: InputMaybe<Categories_Order_By>;
  category_id?: InputMaybe<Order_By>;
  control?: InputMaybe<Controls_Order_By>;
  control_id?: InputMaybe<Order_By>;
};

/** select columns of table "control_categories" */
export enum Control_Categories_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  ControlId = 'control_id',
}

/** placeholder for update columns of table "control_categories" (current role has no relevant permissions) */
export enum Control_Categories_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "control_criteria" */
export type Control_Criteria = {
  __typename?: 'control_criteria';
  /** An object relationship */
  control: Controls;
  control_id: Scalars['uuid']['output'];
  /** An object relationship */
  criteria: Criteria;
  criteria_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "control_criteria" */
export type Control_Criteria_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Control_Criteria_Max_Order_By>;
  min?: InputMaybe<Control_Criteria_Min_Order_By>;
};

/** input type for inserting array relation for remote table "control_criteria" */
export type Control_Criteria_Arr_Rel_Insert_Input = {
  data: Array<Control_Criteria_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Control_Criteria_On_Conflict>;
};

/** Boolean expression to filter rows from the table "control_criteria". All fields are combined with a logical 'AND'. */
export type Control_Criteria_Bool_Exp = {
  _and?: InputMaybe<Array<Control_Criteria_Bool_Exp>>;
  _not?: InputMaybe<Control_Criteria_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Criteria_Bool_Exp>>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  criteria?: InputMaybe<Criteria_Bool_Exp>;
  criteria_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "control_criteria" */
export enum Control_Criteria_Constraint {
  /** unique or primary key constraint on columns "criteria_id", "control_id" */
  ControlCriteriaPkey = 'control_criteria_pkey',
}

/** input type for inserting data into table "control_criteria" */
export type Control_Criteria_Insert_Input = {
  control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  criteria?: InputMaybe<Criteria_Obj_Rel_Insert_Input>;
  criteria_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "control_criteria" */
export type Control_Criteria_Max_Order_By = {
  control_id?: InputMaybe<Order_By>;
  criteria_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "control_criteria" */
export type Control_Criteria_Min_Order_By = {
  control_id?: InputMaybe<Order_By>;
  criteria_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "control_criteria" */
export type Control_Criteria_Mutation_Response = {
  __typename?: 'control_criteria_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control_Criteria>;
};

/** on_conflict condition type for table "control_criteria" */
export type Control_Criteria_On_Conflict = {
  constraint: Control_Criteria_Constraint;
  update_columns?: Array<Control_Criteria_Update_Column>;
  where?: InputMaybe<Control_Criteria_Bool_Exp>;
};

/** Ordering options when selecting data from "control_criteria". */
export type Control_Criteria_Order_By = {
  control?: InputMaybe<Controls_Order_By>;
  control_id?: InputMaybe<Order_By>;
  criteria?: InputMaybe<Criteria_Order_By>;
  criteria_id?: InputMaybe<Order_By>;
};

/** select columns of table "control_criteria" */
export enum Control_Criteria_Select_Column {
  /** column name */
  ControlId = 'control_id',
  /** column name */
  CriteriaId = 'criteria_id',
}

/** placeholder for update columns of table "control_criteria" (current role has no relevant permissions) */
export enum Control_Criteria_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "control_evidences" */
export type Control_Evidences = {
  __typename?: 'control_evidences';
  /** An object relationship */
  control?: Maybe<Controls>;
  /** An array relationship */
  control_findings: Array<Control_Findings>;
  control_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  evidence?: Maybe<Evidences>;
  evidence_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  status: Scalars['ControlEvidenceStatus']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "control_evidences" */
export type Control_EvidencesControl_FindingsArgs = {
  distinct_on?: InputMaybe<Array<Control_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Findings_Order_By>>;
  where?: InputMaybe<Control_Findings_Bool_Exp>;
};

/** order by aggregate values of table "control_evidences" */
export type Control_Evidences_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Control_Evidences_Max_Order_By>;
  min?: InputMaybe<Control_Evidences_Min_Order_By>;
};

/** input type for inserting array relation for remote table "control_evidences" */
export type Control_Evidences_Arr_Rel_Insert_Input = {
  data: Array<Control_Evidences_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Control_Evidences_On_Conflict>;
};

/** Boolean expression to filter rows from the table "control_evidences". All fields are combined with a logical 'AND'. */
export type Control_Evidences_Bool_Exp = {
  _and?: InputMaybe<Array<Control_Evidences_Bool_Exp>>;
  _not?: InputMaybe<Control_Evidences_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Evidences_Bool_Exp>>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_findings?: InputMaybe<Control_Findings_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  evidence?: InputMaybe<Evidences_Bool_Exp>;
  evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "control_evidences" */
export enum Control_Evidences_Constraint {
  /** unique or primary key constraint on columns "evidence_id", "control_id" */
  ControlEvidencesControlIdEvidenceIdKey = 'control_evidences_control_id_evidence_id_key',
  /** unique or primary key constraint on columns "id" */
  ControlEvidencesPrimaryKey = 'control_evidences_primary_key',
}

/** input type for inserting data into table "control_evidences" */
export type Control_Evidences_Insert_Input = {
  control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  evidence?: InputMaybe<Evidences_Obj_Rel_Insert_Input>;
  evidence_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "control_evidences" */
export type Control_Evidences_Max_Order_By = {
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "control_evidences" */
export type Control_Evidences_Min_Order_By = {
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "control_evidences" */
export type Control_Evidences_Mutation_Response = {
  __typename?: 'control_evidences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control_Evidences>;
};

/** on_conflict condition type for table "control_evidences" */
export type Control_Evidences_On_Conflict = {
  constraint: Control_Evidences_Constraint;
  update_columns?: Array<Control_Evidences_Update_Column>;
  where?: InputMaybe<Control_Evidences_Bool_Exp>;
};

/** Ordering options when selecting data from "control_evidences". */
export type Control_Evidences_Order_By = {
  control?: InputMaybe<Controls_Order_By>;
  control_findings_aggregate?: InputMaybe<Control_Findings_Aggregate_Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  evidence?: InputMaybe<Evidences_Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "control_evidences" */
export enum Control_Evidences_Select_Column {
  /** column name */
  ControlId = 'control_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EvidenceId = 'evidence_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** placeholder for update columns of table "control_evidences" (current role has no relevant permissions) */
export enum Control_Evidences_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "control_findings" */
export type Control_Findings = {
  __typename?: 'control_findings';
  cause: Finding_Causes_Enum;
  /** An object relationship */
  control: Controls;
  /** An object relationship */
  control_ai_review_assessment?: Maybe<Control_Ai_Review_Assessments>;
  control_ai_review_assessment_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  control_evidence?: Maybe<Control_Evidences>;
  control_evidence_id?: Maybe<Scalars['uuid']['output']>;
  control_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  evidence_policy?: Maybe<Evidence_Policies>;
  evidence_policy_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  integration_run?: Maybe<Integration_Runs>;
  integration_run_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  manual_finding?: Maybe<Manual_Findings>;
  manual_finding_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  resolution?: Maybe<Finding_Resolutions>;
  /** An object relationship */
  risk?: Maybe<Risks>;
  risk_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  task?: Maybe<Tasks>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  type: Finding_Types_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "control_findings" */
export type Control_Findings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Control_Findings_Max_Order_By>;
  min?: InputMaybe<Control_Findings_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "control_findings". All fields are combined with a logical 'AND'. */
export type Control_Findings_Bool_Exp = {
  _and?: InputMaybe<Array<Control_Findings_Bool_Exp>>;
  _not?: InputMaybe<Control_Findings_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Findings_Bool_Exp>>;
  cause?: InputMaybe<Finding_Causes_Enum_Comparison_Exp>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_ai_review_assessment?: InputMaybe<Control_Ai_Review_Assessments_Bool_Exp>;
  control_ai_review_assessment_id?: InputMaybe<Uuid_Comparison_Exp>;
  control_evidence?: InputMaybe<Control_Evidences_Bool_Exp>;
  control_evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  evidence_policy?: InputMaybe<Evidence_Policies_Bool_Exp>;
  evidence_policy_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  integration_run?: InputMaybe<Integration_Runs_Bool_Exp>;
  integration_run_id?: InputMaybe<Uuid_Comparison_Exp>;
  manual_finding?: InputMaybe<Manual_Findings_Bool_Exp>;
  manual_finding_id?: InputMaybe<Uuid_Comparison_Exp>;
  resolution?: InputMaybe<Finding_Resolutions_Bool_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Finding_Types_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "control_findings" */
export type Control_Findings_Max_Order_By = {
  control_ai_review_assessment_id?: InputMaybe<Order_By>;
  control_evidence_id?: InputMaybe<Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  evidence_policy_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  integration_run_id?: InputMaybe<Order_By>;
  manual_finding_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "control_findings" */
export type Control_Findings_Min_Order_By = {
  control_ai_review_assessment_id?: InputMaybe<Order_By>;
  control_evidence_id?: InputMaybe<Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  evidence_policy_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  integration_run_id?: InputMaybe<Order_By>;
  manual_finding_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "control_findings" */
export type Control_Findings_Mutation_Response = {
  __typename?: 'control_findings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control_Findings>;
};

/** Ordering options when selecting data from "control_findings". */
export type Control_Findings_Order_By = {
  cause?: InputMaybe<Order_By>;
  control?: InputMaybe<Controls_Order_By>;
  control_ai_review_assessment?: InputMaybe<Control_Ai_Review_Assessments_Order_By>;
  control_ai_review_assessment_id?: InputMaybe<Order_By>;
  control_evidence?: InputMaybe<Control_Evidences_Order_By>;
  control_evidence_id?: InputMaybe<Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  evidence_policy?: InputMaybe<Evidence_Policies_Order_By>;
  evidence_policy_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  integration_run?: InputMaybe<Integration_Runs_Order_By>;
  integration_run_id?: InputMaybe<Order_By>;
  manual_finding?: InputMaybe<Manual_Findings_Order_By>;
  manual_finding_id?: InputMaybe<Order_By>;
  resolution?: InputMaybe<Finding_Resolutions_Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: control_findings */
export type Control_Findings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "control_findings" */
export enum Control_Findings_Select_Column {
  /** column name */
  Cause = 'cause',
  /** column name */
  ControlAiReviewAssessmentId = 'control_ai_review_assessment_id',
  /** column name */
  ControlEvidenceId = 'control_evidence_id',
  /** column name */
  ControlId = 'control_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EvidencePolicyId = 'evidence_policy_id',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationRunId = 'integration_run_id',
  /** column name */
  ManualFindingId = 'manual_finding_id',
  /** column name */
  RiskId = 'risk_id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "control_findings" */
export type Control_Findings_Set_Input = {
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Control_Findings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Control_Findings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Control_Findings_Bool_Exp;
};

export enum Control_Frequencies_Enum {
  Annual = 'Annual',
  Biannual = 'Biannual',
  Biweekly = 'Biweekly',
  Daily = 'Daily',
  Indefinite = 'Indefinite',
  Monthly = 'Monthly',
  OneAndHalfYears = 'One_and_half_years',
  Quarterly = 'Quarterly',
  ThreeYears = 'Three_years',
  TwoYears = 'Two_years',
  Weekly = 'Weekly',
}

/** Boolean expression to compare columns of type "control_frequencies_enum". All fields are combined with logical 'AND'. */
export type Control_Frequencies_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Control_Frequencies_Enum>;
  _in?: InputMaybe<Array<Control_Frequencies_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Control_Frequencies_Enum>;
  _nin?: InputMaybe<Array<Control_Frequencies_Enum>>;
};

/** columns and relationships of "control_groups" */
export type Control_Groups = {
  __typename?: 'control_groups';
  /** An object relationship */
  control: Controls;
  control_id: Scalars['uuid']['output'];
  /** An object relationship */
  group: Groups;
  group_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "control_groups" */
export type Control_Groups_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Control_Groups_Max_Order_By>;
  min?: InputMaybe<Control_Groups_Min_Order_By>;
};

/** input type for inserting array relation for remote table "control_groups" */
export type Control_Groups_Arr_Rel_Insert_Input = {
  data: Array<Control_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Control_Groups_On_Conflict>;
};

/** Boolean expression to filter rows from the table "control_groups". All fields are combined with a logical 'AND'. */
export type Control_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Control_Groups_Bool_Exp>>;
  _not?: InputMaybe<Control_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Groups_Bool_Exp>>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  group?: InputMaybe<Groups_Bool_Exp>;
  group_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "control_groups" */
export enum Control_Groups_Constraint {
  /** unique or primary key constraint on columns "control_id", "group_id" */
  ControlGroupsPkey = 'control_groups_pkey',
}

/** input type for inserting data into table "control_groups" */
export type Control_Groups_Insert_Input = {
  control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "control_groups" */
export type Control_Groups_Max_Order_By = {
  control_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "control_groups" */
export type Control_Groups_Min_Order_By = {
  control_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "control_groups" */
export type Control_Groups_Mutation_Response = {
  __typename?: 'control_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control_Groups>;
};

/** on_conflict condition type for table "control_groups" */
export type Control_Groups_On_Conflict = {
  constraint: Control_Groups_Constraint;
  update_columns?: Array<Control_Groups_Update_Column>;
  where?: InputMaybe<Control_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "control_groups". */
export type Control_Groups_Order_By = {
  control?: InputMaybe<Controls_Order_By>;
  control_id?: InputMaybe<Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** select columns of table "control_groups" */
export enum Control_Groups_Select_Column {
  /** column name */
  ControlId = 'control_id',
  /** column name */
  GroupId = 'group_id',
}

/** placeholder for update columns of table "control_groups" (current role has no relevant permissions) */
export enum Control_Groups_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** users responsible for control */
export type Control_Owners = {
  __typename?: 'control_owners';
  /** An object relationship */
  control: Controls;
  control_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  owner_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
};

/** order by aggregate values of table "control_owners" */
export type Control_Owners_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Control_Owners_Max_Order_By>;
  min?: InputMaybe<Control_Owners_Min_Order_By>;
};

/** input type for inserting array relation for remote table "control_owners" */
export type Control_Owners_Arr_Rel_Insert_Input = {
  data: Array<Control_Owners_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Control_Owners_On_Conflict>;
};

/** Boolean expression to filter rows from the table "control_owners". All fields are combined with a logical 'AND'. */
export type Control_Owners_Bool_Exp = {
  _and?: InputMaybe<Array<Control_Owners_Bool_Exp>>;
  _not?: InputMaybe<Control_Owners_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Owners_Bool_Exp>>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "control_owners" */
export enum Control_Owners_Constraint {
  /** unique or primary key constraint on columns "owner_id", "control_id" */
  ControlOwnersControlIdOwnerIdKey = 'control_owners_control_id_owner_id_key',
  /** unique or primary key constraint on columns "id" */
  ControlOwnersPkey = 'control_owners_pkey',
}

/** input type for inserting data into table "control_owners" */
export type Control_Owners_Insert_Input = {
  control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "control_owners" */
export type Control_Owners_Max_Order_By = {
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "control_owners" */
export type Control_Owners_Min_Order_By = {
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "control_owners" */
export type Control_Owners_Mutation_Response = {
  __typename?: 'control_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control_Owners>;
};

/** on_conflict condition type for table "control_owners" */
export type Control_Owners_On_Conflict = {
  constraint: Control_Owners_Constraint;
  update_columns?: Array<Control_Owners_Update_Column>;
  where?: InputMaybe<Control_Owners_Bool_Exp>;
};

/** Ordering options when selecting data from "control_owners". */
export type Control_Owners_Order_By = {
  control?: InputMaybe<Controls_Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "control_owners" */
export enum Control_Owners_Select_Column {
  /** column name */
  ControlId = 'control_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerId = 'owner_id',
}

/** placeholder for update columns of table "control_owners" (current role has no relevant permissions) */
export enum Control_Owners_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

export enum Control_Priorities_Enum {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4',
  P5 = 'P5',
}

/** Boolean expression to compare columns of type "control_priorities_enum". All fields are combined with logical 'AND'. */
export type Control_Priorities_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Control_Priorities_Enum>;
  _in?: InputMaybe<Array<Control_Priorities_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Control_Priorities_Enum>;
  _nin?: InputMaybe<Array<Control_Priorities_Enum>>;
};

/** columns and relationships of "control_tags" */
export type Control_Tags = {
  __typename?: 'control_tags';
  /** An object relationship */
  control: Controls;
  control_id: Scalars['uuid']['output'];
  /** An object relationship */
  tag: Tags;
  tag_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "control_tags" */
export type Control_Tags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Control_Tags_Max_Order_By>;
  min?: InputMaybe<Control_Tags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "control_tags" */
export type Control_Tags_Arr_Rel_Insert_Input = {
  data: Array<Control_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Control_Tags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "control_tags". All fields are combined with a logical 'AND'. */
export type Control_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Control_Tags_Bool_Exp>>;
  _not?: InputMaybe<Control_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Tags_Bool_Exp>>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  tag?: InputMaybe<Tags_Bool_Exp>;
  tag_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "control_tags" */
export enum Control_Tags_Constraint {
  /** unique or primary key constraint on columns "tag_id", "control_id" */
  ControlTagsPkey = 'control_tags_pkey',
}

/** input type for inserting data into table "control_tags" */
export type Control_Tags_Insert_Input = {
  control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  tag?: InputMaybe<Tags_Obj_Rel_Insert_Input>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "control_tags" */
export type Control_Tags_Max_Order_By = {
  control_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "control_tags" */
export type Control_Tags_Min_Order_By = {
  control_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "control_tags" */
export type Control_Tags_Mutation_Response = {
  __typename?: 'control_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control_Tags>;
};

/** on_conflict condition type for table "control_tags" */
export type Control_Tags_On_Conflict = {
  constraint: Control_Tags_Constraint;
  update_columns?: Array<Control_Tags_Update_Column>;
  where?: InputMaybe<Control_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "control_tags". */
export type Control_Tags_Order_By = {
  control?: InputMaybe<Controls_Order_By>;
  control_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Tags_Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** select columns of table "control_tags" */
export enum Control_Tags_Select_Column {
  /** column name */
  ControlId = 'control_id',
  /** column name */
  TagId = 'tag_id',
}

/** placeholder for update columns of table "control_tags" (current role has no relevant permissions) */
export enum Control_Tags_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

export type Control_Tags_View = {
  __typename?: 'control_tags_view';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** columns and relationships of "control_tasks" */
export type Control_Tasks = {
  __typename?: 'control_tasks';
  /** An object relationship */
  control?: Maybe<Controls>;
  control_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  task?: Maybe<Tasks>;
  task_id: Scalars['uuid']['output'];
};

/** aggregated selection of "control_tasks" */
export type Control_Tasks_Aggregate = {
  __typename?: 'control_tasks_aggregate';
  aggregate?: Maybe<Control_Tasks_Aggregate_Fields>;
  nodes: Array<Control_Tasks>;
};

export type Control_Tasks_Aggregate_Bool_Exp = {
  count?: InputMaybe<Control_Tasks_Aggregate_Bool_Exp_Count>;
};

export type Control_Tasks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Control_Tasks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Control_Tasks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "control_tasks" */
export type Control_Tasks_Aggregate_Fields = {
  __typename?: 'control_tasks_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Control_Tasks_Max_Fields>;
  min?: Maybe<Control_Tasks_Min_Fields>;
};

/** aggregate fields of "control_tasks" */
export type Control_Tasks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Control_Tasks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "control_tasks" */
export type Control_Tasks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Control_Tasks_Max_Order_By>;
  min?: InputMaybe<Control_Tasks_Min_Order_By>;
};

/** input type for inserting array relation for remote table "control_tasks" */
export type Control_Tasks_Arr_Rel_Insert_Input = {
  data: Array<Control_Tasks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Control_Tasks_On_Conflict>;
};

/** Boolean expression to filter rows from the table "control_tasks". All fields are combined with a logical 'AND'. */
export type Control_Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Control_Tasks_Bool_Exp>>;
  _not?: InputMaybe<Control_Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Tasks_Bool_Exp>>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "control_tasks" */
export enum Control_Tasks_Constraint {
  /** unique or primary key constraint on columns "task_id", "control_id" */
  ControlTasksControlIdTaskIdKey = 'control_tasks_control_id_task_id_key',
  /** unique or primary key constraint on columns "id" */
  ControlTasksPkey = 'control_tasks_pkey',
}

/** input type for inserting data into table "control_tasks" */
export type Control_Tasks_Insert_Input = {
  control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Control_Tasks_Max_Fields = {
  __typename?: 'control_tasks_max_fields';
  control_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "control_tasks" */
export type Control_Tasks_Max_Order_By = {
  control_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Control_Tasks_Min_Fields = {
  __typename?: 'control_tasks_min_fields';
  control_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "control_tasks" */
export type Control_Tasks_Min_Order_By = {
  control_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "control_tasks" */
export type Control_Tasks_Mutation_Response = {
  __typename?: 'control_tasks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control_Tasks>;
};

/** on_conflict condition type for table "control_tasks" */
export type Control_Tasks_On_Conflict = {
  constraint: Control_Tasks_Constraint;
  update_columns?: Array<Control_Tasks_Update_Column>;
  where?: InputMaybe<Control_Tasks_Bool_Exp>;
};

/** Ordering options when selecting data from "control_tasks". */
export type Control_Tasks_Order_By = {
  control?: InputMaybe<Controls_Order_By>;
  control_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** select columns of table "control_tasks" */
export enum Control_Tasks_Select_Column {
  /** column name */
  ControlId = 'control_id',
  /** column name */
  Id = 'id',
  /** column name */
  TaskId = 'task_id',
}

/** placeholder for update columns of table "control_tasks" (current role has no relevant permissions) */
export enum Control_Tasks_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type Controls = {
  __typename?: 'controls';
  /** An array relationship */
  categories: Array<Control_Categories>;
  /** An array relationship */
  control_ai_review_criteria: Array<Control_Ai_Review_Criteria>;
  /** An array relationship */
  control_evidences: Array<Control_Evidences>;
  /** An array relationship */
  control_owners: Array<Control_Owners>;
  /** An array relationship */
  control_tasks: Array<Control_Tasks>;
  /** An aggregate relationship */
  control_tasks_aggregate: Control_Tasks_Aggregate;
  /** An array relationship */
  controls_comments: Array<Comments>;
  /** An array relationship */
  controls_vector_stores: Array<Ai_Controls_Vector_Store>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  criterias: Array<Control_Criteria>;
  /** An array relationship */
  custom_tags: Array<Control_Tags>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  evidence_runs: Array<Integration_Runs>;
  /** An aggregate relationship */
  evidence_runs_aggregate: Integration_Runs_Aggregate;
  /** An array relationship */
  field_values: Array<Field_Values>;
  /** An array relationship */
  findings: Array<Control_Findings>;
  /** An array relationship */
  frameworks_controls: Array<Frameworks_Controls>;
  frequency: Control_Frequencies_Enum;
  /** An array relationship */
  groups: Array<Control_Groups>;
  id: Scalars['uuid']['output'];
  internal_id?: Maybe<Scalars['String']['output']>;
  irrelevant: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  priority?: Maybe<Control_Priorities_Enum>;
  /** An array relationship */
  program_controls: Array<Program_Controls>;
  /** An aggregate relationship */
  program_controls_aggregate: Program_Controls_Aggregate;
  /** An array relationship */
  risk_controls: Array<Risk_Controls>;
  /** Generic control-level settings. Each feature owns one top-level key (e.g. ai_evidence), validated in application code, not by the DB. Writes must merge their key so sibling sections are not clobbered. */
  settings?: Maybe<Scalars['jsonb']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  /** An array relationship */
  source_entity_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  source_entity_relations_aggregate: Entity_Relations_Aggregate;
  status: Scalars['ControlStatus']['output'];
  tags: Scalars['ControlTags']['output'];
  /** An array relationship */
  target_entity_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  target_entity_relations_aggregate: Entity_Relations_Aggregate;
  /** An object relationship */
  template_control?: Maybe<Template_Controls>;
  template_control_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Control_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Categories_Order_By>>;
  where?: InputMaybe<Control_Categories_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsControl_Ai_Review_CriteriaArgs = {
  distinct_on?: InputMaybe<Array<Control_Ai_Review_Criteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Ai_Review_Criteria_Order_By>>;
  where?: InputMaybe<Control_Ai_Review_Criteria_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsControl_EvidencesArgs = {
  distinct_on?: InputMaybe<Array<Control_Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Evidences_Order_By>>;
  where?: InputMaybe<Control_Evidences_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsControl_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Control_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Owners_Order_By>>;
  where?: InputMaybe<Control_Owners_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsControl_TasksArgs = {
  distinct_on?: InputMaybe<Array<Control_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Tasks_Order_By>>;
  where?: InputMaybe<Control_Tasks_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsControl_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Tasks_Order_By>>;
  where?: InputMaybe<Control_Tasks_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsControls_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsControls_Vector_StoresArgs = {
  distinct_on?: InputMaybe<Array<Ai_Controls_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Controls_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Controls_Vector_Store_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsCriteriasArgs = {
  distinct_on?: InputMaybe<Array<Control_Criteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Criteria_Order_By>>;
  where?: InputMaybe<Control_Criteria_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsCustom_TagsArgs = {
  distinct_on?: InputMaybe<Array<Control_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Tags_Order_By>>;
  where?: InputMaybe<Control_Tags_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsEvidence_RunsArgs = {
  distinct_on?: InputMaybe<Array<Integration_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integration_Runs_Order_By>>;
  where?: InputMaybe<Integration_Runs_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsEvidence_Runs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integration_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integration_Runs_Order_By>>;
  where?: InputMaybe<Integration_Runs_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsField_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Values_Order_By>>;
  where?: InputMaybe<Field_Values_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsFindingsArgs = {
  distinct_on?: InputMaybe<Array<Control_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Findings_Order_By>>;
  where?: InputMaybe<Control_Findings_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsFrameworks_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Frameworks_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Frameworks_Controls_Order_By>>;
  where?: InputMaybe<Frameworks_Controls_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsGroupsArgs = {
  distinct_on?: InputMaybe<Array<Control_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Groups_Order_By>>;
  where?: InputMaybe<Control_Groups_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsProgram_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Program_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Program_Controls_Order_By>>;
  where?: InputMaybe<Program_Controls_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsProgram_Controls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Program_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Program_Controls_Order_By>>;
  where?: InputMaybe<Program_Controls_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsRisk_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Controls_Order_By>>;
  where?: InputMaybe<Risk_Controls_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsSource_Entity_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsSource_Entity_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsTarget_Entity_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** Stores programs' controls, specific to one organization. Controls are customized here. */
export type ControlsTarget_Entity_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** aggregated selection of "controls" */
export type Controls_Aggregate = {
  __typename?: 'controls_aggregate';
  aggregate?: Maybe<Controls_Aggregate_Fields>;
  nodes: Array<Controls>;
};

export type Controls_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Controls_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Controls_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Controls_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Controls_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Controls_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Controls_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Controls_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Controls_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Controls_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Controls_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Controls_Aggregate_Bool_Exp_Var_Samp>;
};

export type Controls_Aggregate_Bool_Exp_Avg = {
  arguments: Controls_Select_Column_Controls_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Controls_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Controls_Aggregate_Bool_Exp_Bool_And = {
  arguments: Controls_Select_Column_Controls_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Controls_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Controls_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Controls_Select_Column_Controls_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Controls_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Controls_Aggregate_Bool_Exp_Corr = {
  arguments: Controls_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Controls_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Controls_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Controls_Select_Column_Controls_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Controls_Select_Column_Controls_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Controls_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Controls_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Controls_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Controls_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Controls_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Controls_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Controls_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Controls_Select_Column_Controls_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Controls_Select_Column_Controls_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Controls_Aggregate_Bool_Exp_Max = {
  arguments: Controls_Select_Column_Controls_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Controls_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Controls_Aggregate_Bool_Exp_Min = {
  arguments: Controls_Select_Column_Controls_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Controls_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Controls_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Controls_Select_Column_Controls_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Controls_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Controls_Aggregate_Bool_Exp_Sum = {
  arguments: Controls_Select_Column_Controls_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Controls_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Controls_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Controls_Select_Column_Controls_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Controls_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "controls" */
export type Controls_Aggregate_Fields = {
  __typename?: 'controls_aggregate_fields';
  avg?: Maybe<Controls_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Controls_Max_Fields>;
  min?: Maybe<Controls_Min_Fields>;
  stddev?: Maybe<Controls_Stddev_Fields>;
  stddev_pop?: Maybe<Controls_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Controls_Stddev_Samp_Fields>;
  sum?: Maybe<Controls_Sum_Fields>;
  var_pop?: Maybe<Controls_Var_Pop_Fields>;
  var_samp?: Maybe<Controls_Var_Samp_Fields>;
  variance?: Maybe<Controls_Variance_Fields>;
};

/** aggregate fields of "controls" */
export type Controls_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Controls_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "controls" */
export type Controls_Aggregate_Order_By = {
  avg?: InputMaybe<Controls_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Controls_Max_Order_By>;
  min?: InputMaybe<Controls_Min_Order_By>;
  stddev?: InputMaybe<Controls_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Controls_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Controls_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Controls_Sum_Order_By>;
  var_pop?: InputMaybe<Controls_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Controls_Var_Samp_Order_By>;
  variance?: InputMaybe<Controls_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Controls_Append_Input = {
  /** Generic control-level settings. Each feature owns one top-level key (e.g. ai_evidence), validated in application code, not by the DB. Writes must merge their key so sibling sections are not clobbered. */
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Controls_Avg_Fields = {
  __typename?: 'controls_avg_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "controls" */
export type Controls_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "controls". All fields are combined with a logical 'AND'. */
export type Controls_Bool_Exp = {
  _and?: InputMaybe<Array<Controls_Bool_Exp>>;
  _not?: InputMaybe<Controls_Bool_Exp>;
  _or?: InputMaybe<Array<Controls_Bool_Exp>>;
  categories?: InputMaybe<Control_Categories_Bool_Exp>;
  control_ai_review_criteria?: InputMaybe<Control_Ai_Review_Criteria_Bool_Exp>;
  control_evidences?: InputMaybe<Control_Evidences_Bool_Exp>;
  control_owners?: InputMaybe<Control_Owners_Bool_Exp>;
  control_tasks?: InputMaybe<Control_Tasks_Bool_Exp>;
  control_tasks_aggregate?: InputMaybe<Control_Tasks_Aggregate_Bool_Exp>;
  controls_comments?: InputMaybe<Comments_Bool_Exp>;
  controls_vector_stores?: InputMaybe<Ai_Controls_Vector_Store_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  criterias?: InputMaybe<Control_Criteria_Bool_Exp>;
  custom_tags?: InputMaybe<Control_Tags_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  evidence_runs?: InputMaybe<Integration_Runs_Bool_Exp>;
  evidence_runs_aggregate?: InputMaybe<Integration_Runs_Aggregate_Bool_Exp>;
  field_values?: InputMaybe<Field_Values_Bool_Exp>;
  findings?: InputMaybe<Control_Findings_Bool_Exp>;
  frameworks_controls?: InputMaybe<Frameworks_Controls_Bool_Exp>;
  frequency?: InputMaybe<Control_Frequencies_Enum_Comparison_Exp>;
  groups?: InputMaybe<Control_Groups_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_id?: InputMaybe<String_Comparison_Exp>;
  irrelevant?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  priority?: InputMaybe<Control_Priorities_Enum_Comparison_Exp>;
  program_controls?: InputMaybe<Program_Controls_Bool_Exp>;
  program_controls_aggregate?: InputMaybe<Program_Controls_Aggregate_Bool_Exp>;
  risk_controls?: InputMaybe<Risk_Controls_Bool_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  source_entity_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  source_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  target_entity_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  target_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  template_control?: InputMaybe<Template_Controls_Bool_Exp>;
  template_control_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "controls" */
export enum Controls_Constraint {
  /** unique or primary key constraint on columns "id", "organization_id" */
  ControlsIdOrganizationIdKey = 'controls_id_organization_id_key',
  /** unique or primary key constraint on columns "organization_id", "internal_id" */
  ControlsOrganizationIdInternalIdKey = 'controls_organization_id_internal_id_key',
  /** unique or primary key constraint on columns "id" */
  ProgramControlsPkey = 'program_controls_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Controls_Delete_At_Path_Input = {
  /** Generic control-level settings. Each feature owns one top-level key (e.g. ai_evidence), validated in application code, not by the DB. Writes must merge their key so sibling sections are not clobbered. */
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Controls_Delete_Elem_Input = {
  /** Generic control-level settings. Each feature owns one top-level key (e.g. ai_evidence), validated in application code, not by the DB. Writes must merge their key so sibling sections are not clobbered. */
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Controls_Delete_Key_Input = {
  /** Generic control-level settings. Each feature owns one top-level key (e.g. ai_evidence), validated in application code, not by the DB. Writes must merge their key so sibling sections are not clobbered. */
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "controls_history_stats" */
export type Controls_History_Stats = {
  __typename?: 'controls_history_stats';
  at_risk_count: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  failing_count: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  not_relevant_count: Scalars['Int']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  owner?: Maybe<Users>;
  owner_id?: Maybe<Scalars['uuid']['output']>;
  pending_count: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  valid_count: Scalars['Int']['output'];
};

/** order by aggregate values of table "controls_history_stats" */
export type Controls_History_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<Controls_History_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Controls_History_Stats_Max_Order_By>;
  min?: InputMaybe<Controls_History_Stats_Min_Order_By>;
  stddev?: InputMaybe<Controls_History_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Controls_History_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Controls_History_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Controls_History_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<Controls_History_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Controls_History_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<Controls_History_Stats_Variance_Order_By>;
};

/** order by avg() on columns of table "controls_history_stats" */
export type Controls_History_Stats_Avg_Order_By = {
  at_risk_count?: InputMaybe<Order_By>;
  failing_count?: InputMaybe<Order_By>;
  not_relevant_count?: InputMaybe<Order_By>;
  pending_count?: InputMaybe<Order_By>;
  valid_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "controls_history_stats". All fields are combined with a logical 'AND'. */
export type Controls_History_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Controls_History_Stats_Bool_Exp>>;
  _not?: InputMaybe<Controls_History_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Controls_History_Stats_Bool_Exp>>;
  at_risk_count?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  failing_count?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  not_relevant_count?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  owner?: InputMaybe<Users_Bool_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  pending_count?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_count?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "controls_history_stats" */
export type Controls_History_Stats_Max_Order_By = {
  at_risk_count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  failing_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  not_relevant_count?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  pending_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_count?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "controls_history_stats" */
export type Controls_History_Stats_Min_Order_By = {
  at_risk_count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  failing_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  not_relevant_count?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  pending_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_count?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "controls_history_stats". */
export type Controls_History_Stats_Order_By = {
  at_risk_count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  failing_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  not_relevant_count?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Users_Order_By>;
  owner_id?: InputMaybe<Order_By>;
  pending_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_count?: InputMaybe<Order_By>;
};

/** select columns of table "controls_history_stats" */
export enum Controls_History_Stats_Select_Column {
  /** column name */
  AtRiskCount = 'at_risk_count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FailingCount = 'failing_count',
  /** column name */
  Id = 'id',
  /** column name */
  NotRelevantCount = 'not_relevant_count',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  PendingCount = 'pending_count',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidCount = 'valid_count',
}

/** order by stddev() on columns of table "controls_history_stats" */
export type Controls_History_Stats_Stddev_Order_By = {
  at_risk_count?: InputMaybe<Order_By>;
  failing_count?: InputMaybe<Order_By>;
  not_relevant_count?: InputMaybe<Order_By>;
  pending_count?: InputMaybe<Order_By>;
  valid_count?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "controls_history_stats" */
export type Controls_History_Stats_Stddev_Pop_Order_By = {
  at_risk_count?: InputMaybe<Order_By>;
  failing_count?: InputMaybe<Order_By>;
  not_relevant_count?: InputMaybe<Order_By>;
  pending_count?: InputMaybe<Order_By>;
  valid_count?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "controls_history_stats" */
export type Controls_History_Stats_Stddev_Samp_Order_By = {
  at_risk_count?: InputMaybe<Order_By>;
  failing_count?: InputMaybe<Order_By>;
  not_relevant_count?: InputMaybe<Order_By>;
  pending_count?: InputMaybe<Order_By>;
  valid_count?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "controls_history_stats" */
export type Controls_History_Stats_Sum_Order_By = {
  at_risk_count?: InputMaybe<Order_By>;
  failing_count?: InputMaybe<Order_By>;
  not_relevant_count?: InputMaybe<Order_By>;
  pending_count?: InputMaybe<Order_By>;
  valid_count?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "controls_history_stats" */
export type Controls_History_Stats_Var_Pop_Order_By = {
  at_risk_count?: InputMaybe<Order_By>;
  failing_count?: InputMaybe<Order_By>;
  not_relevant_count?: InputMaybe<Order_By>;
  pending_count?: InputMaybe<Order_By>;
  valid_count?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "controls_history_stats" */
export type Controls_History_Stats_Var_Samp_Order_By = {
  at_risk_count?: InputMaybe<Order_By>;
  failing_count?: InputMaybe<Order_By>;
  not_relevant_count?: InputMaybe<Order_By>;
  pending_count?: InputMaybe<Order_By>;
  valid_count?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "controls_history_stats" */
export type Controls_History_Stats_Variance_Order_By = {
  at_risk_count?: InputMaybe<Order_By>;
  failing_count?: InputMaybe<Order_By>;
  not_relevant_count?: InputMaybe<Order_By>;
  pending_count?: InputMaybe<Order_By>;
  valid_count?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "controls" */
export type Controls_Insert_Input = {
  categories?: InputMaybe<Control_Categories_Arr_Rel_Insert_Input>;
  control_ai_review_criteria?: InputMaybe<Control_Ai_Review_Criteria_Arr_Rel_Insert_Input>;
  control_evidences?: InputMaybe<Control_Evidences_Arr_Rel_Insert_Input>;
  control_owners?: InputMaybe<Control_Owners_Arr_Rel_Insert_Input>;
  control_tasks?: InputMaybe<Control_Tasks_Arr_Rel_Insert_Input>;
  controls_comments?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  criterias?: InputMaybe<Control_Criteria_Arr_Rel_Insert_Input>;
  custom_tags?: InputMaybe<Control_Tags_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  field_values?: InputMaybe<Field_Values_Arr_Rel_Insert_Input>;
  frameworks_controls?: InputMaybe<Frameworks_Controls_Arr_Rel_Insert_Input>;
  frequency?: InputMaybe<Control_Frequencies_Enum>;
  groups?: InputMaybe<Control_Groups_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  priority?: InputMaybe<Control_Priorities_Enum>;
  program_controls?: InputMaybe<Program_Controls_Arr_Rel_Insert_Input>;
  risk_controls?: InputMaybe<Risk_Controls_Arr_Rel_Insert_Input>;
  source_entity_relations?: InputMaybe<Entity_Relations_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  target_entity_relations?: InputMaybe<Entity_Relations_Arr_Rel_Insert_Input>;
  template_control_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Controls_Max_Fields = {
  __typename?: 'controls_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  template_control_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "controls" */
export type Controls_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  template_control_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Controls_Min_Fields = {
  __typename?: 'controls_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  template_control_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "controls" */
export type Controls_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  template_control_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "controls" */
export type Controls_Mutation_Response = {
  __typename?: 'controls_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Controls>;
};

/** input type for inserting object relation for remote table "controls" */
export type Controls_Obj_Rel_Insert_Input = {
  data: Controls_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Controls_On_Conflict>;
};

/** on_conflict condition type for table "controls" */
export type Controls_On_Conflict = {
  constraint: Controls_Constraint;
  update_columns?: Array<Controls_Update_Column>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

/** Ordering options when selecting data from "controls". */
export type Controls_Order_By = {
  categories_aggregate?: InputMaybe<Control_Categories_Aggregate_Order_By>;
  control_ai_review_criteria_aggregate?: InputMaybe<Control_Ai_Review_Criteria_Aggregate_Order_By>;
  control_evidences_aggregate?: InputMaybe<Control_Evidences_Aggregate_Order_By>;
  control_owners_aggregate?: InputMaybe<Control_Owners_Aggregate_Order_By>;
  control_tasks_aggregate?: InputMaybe<Control_Tasks_Aggregate_Order_By>;
  controls_comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  controls_vector_stores_aggregate?: InputMaybe<Ai_Controls_Vector_Store_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  criterias_aggregate?: InputMaybe<Control_Criteria_Aggregate_Order_By>;
  custom_tags_aggregate?: InputMaybe<Control_Tags_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  evidence_runs_aggregate?: InputMaybe<Integration_Runs_Aggregate_Order_By>;
  field_values_aggregate?: InputMaybe<Field_Values_Aggregate_Order_By>;
  findings_aggregate?: InputMaybe<Control_Findings_Aggregate_Order_By>;
  frameworks_controls_aggregate?: InputMaybe<Frameworks_Controls_Aggregate_Order_By>;
  frequency?: InputMaybe<Order_By>;
  groups_aggregate?: InputMaybe<Control_Groups_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  irrelevant?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  program_controls_aggregate?: InputMaybe<Program_Controls_Aggregate_Order_By>;
  risk_controls_aggregate?: InputMaybe<Risk_Controls_Aggregate_Order_By>;
  settings?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  source_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  target_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  template_control?: InputMaybe<Template_Controls_Order_By>;
  template_control_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: controls */
export type Controls_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Controls_Prepend_Input = {
  /** Generic control-level settings. Each feature owns one top-level key (e.g. ai_evidence), validated in application code, not by the DB. Writes must merge their key so sibling sections are not clobbered. */
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "controls" */
export enum Controls_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  Irrelevant = 'irrelevant',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Priority = 'priority',
  /** column name */
  Settings = 'settings',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Status = 'status',
  /** column name */
  TemplateControlId = 'template_control_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** select "controls_aggregate_bool_exp_avg_arguments_columns" columns of table "controls" */
export enum Controls_Select_Column_Controls_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "controls_aggregate_bool_exp_bool_and_arguments_columns" columns of table "controls" */
export enum Controls_Select_Column_Controls_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Irrelevant = 'irrelevant',
}

/** select "controls_aggregate_bool_exp_bool_or_arguments_columns" columns of table "controls" */
export enum Controls_Select_Column_Controls_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Irrelevant = 'irrelevant',
}

/** select "controls_aggregate_bool_exp_corr_arguments_columns" columns of table "controls" */
export enum Controls_Select_Column_Controls_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "controls_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "controls" */
export enum Controls_Select_Column_Controls_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "controls_aggregate_bool_exp_max_arguments_columns" columns of table "controls" */
export enum Controls_Select_Column_Controls_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "controls_aggregate_bool_exp_min_arguments_columns" columns of table "controls" */
export enum Controls_Select_Column_Controls_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "controls_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "controls" */
export enum Controls_Select_Column_Controls_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "controls_aggregate_bool_exp_sum_arguments_columns" columns of table "controls" */
export enum Controls_Select_Column_Controls_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "controls_aggregate_bool_exp_var_samp_arguments_columns" columns of table "controls" */
export enum Controls_Select_Column_Controls_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** input type for updating data in table "controls" */
export type Controls_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Control_Frequencies_Enum>;
  irrelevant?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Control_Priorities_Enum>;
  /** Generic control-level settings. Each feature owns one top-level key (e.g. ai_evidence), validated in application code, not by the DB. Writes must merge their key so sibling sections are not clobbered. */
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  template_control_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Controls_Stddev_Fields = {
  __typename?: 'controls_stddev_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "controls" */
export type Controls_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Controls_Stddev_Pop_Fields = {
  __typename?: 'controls_stddev_pop_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "controls" */
export type Controls_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Controls_Stddev_Samp_Fields = {
  __typename?: 'controls_stddev_samp_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "controls" */
export type Controls_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "controls" */
export type Controls_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Controls_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Controls_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Control_Frequencies_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_id?: InputMaybe<Scalars['String']['input']>;
  irrelevant?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  priority?: InputMaybe<Control_Priorities_Enum>;
  /** Generic control-level settings. Each feature owns one top-level key (e.g. ai_evidence), validated in application code, not by the DB. Writes must merge their key so sibling sections are not clobbered. */
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  similarity?: InputMaybe<Scalars['float8']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  template_control_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Controls_Sum_Fields = {
  __typename?: 'controls_sum_fields';
  similarity?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "controls" */
export type Controls_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** update columns of table "controls" */
export enum Controls_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Irrelevant = 'irrelevant',
  /** column name */
  Name = 'name',
  /** column name */
  Priority = 'priority',
  /** column name */
  Settings = 'settings',
  /** column name */
  Status = 'status',
  /** column name */
  TemplateControlId = 'template_control_id',
}

export type Controls_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Controls_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Controls_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Controls_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Controls_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Controls_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Controls_Set_Input>;
  /** filter the rows which have to be updated */
  where: Controls_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Controls_Var_Pop_Fields = {
  __typename?: 'controls_var_pop_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "controls" */
export type Controls_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Controls_Var_Samp_Fields = {
  __typename?: 'controls_var_samp_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "controls" */
export type Controls_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Controls_Variance_Fields = {
  __typename?: 'controls_variance_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "controls" */
export type Controls_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** columns and relationships of "criteria" */
export type Criteria = {
  __typename?: 'criteria';
  /** An array relationship */
  control_criteria: Array<Control_Criteria>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "criteria" */
export type CriteriaControl_CriteriaArgs = {
  distinct_on?: InputMaybe<Array<Control_Criteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Criteria_Order_By>>;
  where?: InputMaybe<Control_Criteria_Bool_Exp>;
};

/** order by aggregate values of table "criteria" */
export type Criteria_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Criteria_Max_Order_By>;
  min?: InputMaybe<Criteria_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "criteria". All fields are combined with a logical 'AND'. */
export type Criteria_Bool_Exp = {
  _and?: InputMaybe<Array<Criteria_Bool_Exp>>;
  _not?: InputMaybe<Criteria_Bool_Exp>;
  _or?: InputMaybe<Array<Criteria_Bool_Exp>>;
  control_criteria?: InputMaybe<Control_Criteria_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "criteria" */
export enum Criteria_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  CriteriaNameOrganizationIdKey = 'criteria_name_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  CriteriaPkey = 'criteria_pkey',
}

/** input type for inserting data into table "criteria" */
export type Criteria_Insert_Input = {
  control_criteria?: InputMaybe<Control_Criteria_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "criteria" */
export type Criteria_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "criteria" */
export type Criteria_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "criteria" */
export type Criteria_Mutation_Response = {
  __typename?: 'criteria_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Criteria>;
};

/** input type for inserting object relation for remote table "criteria" */
export type Criteria_Obj_Rel_Insert_Input = {
  data: Criteria_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Criteria_On_Conflict>;
};

/** on_conflict condition type for table "criteria" */
export type Criteria_On_Conflict = {
  constraint: Criteria_Constraint;
  update_columns?: Array<Criteria_Update_Column>;
  where?: InputMaybe<Criteria_Bool_Exp>;
};

/** Ordering options when selecting data from "criteria". */
export type Criteria_Order_By = {
  control_criteria_aggregate?: InputMaybe<Control_Criteria_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: criteria */
export type Criteria_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "criteria" */
export enum Criteria_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "criteria" */
export type Criteria_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "criteria" */
export type Criteria_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Criteria_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Criteria_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "criteria" */
export enum Criteria_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Criteria_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Criteria_Set_Input>;
  /** filter the rows which have to be updated */
  where: Criteria_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC',
}

/** columns and relationships of "daily_control_stats_view" */
export type Daily_Control_Stats_View = {
  __typename?: 'daily_control_stats_view';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  organisation?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  total_at_risk_count?: Maybe<Scalars['bigint']['output']>;
  total_failing_count?: Maybe<Scalars['bigint']['output']>;
  total_not_relevant_count?: Maybe<Scalars['bigint']['output']>;
  total_pending_count?: Maybe<Scalars['bigint']['output']>;
  total_valid_count?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the table "daily_control_stats_view". All fields are combined with a logical 'AND'. */
export type Daily_Control_Stats_View_Bool_Exp = {
  _and?: InputMaybe<Array<Daily_Control_Stats_View_Bool_Exp>>;
  _not?: InputMaybe<Daily_Control_Stats_View_Bool_Exp>;
  _or?: InputMaybe<Array<Daily_Control_Stats_View_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organisation?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_at_risk_count?: InputMaybe<Bigint_Comparison_Exp>;
  total_failing_count?: InputMaybe<Bigint_Comparison_Exp>;
  total_not_relevant_count?: InputMaybe<Bigint_Comparison_Exp>;
  total_pending_count?: InputMaybe<Bigint_Comparison_Exp>;
  total_valid_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** Ordering options when selecting data from "daily_control_stats_view". */
export type Daily_Control_Stats_View_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  total_at_risk_count?: InputMaybe<Order_By>;
  total_failing_count?: InputMaybe<Order_By>;
  total_not_relevant_count?: InputMaybe<Order_By>;
  total_pending_count?: InputMaybe<Order_By>;
  total_valid_count?: InputMaybe<Order_By>;
};

/** select columns of table "daily_control_stats_view" */
export enum Daily_Control_Stats_View_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  TotalAtRiskCount = 'total_at_risk_count',
  /** column name */
  TotalFailingCount = 'total_failing_count',
  /** column name */
  TotalNotRelevantCount = 'total_not_relevant_count',
  /** column name */
  TotalPendingCount = 'total_pending_count',
  /** column name */
  TotalValidCount = 'total_valid_count',
}

/** Streaming cursor of the table "daily_control_stats_view" */
export type Daily_Control_Stats_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Daily_Control_Stats_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Daily_Control_Stats_View_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  total_at_risk_count?: InputMaybe<Scalars['bigint']['input']>;
  total_failing_count?: InputMaybe<Scalars['bigint']['input']>;
  total_not_relevant_count?: InputMaybe<Scalars['bigint']['input']>;
  total_pending_count?: InputMaybe<Scalars['bigint']['input']>;
  total_valid_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** columns and relationships of "daily_control_user_stats_view" */
export type Daily_Control_User_Stats_View = {
  __typename?: 'daily_control_user_stats_view';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  owner_id?: Maybe<Scalars['uuid']['output']>;
  total_at_risk_count?: Maybe<Scalars['bigint']['output']>;
  total_failing_count?: Maybe<Scalars['bigint']['output']>;
  total_not_relevant_count?: Maybe<Scalars['bigint']['output']>;
  total_pending_count?: Maybe<Scalars['bigint']['output']>;
  total_valid_count?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the table "daily_control_user_stats_view". All fields are combined with a logical 'AND'. */
export type Daily_Control_User_Stats_View_Bool_Exp = {
  _and?: InputMaybe<Array<Daily_Control_User_Stats_View_Bool_Exp>>;
  _not?: InputMaybe<Daily_Control_User_Stats_View_Bool_Exp>;
  _or?: InputMaybe<Array<Daily_Control_User_Stats_View_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_at_risk_count?: InputMaybe<Bigint_Comparison_Exp>;
  total_failing_count?: InputMaybe<Bigint_Comparison_Exp>;
  total_not_relevant_count?: InputMaybe<Bigint_Comparison_Exp>;
  total_pending_count?: InputMaybe<Bigint_Comparison_Exp>;
  total_valid_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** Ordering options when selecting data from "daily_control_user_stats_view". */
export type Daily_Control_User_Stats_View_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  total_at_risk_count?: InputMaybe<Order_By>;
  total_failing_count?: InputMaybe<Order_By>;
  total_not_relevant_count?: InputMaybe<Order_By>;
  total_pending_count?: InputMaybe<Order_By>;
  total_valid_count?: InputMaybe<Order_By>;
};

/** select columns of table "daily_control_user_stats_view" */
export enum Daily_Control_User_Stats_View_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  TotalAtRiskCount = 'total_at_risk_count',
  /** column name */
  TotalFailingCount = 'total_failing_count',
  /** column name */
  TotalNotRelevantCount = 'total_not_relevant_count',
  /** column name */
  TotalPendingCount = 'total_pending_count',
  /** column name */
  TotalValidCount = 'total_valid_count',
}

/** Streaming cursor of the table "daily_control_user_stats_view" */
export type Daily_Control_User_Stats_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Daily_Control_User_Stats_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Daily_Control_User_Stats_View_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
  total_at_risk_count?: InputMaybe<Scalars['bigint']['input']>;
  total_failing_count?: InputMaybe<Scalars['bigint']['input']>;
  total_not_relevant_count?: InputMaybe<Scalars['bigint']['input']>;
  total_pending_count?: InputMaybe<Scalars['bigint']['input']>;
  total_valid_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** columns and relationships of "daily_risk_stats_view" */
export type Daily_Risk_Stats_View = {
  __typename?: 'daily_risk_stats_view';
  closed_risk_count?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  new_risk_count?: Maybe<Scalars['Int']['output']>;
  open_risk_count?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  organisation?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "daily_risk_stats_view". All fields are combined with a logical 'AND'. */
export type Daily_Risk_Stats_View_Bool_Exp = {
  _and?: InputMaybe<Array<Daily_Risk_Stats_View_Bool_Exp>>;
  _not?: InputMaybe<Daily_Risk_Stats_View_Bool_Exp>;
  _or?: InputMaybe<Array<Daily_Risk_Stats_View_Bool_Exp>>;
  closed_risk_count?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  new_risk_count?: InputMaybe<Int_Comparison_Exp>;
  open_risk_count?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "daily_risk_stats_view". */
export type Daily_Risk_Stats_View_Order_By = {
  closed_risk_count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  new_risk_count?: InputMaybe<Order_By>;
  open_risk_count?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** select columns of table "daily_risk_stats_view" */
export enum Daily_Risk_Stats_View_Select_Column {
  /** column name */
  ClosedRiskCount = 'closed_risk_count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  NewRiskCount = 'new_risk_count',
  /** column name */
  OpenRiskCount = 'open_risk_count',
  /** column name */
  OrganizationId = 'organization_id',
}

/** Streaming cursor of the table "daily_risk_stats_view" */
export type Daily_Risk_Stats_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Daily_Risk_Stats_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Daily_Risk_Stats_View_Stream_Cursor_Value_Input = {
  closed_risk_count?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  new_risk_count?: InputMaybe<Scalars['Int']['input']>;
  open_risk_count?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "date_field_values" */
export type Date_Field_Values = {
  __typename?: 'date_field_values';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  fieldValueByFieldValueId: Field_Values;
  field_type: Scalars['String']['output'];
  /** An object relationship */
  field_value?: Maybe<Field_Values>;
  field_value_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  value: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "date_field_values" */
export type Date_Field_Values_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Date_Field_Values_Max_Order_By>;
  min?: InputMaybe<Date_Field_Values_Min_Order_By>;
};

/** input type for inserting array relation for remote table "date_field_values" */
export type Date_Field_Values_Arr_Rel_Insert_Input = {
  data: Array<Date_Field_Values_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Date_Field_Values_On_Conflict>;
};

/** Boolean expression to filter rows from the table "date_field_values". All fields are combined with a logical 'AND'. */
export type Date_Field_Values_Bool_Exp = {
  _and?: InputMaybe<Array<Date_Field_Values_Bool_Exp>>;
  _not?: InputMaybe<Date_Field_Values_Bool_Exp>;
  _or?: InputMaybe<Array<Date_Field_Values_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Bool_Exp>;
  field_type?: InputMaybe<String_Comparison_Exp>;
  field_value?: InputMaybe<Field_Values_Bool_Exp>;
  field_value_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "date_field_values" */
export enum Date_Field_Values_Constraint {
  /** unique or primary key constraint on columns "field_value_id" */
  DateFieldValuesPkey = 'date_field_values_pkey',
}

/** input type for inserting data into table "date_field_values" */
export type Date_Field_Values_Insert_Input = {
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Obj_Rel_Insert_Input>;
  field_value?: InputMaybe<Field_Values_Obj_Rel_Insert_Input>;
  field_value_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "date_field_values" */
export type Date_Field_Values_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "date_field_values" */
export type Date_Field_Values_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "date_field_values" */
export type Date_Field_Values_Mutation_Response = {
  __typename?: 'date_field_values_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Date_Field_Values>;
};

/** input type for inserting object relation for remote table "date_field_values" */
export type Date_Field_Values_Obj_Rel_Insert_Input = {
  data: Date_Field_Values_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Date_Field_Values_On_Conflict>;
};

/** on_conflict condition type for table "date_field_values" */
export type Date_Field_Values_On_Conflict = {
  constraint: Date_Field_Values_Constraint;
  update_columns?: Array<Date_Field_Values_Update_Column>;
  where?: InputMaybe<Date_Field_Values_Bool_Exp>;
};

/** Ordering options when selecting data from "date_field_values". */
export type Date_Field_Values_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value?: InputMaybe<Field_Values_Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: date_field_values */
export type Date_Field_Values_Pk_Columns_Input = {
  field_value_id: Scalars['uuid']['input'];
};

/** select columns of table "date_field_values" */
export enum Date_Field_Values_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  FieldValueId = 'field_value_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
}

/** input type for updating data in table "date_field_values" */
export type Date_Field_Values_Set_Input = {
  value?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "date_field_values" */
export enum Date_Field_Values_Update_Column {
  /** column name */
  Value = 'value',
}

export type Date_Field_Values_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Date_Field_Values_Set_Input>;
  /** filter the rows which have to be updated */
  where: Date_Field_Values_Bool_Exp;
};

export enum Document_Type_Enum {
  /** Document holding the golden questionnaire for AI Client QnA */
  GoldenQuestionnaire = 'Golden_questionnaire',
}

/** Boolean expression to compare columns of type "document_type_enum". All fields are combined with logical 'AND'. */
export type Document_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Document_Type_Enum>;
  _in?: InputMaybe<Array<Document_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Document_Type_Enum>;
  _nin?: InputMaybe<Array<Document_Type_Enum>>;
};

/** Set of documents related to a given organization */
export type Documents = {
  __typename?: 'documents';
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  documents_vector_stores: Array<Ai_Documents_Vector_Store>;
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_current: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  similarity?: Maybe<Scalars['float8']['output']>;
  type: Document_Type_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** Set of documents related to a given organization */
export type DocumentsDocuments_Vector_StoresArgs = {
  distinct_on?: InputMaybe<Array<Ai_Documents_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Documents_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Documents_Vector_Store_Bool_Exp>;
};

/** order by aggregate values of table "documents" */
export type Documents_Aggregate_Order_By = {
  avg?: InputMaybe<Documents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Documents_Max_Order_By>;
  min?: InputMaybe<Documents_Min_Order_By>;
  stddev?: InputMaybe<Documents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Documents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Documents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Documents_Sum_Order_By>;
  var_pop?: InputMaybe<Documents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Documents_Var_Samp_Order_By>;
  variance?: InputMaybe<Documents_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "documents" */
export type Documents_Arr_Rel_Insert_Input = {
  data: Array<Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Documents_On_Conflict>;
};

/** order by avg() on columns of table "documents" */
export type Documents_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "documents". All fields are combined with a logical 'AND'. */
export type Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Documents_Bool_Exp>>;
  _not?: InputMaybe<Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Documents_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  documents_vector_stores?: InputMaybe<Ai_Documents_Vector_Store_Bool_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_current?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  type?: InputMaybe<Document_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "documents" */
export enum Documents_Constraint {
  /** unique or primary key constraint on columns "type", "organization_id" */
  DocumentsIsCurrentTypeOrganizationIdKey = 'documents_is_current_type_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  DocumentsPkey = 'documents_pkey',
}

/** input type for inserting data into table "documents" */
export type Documents_Insert_Input = {
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_current?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Document_Type_Enum>;
};

/** order by max() on columns of table "documents" */
export type Documents_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "documents" */
export type Documents_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "documents" */
export type Documents_Mutation_Response = {
  __typename?: 'documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Documents>;
};

/** on_conflict condition type for table "documents" */
export type Documents_On_Conflict = {
  constraint: Documents_Constraint;
  update_columns?: Array<Documents_Update_Column>;
  where?: InputMaybe<Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "documents". */
export type Documents_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  documents_vector_stores_aggregate?: InputMaybe<Ai_Documents_Vector_Store_Aggregate_Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_current?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: documents */
export type Documents_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "documents" */
export enum Documents_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsCurrent = 'is_current',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "documents" */
export type Documents_Set_Input = {
  is_current?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Document_Type_Enum>;
};

/** order by stddev() on columns of table "documents" */
export type Documents_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "documents" */
export type Documents_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "documents" */
export type Documents_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "documents" */
export type Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Documents_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_current?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  similarity?: InputMaybe<Scalars['float8']['input']>;
  type?: InputMaybe<Document_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "documents" */
export type Documents_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** update columns of table "documents" */
export enum Documents_Update_Column {
  /** column name */
  IsCurrent = 'is_current',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
}

export type Documents_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Documents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Documents_Bool_Exp;
};

/** order by var_pop() on columns of table "documents" */
export type Documents_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "documents" */
export type Documents_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "documents" */
export type Documents_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

export enum Email_Domain_Statuses_Enum {
  /** Disabled at complyance level */
  Disabled = 'disabled',
  /** DNS validation failed */
  Failed = 'failed',
  /** Domain created at the provider, awaiting DNS verification */
  Pending = 'pending',
  /** Domain is no longer assignable and is waiting for provider deprovisioning */
  PendingDelete = 'pending_delete',
  /** DNS verified; the domain can sign outbound mail */
  Verified = 'verified',
}

/** Boolean expression to compare columns of type "email_domain_statuses_enum". All fields are combined with logical 'AND'. */
export type Email_Domain_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Email_Domain_Statuses_Enum>;
  _in?: InputMaybe<Array<Email_Domain_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Email_Domain_Statuses_Enum>;
  _nin?: InputMaybe<Array<Email_Domain_Statuses_Enum>>;
};

/** Provider domain authentication objects, shared across organizations */
export type Email_Domains = {
  __typename?: 'email_domains';
  /** Provider-agnostic, normalized DNS records the customer must publish: [{ type, host, value, valid }] */
  dns_records?: Maybe<Scalars['jsonb']['output']>;
  domain: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  organization_email_domains: Array<Organization_Email_Domains>;
  provider: Email_Providers_Enum;
  provider_domain_id?: Maybe<Scalars['String']['output']>;
  status: Email_Domain_Statuses_Enum;
};

/** Provider domain authentication objects, shared across organizations */
export type Email_DomainsDns_RecordsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Provider domain authentication objects, shared across organizations */
export type Email_DomainsOrganization_Email_DomainsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Email_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Email_Domains_Order_By>>;
  where?: InputMaybe<Organization_Email_Domains_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "email_domains". All fields are combined with a logical 'AND'. */
export type Email_Domains_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Domains_Bool_Exp>>;
  _not?: InputMaybe<Email_Domains_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Domains_Bool_Exp>>;
  dns_records?: InputMaybe<Jsonb_Comparison_Exp>;
  domain?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_email_domains?: InputMaybe<Organization_Email_Domains_Bool_Exp>;
  provider?: InputMaybe<Email_Providers_Enum_Comparison_Exp>;
  provider_domain_id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Email_Domain_Statuses_Enum_Comparison_Exp>;
};

/** Ordering options when selecting data from "email_domains". */
export type Email_Domains_Order_By = {
  dns_records?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_email_domains_aggregate?: InputMaybe<Organization_Email_Domains_Aggregate_Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_domain_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** columns and relationships of "email_field_values" */
export type Email_Field_Values = {
  __typename?: 'email_field_values';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  fieldValueByFieldValueId: Field_Values;
  field_type: Scalars['String']['output'];
  /** An object relationship */
  field_value?: Maybe<Field_Values>;
  field_value_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  value: Scalars['citext']['output'];
};

/** order by aggregate values of table "email_field_values" */
export type Email_Field_Values_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Field_Values_Max_Order_By>;
  min?: InputMaybe<Email_Field_Values_Min_Order_By>;
};

/** input type for inserting array relation for remote table "email_field_values" */
export type Email_Field_Values_Arr_Rel_Insert_Input = {
  data: Array<Email_Field_Values_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Field_Values_On_Conflict>;
};

/** Boolean expression to filter rows from the table "email_field_values". All fields are combined with a logical 'AND'. */
export type Email_Field_Values_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Field_Values_Bool_Exp>>;
  _not?: InputMaybe<Email_Field_Values_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Field_Values_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Bool_Exp>;
  field_type?: InputMaybe<String_Comparison_Exp>;
  field_value?: InputMaybe<Field_Values_Bool_Exp>;
  field_value_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Citext_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_field_values" */
export enum Email_Field_Values_Constraint {
  /** unique or primary key constraint on columns "field_value_id" */
  EmailFieldValuesPkey = 'email_field_values_pkey',
}

/** input type for inserting data into table "email_field_values" */
export type Email_Field_Values_Insert_Input = {
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Obj_Rel_Insert_Input>;
  field_value?: InputMaybe<Field_Values_Obj_Rel_Insert_Input>;
  field_value_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['citext']['input']>;
};

/** order by max() on columns of table "email_field_values" */
export type Email_Field_Values_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "email_field_values" */
export type Email_Field_Values_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_field_values" */
export type Email_Field_Values_Mutation_Response = {
  __typename?: 'email_field_values_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Field_Values>;
};

/** input type for inserting object relation for remote table "email_field_values" */
export type Email_Field_Values_Obj_Rel_Insert_Input = {
  data: Email_Field_Values_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Field_Values_On_Conflict>;
};

/** on_conflict condition type for table "email_field_values" */
export type Email_Field_Values_On_Conflict = {
  constraint: Email_Field_Values_Constraint;
  update_columns?: Array<Email_Field_Values_Update_Column>;
  where?: InputMaybe<Email_Field_Values_Bool_Exp>;
};

/** Ordering options when selecting data from "email_field_values". */
export type Email_Field_Values_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value?: InputMaybe<Field_Values_Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_field_values */
export type Email_Field_Values_Pk_Columns_Input = {
  field_value_id: Scalars['uuid']['input'];
};

/** select columns of table "email_field_values" */
export enum Email_Field_Values_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  FieldValueId = 'field_value_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
}

/** input type for updating data in table "email_field_values" */
export type Email_Field_Values_Set_Input = {
  value?: InputMaybe<Scalars['citext']['input']>;
};

/** update columns of table "email_field_values" */
export enum Email_Field_Values_Update_Column {
  /** column name */
  Value = 'value',
}

export type Email_Field_Values_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Field_Values_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Field_Values_Bool_Exp;
};

export enum Email_Providers_Enum {
  /** SendGrid */
  Sendgrid = 'sendgrid',
}

/** Boolean expression to compare columns of type "email_providers_enum". All fields are combined with logical 'AND'. */
export type Email_Providers_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Email_Providers_Enum>;
  _in?: InputMaybe<Array<Email_Providers_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Email_Providers_Enum>;
  _nin?: InputMaybe<Array<Email_Providers_Enum>>;
};

/** columns and relationships of "entity_relations" */
export type Entity_Relations = {
  __typename?: 'entity_relations';
  action_name: Relation_Actions_Enum;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  source_control?: Maybe<Controls>;
  source_control_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  source_evidence?: Maybe<Evidences>;
  source_evidence_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  source_finding?: Maybe<Findings>;
  source_finding_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  source_policy?: Maybe<Policies>;
  source_policy_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  source_risk?: Maybe<Risks>;
  source_risk_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  source_task?: Maybe<Tasks>;
  source_task_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  source_vendor?: Maybe<Vendors>;
  source_vendor_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  target_control?: Maybe<Controls>;
  target_control_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  target_evidence?: Maybe<Evidences>;
  target_evidence_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  target_finding?: Maybe<Findings>;
  target_finding_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  target_policy?: Maybe<Policies>;
  target_policy_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  target_risk?: Maybe<Risks>;
  target_risk_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  target_task?: Maybe<Tasks>;
  target_task_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  target_vendor?: Maybe<Vendors>;
  target_vendor_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "entity_relations" */
export type Entity_Relations_Aggregate = {
  __typename?: 'entity_relations_aggregate';
  aggregate?: Maybe<Entity_Relations_Aggregate_Fields>;
  nodes: Array<Entity_Relations>;
};

export type Entity_Relations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp_Count>;
};

export type Entity_Relations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Entity_Relations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "entity_relations" */
export type Entity_Relations_Aggregate_Fields = {
  __typename?: 'entity_relations_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Entity_Relations_Max_Fields>;
  min?: Maybe<Entity_Relations_Min_Fields>;
};

/** aggregate fields of "entity_relations" */
export type Entity_Relations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "entity_relations" */
export type Entity_Relations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Entity_Relations_Max_Order_By>;
  min?: InputMaybe<Entity_Relations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "entity_relations" */
export type Entity_Relations_Arr_Rel_Insert_Input = {
  data: Array<Entity_Relations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Entity_Relations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "entity_relations". All fields are combined with a logical 'AND'. */
export type Entity_Relations_Bool_Exp = {
  _and?: InputMaybe<Array<Entity_Relations_Bool_Exp>>;
  _not?: InputMaybe<Entity_Relations_Bool_Exp>;
  _or?: InputMaybe<Array<Entity_Relations_Bool_Exp>>;
  action_name?: InputMaybe<Relation_Actions_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  source_control?: InputMaybe<Controls_Bool_Exp>;
  source_control_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_evidence?: InputMaybe<Evidences_Bool_Exp>;
  source_evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_finding?: InputMaybe<Findings_Bool_Exp>;
  source_finding_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_policy?: InputMaybe<Policies_Bool_Exp>;
  source_policy_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_risk?: InputMaybe<Risks_Bool_Exp>;
  source_risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_task?: InputMaybe<Tasks_Bool_Exp>;
  source_task_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_vendor?: InputMaybe<Vendors_Bool_Exp>;
  source_vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
  target_control?: InputMaybe<Controls_Bool_Exp>;
  target_control_id?: InputMaybe<Uuid_Comparison_Exp>;
  target_evidence?: InputMaybe<Evidences_Bool_Exp>;
  target_evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  target_finding?: InputMaybe<Findings_Bool_Exp>;
  target_finding_id?: InputMaybe<Uuid_Comparison_Exp>;
  target_policy?: InputMaybe<Policies_Bool_Exp>;
  target_policy_id?: InputMaybe<Uuid_Comparison_Exp>;
  target_risk?: InputMaybe<Risks_Bool_Exp>;
  target_risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  target_task?: InputMaybe<Tasks_Bool_Exp>;
  target_task_id?: InputMaybe<Uuid_Comparison_Exp>;
  target_vendor?: InputMaybe<Vendors_Bool_Exp>;
  target_vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity_relations" */
export enum Entity_Relations_Constraint {
  /** unique or primary key constraint on columns "action_name", "source_finding_id" */
  EntityRelationsFindingPairIdx = 'entity_relations_finding_pair_idx',
  /** unique or primary key constraint on columns "id" */
  EntityRelationsPkey = 'entity_relations_pkey',
  /** unique or primary key constraint on columns "action_name" */
  EntityRelationsSourceTargetActionKey = 'entity_relations_source_target_action_key',
}

/** input type for inserting data into table "entity_relations" */
export type Entity_Relations_Insert_Input = {
  action_name?: InputMaybe<Relation_Actions_Enum>;
  source_control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  source_control_id?: InputMaybe<Scalars['uuid']['input']>;
  source_evidence?: InputMaybe<Evidences_Obj_Rel_Insert_Input>;
  source_evidence_id?: InputMaybe<Scalars['uuid']['input']>;
  source_finding_id?: InputMaybe<Scalars['uuid']['input']>;
  source_policy?: InputMaybe<Policies_Obj_Rel_Insert_Input>;
  source_policy_id?: InputMaybe<Scalars['uuid']['input']>;
  source_risk?: InputMaybe<Risks_Obj_Rel_Insert_Input>;
  source_risk_id?: InputMaybe<Scalars['uuid']['input']>;
  source_task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  source_task_id?: InputMaybe<Scalars['uuid']['input']>;
  source_vendor?: InputMaybe<Vendors_Obj_Rel_Insert_Input>;
  source_vendor_id?: InputMaybe<Scalars['uuid']['input']>;
  target_control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  target_control_id?: InputMaybe<Scalars['uuid']['input']>;
  target_evidence?: InputMaybe<Evidences_Obj_Rel_Insert_Input>;
  target_evidence_id?: InputMaybe<Scalars['uuid']['input']>;
  target_finding_id?: InputMaybe<Scalars['uuid']['input']>;
  target_policy?: InputMaybe<Policies_Obj_Rel_Insert_Input>;
  target_policy_id?: InputMaybe<Scalars['uuid']['input']>;
  target_risk?: InputMaybe<Risks_Obj_Rel_Insert_Input>;
  target_risk_id?: InputMaybe<Scalars['uuid']['input']>;
  target_task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  target_task_id?: InputMaybe<Scalars['uuid']['input']>;
  target_vendor?: InputMaybe<Vendors_Obj_Rel_Insert_Input>;
  target_vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Entity_Relations_Max_Fields = {
  __typename?: 'entity_relations_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  source_control_id?: Maybe<Scalars['uuid']['output']>;
  source_evidence_id?: Maybe<Scalars['uuid']['output']>;
  source_finding_id?: Maybe<Scalars['uuid']['output']>;
  source_policy_id?: Maybe<Scalars['uuid']['output']>;
  source_risk_id?: Maybe<Scalars['uuid']['output']>;
  source_task_id?: Maybe<Scalars['uuid']['output']>;
  source_vendor_id?: Maybe<Scalars['uuid']['output']>;
  target_control_id?: Maybe<Scalars['uuid']['output']>;
  target_evidence_id?: Maybe<Scalars['uuid']['output']>;
  target_finding_id?: Maybe<Scalars['uuid']['output']>;
  target_policy_id?: Maybe<Scalars['uuid']['output']>;
  target_risk_id?: Maybe<Scalars['uuid']['output']>;
  target_task_id?: Maybe<Scalars['uuid']['output']>;
  target_vendor_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "entity_relations" */
export type Entity_Relations_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source_control_id?: InputMaybe<Order_By>;
  source_evidence_id?: InputMaybe<Order_By>;
  source_finding_id?: InputMaybe<Order_By>;
  source_policy_id?: InputMaybe<Order_By>;
  source_risk_id?: InputMaybe<Order_By>;
  source_task_id?: InputMaybe<Order_By>;
  source_vendor_id?: InputMaybe<Order_By>;
  target_control_id?: InputMaybe<Order_By>;
  target_evidence_id?: InputMaybe<Order_By>;
  target_finding_id?: InputMaybe<Order_By>;
  target_policy_id?: InputMaybe<Order_By>;
  target_risk_id?: InputMaybe<Order_By>;
  target_task_id?: InputMaybe<Order_By>;
  target_vendor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Entity_Relations_Min_Fields = {
  __typename?: 'entity_relations_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  source_control_id?: Maybe<Scalars['uuid']['output']>;
  source_evidence_id?: Maybe<Scalars['uuid']['output']>;
  source_finding_id?: Maybe<Scalars['uuid']['output']>;
  source_policy_id?: Maybe<Scalars['uuid']['output']>;
  source_risk_id?: Maybe<Scalars['uuid']['output']>;
  source_task_id?: Maybe<Scalars['uuid']['output']>;
  source_vendor_id?: Maybe<Scalars['uuid']['output']>;
  target_control_id?: Maybe<Scalars['uuid']['output']>;
  target_evidence_id?: Maybe<Scalars['uuid']['output']>;
  target_finding_id?: Maybe<Scalars['uuid']['output']>;
  target_policy_id?: Maybe<Scalars['uuid']['output']>;
  target_risk_id?: Maybe<Scalars['uuid']['output']>;
  target_task_id?: Maybe<Scalars['uuid']['output']>;
  target_vendor_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "entity_relations" */
export type Entity_Relations_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source_control_id?: InputMaybe<Order_By>;
  source_evidence_id?: InputMaybe<Order_By>;
  source_finding_id?: InputMaybe<Order_By>;
  source_policy_id?: InputMaybe<Order_By>;
  source_risk_id?: InputMaybe<Order_By>;
  source_task_id?: InputMaybe<Order_By>;
  source_vendor_id?: InputMaybe<Order_By>;
  target_control_id?: InputMaybe<Order_By>;
  target_evidence_id?: InputMaybe<Order_By>;
  target_finding_id?: InputMaybe<Order_By>;
  target_policy_id?: InputMaybe<Order_By>;
  target_risk_id?: InputMaybe<Order_By>;
  target_task_id?: InputMaybe<Order_By>;
  target_vendor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "entity_relations" */
export type Entity_Relations_Mutation_Response = {
  __typename?: 'entity_relations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Entity_Relations>;
};

/** on_conflict condition type for table "entity_relations" */
export type Entity_Relations_On_Conflict = {
  constraint: Entity_Relations_Constraint;
  update_columns?: Array<Entity_Relations_Update_Column>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_relations". */
export type Entity_Relations_Order_By = {
  action_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source_control?: InputMaybe<Controls_Order_By>;
  source_control_id?: InputMaybe<Order_By>;
  source_evidence?: InputMaybe<Evidences_Order_By>;
  source_evidence_id?: InputMaybe<Order_By>;
  source_finding?: InputMaybe<Findings_Order_By>;
  source_finding_id?: InputMaybe<Order_By>;
  source_policy?: InputMaybe<Policies_Order_By>;
  source_policy_id?: InputMaybe<Order_By>;
  source_risk?: InputMaybe<Risks_Order_By>;
  source_risk_id?: InputMaybe<Order_By>;
  source_task?: InputMaybe<Tasks_Order_By>;
  source_task_id?: InputMaybe<Order_By>;
  source_vendor?: InputMaybe<Vendors_Order_By>;
  source_vendor_id?: InputMaybe<Order_By>;
  target_control?: InputMaybe<Controls_Order_By>;
  target_control_id?: InputMaybe<Order_By>;
  target_evidence?: InputMaybe<Evidences_Order_By>;
  target_evidence_id?: InputMaybe<Order_By>;
  target_finding?: InputMaybe<Findings_Order_By>;
  target_finding_id?: InputMaybe<Order_By>;
  target_policy?: InputMaybe<Policies_Order_By>;
  target_policy_id?: InputMaybe<Order_By>;
  target_risk?: InputMaybe<Risks_Order_By>;
  target_risk_id?: InputMaybe<Order_By>;
  target_task?: InputMaybe<Tasks_Order_By>;
  target_task_id?: InputMaybe<Order_By>;
  target_vendor?: InputMaybe<Vendors_Order_By>;
  target_vendor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "entity_relations" */
export enum Entity_Relations_Select_Column {
  /** column name */
  ActionName = 'action_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SourceControlId = 'source_control_id',
  /** column name */
  SourceEvidenceId = 'source_evidence_id',
  /** column name */
  SourceFindingId = 'source_finding_id',
  /** column name */
  SourcePolicyId = 'source_policy_id',
  /** column name */
  SourceRiskId = 'source_risk_id',
  /** column name */
  SourceTaskId = 'source_task_id',
  /** column name */
  SourceVendorId = 'source_vendor_id',
  /** column name */
  TargetControlId = 'target_control_id',
  /** column name */
  TargetEvidenceId = 'target_evidence_id',
  /** column name */
  TargetFindingId = 'target_finding_id',
  /** column name */
  TargetPolicyId = 'target_policy_id',
  /** column name */
  TargetRiskId = 'target_risk_id',
  /** column name */
  TargetTaskId = 'target_task_id',
  /** column name */
  TargetVendorId = 'target_vendor_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** placeholder for update columns of table "entity_relations" (current role has no relevant permissions) */
export enum Entity_Relations_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "evidence_acl" */
export type Evidence_Acl = {
  __typename?: 'evidence_acl';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  evidence: Evidences;
  evidence_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "evidence_acl" */
export type Evidence_Acl_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Evidence_Acl_Max_Order_By>;
  min?: InputMaybe<Evidence_Acl_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "evidence_acl". All fields are combined with a logical 'AND'. */
export type Evidence_Acl_Bool_Exp = {
  _and?: InputMaybe<Array<Evidence_Acl_Bool_Exp>>;
  _not?: InputMaybe<Evidence_Acl_Bool_Exp>;
  _or?: InputMaybe<Array<Evidence_Acl_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  evidence?: InputMaybe<Evidences_Bool_Exp>;
  evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "evidence_acl" */
export type Evidence_Acl_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "evidence_acl" */
export type Evidence_Acl_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "evidence_acl". */
export type Evidence_Acl_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidence?: InputMaybe<Evidences_Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "evidence_acl" */
export enum Evidence_Acl_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EvidenceId = 'evidence_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
}

/** columns and relationships of "evidence_integrations" */
export type Evidence_Integrations = {
  __typename?: 'evidence_integrations';
  config: Scalars['jsonb']['output'];
  /** An object relationship */
  evidence: Evidences;
  handler_name: Integration_Handler_Names_Enum;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization_integration: Organization_Integrations;
  service_name: Integration_Service_Names_Enum;
};

/** columns and relationships of "evidence_integrations" */
export type Evidence_IntegrationsConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "evidence_integrations" */
export type Evidence_Integrations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Evidence_Integrations_Max_Order_By>;
  min?: InputMaybe<Evidence_Integrations_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Evidence_Integrations_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "evidence_integrations". All fields are combined with a logical 'AND'. */
export type Evidence_Integrations_Bool_Exp = {
  _and?: InputMaybe<Array<Evidence_Integrations_Bool_Exp>>;
  _not?: InputMaybe<Evidence_Integrations_Bool_Exp>;
  _or?: InputMaybe<Array<Evidence_Integrations_Bool_Exp>>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  evidence?: InputMaybe<Evidences_Bool_Exp>;
  handler_name?: InputMaybe<Integration_Handler_Names_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_integration?: InputMaybe<Organization_Integrations_Bool_Exp>;
  service_name?: InputMaybe<Integration_Service_Names_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "evidence_integrations" */
export enum Evidence_Integrations_Constraint {
  /** unique or primary key constraint on columns "evidence_id" */
  EvidenceIntegrationsEvidenceIdKey = 'evidence_integrations_evidence_id_key',
  /** unique or primary key constraint on columns "id" */
  EvidenceIntegrationsPkey = 'evidence_integrations_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Evidence_Integrations_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Evidence_Integrations_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Evidence_Integrations_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "evidence_integrations" */
export type Evidence_Integrations_Insert_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  evidence?: InputMaybe<Evidences_Obj_Rel_Insert_Input>;
  evidence_id?: InputMaybe<Scalars['uuid']['input']>;
  handler_name?: InputMaybe<Integration_Handler_Names_Enum>;
  organization_integration_id?: InputMaybe<Scalars['uuid']['input']>;
  service_name?: InputMaybe<Integration_Service_Names_Enum>;
};

/** order by max() on columns of table "evidence_integrations" */
export type Evidence_Integrations_Max_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "evidence_integrations" */
export type Evidence_Integrations_Min_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "evidence_integrations" */
export type Evidence_Integrations_Mutation_Response = {
  __typename?: 'evidence_integrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Evidence_Integrations>;
};

/** input type for inserting object relation for remote table "evidence_integrations" */
export type Evidence_Integrations_Obj_Rel_Insert_Input = {
  data: Evidence_Integrations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Evidence_Integrations_On_Conflict>;
};

/** on_conflict condition type for table "evidence_integrations" */
export type Evidence_Integrations_On_Conflict = {
  constraint: Evidence_Integrations_Constraint;
  update_columns?: Array<Evidence_Integrations_Update_Column>;
  where?: InputMaybe<Evidence_Integrations_Bool_Exp>;
};

/** Ordering options when selecting data from "evidence_integrations". */
export type Evidence_Integrations_Order_By = {
  config?: InputMaybe<Order_By>;
  evidence?: InputMaybe<Evidences_Order_By>;
  handler_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_integration?: InputMaybe<Organization_Integrations_Order_By>;
  service_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: evidence_integrations */
export type Evidence_Integrations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Evidence_Integrations_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "evidence_integrations" */
export enum Evidence_Integrations_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  HandlerName = 'handler_name',
  /** column name */
  Id = 'id',
  /** column name */
  ServiceName = 'service_name',
}

/** input type for updating data in table "evidence_integrations" */
export type Evidence_Integrations_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "evidence_integrations" */
export type Evidence_Integrations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Evidence_Integrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Evidence_Integrations_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  handler_name?: InputMaybe<Integration_Handler_Names_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  service_name?: InputMaybe<Integration_Service_Names_Enum>;
};

/** update columns of table "evidence_integrations" */
export enum Evidence_Integrations_Update_Column {
  /** column name */
  Config = 'config',
}

export type Evidence_Integrations_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Evidence_Integrations_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Evidence_Integrations_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Evidence_Integrations_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Evidence_Integrations_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Evidence_Integrations_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Evidence_Integrations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Evidence_Integrations_Bool_Exp;
};

/** users responsible for evidence */
export type Evidence_Owners = {
  __typename?: 'evidence_owners';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  evidence: Evidences;
  evidence_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  owner_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
};

/** order by aggregate values of table "evidence_owners" */
export type Evidence_Owners_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Evidence_Owners_Max_Order_By>;
  min?: InputMaybe<Evidence_Owners_Min_Order_By>;
};

/** input type for inserting array relation for remote table "evidence_owners" */
export type Evidence_Owners_Arr_Rel_Insert_Input = {
  data: Array<Evidence_Owners_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Evidence_Owners_On_Conflict>;
};

/** Boolean expression to filter rows from the table "evidence_owners". All fields are combined with a logical 'AND'. */
export type Evidence_Owners_Bool_Exp = {
  _and?: InputMaybe<Array<Evidence_Owners_Bool_Exp>>;
  _not?: InputMaybe<Evidence_Owners_Bool_Exp>;
  _or?: InputMaybe<Array<Evidence_Owners_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  evidence?: InputMaybe<Evidences_Bool_Exp>;
  evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "evidence_owners" */
export enum Evidence_Owners_Constraint {
  /** unique or primary key constraint on columns "evidence_id", "owner_id" */
  EvidenceOwnersEvidenceIdOwnerIdKey = 'evidence_owners_evidence_id_owner_id_key',
  /** unique or primary key constraint on columns "id" */
  EvidenceOwnersPkey = 'evidence_owners_pkey',
}

/** input type for inserting data into table "evidence_owners" */
export type Evidence_Owners_Insert_Input = {
  evidence?: InputMaybe<Evidences_Obj_Rel_Insert_Input>;
  evidence_id?: InputMaybe<Scalars['uuid']['input']>;
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "evidence_owners" */
export type Evidence_Owners_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "evidence_owners" */
export type Evidence_Owners_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "evidence_owners" */
export type Evidence_Owners_Mutation_Response = {
  __typename?: 'evidence_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Evidence_Owners>;
};

/** on_conflict condition type for table "evidence_owners" */
export type Evidence_Owners_On_Conflict = {
  constraint: Evidence_Owners_Constraint;
  update_columns?: Array<Evidence_Owners_Update_Column>;
  where?: InputMaybe<Evidence_Owners_Bool_Exp>;
};

/** Ordering options when selecting data from "evidence_owners". */
export type Evidence_Owners_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidence?: InputMaybe<Evidences_Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "evidence_owners" */
export enum Evidence_Owners_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EvidenceId = 'evidence_id',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerId = 'owner_id',
}

/** placeholder for update columns of table "evidence_owners" (current role has no relevant permissions) */
export enum Evidence_Owners_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "evidence_policies" */
export type Evidence_Policies = {
  __typename?: 'evidence_policies';
  created_at: Scalars['timestamptz']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  evidence?: Maybe<Evidences>;
  evidence_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  policy?: Maybe<Policies>;
  policy_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  with_acknowledgements_chapter: Scalars['Boolean']['output'];
  with_approvals_chapter: Scalars['Boolean']['output'];
  with_approver_date: Scalars['Boolean']['output'];
  with_company_logo: Scalars['Boolean']['output'];
  with_revision_details: Scalars['Boolean']['output'];
  with_versions_chapter: Scalars['Boolean']['output'];
};

/** order by aggregate values of table "evidence_policies" */
export type Evidence_Policies_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Evidence_Policies_Max_Order_By>;
  min?: InputMaybe<Evidence_Policies_Min_Order_By>;
};

/** input type for inserting array relation for remote table "evidence_policies" */
export type Evidence_Policies_Arr_Rel_Insert_Input = {
  data: Array<Evidence_Policies_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Evidence_Policies_On_Conflict>;
};

/** Boolean expression to filter rows from the table "evidence_policies". All fields are combined with a logical 'AND'. */
export type Evidence_Policies_Bool_Exp = {
  _and?: InputMaybe<Array<Evidence_Policies_Bool_Exp>>;
  _not?: InputMaybe<Evidence_Policies_Bool_Exp>;
  _or?: InputMaybe<Array<Evidence_Policies_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  evidence?: InputMaybe<Evidences_Bool_Exp>;
  evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  policy?: InputMaybe<Policies_Bool_Exp>;
  policy_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  with_acknowledgements_chapter?: InputMaybe<Boolean_Comparison_Exp>;
  with_approvals_chapter?: InputMaybe<Boolean_Comparison_Exp>;
  with_approver_date?: InputMaybe<Boolean_Comparison_Exp>;
  with_company_logo?: InputMaybe<Boolean_Comparison_Exp>;
  with_revision_details?: InputMaybe<Boolean_Comparison_Exp>;
  with_versions_chapter?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "evidence_policies" */
export enum Evidence_Policies_Constraint {
  /** unique or primary key constraint on columns "evidence_id" */
  EvidencePoliciesEvidenceIdKey = 'evidence_policies_evidence_id_key',
  /** unique or primary key constraint on columns "id" */
  EvidencePoliciesPkey = 'evidence_policies_pkey',
}

/** input type for inserting data into table "evidence_policies" */
export type Evidence_Policies_Insert_Input = {
  evidence?: InputMaybe<Evidences_Obj_Rel_Insert_Input>;
  evidence_id?: InputMaybe<Scalars['uuid']['input']>;
  policy?: InputMaybe<Policies_Obj_Rel_Insert_Input>;
  policy_id?: InputMaybe<Scalars['uuid']['input']>;
  with_acknowledgements_chapter?: InputMaybe<Scalars['Boolean']['input']>;
  with_approvals_chapter?: InputMaybe<Scalars['Boolean']['input']>;
  with_approver_date?: InputMaybe<Scalars['Boolean']['input']>;
  with_company_logo?: InputMaybe<Scalars['Boolean']['input']>;
  with_revision_details?: InputMaybe<Scalars['Boolean']['input']>;
  with_versions_chapter?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by max() on columns of table "evidence_policies" */
export type Evidence_Policies_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "evidence_policies" */
export type Evidence_Policies_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "evidence_policies" */
export type Evidence_Policies_Mutation_Response = {
  __typename?: 'evidence_policies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Evidence_Policies>;
};

/** input type for inserting object relation for remote table "evidence_policies" */
export type Evidence_Policies_Obj_Rel_Insert_Input = {
  data: Evidence_Policies_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Evidence_Policies_On_Conflict>;
};

/** on_conflict condition type for table "evidence_policies" */
export type Evidence_Policies_On_Conflict = {
  constraint: Evidence_Policies_Constraint;
  update_columns?: Array<Evidence_Policies_Update_Column>;
  where?: InputMaybe<Evidence_Policies_Bool_Exp>;
};

/** Ordering options when selecting data from "evidence_policies". */
export type Evidence_Policies_Order_By = {
  created_at?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  evidence?: InputMaybe<Evidences_Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy?: InputMaybe<Policies_Order_By>;
  policy_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  with_acknowledgements_chapter?: InputMaybe<Order_By>;
  with_approvals_chapter?: InputMaybe<Order_By>;
  with_approver_date?: InputMaybe<Order_By>;
  with_company_logo?: InputMaybe<Order_By>;
  with_revision_details?: InputMaybe<Order_By>;
  with_versions_chapter?: InputMaybe<Order_By>;
};

/** primary key columns input for table: evidence_policies */
export type Evidence_Policies_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "evidence_policies" */
export enum Evidence_Policies_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  EvidenceId = 'evidence_id',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyId = 'policy_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WithAcknowledgementsChapter = 'with_acknowledgements_chapter',
  /** column name */
  WithApprovalsChapter = 'with_approvals_chapter',
  /** column name */
  WithApproverDate = 'with_approver_date',
  /** column name */
  WithCompanyLogo = 'with_company_logo',
  /** column name */
  WithRevisionDetails = 'with_revision_details',
  /** column name */
  WithVersionsChapter = 'with_versions_chapter',
}

/** input type for updating data in table "evidence_policies" */
export type Evidence_Policies_Set_Input = {
  policy_id?: InputMaybe<Scalars['uuid']['input']>;
  with_acknowledgements_chapter?: InputMaybe<Scalars['Boolean']['input']>;
  with_approvals_chapter?: InputMaybe<Scalars['Boolean']['input']>;
  with_approver_date?: InputMaybe<Scalars['Boolean']['input']>;
  with_company_logo?: InputMaybe<Scalars['Boolean']['input']>;
  with_revision_details?: InputMaybe<Scalars['Boolean']['input']>;
  with_versions_chapter?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "evidence_policies" */
export enum Evidence_Policies_Update_Column {
  /** column name */
  PolicyId = 'policy_id',
  /** column name */
  WithAcknowledgementsChapter = 'with_acknowledgements_chapter',
  /** column name */
  WithApprovalsChapter = 'with_approvals_chapter',
  /** column name */
  WithApproverDate = 'with_approver_date',
  /** column name */
  WithCompanyLogo = 'with_company_logo',
  /** column name */
  WithRevisionDetails = 'with_revision_details',
  /** column name */
  WithVersionsChapter = 'with_versions_chapter',
}

export type Evidence_Policies_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Evidence_Policies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Evidence_Policies_Bool_Exp;
};

/** columns and relationships of "evidence_tags" */
export type Evidence_Tags = {
  __typename?: 'evidence_tags';
  /** An object relationship */
  evidence: Evidences;
  evidence_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  tag: Organization_Evidence_Tags;
  tag_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "evidence_tags" */
export type Evidence_Tags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Evidence_Tags_Max_Order_By>;
  min?: InputMaybe<Evidence_Tags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "evidence_tags" */
export type Evidence_Tags_Arr_Rel_Insert_Input = {
  data: Array<Evidence_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Evidence_Tags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "evidence_tags". All fields are combined with a logical 'AND'. */
export type Evidence_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Evidence_Tags_Bool_Exp>>;
  _not?: InputMaybe<Evidence_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Evidence_Tags_Bool_Exp>>;
  evidence?: InputMaybe<Evidences_Bool_Exp>;
  evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  tag?: InputMaybe<Organization_Evidence_Tags_Bool_Exp>;
  tag_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "evidence_tags" */
export enum Evidence_Tags_Constraint {
  /** unique or primary key constraint on columns "id" */
  EvidenceTagsPkey = 'evidence_tags_pkey',
  /** unique or primary key constraint on columns "evidence_id", "tag_id" */
  EvidenceTagsTagIdEvidenceIdKey = 'evidence_tags_tag_id_evidence_id_key',
}

/** input type for inserting data into table "evidence_tags" */
export type Evidence_Tags_Insert_Input = {
  evidence?: InputMaybe<Evidences_Obj_Rel_Insert_Input>;
  evidence_id?: InputMaybe<Scalars['uuid']['input']>;
  tag?: InputMaybe<Organization_Evidence_Tags_Obj_Rel_Insert_Input>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "evidence_tags" */
export type Evidence_Tags_Max_Order_By = {
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "evidence_tags" */
export type Evidence_Tags_Min_Order_By = {
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "evidence_tags" */
export type Evidence_Tags_Mutation_Response = {
  __typename?: 'evidence_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Evidence_Tags>;
};

/** on_conflict condition type for table "evidence_tags" */
export type Evidence_Tags_On_Conflict = {
  constraint: Evidence_Tags_Constraint;
  update_columns?: Array<Evidence_Tags_Update_Column>;
  where?: InputMaybe<Evidence_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "evidence_tags". */
export type Evidence_Tags_Order_By = {
  evidence?: InputMaybe<Evidences_Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Organization_Evidence_Tags_Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** select columns of table "evidence_tags" */
export enum Evidence_Tags_Select_Column {
  /** column name */
  EvidenceId = 'evidence_id',
  /** column name */
  Id = 'id',
  /** column name */
  TagId = 'tag_id',
}

/** placeholder for update columns of table "evidence_tags" (current role has no relevant permissions) */
export enum Evidence_Tags_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "evidence_tasks" */
export type Evidence_Tasks = {
  __typename?: 'evidence_tasks';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  evidence?: Maybe<Evidences>;
  evidence_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  task?: Maybe<Tasks>;
  task_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "evidence_tasks" */
export type Evidence_Tasks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Evidence_Tasks_Max_Order_By>;
  min?: InputMaybe<Evidence_Tasks_Min_Order_By>;
};

/** input type for inserting array relation for remote table "evidence_tasks" */
export type Evidence_Tasks_Arr_Rel_Insert_Input = {
  data: Array<Evidence_Tasks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Evidence_Tasks_On_Conflict>;
};

/** Boolean expression to filter rows from the table "evidence_tasks". All fields are combined with a logical 'AND'. */
export type Evidence_Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Evidence_Tasks_Bool_Exp>>;
  _not?: InputMaybe<Evidence_Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Evidence_Tasks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  evidence?: InputMaybe<Evidences_Bool_Exp>;
  evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "evidence_tasks" */
export enum Evidence_Tasks_Constraint {
  /** unique or primary key constraint on columns "id" */
  EvidenceTasksPkey = 'evidence_tasks_pkey',
  /** unique or primary key constraint on columns "evidence_id", "task_id" */
  EvidenceTasksTaskIdEvidenceIdKey = 'evidence_tasks_task_id_evidence_id_key',
}

/** input type for inserting data into table "evidence_tasks" */
export type Evidence_Tasks_Insert_Input = {
  evidence?: InputMaybe<Evidences_Obj_Rel_Insert_Input>;
  evidence_id?: InputMaybe<Scalars['uuid']['input']>;
  task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "evidence_tasks" */
export type Evidence_Tasks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "evidence_tasks" */
export type Evidence_Tasks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "evidence_tasks" */
export type Evidence_Tasks_Mutation_Response = {
  __typename?: 'evidence_tasks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Evidence_Tasks>;
};

/** on_conflict condition type for table "evidence_tasks" */
export type Evidence_Tasks_On_Conflict = {
  constraint: Evidence_Tasks_Constraint;
  update_columns?: Array<Evidence_Tasks_Update_Column>;
  where?: InputMaybe<Evidence_Tasks_Bool_Exp>;
};

/** Ordering options when selecting data from "evidence_tasks". */
export type Evidence_Tasks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidence?: InputMaybe<Evidences_Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** select columns of table "evidence_tasks" */
export enum Evidence_Tasks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EvidenceId = 'evidence_id',
  /** column name */
  Id = 'id',
  /** column name */
  TaskId = 'task_id',
}

/** placeholder for update columns of table "evidence_tasks" (current role has no relevant permissions) */
export enum Evidence_Tasks_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "evidence_version_file" */
export type Evidence_Version_File = {
  __typename?: 'evidence_version_file';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  evidence_version: Evidence_Versions;
  evidence_version_id: Scalars['uuid']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "evidence_version_file". All fields are combined with a logical 'AND'. */
export type Evidence_Version_File_Bool_Exp = {
  _and?: InputMaybe<Array<Evidence_Version_File_Bool_Exp>>;
  _not?: InputMaybe<Evidence_Version_File_Bool_Exp>;
  _or?: InputMaybe<Array<Evidence_Version_File_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  evidence_version?: InputMaybe<Evidence_Versions_Bool_Exp>;
  evidence_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "evidence_version_file" */
export enum Evidence_Version_File_Constraint {
  /** unique or primary key constraint on columns "evidence_version_id" */
  EvidenceVersionFileEvidenceVersionIdKey = 'evidence_version_file_evidence_version_id_key',
  /** unique or primary key constraint on columns "file_id" */
  EvidenceVersionFileFileIdKey = 'evidence_version_file_file_id_key',
  /** unique or primary key constraint on columns "evidence_version_id", "file_id" */
  EvidenceVersionFilePkey = 'evidence_version_file_pkey',
}

/** input type for inserting data into table "evidence_version_file" */
export type Evidence_Version_File_Insert_Input = {
  evidence_version?: InputMaybe<Evidence_Versions_Obj_Rel_Insert_Input>;
  evidence_version_id?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "evidence_version_file" */
export type Evidence_Version_File_Mutation_Response = {
  __typename?: 'evidence_version_file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Evidence_Version_File>;
};

/** input type for inserting object relation for remote table "evidence_version_file" */
export type Evidence_Version_File_Obj_Rel_Insert_Input = {
  data: Evidence_Version_File_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Evidence_Version_File_On_Conflict>;
};

/** on_conflict condition type for table "evidence_version_file" */
export type Evidence_Version_File_On_Conflict = {
  constraint: Evidence_Version_File_Constraint;
  update_columns?: Array<Evidence_Version_File_Update_Column>;
  where?: InputMaybe<Evidence_Version_File_Bool_Exp>;
};

/** Ordering options when selecting data from "evidence_version_file". */
export type Evidence_Version_File_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidence_version?: InputMaybe<Evidence_Versions_Order_By>;
  evidence_version_id?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "evidence_version_file" (current role has no relevant permissions) */
export enum Evidence_Version_File_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "evidence_versions" */
export type Evidence_Versions = {
  __typename?: 'evidence_versions';
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  evidence: Evidences;
  evidence_id: Scalars['uuid']['output'];
  /** An object relationship */
  evidence_version_file?: Maybe<Evidence_Version_File>;
  id: Scalars['uuid']['output'];
  is_current: Scalars['Boolean']['output'];
  /** An object relationship */
  policy_version?: Maybe<Policy_Versions>;
  policy_version_id?: Maybe<Scalars['uuid']['output']>;
  type: Scalars['EvidenceVersionType']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByUpdatedBy?: Maybe<Users>;
  validity_start: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "evidence_versions" */
export type Evidence_Versions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Evidence_Versions_Max_Order_By>;
  min?: InputMaybe<Evidence_Versions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "evidence_versions" */
export type Evidence_Versions_Arr_Rel_Insert_Input = {
  data: Array<Evidence_Versions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Evidence_Versions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "evidence_versions". All fields are combined with a logical 'AND'. */
export type Evidence_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<Evidence_Versions_Bool_Exp>>;
  _not?: InputMaybe<Evidence_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<Evidence_Versions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  evidence?: InputMaybe<Evidences_Bool_Exp>;
  evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  evidence_version_file?: InputMaybe<Evidence_Version_File_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_current?: InputMaybe<Boolean_Comparison_Exp>;
  policy_version?: InputMaybe<Policy_Versions_Bool_Exp>;
  policy_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userByUpdatedBy?: InputMaybe<Users_Bool_Exp>;
  validity_start?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "evidence_versions" */
export enum Evidence_Versions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ControlEvidenceVersionPkey = 'control_evidence_version_pkey',
  /** unique or primary key constraint on columns "evidence_id", "is_current" */
  EvidenceVersionsCurrentIdx = 'evidence_versions_current_idx',
}

/** input type for inserting data into table "evidence_versions" */
export type Evidence_Versions_Insert_Input = {
  evidence?: InputMaybe<Evidences_Obj_Rel_Insert_Input>;
  evidence_id?: InputMaybe<Scalars['uuid']['input']>;
  evidence_version_file?: InputMaybe<Evidence_Version_File_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_current?: InputMaybe<Scalars['Boolean']['input']>;
  policy_version?: InputMaybe<Policy_Versions_Obj_Rel_Insert_Input>;
  url?: InputMaybe<Scalars['String']['input']>;
  validity_start?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "evidence_versions" */
export type Evidence_Versions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  validity_start?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "evidence_versions" */
export type Evidence_Versions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  validity_start?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "evidence_versions" */
export type Evidence_Versions_Mutation_Response = {
  __typename?: 'evidence_versions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Evidence_Versions>;
};

/** input type for inserting object relation for remote table "evidence_versions" */
export type Evidence_Versions_Obj_Rel_Insert_Input = {
  data: Evidence_Versions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Evidence_Versions_On_Conflict>;
};

/** on_conflict condition type for table "evidence_versions" */
export type Evidence_Versions_On_Conflict = {
  constraint: Evidence_Versions_Constraint;
  update_columns?: Array<Evidence_Versions_Update_Column>;
  where?: InputMaybe<Evidence_Versions_Bool_Exp>;
};

/** Ordering options when selecting data from "evidence_versions". */
export type Evidence_Versions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  evidence?: InputMaybe<Evidences_Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  evidence_version_file?: InputMaybe<Evidence_Version_File_Order_By>;
  id?: InputMaybe<Order_By>;
  is_current?: InputMaybe<Order_By>;
  policy_version?: InputMaybe<Policy_Versions_Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userByUpdatedBy?: InputMaybe<Users_Order_By>;
  validity_start?: InputMaybe<Order_By>;
};

/** primary key columns input for table: evidence_versions */
export type Evidence_Versions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "evidence_versions" */
export enum Evidence_Versions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EvidenceId = 'evidence_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsCurrent = 'is_current',
  /** column name */
  PolicyVersionId = 'policy_version_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  Url = 'url',
  /** column name */
  ValidityStart = 'validity_start',
}

/** input type for updating data in table "evidence_versions" */
export type Evidence_Versions_Set_Input = {
  is_current?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  validity_start?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "evidence_versions" */
export enum Evidence_Versions_Update_Column {
  /** column name */
  IsCurrent = 'is_current',
  /** column name */
  Url = 'url',
  /** column name */
  ValidityStart = 'validity_start',
}

export type Evidence_Versions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Evidence_Versions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Evidence_Versions_Bool_Exp;
};

/** columns and relationships of "evidences" */
export type Evidences = {
  __typename?: 'evidences';
  /** An array relationship */
  acl: Array<Evidence_Acl>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An array relationship */
  control_evidences: Array<Control_Evidences>;
  /** A computed field, executes function "get_evidence_status" */
  controls_aggregate_status: Scalars['EvidenceStatus']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  evidence_integration?: Maybe<Evidence_Integrations>;
  /** An array relationship */
  evidence_owners: Array<Evidence_Owners>;
  /** An object relationship */
  evidence_policy?: Maybe<Evidence_Policies>;
  /** An array relationship */
  evidence_versions: Array<Evidence_Versions>;
  /** An array relationship */
  evidences_notifications: Array<Notifications>;
  /** An array relationship */
  evidences_vector_stores: Array<Ai_Evidences_Vector_Store>;
  /** An array relationship */
  field_values: Array<Field_Values>;
  id: Scalars['uuid']['output'];
  internal_id?: Maybe<Scalars['String']['output']>;
  is_ai_generated: Scalars['Boolean']['output'];
  is_confidential: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  similarity?: Maybe<Scalars['float8']['output']>;
  /** An array relationship */
  source_entity_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  source_entity_relations_aggregate: Entity_Relations_Aggregate;
  /** An array relationship */
  tags: Array<Evidence_Tags>;
  /** An array relationship */
  target_entity_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  target_entity_relations_aggregate: Entity_Relations_Aggregate;
  /** An array relationship */
  tasks: Array<Evidence_Tasks>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** columns and relationships of "evidences" */
export type EvidencesAclArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Acl_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Acl_Order_By>>;
  where?: InputMaybe<Evidence_Acl_Bool_Exp>;
};

/** columns and relationships of "evidences" */
export type EvidencesCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** columns and relationships of "evidences" */
export type EvidencesControl_EvidencesArgs = {
  distinct_on?: InputMaybe<Array<Control_Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Evidences_Order_By>>;
  where?: InputMaybe<Control_Evidences_Bool_Exp>;
};

/** columns and relationships of "evidences" */
export type EvidencesEvidence_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Owners_Order_By>>;
  where?: InputMaybe<Evidence_Owners_Bool_Exp>;
};

/** columns and relationships of "evidences" */
export type EvidencesEvidence_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Versions_Order_By>>;
  where?: InputMaybe<Evidence_Versions_Bool_Exp>;
};

/** columns and relationships of "evidences" */
export type EvidencesEvidences_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** columns and relationships of "evidences" */
export type EvidencesEvidences_Vector_StoresArgs = {
  distinct_on?: InputMaybe<Array<Ai_Evidences_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Evidences_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Evidences_Vector_Store_Bool_Exp>;
};

/** columns and relationships of "evidences" */
export type EvidencesField_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Values_Order_By>>;
  where?: InputMaybe<Field_Values_Bool_Exp>;
};

/** columns and relationships of "evidences" */
export type EvidencesSource_Entity_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** columns and relationships of "evidences" */
export type EvidencesSource_Entity_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** columns and relationships of "evidences" */
export type EvidencesTagsArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Tags_Order_By>>;
  where?: InputMaybe<Evidence_Tags_Bool_Exp>;
};

/** columns and relationships of "evidences" */
export type EvidencesTarget_Entity_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** columns and relationships of "evidences" */
export type EvidencesTarget_Entity_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** columns and relationships of "evidences" */
export type EvidencesTasksArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Tasks_Order_By>>;
  where?: InputMaybe<Evidence_Tasks_Bool_Exp>;
};

/** aggregated selection of "evidences" */
export type Evidences_Aggregate = {
  __typename?: 'evidences_aggregate';
  aggregate?: Maybe<Evidences_Aggregate_Fields>;
  nodes: Array<Evidences>;
};

export type Evidences_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Evidences_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Evidences_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Evidences_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Evidences_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Evidences_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Evidences_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Evidences_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Evidences_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Evidences_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Evidences_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Evidences_Aggregate_Bool_Exp_Var_Samp>;
};

export type Evidences_Aggregate_Bool_Exp_Avg = {
  arguments: Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Evidences_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Evidences_Aggregate_Bool_Exp_Bool_And = {
  arguments: Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Evidences_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Evidences_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Evidences_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Evidences_Aggregate_Bool_Exp_Corr = {
  arguments: Evidences_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Evidences_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Evidences_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Evidences_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Evidences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Evidences_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Evidences_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Evidences_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Evidences_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Evidences_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Evidences_Aggregate_Bool_Exp_Max = {
  arguments: Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Evidences_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Evidences_Aggregate_Bool_Exp_Min = {
  arguments: Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Evidences_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Evidences_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Evidences_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Evidences_Aggregate_Bool_Exp_Sum = {
  arguments: Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Evidences_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Evidences_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Evidences_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "evidences" */
export type Evidences_Aggregate_Fields = {
  __typename?: 'evidences_aggregate_fields';
  avg?: Maybe<Evidences_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Evidences_Max_Fields>;
  min?: Maybe<Evidences_Min_Fields>;
  stddev?: Maybe<Evidences_Stddev_Fields>;
  stddev_pop?: Maybe<Evidences_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Evidences_Stddev_Samp_Fields>;
  sum?: Maybe<Evidences_Sum_Fields>;
  var_pop?: Maybe<Evidences_Var_Pop_Fields>;
  var_samp?: Maybe<Evidences_Var_Samp_Fields>;
  variance?: Maybe<Evidences_Variance_Fields>;
};

/** aggregate fields of "evidences" */
export type Evidences_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Evidences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "evidences" */
export type Evidences_Aggregate_Order_By = {
  avg?: InputMaybe<Evidences_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Evidences_Max_Order_By>;
  min?: InputMaybe<Evidences_Min_Order_By>;
  stddev?: InputMaybe<Evidences_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Evidences_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Evidences_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Evidences_Sum_Order_By>;
  var_pop?: InputMaybe<Evidences_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Evidences_Var_Samp_Order_By>;
  variance?: InputMaybe<Evidences_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Evidences_Avg_Fields = {
  __typename?: 'evidences_avg_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "evidences" */
export type Evidences_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "evidences". All fields are combined with a logical 'AND'. */
export type Evidences_Bool_Exp = {
  _and?: InputMaybe<Array<Evidences_Bool_Exp>>;
  _not?: InputMaybe<Evidences_Bool_Exp>;
  _or?: InputMaybe<Array<Evidences_Bool_Exp>>;
  acl?: InputMaybe<Evidence_Acl_Bool_Exp>;
  comments?: InputMaybe<Comments_Bool_Exp>;
  control_evidences?: InputMaybe<Control_Evidences_Bool_Exp>;
  controls_aggregate_status?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  evidence_integration?: InputMaybe<Evidence_Integrations_Bool_Exp>;
  evidence_owners?: InputMaybe<Evidence_Owners_Bool_Exp>;
  evidence_policy?: InputMaybe<Evidence_Policies_Bool_Exp>;
  evidence_versions?: InputMaybe<Evidence_Versions_Bool_Exp>;
  evidences_notifications?: InputMaybe<Notifications_Bool_Exp>;
  evidences_vector_stores?: InputMaybe<Ai_Evidences_Vector_Store_Bool_Exp>;
  field_values?: InputMaybe<Field_Values_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_id?: InputMaybe<String_Comparison_Exp>;
  is_ai_generated?: InputMaybe<Boolean_Comparison_Exp>;
  is_confidential?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  source_entity_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  source_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Evidence_Tags_Bool_Exp>;
  target_entity_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  target_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  tasks?: InputMaybe<Evidence_Tasks_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "evidences" */
export enum Evidences_Constraint {
  /** unique or primary key constraint on columns "id" */
  ControlEvidencesPkey = 'control_evidences_pkey',
  /** unique or primary key constraint on columns "organization_id", "internal_id" */
  EvidencesOrganizationIdInternalIdKey = 'evidences_organization_id_internal_id_key',
}

/** input type for inserting data into table "evidences" */
export type Evidences_Insert_Input = {
  comments?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  control_evidences?: InputMaybe<Control_Evidences_Arr_Rel_Insert_Input>;
  evidence_integration?: InputMaybe<Evidence_Integrations_Obj_Rel_Insert_Input>;
  evidence_owners?: InputMaybe<Evidence_Owners_Arr_Rel_Insert_Input>;
  evidence_policy?: InputMaybe<Evidence_Policies_Obj_Rel_Insert_Input>;
  evidence_versions?: InputMaybe<Evidence_Versions_Arr_Rel_Insert_Input>;
  field_values?: InputMaybe<Field_Values_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_confidential?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  source_entity_relations?: InputMaybe<Entity_Relations_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Evidence_Tags_Arr_Rel_Insert_Input>;
  target_entity_relations?: InputMaybe<Entity_Relations_Arr_Rel_Insert_Input>;
  tasks?: InputMaybe<Evidence_Tasks_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Evidences_Max_Fields = {
  __typename?: 'evidences_max_fields';
  /** A computed field, executes function "get_evidence_status" */
  controls_aggregate_status?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "evidences" */
export type Evidences_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Evidences_Min_Fields = {
  __typename?: 'evidences_min_fields';
  /** A computed field, executes function "get_evidence_status" */
  controls_aggregate_status?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "evidences" */
export type Evidences_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "evidences" */
export type Evidences_Mutation_Response = {
  __typename?: 'evidences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Evidences>;
};

/** input type for inserting object relation for remote table "evidences" */
export type Evidences_Obj_Rel_Insert_Input = {
  data: Evidences_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Evidences_On_Conflict>;
};

/** on_conflict condition type for table "evidences" */
export type Evidences_On_Conflict = {
  constraint: Evidences_Constraint;
  update_columns?: Array<Evidences_Update_Column>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

/** Ordering options when selecting data from "evidences". */
export type Evidences_Order_By = {
  acl_aggregate?: InputMaybe<Evidence_Acl_Aggregate_Order_By>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  control_evidences_aggregate?: InputMaybe<Control_Evidences_Aggregate_Order_By>;
  controls_aggregate_status?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  evidence_integration?: InputMaybe<Evidence_Integrations_Order_By>;
  evidence_owners_aggregate?: InputMaybe<Evidence_Owners_Aggregate_Order_By>;
  evidence_policy?: InputMaybe<Evidence_Policies_Order_By>;
  evidence_versions_aggregate?: InputMaybe<Evidence_Versions_Aggregate_Order_By>;
  evidences_notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  evidences_vector_stores_aggregate?: InputMaybe<Ai_Evidences_Vector_Store_Aggregate_Order_By>;
  field_values_aggregate?: InputMaybe<Field_Values_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  is_ai_generated?: InputMaybe<Order_By>;
  is_confidential?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  source_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Evidence_Tags_Aggregate_Order_By>;
  target_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  tasks_aggregate?: InputMaybe<Evidence_Tasks_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: evidences */
export type Evidences_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "evidences" */
export enum Evidences_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  IsAiGenerated = 'is_ai_generated',
  /** column name */
  IsConfidential = 'is_confidential',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** select "evidences_aggregate_bool_exp_avg_arguments_columns" columns of table "evidences" */
export enum Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "evidences_aggregate_bool_exp_bool_and_arguments_columns" columns of table "evidences" */
export enum Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAiGenerated = 'is_ai_generated',
  /** column name */
  IsConfidential = 'is_confidential',
}

/** select "evidences_aggregate_bool_exp_bool_or_arguments_columns" columns of table "evidences" */
export enum Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAiGenerated = 'is_ai_generated',
  /** column name */
  IsConfidential = 'is_confidential',
}

/** select "evidences_aggregate_bool_exp_corr_arguments_columns" columns of table "evidences" */
export enum Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "evidences_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "evidences" */
export enum Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "evidences_aggregate_bool_exp_max_arguments_columns" columns of table "evidences" */
export enum Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "evidences_aggregate_bool_exp_min_arguments_columns" columns of table "evidences" */
export enum Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "evidences_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "evidences" */
export enum Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "evidences_aggregate_bool_exp_sum_arguments_columns" columns of table "evidences" */
export enum Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "evidences_aggregate_bool_exp_var_samp_arguments_columns" columns of table "evidences" */
export enum Evidences_Select_Column_Evidences_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** input type for updating data in table "evidences" */
export type Evidences_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_confidential?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Evidences_Stddev_Fields = {
  __typename?: 'evidences_stddev_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "evidences" */
export type Evidences_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Evidences_Stddev_Pop_Fields = {
  __typename?: 'evidences_stddev_pop_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "evidences" */
export type Evidences_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Evidences_Stddev_Samp_Fields = {
  __typename?: 'evidences_stddev_samp_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "evidences" */
export type Evidences_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "evidences" */
export type Evidences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Evidences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Evidences_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_id?: InputMaybe<Scalars['String']['input']>;
  is_ai_generated?: InputMaybe<Scalars['Boolean']['input']>;
  is_confidential?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  similarity?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Evidences_Sum_Fields = {
  __typename?: 'evidences_sum_fields';
  similarity?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "evidences" */
export type Evidences_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** update columns of table "evidences" */
export enum Evidences_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  IsConfidential = 'is_confidential',
  /** column name */
  Name = 'name',
}

export type Evidences_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Evidences_Set_Input>;
  /** filter the rows which have to be updated */
  where: Evidences_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Evidences_Var_Pop_Fields = {
  __typename?: 'evidences_var_pop_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "evidences" */
export type Evidences_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Evidences_Var_Samp_Fields = {
  __typename?: 'evidences_var_samp_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "evidences" */
export type Evidences_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Evidences_Variance_Fields = {
  __typename?: 'evidences_variance_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "evidences" */
export type Evidences_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** columns and relationships of "field_configs" */
export type Field_Configs = {
  __typename?: 'field_configs';
  created_at: Scalars['timestamptz']['output'];
  entity_name: Field_Entities_Enum;
  field_type: Field_Types_Enum;
  /** An array relationship */
  field_values: Array<Field_Values>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  program_field_configs: Array<Program_Field_Configs>;
  /** An object relationship */
  select_field_config?: Maybe<Select_Field_Configs>;
  /** An array relationship */
  select_field_configs: Array<Select_Field_Configs>;
  system_field?: Maybe<System_Fields_Enum>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  vq_custom_fields: Array<Vq_Custom_Fields>;
};

/** columns and relationships of "field_configs" */
export type Field_ConfigsField_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Values_Order_By>>;
  where?: InputMaybe<Field_Values_Bool_Exp>;
};

/** columns and relationships of "field_configs" */
export type Field_ConfigsProgram_Field_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Program_Field_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Program_Field_Configs_Order_By>>;
  where?: InputMaybe<Program_Field_Configs_Bool_Exp>;
};

/** columns and relationships of "field_configs" */
export type Field_ConfigsSelect_Field_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Select_Field_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Select_Field_Configs_Order_By>>;
  where?: InputMaybe<Select_Field_Configs_Bool_Exp>;
};

/** columns and relationships of "field_configs" */
export type Field_ConfigsVq_Custom_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Vq_Custom_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vq_Custom_Fields_Order_By>>;
  where?: InputMaybe<Vq_Custom_Fields_Bool_Exp>;
};

/** order by aggregate values of table "field_configs" */
export type Field_Configs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Field_Configs_Max_Order_By>;
  min?: InputMaybe<Field_Configs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "field_configs". All fields are combined with a logical 'AND'. */
export type Field_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<Field_Configs_Bool_Exp>>;
  _not?: InputMaybe<Field_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Configs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entity_name?: InputMaybe<Field_Entities_Enum_Comparison_Exp>;
  field_type?: InputMaybe<Field_Types_Enum_Comparison_Exp>;
  field_values?: InputMaybe<Field_Values_Bool_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  program_field_configs?: InputMaybe<Program_Field_Configs_Bool_Exp>;
  select_field_config?: InputMaybe<Select_Field_Configs_Bool_Exp>;
  select_field_configs?: InputMaybe<Select_Field_Configs_Bool_Exp>;
  system_field?: InputMaybe<System_Fields_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vq_custom_fields?: InputMaybe<Vq_Custom_Fields_Bool_Exp>;
};

/** unique or primary key constraints on table "field_configs" */
export enum Field_Configs_Constraint {
  /** unique or primary key constraint on columns "entity_name", "id", "field_type" */
  FieldConfigsEntityNameFieldTypeIdKey = 'field_configs_entity_name_field_type_id_key',
  /** unique or primary key constraint on columns "entity_name", "organization_id", "system_field" */
  FieldConfigsEntityNameOrganizationIdSystemFieldKey = 'field_configs_entity_name_organization_id_system_field_key',
  /** unique or primary key constraint on columns "id", "field_type" */
  FieldConfigsFieldTypeIdKey = 'field_configs_field_type_id_key',
  /** unique or primary key constraint on columns "entity_name", "id" */
  FieldConfigsIdEntityNameKey = 'field_configs_id_entity_name_key',
  /** unique or primary key constraint on columns "entity_name", "organization_id", "name" */
  FieldConfigsOrganizationIdEntityNameNameKey = 'field_configs_organization_id_entity_name_name_key',
  /** unique or primary key constraint on columns "entity_name", "organization_id", "order" */
  FieldConfigsOrganizationIdEntityNameOrderKey = 'field_configs_organization_id_entity_name_order_key',
  /** unique or primary key constraint on columns "id" */
  FieldConfigsPkey = 'field_configs_pkey',
}

/** input type for inserting data into table "field_configs" */
export type Field_Configs_Insert_Input = {
  entity_name?: InputMaybe<Field_Entities_Enum>;
  field_type?: InputMaybe<Field_Types_Enum>;
  field_values?: InputMaybe<Field_Values_Arr_Rel_Insert_Input>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  program_field_configs?: InputMaybe<Program_Field_Configs_Arr_Rel_Insert_Input>;
  select_field_config?: InputMaybe<Select_Field_Configs_Obj_Rel_Insert_Input>;
  select_field_configs?: InputMaybe<Select_Field_Configs_Arr_Rel_Insert_Input>;
  vq_custom_fields?: InputMaybe<Vq_Custom_Fields_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "field_configs" */
export type Field_Configs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "field_configs" */
export type Field_Configs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "field_configs" */
export type Field_Configs_Mutation_Response = {
  __typename?: 'field_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Field_Configs>;
};

/** input type for inserting object relation for remote table "field_configs" */
export type Field_Configs_Obj_Rel_Insert_Input = {
  data: Field_Configs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Configs_On_Conflict>;
};

/** on_conflict condition type for table "field_configs" */
export type Field_Configs_On_Conflict = {
  constraint: Field_Configs_Constraint;
  update_columns?: Array<Field_Configs_Update_Column>;
  where?: InputMaybe<Field_Configs_Bool_Exp>;
};

/** Ordering options when selecting data from "field_configs". */
export type Field_Configs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_name?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_values_aggregate?: InputMaybe<Field_Values_Aggregate_Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  program_field_configs_aggregate?: InputMaybe<Program_Field_Configs_Aggregate_Order_By>;
  select_field_config?: InputMaybe<Select_Field_Configs_Order_By>;
  select_field_configs_aggregate?: InputMaybe<Select_Field_Configs_Aggregate_Order_By>;
  system_field?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vq_custom_fields_aggregate?: InputMaybe<Vq_Custom_Fields_Aggregate_Order_By>;
};

/** primary key columns input for table: field_configs */
export type Field_Configs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "field_configs" */
export enum Field_Configs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityName = 'entity_name',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  SystemField = 'system_field',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "field_configs" */
export type Field_Configs_Set_Input = {
  field_type?: InputMaybe<Field_Types_Enum>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "field_configs" */
export type Field_Configs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Field_Configs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Field_Configs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_name?: InputMaybe<Field_Entities_Enum>;
  field_type?: InputMaybe<Field_Types_Enum>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  system_field?: InputMaybe<System_Fields_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "field_configs" */
export enum Field_Configs_Update_Column {
  /** column name */
  FieldType = 'field_type',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Field_Configs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Field_Configs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Field_Configs_Bool_Exp;
};

export enum Field_Entities_Enum {
  Control = 'control',
  Evidence = 'evidence',
  Finding = 'finding',
  Policy = 'policy',
  Risk = 'risk',
  Task = 'task',
  Vendor = 'vendor',
}

/** Boolean expression to compare columns of type "field_entities_enum". All fields are combined with logical 'AND'. */
export type Field_Entities_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Field_Entities_Enum>;
  _in?: InputMaybe<Array<Field_Entities_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Field_Entities_Enum>;
  _nin?: InputMaybe<Array<Field_Entities_Enum>>;
};

export enum Field_Types_Enum {
  Date = 'date',
  Email = 'email',
  Number = 'number',
  Reference = 'reference',
  Select = 'select',
  Text = 'text',
  Url = 'url',
  User = 'user',
}

/** Boolean expression to compare columns of type "field_types_enum". All fields are combined with logical 'AND'. */
export type Field_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Field_Types_Enum>;
  _in?: InputMaybe<Array<Field_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Field_Types_Enum>;
  _nin?: InputMaybe<Array<Field_Types_Enum>>;
};

/** columns and relationships of "field_values" */
export type Field_Values = {
  __typename?: 'field_values';
  /** An object relationship */
  control?: Maybe<Controls>;
  control_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  date_field_value?: Maybe<Date_Field_Values>;
  /** An array relationship */
  date_field_values: Array<Date_Field_Values>;
  /** An object relationship */
  email_field_value?: Maybe<Email_Field_Values>;
  /** An array relationship */
  email_field_values: Array<Email_Field_Values>;
  entity_name: Field_Entities_Enum;
  /** An object relationship */
  evidence?: Maybe<Evidences>;
  evidence_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  field_config?: Maybe<Field_Configs>;
  field_config_id: Scalars['uuid']['output'];
  field_type: Field_Types_Enum;
  /** An object relationship */
  finding?: Maybe<Findings>;
  finding_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  number_field_value?: Maybe<Number_Field_Values>;
  /** An array relationship */
  number_field_values: Array<Number_Field_Values>;
  /** An object relationship */
  policy?: Maybe<Policies>;
  policy_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  risk?: Maybe<Risks>;
  risk_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  select_field_value?: Maybe<Select_Field_Values>;
  /** An array relationship */
  select_field_values: Array<Select_Field_Values>;
  /** An object relationship */
  task?: Maybe<Tasks>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  text_field_value?: Maybe<Text_Field_Values>;
  /** An array relationship */
  text_field_values: Array<Text_Field_Values>;
  /** An object relationship */
  url_field_value?: Maybe<Url_Field_Values>;
  /** An array relationship */
  url_field_values: Array<Url_Field_Values>;
  /** An object relationship */
  vendor?: Maybe<Vendors>;
  vendor_id?: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "field_values" */
export type Field_ValuesDate_Field_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Date_Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Date_Field_Values_Order_By>>;
  where?: InputMaybe<Date_Field_Values_Bool_Exp>;
};

/** columns and relationships of "field_values" */
export type Field_ValuesEmail_Field_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Email_Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Field_Values_Order_By>>;
  where?: InputMaybe<Email_Field_Values_Bool_Exp>;
};

/** columns and relationships of "field_values" */
export type Field_ValuesNumber_Field_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Number_Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Number_Field_Values_Order_By>>;
  where?: InputMaybe<Number_Field_Values_Bool_Exp>;
};

/** columns and relationships of "field_values" */
export type Field_ValuesSelect_Field_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Select_Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Select_Field_Values_Order_By>>;
  where?: InputMaybe<Select_Field_Values_Bool_Exp>;
};

/** columns and relationships of "field_values" */
export type Field_ValuesText_Field_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Text_Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Text_Field_Values_Order_By>>;
  where?: InputMaybe<Text_Field_Values_Bool_Exp>;
};

/** columns and relationships of "field_values" */
export type Field_ValuesUrl_Field_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Url_Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Url_Field_Values_Order_By>>;
  where?: InputMaybe<Url_Field_Values_Bool_Exp>;
};

/** order by aggregate values of table "field_values" */
export type Field_Values_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Field_Values_Max_Order_By>;
  min?: InputMaybe<Field_Values_Min_Order_By>;
};

/** input type for inserting array relation for remote table "field_values" */
export type Field_Values_Arr_Rel_Insert_Input = {
  data: Array<Field_Values_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Values_On_Conflict>;
};

/** Boolean expression to filter rows from the table "field_values". All fields are combined with a logical 'AND'. */
export type Field_Values_Bool_Exp = {
  _and?: InputMaybe<Array<Field_Values_Bool_Exp>>;
  _not?: InputMaybe<Field_Values_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Values_Bool_Exp>>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  date_field_value?: InputMaybe<Date_Field_Values_Bool_Exp>;
  date_field_values?: InputMaybe<Date_Field_Values_Bool_Exp>;
  email_field_value?: InputMaybe<Email_Field_Values_Bool_Exp>;
  email_field_values?: InputMaybe<Email_Field_Values_Bool_Exp>;
  entity_name?: InputMaybe<Field_Entities_Enum_Comparison_Exp>;
  evidence?: InputMaybe<Evidences_Bool_Exp>;
  evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  field_config?: InputMaybe<Field_Configs_Bool_Exp>;
  field_config_id?: InputMaybe<Uuid_Comparison_Exp>;
  field_type?: InputMaybe<Field_Types_Enum_Comparison_Exp>;
  finding?: InputMaybe<Findings_Bool_Exp>;
  finding_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  number_field_value?: InputMaybe<Number_Field_Values_Bool_Exp>;
  number_field_values?: InputMaybe<Number_Field_Values_Bool_Exp>;
  policy?: InputMaybe<Policies_Bool_Exp>;
  policy_id?: InputMaybe<Uuid_Comparison_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  select_field_value?: InputMaybe<Select_Field_Values_Bool_Exp>;
  select_field_values?: InputMaybe<Select_Field_Values_Bool_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  text_field_value?: InputMaybe<Text_Field_Values_Bool_Exp>;
  text_field_values?: InputMaybe<Text_Field_Values_Bool_Exp>;
  url_field_value?: InputMaybe<Url_Field_Values_Bool_Exp>;
  url_field_values?: InputMaybe<Url_Field_Values_Bool_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "field_values" */
export enum Field_Values_Constraint {
  /** unique or primary key constraint on columns "field_config_id", "id", "field_type" */
  FieldValuesFieldConfigIdFieldTypeIdKey = 'field_values_field_config_id_field_type_id_key',
  /** unique or primary key constraint on columns "id", "field_type" */
  FieldValuesFieldTypeIdKey = 'field_values_field_type_id_key',
  /** unique or primary key constraint on columns "field_config_id", "finding_id" */
  FieldValuesFindingScalarIdx = 'field_values_finding_scalar_idx',
  /** unique or primary key constraint on columns "id" */
  FieldValuesPkey = 'field_values_pkey',
}

/** input type for inserting data into table "field_values" */
export type Field_Values_Insert_Input = {
  control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  date_field_value?: InputMaybe<Date_Field_Values_Obj_Rel_Insert_Input>;
  date_field_values?: InputMaybe<Date_Field_Values_Arr_Rel_Insert_Input>;
  email_field_value?: InputMaybe<Email_Field_Values_Obj_Rel_Insert_Input>;
  email_field_values?: InputMaybe<Email_Field_Values_Arr_Rel_Insert_Input>;
  entity_name?: InputMaybe<Field_Entities_Enum>;
  evidence?: InputMaybe<Evidences_Obj_Rel_Insert_Input>;
  evidence_id?: InputMaybe<Scalars['uuid']['input']>;
  field_config?: InputMaybe<Field_Configs_Obj_Rel_Insert_Input>;
  field_config_id?: InputMaybe<Scalars['uuid']['input']>;
  field_type?: InputMaybe<Field_Types_Enum>;
  finding_id?: InputMaybe<Scalars['uuid']['input']>;
  number_field_value?: InputMaybe<Number_Field_Values_Obj_Rel_Insert_Input>;
  number_field_values?: InputMaybe<Number_Field_Values_Arr_Rel_Insert_Input>;
  policy?: InputMaybe<Policies_Obj_Rel_Insert_Input>;
  policy_id?: InputMaybe<Scalars['uuid']['input']>;
  risk?: InputMaybe<Risks_Obj_Rel_Insert_Input>;
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
  task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  text_field_value?: InputMaybe<Text_Field_Values_Obj_Rel_Insert_Input>;
  text_field_values?: InputMaybe<Text_Field_Values_Arr_Rel_Insert_Input>;
  url_field_value?: InputMaybe<Url_Field_Values_Obj_Rel_Insert_Input>;
  url_field_values?: InputMaybe<Url_Field_Values_Arr_Rel_Insert_Input>;
  vendor?: InputMaybe<Vendors_Obj_Rel_Insert_Input>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "field_values" */
export type Field_Values_Max_Order_By = {
  control_id?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  field_config_id?: InputMaybe<Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "field_values" */
export type Field_Values_Min_Order_By = {
  control_id?: InputMaybe<Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  field_config_id?: InputMaybe<Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "field_values" */
export type Field_Values_Mutation_Response = {
  __typename?: 'field_values_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Field_Values>;
};

/** input type for inserting object relation for remote table "field_values" */
export type Field_Values_Obj_Rel_Insert_Input = {
  data: Field_Values_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Values_On_Conflict>;
};

/** on_conflict condition type for table "field_values" */
export type Field_Values_On_Conflict = {
  constraint: Field_Values_Constraint;
  update_columns?: Array<Field_Values_Update_Column>;
  where?: InputMaybe<Field_Values_Bool_Exp>;
};

/** Ordering options when selecting data from "field_values". */
export type Field_Values_Order_By = {
  control?: InputMaybe<Controls_Order_By>;
  control_id?: InputMaybe<Order_By>;
  date_field_value?: InputMaybe<Date_Field_Values_Order_By>;
  date_field_values_aggregate?: InputMaybe<Date_Field_Values_Aggregate_Order_By>;
  email_field_value?: InputMaybe<Email_Field_Values_Order_By>;
  email_field_values_aggregate?: InputMaybe<Email_Field_Values_Aggregate_Order_By>;
  entity_name?: InputMaybe<Order_By>;
  evidence?: InputMaybe<Evidences_Order_By>;
  evidence_id?: InputMaybe<Order_By>;
  field_config?: InputMaybe<Field_Configs_Order_By>;
  field_config_id?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  finding?: InputMaybe<Findings_Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number_field_value?: InputMaybe<Number_Field_Values_Order_By>;
  number_field_values_aggregate?: InputMaybe<Number_Field_Values_Aggregate_Order_By>;
  policy?: InputMaybe<Policies_Order_By>;
  policy_id?: InputMaybe<Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risk_id?: InputMaybe<Order_By>;
  select_field_value?: InputMaybe<Select_Field_Values_Order_By>;
  select_field_values_aggregate?: InputMaybe<Select_Field_Values_Aggregate_Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  text_field_value?: InputMaybe<Text_Field_Values_Order_By>;
  text_field_values_aggregate?: InputMaybe<Text_Field_Values_Aggregate_Order_By>;
  url_field_value?: InputMaybe<Url_Field_Values_Order_By>;
  url_field_values_aggregate?: InputMaybe<Url_Field_Values_Aggregate_Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** select columns of table "field_values" */
export enum Field_Values_Select_Column {
  /** column name */
  ControlId = 'control_id',
  /** column name */
  EntityName = 'entity_name',
  /** column name */
  EvidenceId = 'evidence_id',
  /** column name */
  FieldConfigId = 'field_config_id',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  FindingId = 'finding_id',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyId = 'policy_id',
  /** column name */
  RiskId = 'risk_id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  VendorId = 'vendor_id',
}

/** placeholder for update columns of table "field_values" (current role has no relevant permissions) */
export enum Field_Values_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "storage.files" */
export type Files = {
  __typename?: 'files';
  bucketId: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  documents: Array<Documents>;
  etag?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  exception_files: Array<Policy_Exception_Files>;
  /** An array relationship */
  export_client_questionnaires: Array<Client_Questionnaires>;
  /** An array relationship */
  file_processings: Array<Storage_File_Processings>;
  /** An object relationship */
  files_client_questionnaire?: Maybe<Client_Questionnaires>;
  /** An object relationship */
  files_comment_upload?: Maybe<Comment_Uploads>;
  /** An array relationship */
  framework_logo_files: Array<Trust_Portal_Frameworks>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  integration_runs: Array<Integration_Runs>;
  /** An aggregate relationship */
  integration_runs_aggregate: Integration_Runs_Aggregate;
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organization_profile_logo: Array<Organization_Profiles>;
  /** An array relationship */
  policy_version_content_files: Array<Policy_Version_Content_Files>;
  /** An array relationship */
  policy_versions: Array<Policy_Versions>;
  /** An object relationship */
  questionnaire_file?: Maybe<Questionnaires>;
  /** An array relationship */
  questionnaire_uploads: Array<Questionnaire_Uploads>;
  /** An array relationship */
  review_files: Array<Review_Files>;
  /** An array relationship */
  risk_approval_files: Array<Risk_Approval_Files>;
  /** An object relationship */
  risk_document?: Maybe<Risk_Documents>;
  size?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  trust_portal_documents: Array<Trust_Portal_Documents>;
  /** An array relationship */
  trust_portal_pages_logo: Array<Trust_Portal_Pages>;
  updatedAt: Scalars['timestamptz']['output'];
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  vendor_approval_files: Array<Vendor_Approval_Files>;
  /** An object relationship */
  vendor_document?: Maybe<Vendor_Documents>;
  /** An array relationship */
  vendor_questionnaire_form_uploads: Array<Vendor_Questionnaire_Form_Uploads>;
  /** An array relationship */
  vendor_questionnaire_uploads: Array<Vendor_Questionnaire_Uploads>;
};

/** columns and relationships of "storage.files" */
export type FilesDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesException_FilesArgs = {
  distinct_on?: InputMaybe<Array<Policy_Exception_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Exception_Files_Order_By>>;
  where?: InputMaybe<Policy_Exception_Files_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesExport_Client_QuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Client_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Questionnaires_Order_By>>;
  where?: InputMaybe<Client_Questionnaires_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesFile_ProcessingsArgs = {
  distinct_on?: InputMaybe<Array<Storage_File_Processings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storage_File_Processings_Order_By>>;
  where?: InputMaybe<Storage_File_Processings_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesFramework_Logo_FilesArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Frameworks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Frameworks_Order_By>>;
  where?: InputMaybe<Trust_Portal_Frameworks_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesIntegration_RunsArgs = {
  distinct_on?: InputMaybe<Array<Integration_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integration_Runs_Order_By>>;
  where?: InputMaybe<Integration_Runs_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesIntegration_Runs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integration_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integration_Runs_Order_By>>;
  where?: InputMaybe<Integration_Runs_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "storage.files" */
export type FilesOrganization_Profile_LogoArgs = {
  distinct_on?: InputMaybe<Array<Organization_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Profiles_Order_By>>;
  where?: InputMaybe<Organization_Profiles_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesPolicy_Version_Content_FilesArgs = {
  distinct_on?: InputMaybe<Array<Policy_Version_Content_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Version_Content_Files_Order_By>>;
  where?: InputMaybe<Policy_Version_Content_Files_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesPolicy_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Policy_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Versions_Order_By>>;
  where?: InputMaybe<Policy_Versions_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesQuestionnaire_UploadsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Uploads_Order_By>>;
  where?: InputMaybe<Questionnaire_Uploads_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesReview_FilesArgs = {
  distinct_on?: InputMaybe<Array<Review_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Review_Files_Order_By>>;
  where?: InputMaybe<Review_Files_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesRisk_Approval_FilesArgs = {
  distinct_on?: InputMaybe<Array<Risk_Approval_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Approval_Files_Order_By>>;
  where?: InputMaybe<Risk_Approval_Files_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesTrust_Portal_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Documents_Order_By>>;
  where?: InputMaybe<Trust_Portal_Documents_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesTrust_Portal_Pages_LogoArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Pages_Order_By>>;
  where?: InputMaybe<Trust_Portal_Pages_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesVendor_Approval_FilesArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Approval_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Approval_Files_Order_By>>;
  where?: InputMaybe<Vendor_Approval_Files_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesVendor_Questionnaire_Form_UploadsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaire_Form_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaire_Form_Uploads_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaire_Form_Uploads_Bool_Exp>;
};

/** columns and relationships of "storage.files" */
export type FilesVendor_Questionnaire_UploadsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaire_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaire_Uploads_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaire_Uploads_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  bucketId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  documents?: InputMaybe<Documents_Bool_Exp>;
  etag?: InputMaybe<String_Comparison_Exp>;
  exception_files?: InputMaybe<Policy_Exception_Files_Bool_Exp>;
  export_client_questionnaires?: InputMaybe<Client_Questionnaires_Bool_Exp>;
  file_processings?: InputMaybe<Storage_File_Processings_Bool_Exp>;
  files_client_questionnaire?: InputMaybe<Client_Questionnaires_Bool_Exp>;
  files_comment_upload?: InputMaybe<Comment_Uploads_Bool_Exp>;
  framework_logo_files?: InputMaybe<Trust_Portal_Frameworks_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  integration_runs?: InputMaybe<Integration_Runs_Bool_Exp>;
  integration_runs_aggregate?: InputMaybe<Integration_Runs_Aggregate_Bool_Exp>;
  isUploaded?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mimeType?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_profile_logo?: InputMaybe<Organization_Profiles_Bool_Exp>;
  policy_version_content_files?: InputMaybe<Policy_Version_Content_Files_Bool_Exp>;
  policy_versions?: InputMaybe<Policy_Versions_Bool_Exp>;
  questionnaire_file?: InputMaybe<Questionnaires_Bool_Exp>;
  questionnaire_uploads?: InputMaybe<Questionnaire_Uploads_Bool_Exp>;
  review_files?: InputMaybe<Review_Files_Bool_Exp>;
  risk_approval_files?: InputMaybe<Risk_Approval_Files_Bool_Exp>;
  risk_document?: InputMaybe<Risk_Documents_Bool_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  trust_portal_documents?: InputMaybe<Trust_Portal_Documents_Bool_Exp>;
  trust_portal_pages_logo?: InputMaybe<Trust_Portal_Pages_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadedByUserId?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_approval_files?: InputMaybe<Vendor_Approval_Files_Bool_Exp>;
  vendor_document?: InputMaybe<Vendor_Documents_Bool_Exp>;
  vendor_questionnaire_form_uploads?: InputMaybe<Vendor_Questionnaire_Form_Uploads_Bool_Exp>;
  vendor_questionnaire_uploads?: InputMaybe<Vendor_Questionnaire_Uploads_Bool_Exp>;
};

/** unique or primary key constraints on table "storage.files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey',
}

/** input type for inserting data into table "storage.files" */
export type Files_Insert_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  documents?: InputMaybe<Documents_Arr_Rel_Insert_Input>;
  etag?: InputMaybe<Scalars['String']['input']>;
  exception_files?: InputMaybe<Policy_Exception_Files_Arr_Rel_Insert_Input>;
  export_client_questionnaires?: InputMaybe<Client_Questionnaires_Arr_Rel_Insert_Input>;
  files_client_questionnaire?: InputMaybe<Client_Questionnaires_Obj_Rel_Insert_Input>;
  files_comment_upload?: InputMaybe<Comment_Uploads_Obj_Rel_Insert_Input>;
  framework_logo_files?: InputMaybe<Trust_Portal_Frameworks_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_profile_logo?: InputMaybe<Organization_Profiles_Arr_Rel_Insert_Input>;
  policy_versions?: InputMaybe<Policy_Versions_Arr_Rel_Insert_Input>;
  questionnaire_file?: InputMaybe<Questionnaires_Obj_Rel_Insert_Input>;
  questionnaire_uploads?: InputMaybe<Questionnaire_Uploads_Arr_Rel_Insert_Input>;
  review_files?: InputMaybe<Review_Files_Arr_Rel_Insert_Input>;
  risk_approval_files?: InputMaybe<Risk_Approval_Files_Arr_Rel_Insert_Input>;
  risk_document?: InputMaybe<Risk_Documents_Obj_Rel_Insert_Input>;
  size?: InputMaybe<Scalars['Int']['input']>;
  trust_portal_documents?: InputMaybe<Trust_Portal_Documents_Arr_Rel_Insert_Input>;
  trust_portal_pages_logo?: InputMaybe<Trust_Portal_Pages_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  vendor_approval_files?: InputMaybe<Vendor_Approval_Files_Arr_Rel_Insert_Input>;
  vendor_document?: InputMaybe<Vendor_Documents_Obj_Rel_Insert_Input>;
};

/** response of any mutation on the table "storage.files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "storage.files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "storage.files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.files". */
export type Files_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Documents_Aggregate_Order_By>;
  etag?: InputMaybe<Order_By>;
  exception_files_aggregate?: InputMaybe<Policy_Exception_Files_Aggregate_Order_By>;
  export_client_questionnaires_aggregate?: InputMaybe<Client_Questionnaires_Aggregate_Order_By>;
  file_processings_aggregate?: InputMaybe<Storage_File_Processings_Aggregate_Order_By>;
  files_client_questionnaire?: InputMaybe<Client_Questionnaires_Order_By>;
  files_comment_upload?: InputMaybe<Comment_Uploads_Order_By>;
  framework_logo_files_aggregate?: InputMaybe<Trust_Portal_Frameworks_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  integration_runs_aggregate?: InputMaybe<Integration_Runs_Aggregate_Order_By>;
  isUploaded?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_profile_logo_aggregate?: InputMaybe<Organization_Profiles_Aggregate_Order_By>;
  policy_version_content_files_aggregate?: InputMaybe<Policy_Version_Content_Files_Aggregate_Order_By>;
  policy_versions_aggregate?: InputMaybe<Policy_Versions_Aggregate_Order_By>;
  questionnaire_file?: InputMaybe<Questionnaires_Order_By>;
  questionnaire_uploads_aggregate?: InputMaybe<Questionnaire_Uploads_Aggregate_Order_By>;
  review_files_aggregate?: InputMaybe<Review_Files_Aggregate_Order_By>;
  risk_approval_files_aggregate?: InputMaybe<Risk_Approval_Files_Aggregate_Order_By>;
  risk_document?: InputMaybe<Risk_Documents_Order_By>;
  size?: InputMaybe<Order_By>;
  trust_portal_documents_aggregate?: InputMaybe<Trust_Portal_Documents_Aggregate_Order_By>;
  trust_portal_pages_logo_aggregate?: InputMaybe<Trust_Portal_Pages_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
  vendor_approval_files_aggregate?: InputMaybe<Vendor_Approval_Files_Aggregate_Order_By>;
  vendor_document?: InputMaybe<Vendor_Documents_Order_By>;
  vendor_questionnaire_form_uploads_aggregate?: InputMaybe<Vendor_Questionnaire_Form_Uploads_Aggregate_Order_By>;
  vendor_questionnaire_uploads_aggregate?: InputMaybe<Vendor_Questionnaire_Uploads_Aggregate_Order_By>;
};

/** placeholder for update columns of table "storage.files" (current role has no relevant permissions) */
export enum Files_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "finding_anchors" */
export type Finding_Anchors = {
  __typename?: 'finding_anchors';
  /** An object relationship */
  answer?: Maybe<Vendor_Questionnaire_Form_Answers>;
  /** An object relationship */
  control?: Maybe<Controls>;
  control_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  finding: Findings;
  finding_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_primary: Scalars['Boolean']['output'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  risk?: Maybe<Risks>;
  risk_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  vendor?: Maybe<Vendors>;
  vendor_id?: Maybe<Scalars['uuid']['output']>;
  vendor_questionnaire_form_answer_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "finding_anchors" */
export type Finding_Anchors_Aggregate = {
  __typename?: 'finding_anchors_aggregate';
  aggregate?: Maybe<Finding_Anchors_Aggregate_Fields>;
  nodes: Array<Finding_Anchors>;
};

export type Finding_Anchors_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Finding_Anchors_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Finding_Anchors_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Finding_Anchors_Aggregate_Bool_Exp_Count>;
};

export type Finding_Anchors_Aggregate_Bool_Exp_Bool_And = {
  arguments: Finding_Anchors_Select_Column_Finding_Anchors_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Finding_Anchors_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Finding_Anchors_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Finding_Anchors_Select_Column_Finding_Anchors_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Finding_Anchors_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Finding_Anchors_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Finding_Anchors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Finding_Anchors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "finding_anchors" */
export type Finding_Anchors_Aggregate_Fields = {
  __typename?: 'finding_anchors_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Finding_Anchors_Max_Fields>;
  min?: Maybe<Finding_Anchors_Min_Fields>;
};

/** aggregate fields of "finding_anchors" */
export type Finding_Anchors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Finding_Anchors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "finding_anchors" */
export type Finding_Anchors_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Finding_Anchors_Max_Order_By>;
  min?: InputMaybe<Finding_Anchors_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "finding_anchors". All fields are combined with a logical 'AND'. */
export type Finding_Anchors_Bool_Exp = {
  _and?: InputMaybe<Array<Finding_Anchors_Bool_Exp>>;
  _not?: InputMaybe<Finding_Anchors_Bool_Exp>;
  _or?: InputMaybe<Array<Finding_Anchors_Bool_Exp>>;
  answer?: InputMaybe<Vendor_Questionnaire_Form_Answers_Bool_Exp>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  finding?: InputMaybe<Findings_Bool_Exp>;
  finding_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_primary?: InputMaybe<Boolean_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_questionnaire_form_answer_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Finding_Anchors_Max_Fields = {
  __typename?: 'finding_anchors_max_fields';
  control_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  finding_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  risk_id?: Maybe<Scalars['uuid']['output']>;
  vendor_id?: Maybe<Scalars['uuid']['output']>;
  vendor_questionnaire_form_answer_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "finding_anchors" */
export type Finding_Anchors_Max_Order_By = {
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_questionnaire_form_answer_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Finding_Anchors_Min_Fields = {
  __typename?: 'finding_anchors_min_fields';
  control_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  finding_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  risk_id?: Maybe<Scalars['uuid']['output']>;
  vendor_id?: Maybe<Scalars['uuid']['output']>;
  vendor_questionnaire_form_answer_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "finding_anchors" */
export type Finding_Anchors_Min_Order_By = {
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_questionnaire_form_answer_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "finding_anchors". */
export type Finding_Anchors_Order_By = {
  answer?: InputMaybe<Vendor_Questionnaire_Form_Answers_Order_By>;
  control?: InputMaybe<Controls_Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  finding?: InputMaybe<Findings_Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_primary?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risk_id?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_questionnaire_form_answer_id?: InputMaybe<Order_By>;
};

/** select columns of table "finding_anchors" */
export enum Finding_Anchors_Select_Column {
  /** column name */
  ControlId = 'control_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FindingId = 'finding_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RiskId = 'risk_id',
  /** column name */
  VendorId = 'vendor_id',
  /** column name */
  VendorQuestionnaireFormAnswerId = 'vendor_questionnaire_form_answer_id',
}

/** select "finding_anchors_aggregate_bool_exp_bool_and_arguments_columns" columns of table "finding_anchors" */
export enum Finding_Anchors_Select_Column_Finding_Anchors_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPrimary = 'is_primary',
}

/** select "finding_anchors_aggregate_bool_exp_bool_or_arguments_columns" columns of table "finding_anchors" */
export enum Finding_Anchors_Select_Column_Finding_Anchors_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPrimary = 'is_primary',
}

export enum Finding_Causes_Enum {
  AiEvidenceCheck = 'ai_evidence_check',
  AiEvidenceError = 'ai_evidence_error',
  AiRecommendation = 'ai_recommendation',
  AtRiskEvidence = 'at_risk_evidence',
  ExpiredEvidence = 'expired_evidence',
  FutureEvidenceValidity = 'future_evidence_validity',
  IntegrationCheck = 'integration_check',
  IntegrationError = 'integration_error',
  ManualConsideration = 'manual_consideration',
  ManualIssue = 'manual_issue',
  ManualRecommendation = 'manual_recommendation',
  MissingEvidence = 'missing_evidence',
  PolicyError = 'policy_error',
}

/** Boolean expression to compare columns of type "finding_causes_enum". All fields are combined with logical 'AND'. */
export type Finding_Causes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Finding_Causes_Enum>;
  _in?: InputMaybe<Array<Finding_Causes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Finding_Causes_Enum>;
  _nin?: InputMaybe<Array<Finding_Causes_Enum>>;
};

export enum Finding_Closure_Reasons_Enum {
  FalsePositive = 'false_positive',
  Fixed = 'fixed',
  NotRelevant = 'not_relevant',
}

/** Boolean expression to compare columns of type "finding_closure_reasons_enum". All fields are combined with logical 'AND'. */
export type Finding_Closure_Reasons_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Finding_Closure_Reasons_Enum>;
  _in?: InputMaybe<Array<Finding_Closure_Reasons_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Finding_Closure_Reasons_Enum>;
  _nin?: InputMaybe<Array<Finding_Closure_Reasons_Enum>>;
};

export enum Finding_Creation_Kinds_Enum {
  Detector = 'detector',
  Intake = 'intake',
  Manual = 'manual',
}

/** Boolean expression to compare columns of type "finding_creation_kinds_enum". All fields are combined with logical 'AND'. */
export type Finding_Creation_Kinds_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Finding_Creation_Kinds_Enum>;
  _in?: InputMaybe<Array<Finding_Creation_Kinds_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Finding_Creation_Kinds_Enum>;
  _nin?: InputMaybe<Array<Finding_Creation_Kinds_Enum>>;
};

export enum Finding_Detector_Kinds_Enum {
  AiReview = 'ai_review',
  Automation = 'automation',
  Integration = 'integration',
  User = 'user',
}

/** Boolean expression to compare columns of type "finding_detector_kinds_enum". All fields are combined with logical 'AND'. */
export type Finding_Detector_Kinds_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Finding_Detector_Kinds_Enum>;
  _in?: InputMaybe<Array<Finding_Detector_Kinds_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Finding_Detector_Kinds_Enum>;
  _nin?: InputMaybe<Array<Finding_Detector_Kinds_Enum>>;
};

/** columns and relationships of "finding_history_details" */
export type Finding_History_Details = {
  __typename?: 'finding_history_details';
  /** An object relationship */
  finding?: Maybe<Findings>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  observation?: Maybe<Finding_Observations>;
  payload?: Maybe<Scalars['jsonb']['output']>;
};

/** columns and relationships of "finding_history_details" */
export type Finding_History_DetailsPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "finding_history_details". All fields are combined with a logical 'AND'. */
export type Finding_History_Details_Bool_Exp = {
  _and?: InputMaybe<Array<Finding_History_Details_Bool_Exp>>;
  _not?: InputMaybe<Finding_History_Details_Bool_Exp>;
  _or?: InputMaybe<Array<Finding_History_Details_Bool_Exp>>;
  finding?: InputMaybe<Findings_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  observation?: InputMaybe<Finding_Observations_Bool_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Ordering options when selecting data from "finding_history_details". */
export type Finding_History_Details_Order_By = {
  finding?: InputMaybe<Findings_Order_By>;
  id?: InputMaybe<Order_By>;
  observation?: InputMaybe<Finding_Observations_Order_By>;
  payload?: InputMaybe<Order_By>;
};

export enum Finding_Observation_Results_Enum {
  ConditionAbsent = 'condition_absent',
  ConditionPresent = 'condition_present',
  Inconclusive = 'inconclusive',
}

/** Boolean expression to compare columns of type "finding_observation_results_enum". All fields are combined with logical 'AND'. */
export type Finding_Observation_Results_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Finding_Observation_Results_Enum>;
  _in?: InputMaybe<Array<Finding_Observation_Results_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Finding_Observation_Results_Enum>;
  _nin?: InputMaybe<Array<Finding_Observation_Results_Enum>>;
};

/** columns and relationships of "finding_observation_sources" */
export type Finding_Observation_Sources = {
  __typename?: 'finding_observation_sources';
  citation_snapshot: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  evidence_version_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  observation: Finding_Observations;
  observation_id: Scalars['uuid']['output'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id: Scalars['uuid']['output'];
  original_source_id: Scalars['uuid']['output'];
  original_source_kind: Scalars['String']['output'];
  /** An object relationship */
  upload?: Maybe<Vendor_Questionnaire_Form_Uploads>;
  vendor_questionnaire_form_upload_id?: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "finding_observation_sources" */
export type Finding_Observation_SourcesCitation_SnapshotArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "finding_observation_sources" */
export type Finding_Observation_Sources_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Finding_Observation_Sources_Max_Order_By>;
  min?: InputMaybe<Finding_Observation_Sources_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "finding_observation_sources". All fields are combined with a logical 'AND'. */
export type Finding_Observation_Sources_Bool_Exp = {
  _and?: InputMaybe<Array<Finding_Observation_Sources_Bool_Exp>>;
  _not?: InputMaybe<Finding_Observation_Sources_Bool_Exp>;
  _or?: InputMaybe<Array<Finding_Observation_Sources_Bool_Exp>>;
  citation_snapshot?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  evidence_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  observation?: InputMaybe<Finding_Observations_Bool_Exp>;
  observation_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  original_source_id?: InputMaybe<Uuid_Comparison_Exp>;
  original_source_kind?: InputMaybe<String_Comparison_Exp>;
  upload?: InputMaybe<Vendor_Questionnaire_Form_Uploads_Bool_Exp>;
  vendor_questionnaire_form_upload_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "finding_observation_sources" */
export type Finding_Observation_Sources_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidence_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  original_source_id?: InputMaybe<Order_By>;
  original_source_kind?: InputMaybe<Order_By>;
  vendor_questionnaire_form_upload_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "finding_observation_sources" */
export type Finding_Observation_Sources_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidence_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  original_source_id?: InputMaybe<Order_By>;
  original_source_kind?: InputMaybe<Order_By>;
  vendor_questionnaire_form_upload_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "finding_observation_sources". */
export type Finding_Observation_Sources_Order_By = {
  citation_snapshot?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  evidence_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  observation?: InputMaybe<Finding_Observations_Order_By>;
  observation_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  original_source_id?: InputMaybe<Order_By>;
  original_source_kind?: InputMaybe<Order_By>;
  upload?: InputMaybe<Vendor_Questionnaire_Form_Uploads_Order_By>;
  vendor_questionnaire_form_upload_id?: InputMaybe<Order_By>;
};

/** select columns of table "finding_observation_sources" */
export enum Finding_Observation_Sources_Select_Column {
  /** column name */
  CitationSnapshot = 'citation_snapshot',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EvidenceVersionId = 'evidence_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  ObservationId = 'observation_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OriginalSourceId = 'original_source_id',
  /** column name */
  OriginalSourceKind = 'original_source_kind',
  /** column name */
  VendorQuestionnaireFormUploadId = 'vendor_questionnaire_form_upload_id',
}

/** columns and relationships of "finding_observations" */
export type Finding_Observations = {
  __typename?: 'finding_observations';
  /** An object relationship */
  answer_assessment?: Maybe<Vendor_Questionnaire_Ai_Review_Assessments>;
  context_snapshot: Scalars['jsonb']['output'];
  control_ai_review_assessment_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  control_assessment?: Maybe<Control_Ai_Review_Assessments>;
  /** An object relationship */
  control_evidence?: Maybe<Control_Evidences>;
  control_evidence_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  detail: Scalars['String']['output'];
  detector_kind: Finding_Detector_Kinds_Enum;
  /** An object relationship */
  evidence_policy?: Maybe<Evidence_Policies>;
  evidence_policy_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  finding: Findings;
  finding_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  integration_run?: Maybe<Integration_Runs>;
  integration_run_id?: Maybe<Scalars['uuid']['output']>;
  message_key?: Maybe<Scalars['String']['output']>;
  message_params: Scalars['jsonb']['output'];
  observed_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id: Scalars['uuid']['output'];
  original_provenance: Scalars['jsonb']['output'];
  reporter_id?: Maybe<Scalars['uuid']['output']>;
  result: Finding_Observation_Results_Enum;
  source_language?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  sources: Array<Finding_Observation_Sources>;
  vendor_questionnaire_ai_review_assessment_id?: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "finding_observations" */
export type Finding_ObservationsContext_SnapshotArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "finding_observations" */
export type Finding_ObservationsMessage_ParamsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "finding_observations" */
export type Finding_ObservationsOriginal_ProvenanceArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "finding_observations" */
export type Finding_ObservationsSourcesArgs = {
  distinct_on?: InputMaybe<Array<Finding_Observation_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Finding_Observation_Sources_Order_By>>;
  where?: InputMaybe<Finding_Observation_Sources_Bool_Exp>;
};

/** aggregated selection of "finding_observations" */
export type Finding_Observations_Aggregate = {
  __typename?: 'finding_observations_aggregate';
  aggregate?: Maybe<Finding_Observations_Aggregate_Fields>;
  nodes: Array<Finding_Observations>;
};

export type Finding_Observations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Finding_Observations_Aggregate_Bool_Exp_Count>;
};

export type Finding_Observations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Finding_Observations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Finding_Observations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "finding_observations" */
export type Finding_Observations_Aggregate_Fields = {
  __typename?: 'finding_observations_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Finding_Observations_Max_Fields>;
  min?: Maybe<Finding_Observations_Min_Fields>;
};

/** aggregate fields of "finding_observations" */
export type Finding_Observations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Finding_Observations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "finding_observations" */
export type Finding_Observations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Finding_Observations_Max_Order_By>;
  min?: InputMaybe<Finding_Observations_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "finding_observations". All fields are combined with a logical 'AND'. */
export type Finding_Observations_Bool_Exp = {
  _and?: InputMaybe<Array<Finding_Observations_Bool_Exp>>;
  _not?: InputMaybe<Finding_Observations_Bool_Exp>;
  _or?: InputMaybe<Array<Finding_Observations_Bool_Exp>>;
  answer_assessment?: InputMaybe<Vendor_Questionnaire_Ai_Review_Assessments_Bool_Exp>;
  context_snapshot?: InputMaybe<Jsonb_Comparison_Exp>;
  control_ai_review_assessment_id?: InputMaybe<Uuid_Comparison_Exp>;
  control_assessment?: InputMaybe<Control_Ai_Review_Assessments_Bool_Exp>;
  control_evidence?: InputMaybe<Control_Evidences_Bool_Exp>;
  control_evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  detail?: InputMaybe<String_Comparison_Exp>;
  detector_kind?: InputMaybe<Finding_Detector_Kinds_Enum_Comparison_Exp>;
  evidence_policy?: InputMaybe<Evidence_Policies_Bool_Exp>;
  evidence_policy_id?: InputMaybe<Uuid_Comparison_Exp>;
  finding?: InputMaybe<Findings_Bool_Exp>;
  finding_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  integration_run?: InputMaybe<Integration_Runs_Bool_Exp>;
  integration_run_id?: InputMaybe<Uuid_Comparison_Exp>;
  message_key?: InputMaybe<String_Comparison_Exp>;
  message_params?: InputMaybe<Jsonb_Comparison_Exp>;
  observed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  original_provenance?: InputMaybe<Jsonb_Comparison_Exp>;
  reporter_id?: InputMaybe<Uuid_Comparison_Exp>;
  result?: InputMaybe<Finding_Observation_Results_Enum_Comparison_Exp>;
  source_language?: InputMaybe<String_Comparison_Exp>;
  sources?: InputMaybe<Finding_Observation_Sources_Bool_Exp>;
  vendor_questionnaire_ai_review_assessment_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Finding_Observations_Max_Fields = {
  __typename?: 'finding_observations_max_fields';
  control_ai_review_assessment_id?: Maybe<Scalars['uuid']['output']>;
  control_evidence_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  evidence_policy_id?: Maybe<Scalars['uuid']['output']>;
  finding_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  integration_run_id?: Maybe<Scalars['uuid']['output']>;
  message_key?: Maybe<Scalars['String']['output']>;
  observed_at?: Maybe<Scalars['timestamptz']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  reporter_id?: Maybe<Scalars['uuid']['output']>;
  source_language?: Maybe<Scalars['String']['output']>;
  vendor_questionnaire_ai_review_assessment_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "finding_observations" */
export type Finding_Observations_Max_Order_By = {
  control_ai_review_assessment_id?: InputMaybe<Order_By>;
  control_evidence_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  detail?: InputMaybe<Order_By>;
  evidence_policy_id?: InputMaybe<Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  integration_run_id?: InputMaybe<Order_By>;
  message_key?: InputMaybe<Order_By>;
  observed_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  source_language?: InputMaybe<Order_By>;
  vendor_questionnaire_ai_review_assessment_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Finding_Observations_Min_Fields = {
  __typename?: 'finding_observations_min_fields';
  control_ai_review_assessment_id?: Maybe<Scalars['uuid']['output']>;
  control_evidence_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  evidence_policy_id?: Maybe<Scalars['uuid']['output']>;
  finding_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  integration_run_id?: Maybe<Scalars['uuid']['output']>;
  message_key?: Maybe<Scalars['String']['output']>;
  observed_at?: Maybe<Scalars['timestamptz']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  reporter_id?: Maybe<Scalars['uuid']['output']>;
  source_language?: Maybe<Scalars['String']['output']>;
  vendor_questionnaire_ai_review_assessment_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "finding_observations" */
export type Finding_Observations_Min_Order_By = {
  control_ai_review_assessment_id?: InputMaybe<Order_By>;
  control_evidence_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  detail?: InputMaybe<Order_By>;
  evidence_policy_id?: InputMaybe<Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  integration_run_id?: InputMaybe<Order_By>;
  message_key?: InputMaybe<Order_By>;
  observed_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  source_language?: InputMaybe<Order_By>;
  vendor_questionnaire_ai_review_assessment_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "finding_observations". */
export type Finding_Observations_Order_By = {
  answer_assessment?: InputMaybe<Vendor_Questionnaire_Ai_Review_Assessments_Order_By>;
  context_snapshot?: InputMaybe<Order_By>;
  control_ai_review_assessment_id?: InputMaybe<Order_By>;
  control_assessment?: InputMaybe<Control_Ai_Review_Assessments_Order_By>;
  control_evidence?: InputMaybe<Control_Evidences_Order_By>;
  control_evidence_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  detail?: InputMaybe<Order_By>;
  detector_kind?: InputMaybe<Order_By>;
  evidence_policy?: InputMaybe<Evidence_Policies_Order_By>;
  evidence_policy_id?: InputMaybe<Order_By>;
  finding?: InputMaybe<Findings_Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  integration_run?: InputMaybe<Integration_Runs_Order_By>;
  integration_run_id?: InputMaybe<Order_By>;
  message_key?: InputMaybe<Order_By>;
  message_params?: InputMaybe<Order_By>;
  observed_at?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  original_provenance?: InputMaybe<Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  result?: InputMaybe<Order_By>;
  source_language?: InputMaybe<Order_By>;
  sources_aggregate?: InputMaybe<Finding_Observation_Sources_Aggregate_Order_By>;
  vendor_questionnaire_ai_review_assessment_id?: InputMaybe<Order_By>;
};

/** select columns of table "finding_observations" */
export enum Finding_Observations_Select_Column {
  /** column name */
  ContextSnapshot = 'context_snapshot',
  /** column name */
  ControlAiReviewAssessmentId = 'control_ai_review_assessment_id',
  /** column name */
  ControlEvidenceId = 'control_evidence_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Detail = 'detail',
  /** column name */
  DetectorKind = 'detector_kind',
  /** column name */
  EvidencePolicyId = 'evidence_policy_id',
  /** column name */
  FindingId = 'finding_id',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationRunId = 'integration_run_id',
  /** column name */
  MessageKey = 'message_key',
  /** column name */
  MessageParams = 'message_params',
  /** column name */
  ObservedAt = 'observed_at',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OriginalProvenance = 'original_provenance',
  /** column name */
  ReporterId = 'reporter_id',
  /** column name */
  Result = 'result',
  /** column name */
  SourceLanguage = 'source_language',
  /** column name */
  VendorQuestionnaireAiReviewAssessmentId = 'vendor_questionnaire_ai_review_assessment_id',
}

/** columns and relationships of "finding_owners" */
export type Finding_Owners = {
  __typename?: 'finding_owners';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  finding: Findings;
  finding_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  owner?: Maybe<Users>;
  owner_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "finding_owners" */
export type Finding_Owners_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Finding_Owners_Max_Order_By>;
  min?: InputMaybe<Finding_Owners_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "finding_owners". All fields are combined with a logical 'AND'. */
export type Finding_Owners_Bool_Exp = {
  _and?: InputMaybe<Array<Finding_Owners_Bool_Exp>>;
  _not?: InputMaybe<Finding_Owners_Bool_Exp>;
  _or?: InputMaybe<Array<Finding_Owners_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  finding?: InputMaybe<Findings_Bool_Exp>;
  finding_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  owner?: InputMaybe<Users_Bool_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "finding_owners" */
export type Finding_Owners_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "finding_owners" */
export type Finding_Owners_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "finding_owners". */
export type Finding_Owners_Order_By = {
  created_at?: InputMaybe<Order_By>;
  finding?: InputMaybe<Findings_Order_By>;
  finding_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Users_Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** select columns of table "finding_owners" */
export enum Finding_Owners_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FindingId = 'finding_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OwnerId = 'owner_id',
}

export enum Finding_Resolution_Types_Enum {
  Accepted = 'Accepted',
  Ignored = 'Ignored',
  Resolved = 'Resolved',
}

/** Boolean expression to compare columns of type "finding_resolution_types_enum". All fields are combined with logical 'AND'. */
export type Finding_Resolution_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Finding_Resolution_Types_Enum>;
  _in?: InputMaybe<Array<Finding_Resolution_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Finding_Resolution_Types_Enum>;
  _nin?: InputMaybe<Array<Finding_Resolution_Types_Enum>>;
};

/** columns and relationships of "finding_resolutions" */
export type Finding_Resolutions = {
  __typename?: 'finding_resolutions';
  comment?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  control_finding?: Maybe<Control_Findings>;
  control_finding_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  type: Finding_Resolution_Types_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  vendor_finding?: Maybe<Vendor_Findings>;
  vendor_finding_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "finding_resolutions". All fields are combined with a logical 'AND'. */
export type Finding_Resolutions_Bool_Exp = {
  _and?: InputMaybe<Array<Finding_Resolutions_Bool_Exp>>;
  _not?: InputMaybe<Finding_Resolutions_Bool_Exp>;
  _or?: InputMaybe<Array<Finding_Resolutions_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  control_finding?: InputMaybe<Control_Findings_Bool_Exp>;
  control_finding_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Finding_Resolution_Types_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  vendor_finding?: InputMaybe<Vendor_Findings_Bool_Exp>;
  vendor_finding_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "finding_resolutions" */
export enum Finding_Resolutions_Constraint {
  /** unique or primary key constraint on columns "control_finding_id" */
  FindingResolutionsControlFindingIdKey = 'finding_resolutions_control_finding_id_key',
  /** unique or primary key constraint on columns "id" */
  FindingResolutionsPkey = 'finding_resolutions_pkey',
  /** unique or primary key constraint on columns "vendor_finding_id" */
  FindingResolutionsVendorFindingIdKey = 'finding_resolutions_vendor_finding_id_key',
}

/** input type for inserting data into table "finding_resolutions" */
export type Finding_Resolutions_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  control_finding_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Finding_Resolution_Types_Enum>;
  vendor_finding_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "finding_resolutions" */
export type Finding_Resolutions_Mutation_Response = {
  __typename?: 'finding_resolutions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Finding_Resolutions>;
};

/** on_conflict condition type for table "finding_resolutions" */
export type Finding_Resolutions_On_Conflict = {
  constraint: Finding_Resolutions_Constraint;
  update_columns?: Array<Finding_Resolutions_Update_Column>;
  where?: InputMaybe<Finding_Resolutions_Bool_Exp>;
};

/** Ordering options when selecting data from "finding_resolutions". */
export type Finding_Resolutions_Order_By = {
  comment?: InputMaybe<Order_By>;
  control_finding?: InputMaybe<Control_Findings_Order_By>;
  control_finding_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  vendor_finding?: InputMaybe<Vendor_Findings_Order_By>;
  vendor_finding_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: finding_resolutions */
export type Finding_Resolutions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** input type for updating data in table "finding_resolutions" */
export type Finding_Resolutions_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "finding_resolutions" */
export enum Finding_Resolutions_Update_Column {
  /** column name */
  Comment = 'comment',
}

export type Finding_Resolutions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Finding_Resolutions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Finding_Resolutions_Bool_Exp;
};

export enum Finding_Statuses_Enum {
  Accepted = 'accepted',
  Closed = 'closed',
  InProgress = 'in_progress',
  Open = 'open',
}

/** Boolean expression to compare columns of type "finding_statuses_enum". All fields are combined with logical 'AND'. */
export type Finding_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Finding_Statuses_Enum>;
  _in?: InputMaybe<Array<Finding_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Finding_Statuses_Enum>;
  _nin?: InputMaybe<Array<Finding_Statuses_Enum>>;
};

export enum Finding_Types_Enum {
  Consideration = 'consideration',
  Issue = 'issue',
  Recommendation = 'recommendation',
}

/** Boolean expression to compare columns of type "finding_types_enum". All fields are combined with logical 'AND'. */
export type Finding_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Finding_Types_Enum>;
  _in?: InputMaybe<Array<Finding_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Finding_Types_Enum>;
  _nin?: InputMaybe<Array<Finding_Types_Enum>>;
};

/** columns and relationships of "findings" */
export type Findings = {
  __typename?: 'findings';
  acceptance_reason?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  anchors: Array<Finding_Anchors>;
  /** An aggregate relationship */
  anchors_aggregate: Finding_Anchors_Aggregate;
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  archived_by?: Maybe<Scalars['uuid']['output']>;
  closure_reason?: Maybe<Finding_Closure_Reasons_Enum>;
  /** An array relationship */
  comments: Array<Comments>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  creation_kind: Finding_Creation_Kinds_Enum;
  cycle_year?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  /** An array relationship */
  field_values: Array<Field_Values>;
  /** An array relationship */
  history: Array<Audit_Finding_History>;
  /** An aggregate relationship */
  history_aggregate: Audit_Finding_History_Aggregate;
  id: Scalars['uuid']['output'];
  internal_id: Scalars['String']['output'];
  lifecycle_note?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  observations: Array<Finding_Observations>;
  /** An aggregate relationship */
  observations_aggregate: Finding_Observations_Aggregate;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  owners: Array<Finding_Owners>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  published_by?: Maybe<Scalars['uuid']['output']>;
  revision: Scalars['bigint']['output'];
  /** An object relationship */
  severity: Organization_Finding_Severities;
  severity_id: Scalars['uuid']['output'];
  /** An array relationship */
  source_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  source_relations_aggregate: Entity_Relations_Aggregate;
  status: Finding_Statuses_Enum;
  /** An array relationship */
  target_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  target_relations_aggregate: Entity_Relations_Aggregate;
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "findings" */
export type FindingsAnchorsArgs = {
  distinct_on?: InputMaybe<Array<Finding_Anchors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Finding_Anchors_Order_By>>;
  where?: InputMaybe<Finding_Anchors_Bool_Exp>;
};

/** columns and relationships of "findings" */
export type FindingsAnchors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Finding_Anchors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Finding_Anchors_Order_By>>;
  where?: InputMaybe<Finding_Anchors_Bool_Exp>;
};

/** columns and relationships of "findings" */
export type FindingsCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** columns and relationships of "findings" */
export type FindingsField_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Values_Order_By>>;
  where?: InputMaybe<Field_Values_Bool_Exp>;
};

/** columns and relationships of "findings" */
export type FindingsHistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Finding_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Finding_History_Order_By>>;
  where?: InputMaybe<Audit_Finding_History_Bool_Exp>;
};

/** columns and relationships of "findings" */
export type FindingsHistory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Finding_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Finding_History_Order_By>>;
  where?: InputMaybe<Audit_Finding_History_Bool_Exp>;
};

/** columns and relationships of "findings" */
export type FindingsObservationsArgs = {
  distinct_on?: InputMaybe<Array<Finding_Observations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Finding_Observations_Order_By>>;
  where?: InputMaybe<Finding_Observations_Bool_Exp>;
};

/** columns and relationships of "findings" */
export type FindingsObservations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Finding_Observations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Finding_Observations_Order_By>>;
  where?: InputMaybe<Finding_Observations_Bool_Exp>;
};

/** columns and relationships of "findings" */
export type FindingsOwnersArgs = {
  distinct_on?: InputMaybe<Array<Finding_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Finding_Owners_Order_By>>;
  where?: InputMaybe<Finding_Owners_Bool_Exp>;
};

/** columns and relationships of "findings" */
export type FindingsSource_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** columns and relationships of "findings" */
export type FindingsSource_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** columns and relationships of "findings" */
export type FindingsTarget_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** columns and relationships of "findings" */
export type FindingsTarget_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** aggregated selection of "findings" */
export type Findings_Aggregate = {
  __typename?: 'findings_aggregate';
  aggregate?: Maybe<Findings_Aggregate_Fields>;
  nodes: Array<Findings>;
};

/** aggregate fields of "findings" */
export type Findings_Aggregate_Fields = {
  __typename?: 'findings_aggregate_fields';
  avg?: Maybe<Findings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Findings_Max_Fields>;
  min?: Maybe<Findings_Min_Fields>;
  stddev?: Maybe<Findings_Stddev_Fields>;
  stddev_pop?: Maybe<Findings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Findings_Stddev_Samp_Fields>;
  sum?: Maybe<Findings_Sum_Fields>;
  var_pop?: Maybe<Findings_Var_Pop_Fields>;
  var_samp?: Maybe<Findings_Var_Samp_Fields>;
  variance?: Maybe<Findings_Variance_Fields>;
};

/** aggregate fields of "findings" */
export type Findings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Findings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Findings_Avg_Fields = {
  __typename?: 'findings_avg_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "findings". All fields are combined with a logical 'AND'. */
export type Findings_Bool_Exp = {
  _and?: InputMaybe<Array<Findings_Bool_Exp>>;
  _not?: InputMaybe<Findings_Bool_Exp>;
  _or?: InputMaybe<Array<Findings_Bool_Exp>>;
  acceptance_reason?: InputMaybe<String_Comparison_Exp>;
  anchors?: InputMaybe<Finding_Anchors_Bool_Exp>;
  anchors_aggregate?: InputMaybe<Finding_Anchors_Aggregate_Bool_Exp>;
  archived_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  archived_by?: InputMaybe<Uuid_Comparison_Exp>;
  closure_reason?: InputMaybe<Finding_Closure_Reasons_Enum_Comparison_Exp>;
  comments?: InputMaybe<Comments_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creation_kind?: InputMaybe<Finding_Creation_Kinds_Enum_Comparison_Exp>;
  cycle_year?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  field_values?: InputMaybe<Field_Values_Bool_Exp>;
  history?: InputMaybe<Audit_Finding_History_Bool_Exp>;
  history_aggregate?: InputMaybe<Audit_Finding_History_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_id?: InputMaybe<String_Comparison_Exp>;
  lifecycle_note?: InputMaybe<String_Comparison_Exp>;
  observations?: InputMaybe<Finding_Observations_Bool_Exp>;
  observations_aggregate?: InputMaybe<Finding_Observations_Aggregate_Bool_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  owners?: InputMaybe<Finding_Owners_Bool_Exp>;
  published_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  published_by?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<Bigint_Comparison_Exp>;
  severity?: InputMaybe<Organization_Finding_Severities_Bool_Exp>;
  severity_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  source_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  status?: InputMaybe<Finding_Statuses_Enum_Comparison_Exp>;
  target_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  target_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Findings_Max_Fields = {
  __typename?: 'findings_max_fields';
  acceptance_reason?: Maybe<Scalars['String']['output']>;
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  archived_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  cycle_year?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  lifecycle_note?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  published_by?: Maybe<Scalars['uuid']['output']>;
  revision?: Maybe<Scalars['bigint']['output']>;
  severity_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Findings_Min_Fields = {
  __typename?: 'findings_min_fields';
  acceptance_reason?: Maybe<Scalars['String']['output']>;
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  archived_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  cycle_year?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  lifecycle_note?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  published_by?: Maybe<Scalars['uuid']['output']>;
  revision?: Maybe<Scalars['bigint']['output']>;
  severity_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "findings". */
export type Findings_Order_By = {
  acceptance_reason?: InputMaybe<Order_By>;
  anchors_aggregate?: InputMaybe<Finding_Anchors_Aggregate_Order_By>;
  archived_at?: InputMaybe<Order_By>;
  archived_by?: InputMaybe<Order_By>;
  closure_reason?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creation_kind?: InputMaybe<Order_By>;
  cycle_year?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  field_values_aggregate?: InputMaybe<Field_Values_Aggregate_Order_By>;
  history_aggregate?: InputMaybe<Audit_Finding_History_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  lifecycle_note?: InputMaybe<Order_By>;
  observations_aggregate?: InputMaybe<Finding_Observations_Aggregate_Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owners_aggregate?: InputMaybe<Finding_Owners_Aggregate_Order_By>;
  published_at?: InputMaybe<Order_By>;
  published_by?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  severity?: InputMaybe<Organization_Finding_Severities_Order_By>;
  severity_id?: InputMaybe<Order_By>;
  source_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  target_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "findings" */
export enum Findings_Select_Column {
  /** column name */
  AcceptanceReason = 'acceptance_reason',
  /** column name */
  ArchivedAt = 'archived_at',
  /** column name */
  ArchivedBy = 'archived_by',
  /** column name */
  ClosureReason = 'closure_reason',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreationKind = 'creation_kind',
  /** column name */
  CycleYear = 'cycle_year',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  LifecycleNote = 'lifecycle_note',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  PublishedBy = 'published_by',
  /** column name */
  Revision = 'revision',
  /** column name */
  SeverityId = 'severity_id',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** aggregate stddev on columns */
export type Findings_Stddev_Fields = {
  __typename?: 'findings_stddev_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Findings_Stddev_Pop_Fields = {
  __typename?: 'findings_stddev_pop_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Findings_Stddev_Samp_Fields = {
  __typename?: 'findings_stddev_samp_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "findings" */
export type Findings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Findings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Findings_Stream_Cursor_Value_Input = {
  acceptance_reason?: InputMaybe<Scalars['String']['input']>;
  archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  archived_by?: InputMaybe<Scalars['uuid']['input']>;
  closure_reason?: InputMaybe<Finding_Closure_Reasons_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creation_kind?: InputMaybe<Finding_Creation_Kinds_Enum>;
  cycle_year?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_id?: InputMaybe<Scalars['String']['input']>;
  lifecycle_note?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  published_by?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<Scalars['bigint']['input']>;
  severity_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Finding_Statuses_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Findings_Sum_Fields = {
  __typename?: 'findings_sum_fields';
  cycle_year?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Findings_Var_Pop_Fields = {
  __typename?: 'findings_var_pop_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Findings_Var_Samp_Fields = {
  __typename?: 'findings_var_samp_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Findings_Variance_Fields = {
  __typename?: 'findings_variance_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "forms" */
export type Forms = {
  __typename?: 'forms';
  config?: Maybe<Scalars['FormConfig']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  questionnaire?: Maybe<Questionnaires>;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "forms" */
export type FormsConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Forms_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "forms". All fields are combined with a logical 'AND'. */
export type Forms_Bool_Exp = {
  _and?: InputMaybe<Array<Forms_Bool_Exp>>;
  _not?: InputMaybe<Forms_Bool_Exp>;
  _or?: InputMaybe<Array<Forms_Bool_Exp>>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  questionnaire?: InputMaybe<Questionnaires_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "forms" */
export enum Forms_Constraint {
  /** unique or primary key constraint on columns "id" */
  FormsPkey = 'forms_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Forms_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Forms_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Forms_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "forms" */
export type Forms_Insert_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  questionnaire?: InputMaybe<Questionnaires_Obj_Rel_Insert_Input>;
};

/** response of any mutation on the table "forms" */
export type Forms_Mutation_Response = {
  __typename?: 'forms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Forms>;
};

/** input type for inserting object relation for remote table "forms" */
export type Forms_Obj_Rel_Insert_Input = {
  data: Forms_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Forms_On_Conflict>;
};

/** on_conflict condition type for table "forms" */
export type Forms_On_Conflict = {
  constraint: Forms_Constraint;
  update_columns?: Array<Forms_Update_Column>;
  where?: InputMaybe<Forms_Bool_Exp>;
};

/** Ordering options when selecting data from "forms". */
export type Forms_Order_By = {
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire?: InputMaybe<Questionnaires_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: forms */
export type Forms_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Forms_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for updating data in table "forms" */
export type Forms_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "forms" */
export enum Forms_Update_Column {
  /** column name */
  Config = 'config',
}

export type Forms_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Forms_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Forms_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Forms_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Forms_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Forms_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Forms_Set_Input>;
  /** filter the rows which have to be updated */
  where: Forms_Bool_Exp;
};

/** columns and relationships of "frameworks" */
export type Frameworks = {
  __typename?: 'frameworks';
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  frameworks_controls: Array<Frameworks_Controls>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  programs: Array<Programs>;
};

/** columns and relationships of "frameworks" */
export type FrameworksFrameworks_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Frameworks_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Frameworks_Controls_Order_By>>;
  where?: InputMaybe<Frameworks_Controls_Bool_Exp>;
};

/** columns and relationships of "frameworks" */
export type FrameworksProgramsArgs = {
  distinct_on?: InputMaybe<Array<Programs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programs_Order_By>>;
  where?: InputMaybe<Programs_Bool_Exp>;
};

/** order by aggregate values of table "frameworks" */
export type Frameworks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Frameworks_Max_Order_By>;
  min?: InputMaybe<Frameworks_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "frameworks". All fields are combined with a logical 'AND'. */
export type Frameworks_Bool_Exp = {
  _and?: InputMaybe<Array<Frameworks_Bool_Exp>>;
  _not?: InputMaybe<Frameworks_Bool_Exp>;
  _or?: InputMaybe<Array<Frameworks_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  frameworks_controls?: InputMaybe<Frameworks_Controls_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  programs?: InputMaybe<Programs_Bool_Exp>;
};

/** unique or primary key constraints on table "frameworks" */
export enum Frameworks_Constraint {
  /** unique or primary key constraint on columns "id" */
  FrameworksPkey1 = 'frameworks_pkey1',
}

/** columns and relationships of "frameworks_controls" */
export type Frameworks_Controls = {
  __typename?: 'frameworks_controls';
  /** An object relationship */
  control: Controls;
  control_id: Scalars['uuid']['output'];
  /** An object relationship */
  framework: Frameworks;
  framework_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "frameworks_controls" */
export type Frameworks_Controls_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Frameworks_Controls_Max_Order_By>;
  min?: InputMaybe<Frameworks_Controls_Min_Order_By>;
};

/** input type for inserting array relation for remote table "frameworks_controls" */
export type Frameworks_Controls_Arr_Rel_Insert_Input = {
  data: Array<Frameworks_Controls_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Frameworks_Controls_On_Conflict>;
};

/** Boolean expression to filter rows from the table "frameworks_controls". All fields are combined with a logical 'AND'. */
export type Frameworks_Controls_Bool_Exp = {
  _and?: InputMaybe<Array<Frameworks_Controls_Bool_Exp>>;
  _not?: InputMaybe<Frameworks_Controls_Bool_Exp>;
  _or?: InputMaybe<Array<Frameworks_Controls_Bool_Exp>>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  framework?: InputMaybe<Frameworks_Bool_Exp>;
  framework_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "frameworks_controls" */
export enum Frameworks_Controls_Constraint {
  /** unique or primary key constraint on columns "framework_id", "control_id" */
  FrameworksControlsPkey1 = 'frameworks_controls_pkey1',
}

/** input type for inserting data into table "frameworks_controls" */
export type Frameworks_Controls_Insert_Input = {
  control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  framework?: InputMaybe<Frameworks_Obj_Rel_Insert_Input>;
  framework_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "frameworks_controls" */
export type Frameworks_Controls_Max_Order_By = {
  control_id?: InputMaybe<Order_By>;
  framework_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "frameworks_controls" */
export type Frameworks_Controls_Min_Order_By = {
  control_id?: InputMaybe<Order_By>;
  framework_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "frameworks_controls" */
export type Frameworks_Controls_Mutation_Response = {
  __typename?: 'frameworks_controls_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Frameworks_Controls>;
};

/** on_conflict condition type for table "frameworks_controls" */
export type Frameworks_Controls_On_Conflict = {
  constraint: Frameworks_Controls_Constraint;
  update_columns?: Array<Frameworks_Controls_Update_Column>;
  where?: InputMaybe<Frameworks_Controls_Bool_Exp>;
};

/** Ordering options when selecting data from "frameworks_controls". */
export type Frameworks_Controls_Order_By = {
  control?: InputMaybe<Controls_Order_By>;
  control_id?: InputMaybe<Order_By>;
  framework?: InputMaybe<Frameworks_Order_By>;
  framework_id?: InputMaybe<Order_By>;
};

/** select columns of table "frameworks_controls" */
export enum Frameworks_Controls_Select_Column {
  /** column name */
  ControlId = 'control_id',
  /** column name */
  FrameworkId = 'framework_id',
}

/** Streaming cursor of the table "frameworks_controls" */
export type Frameworks_Controls_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Frameworks_Controls_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Frameworks_Controls_Stream_Cursor_Value_Input = {
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  framework_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "frameworks_controls" (current role has no relevant permissions) */
export enum Frameworks_Controls_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** input type for inserting data into table "frameworks" */
export type Frameworks_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  frameworks_controls?: InputMaybe<Frameworks_Controls_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  programs?: InputMaybe<Programs_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "frameworks" */
export type Frameworks_Max_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "frameworks" */
export type Frameworks_Min_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "frameworks" */
export type Frameworks_Mutation_Response = {
  __typename?: 'frameworks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Frameworks>;
};

/** input type for inserting object relation for remote table "frameworks" */
export type Frameworks_Obj_Rel_Insert_Input = {
  data: Frameworks_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Frameworks_On_Conflict>;
};

/** on_conflict condition type for table "frameworks" */
export type Frameworks_On_Conflict = {
  constraint: Frameworks_Constraint;
  update_columns?: Array<Frameworks_Update_Column>;
  where?: InputMaybe<Frameworks_Bool_Exp>;
};

/** Ordering options when selecting data from "frameworks". */
export type Frameworks_Order_By = {
  active?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  frameworks_controls_aggregate?: InputMaybe<Frameworks_Controls_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  programs_aggregate?: InputMaybe<Programs_Aggregate_Order_By>;
};

/** select columns of table "frameworks" */
export enum Frameworks_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
}

/** Streaming cursor of the table "frameworks" */
export type Frameworks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Frameworks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Frameworks_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "frameworks" (current role has no relevant permissions) */
export enum Frameworks_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

export enum Frequencies_Enum {
  Annual = 'Annual',
  Biannual = 'Biannual',
  Biweekly = 'Biweekly',
  Daily = 'Daily',
  Indefinite = 'Indefinite',
  Monthly = 'Monthly',
  OneAndHalfYears = 'One_and_half_years',
  Quarterly = 'Quarterly',
  ThreeYears = 'Three_years',
  TwoYears = 'Two_years',
  Weekly = 'Weekly',
}

/** Boolean expression to compare columns of type "frequencies_enum". All fields are combined with logical 'AND'. */
export type Frequencies_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Frequencies_Enum>;
  _in?: InputMaybe<Array<Frequencies_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Frequencies_Enum>;
  _nin?: InputMaybe<Array<Frequencies_Enum>>;
};

/** columns and relationships of "groups" */
export type Groups = {
  __typename?: 'groups';
  /** An array relationship */
  control_groups: Array<Control_Groups>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "groups" */
export type GroupsControl_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Control_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Groups_Order_By>>;
  where?: InputMaybe<Control_Groups_Bool_Exp>;
};

/** order by aggregate values of table "groups" */
export type Groups_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Groups_Max_Order_By>;
  min?: InputMaybe<Groups_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "groups". All fields are combined with a logical 'AND'. */
export type Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Groups_Bool_Exp>>;
  _not?: InputMaybe<Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Groups_Bool_Exp>>;
  control_groups?: InputMaybe<Control_Groups_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "groups" */
export enum Groups_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  GroupsOrganizationIdNameKey = 'groups_organization_id_name_key',
  /** unique or primary key constraint on columns "id" */
  GroupsPkey = 'groups_pkey',
}

/** input type for inserting data into table "groups" */
export type Groups_Insert_Input = {
  control_groups?: InputMaybe<Control_Groups_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "groups" */
export type Groups_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "groups" */
export type Groups_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "groups" */
export type Groups_Mutation_Response = {
  __typename?: 'groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Groups>;
};

/** input type for inserting object relation for remote table "groups" */
export type Groups_Obj_Rel_Insert_Input = {
  data: Groups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};

/** on_conflict condition type for table "groups" */
export type Groups_On_Conflict = {
  constraint: Groups_Constraint;
  update_columns?: Array<Groups_Update_Column>;
  where?: InputMaybe<Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "groups". */
export type Groups_Order_By = {
  control_groups_aggregate?: InputMaybe<Control_Groups_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: groups */
export type Groups_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "groups" */
export enum Groups_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "groups" */
export type Groups_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "groups" */
export type Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Groups_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "groups" */
export enum Groups_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Groups_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Groups_Bool_Exp;
};

/** columns and relationships of "grove.agents" */
export type Grove_Agents = {
  __typename?: 'grove_agents';
  /** An array relationship */
  children: Array<Grove_Agents>;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  instances: Array<Agent_Instances>;
  manifest?: Maybe<Scalars['jsonb']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  parent?: Maybe<Grove_Agents>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  retired_at?: Maybe<Scalars['timestamptz']['output']>;
  unique_id: Scalars['String']['output'];
};

/** columns and relationships of "grove.agents" */
export type Grove_AgentsChildrenArgs = {
  distinct_on?: InputMaybe<Array<Grove_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grove_Agents_Order_By>>;
  where?: InputMaybe<Grove_Agents_Bool_Exp>;
};

/** columns and relationships of "grove.agents" */
export type Grove_AgentsInstancesArgs = {
  distinct_on?: InputMaybe<Array<Agent_Instances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Instances_Order_By>>;
  where?: InputMaybe<Agent_Instances_Bool_Exp>;
};

/** columns and relationships of "grove.agents" */
export type Grove_AgentsManifestArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "grove.agents" */
export type Grove_Agents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Grove_Agents_Max_Order_By>;
  min?: InputMaybe<Grove_Agents_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "grove.agents". All fields are combined with a logical 'AND'. */
export type Grove_Agents_Bool_Exp = {
  _and?: InputMaybe<Array<Grove_Agents_Bool_Exp>>;
  _not?: InputMaybe<Grove_Agents_Bool_Exp>;
  _or?: InputMaybe<Array<Grove_Agents_Bool_Exp>>;
  children?: InputMaybe<Grove_Agents_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  instances?: InputMaybe<Agent_Instances_Bool_Exp>;
  manifest?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent?: InputMaybe<Grove_Agents_Bool_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  retired_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  unique_id?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "grove.agents" */
export type Grove_Agents_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  retired_at?: InputMaybe<Order_By>;
  unique_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "grove.agents" */
export type Grove_Agents_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  retired_at?: InputMaybe<Order_By>;
  unique_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "grove.agents". */
export type Grove_Agents_Order_By = {
  children_aggregate?: InputMaybe<Grove_Agents_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instances_aggregate?: InputMaybe<Agent_Instances_Aggregate_Order_By>;
  manifest?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent?: InputMaybe<Grove_Agents_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  retired_at?: InputMaybe<Order_By>;
  unique_id?: InputMaybe<Order_By>;
};

/** select columns of table "grove.agents" */
export enum Grove_Agents_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Manifest = 'manifest',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  RetiredAt = 'retired_at',
  /** column name */
  UniqueId = 'unique_id',
}

/** Streaming cursor of the table "grove_agents" */
export type Grove_Agents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grove_Agents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grove_Agents_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manifest?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  retired_at?: InputMaybe<Scalars['timestamptz']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "grove.chats" */
export type Grove_Chats = {
  __typename?: 'grove_chats';
  /** An object relationship */
  agent: Grove_Agents;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  messages: Array<Grove_Messages>;
  /** An aggregate relationship */
  messages_aggregate: Grove_Messages_Aggregate;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

/** columns and relationships of "grove.chats" */
export type Grove_ChatsMessagesArgs = {
  distinct_on?: InputMaybe<Array<Grove_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grove_Messages_Order_By>>;
  where?: InputMaybe<Grove_Messages_Bool_Exp>;
};

/** columns and relationships of "grove.chats" */
export type Grove_ChatsMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grove_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grove_Messages_Order_By>>;
  where?: InputMaybe<Grove_Messages_Bool_Exp>;
};

/** columns and relationships of "grove.chats" */
export type Grove_ChatsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "grove.chats" */
export type Grove_Chats_Aggregate = {
  __typename?: 'grove_chats_aggregate';
  aggregate?: Maybe<Grove_Chats_Aggregate_Fields>;
  nodes: Array<Grove_Chats>;
};

/** aggregate fields of "grove.chats" */
export type Grove_Chats_Aggregate_Fields = {
  __typename?: 'grove_chats_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Grove_Chats_Max_Fields>;
  min?: Maybe<Grove_Chats_Min_Fields>;
};

/** aggregate fields of "grove.chats" */
export type Grove_Chats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grove_Chats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "grove.chats". All fields are combined with a logical 'AND'. */
export type Grove_Chats_Bool_Exp = {
  _and?: InputMaybe<Array<Grove_Chats_Bool_Exp>>;
  _not?: InputMaybe<Grove_Chats_Bool_Exp>;
  _or?: InputMaybe<Array<Grove_Chats_Bool_Exp>>;
  agent?: InputMaybe<Grove_Agents_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  messages?: InputMaybe<Grove_Messages_Bool_Exp>;
  messages_aggregate?: InputMaybe<Grove_Messages_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Grove_Chats_Max_Fields = {
  __typename?: 'grove_chats_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Grove_Chats_Min_Fields = {
  __typename?: 'grove_chats_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "grove.chats". */
export type Grove_Chats_Order_By = {
  agent?: InputMaybe<Grove_Agents_Order_By>;
  id?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Grove_Messages_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "grove.chats" */
export enum Grove_Chats_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
}

/** Streaming cursor of the table "grove_chats" */
export type Grove_Chats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grove_Chats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grove_Chats_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "grove.messages" */
export type Grove_Messages = {
  __typename?: 'grove_messages';
  /** An object relationship */
  agent?: Maybe<Grove_Agents>;
  /** An object relationship */
  chat: Grove_Chats;
  chat_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_read: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
};

/** aggregated selection of "grove.messages" */
export type Grove_Messages_Aggregate = {
  __typename?: 'grove_messages_aggregate';
  aggregate?: Maybe<Grove_Messages_Aggregate_Fields>;
  nodes: Array<Grove_Messages>;
};

export type Grove_Messages_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Grove_Messages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Grove_Messages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Grove_Messages_Aggregate_Bool_Exp_Count>;
};

export type Grove_Messages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Grove_Messages_Select_Column_Grove_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Grove_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Grove_Messages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Grove_Messages_Select_Column_Grove_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Grove_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Grove_Messages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Grove_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Grove_Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "grove.messages" */
export type Grove_Messages_Aggregate_Fields = {
  __typename?: 'grove_messages_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Grove_Messages_Max_Fields>;
  min?: Maybe<Grove_Messages_Min_Fields>;
};

/** aggregate fields of "grove.messages" */
export type Grove_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grove_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "grove.messages" */
export type Grove_Messages_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Grove_Messages_Max_Order_By>;
  min?: InputMaybe<Grove_Messages_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "grove.messages". All fields are combined with a logical 'AND'. */
export type Grove_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Grove_Messages_Bool_Exp>>;
  _not?: InputMaybe<Grove_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Grove_Messages_Bool_Exp>>;
  agent?: InputMaybe<Grove_Agents_Bool_Exp>;
  chat?: InputMaybe<Grove_Chats_Bool_Exp>;
  chat_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_read?: InputMaybe<Boolean_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Grove_Messages_Max_Fields = {
  __typename?: 'grove_messages_max_fields';
  chat_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "grove.messages" */
export type Grove_Messages_Max_Order_By = {
  chat_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Grove_Messages_Min_Fields = {
  __typename?: 'grove_messages_min_fields';
  chat_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "grove.messages" */
export type Grove_Messages_Min_Order_By = {
  chat_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "grove.messages". */
export type Grove_Messages_Order_By = {
  agent?: InputMaybe<Grove_Agents_Order_By>;
  chat?: InputMaybe<Grove_Chats_Order_By>;
  chat_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_read?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** select columns of table "grove.messages" */
export enum Grove_Messages_Select_Column {
  /** column name */
  ChatId = 'chat_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsRead = 'is_read',
  /** column name */
  Role = 'role',
}

/** select "grove_messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "grove.messages" */
export enum Grove_Messages_Select_Column_Grove_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsRead = 'is_read',
}

/** select "grove_messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "grove.messages" */
export enum Grove_Messages_Select_Column_Grove_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsRead = 'is_read',
}

/** Streaming cursor of the table "grove_messages" */
export type Grove_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grove_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grove_Messages_Stream_Cursor_Value_Input = {
  chat_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export enum Integration_Auth_Names_Enum {
  ApiClient = 'api_client',
  ApiCredentials = 'api_credentials',
  ApiKey = 'api_key',
  ApiToken = 'api_token',
  App = 'app',
  AppManual = 'app_manual',
  AppOauthClientCredentials = 'app_oauth_client_credentials',
  AppPrivateKey = 'app_private_key',
  AppRegistrationClientSecret = 'app_registration_client_secret',
  AssumeRole = 'assume_role',
  OauthClient = 'oauth_client',
  Password = 'password',
  PersonalAccessToken = 'personal_access_token',
  SelfHostedOauthClient = 'self_hosted_oauth_client',
  ServiceAccountOauth = 'service_account_oauth',
  ServiceAccountPrivateKey = 'service_account_private_key',
}

/** Boolean expression to compare columns of type "integration_auth_names_enum". All fields are combined with logical 'AND'. */
export type Integration_Auth_Names_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Integration_Auth_Names_Enum>;
  _in?: InputMaybe<Array<Integration_Auth_Names_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Integration_Auth_Names_Enum>;
  _nin?: InputMaybe<Array<Integration_Auth_Names_Enum>>;
};

export enum Integration_Handler_Names_Enum {
  AccessKeyRotation = 'access_key_rotation',
  ActiveFirewall = 'active_firewall',
  ActivePipelines = 'active_pipelines',
  AlarmActionsActivated = 'alarm_actions_activated',
  AlarmActionsConfigured = 'alarm_actions_configured',
  AntiMalware = 'anti_malware',
  Backups = 'backups',
  BlockPublicAccess = 'block_public_access',
  BranchProtectionRules = 'branch_protection_rules',
  BranchProtectionRulesLogs = 'branch_protection_rules_logs',
  ConditionalAccessPolicyDefinition = 'conditional_access_policy_definition',
  CriticalVulnerabilities = 'critical_vulnerabilities',
  DeviceCompliancePolicyDefinition = 'device_compliance_policy_definition',
  Encryption = 'encryption',
  EndpointSecurityPolicyDefinition = 'endpoint_security_policy_definition',
  ExpiredServerCertificate = 'expired_server_certificate',
  ExternalAccessAnalyzer = 'external_access_analyzer',
  FileChanges = 'file_changes',
  FileSync = 'file_sync',
  FullDiskEncryption = 'full_disk_encryption',
  GuarddutyReport = 'guardduty_report',
  HighSeverityFindings = 'high_severity_findings',
  ImageScanningConfigured = 'image_scanning_configured',
  IssuesExport = 'issues_export',
  IssuesExportCsv = 'issues_export_csv',
  ListDeletionSchedules = 'list_deletion_schedules',
  ListIncidents = 'list_incidents',
  ListLogIndexes = 'list_log_indexes',
  ListMembers = 'list_members',
  ListMonitors = 'list_monitors',
  ListSecurityAlerts = 'list_security_alerts',
  ListTrainingCampaigns = 'list_training_campaigns',
  ListUsers = 'list_users',
  LogFileValidation = 'log_file_validation',
  LogGroupsRetention = 'log_groups_retention',
  LogMetricFilter = 'log_metric_filter',
  Logging = 'logging',
  LogsIntegration = 'logs_integration',
  MergedPullRequests = 'merged_pull_requests',
  MfaDelete = 'mfa_delete',
  MfaEnabledAllUsers = 'mfa_enabled_all_users',
  MfaEnabledConsoleAccess = 'mfa_enabled_console_access',
  MfaEnrollment = 'mfa_enrollment',
  MissingAgents = 'missing_agents',
  MultiAz = 'multi_az',
  MultiRegionTrail = 'multi_region_trail',
  NoAdminPrivileges = 'no_admin_privileges',
  NoCloudShellFullAccess = 'no_cloud_shell_full_access',
  NoPoliciesAttached = 'no_policies_attached',
  NoWildcardActionsForServices = 'no_wildcard_actions_for_services',
  ObjectLock = 'object_lock',
  OldestChange = 'oldest_change',
  PageExport = 'page_export',
  PasswordPolicyConfiguration = 'password_policy_configuration',
  PasswordRotation = 'password_rotation',
  PatchPolicy = 'patch_policy',
  PeriodicRotation = 'periodic_rotation',
  RemovableMedia = 'removable_media',
  Replication = 'replication',
  Require_2fa = 'require_2fa',
  RequireMfa = 'require_mfa',
  RequireSsl = 'require_ssl',
  RoleDetails = 'role_details',
  RoleMembership = 'role_membership',
  RoleMembershipLogs = 'role_membership_logs',
  RotationEnabled = 'rotation_enabled',
  RulesExport = 'rules_export',
  Ruleset = 'ruleset',
  ScreenLockTimer = 'screen_lock_timer',
  SecurityAlertNotifications = 'security_alert_notifications',
  SecurityGroupDetails = 'security_group_details',
  StatusReport = 'status_report',
  SuperUsers = 'super_users',
  SupportRole = 'support_role',
  TicketsExport = 'tickets_export',
  TlsSettingsExport = 'tls_settings_export',
  TrailEnabled = 'trail_enabled',
  TrailEncryption = 'trail_encryption',
  TrainingCampaignUserEnrollment = 'training_campaign_user_enrollment',
  UnusedCredentials = 'unused_credentials',
  UnusedSecrets = 'unused_secrets',
  Versioning = 'versioning',
  VulnerabilityScanning = 'vulnerability_scanning',
  VulnerabilityScanningStatus = 'vulnerability_scanning_status',
  WasVulnerabilityScanning = 'was_vulnerability_scanning',
  WebAclAssociation = 'web_acl_association',
  ZoneRedundant = 'zone_redundant',
}

/** Boolean expression to compare columns of type "integration_handler_names_enum". All fields are combined with logical 'AND'. */
export type Integration_Handler_Names_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Integration_Handler_Names_Enum>;
  _in?: InputMaybe<Array<Integration_Handler_Names_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Integration_Handler_Names_Enum>;
  _nin?: InputMaybe<Array<Integration_Handler_Names_Enum>>;
};

/** columns and relationships of "integration.managed_credentials" */
export type Integration_Managed_Credentials = {
  __typename?: 'integration_managed_credentials';
  issuing_connection_revision?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  organization_integration: Organization_Integrations;
  refresh_failure_code?: Maybe<Scalars['String']['output']>;
  retry_not_before?: Maybe<Scalars['timestamptz']['output']>;
  state: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "integration.managed_credentials". All fields are combined with a logical 'AND'. */
export type Integration_Managed_Credentials_Bool_Exp = {
  _and?: InputMaybe<Array<Integration_Managed_Credentials_Bool_Exp>>;
  _not?: InputMaybe<Integration_Managed_Credentials_Bool_Exp>;
  _or?: InputMaybe<Array<Integration_Managed_Credentials_Bool_Exp>>;
  issuing_connection_revision?: InputMaybe<Int_Comparison_Exp>;
  organization_integration?: InputMaybe<Organization_Integrations_Bool_Exp>;
  refresh_failure_code?: InputMaybe<String_Comparison_Exp>;
  retry_not_before?: InputMaybe<Timestamptz_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "integration.managed_credentials". */
export type Integration_Managed_Credentials_Order_By = {
  issuing_connection_revision?: InputMaybe<Order_By>;
  organization_integration?: InputMaybe<Organization_Integrations_Order_By>;
  refresh_failure_code?: InputMaybe<Order_By>;
  retry_not_before?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

export enum Integration_Names_Enum {
  Aws = 'aws',
  Azure = 'azure',
  Cloudflare = 'cloudflare',
  Confluence = 'confluence',
  Crowdstrike = 'crowdstrike',
  Datadog = 'datadog',
  Freshdesk = 'freshdesk',
  Freshservice = 'freshservice',
  Gcp = 'gcp',
  Github = 'github',
  Gitlab = 'gitlab',
  GoogleDrive = 'google_drive',
  Ironclad = 'ironclad',
  Jira = 'jira',
  Jumpcloud = 'jumpcloud',
  Knowbe4 = 'knowbe4',
  MicrosoftEntra = 'microsoft_entra',
  MicrosoftIntune = 'microsoft_intune',
  Mongodb = 'mongodb',
  Okta = 'okta',
  Onelogin = 'onelogin',
  Pagerduty = 'pagerduty',
  Qualys = 'qualys',
  Servicenow = 'servicenow',
  Sharepoint = 'sharepoint',
  Shortcut = 'shortcut',
  Veracode = 'veracode',
  Zendesk = 'zendesk',
}

/** Boolean expression to compare columns of type "integration_names_enum". All fields are combined with logical 'AND'. */
export type Integration_Names_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Integration_Names_Enum>;
  _in?: InputMaybe<Array<Integration_Names_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Integration_Names_Enum>;
  _nin?: InputMaybe<Array<Integration_Names_Enum>>;
};

export enum Integration_Run_Types_Enum {
  Ai = 'ai',
  Integration = 'integration',
}

/** Boolean expression to compare columns of type "integration_run_types_enum". All fields are combined with logical 'AND'. */
export type Integration_Run_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Integration_Run_Types_Enum>;
  _in?: InputMaybe<Array<Integration_Run_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Integration_Run_Types_Enum>;
  _nin?: InputMaybe<Array<Integration_Run_Types_Enum>>;
};

/** columns and relationships of "integration_runs" */
export type Integration_Runs = {
  __typename?: 'integration_runs';
  check_failure_message?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  control?: Maybe<Controls>;
  /** An object relationship */
  control_evidence?: Maybe<Control_Evidences>;
  control_evidence_id?: Maybe<Scalars['uuid']['output']>;
  control_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  evidence_integration?: Maybe<Evidence_Integrations>;
  evidence_integration_id?: Maybe<Scalars['uuid']['output']>;
  grove_run_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  type: Integration_Run_Types_Enum;
  verdict?: Maybe<Scalars['String']['output']>;
  verdict_summary?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "integration_runs" */
export type Integration_Runs_Aggregate = {
  __typename?: 'integration_runs_aggregate';
  aggregate?: Maybe<Integration_Runs_Aggregate_Fields>;
  nodes: Array<Integration_Runs>;
};

export type Integration_Runs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Integration_Runs_Aggregate_Bool_Exp_Count>;
};

export type Integration_Runs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Integration_Runs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Integration_Runs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "integration_runs" */
export type Integration_Runs_Aggregate_Fields = {
  __typename?: 'integration_runs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Integration_Runs_Max_Fields>;
  min?: Maybe<Integration_Runs_Min_Fields>;
};

/** aggregate fields of "integration_runs" */
export type Integration_Runs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Integration_Runs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "integration_runs" */
export type Integration_Runs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Integration_Runs_Max_Order_By>;
  min?: InputMaybe<Integration_Runs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "integration_runs". All fields are combined with a logical 'AND'. */
export type Integration_Runs_Bool_Exp = {
  _and?: InputMaybe<Array<Integration_Runs_Bool_Exp>>;
  _not?: InputMaybe<Integration_Runs_Bool_Exp>;
  _or?: InputMaybe<Array<Integration_Runs_Bool_Exp>>;
  check_failure_message?: InputMaybe<String_Comparison_Exp>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_evidence?: InputMaybe<Control_Evidences_Bool_Exp>;
  control_evidence_id?: InputMaybe<Uuid_Comparison_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  evidence_integration?: InputMaybe<Evidence_Integrations_Bool_Exp>;
  evidence_integration_id?: InputMaybe<Uuid_Comparison_Exp>;
  grove_run_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  instructions?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Integration_Run_Types_Enum_Comparison_Exp>;
  verdict?: InputMaybe<String_Comparison_Exp>;
  verdict_summary?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Integration_Runs_Max_Fields = {
  __typename?: 'integration_runs_max_fields';
  check_failure_message?: Maybe<Scalars['String']['output']>;
  control_evidence_id?: Maybe<Scalars['uuid']['output']>;
  control_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  evidence_integration_id?: Maybe<Scalars['uuid']['output']>;
  grove_run_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  verdict?: Maybe<Scalars['String']['output']>;
  verdict_summary?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "integration_runs" */
export type Integration_Runs_Max_Order_By = {
  check_failure_message?: InputMaybe<Order_By>;
  control_evidence_id?: InputMaybe<Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  evidence_integration_id?: InputMaybe<Order_By>;
  grove_run_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructions?: InputMaybe<Order_By>;
  verdict?: InputMaybe<Order_By>;
  verdict_summary?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Integration_Runs_Min_Fields = {
  __typename?: 'integration_runs_min_fields';
  check_failure_message?: Maybe<Scalars['String']['output']>;
  control_evidence_id?: Maybe<Scalars['uuid']['output']>;
  control_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  evidence_integration_id?: Maybe<Scalars['uuid']['output']>;
  grove_run_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  verdict?: Maybe<Scalars['String']['output']>;
  verdict_summary?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "integration_runs" */
export type Integration_Runs_Min_Order_By = {
  check_failure_message?: InputMaybe<Order_By>;
  control_evidence_id?: InputMaybe<Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  evidence_integration_id?: InputMaybe<Order_By>;
  grove_run_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructions?: InputMaybe<Order_By>;
  verdict?: InputMaybe<Order_By>;
  verdict_summary?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "integration_runs". */
export type Integration_Runs_Order_By = {
  check_failure_message?: InputMaybe<Order_By>;
  control?: InputMaybe<Controls_Order_By>;
  control_evidence?: InputMaybe<Control_Evidences_Order_By>;
  control_evidence_id?: InputMaybe<Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  evidence_integration?: InputMaybe<Evidence_Integrations_Order_By>;
  evidence_integration_id?: InputMaybe<Order_By>;
  grove_run_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructions?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  verdict?: InputMaybe<Order_By>;
  verdict_summary?: InputMaybe<Order_By>;
};

/** select columns of table "integration_runs" */
export enum Integration_Runs_Select_Column {
  /** column name */
  CheckFailureMessage = 'check_failure_message',
  /** column name */
  ControlEvidenceId = 'control_evidence_id',
  /** column name */
  ControlId = 'control_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  EvidenceIntegrationId = 'evidence_integration_id',
  /** column name */
  GroveRunId = 'grove_run_id',
  /** column name */
  Id = 'id',
  /** column name */
  Instructions = 'instructions',
  /** column name */
  Type = 'type',
  /** column name */
  Verdict = 'verdict',
  /** column name */
  VerdictSummary = 'verdict_summary',
}

export enum Integration_Service_Names_Enum {
  CloudSql = 'cloud_sql',
  Cloudflare = 'cloudflare',
  Cloudtrail = 'cloudtrail',
  Cloudwatch = 'cloudwatch',
  Confluence = 'confluence',
  Crowdstrike = 'crowdstrike',
  Datadog = 'datadog',
  Ec2 = 'ec2',
  Ecr = 'ecr',
  EntraId = 'entra_id',
  Freshdesk = 'freshdesk',
  Freshservice = 'freshservice',
  Github = 'github',
  Gitlab = 'gitlab',
  GoogleDrive = 'google_drive',
  Guardduty = 'guardduty',
  Iam = 'iam',
  Inspector = 'inspector',
  Jira = 'jira',
  Knowbe4 = 'knowbe4',
  Mdm = 'mdm',
  MicrosoftDefender = 'microsoft_defender',
  MicrosoftIntune = 'microsoft_intune',
  Mongodb = 'mongodb',
  Okta = 'okta',
  Onelogin = 'onelogin',
  Pagerduty = 'pagerduty',
  Qualys = 'qualys',
  Rds = 'rds',
  S3 = 's3',
  SecretsManager = 'secrets_manager',
  Servicenow = 'servicenow',
  Sharepoint = 'sharepoint',
  Sql = 'sql',
  Sts = 'sts',
  Veracode = 'veracode',
  Waf = 'waf',
  Zendesk = 'zendesk',
}

/** Boolean expression to compare columns of type "integration_service_names_enum". All fields are combined with logical 'AND'. */
export type Integration_Service_Names_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Integration_Service_Names_Enum>;
  _in?: InputMaybe<Array<Integration_Service_Names_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Integration_Service_Names_Enum>;
  _nin?: InputMaybe<Array<Integration_Service_Names_Enum>>;
};

/** columns and relationships of "integration_usage_stats_view" */
export type Integration_Usage_Stats_View = {
  __typename?: 'integration_usage_stats_view';
  controls_count?: Maybe<Scalars['bigint']['output']>;
  evidence_count?: Maybe<Scalars['bigint']['output']>;
  organization_integration_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "integration_usage_stats_view". All fields are combined with a logical 'AND'. */
export type Integration_Usage_Stats_View_Bool_Exp = {
  _and?: InputMaybe<Array<Integration_Usage_Stats_View_Bool_Exp>>;
  _not?: InputMaybe<Integration_Usage_Stats_View_Bool_Exp>;
  _or?: InputMaybe<Array<Integration_Usage_Stats_View_Bool_Exp>>;
  controls_count?: InputMaybe<Bigint_Comparison_Exp>;
  evidence_count?: InputMaybe<Bigint_Comparison_Exp>;
  organization_integration_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "integration_usage_stats_view". */
export type Integration_Usage_Stats_View_Order_By = {
  controls_count?: InputMaybe<Order_By>;
  evidence_count?: InputMaybe<Order_By>;
  organization_integration_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "integrations" */
export type Integrations = {
  __typename?: 'integrations';
  disabled: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  name: Integration_Names_Enum;
  /** An array relationship */
  organization_integrations: Array<Organization_Integrations>;
};

/** columns and relationships of "integrations" */
export type IntegrationsOrganization_IntegrationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Integrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Integrations_Order_By>>;
  where?: InputMaybe<Organization_Integrations_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "integrations". All fields are combined with a logical 'AND'. */
export type Integrations_Bool_Exp = {
  _and?: InputMaybe<Array<Integrations_Bool_Exp>>;
  _not?: InputMaybe<Integrations_Bool_Exp>;
  _or?: InputMaybe<Array<Integrations_Bool_Exp>>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<Integration_Names_Enum_Comparison_Exp>;
  organization_integrations?: InputMaybe<Organization_Integrations_Bool_Exp>;
};

/** Ordering options when selecting data from "integrations". */
export type Integrations_Order_By = {
  disabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_integrations_aggregate?: InputMaybe<Organization_Integrations_Aggregate_Order_By>;
};

/** select columns of table "integrations" */
export enum Integrations_Select_Column {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
}

/** Streaming cursor of the table "integrations" */
export type Integrations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Integrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Integrations_Stream_Cursor_Value_Input = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Integration_Names_Enum>;
};

/** columns and relationships of "invitations" */
export type Invitations = {
  __typename?: 'invitations';
  created_at: Scalars['timestamptz']['output'];
  email: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_joined: Scalars['Boolean']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  role: Roles;
  role_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "invitations" */
export type Invitations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invitations_Max_Order_By>;
  min?: InputMaybe<Invitations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "invitations" */
export type Invitations_Arr_Rel_Insert_Input = {
  data: Array<Invitations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invitations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "invitations". All fields are combined with a logical 'AND'. */
export type Invitations_Bool_Exp = {
  _and?: InputMaybe<Array<Invitations_Bool_Exp>>;
  _not?: InputMaybe<Invitations_Bool_Exp>;
  _or?: InputMaybe<Array<Invitations_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_joined?: InputMaybe<Boolean_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "invitations" */
export enum Invitations_Constraint {
  /** unique or primary key constraint on columns "id" */
  InvitationsPkey = 'invitations_pkey',
}

/** input type for inserting data into table "invitations" */
export type Invitations_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_joined?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "invitations" */
export type Invitations_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "invitations" */
export type Invitations_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invitations" */
export type Invitations_Mutation_Response = {
  __typename?: 'invitations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invitations>;
};

/** on_conflict condition type for table "invitations" */
export type Invitations_On_Conflict = {
  constraint: Invitations_Constraint;
  update_columns?: Array<Invitations_Update_Column>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};

/** Ordering options when selecting data from "invitations". */
export type Invitations_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_joined?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "invitations" */
export enum Invitations_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsJoined = 'is_joined',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
}

/** Streaming cursor of the table "invitations" */
export type Invitations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invitations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invitations_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_joined?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "invitations" (current role has no relevant permissions) */
export enum Invitations_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "manual_findings" */
export type Manual_Findings = {
  __typename?: 'manual_findings';
  /** An object relationship */
  control_finding?: Maybe<Control_Findings>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor_finding?: Maybe<Vendor_Findings>;
};

/** Boolean expression to filter rows from the table "manual_findings". All fields are combined with a logical 'AND'. */
export type Manual_Findings_Bool_Exp = {
  _and?: InputMaybe<Array<Manual_Findings_Bool_Exp>>;
  _not?: InputMaybe<Manual_Findings_Bool_Exp>;
  _or?: InputMaybe<Array<Manual_Findings_Bool_Exp>>;
  control_finding?: InputMaybe<Control_Findings_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor_finding?: InputMaybe<Vendor_Findings_Bool_Exp>;
};

/** response of any mutation on the table "manual_findings" */
export type Manual_Findings_Mutation_Response = {
  __typename?: 'manual_findings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Manual_Findings>;
};

/** Ordering options when selecting data from "manual_findings". */
export type Manual_Findings_Order_By = {
  control_finding?: InputMaybe<Control_Findings_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_finding?: InputMaybe<Vendor_Findings_Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  activate_trust_portal_nda_gate: TrustPortalNdaGateLifecycleOutput;
  /** Use AI to autocomplete an entity */
  ai_autocomplete_entity?: Maybe<AiAutocompleteEntityOutput>;
  /** Use AI to create a new entity */
  ai_create_entity?: Maybe<AiCreateEntityOutput>;
  bulk_set_select_field_values?: Maybe<GeneralActionOutput>;
  /** action to create multiple uploaded policies from files */
  bulk_upload_policies?: Maybe<BulkUploadPoliciesOutput>;
  command_findings: Array<FindingCommandOutput>;
  create_api_key?: Maybe<CreateApiKeyOutput>;
  /** This action is used to create custom control */
  create_control?: Maybe<CreateControlOutput>;
  create_custom_program_request?: Maybe<CreateCustomProgramRequestOutput>;
  create_finding: Array<FindingCommandOutput>;
  create_framework_request?: Maybe<FrameworkRequestOutput>;
  create_manual_finding?: Maybe<CreateManualFindingOutput>;
  create_manual_integration_connector?: Maybe<ManualIntegrationConnectorOutput>;
  /** Manually trigger the snapshot for a policy version whose file is sourced from an external integration. */
  create_policy_version_snapshot?: Maybe<CreatePolicyVersionSnapshotOutput>;
  create_program?: Maybe<ProgramOutput>;
  create_service_account?: Maybe<CreateServiceAccountOutput>;
  create_trust_portal_access_link?: Maybe<TrustPortalAccessLinkOutput>;
  /** Create the remediation task for a vendor finding, honoring the question's Task from finding settings */
  create_vendor_finding_task?: Maybe<CreateVendorFindingTaskOutput>;
  /** delete single row from the table: "auth.refresh_tokens" */
  deleteAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** delete data from the table: "auth.refresh_tokens" */
  deleteAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** delete data from the table: "categories" */
  delete_categories?: Maybe<Categories_Mutation_Response>;
  /** delete single row from the table: "categories" */
  delete_categories_by_pk?: Maybe<Categories>;
  /** delete data from the table: "client_questionnaires" */
  delete_client_questionnaires?: Maybe<Client_Questionnaires_Mutation_Response>;
  /** delete single row from the table: "client_questionnaires" */
  delete_client_questionnaires_by_pk?: Maybe<Client_Questionnaires>;
  /** delete data from the table: "comment_uploads" */
  delete_comment_uploads?: Maybe<Comment_Uploads_Mutation_Response>;
  /** delete single row from the table: "comment_uploads" */
  delete_comment_uploads_by_pk?: Maybe<Comment_Uploads>;
  /** delete data from the table: "comments" */
  delete_comments?: Maybe<Comments_Mutation_Response>;
  /** delete single row from the table: "comments" */
  delete_comments_by_pk?: Maybe<Comments>;
  /** delete data from the table: "control_ai_review_criteria" */
  delete_control_ai_review_criteria?: Maybe<Control_Ai_Review_Criteria_Mutation_Response>;
  /** delete single row from the table: "control_ai_review_criteria" */
  delete_control_ai_review_criteria_by_pk?: Maybe<Control_Ai_Review_Criteria>;
  /** delete data from the table: "control_categories" */
  delete_control_categories?: Maybe<Control_Categories_Mutation_Response>;
  /** delete single row from the table: "control_categories" */
  delete_control_categories_by_pk?: Maybe<Control_Categories>;
  /** delete data from the table: "control_criteria" */
  delete_control_criteria?: Maybe<Control_Criteria_Mutation_Response>;
  /** delete single row from the table: "control_criteria" */
  delete_control_criteria_by_pk?: Maybe<Control_Criteria>;
  /** delete data from the table: "control_evidences" */
  delete_control_evidences?: Maybe<Control_Evidences_Mutation_Response>;
  /** delete single row from the table: "control_evidences" */
  delete_control_evidences_by_pk?: Maybe<Control_Evidences>;
  /** delete data from the table: "control_groups" */
  delete_control_groups?: Maybe<Control_Groups_Mutation_Response>;
  /** delete single row from the table: "control_groups" */
  delete_control_groups_by_pk?: Maybe<Control_Groups>;
  /** delete data from the table: "control_owners" */
  delete_control_owners?: Maybe<Control_Owners_Mutation_Response>;
  /** delete single row from the table: "control_owners" */
  delete_control_owners_by_pk?: Maybe<Control_Owners>;
  /** delete data from the table: "control_tags" */
  delete_control_tags?: Maybe<Control_Tags_Mutation_Response>;
  /** delete single row from the table: "control_tags" */
  delete_control_tags_by_pk?: Maybe<Control_Tags>;
  /** delete data from the table: "control_tasks" */
  delete_control_tasks?: Maybe<Control_Tasks_Mutation_Response>;
  /** delete single row from the table: "control_tasks" */
  delete_control_tasks_by_pk?: Maybe<Control_Tasks>;
  /** delete data from the table: "controls" */
  delete_controls?: Maybe<Controls_Mutation_Response>;
  /** delete single row from the table: "controls" */
  delete_controls_by_pk?: Maybe<Controls>;
  /** delete data from the table: "criteria" */
  delete_criteria?: Maybe<Criteria_Mutation_Response>;
  /** delete single row from the table: "criteria" */
  delete_criteria_by_pk?: Maybe<Criteria>;
  /** delete data from the table: "entity_relations" */
  delete_entity_relations?: Maybe<Entity_Relations_Mutation_Response>;
  /** delete single row from the table: "entity_relations" */
  delete_entity_relations_by_pk?: Maybe<Entity_Relations>;
  /** delete data from the table: "evidence_integrations" */
  delete_evidence_integrations?: Maybe<Evidence_Integrations_Mutation_Response>;
  /** delete single row from the table: "evidence_integrations" */
  delete_evidence_integrations_by_pk?: Maybe<Evidence_Integrations>;
  /** delete data from the table: "evidence_owners" */
  delete_evidence_owners?: Maybe<Evidence_Owners_Mutation_Response>;
  /** delete single row from the table: "evidence_owners" */
  delete_evidence_owners_by_pk?: Maybe<Evidence_Owners>;
  /** delete data from the table: "evidence_policies" */
  delete_evidence_policies?: Maybe<Evidence_Policies_Mutation_Response>;
  /** delete single row from the table: "evidence_policies" */
  delete_evidence_policies_by_pk?: Maybe<Evidence_Policies>;
  /** delete data from the table: "evidence_tags" */
  delete_evidence_tags?: Maybe<Evidence_Tags_Mutation_Response>;
  /** delete single row from the table: "evidence_tags" */
  delete_evidence_tags_by_pk?: Maybe<Evidence_Tags>;
  /** delete data from the table: "evidence_tasks" */
  delete_evidence_tasks?: Maybe<Evidence_Tasks_Mutation_Response>;
  /** delete single row from the table: "evidence_tasks" */
  delete_evidence_tasks_by_pk?: Maybe<Evidence_Tasks>;
  /** delete data from the table: "evidence_version_file" */
  delete_evidence_version_file?: Maybe<Evidence_Version_File_Mutation_Response>;
  /** delete single row from the table: "evidence_version_file" */
  delete_evidence_version_file_by_pk?: Maybe<Evidence_Version_File>;
  /** delete data from the table: "evidence_versions" */
  delete_evidence_versions?: Maybe<Evidence_Versions_Mutation_Response>;
  /** delete single row from the table: "evidence_versions" */
  delete_evidence_versions_by_pk?: Maybe<Evidence_Versions>;
  /** delete data from the table: "evidences" */
  delete_evidences?: Maybe<Evidences_Mutation_Response>;
  /** delete single row from the table: "evidences" */
  delete_evidences_by_pk?: Maybe<Evidences>;
  /** delete data from the table: "field_configs" */
  delete_field_configs?: Maybe<Field_Configs_Mutation_Response>;
  /** delete single row from the table: "field_configs" */
  delete_field_configs_by_pk?: Maybe<Field_Configs>;
  /** delete data from the table: "field_values" */
  delete_field_values?: Maybe<Field_Values_Mutation_Response>;
  /** delete single row from the table: "field_values" */
  delete_field_values_by_pk?: Maybe<Field_Values>;
  /** delete data from the table: "finding_resolutions" */
  delete_finding_resolutions?: Maybe<Finding_Resolutions_Mutation_Response>;
  /** delete single row from the table: "finding_resolutions" */
  delete_finding_resolutions_by_pk?: Maybe<Finding_Resolutions>;
  /** delete data from the table: "forms" */
  delete_forms?: Maybe<Forms_Mutation_Response>;
  /** delete single row from the table: "forms" */
  delete_forms_by_pk?: Maybe<Forms>;
  /** delete data from the table: "groups" */
  delete_groups?: Maybe<Groups_Mutation_Response>;
  /** delete single row from the table: "groups" */
  delete_groups_by_pk?: Maybe<Groups>;
  /** delete data from the table: "invitations" */
  delete_invitations?: Maybe<Invitations_Mutation_Response>;
  /** delete single row from the table: "invitations" */
  delete_invitations_by_pk?: Maybe<Invitations>;
  /** delete data from the table: "manual_findings" */
  delete_manual_findings?: Maybe<Manual_Findings_Mutation_Response>;
  /** delete single row from the table: "manual_findings" */
  delete_manual_findings_by_pk?: Maybe<Manual_Findings>;
  /** delete data from the table: "notification_disabled_settings" */
  delete_notification_disabled_settings?: Maybe<Notification_Disabled_Settings_Mutation_Response>;
  /** delete single row from the table: "notification_disabled_settings" */
  delete_notification_disabled_settings_by_pk?: Maybe<Notification_Disabled_Settings>;
  /** delete data from the table: "organization_evidence_tags" */
  delete_organization_evidence_tags?: Maybe<Organization_Evidence_Tags_Mutation_Response>;
  /** delete single row from the table: "organization_evidence_tags" */
  delete_organization_evidence_tags_by_pk?: Maybe<Organization_Evidence_Tags>;
  /** delete data from the table: "organization_finding_severities" */
  delete_organization_finding_severities?: Maybe<Organization_Finding_Severities_Mutation_Response>;
  /** delete single row from the table: "organization_finding_severities" */
  delete_organization_finding_severities_by_pk?: Maybe<Organization_Finding_Severities>;
  /** delete data from the table: "organization_integrations" */
  delete_organization_integrations?: Maybe<Organization_Integrations_Mutation_Response>;
  /** delete single row from the table: "organization_integrations" */
  delete_organization_integrations_by_pk?: Maybe<Organization_Integrations>;
  /** delete data from the table: "organization_risk_categories" */
  delete_organization_risk_categories?: Maybe<Organization_Risk_Categories_Mutation_Response>;
  /** delete single row from the table: "organization_risk_categories" */
  delete_organization_risk_categories_by_pk?: Maybe<Organization_Risk_Categories>;
  /** delete data from the table: "organization_risk_levels" */
  delete_organization_risk_levels?: Maybe<Organization_Risk_Levels_Mutation_Response>;
  /** delete single row from the table: "organization_risk_levels" */
  delete_organization_risk_levels_by_pk?: Maybe<Organization_Risk_Levels>;
  /** delete data from the table: "organization_risk_tags" */
  delete_organization_risk_tags?: Maybe<Organization_Risk_Tags_Mutation_Response>;
  /** delete single row from the table: "organization_risk_tags" */
  delete_organization_risk_tags_by_pk?: Maybe<Organization_Risk_Tags>;
  /** delete data from the table: "organization_vendor_risk_levels" */
  delete_organization_vendor_risk_levels?: Maybe<Organization_Vendor_Risk_Levels_Mutation_Response>;
  /** delete single row from the table: "organization_vendor_risk_levels" */
  delete_organization_vendor_risk_levels_by_pk?: Maybe<Organization_Vendor_Risk_Levels>;
  /** delete data from the table: "organization_vendor_tiers" */
  delete_organization_vendor_tiers?: Maybe<Organization_Vendor_Tiers_Mutation_Response>;
  /** delete single row from the table: "organization_vendor_tiers" */
  delete_organization_vendor_tiers_by_pk?: Maybe<Organization_Vendor_Tiers>;
  /** delete data from the table: "policies" */
  delete_policies?: Maybe<Policies_Mutation_Response>;
  /** delete single row from the table: "policies" */
  delete_policies_by_pk?: Maybe<Policies>;
  /** delete data from the table: "policy_acknowledgement_users" */
  delete_policy_acknowledgement_users?: Maybe<Policy_Acknowledgement_Users_Mutation_Response>;
  /** delete single row from the table: "policy_acknowledgement_users" */
  delete_policy_acknowledgement_users_by_pk?: Maybe<Policy_Acknowledgement_Users>;
  /** delete data from the table: "policy_acknowledgements" */
  delete_policy_acknowledgements?: Maybe<Policy_Acknowledgements_Mutation_Response>;
  /** delete single row from the table: "policy_acknowledgements" */
  delete_policy_acknowledgements_by_pk?: Maybe<Policy_Acknowledgements>;
  /** delete data from the table: "policy_approval_users" */
  delete_policy_approval_users?: Maybe<Policy_Approval_Users_Mutation_Response>;
  /** delete single row from the table: "policy_approval_users" */
  delete_policy_approval_users_by_pk?: Maybe<Policy_Approval_Users>;
  /** delete data from the table: "policy_approvals" */
  delete_policy_approvals?: Maybe<Policy_Approvals_Mutation_Response>;
  /** delete single row from the table: "policy_approvals" */
  delete_policy_approvals_by_pk?: Maybe<Policy_Approvals>;
  /** delete data from the table: "policy_approvers" */
  delete_policy_approvers?: Maybe<Policy_Approvers_Mutation_Response>;
  /** delete single row from the table: "policy_approvers" */
  delete_policy_approvers_by_pk?: Maybe<Policy_Approvers>;
  /** delete data from the table: "policy_exception_approvers" */
  delete_policy_exception_approvers?: Maybe<Policy_Exception_Approvers_Mutation_Response>;
  /** delete single row from the table: "policy_exception_approvers" */
  delete_policy_exception_approvers_by_pk?: Maybe<Policy_Exception_Approvers>;
  /** delete data from the table: "policy_exception_files" */
  delete_policy_exception_files?: Maybe<Policy_Exception_Files_Mutation_Response>;
  /** delete single row from the table: "policy_exception_files" */
  delete_policy_exception_files_by_pk?: Maybe<Policy_Exception_Files>;
  /** delete data from the table: "policy_exceptions" */
  delete_policy_exceptions?: Maybe<Policy_Exceptions_Mutation_Response>;
  /** delete single row from the table: "policy_exceptions" */
  delete_policy_exceptions_by_pk?: Maybe<Policy_Exceptions>;
  /** delete data from the table: "policy_integrations" */
  delete_policy_integrations?: Maybe<Policy_Integrations_Mutation_Response>;
  /** delete single row from the table: "policy_integrations" */
  delete_policy_integrations_by_pk?: Maybe<Policy_Integrations>;
  /** delete data from the table: "policy_owners" */
  delete_policy_owners?: Maybe<Policy_Owners_Mutation_Response>;
  /** delete single row from the table: "policy_owners" */
  delete_policy_owners_by_pk?: Maybe<Policy_Owners>;
  /** delete data from the table: "policy_tasks" */
  delete_policy_tasks?: Maybe<Policy_Tasks_Mutation_Response>;
  /** delete single row from the table: "policy_tasks" */
  delete_policy_tasks_by_pk?: Maybe<Policy_Tasks>;
  /** delete data from the table: "policy_versions" */
  delete_policy_versions?: Maybe<Policy_Versions_Mutation_Response>;
  /** delete single row from the table: "policy_versions" */
  delete_policy_versions_by_pk?: Maybe<Policy_Versions>;
  /** delete data from the table: "program_assignees" */
  delete_program_assignees?: Maybe<Program_Assignees_Mutation_Response>;
  /** delete data from the table: "program_controls" */
  delete_program_controls?: Maybe<Program_Controls_Mutation_Response>;
  /** delete single row from the table: "program_controls" */
  delete_program_controls_by_pk?: Maybe<Program_Controls>;
  /** delete data from the table: "program_field_configs" */
  delete_program_field_configs?: Maybe<Program_Field_Configs_Mutation_Response>;
  /** delete single row from the table: "program_field_configs" */
  delete_program_field_configs_by_pk?: Maybe<Program_Field_Configs>;
  /** delete data from the table: "programs" */
  delete_programs?: Maybe<Programs_Mutation_Response>;
  /** delete single row from the table: "programs" */
  delete_programs_by_pk?: Maybe<Programs>;
  /** delete data from the table: "questionnaire_uploads" */
  delete_questionnaire_uploads?: Maybe<Questionnaire_Uploads_Mutation_Response>;
  /** delete single row from the table: "questionnaire_uploads" */
  delete_questionnaire_uploads_by_pk?: Maybe<Questionnaire_Uploads>;
  /** delete data from the table: "questionnaires" */
  delete_questionnaires?: Maybe<Questionnaires_Mutation_Response>;
  /** delete single row from the table: "questionnaires" */
  delete_questionnaires_by_pk?: Maybe<Questionnaires>;
  /** delete data from the table: "reports" */
  delete_reports?: Maybe<Reports_Mutation_Response>;
  /** delete single row from the table: "reports" */
  delete_reports_by_pk?: Maybe<Reports>;
  /** delete data from the table: "review_files" */
  delete_review_files?: Maybe<Review_Files_Mutation_Response>;
  /** delete single row from the table: "review_files" */
  delete_review_files_by_pk?: Maybe<Review_Files>;
  /** delete data from the table: "reviews" */
  delete_reviews?: Maybe<Reviews_Mutation_Response>;
  /** delete single row from the table: "reviews" */
  delete_reviews_by_pk?: Maybe<Reviews>;
  /** delete data from the table: "risk_approval_files" */
  delete_risk_approval_files?: Maybe<Risk_Approval_Files_Mutation_Response>;
  /** delete single row from the table: "risk_approval_files" */
  delete_risk_approval_files_by_pk?: Maybe<Risk_Approval_Files>;
  /** delete data from the table: "risk_approval_reason_entries" */
  delete_risk_approval_reason_entries?: Maybe<Risk_Approval_Reason_Entries_Mutation_Response>;
  /** delete single row from the table: "risk_approval_reason_entries" */
  delete_risk_approval_reason_entries_by_pk?: Maybe<Risk_Approval_Reason_Entries>;
  /** delete data from the table: "risk_approvals" */
  delete_risk_approvals?: Maybe<Risk_Approvals_Mutation_Response>;
  /** delete single row from the table: "risk_approvals" */
  delete_risk_approvals_by_pk?: Maybe<Risk_Approvals>;
  /** delete data from the table: "risk_approvers" */
  delete_risk_approvers?: Maybe<Risk_Approvers_Mutation_Response>;
  /** delete single row from the table: "risk_approvers" */
  delete_risk_approvers_by_pk?: Maybe<Risk_Approvers>;
  /** delete data from the table: "risk_categories" */
  delete_risk_categories?: Maybe<Risk_Categories_Mutation_Response>;
  /** delete single row from the table: "risk_categories" */
  delete_risk_categories_by_pk?: Maybe<Risk_Categories>;
  /** delete data from the table: "risk_controls" */
  delete_risk_controls?: Maybe<Risk_Controls_Mutation_Response>;
  /** delete single row from the table: "risk_controls" */
  delete_risk_controls_by_pk?: Maybe<Risk_Controls>;
  /** delete data from the table: "risk_documents" */
  delete_risk_documents?: Maybe<Risk_Documents_Mutation_Response>;
  /** delete single row from the table: "risk_documents" */
  delete_risk_documents_by_pk?: Maybe<Risk_Documents>;
  /** delete data from the table: "risk_impacts" */
  delete_risk_impacts?: Maybe<Risk_Impacts_Mutation_Response>;
  /** delete single row from the table: "risk_impacts" */
  delete_risk_impacts_by_pk?: Maybe<Risk_Impacts>;
  /** delete data from the table: "risk_likelihoods" */
  delete_risk_likelihoods?: Maybe<Risk_Likelihoods_Mutation_Response>;
  /** delete single row from the table: "risk_likelihoods" */
  delete_risk_likelihoods_by_pk?: Maybe<Risk_Likelihoods>;
  /** delete data from the table: "risk_owners" */
  delete_risk_owners?: Maybe<Risk_Owners_Mutation_Response>;
  /** delete single row from the table: "risk_owners" */
  delete_risk_owners_by_pk?: Maybe<Risk_Owners>;
  /** delete data from the table: "risk_tags" */
  delete_risk_tags?: Maybe<Risk_Tags_Mutation_Response>;
  /** delete single row from the table: "risk_tags" */
  delete_risk_tags_by_pk?: Maybe<Risk_Tags>;
  /** delete data from the table: "risk_tasks" */
  delete_risk_tasks?: Maybe<Risk_Tasks_Mutation_Response>;
  /** delete single row from the table: "risk_tasks" */
  delete_risk_tasks_by_pk?: Maybe<Risk_Tasks>;
  /** delete data from the table: "risks" */
  delete_risks?: Maybe<Risks_Mutation_Response>;
  /** delete single row from the table: "risks" */
  delete_risks_by_pk?: Maybe<Risks>;
  /** delete data from the table: "role_permissions" */
  delete_role_permissions?: Maybe<Role_Permissions_Mutation_Response>;
  /** delete single row from the table: "role_permissions" */
  delete_role_permissions_by_pk?: Maybe<Role_Permissions>;
  /** delete data from the table: "roles" */
  delete_roles?: Maybe<Roles_Mutation_Response>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: Maybe<Roles>;
  /** delete data from the table: "select_field_options" */
  delete_select_field_options?: Maybe<Select_Field_Options_Mutation_Response>;
  /** delete single row from the table: "select_field_options" */
  delete_select_field_options_by_pk?: Maybe<Select_Field_Options>;
  delete_service_account?: Maybe<DeleteServiceAccountOutput>;
  /** delete data from the table: "tags" */
  delete_tags?: Maybe<Tags_Mutation_Response>;
  /** delete single row from the table: "tags" */
  delete_tags_by_pk?: Maybe<Tags>;
  /** delete data from the table: "task_owners" */
  delete_task_owners?: Maybe<Task_Owners_Mutation_Response>;
  /** delete single row from the table: "task_owners" */
  delete_task_owners_by_pk?: Maybe<Task_Owners>;
  /** delete data from the table: "tasks" */
  delete_tasks?: Maybe<Tasks_Mutation_Response>;
  /** delete single row from the table: "tasks" */
  delete_tasks_by_pk?: Maybe<Tasks>;
  /** delete data from the table: "team_members" */
  delete_team_members?: Maybe<Team_Members_Mutation_Response>;
  /** delete single row from the table: "team_members" */
  delete_team_members_by_pk?: Maybe<Team_Members>;
  /** delete data from the table: "teams" */
  delete_teams?: Maybe<Teams_Mutation_Response>;
  /** delete single row from the table: "teams" */
  delete_teams_by_pk?: Maybe<Teams>;
  /** delete data from the table: "trust_portal.document_resource_sections" */
  delete_trust_portal_document_resource_sections?: Maybe<Trust_Portal_Document_Resource_Sections_Mutation_Response>;
  /** delete single row from the table: "trust_portal.document_resource_sections" */
  delete_trust_portal_document_resource_sections_by_pk?: Maybe<Trust_Portal_Document_Resource_Sections>;
  /** delete data from the table: "trust_portal.documents" */
  delete_trust_portal_documents?: Maybe<Trust_Portal_Documents_Mutation_Response>;
  /** delete single row from the table: "trust_portal.documents" */
  delete_trust_portal_documents_by_pk?: Maybe<Trust_Portal_Documents>;
  /** delete data from the table: "trust_portal.faqs" */
  delete_trust_portal_faqs?: Maybe<Trust_Portal_Faqs_Mutation_Response>;
  /** delete single row from the table: "trust_portal.faqs" */
  delete_trust_portal_faqs_by_pk?: Maybe<Trust_Portal_Faqs>;
  /** delete data from the table: "trust_portal.frameworks" */
  delete_trust_portal_frameworks?: Maybe<Trust_Portal_Frameworks_Mutation_Response>;
  /** delete single row from the table: "trust_portal.frameworks" */
  delete_trust_portal_frameworks_by_pk?: Maybe<Trust_Portal_Frameworks>;
  /** delete data from the table: "trust_portal.resource_sections" */
  delete_trust_portal_resource_sections?: Maybe<Trust_Portal_Resource_Sections_Mutation_Response>;
  /** delete single row from the table: "trust_portal.resource_sections" */
  delete_trust_portal_resource_sections_by_pk?: Maybe<Trust_Portal_Resource_Sections>;
  /** delete data from the table: "trust_portal.update_categories" */
  delete_trust_portal_update_categories?: Maybe<Trust_Portal_Update_Categories_Mutation_Response>;
  /** delete single row from the table: "trust_portal.update_categories" */
  delete_trust_portal_update_categories_by_pk?: Maybe<Trust_Portal_Update_Categories>;
  /** delete data from the table: "trust_portal.updates" */
  delete_trust_portal_updates?: Maybe<Trust_Portal_Updates_Mutation_Response>;
  /** delete single row from the table: "trust_portal.updates" */
  delete_trust_portal_updates_by_pk?: Maybe<Trust_Portal_Updates>;
  /** delete data from the table: "vendor_approval_files" */
  delete_vendor_approval_files?: Maybe<Vendor_Approval_Files_Mutation_Response>;
  /** delete single row from the table: "vendor_approval_files" */
  delete_vendor_approval_files_by_pk?: Maybe<Vendor_Approval_Files>;
  /** delete data from the table: "vendor_approvals" */
  delete_vendor_approvals?: Maybe<Vendor_Approvals_Mutation_Response>;
  /** delete single row from the table: "vendor_approvals" */
  delete_vendor_approvals_by_pk?: Maybe<Vendor_Approvals>;
  /** delete data from the table: "vendor_approvers" */
  delete_vendor_approvers?: Maybe<Vendor_Approvers_Mutation_Response>;
  /** delete single row from the table: "vendor_approvers" */
  delete_vendor_approvers_by_pk?: Maybe<Vendor_Approvers>;
  /** delete data from the table: "vendor_documents" */
  delete_vendor_documents?: Maybe<Vendor_Documents_Mutation_Response>;
  /** delete single row from the table: "vendor_documents" */
  delete_vendor_documents_by_pk?: Maybe<Vendor_Documents>;
  /** delete data from the table: "vendor_owners" */
  delete_vendor_owners?: Maybe<Vendor_Owners_Mutation_Response>;
  /** delete single row from the table: "vendor_owners" */
  delete_vendor_owners_by_pk?: Maybe<Vendor_Owners>;
  /** delete data from the table: "vendor_questionnaire_forms" */
  delete_vendor_questionnaire_forms?: Maybe<Vendor_Questionnaire_Forms_Mutation_Response>;
  /** delete single row from the table: "vendor_questionnaire_forms" */
  delete_vendor_questionnaire_forms_by_pk?: Maybe<Vendor_Questionnaire_Forms>;
  /** delete data from the table: "vendor_questionnaire_schedules" */
  delete_vendor_questionnaire_schedules?: Maybe<Vendor_Questionnaire_Schedules_Mutation_Response>;
  /** delete single row from the table: "vendor_questionnaire_schedules" */
  delete_vendor_questionnaire_schedules_by_pk?: Maybe<Vendor_Questionnaire_Schedules>;
  /** delete data from the table: "vendor_questionnaire_uploads" */
  delete_vendor_questionnaire_uploads?: Maybe<Vendor_Questionnaire_Uploads_Mutation_Response>;
  /** delete single row from the table: "vendor_questionnaire_uploads" */
  delete_vendor_questionnaire_uploads_by_pk?: Maybe<Vendor_Questionnaire_Uploads>;
  /** delete data from the table: "vendor_questionnaires" */
  delete_vendor_questionnaires?: Maybe<Vendor_Questionnaires_Mutation_Response>;
  /** delete single row from the table: "vendor_questionnaires" */
  delete_vendor_questionnaires_by_pk?: Maybe<Vendor_Questionnaires>;
  /** delete data from the table: "vendor_risks" */
  delete_vendor_risks?: Maybe<Vendor_Risks_Mutation_Response>;
  /** delete single row from the table: "vendor_risks" */
  delete_vendor_risks_by_pk?: Maybe<Vendor_Risks>;
  /** delete data from the table: "vendor_tasks" */
  delete_vendor_tasks?: Maybe<Vendor_Tasks_Mutation_Response>;
  /** delete single row from the table: "vendor_tasks" */
  delete_vendor_tasks_by_pk?: Maybe<Vendor_Tasks>;
  /** delete data from the table: "vendors" */
  delete_vendors?: Maybe<Vendors_Mutation_Response>;
  /** delete single row from the table: "vendors" */
  delete_vendors_by_pk?: Maybe<Vendors>;
  /** delete data from the table: "vq_custom_fields" */
  delete_vq_custom_fields?: Maybe<Vq_Custom_Fields_Mutation_Response>;
  /** delete single row from the table: "vq_custom_fields" */
  delete_vq_custom_fields_by_pk?: Maybe<Vq_Custom_Fields>;
  deny_trust_portal_access: TrustPortalAccessDecisionOutput;
  disconnect_integration?: Maybe<GeneralActionOutput>;
  disconnect_mcp_connection?: Maybe<DisconnectMcpConnectionOutput>;
  disconnect_trust_portal_nda_gate: TrustPortalNdaGateDisconnectOutput;
  /** action to duplicate multiple controls */
  duplicate_controls?: Maybe<DuplicateControlsOutput>;
  /** action to duplicate multiple evidences */
  duplicate_evidences?: Maybe<DuplicateEvidencesOutput>;
  /** action to duplicate multiple policies */
  duplicate_policies?: Maybe<DuplicatePoliciesOutput>;
  /** action to duplicate a program */
  duplicate_program?: Maybe<ProgramOutput>;
  /** action to duplicate multiple questionnaires */
  duplicate_questionnaires?: Maybe<DuplicateQuestionnairesOutput>;
  /** action to duplicate multiple risks */
  duplicate_risks?: Maybe<DuplicateRisksOutput>;
  /** action to duplicate a task */
  duplicate_task?: Maybe<DuplicateTaskOutput>;
  /** action to duplicate multiple tasks */
  duplicate_tasks?: Maybe<DuplicateTasksOutput>;
  /** action to duplicate multiple vendors */
  duplicate_vendors?: Maybe<DuplicateVendorsOutput>;
  edit_findings: Array<FindingCommandOutput>;
  /** Trigger export of the Client Questionnaire */
  export_client_questionnaire?: Maybe<ExportClientQuestionnaireOutput>;
  export_policy?: Maybe<ExportPolicyOutput>;
  export_policy_version?: Maybe<ExportPolicyOutput>;
  export_vendor?: Maybe<ExportVendorOutput>;
  gen_integration_run_report?: Maybe<GenIntegrationRunReportOutput>;
  /** Generate a vendor portal link with a scoped PAT */
  generate_vendor_questionnaire_link?: Maybe<GenerateVendorQuestionnaireLinkOutput>;
  /** This action is used to generate admin link to manage audit trail in workos */
  generate_workos_admin_link?: Maybe<GenerateWorkosAdminLinkOutput>;
  grant_evidence_access?: Maybe<GrantEvidenceAccessOutput>;
  grant_trust_portal_access: TrustPortalAccessDecisionOutput;
  /** insert a single row into the table: "storage.files" */
  insertFile?: Maybe<Files>;
  /** insert data into the table: "storage.files" */
  insertFiles?: Maybe<Files_Mutation_Response>;
  /** insert data into the table: "agent_instances" */
  insert_agent_instances?: Maybe<Agent_Instances_Mutation_Response>;
  /** insert a single row into the table: "agent_instances" */
  insert_agent_instances_one?: Maybe<Agent_Instances>;
  /** insert data into the table: "categories" */
  insert_categories?: Maybe<Categories_Mutation_Response>;
  /** insert a single row into the table: "categories" */
  insert_categories_one?: Maybe<Categories>;
  /** insert data into the table: "client_questionnaire_answers" */
  insert_client_questionnaire_answers?: Maybe<Client_Questionnaire_Answers_Mutation_Response>;
  /** insert a single row into the table: "client_questionnaire_answers" */
  insert_client_questionnaire_answers_one?: Maybe<Client_Questionnaire_Answers>;
  /** insert data into the table: "client_questionnaires" */
  insert_client_questionnaires?: Maybe<Client_Questionnaires_Mutation_Response>;
  /** insert a single row into the table: "client_questionnaires" */
  insert_client_questionnaires_one?: Maybe<Client_Questionnaires>;
  /** insert data into the table: "comment_uploads" */
  insert_comment_uploads?: Maybe<Comment_Uploads_Mutation_Response>;
  /** insert a single row into the table: "comment_uploads" */
  insert_comment_uploads_one?: Maybe<Comment_Uploads>;
  /** insert data into the table: "comments" */
  insert_comments?: Maybe<Comments_Mutation_Response>;
  /** insert a single row into the table: "comments" */
  insert_comments_one?: Maybe<Comments>;
  /** insert data into the table: "control_ai_review_criteria" */
  insert_control_ai_review_criteria?: Maybe<Control_Ai_Review_Criteria_Mutation_Response>;
  /** insert a single row into the table: "control_ai_review_criteria" */
  insert_control_ai_review_criteria_one?: Maybe<Control_Ai_Review_Criteria>;
  /** insert data into the table: "control_categories" */
  insert_control_categories?: Maybe<Control_Categories_Mutation_Response>;
  /** insert a single row into the table: "control_categories" */
  insert_control_categories_one?: Maybe<Control_Categories>;
  /** insert data into the table: "control_criteria" */
  insert_control_criteria?: Maybe<Control_Criteria_Mutation_Response>;
  /** insert a single row into the table: "control_criteria" */
  insert_control_criteria_one?: Maybe<Control_Criteria>;
  /** insert data into the table: "control_evidences" */
  insert_control_evidences?: Maybe<Control_Evidences_Mutation_Response>;
  /** insert a single row into the table: "control_evidences" */
  insert_control_evidences_one?: Maybe<Control_Evidences>;
  /** insert data into the table: "control_groups" */
  insert_control_groups?: Maybe<Control_Groups_Mutation_Response>;
  /** insert a single row into the table: "control_groups" */
  insert_control_groups_one?: Maybe<Control_Groups>;
  /** insert data into the table: "control_owners" */
  insert_control_owners?: Maybe<Control_Owners_Mutation_Response>;
  /** insert a single row into the table: "control_owners" */
  insert_control_owners_one?: Maybe<Control_Owners>;
  /** insert data into the table: "control_tags" */
  insert_control_tags?: Maybe<Control_Tags_Mutation_Response>;
  /** insert a single row into the table: "control_tags" */
  insert_control_tags_one?: Maybe<Control_Tags>;
  /** insert data into the table: "control_tasks" */
  insert_control_tasks?: Maybe<Control_Tasks_Mutation_Response>;
  /** insert a single row into the table: "control_tasks" */
  insert_control_tasks_one?: Maybe<Control_Tasks>;
  /** insert data into the table: "controls" */
  insert_controls?: Maybe<Controls_Mutation_Response>;
  /** insert a single row into the table: "controls" */
  insert_controls_one?: Maybe<Controls>;
  /** insert data into the table: "criteria" */
  insert_criteria?: Maybe<Criteria_Mutation_Response>;
  /** insert a single row into the table: "criteria" */
  insert_criteria_one?: Maybe<Criteria>;
  /** insert data into the table: "date_field_values" */
  insert_date_field_values?: Maybe<Date_Field_Values_Mutation_Response>;
  /** insert a single row into the table: "date_field_values" */
  insert_date_field_values_one?: Maybe<Date_Field_Values>;
  /** insert data into the table: "documents" */
  insert_documents?: Maybe<Documents_Mutation_Response>;
  /** insert a single row into the table: "documents" */
  insert_documents_one?: Maybe<Documents>;
  /** insert data into the table: "email_field_values" */
  insert_email_field_values?: Maybe<Email_Field_Values_Mutation_Response>;
  /** insert a single row into the table: "email_field_values" */
  insert_email_field_values_one?: Maybe<Email_Field_Values>;
  /** insert data into the table: "entity_relations" */
  insert_entity_relations?: Maybe<Entity_Relations_Mutation_Response>;
  /** insert a single row into the table: "entity_relations" */
  insert_entity_relations_one?: Maybe<Entity_Relations>;
  /** insert data into the table: "evidence_integrations" */
  insert_evidence_integrations?: Maybe<Evidence_Integrations_Mutation_Response>;
  /** insert a single row into the table: "evidence_integrations" */
  insert_evidence_integrations_one?: Maybe<Evidence_Integrations>;
  /** insert data into the table: "evidence_owners" */
  insert_evidence_owners?: Maybe<Evidence_Owners_Mutation_Response>;
  /** insert a single row into the table: "evidence_owners" */
  insert_evidence_owners_one?: Maybe<Evidence_Owners>;
  /** insert data into the table: "evidence_policies" */
  insert_evidence_policies?: Maybe<Evidence_Policies_Mutation_Response>;
  /** insert a single row into the table: "evidence_policies" */
  insert_evidence_policies_one?: Maybe<Evidence_Policies>;
  /** insert data into the table: "evidence_tags" */
  insert_evidence_tags?: Maybe<Evidence_Tags_Mutation_Response>;
  /** insert a single row into the table: "evidence_tags" */
  insert_evidence_tags_one?: Maybe<Evidence_Tags>;
  /** insert data into the table: "evidence_tasks" */
  insert_evidence_tasks?: Maybe<Evidence_Tasks_Mutation_Response>;
  /** insert a single row into the table: "evidence_tasks" */
  insert_evidence_tasks_one?: Maybe<Evidence_Tasks>;
  /** insert data into the table: "evidence_version_file" */
  insert_evidence_version_file?: Maybe<Evidence_Version_File_Mutation_Response>;
  /** insert a single row into the table: "evidence_version_file" */
  insert_evidence_version_file_one?: Maybe<Evidence_Version_File>;
  /** insert data into the table: "evidence_versions" */
  insert_evidence_versions?: Maybe<Evidence_Versions_Mutation_Response>;
  /** insert a single row into the table: "evidence_versions" */
  insert_evidence_versions_one?: Maybe<Evidence_Versions>;
  /** insert data into the table: "evidences" */
  insert_evidences?: Maybe<Evidences_Mutation_Response>;
  /** insert a single row into the table: "evidences" */
  insert_evidences_one?: Maybe<Evidences>;
  /** insert data into the table: "field_configs" */
  insert_field_configs?: Maybe<Field_Configs_Mutation_Response>;
  /** insert a single row into the table: "field_configs" */
  insert_field_configs_one?: Maybe<Field_Configs>;
  /** insert data into the table: "field_values" */
  insert_field_values?: Maybe<Field_Values_Mutation_Response>;
  /** insert a single row into the table: "field_values" */
  insert_field_values_one?: Maybe<Field_Values>;
  /** insert data into the table: "finding_resolutions" */
  insert_finding_resolutions?: Maybe<Finding_Resolutions_Mutation_Response>;
  /** insert a single row into the table: "finding_resolutions" */
  insert_finding_resolutions_one?: Maybe<Finding_Resolutions>;
  /** insert data into the table: "forms" */
  insert_forms?: Maybe<Forms_Mutation_Response>;
  /** insert a single row into the table: "forms" */
  insert_forms_one?: Maybe<Forms>;
  /** insert data into the table: "frameworks" */
  insert_frameworks?: Maybe<Frameworks_Mutation_Response>;
  /** insert data into the table: "frameworks_controls" */
  insert_frameworks_controls?: Maybe<Frameworks_Controls_Mutation_Response>;
  /** insert a single row into the table: "frameworks_controls" */
  insert_frameworks_controls_one?: Maybe<Frameworks_Controls>;
  /** insert a single row into the table: "frameworks" */
  insert_frameworks_one?: Maybe<Frameworks>;
  /** insert data into the table: "groups" */
  insert_groups?: Maybe<Groups_Mutation_Response>;
  /** insert a single row into the table: "groups" */
  insert_groups_one?: Maybe<Groups>;
  /** insert data into the table: "invitations" */
  insert_invitations?: Maybe<Invitations_Mutation_Response>;
  /** insert a single row into the table: "invitations" */
  insert_invitations_one?: Maybe<Invitations>;
  /** insert data into the table: "notification_disabled_settings" */
  insert_notification_disabled_settings?: Maybe<Notification_Disabled_Settings_Mutation_Response>;
  /** insert a single row into the table: "notification_disabled_settings" */
  insert_notification_disabled_settings_one?: Maybe<Notification_Disabled_Settings>;
  /** insert data into the table: "number_field_values" */
  insert_number_field_values?: Maybe<Number_Field_Values_Mutation_Response>;
  /** insert a single row into the table: "number_field_values" */
  insert_number_field_values_one?: Maybe<Number_Field_Values>;
  /** insert data into the table: "organization_evidence_tags" */
  insert_organization_evidence_tags?: Maybe<Organization_Evidence_Tags_Mutation_Response>;
  /** insert a single row into the table: "organization_evidence_tags" */
  insert_organization_evidence_tags_one?: Maybe<Organization_Evidence_Tags>;
  /** insert data into the table: "organization_finding_severities" */
  insert_organization_finding_severities?: Maybe<Organization_Finding_Severities_Mutation_Response>;
  /** insert a single row into the table: "organization_finding_severities" */
  insert_organization_finding_severities_one?: Maybe<Organization_Finding_Severities>;
  /** insert data into the table: "organization_profiles" */
  insert_organization_profiles?: Maybe<Organization_Profiles_Mutation_Response>;
  /** insert a single row into the table: "organization_profiles" */
  insert_organization_profiles_one?: Maybe<Organization_Profiles>;
  /** insert data into the table: "organization_risk_categories" */
  insert_organization_risk_categories?: Maybe<Organization_Risk_Categories_Mutation_Response>;
  /** insert a single row into the table: "organization_risk_categories" */
  insert_organization_risk_categories_one?: Maybe<Organization_Risk_Categories>;
  /** insert data into the table: "organization_risk_levels" */
  insert_organization_risk_levels?: Maybe<Organization_Risk_Levels_Mutation_Response>;
  /** insert a single row into the table: "organization_risk_levels" */
  insert_organization_risk_levels_one?: Maybe<Organization_Risk_Levels>;
  /** insert data into the table: "organization_risk_tags" */
  insert_organization_risk_tags?: Maybe<Organization_Risk_Tags_Mutation_Response>;
  /** insert a single row into the table: "organization_risk_tags" */
  insert_organization_risk_tags_one?: Maybe<Organization_Risk_Tags>;
  /** insert data into the table: "organization_vendor_risk_levels" */
  insert_organization_vendor_risk_levels?: Maybe<Organization_Vendor_Risk_Levels_Mutation_Response>;
  /** insert a single row into the table: "organization_vendor_risk_levels" */
  insert_organization_vendor_risk_levels_one?: Maybe<Organization_Vendor_Risk_Levels>;
  /** insert data into the table: "organization_vendor_tiers" */
  insert_organization_vendor_tiers?: Maybe<Organization_Vendor_Tiers_Mutation_Response>;
  /** insert a single row into the table: "organization_vendor_tiers" */
  insert_organization_vendor_tiers_one?: Maybe<Organization_Vendor_Tiers>;
  /** insert data into the table: "policies" */
  insert_policies?: Maybe<Policies_Mutation_Response>;
  /** insert a single row into the table: "policies" */
  insert_policies_one?: Maybe<Policies>;
  /** insert data into the table: "policy_approval_users" */
  insert_policy_approval_users?: Maybe<Policy_Approval_Users_Mutation_Response>;
  /** insert a single row into the table: "policy_approval_users" */
  insert_policy_approval_users_one?: Maybe<Policy_Approval_Users>;
  /** insert data into the table: "policy_approvals" */
  insert_policy_approvals?: Maybe<Policy_Approvals_Mutation_Response>;
  /** insert a single row into the table: "policy_approvals" */
  insert_policy_approvals_one?: Maybe<Policy_Approvals>;
  /** insert data into the table: "policy_approvers" */
  insert_policy_approvers?: Maybe<Policy_Approvers_Mutation_Response>;
  /** insert a single row into the table: "policy_approvers" */
  insert_policy_approvers_one?: Maybe<Policy_Approvers>;
  /** insert data into the table: "policy_exception_approvers" */
  insert_policy_exception_approvers?: Maybe<Policy_Exception_Approvers_Mutation_Response>;
  /** insert a single row into the table: "policy_exception_approvers" */
  insert_policy_exception_approvers_one?: Maybe<Policy_Exception_Approvers>;
  /** insert data into the table: "policy_exception_files" */
  insert_policy_exception_files?: Maybe<Policy_Exception_Files_Mutation_Response>;
  /** insert a single row into the table: "policy_exception_files" */
  insert_policy_exception_files_one?: Maybe<Policy_Exception_Files>;
  /** insert data into the table: "policy_exceptions" */
  insert_policy_exceptions?: Maybe<Policy_Exceptions_Mutation_Response>;
  /** insert a single row into the table: "policy_exceptions" */
  insert_policy_exceptions_one?: Maybe<Policy_Exceptions>;
  /** insert data into the table: "policy_integrations" */
  insert_policy_integrations?: Maybe<Policy_Integrations_Mutation_Response>;
  /** insert a single row into the table: "policy_integrations" */
  insert_policy_integrations_one?: Maybe<Policy_Integrations>;
  /** insert data into the table: "policy_owners" */
  insert_policy_owners?: Maybe<Policy_Owners_Mutation_Response>;
  /** insert a single row into the table: "policy_owners" */
  insert_policy_owners_one?: Maybe<Policy_Owners>;
  /** insert data into the table: "policy_tasks" */
  insert_policy_tasks?: Maybe<Policy_Tasks_Mutation_Response>;
  /** insert a single row into the table: "policy_tasks" */
  insert_policy_tasks_one?: Maybe<Policy_Tasks>;
  /** insert data into the table: "policy_versions" */
  insert_policy_versions?: Maybe<Policy_Versions_Mutation_Response>;
  /** insert a single row into the table: "policy_versions" */
  insert_policy_versions_one?: Maybe<Policy_Versions>;
  /** insert data into the table: "program_assignees" */
  insert_program_assignees?: Maybe<Program_Assignees_Mutation_Response>;
  /** insert a single row into the table: "program_assignees" */
  insert_program_assignees_one?: Maybe<Program_Assignees>;
  /** insert data into the table: "program_controls" */
  insert_program_controls?: Maybe<Program_Controls_Mutation_Response>;
  /** insert a single row into the table: "program_controls" */
  insert_program_controls_one?: Maybe<Program_Controls>;
  /** insert data into the table: "program_field_configs" */
  insert_program_field_configs?: Maybe<Program_Field_Configs_Mutation_Response>;
  /** insert a single row into the table: "program_field_configs" */
  insert_program_field_configs_one?: Maybe<Program_Field_Configs>;
  /** insert data into the table: "programs" */
  insert_programs?: Maybe<Programs_Mutation_Response>;
  /** insert a single row into the table: "programs" */
  insert_programs_one?: Maybe<Programs>;
  /** insert data into the table: "questionnaire_uploads" */
  insert_questionnaire_uploads?: Maybe<Questionnaire_Uploads_Mutation_Response>;
  /** insert a single row into the table: "questionnaire_uploads" */
  insert_questionnaire_uploads_one?: Maybe<Questionnaire_Uploads>;
  /** insert data into the table: "questionnaires" */
  insert_questionnaires?: Maybe<Questionnaires_Mutation_Response>;
  /** insert a single row into the table: "questionnaires" */
  insert_questionnaires_one?: Maybe<Questionnaires>;
  /** insert data into the table: "reports" */
  insert_reports?: Maybe<Reports_Mutation_Response>;
  /** insert a single row into the table: "reports" */
  insert_reports_one?: Maybe<Reports>;
  /** insert data into the table: "review_files" */
  insert_review_files?: Maybe<Review_Files_Mutation_Response>;
  /** insert a single row into the table: "review_files" */
  insert_review_files_one?: Maybe<Review_Files>;
  /** insert data into the table: "reviews" */
  insert_reviews?: Maybe<Reviews_Mutation_Response>;
  /** insert a single row into the table: "reviews" */
  insert_reviews_one?: Maybe<Reviews>;
  /** insert data into the table: "risk_approval_files" */
  insert_risk_approval_files?: Maybe<Risk_Approval_Files_Mutation_Response>;
  /** insert a single row into the table: "risk_approval_files" */
  insert_risk_approval_files_one?: Maybe<Risk_Approval_Files>;
  /** insert data into the table: "risk_approval_reason_entries" */
  insert_risk_approval_reason_entries?: Maybe<Risk_Approval_Reason_Entries_Mutation_Response>;
  /** insert a single row into the table: "risk_approval_reason_entries" */
  insert_risk_approval_reason_entries_one?: Maybe<Risk_Approval_Reason_Entries>;
  /** insert data into the table: "risk_approvals" */
  insert_risk_approvals?: Maybe<Risk_Approvals_Mutation_Response>;
  /** insert a single row into the table: "risk_approvals" */
  insert_risk_approvals_one?: Maybe<Risk_Approvals>;
  /** insert data into the table: "risk_approvers" */
  insert_risk_approvers?: Maybe<Risk_Approvers_Mutation_Response>;
  /** insert a single row into the table: "risk_approvers" */
  insert_risk_approvers_one?: Maybe<Risk_Approvers>;
  /** insert data into the table: "risk_categories" */
  insert_risk_categories?: Maybe<Risk_Categories_Mutation_Response>;
  /** insert a single row into the table: "risk_categories" */
  insert_risk_categories_one?: Maybe<Risk_Categories>;
  /** insert data into the table: "risk_controls" */
  insert_risk_controls?: Maybe<Risk_Controls_Mutation_Response>;
  /** insert a single row into the table: "risk_controls" */
  insert_risk_controls_one?: Maybe<Risk_Controls>;
  /** insert data into the table: "risk_documents" */
  insert_risk_documents?: Maybe<Risk_Documents_Mutation_Response>;
  /** insert a single row into the table: "risk_documents" */
  insert_risk_documents_one?: Maybe<Risk_Documents>;
  /** insert data into the table: "risk_impacts" */
  insert_risk_impacts?: Maybe<Risk_Impacts_Mutation_Response>;
  /** insert a single row into the table: "risk_impacts" */
  insert_risk_impacts_one?: Maybe<Risk_Impacts>;
  /** insert data into the table: "risk_likelihoods" */
  insert_risk_likelihoods?: Maybe<Risk_Likelihoods_Mutation_Response>;
  /** insert a single row into the table: "risk_likelihoods" */
  insert_risk_likelihoods_one?: Maybe<Risk_Likelihoods>;
  /** insert data into the table: "risk_owners" */
  insert_risk_owners?: Maybe<Risk_Owners_Mutation_Response>;
  /** insert a single row into the table: "risk_owners" */
  insert_risk_owners_one?: Maybe<Risk_Owners>;
  /** insert data into the table: "risk_tags" */
  insert_risk_tags?: Maybe<Risk_Tags_Mutation_Response>;
  /** insert a single row into the table: "risk_tags" */
  insert_risk_tags_one?: Maybe<Risk_Tags>;
  /** insert data into the table: "risk_tasks" */
  insert_risk_tasks?: Maybe<Risk_Tasks_Mutation_Response>;
  /** insert a single row into the table: "risk_tasks" */
  insert_risk_tasks_one?: Maybe<Risk_Tasks>;
  /** insert data into the table: "risks" */
  insert_risks?: Maybe<Risks_Mutation_Response>;
  /** insert a single row into the table: "risks" */
  insert_risks_one?: Maybe<Risks>;
  /** insert data into the table: "role_permissions" */
  insert_role_permissions?: Maybe<Role_Permissions_Mutation_Response>;
  /** insert a single row into the table: "role_permissions" */
  insert_role_permissions_one?: Maybe<Role_Permissions>;
  /** insert data into the table: "roles" */
  insert_roles?: Maybe<Roles_Mutation_Response>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: Maybe<Roles>;
  /** insert data into the table: "select_field_configs" */
  insert_select_field_configs?: Maybe<Select_Field_Configs_Mutation_Response>;
  /** insert a single row into the table: "select_field_configs" */
  insert_select_field_configs_one?: Maybe<Select_Field_Configs>;
  /** insert data into the table: "select_field_options" */
  insert_select_field_options?: Maybe<Select_Field_Options_Mutation_Response>;
  /** insert a single row into the table: "select_field_options" */
  insert_select_field_options_one?: Maybe<Select_Field_Options>;
  /** insert data into the table: "tags" */
  insert_tags?: Maybe<Tags_Mutation_Response>;
  /** insert a single row into the table: "tags" */
  insert_tags_one?: Maybe<Tags>;
  /** insert data into the table: "task_owners" */
  insert_task_owners?: Maybe<Task_Owners_Mutation_Response>;
  /** insert a single row into the table: "task_owners" */
  insert_task_owners_one?: Maybe<Task_Owners>;
  /** insert data into the table: "tasks" */
  insert_tasks?: Maybe<Tasks_Mutation_Response>;
  /** insert a single row into the table: "tasks" */
  insert_tasks_one?: Maybe<Tasks>;
  /** insert data into the table: "team_members" */
  insert_team_members?: Maybe<Team_Members_Mutation_Response>;
  /** insert a single row into the table: "team_members" */
  insert_team_members_one?: Maybe<Team_Members>;
  /** insert data into the table: "teams" */
  insert_teams?: Maybe<Teams_Mutation_Response>;
  /** insert a single row into the table: "teams" */
  insert_teams_one?: Maybe<Teams>;
  /** insert data into the table: "text_field_values" */
  insert_text_field_values?: Maybe<Text_Field_Values_Mutation_Response>;
  /** insert a single row into the table: "text_field_values" */
  insert_text_field_values_one?: Maybe<Text_Field_Values>;
  /** insert data into the table: "trust_portal.categories" */
  insert_trust_portal_categories?: Maybe<Trust_Portal_Categories_Mutation_Response>;
  /** insert a single row into the table: "trust_portal.categories" */
  insert_trust_portal_categories_one?: Maybe<Trust_Portal_Categories>;
  /** insert data into the table: "trust_portal.document_resource_sections" */
  insert_trust_portal_document_resource_sections?: Maybe<Trust_Portal_Document_Resource_Sections_Mutation_Response>;
  /** insert a single row into the table: "trust_portal.document_resource_sections" */
  insert_trust_portal_document_resource_sections_one?: Maybe<Trust_Portal_Document_Resource_Sections>;
  /** insert data into the table: "trust_portal.documents" */
  insert_trust_portal_documents?: Maybe<Trust_Portal_Documents_Mutation_Response>;
  /** insert a single row into the table: "trust_portal.documents" */
  insert_trust_portal_documents_one?: Maybe<Trust_Portal_Documents>;
  /** insert data into the table: "trust_portal.faqs" */
  insert_trust_portal_faqs?: Maybe<Trust_Portal_Faqs_Mutation_Response>;
  /** insert a single row into the table: "trust_portal.faqs" */
  insert_trust_portal_faqs_one?: Maybe<Trust_Portal_Faqs>;
  /** insert data into the table: "trust_portal.frameworks" */
  insert_trust_portal_frameworks?: Maybe<Trust_Portal_Frameworks_Mutation_Response>;
  /** insert a single row into the table: "trust_portal.frameworks" */
  insert_trust_portal_frameworks_one?: Maybe<Trust_Portal_Frameworks>;
  /** insert data into the table: "trust_portal.pages" */
  insert_trust_portal_pages?: Maybe<Trust_Portal_Pages_Mutation_Response>;
  /** insert a single row into the table: "trust_portal.pages" */
  insert_trust_portal_pages_one?: Maybe<Trust_Portal_Pages>;
  /** insert data into the table: "trust_portal.resource_sections" */
  insert_trust_portal_resource_sections?: Maybe<Trust_Portal_Resource_Sections_Mutation_Response>;
  /** insert a single row into the table: "trust_portal.resource_sections" */
  insert_trust_portal_resource_sections_one?: Maybe<Trust_Portal_Resource_Sections>;
  /** insert data into the table: "trust_portal.update_categories" */
  insert_trust_portal_update_categories?: Maybe<Trust_Portal_Update_Categories_Mutation_Response>;
  /** insert a single row into the table: "trust_portal.update_categories" */
  insert_trust_portal_update_categories_one?: Maybe<Trust_Portal_Update_Categories>;
  /** insert data into the table: "trust_portal.updates" */
  insert_trust_portal_updates?: Maybe<Trust_Portal_Updates_Mutation_Response>;
  /** insert a single row into the table: "trust_portal.updates" */
  insert_trust_portal_updates_one?: Maybe<Trust_Portal_Updates>;
  /** insert data into the table: "url_field_values" */
  insert_url_field_values?: Maybe<Url_Field_Values_Mutation_Response>;
  /** insert a single row into the table: "url_field_values" */
  insert_url_field_values_one?: Maybe<Url_Field_Values>;
  /** insert data into the table: "user_profiles" */
  insert_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** insert a single row into the table: "user_profiles" */
  insert_user_profiles_one?: Maybe<User_Profiles>;
  /** insert data into the table: "vendor_approval_files" */
  insert_vendor_approval_files?: Maybe<Vendor_Approval_Files_Mutation_Response>;
  /** insert a single row into the table: "vendor_approval_files" */
  insert_vendor_approval_files_one?: Maybe<Vendor_Approval_Files>;
  /** insert data into the table: "vendor_approvals" */
  insert_vendor_approvals?: Maybe<Vendor_Approvals_Mutation_Response>;
  /** insert a single row into the table: "vendor_approvals" */
  insert_vendor_approvals_one?: Maybe<Vendor_Approvals>;
  /** insert data into the table: "vendor_approvers" */
  insert_vendor_approvers?: Maybe<Vendor_Approvers_Mutation_Response>;
  /** insert a single row into the table: "vendor_approvers" */
  insert_vendor_approvers_one?: Maybe<Vendor_Approvers>;
  /** insert data into the table: "vendor_documents" */
  insert_vendor_documents?: Maybe<Vendor_Documents_Mutation_Response>;
  /** insert a single row into the table: "vendor_documents" */
  insert_vendor_documents_one?: Maybe<Vendor_Documents>;
  /** insert data into the table: "vendor_owners" */
  insert_vendor_owners?: Maybe<Vendor_Owners_Mutation_Response>;
  /** insert a single row into the table: "vendor_owners" */
  insert_vendor_owners_one?: Maybe<Vendor_Owners>;
  /** insert data into the table: "vendor_questionnaire_forms" */
  insert_vendor_questionnaire_forms?: Maybe<Vendor_Questionnaire_Forms_Mutation_Response>;
  /** insert a single row into the table: "vendor_questionnaire_forms" */
  insert_vendor_questionnaire_forms_one?: Maybe<Vendor_Questionnaire_Forms>;
  /** insert data into the table: "vendor_risks" */
  insert_vendor_risks?: Maybe<Vendor_Risks_Mutation_Response>;
  /** insert a single row into the table: "vendor_risks" */
  insert_vendor_risks_one?: Maybe<Vendor_Risks>;
  /** insert data into the table: "vendor_tasks" */
  insert_vendor_tasks?: Maybe<Vendor_Tasks_Mutation_Response>;
  /** insert a single row into the table: "vendor_tasks" */
  insert_vendor_tasks_one?: Maybe<Vendor_Tasks>;
  /** insert data into the table: "vendors" */
  insert_vendors?: Maybe<Vendors_Mutation_Response>;
  /** insert a single row into the table: "vendors" */
  insert_vendors_one?: Maybe<Vendors>;
  /** insert data into the table: "vq_custom_fields" */
  insert_vq_custom_fields?: Maybe<Vq_Custom_Fields_Mutation_Response>;
  /** insert a single row into the table: "vq_custom_fields" */
  insert_vq_custom_fields_one?: Maybe<Vq_Custom_Fields>;
  invite_user?: Maybe<InviteUserOutput>;
  join_organization?: Maybe<GeneralActionOutput>;
  lift_trust_portal_access_block: TrustPortalLiftAccessBlockOutput;
  pause_trust_portal_nda_gate: TrustPortalNdaGateLifecycleOutput;
  reconfigure_manual_integration_connector?: Maybe<ManualIntegrationConnectorOutput>;
  /** Record what an agent concluded after checking a control's evidence */
  record_evidence_check?: Maybe<RecordEvidenceCheckOutput>;
  remediate_finding: Array<FindingCommandOutput>;
  remove_email_sender?: Maybe<GeneralActionOutput>;
  remove_trust_portal_domain?: Maybe<GeneralActionOutput>;
  rename_integration_connector?: Maybe<RenameIntegrationConnectorOutput>;
  /** This action triggers an endpoint that resends risk approval request to an approver */
  resend_risk_approval_request?: Maybe<GeneralActionOutput>;
  /** This action triggers an endpoint that resends vendor approval request to an approver */
  resend_vendor_approval_request?: Maybe<GeneralActionOutput>;
  revoke_and_block_trust_portal_access: TrustPortalRevokeAndBlockAccessOutput;
  revoke_evidence_access?: Maybe<RevokeEvidenceAccessOutput>;
  revoke_trust_portal_access: TrustPortalAccessDecisionOutput;
  rotate_api_key?: Maybe<RotateApiKeyOutput>;
  save_trust_portal_nda_gate_configuration: TrustPortalNdaGateConnectionOutput;
  /** Send questionnaire to multiple vendors */
  sendVendorQuestionnaire?: Maybe<SendVendorQuestionnaireOutput>;
  /** This action triggers an endpoint that sends reminder for policy acknowledgement */
  send_acknowledgement_reminder?: Maybe<AcknowledgementReminderOutput>;
  /** This action triggers an endpoint that sends reminder for policy approval */
  send_approval_reminder?: Maybe<ApprovalReminderOutput>;
  /** This action triggers an endpoint that sends reminder for policy exception */
  send_exception_reminder?: Maybe<ExceptionReminderOutput>;
  /** This action sends policy acknowledgements for single and bulk selections */
  send_policy_acknowledgements?: Maybe<SendPolicyAcknowledgementsOutput>;
  /** This action triggers an endpoint that sends reminder for risk approval */
  send_risk_approval_reminder?: Maybe<ApprovalReminderOutput>;
  /** This action triggers an endpoint that sends reminder for vendor approval */
  send_vendor_approval_reminder?: Maybe<ApprovalReminderOutput>;
  set_evidence_confidential?: Maybe<SetEvidenceConfidentialOutput>;
  set_org_integration_config?: Maybe<OrgIntegrationConfigState>;
  set_scalar_field_values: GeneralActionOutput;
  set_select_field_values?: Maybe<SetSelectFieldValuesOutput>;
  setup_email_sender?: Maybe<EmailSenderSetupOutput>;
  setup_trust_portal_domain?: Maybe<TrustPortalDomainStatusOutput>;
  share_trust_portal_access: TrustPortalAccessDecisionOutput;
  toggle_close_out_risk?: Maybe<ToggleRiskCloseOutOutput>;
  toggle_close_out_risks?: Maybe<ToggleRisksCloseOutOutput>;
  toggle_terminate_vendor?: Maybe<ToggleTerminateVendorOutput>;
  toggle_terminate_vendors?: Maybe<ToggleTerminateVendorsOutput>;
  /** update single row of the table: "auth.users" */
  updateUser?: Maybe<Users>;
  /** update data of the table: "auth.users" */
  updateUsers?: Maybe<Users_Mutation_Response>;
  /** update data of the table: "agent_instances" */
  update_agent_instances?: Maybe<Agent_Instances_Mutation_Response>;
  /** update single row of the table: "agent_instances" */
  update_agent_instances_by_pk?: Maybe<Agent_Instances>;
  /** update multiples rows of table: "agent_instances" */
  update_agent_instances_many?: Maybe<Array<Maybe<Agent_Instances_Mutation_Response>>>;
  /** update data of the table: "api_keys" */
  update_api_keys?: Maybe<Api_Keys_Mutation_Response>;
  /** update single row of the table: "api_keys" */
  update_api_keys_by_pk?: Maybe<Api_Keys>;
  /** update multiples rows of table: "api_keys" */
  update_api_keys_many?: Maybe<Array<Maybe<Api_Keys_Mutation_Response>>>;
  /** update data of the table: "categories" */
  update_categories?: Maybe<Categories_Mutation_Response>;
  /** update single row of the table: "categories" */
  update_categories_by_pk?: Maybe<Categories>;
  /** update multiples rows of table: "categories" */
  update_categories_many?: Maybe<Array<Maybe<Categories_Mutation_Response>>>;
  /** update data of the table: "client_questionnaire_questions" */
  update_client_questionnaire_questions?: Maybe<Client_Questionnaire_Questions_Mutation_Response>;
  /** update single row of the table: "client_questionnaire_questions" */
  update_client_questionnaire_questions_by_pk?: Maybe<Client_Questionnaire_Questions>;
  /** update multiples rows of table: "client_questionnaire_questions" */
  update_client_questionnaire_questions_many?: Maybe<
    Array<Maybe<Client_Questionnaire_Questions_Mutation_Response>>
  >;
  /** update data of the table: "client_questionnaires" */
  update_client_questionnaires?: Maybe<Client_Questionnaires_Mutation_Response>;
  /** update single row of the table: "client_questionnaires" */
  update_client_questionnaires_by_pk?: Maybe<Client_Questionnaires>;
  /** update multiples rows of table: "client_questionnaires" */
  update_client_questionnaires_many?: Maybe<Array<Maybe<Client_Questionnaires_Mutation_Response>>>;
  /** update data of the table: "comments" */
  update_comments?: Maybe<Comments_Mutation_Response>;
  /** update single row of the table: "comments" */
  update_comments_by_pk?: Maybe<Comments>;
  /** update multiples rows of table: "comments" */
  update_comments_many?: Maybe<Array<Maybe<Comments_Mutation_Response>>>;
  /** update data of the table: "control_ai_review_criteria" */
  update_control_ai_review_criteria?: Maybe<Control_Ai_Review_Criteria_Mutation_Response>;
  /** update single row of the table: "control_ai_review_criteria" */
  update_control_ai_review_criteria_by_pk?: Maybe<Control_Ai_Review_Criteria>;
  /** update multiples rows of table: "control_ai_review_criteria" */
  update_control_ai_review_criteria_many?: Maybe<
    Array<Maybe<Control_Ai_Review_Criteria_Mutation_Response>>
  >;
  /** update data of the table: "control_findings" */
  update_control_findings?: Maybe<Control_Findings_Mutation_Response>;
  /** update single row of the table: "control_findings" */
  update_control_findings_by_pk?: Maybe<Control_Findings>;
  /** update multiples rows of table: "control_findings" */
  update_control_findings_many?: Maybe<Array<Maybe<Control_Findings_Mutation_Response>>>;
  /** update data of the table: "controls" */
  update_controls?: Maybe<Controls_Mutation_Response>;
  /** update single row of the table: "controls" */
  update_controls_by_pk?: Maybe<Controls>;
  /** update multiples rows of table: "controls" */
  update_controls_many?: Maybe<Array<Maybe<Controls_Mutation_Response>>>;
  /** update data of the table: "criteria" */
  update_criteria?: Maybe<Criteria_Mutation_Response>;
  /** update single row of the table: "criteria" */
  update_criteria_by_pk?: Maybe<Criteria>;
  /** update multiples rows of table: "criteria" */
  update_criteria_many?: Maybe<Array<Maybe<Criteria_Mutation_Response>>>;
  /** update data of the table: "date_field_values" */
  update_date_field_values?: Maybe<Date_Field_Values_Mutation_Response>;
  /** update single row of the table: "date_field_values" */
  update_date_field_values_by_pk?: Maybe<Date_Field_Values>;
  /** update multiples rows of table: "date_field_values" */
  update_date_field_values_many?: Maybe<Array<Maybe<Date_Field_Values_Mutation_Response>>>;
  /** update data of the table: "documents" */
  update_documents?: Maybe<Documents_Mutation_Response>;
  /** update single row of the table: "documents" */
  update_documents_by_pk?: Maybe<Documents>;
  /** update multiples rows of table: "documents" */
  update_documents_many?: Maybe<Array<Maybe<Documents_Mutation_Response>>>;
  /** update data of the table: "email_field_values" */
  update_email_field_values?: Maybe<Email_Field_Values_Mutation_Response>;
  /** update single row of the table: "email_field_values" */
  update_email_field_values_by_pk?: Maybe<Email_Field_Values>;
  /** update multiples rows of table: "email_field_values" */
  update_email_field_values_many?: Maybe<Array<Maybe<Email_Field_Values_Mutation_Response>>>;
  /** update data of the table: "evidence_integrations" */
  update_evidence_integrations?: Maybe<Evidence_Integrations_Mutation_Response>;
  /** update single row of the table: "evidence_integrations" */
  update_evidence_integrations_by_pk?: Maybe<Evidence_Integrations>;
  /** update multiples rows of table: "evidence_integrations" */
  update_evidence_integrations_many?: Maybe<Array<Maybe<Evidence_Integrations_Mutation_Response>>>;
  /** update data of the table: "evidence_policies" */
  update_evidence_policies?: Maybe<Evidence_Policies_Mutation_Response>;
  /** update single row of the table: "evidence_policies" */
  update_evidence_policies_by_pk?: Maybe<Evidence_Policies>;
  /** update multiples rows of table: "evidence_policies" */
  update_evidence_policies_many?: Maybe<Array<Maybe<Evidence_Policies_Mutation_Response>>>;
  /** update data of the table: "evidence_versions" */
  update_evidence_versions?: Maybe<Evidence_Versions_Mutation_Response>;
  /** update single row of the table: "evidence_versions" */
  update_evidence_versions_by_pk?: Maybe<Evidence_Versions>;
  /** update multiples rows of table: "evidence_versions" */
  update_evidence_versions_many?: Maybe<Array<Maybe<Evidence_Versions_Mutation_Response>>>;
  /** update data of the table: "evidences" */
  update_evidences?: Maybe<Evidences_Mutation_Response>;
  /** update single row of the table: "evidences" */
  update_evidences_by_pk?: Maybe<Evidences>;
  /** update multiples rows of table: "evidences" */
  update_evidences_many?: Maybe<Array<Maybe<Evidences_Mutation_Response>>>;
  /** update data of the table: "field_configs" */
  update_field_configs?: Maybe<Field_Configs_Mutation_Response>;
  /** update single row of the table: "field_configs" */
  update_field_configs_by_pk?: Maybe<Field_Configs>;
  /** update multiples rows of table: "field_configs" */
  update_field_configs_many?: Maybe<Array<Maybe<Field_Configs_Mutation_Response>>>;
  /** update data of the table: "finding_resolutions" */
  update_finding_resolutions?: Maybe<Finding_Resolutions_Mutation_Response>;
  /** update single row of the table: "finding_resolutions" */
  update_finding_resolutions_by_pk?: Maybe<Finding_Resolutions>;
  /** update multiples rows of table: "finding_resolutions" */
  update_finding_resolutions_many?: Maybe<Array<Maybe<Finding_Resolutions_Mutation_Response>>>;
  /** update data of the table: "forms" */
  update_forms?: Maybe<Forms_Mutation_Response>;
  /** update single row of the table: "forms" */
  update_forms_by_pk?: Maybe<Forms>;
  /** update multiples rows of table: "forms" */
  update_forms_many?: Maybe<Array<Maybe<Forms_Mutation_Response>>>;
  /** update data of the table: "groups" */
  update_groups?: Maybe<Groups_Mutation_Response>;
  /** update single row of the table: "groups" */
  update_groups_by_pk?: Maybe<Groups>;
  /** update multiples rows of table: "groups" */
  update_groups_many?: Maybe<Array<Maybe<Groups_Mutation_Response>>>;
  update_mcp_client_policy: UpdateMcpClientPolicyOutput;
  /** update data of the table: "number_field_values" */
  update_number_field_values?: Maybe<Number_Field_Values_Mutation_Response>;
  /** update single row of the table: "number_field_values" */
  update_number_field_values_by_pk?: Maybe<Number_Field_Values>;
  /** update multiples rows of table: "number_field_values" */
  update_number_field_values_many?: Maybe<Array<Maybe<Number_Field_Values_Mutation_Response>>>;
  /** update data of the table: "organization_evidence_tags" */
  update_organization_evidence_tags?: Maybe<Organization_Evidence_Tags_Mutation_Response>;
  /** update single row of the table: "organization_evidence_tags" */
  update_organization_evidence_tags_by_pk?: Maybe<Organization_Evidence_Tags>;
  /** update multiples rows of table: "organization_evidence_tags" */
  update_organization_evidence_tags_many?: Maybe<
    Array<Maybe<Organization_Evidence_Tags_Mutation_Response>>
  >;
  /** update data of the table: "organization_finding_severities" */
  update_organization_finding_severities?: Maybe<Organization_Finding_Severities_Mutation_Response>;
  /** update single row of the table: "organization_finding_severities" */
  update_organization_finding_severities_by_pk?: Maybe<Organization_Finding_Severities>;
  /** update multiples rows of table: "organization_finding_severities" */
  update_organization_finding_severities_many?: Maybe<
    Array<Maybe<Organization_Finding_Severities_Mutation_Response>>
  >;
  /** update data of the table: "organization_profiles" */
  update_organization_profiles?: Maybe<Organization_Profiles_Mutation_Response>;
  /** update single row of the table: "organization_profiles" */
  update_organization_profiles_by_pk?: Maybe<Organization_Profiles>;
  /** update multiples rows of table: "organization_profiles" */
  update_organization_profiles_many?: Maybe<Array<Maybe<Organization_Profiles_Mutation_Response>>>;
  /** update data of the table: "organization_risk_categories" */
  update_organization_risk_categories?: Maybe<Organization_Risk_Categories_Mutation_Response>;
  /** update single row of the table: "organization_risk_categories" */
  update_organization_risk_categories_by_pk?: Maybe<Organization_Risk_Categories>;
  /** update multiples rows of table: "organization_risk_categories" */
  update_organization_risk_categories_many?: Maybe<
    Array<Maybe<Organization_Risk_Categories_Mutation_Response>>
  >;
  /** update data of the table: "organization_risk_levels" */
  update_organization_risk_levels?: Maybe<Organization_Risk_Levels_Mutation_Response>;
  /** update single row of the table: "organization_risk_levels" */
  update_organization_risk_levels_by_pk?: Maybe<Organization_Risk_Levels>;
  /** update multiples rows of table: "organization_risk_levels" */
  update_organization_risk_levels_many?: Maybe<
    Array<Maybe<Organization_Risk_Levels_Mutation_Response>>
  >;
  /** update data of the table: "organization_risk_tags" */
  update_organization_risk_tags?: Maybe<Organization_Risk_Tags_Mutation_Response>;
  /** update single row of the table: "organization_risk_tags" */
  update_organization_risk_tags_by_pk?: Maybe<Organization_Risk_Tags>;
  /** update multiples rows of table: "organization_risk_tags" */
  update_organization_risk_tags_many?: Maybe<
    Array<Maybe<Organization_Risk_Tags_Mutation_Response>>
  >;
  /** update data of the table: "organization_users" */
  update_organization_users?: Maybe<Organization_Users_Mutation_Response>;
  /** update single row of the table: "organization_users" */
  update_organization_users_by_pk?: Maybe<Organization_Users>;
  /** update multiples rows of table: "organization_users" */
  update_organization_users_many?: Maybe<Array<Maybe<Organization_Users_Mutation_Response>>>;
  /** update data of the table: "organization_vendor_risk_levels" */
  update_organization_vendor_risk_levels?: Maybe<Organization_Vendor_Risk_Levels_Mutation_Response>;
  /** update single row of the table: "organization_vendor_risk_levels" */
  update_organization_vendor_risk_levels_by_pk?: Maybe<Organization_Vendor_Risk_Levels>;
  /** update multiples rows of table: "organization_vendor_risk_levels" */
  update_organization_vendor_risk_levels_many?: Maybe<
    Array<Maybe<Organization_Vendor_Risk_Levels_Mutation_Response>>
  >;
  /** update data of the table: "organization_vendor_tiers" */
  update_organization_vendor_tiers?: Maybe<Organization_Vendor_Tiers_Mutation_Response>;
  /** update single row of the table: "organization_vendor_tiers" */
  update_organization_vendor_tiers_by_pk?: Maybe<Organization_Vendor_Tiers>;
  /** update multiples rows of table: "organization_vendor_tiers" */
  update_organization_vendor_tiers_many?: Maybe<
    Array<Maybe<Organization_Vendor_Tiers_Mutation_Response>>
  >;
  /** update data of the table: "organizations" */
  update_organizations?: Maybe<Organizations_Mutation_Response>;
  /** update single row of the table: "organizations" */
  update_organizations_by_pk?: Maybe<Organizations>;
  /** update multiples rows of table: "organizations" */
  update_organizations_many?: Maybe<Array<Maybe<Organizations_Mutation_Response>>>;
  /** update data of the table: "policies" */
  update_policies?: Maybe<Policies_Mutation_Response>;
  /** update single row of the table: "policies" */
  update_policies_by_pk?: Maybe<Policies>;
  /** update multiples rows of table: "policies" */
  update_policies_many?: Maybe<Array<Maybe<Policies_Mutation_Response>>>;
  /** update data of the table: "policy_acknowledgement_users" */
  update_policy_acknowledgement_users?: Maybe<Policy_Acknowledgement_Users_Mutation_Response>;
  /** update single row of the table: "policy_acknowledgement_users" */
  update_policy_acknowledgement_users_by_pk?: Maybe<Policy_Acknowledgement_Users>;
  /** update multiples rows of table: "policy_acknowledgement_users" */
  update_policy_acknowledgement_users_many?: Maybe<
    Array<Maybe<Policy_Acknowledgement_Users_Mutation_Response>>
  >;
  /** update data of the table: "policy_acknowledgements" */
  update_policy_acknowledgements?: Maybe<Policy_Acknowledgements_Mutation_Response>;
  /** update single row of the table: "policy_acknowledgements" */
  update_policy_acknowledgements_by_pk?: Maybe<Policy_Acknowledgements>;
  /** update multiples rows of table: "policy_acknowledgements" */
  update_policy_acknowledgements_many?: Maybe<
    Array<Maybe<Policy_Acknowledgements_Mutation_Response>>
  >;
  /** update data of the table: "policy_approval_users" */
  update_policy_approval_users?: Maybe<Policy_Approval_Users_Mutation_Response>;
  /** update single row of the table: "policy_approval_users" */
  update_policy_approval_users_by_pk?: Maybe<Policy_Approval_Users>;
  /** update multiples rows of table: "policy_approval_users" */
  update_policy_approval_users_many?: Maybe<Array<Maybe<Policy_Approval_Users_Mutation_Response>>>;
  /** update data of the table: "policy_approvals" */
  update_policy_approvals?: Maybe<Policy_Approvals_Mutation_Response>;
  /** update single row of the table: "policy_approvals" */
  update_policy_approvals_by_pk?: Maybe<Policy_Approvals>;
  /** update multiples rows of table: "policy_approvals" */
  update_policy_approvals_many?: Maybe<Array<Maybe<Policy_Approvals_Mutation_Response>>>;
  /** update data of the table: "policy_exception_approvers" */
  update_policy_exception_approvers?: Maybe<Policy_Exception_Approvers_Mutation_Response>;
  /** update single row of the table: "policy_exception_approvers" */
  update_policy_exception_approvers_by_pk?: Maybe<Policy_Exception_Approvers>;
  /** update multiples rows of table: "policy_exception_approvers" */
  update_policy_exception_approvers_many?: Maybe<
    Array<Maybe<Policy_Exception_Approvers_Mutation_Response>>
  >;
  /** update data of the table: "policy_exceptions" */
  update_policy_exceptions?: Maybe<Policy_Exceptions_Mutation_Response>;
  /** update single row of the table: "policy_exceptions" */
  update_policy_exceptions_by_pk?: Maybe<Policy_Exceptions>;
  /** update multiples rows of table: "policy_exceptions" */
  update_policy_exceptions_many?: Maybe<Array<Maybe<Policy_Exceptions_Mutation_Response>>>;
  /** update data of the table: "policy_integrations" */
  update_policy_integrations?: Maybe<Policy_Integrations_Mutation_Response>;
  /** update single row of the table: "policy_integrations" */
  update_policy_integrations_by_pk?: Maybe<Policy_Integrations>;
  /** update multiples rows of table: "policy_integrations" */
  update_policy_integrations_many?: Maybe<Array<Maybe<Policy_Integrations_Mutation_Response>>>;
  update_policy_version_content?: Maybe<GeneralActionOutput>;
  /** update data of the table: "policy_versions" */
  update_policy_versions?: Maybe<Policy_Versions_Mutation_Response>;
  /** update single row of the table: "policy_versions" */
  update_policy_versions_by_pk?: Maybe<Policy_Versions>;
  /** update multiples rows of table: "policy_versions" */
  update_policy_versions_many?: Maybe<Array<Maybe<Policy_Versions_Mutation_Response>>>;
  /** update data of the table: "programs" */
  update_programs?: Maybe<Programs_Mutation_Response>;
  /** update single row of the table: "programs" */
  update_programs_by_pk?: Maybe<Programs>;
  /** update multiples rows of table: "programs" */
  update_programs_many?: Maybe<Array<Maybe<Programs_Mutation_Response>>>;
  /** update data of the table: "questionnaire_uploads" */
  update_questionnaire_uploads?: Maybe<Questionnaire_Uploads_Mutation_Response>;
  /** update single row of the table: "questionnaire_uploads" */
  update_questionnaire_uploads_by_pk?: Maybe<Questionnaire_Uploads>;
  /** update multiples rows of table: "questionnaire_uploads" */
  update_questionnaire_uploads_many?: Maybe<Array<Maybe<Questionnaire_Uploads_Mutation_Response>>>;
  /** update data of the table: "questionnaires" */
  update_questionnaires?: Maybe<Questionnaires_Mutation_Response>;
  /** update single row of the table: "questionnaires" */
  update_questionnaires_by_pk?: Maybe<Questionnaires>;
  /** update multiples rows of table: "questionnaires" */
  update_questionnaires_many?: Maybe<Array<Maybe<Questionnaires_Mutation_Response>>>;
  /** update data of the table: "reports" */
  update_reports?: Maybe<Reports_Mutation_Response>;
  /** update single row of the table: "reports" */
  update_reports_by_pk?: Maybe<Reports>;
  /** update multiples rows of table: "reports" */
  update_reports_many?: Maybe<Array<Maybe<Reports_Mutation_Response>>>;
  /** update data of the table: "review_files" */
  update_review_files?: Maybe<Review_Files_Mutation_Response>;
  /** update single row of the table: "review_files" */
  update_review_files_by_pk?: Maybe<Review_Files>;
  /** update multiples rows of table: "review_files" */
  update_review_files_many?: Maybe<Array<Maybe<Review_Files_Mutation_Response>>>;
  /** update data of the table: "reviews" */
  update_reviews?: Maybe<Reviews_Mutation_Response>;
  /** update single row of the table: "reviews" */
  update_reviews_by_pk?: Maybe<Reviews>;
  /** update multiples rows of table: "reviews" */
  update_reviews_many?: Maybe<Array<Maybe<Reviews_Mutation_Response>>>;
  /** update data of the table: "risk_approvals" */
  update_risk_approvals?: Maybe<Risk_Approvals_Mutation_Response>;
  /** update single row of the table: "risk_approvals" */
  update_risk_approvals_by_pk?: Maybe<Risk_Approvals>;
  /** update multiples rows of table: "risk_approvals" */
  update_risk_approvals_many?: Maybe<Array<Maybe<Risk_Approvals_Mutation_Response>>>;
  /** update data of the table: "risk_approvers" */
  update_risk_approvers?: Maybe<Risk_Approvers_Mutation_Response>;
  /** update single row of the table: "risk_approvers" */
  update_risk_approvers_by_pk?: Maybe<Risk_Approvers>;
  /** update multiples rows of table: "risk_approvers" */
  update_risk_approvers_many?: Maybe<Array<Maybe<Risk_Approvers_Mutation_Response>>>;
  /** update data of the table: "risk_impacts" */
  update_risk_impacts?: Maybe<Risk_Impacts_Mutation_Response>;
  /** update single row of the table: "risk_impacts" */
  update_risk_impacts_by_pk?: Maybe<Risk_Impacts>;
  /** update multiples rows of table: "risk_impacts" */
  update_risk_impacts_many?: Maybe<Array<Maybe<Risk_Impacts_Mutation_Response>>>;
  /** update data of the table: "risk_inherent_levels" */
  update_risk_inherent_levels?: Maybe<Risk_Inherent_Levels_Mutation_Response>;
  /** update single row of the table: "risk_inherent_levels" */
  update_risk_inherent_levels_by_pk?: Maybe<Risk_Inherent_Levels>;
  /** update multiples rows of table: "risk_inherent_levels" */
  update_risk_inherent_levels_many?: Maybe<Array<Maybe<Risk_Inherent_Levels_Mutation_Response>>>;
  /** update data of the table: "risk_likelihoods" */
  update_risk_likelihoods?: Maybe<Risk_Likelihoods_Mutation_Response>;
  /** update single row of the table: "risk_likelihoods" */
  update_risk_likelihoods_by_pk?: Maybe<Risk_Likelihoods>;
  /** update multiples rows of table: "risk_likelihoods" */
  update_risk_likelihoods_many?: Maybe<Array<Maybe<Risk_Likelihoods_Mutation_Response>>>;
  /** update data of the table: "risk_residual_levels" */
  update_risk_residual_levels?: Maybe<Risk_Residual_Levels_Mutation_Response>;
  /** update single row of the table: "risk_residual_levels" */
  update_risk_residual_levels_by_pk?: Maybe<Risk_Residual_Levels>;
  /** update multiples rows of table: "risk_residual_levels" */
  update_risk_residual_levels_many?: Maybe<Array<Maybe<Risk_Residual_Levels_Mutation_Response>>>;
  /** update data of the table: "risks" */
  update_risks?: Maybe<Risks_Mutation_Response>;
  /** update single row of the table: "risks" */
  update_risks_by_pk?: Maybe<Risks>;
  /** update multiples rows of table: "risks" */
  update_risks_many?: Maybe<Array<Maybe<Risks_Mutation_Response>>>;
  /** update data of the table: "roles" */
  update_roles?: Maybe<Roles_Mutation_Response>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: Maybe<Roles>;
  /** update multiples rows of table: "roles" */
  update_roles_many?: Maybe<Array<Maybe<Roles_Mutation_Response>>>;
  /** update data of the table: "select_field_configs" */
  update_select_field_configs?: Maybe<Select_Field_Configs_Mutation_Response>;
  /** update single row of the table: "select_field_configs" */
  update_select_field_configs_by_pk?: Maybe<Select_Field_Configs>;
  /** update multiples rows of table: "select_field_configs" */
  update_select_field_configs_many?: Maybe<Array<Maybe<Select_Field_Configs_Mutation_Response>>>;
  /** update data of the table: "select_field_options" */
  update_select_field_options?: Maybe<Select_Field_Options_Mutation_Response>;
  /** update single row of the table: "select_field_options" */
  update_select_field_options_by_pk?: Maybe<Select_Field_Options>;
  /** update multiples rows of table: "select_field_options" */
  update_select_field_options_many?: Maybe<Array<Maybe<Select_Field_Options_Mutation_Response>>>;
  /** update data of the table: "service_accounts" */
  update_service_accounts?: Maybe<Service_Accounts_Mutation_Response>;
  /** update single row of the table: "service_accounts" */
  update_service_accounts_by_pk?: Maybe<Service_Accounts>;
  /** update multiples rows of table: "service_accounts" */
  update_service_accounts_many?: Maybe<Array<Maybe<Service_Accounts_Mutation_Response>>>;
  /** update data of the table: "tags" */
  update_tags?: Maybe<Tags_Mutation_Response>;
  /** update single row of the table: "tags" */
  update_tags_by_pk?: Maybe<Tags>;
  /** update multiples rows of table: "tags" */
  update_tags_many?: Maybe<Array<Maybe<Tags_Mutation_Response>>>;
  /** update data of the table: "tasks" */
  update_tasks?: Maybe<Tasks_Mutation_Response>;
  /** update single row of the table: "tasks" */
  update_tasks_by_pk?: Maybe<Tasks>;
  /** update multiples rows of table: "tasks" */
  update_tasks_many?: Maybe<Array<Maybe<Tasks_Mutation_Response>>>;
  /** update data of the table: "teams" */
  update_teams?: Maybe<Teams_Mutation_Response>;
  /** update single row of the table: "teams" */
  update_teams_by_pk?: Maybe<Teams>;
  /** update multiples rows of table: "teams" */
  update_teams_many?: Maybe<Array<Maybe<Teams_Mutation_Response>>>;
  /** update data of the table: "text_field_values" */
  update_text_field_values?: Maybe<Text_Field_Values_Mutation_Response>;
  /** update single row of the table: "text_field_values" */
  update_text_field_values_by_pk?: Maybe<Text_Field_Values>;
  /** update multiples rows of table: "text_field_values" */
  update_text_field_values_many?: Maybe<Array<Maybe<Text_Field_Values_Mutation_Response>>>;
  /** update data of the table: "trust_portal.access_requests" */
  update_trust_portal_access_requests?: Maybe<Trust_Portal_Access_Requests_Mutation_Response>;
  /** update single row of the table: "trust_portal.access_requests" */
  update_trust_portal_access_requests_by_pk?: Maybe<Trust_Portal_Access_Requests>;
  /** update multiples rows of table: "trust_portal.access_requests" */
  update_trust_portal_access_requests_many?: Maybe<
    Array<Maybe<Trust_Portal_Access_Requests_Mutation_Response>>
  >;
  /** update data of the table: "trust_portal.categories" */
  update_trust_portal_categories?: Maybe<Trust_Portal_Categories_Mutation_Response>;
  /** update single row of the table: "trust_portal.categories" */
  update_trust_portal_categories_by_pk?: Maybe<Trust_Portal_Categories>;
  /** update multiples rows of table: "trust_portal.categories" */
  update_trust_portal_categories_many?: Maybe<
    Array<Maybe<Trust_Portal_Categories_Mutation_Response>>
  >;
  /** update data of the table: "trust_portal.documents" */
  update_trust_portal_documents?: Maybe<Trust_Portal_Documents_Mutation_Response>;
  /** update single row of the table: "trust_portal.documents" */
  update_trust_portal_documents_by_pk?: Maybe<Trust_Portal_Documents>;
  /** update multiples rows of table: "trust_portal.documents" */
  update_trust_portal_documents_many?: Maybe<
    Array<Maybe<Trust_Portal_Documents_Mutation_Response>>
  >;
  /** update data of the table: "trust_portal.faqs" */
  update_trust_portal_faqs?: Maybe<Trust_Portal_Faqs_Mutation_Response>;
  /** update single row of the table: "trust_portal.faqs" */
  update_trust_portal_faqs_by_pk?: Maybe<Trust_Portal_Faqs>;
  /** update multiples rows of table: "trust_portal.faqs" */
  update_trust_portal_faqs_many?: Maybe<Array<Maybe<Trust_Portal_Faqs_Mutation_Response>>>;
  /** update data of the table: "trust_portal.frameworks" */
  update_trust_portal_frameworks?: Maybe<Trust_Portal_Frameworks_Mutation_Response>;
  /** update single row of the table: "trust_portal.frameworks" */
  update_trust_portal_frameworks_by_pk?: Maybe<Trust_Portal_Frameworks>;
  /** update multiples rows of table: "trust_portal.frameworks" */
  update_trust_portal_frameworks_many?: Maybe<
    Array<Maybe<Trust_Portal_Frameworks_Mutation_Response>>
  >;
  /** update data of the table: "trust_portal.pages" */
  update_trust_portal_pages?: Maybe<Trust_Portal_Pages_Mutation_Response>;
  /** update single row of the table: "trust_portal.pages" */
  update_trust_portal_pages_by_pk?: Maybe<Trust_Portal_Pages>;
  /** update multiples rows of table: "trust_portal.pages" */
  update_trust_portal_pages_many?: Maybe<Array<Maybe<Trust_Portal_Pages_Mutation_Response>>>;
  /** update data of the table: "trust_portal.resource_sections" */
  update_trust_portal_resource_sections?: Maybe<Trust_Portal_Resource_Sections_Mutation_Response>;
  /** update single row of the table: "trust_portal.resource_sections" */
  update_trust_portal_resource_sections_by_pk?: Maybe<Trust_Portal_Resource_Sections>;
  /** update multiples rows of table: "trust_portal.resource_sections" */
  update_trust_portal_resource_sections_many?: Maybe<
    Array<Maybe<Trust_Portal_Resource_Sections_Mutation_Response>>
  >;
  /** update data of the table: "trust_portal.updates" */
  update_trust_portal_updates?: Maybe<Trust_Portal_Updates_Mutation_Response>;
  /** update single row of the table: "trust_portal.updates" */
  update_trust_portal_updates_by_pk?: Maybe<Trust_Portal_Updates>;
  /** update multiples rows of table: "trust_portal.updates" */
  update_trust_portal_updates_many?: Maybe<Array<Maybe<Trust_Portal_Updates_Mutation_Response>>>;
  /** update data of the table: "url_field_values" */
  update_url_field_values?: Maybe<Url_Field_Values_Mutation_Response>;
  /** update single row of the table: "url_field_values" */
  update_url_field_values_by_pk?: Maybe<Url_Field_Values>;
  /** update multiples rows of table: "url_field_values" */
  update_url_field_values_many?: Maybe<Array<Maybe<Url_Field_Values_Mutation_Response>>>;
  /** update data of the table: "user_notifications" */
  update_user_notifications?: Maybe<User_Notifications_Mutation_Response>;
  /** update single row of the table: "user_notifications" */
  update_user_notifications_by_pk?: Maybe<User_Notifications>;
  /** update multiples rows of table: "user_notifications" */
  update_user_notifications_many?: Maybe<Array<Maybe<User_Notifications_Mutation_Response>>>;
  /** update data of the table: "user_profiles" */
  update_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** update single row of the table: "user_profiles" */
  update_user_profiles_by_pk?: Maybe<User_Profiles>;
  /** update multiples rows of table: "user_profiles" */
  update_user_profiles_many?: Maybe<Array<Maybe<User_Profiles_Mutation_Response>>>;
  /** update multiples rows of table: "auth.users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** Update vendor approval status when vendor approval workflows are disabled */
  update_vendor_approval_status?: Maybe<GeneralActionOutput>;
  /** update data of the table: "vendor_approvals" */
  update_vendor_approvals?: Maybe<Vendor_Approvals_Mutation_Response>;
  /** update single row of the table: "vendor_approvals" */
  update_vendor_approvals_by_pk?: Maybe<Vendor_Approvals>;
  /** update multiples rows of table: "vendor_approvals" */
  update_vendor_approvals_many?: Maybe<Array<Maybe<Vendor_Approvals_Mutation_Response>>>;
  /** update data of the table: "vendor_approvers" */
  update_vendor_approvers?: Maybe<Vendor_Approvers_Mutation_Response>;
  /** update single row of the table: "vendor_approvers" */
  update_vendor_approvers_by_pk?: Maybe<Vendor_Approvers>;
  /** update multiples rows of table: "vendor_approvers" */
  update_vendor_approvers_many?: Maybe<Array<Maybe<Vendor_Approvers_Mutation_Response>>>;
  /** update data of the table: "vendor_findings" */
  update_vendor_findings?: Maybe<Vendor_Findings_Mutation_Response>;
  /** update single row of the table: "vendor_findings" */
  update_vendor_findings_by_pk?: Maybe<Vendor_Findings>;
  /** update multiples rows of table: "vendor_findings" */
  update_vendor_findings_many?: Maybe<Array<Maybe<Vendor_Findings_Mutation_Response>>>;
  /** update data of the table: "vendor_questionnaire_schedules" */
  update_vendor_questionnaire_schedules?: Maybe<Vendor_Questionnaire_Schedules_Mutation_Response>;
  /** update single row of the table: "vendor_questionnaire_schedules" */
  update_vendor_questionnaire_schedules_by_pk?: Maybe<Vendor_Questionnaire_Schedules>;
  /** update multiples rows of table: "vendor_questionnaire_schedules" */
  update_vendor_questionnaire_schedules_many?: Maybe<
    Array<Maybe<Vendor_Questionnaire_Schedules_Mutation_Response>>
  >;
  /** update data of the table: "vendor_questionnaires" */
  update_vendor_questionnaires?: Maybe<Vendor_Questionnaires_Mutation_Response>;
  /** update single row of the table: "vendor_questionnaires" */
  update_vendor_questionnaires_by_pk?: Maybe<Vendor_Questionnaires>;
  /** update multiples rows of table: "vendor_questionnaires" */
  update_vendor_questionnaires_many?: Maybe<Array<Maybe<Vendor_Questionnaires_Mutation_Response>>>;
  /** update data of the table: "vendors" */
  update_vendors?: Maybe<Vendors_Mutation_Response>;
  /** update single row of the table: "vendors" */
  update_vendors_by_pk?: Maybe<Vendors>;
  /** update multiples rows of table: "vendors" */
  update_vendors_many?: Maybe<Array<Maybe<Vendors_Mutation_Response>>>;
  /** update data of the table: "vq_custom_fields" */
  update_vq_custom_fields?: Maybe<Vq_Custom_Fields_Mutation_Response>;
  /** update single row of the table: "vq_custom_fields" */
  update_vq_custom_fields_by_pk?: Maybe<Vq_Custom_Fields>;
  /** update multiples rows of table: "vq_custom_fields" */
  update_vq_custom_fields_many?: Maybe<Array<Maybe<Vq_Custom_Fields_Mutation_Response>>>;
  verify_email_sender?: Maybe<EmailSenderStatusOutput>;
  verify_trust_portal_domain?: Maybe<TrustPortalDomainStatusOutput>;
};

/** mutation root */
export type Mutation_RootActivate_Trust_Portal_Nda_GateArgs = {
  pageId: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootAi_Autocomplete_EntityArgs = {
  input: AiAutocompleteEntityInput;
};

/** mutation root */
export type Mutation_RootAi_Create_EntityArgs = {
  input: Scalars['AiCreateEntityInput']['input'];
};

/** mutation root */
export type Mutation_RootBulk_Set_Select_Field_ValuesArgs = {
  input: BulkSetSelectFieldValuesInput;
};

/** mutation root */
export type Mutation_RootBulk_Upload_PoliciesArgs = {
  object: BulkUploadPoliciesInput;
};

/** mutation root */
export type Mutation_RootCommand_FindingsArgs = {
  args: FindingBatchCommandArgs;
};

/** mutation root */
export type Mutation_RootCreate_Api_KeyArgs = {
  payload: CreateApiKeyInput;
};

/** mutation root */
export type Mutation_RootCreate_ControlArgs = {
  payload: CreateControlInput;
};

/** mutation root */
export type Mutation_RootCreate_Custom_Program_RequestArgs = {
  payload: CreateCustomProgramRequestInput;
};

/** mutation root */
export type Mutation_RootCreate_FindingArgs = {
  args: FindingSingleCommandArgs;
};

/** mutation root */
export type Mutation_RootCreate_Framework_RequestArgs = {
  object: FrameworkRequestInput;
};

/** mutation root */
export type Mutation_RootCreate_Manual_FindingArgs = {
  input: CreateManualFindingInput;
};

/** mutation root */
export type Mutation_RootCreate_Manual_Integration_ConnectorArgs = {
  input: CreateManualIntegrationConnectorInput;
};

/** mutation root */
export type Mutation_RootCreate_Policy_Version_SnapshotArgs = {
  policy_version_id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootCreate_ProgramArgs = {
  object: CreateProgramInput;
};

/** mutation root */
export type Mutation_RootCreate_Service_AccountArgs = {
  payload: CreateServiceAccountInput;
};

/** mutation root */
export type Mutation_RootCreate_Trust_Portal_Access_LinkArgs = {
  accessRequestId: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootCreate_Vendor_Finding_TaskArgs = {
  input: CreateVendorFindingTaskInput;
};

/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokensArgs = {
  where: AuthRefreshTokens_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_CategoriesArgs = {
  where: Categories_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Client_QuestionnairesArgs = {
  where: Client_Questionnaires_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Client_Questionnaires_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Comment_UploadsArgs = {
  where: Comment_Uploads_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Comment_Uploads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_CommentsArgs = {
  where: Comments_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Comments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Control_Ai_Review_CriteriaArgs = {
  where: Control_Ai_Review_Criteria_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Control_Ai_Review_Criteria_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Control_CategoriesArgs = {
  where: Control_Categories_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Control_Categories_By_PkArgs = {
  category_id: Scalars['uuid']['input'];
  control_id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Control_CriteriaArgs = {
  where: Control_Criteria_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Control_Criteria_By_PkArgs = {
  control_id: Scalars['uuid']['input'];
  criteria_id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Control_EvidencesArgs = {
  where: Control_Evidences_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Control_Evidences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Control_GroupsArgs = {
  where: Control_Groups_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Control_Groups_By_PkArgs = {
  control_id: Scalars['uuid']['input'];
  group_id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Control_OwnersArgs = {
  where: Control_Owners_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Control_Owners_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Control_TagsArgs = {
  where: Control_Tags_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Control_Tags_By_PkArgs = {
  control_id: Scalars['uuid']['input'];
  tag_id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Control_TasksArgs = {
  where: Control_Tasks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Control_Tasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_ControlsArgs = {
  where: Controls_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Controls_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_CriteriaArgs = {
  where: Criteria_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Criteria_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Entity_RelationsArgs = {
  where: Entity_Relations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Entity_Relations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Evidence_IntegrationsArgs = {
  where: Evidence_Integrations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Evidence_Integrations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Evidence_OwnersArgs = {
  where: Evidence_Owners_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Evidence_Owners_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Evidence_PoliciesArgs = {
  where: Evidence_Policies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Evidence_Policies_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Evidence_TagsArgs = {
  where: Evidence_Tags_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Evidence_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Evidence_TasksArgs = {
  where: Evidence_Tasks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Evidence_Tasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Evidence_Version_FileArgs = {
  where: Evidence_Version_File_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Evidence_Version_File_By_PkArgs = {
  evidence_version_id: Scalars['uuid']['input'];
  file_id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Evidence_VersionsArgs = {
  where: Evidence_Versions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Evidence_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_EvidencesArgs = {
  where: Evidences_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Evidences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Field_ConfigsArgs = {
  where: Field_Configs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Field_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Field_ValuesArgs = {
  where: Field_Values_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Field_Values_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Finding_ResolutionsArgs = {
  where: Finding_Resolutions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Finding_Resolutions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_FormsArgs = {
  where: Forms_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Forms_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_GroupsArgs = {
  where: Groups_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Groups_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_InvitationsArgs = {
  where: Invitations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Invitations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Manual_FindingsArgs = {
  where: Manual_Findings_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Manual_Findings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Notification_Disabled_SettingsArgs = {
  where: Notification_Disabled_Settings_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Notification_Disabled_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Organization_Evidence_TagsArgs = {
  where: Organization_Evidence_Tags_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organization_Evidence_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Organization_Finding_SeveritiesArgs = {
  where: Organization_Finding_Severities_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organization_Finding_Severities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Organization_IntegrationsArgs = {
  where: Organization_Integrations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organization_Integrations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Organization_Risk_CategoriesArgs = {
  where: Organization_Risk_Categories_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organization_Risk_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Organization_Risk_LevelsArgs = {
  where: Organization_Risk_Levels_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organization_Risk_Levels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Organization_Risk_TagsArgs = {
  where: Organization_Risk_Tags_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organization_Risk_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Organization_Vendor_Risk_LevelsArgs = {
  where: Organization_Vendor_Risk_Levels_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organization_Vendor_Risk_Levels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Organization_Vendor_TiersArgs = {
  where: Organization_Vendor_Tiers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organization_Vendor_Tiers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_PoliciesArgs = {
  where: Policies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Policies_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Policy_Acknowledgement_UsersArgs = {
  where: Policy_Acknowledgement_Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Policy_Acknowledgement_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Policy_AcknowledgementsArgs = {
  where: Policy_Acknowledgements_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Policy_Acknowledgements_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Policy_Approval_UsersArgs = {
  where: Policy_Approval_Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Policy_Approval_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Policy_ApprovalsArgs = {
  where: Policy_Approvals_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Policy_Approvals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Policy_ApproversArgs = {
  where: Policy_Approvers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Policy_Approvers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Policy_Exception_ApproversArgs = {
  where: Policy_Exception_Approvers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Policy_Exception_Approvers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Policy_Exception_FilesArgs = {
  where: Policy_Exception_Files_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Policy_Exception_Files_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Policy_ExceptionsArgs = {
  where: Policy_Exceptions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Policy_Exceptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Policy_IntegrationsArgs = {
  where: Policy_Integrations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Policy_Integrations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Policy_OwnersArgs = {
  where: Policy_Owners_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Policy_Owners_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Policy_TasksArgs = {
  where: Policy_Tasks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Policy_Tasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Policy_VersionsArgs = {
  where: Policy_Versions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Policy_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Program_AssigneesArgs = {
  where: Program_Assignees_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Program_ControlsArgs = {
  where: Program_Controls_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Program_Controls_By_PkArgs = {
  control_id: Scalars['uuid']['input'];
  program_id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Program_Field_ConfigsArgs = {
  where: Program_Field_Configs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Program_Field_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_ProgramsArgs = {
  where: Programs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Programs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Questionnaire_UploadsArgs = {
  where: Questionnaire_Uploads_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Questionnaire_Uploads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_QuestionnairesArgs = {
  where: Questionnaires_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Questionnaires_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_ReportsArgs = {
  where: Reports_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Review_FilesArgs = {
  where: Review_Files_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Review_Files_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_ReviewsArgs = {
  where: Reviews_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Reviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Risk_Approval_FilesArgs = {
  where: Risk_Approval_Files_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Risk_Approval_Files_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Risk_Approval_Reason_EntriesArgs = {
  where: Risk_Approval_Reason_Entries_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Risk_Approval_Reason_Entries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Risk_ApprovalsArgs = {
  where: Risk_Approvals_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Risk_Approvals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Risk_ApproversArgs = {
  where: Risk_Approvers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Risk_Approvers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Risk_CategoriesArgs = {
  where: Risk_Categories_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Risk_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Risk_ControlsArgs = {
  where: Risk_Controls_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Risk_Controls_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Risk_DocumentsArgs = {
  where: Risk_Documents_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Risk_Documents_By_PkArgs = {
  file_id: Scalars['uuid']['input'];
  risk_id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Risk_ImpactsArgs = {
  where: Risk_Impacts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Risk_Impacts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Risk_LikelihoodsArgs = {
  where: Risk_Likelihoods_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Risk_Likelihoods_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Risk_OwnersArgs = {
  where: Risk_Owners_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Risk_Owners_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Risk_TagsArgs = {
  where: Risk_Tags_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Risk_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Risk_TasksArgs = {
  where: Risk_Tasks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Risk_Tasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_RisksArgs = {
  where: Risks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Risks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Role_PermissionsArgs = {
  where: Role_Permissions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Role_Permissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_RolesArgs = {
  where: Roles_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Select_Field_OptionsArgs = {
  where: Select_Field_Options_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Select_Field_Options_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Service_AccountArgs = {
  payload: DeleteServiceAccountInput;
};

/** mutation root */
export type Mutation_RootDelete_TagsArgs = {
  where: Tags_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Task_OwnersArgs = {
  where: Task_Owners_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Task_Owners_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_TasksArgs = {
  where: Tasks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Tasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Team_MembersArgs = {
  where: Team_Members_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Team_Members_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_TeamsArgs = {
  where: Teams_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_Document_Resource_SectionsArgs = {
  where: Trust_Portal_Document_Resource_Sections_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_Document_Resource_Sections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_DocumentsArgs = {
  where: Trust_Portal_Documents_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_FaqsArgs = {
  where: Trust_Portal_Faqs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_Faqs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_FrameworksArgs = {
  where: Trust_Portal_Frameworks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_Frameworks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_Resource_SectionsArgs = {
  where: Trust_Portal_Resource_Sections_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_Resource_Sections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_Update_CategoriesArgs = {
  where: Trust_Portal_Update_Categories_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_Update_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_UpdatesArgs = {
  where: Trust_Portal_Updates_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Trust_Portal_Updates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Approval_FilesArgs = {
  where: Vendor_Approval_Files_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Approval_Files_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Vendor_ApprovalsArgs = {
  where: Vendor_Approvals_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Approvals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Vendor_ApproversArgs = {
  where: Vendor_Approvers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Approvers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Vendor_DocumentsArgs = {
  where: Vendor_Documents_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Documents_By_PkArgs = {
  file_id: Scalars['uuid']['input'];
  vendor_id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Vendor_OwnersArgs = {
  where: Vendor_Owners_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Owners_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Questionnaire_FormsArgs = {
  where: Vendor_Questionnaire_Forms_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Questionnaire_Forms_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Questionnaire_SchedulesArgs = {
  where: Vendor_Questionnaire_Schedules_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Questionnaire_Schedules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Questionnaire_UploadsArgs = {
  where: Vendor_Questionnaire_Uploads_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Questionnaire_Uploads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Vendor_QuestionnairesArgs = {
  where: Vendor_Questionnaires_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Questionnaires_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Vendor_RisksArgs = {
  where: Vendor_Risks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Risks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Vendor_TasksArgs = {
  where: Vendor_Tasks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Vendor_Tasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_VendorsArgs = {
  where: Vendors_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Vendors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Vq_Custom_FieldsArgs = {
  where: Vq_Custom_Fields_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Vq_Custom_Fields_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDeny_Trust_Portal_AccessArgs = {
  object: TrustPortalAccessDecisionInput;
};

/** mutation root */
export type Mutation_RootDisconnect_IntegrationArgs = {
  input: DisconnectIntegrationInput;
};

/** mutation root */
export type Mutation_RootDisconnect_Mcp_ConnectionArgs = {
  payload: DisconnectMcpConnectionInput;
};

/** mutation root */
export type Mutation_RootDisconnect_Trust_Portal_Nda_GateArgs = {
  object: DisconnectTrustPortalNdaGateInput;
};

/** mutation root */
export type Mutation_RootDuplicate_ControlsArgs = {
  ids: Array<Scalars['String']['input']>;
};

/** mutation root */
export type Mutation_RootDuplicate_EvidencesArgs = {
  ids: Array<Scalars['String']['input']>;
};

/** mutation root */
export type Mutation_RootDuplicate_PoliciesArgs = {
  ids: Array<Scalars['String']['input']>;
};

/** mutation root */
export type Mutation_RootDuplicate_ProgramArgs = {
  input: DuplicateProgramInput;
};

/** mutation root */
export type Mutation_RootDuplicate_QuestionnairesArgs = {
  ids: Array<Scalars['String']['input']>;
};

/** mutation root */
export type Mutation_RootDuplicate_RisksArgs = {
  ids: Array<Scalars['String']['input']>;
};

/** mutation root */
export type Mutation_RootDuplicate_TaskArgs = {
  id: Scalars['String']['input'];
  parent?: InputMaybe<DuplicateTaskParentInput>;
};

/** mutation root */
export type Mutation_RootDuplicate_TasksArgs = {
  ids: Array<Scalars['String']['input']>;
  parent?: InputMaybe<DuplicateTaskParentInput>;
};

/** mutation root */
export type Mutation_RootDuplicate_VendorsArgs = {
  ids: Array<Scalars['String']['input']>;
};

/** mutation root */
export type Mutation_RootEdit_FindingsArgs = {
  args: FindingBatchCommandArgs;
};

/** mutation root */
export type Mutation_RootExport_Client_QuestionnaireArgs = {
  input: ExportClientQuestionnaireInput;
};

/** mutation root */
export type Mutation_RootExport_PolicyArgs = {
  input: ExportPolicyInput;
};

/** mutation root */
export type Mutation_RootExport_Policy_VersionArgs = {
  input: ExportPolicyVersionInput;
};

/** mutation root */
export type Mutation_RootExport_VendorArgs = {
  input: ExportVendorInput;
};

/** mutation root */
export type Mutation_RootGen_Integration_Run_ReportArgs = {
  input: GenIntegrationRunReportInput;
};

/** mutation root */
export type Mutation_RootGenerate_Vendor_Questionnaire_LinkArgs = {
  input: GenerateVendorQuestionnaireLinkInput;
};

/** mutation root */
export type Mutation_RootGenerate_Workos_Admin_LinkArgs = {
  object: GenerateWorkosAdminLinkInput;
};

/** mutation root */
export type Mutation_RootGrant_Evidence_AccessArgs = {
  input: GrantEvidenceAccessInput;
};

/** mutation root */
export type Mutation_RootGrant_Trust_Portal_AccessArgs = {
  object: TrustPortalGrantAccessInput;
};

/** mutation root */
export type Mutation_RootInsertFileArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsertFilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Agent_InstancesArgs = {
  objects: Array<Agent_Instances_Insert_Input>;
  on_conflict?: InputMaybe<Agent_Instances_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Agent_Instances_OneArgs = {
  object: Agent_Instances_Insert_Input;
  on_conflict?: InputMaybe<Agent_Instances_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_CategoriesArgs = {
  objects: Array<Categories_Insert_Input>;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Categories_OneArgs = {
  object: Categories_Insert_Input;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Client_Questionnaire_AnswersArgs = {
  objects: Array<Client_Questionnaire_Answers_Insert_Input>;
  on_conflict?: InputMaybe<Client_Questionnaire_Answers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Client_Questionnaire_Answers_OneArgs = {
  object: Client_Questionnaire_Answers_Insert_Input;
  on_conflict?: InputMaybe<Client_Questionnaire_Answers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Client_QuestionnairesArgs = {
  objects: Array<Client_Questionnaires_Insert_Input>;
  on_conflict?: InputMaybe<Client_Questionnaires_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Client_Questionnaires_OneArgs = {
  object: Client_Questionnaires_Insert_Input;
  on_conflict?: InputMaybe<Client_Questionnaires_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Comment_UploadsArgs = {
  objects: Array<Comment_Uploads_Insert_Input>;
  on_conflict?: InputMaybe<Comment_Uploads_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Comment_Uploads_OneArgs = {
  object: Comment_Uploads_Insert_Input;
  on_conflict?: InputMaybe<Comment_Uploads_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_CommentsArgs = {
  objects: Array<Comments_Insert_Input>;
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Comments_OneArgs = {
  object: Comments_Insert_Input;
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_Ai_Review_CriteriaArgs = {
  objects: Array<Control_Ai_Review_Criteria_Insert_Input>;
  on_conflict?: InputMaybe<Control_Ai_Review_Criteria_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_Ai_Review_Criteria_OneArgs = {
  object: Control_Ai_Review_Criteria_Insert_Input;
  on_conflict?: InputMaybe<Control_Ai_Review_Criteria_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_CategoriesArgs = {
  objects: Array<Control_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Control_Categories_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_Categories_OneArgs = {
  object: Control_Categories_Insert_Input;
  on_conflict?: InputMaybe<Control_Categories_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_CriteriaArgs = {
  objects: Array<Control_Criteria_Insert_Input>;
  on_conflict?: InputMaybe<Control_Criteria_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_Criteria_OneArgs = {
  object: Control_Criteria_Insert_Input;
  on_conflict?: InputMaybe<Control_Criteria_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_EvidencesArgs = {
  objects: Array<Control_Evidences_Insert_Input>;
  on_conflict?: InputMaybe<Control_Evidences_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_Evidences_OneArgs = {
  object: Control_Evidences_Insert_Input;
  on_conflict?: InputMaybe<Control_Evidences_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_GroupsArgs = {
  objects: Array<Control_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Control_Groups_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_Groups_OneArgs = {
  object: Control_Groups_Insert_Input;
  on_conflict?: InputMaybe<Control_Groups_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_OwnersArgs = {
  objects: Array<Control_Owners_Insert_Input>;
  on_conflict?: InputMaybe<Control_Owners_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_Owners_OneArgs = {
  object: Control_Owners_Insert_Input;
  on_conflict?: InputMaybe<Control_Owners_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_TagsArgs = {
  objects: Array<Control_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Control_Tags_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_Tags_OneArgs = {
  object: Control_Tags_Insert_Input;
  on_conflict?: InputMaybe<Control_Tags_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_TasksArgs = {
  objects: Array<Control_Tasks_Insert_Input>;
  on_conflict?: InputMaybe<Control_Tasks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Control_Tasks_OneArgs = {
  object: Control_Tasks_Insert_Input;
  on_conflict?: InputMaybe<Control_Tasks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ControlsArgs = {
  objects: Array<Controls_Insert_Input>;
  on_conflict?: InputMaybe<Controls_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Controls_OneArgs = {
  object: Controls_Insert_Input;
  on_conflict?: InputMaybe<Controls_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_CriteriaArgs = {
  objects: Array<Criteria_Insert_Input>;
  on_conflict?: InputMaybe<Criteria_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Criteria_OneArgs = {
  object: Criteria_Insert_Input;
  on_conflict?: InputMaybe<Criteria_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Date_Field_ValuesArgs = {
  objects: Array<Date_Field_Values_Insert_Input>;
  on_conflict?: InputMaybe<Date_Field_Values_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Date_Field_Values_OneArgs = {
  object: Date_Field_Values_Insert_Input;
  on_conflict?: InputMaybe<Date_Field_Values_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_DocumentsArgs = {
  objects: Array<Documents_Insert_Input>;
  on_conflict?: InputMaybe<Documents_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Documents_OneArgs = {
  object: Documents_Insert_Input;
  on_conflict?: InputMaybe<Documents_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Email_Field_ValuesArgs = {
  objects: Array<Email_Field_Values_Insert_Input>;
  on_conflict?: InputMaybe<Email_Field_Values_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Email_Field_Values_OneArgs = {
  object: Email_Field_Values_Insert_Input;
  on_conflict?: InputMaybe<Email_Field_Values_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Entity_RelationsArgs = {
  objects: Array<Entity_Relations_Insert_Input>;
  on_conflict?: InputMaybe<Entity_Relations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Entity_Relations_OneArgs = {
  object: Entity_Relations_Insert_Input;
  on_conflict?: InputMaybe<Entity_Relations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_IntegrationsArgs = {
  objects: Array<Evidence_Integrations_Insert_Input>;
  on_conflict?: InputMaybe<Evidence_Integrations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_Integrations_OneArgs = {
  object: Evidence_Integrations_Insert_Input;
  on_conflict?: InputMaybe<Evidence_Integrations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_OwnersArgs = {
  objects: Array<Evidence_Owners_Insert_Input>;
  on_conflict?: InputMaybe<Evidence_Owners_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_Owners_OneArgs = {
  object: Evidence_Owners_Insert_Input;
  on_conflict?: InputMaybe<Evidence_Owners_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_PoliciesArgs = {
  objects: Array<Evidence_Policies_Insert_Input>;
  on_conflict?: InputMaybe<Evidence_Policies_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_Policies_OneArgs = {
  object: Evidence_Policies_Insert_Input;
  on_conflict?: InputMaybe<Evidence_Policies_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_TagsArgs = {
  objects: Array<Evidence_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Evidence_Tags_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_Tags_OneArgs = {
  object: Evidence_Tags_Insert_Input;
  on_conflict?: InputMaybe<Evidence_Tags_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_TasksArgs = {
  objects: Array<Evidence_Tasks_Insert_Input>;
  on_conflict?: InputMaybe<Evidence_Tasks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_Tasks_OneArgs = {
  object: Evidence_Tasks_Insert_Input;
  on_conflict?: InputMaybe<Evidence_Tasks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_Version_FileArgs = {
  objects: Array<Evidence_Version_File_Insert_Input>;
  on_conflict?: InputMaybe<Evidence_Version_File_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_Version_File_OneArgs = {
  object: Evidence_Version_File_Insert_Input;
  on_conflict?: InputMaybe<Evidence_Version_File_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_VersionsArgs = {
  objects: Array<Evidence_Versions_Insert_Input>;
  on_conflict?: InputMaybe<Evidence_Versions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidence_Versions_OneArgs = {
  object: Evidence_Versions_Insert_Input;
  on_conflict?: InputMaybe<Evidence_Versions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_EvidencesArgs = {
  objects: Array<Evidences_Insert_Input>;
  on_conflict?: InputMaybe<Evidences_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Evidences_OneArgs = {
  object: Evidences_Insert_Input;
  on_conflict?: InputMaybe<Evidences_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Field_ConfigsArgs = {
  objects: Array<Field_Configs_Insert_Input>;
  on_conflict?: InputMaybe<Field_Configs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Field_Configs_OneArgs = {
  object: Field_Configs_Insert_Input;
  on_conflict?: InputMaybe<Field_Configs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Field_ValuesArgs = {
  objects: Array<Field_Values_Insert_Input>;
  on_conflict?: InputMaybe<Field_Values_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Field_Values_OneArgs = {
  object: Field_Values_Insert_Input;
  on_conflict?: InputMaybe<Field_Values_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Finding_ResolutionsArgs = {
  objects: Array<Finding_Resolutions_Insert_Input>;
  on_conflict?: InputMaybe<Finding_Resolutions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Finding_Resolutions_OneArgs = {
  object: Finding_Resolutions_Insert_Input;
  on_conflict?: InputMaybe<Finding_Resolutions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_FormsArgs = {
  objects: Array<Forms_Insert_Input>;
  on_conflict?: InputMaybe<Forms_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Forms_OneArgs = {
  object: Forms_Insert_Input;
  on_conflict?: InputMaybe<Forms_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_FrameworksArgs = {
  objects: Array<Frameworks_Insert_Input>;
  on_conflict?: InputMaybe<Frameworks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Frameworks_ControlsArgs = {
  objects: Array<Frameworks_Controls_Insert_Input>;
  on_conflict?: InputMaybe<Frameworks_Controls_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Frameworks_Controls_OneArgs = {
  object: Frameworks_Controls_Insert_Input;
  on_conflict?: InputMaybe<Frameworks_Controls_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Frameworks_OneArgs = {
  object: Frameworks_Insert_Input;
  on_conflict?: InputMaybe<Frameworks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_GroupsArgs = {
  objects: Array<Groups_Insert_Input>;
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Groups_OneArgs = {
  object: Groups_Insert_Input;
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_InvitationsArgs = {
  objects: Array<Invitations_Insert_Input>;
  on_conflict?: InputMaybe<Invitations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Invitations_OneArgs = {
  object: Invitations_Insert_Input;
  on_conflict?: InputMaybe<Invitations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Notification_Disabled_SettingsArgs = {
  objects: Array<Notification_Disabled_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Disabled_Settings_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Notification_Disabled_Settings_OneArgs = {
  object: Notification_Disabled_Settings_Insert_Input;
  on_conflict?: InputMaybe<Notification_Disabled_Settings_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Number_Field_ValuesArgs = {
  objects: Array<Number_Field_Values_Insert_Input>;
  on_conflict?: InputMaybe<Number_Field_Values_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Number_Field_Values_OneArgs = {
  object: Number_Field_Values_Insert_Input;
  on_conflict?: InputMaybe<Number_Field_Values_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Evidence_TagsArgs = {
  objects: Array<Organization_Evidence_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Evidence_Tags_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Evidence_Tags_OneArgs = {
  object: Organization_Evidence_Tags_Insert_Input;
  on_conflict?: InputMaybe<Organization_Evidence_Tags_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Finding_SeveritiesArgs = {
  objects: Array<Organization_Finding_Severities_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Finding_Severities_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Finding_Severities_OneArgs = {
  object: Organization_Finding_Severities_Insert_Input;
  on_conflict?: InputMaybe<Organization_Finding_Severities_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_ProfilesArgs = {
  objects: Array<Organization_Profiles_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Profiles_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Profiles_OneArgs = {
  object: Organization_Profiles_Insert_Input;
  on_conflict?: InputMaybe<Organization_Profiles_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Risk_CategoriesArgs = {
  objects: Array<Organization_Risk_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Risk_Categories_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Risk_Categories_OneArgs = {
  object: Organization_Risk_Categories_Insert_Input;
  on_conflict?: InputMaybe<Organization_Risk_Categories_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Risk_LevelsArgs = {
  objects: Array<Organization_Risk_Levels_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Risk_Levels_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Risk_Levels_OneArgs = {
  object: Organization_Risk_Levels_Insert_Input;
  on_conflict?: InputMaybe<Organization_Risk_Levels_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Risk_TagsArgs = {
  objects: Array<Organization_Risk_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Risk_Tags_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Risk_Tags_OneArgs = {
  object: Organization_Risk_Tags_Insert_Input;
  on_conflict?: InputMaybe<Organization_Risk_Tags_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Vendor_Risk_LevelsArgs = {
  objects: Array<Organization_Vendor_Risk_Levels_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Vendor_Risk_Levels_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Vendor_Risk_Levels_OneArgs = {
  object: Organization_Vendor_Risk_Levels_Insert_Input;
  on_conflict?: InputMaybe<Organization_Vendor_Risk_Levels_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Vendor_TiersArgs = {
  objects: Array<Organization_Vendor_Tiers_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Vendor_Tiers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organization_Vendor_Tiers_OneArgs = {
  object: Organization_Vendor_Tiers_Insert_Input;
  on_conflict?: InputMaybe<Organization_Vendor_Tiers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_PoliciesArgs = {
  objects: Array<Policies_Insert_Input>;
  on_conflict?: InputMaybe<Policies_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policies_OneArgs = {
  object: Policies_Insert_Input;
  on_conflict?: InputMaybe<Policies_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_Approval_UsersArgs = {
  objects: Array<Policy_Approval_Users_Insert_Input>;
  on_conflict?: InputMaybe<Policy_Approval_Users_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_Approval_Users_OneArgs = {
  object: Policy_Approval_Users_Insert_Input;
  on_conflict?: InputMaybe<Policy_Approval_Users_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_ApprovalsArgs = {
  objects: Array<Policy_Approvals_Insert_Input>;
  on_conflict?: InputMaybe<Policy_Approvals_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_Approvals_OneArgs = {
  object: Policy_Approvals_Insert_Input;
  on_conflict?: InputMaybe<Policy_Approvals_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_ApproversArgs = {
  objects: Array<Policy_Approvers_Insert_Input>;
  on_conflict?: InputMaybe<Policy_Approvers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_Approvers_OneArgs = {
  object: Policy_Approvers_Insert_Input;
  on_conflict?: InputMaybe<Policy_Approvers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_Exception_ApproversArgs = {
  objects: Array<Policy_Exception_Approvers_Insert_Input>;
  on_conflict?: InputMaybe<Policy_Exception_Approvers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_Exception_Approvers_OneArgs = {
  object: Policy_Exception_Approvers_Insert_Input;
  on_conflict?: InputMaybe<Policy_Exception_Approvers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_Exception_FilesArgs = {
  objects: Array<Policy_Exception_Files_Insert_Input>;
  on_conflict?: InputMaybe<Policy_Exception_Files_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_Exception_Files_OneArgs = {
  object: Policy_Exception_Files_Insert_Input;
  on_conflict?: InputMaybe<Policy_Exception_Files_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_ExceptionsArgs = {
  objects: Array<Policy_Exceptions_Insert_Input>;
  on_conflict?: InputMaybe<Policy_Exceptions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_Exceptions_OneArgs = {
  object: Policy_Exceptions_Insert_Input;
  on_conflict?: InputMaybe<Policy_Exceptions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_IntegrationsArgs = {
  objects: Array<Policy_Integrations_Insert_Input>;
  on_conflict?: InputMaybe<Policy_Integrations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_Integrations_OneArgs = {
  object: Policy_Integrations_Insert_Input;
  on_conflict?: InputMaybe<Policy_Integrations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_OwnersArgs = {
  objects: Array<Policy_Owners_Insert_Input>;
  on_conflict?: InputMaybe<Policy_Owners_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_Owners_OneArgs = {
  object: Policy_Owners_Insert_Input;
  on_conflict?: InputMaybe<Policy_Owners_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_TasksArgs = {
  objects: Array<Policy_Tasks_Insert_Input>;
  on_conflict?: InputMaybe<Policy_Tasks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_Tasks_OneArgs = {
  object: Policy_Tasks_Insert_Input;
  on_conflict?: InputMaybe<Policy_Tasks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_VersionsArgs = {
  objects: Array<Policy_Versions_Insert_Input>;
  on_conflict?: InputMaybe<Policy_Versions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Policy_Versions_OneArgs = {
  object: Policy_Versions_Insert_Input;
  on_conflict?: InputMaybe<Policy_Versions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Program_AssigneesArgs = {
  objects: Array<Program_Assignees_Insert_Input>;
  on_conflict?: InputMaybe<Program_Assignees_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Program_Assignees_OneArgs = {
  object: Program_Assignees_Insert_Input;
  on_conflict?: InputMaybe<Program_Assignees_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Program_ControlsArgs = {
  objects: Array<Program_Controls_Insert_Input>;
  on_conflict?: InputMaybe<Program_Controls_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Program_Controls_OneArgs = {
  object: Program_Controls_Insert_Input;
  on_conflict?: InputMaybe<Program_Controls_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Program_Field_ConfigsArgs = {
  objects: Array<Program_Field_Configs_Insert_Input>;
  on_conflict?: InputMaybe<Program_Field_Configs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Program_Field_Configs_OneArgs = {
  object: Program_Field_Configs_Insert_Input;
  on_conflict?: InputMaybe<Program_Field_Configs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ProgramsArgs = {
  objects: Array<Programs_Insert_Input>;
  on_conflict?: InputMaybe<Programs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Programs_OneArgs = {
  object: Programs_Insert_Input;
  on_conflict?: InputMaybe<Programs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Questionnaire_UploadsArgs = {
  objects: Array<Questionnaire_Uploads_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaire_Uploads_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Questionnaire_Uploads_OneArgs = {
  object: Questionnaire_Uploads_Insert_Input;
  on_conflict?: InputMaybe<Questionnaire_Uploads_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_QuestionnairesArgs = {
  objects: Array<Questionnaires_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaires_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Questionnaires_OneArgs = {
  object: Questionnaires_Insert_Input;
  on_conflict?: InputMaybe<Questionnaires_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ReportsArgs = {
  objects: Array<Reports_Insert_Input>;
  on_conflict?: InputMaybe<Reports_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Reports_OneArgs = {
  object: Reports_Insert_Input;
  on_conflict?: InputMaybe<Reports_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Review_FilesArgs = {
  objects: Array<Review_Files_Insert_Input>;
  on_conflict?: InputMaybe<Review_Files_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Review_Files_OneArgs = {
  object: Review_Files_Insert_Input;
  on_conflict?: InputMaybe<Review_Files_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ReviewsArgs = {
  objects: Array<Reviews_Insert_Input>;
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Reviews_OneArgs = {
  object: Reviews_Insert_Input;
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Approval_FilesArgs = {
  objects: Array<Risk_Approval_Files_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Approval_Files_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Approval_Files_OneArgs = {
  object: Risk_Approval_Files_Insert_Input;
  on_conflict?: InputMaybe<Risk_Approval_Files_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Approval_Reason_EntriesArgs = {
  objects: Array<Risk_Approval_Reason_Entries_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Approval_Reason_Entries_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Approval_Reason_Entries_OneArgs = {
  object: Risk_Approval_Reason_Entries_Insert_Input;
  on_conflict?: InputMaybe<Risk_Approval_Reason_Entries_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_ApprovalsArgs = {
  objects: Array<Risk_Approvals_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Approvals_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Approvals_OneArgs = {
  object: Risk_Approvals_Insert_Input;
  on_conflict?: InputMaybe<Risk_Approvals_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_ApproversArgs = {
  objects: Array<Risk_Approvers_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Approvers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Approvers_OneArgs = {
  object: Risk_Approvers_Insert_Input;
  on_conflict?: InputMaybe<Risk_Approvers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_CategoriesArgs = {
  objects: Array<Risk_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Categories_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Categories_OneArgs = {
  object: Risk_Categories_Insert_Input;
  on_conflict?: InputMaybe<Risk_Categories_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_ControlsArgs = {
  objects: Array<Risk_Controls_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Controls_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Controls_OneArgs = {
  object: Risk_Controls_Insert_Input;
  on_conflict?: InputMaybe<Risk_Controls_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_DocumentsArgs = {
  objects: Array<Risk_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Documents_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Documents_OneArgs = {
  object: Risk_Documents_Insert_Input;
  on_conflict?: InputMaybe<Risk_Documents_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_ImpactsArgs = {
  objects: Array<Risk_Impacts_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Impacts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Impacts_OneArgs = {
  object: Risk_Impacts_Insert_Input;
  on_conflict?: InputMaybe<Risk_Impacts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_LikelihoodsArgs = {
  objects: Array<Risk_Likelihoods_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Likelihoods_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Likelihoods_OneArgs = {
  object: Risk_Likelihoods_Insert_Input;
  on_conflict?: InputMaybe<Risk_Likelihoods_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_OwnersArgs = {
  objects: Array<Risk_Owners_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Owners_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Owners_OneArgs = {
  object: Risk_Owners_Insert_Input;
  on_conflict?: InputMaybe<Risk_Owners_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_TagsArgs = {
  objects: Array<Risk_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Tags_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Tags_OneArgs = {
  object: Risk_Tags_Insert_Input;
  on_conflict?: InputMaybe<Risk_Tags_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_TasksArgs = {
  objects: Array<Risk_Tasks_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Tasks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risk_Tasks_OneArgs = {
  object: Risk_Tasks_Insert_Input;
  on_conflict?: InputMaybe<Risk_Tasks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_RisksArgs = {
  objects: Array<Risks_Insert_Input>;
  on_conflict?: InputMaybe<Risks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Risks_OneArgs = {
  object: Risks_Insert_Input;
  on_conflict?: InputMaybe<Risks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Role_PermissionsArgs = {
  objects: Array<Role_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Role_Permissions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Role_Permissions_OneArgs = {
  object: Role_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Role_Permissions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_RolesArgs = {
  objects: Array<Roles_Insert_Input>;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Roles_OneArgs = {
  object: Roles_Insert_Input;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Select_Field_ConfigsArgs = {
  objects: Array<Select_Field_Configs_Insert_Input>;
  on_conflict?: InputMaybe<Select_Field_Configs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Select_Field_Configs_OneArgs = {
  object: Select_Field_Configs_Insert_Input;
  on_conflict?: InputMaybe<Select_Field_Configs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Select_Field_OptionsArgs = {
  objects: Array<Select_Field_Options_Insert_Input>;
  on_conflict?: InputMaybe<Select_Field_Options_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Select_Field_Options_OneArgs = {
  object: Select_Field_Options_Insert_Input;
  on_conflict?: InputMaybe<Select_Field_Options_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_TagsArgs = {
  objects: Array<Tags_Insert_Input>;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Tags_OneArgs = {
  object: Tags_Insert_Input;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Task_OwnersArgs = {
  objects: Array<Task_Owners_Insert_Input>;
  on_conflict?: InputMaybe<Task_Owners_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Task_Owners_OneArgs = {
  object: Task_Owners_Insert_Input;
  on_conflict?: InputMaybe<Task_Owners_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_TasksArgs = {
  objects: Array<Tasks_Insert_Input>;
  on_conflict?: InputMaybe<Tasks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Tasks_OneArgs = {
  object: Tasks_Insert_Input;
  on_conflict?: InputMaybe<Tasks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Team_MembersArgs = {
  objects: Array<Team_Members_Insert_Input>;
  on_conflict?: InputMaybe<Team_Members_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Team_Members_OneArgs = {
  object: Team_Members_Insert_Input;
  on_conflict?: InputMaybe<Team_Members_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_TeamsArgs = {
  objects: Array<Teams_Insert_Input>;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Teams_OneArgs = {
  object: Teams_Insert_Input;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Text_Field_ValuesArgs = {
  objects: Array<Text_Field_Values_Insert_Input>;
  on_conflict?: InputMaybe<Text_Field_Values_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Text_Field_Values_OneArgs = {
  object: Text_Field_Values_Insert_Input;
  on_conflict?: InputMaybe<Text_Field_Values_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_CategoriesArgs = {
  objects: Array<Trust_Portal_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Trust_Portal_Categories_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_Categories_OneArgs = {
  object: Trust_Portal_Categories_Insert_Input;
  on_conflict?: InputMaybe<Trust_Portal_Categories_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_Document_Resource_SectionsArgs = {
  objects: Array<Trust_Portal_Document_Resource_Sections_Insert_Input>;
  on_conflict?: InputMaybe<Trust_Portal_Document_Resource_Sections_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_Document_Resource_Sections_OneArgs = {
  object: Trust_Portal_Document_Resource_Sections_Insert_Input;
  on_conflict?: InputMaybe<Trust_Portal_Document_Resource_Sections_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_DocumentsArgs = {
  objects: Array<Trust_Portal_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Trust_Portal_Documents_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_Documents_OneArgs = {
  object: Trust_Portal_Documents_Insert_Input;
  on_conflict?: InputMaybe<Trust_Portal_Documents_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_FaqsArgs = {
  objects: Array<Trust_Portal_Faqs_Insert_Input>;
  on_conflict?: InputMaybe<Trust_Portal_Faqs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_Faqs_OneArgs = {
  object: Trust_Portal_Faqs_Insert_Input;
  on_conflict?: InputMaybe<Trust_Portal_Faqs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_FrameworksArgs = {
  objects: Array<Trust_Portal_Frameworks_Insert_Input>;
  on_conflict?: InputMaybe<Trust_Portal_Frameworks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_Frameworks_OneArgs = {
  object: Trust_Portal_Frameworks_Insert_Input;
  on_conflict?: InputMaybe<Trust_Portal_Frameworks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_PagesArgs = {
  objects: Array<Trust_Portal_Pages_Insert_Input>;
  on_conflict?: InputMaybe<Trust_Portal_Pages_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_Pages_OneArgs = {
  object: Trust_Portal_Pages_Insert_Input;
  on_conflict?: InputMaybe<Trust_Portal_Pages_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_Resource_SectionsArgs = {
  objects: Array<Trust_Portal_Resource_Sections_Insert_Input>;
  on_conflict?: InputMaybe<Trust_Portal_Resource_Sections_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_Resource_Sections_OneArgs = {
  object: Trust_Portal_Resource_Sections_Insert_Input;
  on_conflict?: InputMaybe<Trust_Portal_Resource_Sections_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_Update_CategoriesArgs = {
  objects: Array<Trust_Portal_Update_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Trust_Portal_Update_Categories_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_Update_Categories_OneArgs = {
  object: Trust_Portal_Update_Categories_Insert_Input;
  on_conflict?: InputMaybe<Trust_Portal_Update_Categories_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_UpdatesArgs = {
  objects: Array<Trust_Portal_Updates_Insert_Input>;
  on_conflict?: InputMaybe<Trust_Portal_Updates_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Trust_Portal_Updates_OneArgs = {
  object: Trust_Portal_Updates_Insert_Input;
  on_conflict?: InputMaybe<Trust_Portal_Updates_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Url_Field_ValuesArgs = {
  objects: Array<Url_Field_Values_Insert_Input>;
  on_conflict?: InputMaybe<Url_Field_Values_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Url_Field_Values_OneArgs = {
  object: Url_Field_Values_Insert_Input;
  on_conflict?: InputMaybe<Url_Field_Values_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_User_ProfilesArgs = {
  objects: Array<User_Profiles_Insert_Input>;
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_User_Profiles_OneArgs = {
  object: User_Profiles_Insert_Input;
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_Approval_FilesArgs = {
  objects: Array<Vendor_Approval_Files_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Approval_Files_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_Approval_Files_OneArgs = {
  object: Vendor_Approval_Files_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Approval_Files_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_ApprovalsArgs = {
  objects: Array<Vendor_Approvals_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Approvals_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_Approvals_OneArgs = {
  object: Vendor_Approvals_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Approvals_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_ApproversArgs = {
  objects: Array<Vendor_Approvers_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Approvers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_Approvers_OneArgs = {
  object: Vendor_Approvers_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Approvers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_DocumentsArgs = {
  objects: Array<Vendor_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Documents_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_Documents_OneArgs = {
  object: Vendor_Documents_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Documents_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_OwnersArgs = {
  objects: Array<Vendor_Owners_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Owners_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_Owners_OneArgs = {
  object: Vendor_Owners_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Owners_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_Questionnaire_FormsArgs = {
  objects: Array<Vendor_Questionnaire_Forms_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Questionnaire_Forms_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_Questionnaire_Forms_OneArgs = {
  object: Vendor_Questionnaire_Forms_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Questionnaire_Forms_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_RisksArgs = {
  objects: Array<Vendor_Risks_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Risks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_Risks_OneArgs = {
  object: Vendor_Risks_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Risks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_TasksArgs = {
  objects: Array<Vendor_Tasks_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Tasks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendor_Tasks_OneArgs = {
  object: Vendor_Tasks_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Tasks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_VendorsArgs = {
  objects: Array<Vendors_Insert_Input>;
  on_conflict?: InputMaybe<Vendors_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vendors_OneArgs = {
  object: Vendors_Insert_Input;
  on_conflict?: InputMaybe<Vendors_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vq_Custom_FieldsArgs = {
  objects: Array<Vq_Custom_Fields_Insert_Input>;
  on_conflict?: InputMaybe<Vq_Custom_Fields_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Vq_Custom_Fields_OneArgs = {
  object: Vq_Custom_Fields_Insert_Input;
  on_conflict?: InputMaybe<Vq_Custom_Fields_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInvite_UserArgs = {
  object: InviteUserInput;
};

/** mutation root */
export type Mutation_RootJoin_OrganizationArgs = {
  object: JoinOrganizationInput;
};

/** mutation root */
export type Mutation_RootLift_Trust_Portal_Access_BlockArgs = {
  object: TrustPortalLiftAccessBlockInput;
};

/** mutation root */
export type Mutation_RootPause_Trust_Portal_Nda_GateArgs = {
  pageId: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootReconfigure_Manual_Integration_ConnectorArgs = {
  input: ReconfigureManualIntegrationConnectorInput;
};

/** mutation root */
export type Mutation_RootRecord_Evidence_CheckArgs = {
  input: RecordEvidenceCheckInput;
};

/** mutation root */
export type Mutation_RootRemediate_FindingArgs = {
  args: FindingSingleCommandArgs;
};

/** mutation root */
export type Mutation_RootRemove_Email_SenderArgs = {
  object: EmailSenderOrgInput;
};

/** mutation root */
export type Mutation_RootRemove_Trust_Portal_DomainArgs = {
  object: TrustPortalDomainOrgInput;
};

/** mutation root */
export type Mutation_RootRename_Integration_ConnectorArgs = {
  input: RenameIntegrationConnectorInput;
};

/** mutation root */
export type Mutation_RootResend_Risk_Approval_RequestArgs = {
  input: ResendRiskApprovalRequestInput;
};

/** mutation root */
export type Mutation_RootResend_Vendor_Approval_RequestArgs = {
  input: ResendVendorApprovalRequestInput;
};

/** mutation root */
export type Mutation_RootRevoke_And_Block_Trust_Portal_AccessArgs = {
  object: TrustPortalRevokeAndBlockAccessInput;
};

/** mutation root */
export type Mutation_RootRevoke_Evidence_AccessArgs = {
  input: RevokeEvidenceAccessInput;
};

/** mutation root */
export type Mutation_RootRevoke_Trust_Portal_AccessArgs = {
  object: TrustPortalAccessDecisionInput;
};

/** mutation root */
export type Mutation_RootRotate_Api_KeyArgs = {
  payload: RotateApiKeyInput;
};

/** mutation root */
export type Mutation_RootSave_Trust_Portal_Nda_Gate_ConfigurationArgs = {
  object: SaveTrustPortalNdaGateConfigurationInput;
};

/** mutation root */
export type Mutation_RootSendVendorQuestionnaireArgs = {
  input: SendVendorQuestionnaireInput;
};

/** mutation root */
export type Mutation_RootSend_Acknowledgement_ReminderArgs = {
  input: AcknowledgementReminderInput;
};

/** mutation root */
export type Mutation_RootSend_Approval_ReminderArgs = {
  input: ApprovalReminderInput;
};

/** mutation root */
export type Mutation_RootSend_Exception_ReminderArgs = {
  input: ExceptionReminderInput;
};

/** mutation root */
export type Mutation_RootSend_Policy_AcknowledgementsArgs = {
  input: SendPolicyAcknowledgementsInput;
};

/** mutation root */
export type Mutation_RootSend_Risk_Approval_ReminderArgs = {
  input: RiskApprovalReminderInput;
};

/** mutation root */
export type Mutation_RootSend_Vendor_Approval_ReminderArgs = {
  input: VendorApprovalReminderInput;
};

/** mutation root */
export type Mutation_RootSet_Evidence_ConfidentialArgs = {
  input: SetEvidenceConfidentialInput;
};

/** mutation root */
export type Mutation_RootSet_Org_Integration_ConfigArgs = {
  input: SetOrgIntegrationConfigInput;
};

/** mutation root */
export type Mutation_RootSet_Scalar_Field_ValuesArgs = {
  input: SetScalarFieldValuesInput;
};

/** mutation root */
export type Mutation_RootSet_Select_Field_ValuesArgs = {
  input: SetSelectFieldValuesInput;
};

/** mutation root */
export type Mutation_RootSetup_Email_SenderArgs = {
  object: SetupEmailSenderInput;
};

/** mutation root */
export type Mutation_RootSetup_Trust_Portal_DomainArgs = {
  object: SetupTrustPortalDomainInput;
};

/** mutation root */
export type Mutation_RootShare_Trust_Portal_AccessArgs = {
  object: TrustPortalShareAccessInput;
};

/** mutation root */
export type Mutation_RootToggle_Close_Out_RiskArgs = {
  riskId: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootToggle_Close_Out_RisksArgs = {
  riskIds: Array<Scalars['uuid']['input']>;
};

/** mutation root */
export type Mutation_RootToggle_Terminate_VendorArgs = {
  vendorId: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootToggle_Terminate_VendorsArgs = {
  vendorIds: Array<Scalars['uuid']['input']>;
};

/** mutation root */
export type Mutation_RootUpdateUserArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Agent_InstancesArgs = {
  _append?: InputMaybe<Agent_Instances_Append_Input>;
  _delete_at_path?: InputMaybe<Agent_Instances_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Agent_Instances_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Agent_Instances_Delete_Key_Input>;
  _prepend?: InputMaybe<Agent_Instances_Prepend_Input>;
  _set?: InputMaybe<Agent_Instances_Set_Input>;
  where: Agent_Instances_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Agent_Instances_By_PkArgs = {
  _append?: InputMaybe<Agent_Instances_Append_Input>;
  _delete_at_path?: InputMaybe<Agent_Instances_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Agent_Instances_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Agent_Instances_Delete_Key_Input>;
  _prepend?: InputMaybe<Agent_Instances_Prepend_Input>;
  _set?: InputMaybe<Agent_Instances_Set_Input>;
  pk_columns: Agent_Instances_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Agent_Instances_ManyArgs = {
  updates: Array<Agent_Instances_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Api_KeysArgs = {
  _append?: InputMaybe<Api_Keys_Append_Input>;
  _delete_at_path?: InputMaybe<Api_Keys_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Api_Keys_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Api_Keys_Delete_Key_Input>;
  _prepend?: InputMaybe<Api_Keys_Prepend_Input>;
  _set?: InputMaybe<Api_Keys_Set_Input>;
  where: Api_Keys_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Api_Keys_By_PkArgs = {
  _append?: InputMaybe<Api_Keys_Append_Input>;
  _delete_at_path?: InputMaybe<Api_Keys_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Api_Keys_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Api_Keys_Delete_Key_Input>;
  _prepend?: InputMaybe<Api_Keys_Prepend_Input>;
  _set?: InputMaybe<Api_Keys_Set_Input>;
  pk_columns: Api_Keys_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Api_Keys_ManyArgs = {
  updates: Array<Api_Keys_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_CategoriesArgs = {
  _set?: InputMaybe<Categories_Set_Input>;
  where: Categories_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Categories_By_PkArgs = {
  _set?: InputMaybe<Categories_Set_Input>;
  pk_columns: Categories_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Categories_ManyArgs = {
  updates: Array<Categories_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Client_Questionnaire_QuestionsArgs = {
  _set?: InputMaybe<Client_Questionnaire_Questions_Set_Input>;
  where: Client_Questionnaire_Questions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Client_Questionnaire_Questions_By_PkArgs = {
  _set?: InputMaybe<Client_Questionnaire_Questions_Set_Input>;
  pk_columns: Client_Questionnaire_Questions_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Client_Questionnaire_Questions_ManyArgs = {
  updates: Array<Client_Questionnaire_Questions_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Client_QuestionnairesArgs = {
  _set?: InputMaybe<Client_Questionnaires_Set_Input>;
  where: Client_Questionnaires_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Client_Questionnaires_By_PkArgs = {
  _set?: InputMaybe<Client_Questionnaires_Set_Input>;
  pk_columns: Client_Questionnaires_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Client_Questionnaires_ManyArgs = {
  updates: Array<Client_Questionnaires_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_CommentsArgs = {
  _set?: InputMaybe<Comments_Set_Input>;
  where: Comments_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Comments_By_PkArgs = {
  _set?: InputMaybe<Comments_Set_Input>;
  pk_columns: Comments_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Comments_ManyArgs = {
  updates: Array<Comments_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Control_Ai_Review_CriteriaArgs = {
  _set?: InputMaybe<Control_Ai_Review_Criteria_Set_Input>;
  where: Control_Ai_Review_Criteria_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Control_Ai_Review_Criteria_By_PkArgs = {
  _set?: InputMaybe<Control_Ai_Review_Criteria_Set_Input>;
  pk_columns: Control_Ai_Review_Criteria_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Control_Ai_Review_Criteria_ManyArgs = {
  updates: Array<Control_Ai_Review_Criteria_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Control_FindingsArgs = {
  _set?: InputMaybe<Control_Findings_Set_Input>;
  where: Control_Findings_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Control_Findings_By_PkArgs = {
  _set?: InputMaybe<Control_Findings_Set_Input>;
  pk_columns: Control_Findings_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Control_Findings_ManyArgs = {
  updates: Array<Control_Findings_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_ControlsArgs = {
  _append?: InputMaybe<Controls_Append_Input>;
  _delete_at_path?: InputMaybe<Controls_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Controls_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Controls_Delete_Key_Input>;
  _prepend?: InputMaybe<Controls_Prepend_Input>;
  _set?: InputMaybe<Controls_Set_Input>;
  where: Controls_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Controls_By_PkArgs = {
  _append?: InputMaybe<Controls_Append_Input>;
  _delete_at_path?: InputMaybe<Controls_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Controls_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Controls_Delete_Key_Input>;
  _prepend?: InputMaybe<Controls_Prepend_Input>;
  _set?: InputMaybe<Controls_Set_Input>;
  pk_columns: Controls_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Controls_ManyArgs = {
  updates: Array<Controls_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_CriteriaArgs = {
  _set?: InputMaybe<Criteria_Set_Input>;
  where: Criteria_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Criteria_By_PkArgs = {
  _set?: InputMaybe<Criteria_Set_Input>;
  pk_columns: Criteria_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Criteria_ManyArgs = {
  updates: Array<Criteria_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Date_Field_ValuesArgs = {
  _set?: InputMaybe<Date_Field_Values_Set_Input>;
  where: Date_Field_Values_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Date_Field_Values_By_PkArgs = {
  _set?: InputMaybe<Date_Field_Values_Set_Input>;
  pk_columns: Date_Field_Values_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Date_Field_Values_ManyArgs = {
  updates: Array<Date_Field_Values_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_DocumentsArgs = {
  _set?: InputMaybe<Documents_Set_Input>;
  where: Documents_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Documents_By_PkArgs = {
  _set?: InputMaybe<Documents_Set_Input>;
  pk_columns: Documents_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Documents_ManyArgs = {
  updates: Array<Documents_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Email_Field_ValuesArgs = {
  _set?: InputMaybe<Email_Field_Values_Set_Input>;
  where: Email_Field_Values_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Email_Field_Values_By_PkArgs = {
  _set?: InputMaybe<Email_Field_Values_Set_Input>;
  pk_columns: Email_Field_Values_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Email_Field_Values_ManyArgs = {
  updates: Array<Email_Field_Values_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Evidence_IntegrationsArgs = {
  _append?: InputMaybe<Evidence_Integrations_Append_Input>;
  _delete_at_path?: InputMaybe<Evidence_Integrations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Evidence_Integrations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Evidence_Integrations_Delete_Key_Input>;
  _prepend?: InputMaybe<Evidence_Integrations_Prepend_Input>;
  _set?: InputMaybe<Evidence_Integrations_Set_Input>;
  where: Evidence_Integrations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Evidence_Integrations_By_PkArgs = {
  _append?: InputMaybe<Evidence_Integrations_Append_Input>;
  _delete_at_path?: InputMaybe<Evidence_Integrations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Evidence_Integrations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Evidence_Integrations_Delete_Key_Input>;
  _prepend?: InputMaybe<Evidence_Integrations_Prepend_Input>;
  _set?: InputMaybe<Evidence_Integrations_Set_Input>;
  pk_columns: Evidence_Integrations_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Evidence_Integrations_ManyArgs = {
  updates: Array<Evidence_Integrations_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Evidence_PoliciesArgs = {
  _set?: InputMaybe<Evidence_Policies_Set_Input>;
  where: Evidence_Policies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Evidence_Policies_By_PkArgs = {
  _set?: InputMaybe<Evidence_Policies_Set_Input>;
  pk_columns: Evidence_Policies_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Evidence_Policies_ManyArgs = {
  updates: Array<Evidence_Policies_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Evidence_VersionsArgs = {
  _set?: InputMaybe<Evidence_Versions_Set_Input>;
  where: Evidence_Versions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Evidence_Versions_By_PkArgs = {
  _set?: InputMaybe<Evidence_Versions_Set_Input>;
  pk_columns: Evidence_Versions_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Evidence_Versions_ManyArgs = {
  updates: Array<Evidence_Versions_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_EvidencesArgs = {
  _set?: InputMaybe<Evidences_Set_Input>;
  where: Evidences_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Evidences_By_PkArgs = {
  _set?: InputMaybe<Evidences_Set_Input>;
  pk_columns: Evidences_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Evidences_ManyArgs = {
  updates: Array<Evidences_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Field_ConfigsArgs = {
  _set?: InputMaybe<Field_Configs_Set_Input>;
  where: Field_Configs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Field_Configs_By_PkArgs = {
  _set?: InputMaybe<Field_Configs_Set_Input>;
  pk_columns: Field_Configs_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Field_Configs_ManyArgs = {
  updates: Array<Field_Configs_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Finding_ResolutionsArgs = {
  _set?: InputMaybe<Finding_Resolutions_Set_Input>;
  where: Finding_Resolutions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Finding_Resolutions_By_PkArgs = {
  _set?: InputMaybe<Finding_Resolutions_Set_Input>;
  pk_columns: Finding_Resolutions_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Finding_Resolutions_ManyArgs = {
  updates: Array<Finding_Resolutions_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_FormsArgs = {
  _append?: InputMaybe<Forms_Append_Input>;
  _delete_at_path?: InputMaybe<Forms_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Forms_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Forms_Delete_Key_Input>;
  _prepend?: InputMaybe<Forms_Prepend_Input>;
  _set?: InputMaybe<Forms_Set_Input>;
  where: Forms_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Forms_By_PkArgs = {
  _append?: InputMaybe<Forms_Append_Input>;
  _delete_at_path?: InputMaybe<Forms_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Forms_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Forms_Delete_Key_Input>;
  _prepend?: InputMaybe<Forms_Prepend_Input>;
  _set?: InputMaybe<Forms_Set_Input>;
  pk_columns: Forms_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Forms_ManyArgs = {
  updates: Array<Forms_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_GroupsArgs = {
  _set?: InputMaybe<Groups_Set_Input>;
  where: Groups_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Groups_By_PkArgs = {
  _set?: InputMaybe<Groups_Set_Input>;
  pk_columns: Groups_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Groups_ManyArgs = {
  updates: Array<Groups_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mcp_Client_PolicyArgs = {
  payload: UpdateMcpClientPolicyInput;
};

/** mutation root */
export type Mutation_RootUpdate_Number_Field_ValuesArgs = {
  _inc?: InputMaybe<Number_Field_Values_Inc_Input>;
  _set?: InputMaybe<Number_Field_Values_Set_Input>;
  where: Number_Field_Values_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Number_Field_Values_By_PkArgs = {
  _inc?: InputMaybe<Number_Field_Values_Inc_Input>;
  _set?: InputMaybe<Number_Field_Values_Set_Input>;
  pk_columns: Number_Field_Values_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Number_Field_Values_ManyArgs = {
  updates: Array<Number_Field_Values_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Evidence_TagsArgs = {
  _set?: InputMaybe<Organization_Evidence_Tags_Set_Input>;
  where: Organization_Evidence_Tags_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Evidence_Tags_By_PkArgs = {
  _set?: InputMaybe<Organization_Evidence_Tags_Set_Input>;
  pk_columns: Organization_Evidence_Tags_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Evidence_Tags_ManyArgs = {
  updates: Array<Organization_Evidence_Tags_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Finding_SeveritiesArgs = {
  _inc?: InputMaybe<Organization_Finding_Severities_Inc_Input>;
  _set?: InputMaybe<Organization_Finding_Severities_Set_Input>;
  where: Organization_Finding_Severities_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Finding_Severities_By_PkArgs = {
  _inc?: InputMaybe<Organization_Finding_Severities_Inc_Input>;
  _set?: InputMaybe<Organization_Finding_Severities_Set_Input>;
  pk_columns: Organization_Finding_Severities_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Finding_Severities_ManyArgs = {
  updates: Array<Organization_Finding_Severities_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_ProfilesArgs = {
  _inc?: InputMaybe<Organization_Profiles_Inc_Input>;
  _set?: InputMaybe<Organization_Profiles_Set_Input>;
  where: Organization_Profiles_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Profiles_By_PkArgs = {
  _inc?: InputMaybe<Organization_Profiles_Inc_Input>;
  _set?: InputMaybe<Organization_Profiles_Set_Input>;
  pk_columns: Organization_Profiles_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Profiles_ManyArgs = {
  updates: Array<Organization_Profiles_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Risk_CategoriesArgs = {
  _set?: InputMaybe<Organization_Risk_Categories_Set_Input>;
  where: Organization_Risk_Categories_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Risk_Categories_By_PkArgs = {
  _set?: InputMaybe<Organization_Risk_Categories_Set_Input>;
  pk_columns: Organization_Risk_Categories_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Risk_Categories_ManyArgs = {
  updates: Array<Organization_Risk_Categories_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Risk_LevelsArgs = {
  _set?: InputMaybe<Organization_Risk_Levels_Set_Input>;
  where: Organization_Risk_Levels_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Risk_Levels_By_PkArgs = {
  _set?: InputMaybe<Organization_Risk_Levels_Set_Input>;
  pk_columns: Organization_Risk_Levels_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Risk_Levels_ManyArgs = {
  updates: Array<Organization_Risk_Levels_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Risk_TagsArgs = {
  _set?: InputMaybe<Organization_Risk_Tags_Set_Input>;
  where: Organization_Risk_Tags_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Risk_Tags_By_PkArgs = {
  _set?: InputMaybe<Organization_Risk_Tags_Set_Input>;
  pk_columns: Organization_Risk_Tags_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Risk_Tags_ManyArgs = {
  updates: Array<Organization_Risk_Tags_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_UsersArgs = {
  _set?: InputMaybe<Organization_Users_Set_Input>;
  where: Organization_Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Users_By_PkArgs = {
  _set?: InputMaybe<Organization_Users_Set_Input>;
  pk_columns: Organization_Users_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Users_ManyArgs = {
  updates: Array<Organization_Users_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Vendor_Risk_LevelsArgs = {
  _set?: InputMaybe<Organization_Vendor_Risk_Levels_Set_Input>;
  where: Organization_Vendor_Risk_Levels_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Vendor_Risk_Levels_By_PkArgs = {
  _set?: InputMaybe<Organization_Vendor_Risk_Levels_Set_Input>;
  pk_columns: Organization_Vendor_Risk_Levels_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Vendor_Risk_Levels_ManyArgs = {
  updates: Array<Organization_Vendor_Risk_Levels_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Vendor_TiersArgs = {
  _set?: InputMaybe<Organization_Vendor_Tiers_Set_Input>;
  where: Organization_Vendor_Tiers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Vendor_Tiers_By_PkArgs = {
  _set?: InputMaybe<Organization_Vendor_Tiers_Set_Input>;
  pk_columns: Organization_Vendor_Tiers_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organization_Vendor_Tiers_ManyArgs = {
  updates: Array<Organization_Vendor_Tiers_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_OrganizationsArgs = {
  _set?: InputMaybe<Organizations_Set_Input>;
  where: Organizations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organizations_By_PkArgs = {
  _set?: InputMaybe<Organizations_Set_Input>;
  pk_columns: Organizations_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organizations_ManyArgs = {
  updates: Array<Organizations_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_PoliciesArgs = {
  _set?: InputMaybe<Policies_Set_Input>;
  where: Policies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Policies_By_PkArgs = {
  _set?: InputMaybe<Policies_Set_Input>;
  pk_columns: Policies_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Policies_ManyArgs = {
  updates: Array<Policies_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Acknowledgement_UsersArgs = {
  _set?: InputMaybe<Policy_Acknowledgement_Users_Set_Input>;
  where: Policy_Acknowledgement_Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Acknowledgement_Users_By_PkArgs = {
  _set?: InputMaybe<Policy_Acknowledgement_Users_Set_Input>;
  pk_columns: Policy_Acknowledgement_Users_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Acknowledgement_Users_ManyArgs = {
  updates: Array<Policy_Acknowledgement_Users_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_AcknowledgementsArgs = {
  _set?: InputMaybe<Policy_Acknowledgements_Set_Input>;
  where: Policy_Acknowledgements_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Acknowledgements_By_PkArgs = {
  _set?: InputMaybe<Policy_Acknowledgements_Set_Input>;
  pk_columns: Policy_Acknowledgements_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Acknowledgements_ManyArgs = {
  updates: Array<Policy_Acknowledgements_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Approval_UsersArgs = {
  _set?: InputMaybe<Policy_Approval_Users_Set_Input>;
  where: Policy_Approval_Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Approval_Users_By_PkArgs = {
  _set?: InputMaybe<Policy_Approval_Users_Set_Input>;
  pk_columns: Policy_Approval_Users_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Approval_Users_ManyArgs = {
  updates: Array<Policy_Approval_Users_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_ApprovalsArgs = {
  _set?: InputMaybe<Policy_Approvals_Set_Input>;
  where: Policy_Approvals_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Approvals_By_PkArgs = {
  _set?: InputMaybe<Policy_Approvals_Set_Input>;
  pk_columns: Policy_Approvals_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Approvals_ManyArgs = {
  updates: Array<Policy_Approvals_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Exception_ApproversArgs = {
  _set?: InputMaybe<Policy_Exception_Approvers_Set_Input>;
  where: Policy_Exception_Approvers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Exception_Approvers_By_PkArgs = {
  _set?: InputMaybe<Policy_Exception_Approvers_Set_Input>;
  pk_columns: Policy_Exception_Approvers_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Exception_Approvers_ManyArgs = {
  updates: Array<Policy_Exception_Approvers_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_ExceptionsArgs = {
  _set?: InputMaybe<Policy_Exceptions_Set_Input>;
  where: Policy_Exceptions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Exceptions_By_PkArgs = {
  _set?: InputMaybe<Policy_Exceptions_Set_Input>;
  pk_columns: Policy_Exceptions_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Exceptions_ManyArgs = {
  updates: Array<Policy_Exceptions_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_IntegrationsArgs = {
  _append?: InputMaybe<Policy_Integrations_Append_Input>;
  _delete_at_path?: InputMaybe<Policy_Integrations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Policy_Integrations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Policy_Integrations_Delete_Key_Input>;
  _prepend?: InputMaybe<Policy_Integrations_Prepend_Input>;
  _set?: InputMaybe<Policy_Integrations_Set_Input>;
  where: Policy_Integrations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Integrations_By_PkArgs = {
  _append?: InputMaybe<Policy_Integrations_Append_Input>;
  _delete_at_path?: InputMaybe<Policy_Integrations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Policy_Integrations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Policy_Integrations_Delete_Key_Input>;
  _prepend?: InputMaybe<Policy_Integrations_Prepend_Input>;
  _set?: InputMaybe<Policy_Integrations_Set_Input>;
  pk_columns: Policy_Integrations_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Integrations_ManyArgs = {
  updates: Array<Policy_Integrations_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Version_ContentArgs = {
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  policy_markdown?: InputMaybe<Scalars['String']['input']>;
  policy_text?: InputMaybe<Scalars['String']['input']>;
  policy_version_id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootUpdate_Policy_VersionsArgs = {
  _set?: InputMaybe<Policy_Versions_Set_Input>;
  where: Policy_Versions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Versions_By_PkArgs = {
  _set?: InputMaybe<Policy_Versions_Set_Input>;
  pk_columns: Policy_Versions_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Policy_Versions_ManyArgs = {
  updates: Array<Policy_Versions_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_ProgramsArgs = {
  _set?: InputMaybe<Programs_Set_Input>;
  where: Programs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Programs_By_PkArgs = {
  _set?: InputMaybe<Programs_Set_Input>;
  pk_columns: Programs_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Programs_ManyArgs = {
  updates: Array<Programs_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Questionnaire_UploadsArgs = {
  _set?: InputMaybe<Questionnaire_Uploads_Set_Input>;
  where: Questionnaire_Uploads_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Uploads_By_PkArgs = {
  _set?: InputMaybe<Questionnaire_Uploads_Set_Input>;
  pk_columns: Questionnaire_Uploads_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Uploads_ManyArgs = {
  updates: Array<Questionnaire_Uploads_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_QuestionnairesArgs = {
  _set?: InputMaybe<Questionnaires_Set_Input>;
  where: Questionnaires_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Questionnaires_By_PkArgs = {
  _set?: InputMaybe<Questionnaires_Set_Input>;
  pk_columns: Questionnaires_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Questionnaires_ManyArgs = {
  updates: Array<Questionnaires_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_ReportsArgs = {
  _append?: InputMaybe<Reports_Append_Input>;
  _delete_at_path?: InputMaybe<Reports_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Reports_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Reports_Delete_Key_Input>;
  _prepend?: InputMaybe<Reports_Prepend_Input>;
  _set?: InputMaybe<Reports_Set_Input>;
  where: Reports_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Reports_By_PkArgs = {
  _append?: InputMaybe<Reports_Append_Input>;
  _delete_at_path?: InputMaybe<Reports_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Reports_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Reports_Delete_Key_Input>;
  _prepend?: InputMaybe<Reports_Prepend_Input>;
  _set?: InputMaybe<Reports_Set_Input>;
  pk_columns: Reports_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Reports_ManyArgs = {
  updates: Array<Reports_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Review_FilesArgs = {
  _set?: InputMaybe<Review_Files_Set_Input>;
  where: Review_Files_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Review_Files_By_PkArgs = {
  _set?: InputMaybe<Review_Files_Set_Input>;
  pk_columns: Review_Files_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Review_Files_ManyArgs = {
  updates: Array<Review_Files_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_ReviewsArgs = {
  _set?: InputMaybe<Reviews_Set_Input>;
  where: Reviews_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Reviews_By_PkArgs = {
  _set?: InputMaybe<Reviews_Set_Input>;
  pk_columns: Reviews_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Reviews_ManyArgs = {
  updates: Array<Reviews_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_ApprovalsArgs = {
  _set?: InputMaybe<Risk_Approvals_Set_Input>;
  where: Risk_Approvals_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Approvals_By_PkArgs = {
  _set?: InputMaybe<Risk_Approvals_Set_Input>;
  pk_columns: Risk_Approvals_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Approvals_ManyArgs = {
  updates: Array<Risk_Approvals_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_ApproversArgs = {
  _set?: InputMaybe<Risk_Approvers_Set_Input>;
  where: Risk_Approvers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Approvers_By_PkArgs = {
  _set?: InputMaybe<Risk_Approvers_Set_Input>;
  pk_columns: Risk_Approvers_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Approvers_ManyArgs = {
  updates: Array<Risk_Approvers_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_ImpactsArgs = {
  _set?: InputMaybe<Risk_Impacts_Set_Input>;
  where: Risk_Impacts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Impacts_By_PkArgs = {
  _set?: InputMaybe<Risk_Impacts_Set_Input>;
  pk_columns: Risk_Impacts_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Impacts_ManyArgs = {
  updates: Array<Risk_Impacts_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Inherent_LevelsArgs = {
  _set?: InputMaybe<Risk_Inherent_Levels_Set_Input>;
  where: Risk_Inherent_Levels_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Inherent_Levels_By_PkArgs = {
  _set?: InputMaybe<Risk_Inherent_Levels_Set_Input>;
  pk_columns: Risk_Inherent_Levels_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Inherent_Levels_ManyArgs = {
  updates: Array<Risk_Inherent_Levels_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_LikelihoodsArgs = {
  _set?: InputMaybe<Risk_Likelihoods_Set_Input>;
  where: Risk_Likelihoods_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Likelihoods_By_PkArgs = {
  _set?: InputMaybe<Risk_Likelihoods_Set_Input>;
  pk_columns: Risk_Likelihoods_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Likelihoods_ManyArgs = {
  updates: Array<Risk_Likelihoods_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Residual_LevelsArgs = {
  _set?: InputMaybe<Risk_Residual_Levels_Set_Input>;
  where: Risk_Residual_Levels_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Residual_Levels_By_PkArgs = {
  _set?: InputMaybe<Risk_Residual_Levels_Set_Input>;
  pk_columns: Risk_Residual_Levels_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Risk_Residual_Levels_ManyArgs = {
  updates: Array<Risk_Residual_Levels_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_RisksArgs = {
  _set?: InputMaybe<Risks_Set_Input>;
  where: Risks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Risks_By_PkArgs = {
  _set?: InputMaybe<Risks_Set_Input>;
  pk_columns: Risks_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Risks_ManyArgs = {
  updates: Array<Risks_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_RolesArgs = {
  _set?: InputMaybe<Roles_Set_Input>;
  where: Roles_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgs = {
  _set?: InputMaybe<Roles_Set_Input>;
  pk_columns: Roles_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Roles_ManyArgs = {
  updates: Array<Roles_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Select_Field_ConfigsArgs = {
  _set?: InputMaybe<Select_Field_Configs_Set_Input>;
  where: Select_Field_Configs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Select_Field_Configs_By_PkArgs = {
  _set?: InputMaybe<Select_Field_Configs_Set_Input>;
  pk_columns: Select_Field_Configs_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Select_Field_Configs_ManyArgs = {
  updates: Array<Select_Field_Configs_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Select_Field_OptionsArgs = {
  _set?: InputMaybe<Select_Field_Options_Set_Input>;
  where: Select_Field_Options_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Select_Field_Options_By_PkArgs = {
  _set?: InputMaybe<Select_Field_Options_Set_Input>;
  pk_columns: Select_Field_Options_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Select_Field_Options_ManyArgs = {
  updates: Array<Select_Field_Options_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Service_AccountsArgs = {
  _set?: InputMaybe<Service_Accounts_Set_Input>;
  where: Service_Accounts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Service_Accounts_By_PkArgs = {
  _set?: InputMaybe<Service_Accounts_Set_Input>;
  pk_columns: Service_Accounts_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Service_Accounts_ManyArgs = {
  updates: Array<Service_Accounts_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_TagsArgs = {
  _set?: InputMaybe<Tags_Set_Input>;
  where: Tags_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Tags_By_PkArgs = {
  _set?: InputMaybe<Tags_Set_Input>;
  pk_columns: Tags_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Tags_ManyArgs = {
  updates: Array<Tags_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_TasksArgs = {
  _set?: InputMaybe<Tasks_Set_Input>;
  where: Tasks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Tasks_By_PkArgs = {
  _set?: InputMaybe<Tasks_Set_Input>;
  pk_columns: Tasks_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Tasks_ManyArgs = {
  updates: Array<Tasks_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_TeamsArgs = {
  _set?: InputMaybe<Teams_Set_Input>;
  where: Teams_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Teams_By_PkArgs = {
  _set?: InputMaybe<Teams_Set_Input>;
  pk_columns: Teams_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Teams_ManyArgs = {
  updates: Array<Teams_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Text_Field_ValuesArgs = {
  _set?: InputMaybe<Text_Field_Values_Set_Input>;
  where: Text_Field_Values_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Text_Field_Values_By_PkArgs = {
  _set?: InputMaybe<Text_Field_Values_Set_Input>;
  pk_columns: Text_Field_Values_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Text_Field_Values_ManyArgs = {
  updates: Array<Text_Field_Values_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Access_RequestsArgs = {
  _set?: InputMaybe<Trust_Portal_Access_Requests_Set_Input>;
  where: Trust_Portal_Access_Requests_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Access_Requests_By_PkArgs = {
  _set?: InputMaybe<Trust_Portal_Access_Requests_Set_Input>;
  pk_columns: Trust_Portal_Access_Requests_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Access_Requests_ManyArgs = {
  updates: Array<Trust_Portal_Access_Requests_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_CategoriesArgs = {
  _set?: InputMaybe<Trust_Portal_Categories_Set_Input>;
  where: Trust_Portal_Categories_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Categories_By_PkArgs = {
  _set?: InputMaybe<Trust_Portal_Categories_Set_Input>;
  pk_columns: Trust_Portal_Categories_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Categories_ManyArgs = {
  updates: Array<Trust_Portal_Categories_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_DocumentsArgs = {
  _set?: InputMaybe<Trust_Portal_Documents_Set_Input>;
  where: Trust_Portal_Documents_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Documents_By_PkArgs = {
  _set?: InputMaybe<Trust_Portal_Documents_Set_Input>;
  pk_columns: Trust_Portal_Documents_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Documents_ManyArgs = {
  updates: Array<Trust_Portal_Documents_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_FaqsArgs = {
  _set?: InputMaybe<Trust_Portal_Faqs_Set_Input>;
  where: Trust_Portal_Faqs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Faqs_By_PkArgs = {
  _set?: InputMaybe<Trust_Portal_Faqs_Set_Input>;
  pk_columns: Trust_Portal_Faqs_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Faqs_ManyArgs = {
  updates: Array<Trust_Portal_Faqs_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_FrameworksArgs = {
  _set?: InputMaybe<Trust_Portal_Frameworks_Set_Input>;
  where: Trust_Portal_Frameworks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Frameworks_By_PkArgs = {
  _set?: InputMaybe<Trust_Portal_Frameworks_Set_Input>;
  pk_columns: Trust_Portal_Frameworks_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Frameworks_ManyArgs = {
  updates: Array<Trust_Portal_Frameworks_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_PagesArgs = {
  _append?: InputMaybe<Trust_Portal_Pages_Append_Input>;
  _delete_at_path?: InputMaybe<Trust_Portal_Pages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trust_Portal_Pages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trust_Portal_Pages_Delete_Key_Input>;
  _prepend?: InputMaybe<Trust_Portal_Pages_Prepend_Input>;
  _set?: InputMaybe<Trust_Portal_Pages_Set_Input>;
  where: Trust_Portal_Pages_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Pages_By_PkArgs = {
  _append?: InputMaybe<Trust_Portal_Pages_Append_Input>;
  _delete_at_path?: InputMaybe<Trust_Portal_Pages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trust_Portal_Pages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trust_Portal_Pages_Delete_Key_Input>;
  _prepend?: InputMaybe<Trust_Portal_Pages_Prepend_Input>;
  _set?: InputMaybe<Trust_Portal_Pages_Set_Input>;
  pk_columns: Trust_Portal_Pages_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Pages_ManyArgs = {
  updates: Array<Trust_Portal_Pages_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Resource_SectionsArgs = {
  _set?: InputMaybe<Trust_Portal_Resource_Sections_Set_Input>;
  where: Trust_Portal_Resource_Sections_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Resource_Sections_By_PkArgs = {
  _set?: InputMaybe<Trust_Portal_Resource_Sections_Set_Input>;
  pk_columns: Trust_Portal_Resource_Sections_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Resource_Sections_ManyArgs = {
  updates: Array<Trust_Portal_Resource_Sections_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_UpdatesArgs = {
  _set?: InputMaybe<Trust_Portal_Updates_Set_Input>;
  where: Trust_Portal_Updates_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Updates_By_PkArgs = {
  _set?: InputMaybe<Trust_Portal_Updates_Set_Input>;
  pk_columns: Trust_Portal_Updates_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Trust_Portal_Updates_ManyArgs = {
  updates: Array<Trust_Portal_Updates_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Url_Field_ValuesArgs = {
  _set?: InputMaybe<Url_Field_Values_Set_Input>;
  where: Url_Field_Values_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Url_Field_Values_By_PkArgs = {
  _set?: InputMaybe<Url_Field_Values_Set_Input>;
  pk_columns: Url_Field_Values_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Url_Field_Values_ManyArgs = {
  updates: Array<Url_Field_Values_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_User_NotificationsArgs = {
  _set?: InputMaybe<User_Notifications_Set_Input>;
  where: User_Notifications_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_User_Notifications_By_PkArgs = {
  _set?: InputMaybe<User_Notifications_Set_Input>;
  pk_columns: User_Notifications_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_User_Notifications_ManyArgs = {
  updates: Array<User_Notifications_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_User_ProfilesArgs = {
  _set?: InputMaybe<User_Profiles_Set_Input>;
  where: User_Profiles_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_User_Profiles_By_PkArgs = {
  _set?: InputMaybe<User_Profiles_Set_Input>;
  pk_columns: User_Profiles_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_User_Profiles_ManyArgs = {
  updates: Array<User_Profiles_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_Approval_StatusArgs = {
  approvalStatus?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['uuid']['input']>;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_ApprovalsArgs = {
  _set?: InputMaybe<Vendor_Approvals_Set_Input>;
  where: Vendor_Approvals_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_Approvals_By_PkArgs = {
  _set?: InputMaybe<Vendor_Approvals_Set_Input>;
  pk_columns: Vendor_Approvals_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_Approvals_ManyArgs = {
  updates: Array<Vendor_Approvals_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_ApproversArgs = {
  _set?: InputMaybe<Vendor_Approvers_Set_Input>;
  where: Vendor_Approvers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_Approvers_By_PkArgs = {
  _set?: InputMaybe<Vendor_Approvers_Set_Input>;
  pk_columns: Vendor_Approvers_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_Approvers_ManyArgs = {
  updates: Array<Vendor_Approvers_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_FindingsArgs = {
  _set?: InputMaybe<Vendor_Findings_Set_Input>;
  where: Vendor_Findings_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_Findings_By_PkArgs = {
  _set?: InputMaybe<Vendor_Findings_Set_Input>;
  pk_columns: Vendor_Findings_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_Findings_ManyArgs = {
  updates: Array<Vendor_Findings_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_Questionnaire_SchedulesArgs = {
  _set?: InputMaybe<Vendor_Questionnaire_Schedules_Set_Input>;
  where: Vendor_Questionnaire_Schedules_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_Questionnaire_Schedules_By_PkArgs = {
  _set?: InputMaybe<Vendor_Questionnaire_Schedules_Set_Input>;
  pk_columns: Vendor_Questionnaire_Schedules_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_Questionnaire_Schedules_ManyArgs = {
  updates: Array<Vendor_Questionnaire_Schedules_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_QuestionnairesArgs = {
  _set?: InputMaybe<Vendor_Questionnaires_Set_Input>;
  where: Vendor_Questionnaires_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_Questionnaires_By_PkArgs = {
  _set?: InputMaybe<Vendor_Questionnaires_Set_Input>;
  pk_columns: Vendor_Questionnaires_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Vendor_Questionnaires_ManyArgs = {
  updates: Array<Vendor_Questionnaires_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_VendorsArgs = {
  _set?: InputMaybe<Vendors_Set_Input>;
  where: Vendors_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Vendors_By_PkArgs = {
  _set?: InputMaybe<Vendors_Set_Input>;
  pk_columns: Vendors_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Vendors_ManyArgs = {
  updates: Array<Vendors_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Vq_Custom_FieldsArgs = {
  _set?: InputMaybe<Vq_Custom_Fields_Set_Input>;
  where: Vq_Custom_Fields_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Vq_Custom_Fields_By_PkArgs = {
  _set?: InputMaybe<Vq_Custom_Fields_Set_Input>;
  pk_columns: Vq_Custom_Fields_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Vq_Custom_Fields_ManyArgs = {
  updates: Array<Vq_Custom_Fields_Updates>;
};

/** mutation root */
export type Mutation_RootVerify_Email_SenderArgs = {
  object: EmailSenderOrgInput;
};

/** mutation root */
export type Mutation_RootVerify_Trust_Portal_DomainArgs = {
  object: TrustPortalDomainOrgInput;
};

export enum Notification_Delivery_Types_Enum {
  Email = 'email',
  Platform = 'platform',
}

/** Boolean expression to compare columns of type "notification_delivery_types_enum". All fields are combined with logical 'AND'. */
export type Notification_Delivery_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Notification_Delivery_Types_Enum>;
  _in?: InputMaybe<Array<Notification_Delivery_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Notification_Delivery_Types_Enum>;
  _nin?: InputMaybe<Array<Notification_Delivery_Types_Enum>>;
};

/** entries for disabling a notification delivery type */
export type Notification_Disabled_Settings = {
  __typename?: 'notification_disabled_settings';
  created_at: Scalars['timestamptz']['output'];
  delivery_type: Notification_Delivery_Types_Enum;
  id: Scalars['uuid']['output'];
  type: Notification_Types_Enum;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "notification_disabled_settings" */
export type Notification_Disabled_Settings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notification_Disabled_Settings_Max_Order_By>;
  min?: InputMaybe<Notification_Disabled_Settings_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "notification_disabled_settings". All fields are combined with a logical 'AND'. */
export type Notification_Disabled_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Disabled_Settings_Bool_Exp>>;
  _not?: InputMaybe<Notification_Disabled_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Disabled_Settings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_type?: InputMaybe<Notification_Delivery_Types_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Notification_Types_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_disabled_settings" */
export enum Notification_Disabled_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationDisabledSettingsPkey = 'notification_disabled_settings_pkey',
  /** unique or primary key constraint on columns "user_id", "type", "delivery_type" */
  NotificationDisabledSettingsUserIdTypeDeliveryTypeKey = 'notification_disabled_settings_user_id_type_delivery_type_key',
}

/** input type for inserting data into table "notification_disabled_settings" */
export type Notification_Disabled_Settings_Insert_Input = {
  delivery_type?: InputMaybe<Notification_Delivery_Types_Enum>;
  type?: InputMaybe<Notification_Types_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "notification_disabled_settings" */
export type Notification_Disabled_Settings_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "notification_disabled_settings" */
export type Notification_Disabled_Settings_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_disabled_settings" */
export type Notification_Disabled_Settings_Mutation_Response = {
  __typename?: 'notification_disabled_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Disabled_Settings>;
};

/** on_conflict condition type for table "notification_disabled_settings" */
export type Notification_Disabled_Settings_On_Conflict = {
  constraint: Notification_Disabled_Settings_Constraint;
  update_columns?: Array<Notification_Disabled_Settings_Update_Column>;
  where?: InputMaybe<Notification_Disabled_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_disabled_settings". */
export type Notification_Disabled_Settings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  delivery_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "notification_disabled_settings" */
export enum Notification_Disabled_Settings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveryType = 'delivery_type',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id',
}

/** Streaming cursor of the table "notification_disabled_settings" */
export type Notification_Disabled_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Disabled_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Disabled_Settings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_type?: InputMaybe<Notification_Delivery_Types_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Notification_Types_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "notification_disabled_settings" (current role has no relevant permissions) */
export enum Notification_Disabled_Settings_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "notification_entities" */
export type Notification_Entities = {
  __typename?: 'notification_entities';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  notification: Notifications;
  notification_id: Scalars['uuid']['output'];
  /** An object relationship */
  policy_version: Policy_Versions;
  policy_version_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "notification_entities" */
export type Notification_Entities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notification_Entities_Max_Order_By>;
  min?: InputMaybe<Notification_Entities_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "notification_entities". All fields are combined with a logical 'AND'. */
export type Notification_Entities_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Entities_Bool_Exp>>;
  _not?: InputMaybe<Notification_Entities_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Entities_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notification?: InputMaybe<Notifications_Bool_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  policy_version?: InputMaybe<Policy_Versions_Bool_Exp>;
  policy_version_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "notification_entities" */
export type Notification_Entities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "notification_entities" */
export type Notification_Entities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "notification_entities". */
export type Notification_Entities_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification?: InputMaybe<Notifications_Order_By>;
  notification_id?: InputMaybe<Order_By>;
  policy_version?: InputMaybe<Policy_Versions_Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
};

/** select columns of table "notification_entities" */
export enum Notification_Entities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  PolicyVersionId = 'policy_version_id',
}

export enum Notification_Types_Enum {
  ClientQuestionnaireProcessingDone = 'client_questionnaire_processing_done',
  ClientQuestionnaireProcessingFailed = 'client_questionnaire_processing_failed',
  ClientQuestionnaireStatusExpiring = 'client_questionnaire_status_expiring',
  ClientQuestionnaireStatusOverdue = 'client_questionnaire_status_overdue',
  CommentedInThread = 'commented_in_thread',
  CompletedTasksCreatedByYou = 'completed_tasks_created_by_you',
  ControlStatusChangedToNotValid = 'control_status_changed_to_not_valid',
  EntityOwnershipChanged = 'entity_ownership_changed',
  EvidenceAccessGranted = 'evidence_access_granted',
  MentionedInComment = 'mentioned_in_comment',
  OverdueTasksAssignedToYou = 'overdue_tasks_assigned_to_you',
  OverdueTasksCreatedByYou = 'overdue_tasks_created_by_you',
  PolicyAcknowledgementReminder = 'policy_acknowledgement_reminder',
  PolicyApprovalReminder = 'policy_approval_reminder',
  PolicyVersionStatusChangedToExpiring = 'policy_version_status_changed_to_expiring',
  QuestionnaireStatusOverdue = 'questionnaire_status_overdue',
  RecurringVendorQuestionnaireSent = 'recurring_vendor_questionnaire_sent',
  RiskApprovalDueSoon = 'risk_approval_due_soon',
  RiskApprovalExpired = 'risk_approval_expired',
  RiskApprovalExpiring = 'risk_approval_expiring',
  RiskApprovalOverdue = 'risk_approval_overdue',
  RiskApprovalResponseReceived = 'risk_approval_response_received',
  RiskStatusChangedToExpiring = 'risk_status_changed_to_expiring',
  TrustPortalAccessRequestCreated = 'trust_portal_access_request_created',
  VendorApprovalDueSoon = 'vendor_approval_due_soon',
  VendorApprovalExpired = 'vendor_approval_expired',
  VendorApprovalExpiring = 'vendor_approval_expiring',
  VendorApprovalOverdue = 'vendor_approval_overdue',
  VendorApprovalResponseReceived = 'vendor_approval_response_received',
  VendorQuestionnaireSubmission = 'vendor_questionnaire_submission',
  VendorStatusChangedToExpiring = 'vendor_status_changed_to_expiring',
}

/** Boolean expression to compare columns of type "notification_types_enum". All fields are combined with logical 'AND'. */
export type Notification_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Notification_Types_Enum>;
  _in?: InputMaybe<Array<Notification_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Notification_Types_Enum>;
  _nin?: InputMaybe<Array<Notification_Types_Enum>>;
};

/** this table contains a notification entries which could have many users associated to */
export type Notifications = {
  __typename?: 'notifications';
  /** An object relationship */
  actor?: Maybe<Users>;
  actor_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  client_questionnaire?: Maybe<Client_Questionnaires>;
  /** An object relationship */
  control?: Maybe<Controls>;
  /** An object relationship */
  finding?: Maybe<Findings>;
  has_entities: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  notification_entities: Array<Notification_Entities>;
  /** An object relationship */
  notifications_comment?: Maybe<Comments>;
  /** An object relationship */
  notifications_evidence?: Maybe<Evidences>;
  /** An object relationship */
  notifications_risk?: Maybe<Risks>;
  /** An object relationship */
  notifications_vendor?: Maybe<Vendors>;
  /** An object relationship */
  notifications_vendor_questionnaire?: Maybe<Vendor_Questionnaires>;
  params: Scalars['NotificationParams']['output'];
  /** An object relationship */
  policy?: Maybe<Policies>;
  /** An object relationship */
  policy_exception?: Maybe<Policy_Exceptions>;
  /** An object relationship */
  policy_version?: Maybe<Policy_Versions>;
  /** An object relationship */
  task?: Maybe<Tasks>;
  /** An object relationship */
  trust_portal_access_request?: Maybe<Trust_Portal_Access_Requests>;
  type: Notification_Types_Enum;
  /** An array relationship */
  user_notifications: Array<User_Notifications>;
  /** An aggregate relationship */
  user_notifications_aggregate: User_Notifications_Aggregate;
};

/** this table contains a notification entries which could have many users associated to */
export type NotificationsNotification_EntitiesArgs = {
  distinct_on?: InputMaybe<Array<Notification_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Entities_Order_By>>;
  where?: InputMaybe<Notification_Entities_Bool_Exp>;
};

/** this table contains a notification entries which could have many users associated to */
export type NotificationsParamsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** this table contains a notification entries which could have many users associated to */
export type NotificationsUser_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};

/** this table contains a notification entries which could have many users associated to */
export type NotificationsUser_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};

/** order by aggregate values of table "notifications" */
export type Notifications_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notifications_Max_Order_By>;
  min?: InputMaybe<Notifications_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export type Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Notifications_Bool_Exp>>;
  _not?: InputMaybe<Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Notifications_Bool_Exp>>;
  actor?: InputMaybe<Users_Bool_Exp>;
  actor_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  client_questionnaire?: InputMaybe<Client_Questionnaires_Bool_Exp>;
  control?: InputMaybe<Controls_Bool_Exp>;
  finding?: InputMaybe<Findings_Bool_Exp>;
  has_entities?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notification_entities?: InputMaybe<Notification_Entities_Bool_Exp>;
  notifications_comment?: InputMaybe<Comments_Bool_Exp>;
  notifications_evidence?: InputMaybe<Evidences_Bool_Exp>;
  notifications_risk?: InputMaybe<Risks_Bool_Exp>;
  notifications_vendor?: InputMaybe<Vendors_Bool_Exp>;
  notifications_vendor_questionnaire?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
  params?: InputMaybe<Jsonb_Comparison_Exp>;
  policy?: InputMaybe<Policies_Bool_Exp>;
  policy_exception?: InputMaybe<Policy_Exceptions_Bool_Exp>;
  policy_version?: InputMaybe<Policy_Versions_Bool_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  trust_portal_access_request?: InputMaybe<Trust_Portal_Access_Requests_Bool_Exp>;
  type?: InputMaybe<Notification_Types_Enum_Comparison_Exp>;
  user_notifications?: InputMaybe<User_Notifications_Bool_Exp>;
  user_notifications_aggregate?: InputMaybe<User_Notifications_Aggregate_Bool_Exp>;
};

export type Notifications_Insert_Input = {
  __typename?: 'notifications_insert_input';
  params: Scalars['NotificationParams']['output'];
};

/** order by max() on columns of table "notifications" */
export type Notifications_Max_Order_By = {
  actor_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "notifications" */
export type Notifications_Min_Order_By = {
  actor_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "notifications". */
export type Notifications_Order_By = {
  actor?: InputMaybe<Users_Order_By>;
  actor_user_id?: InputMaybe<Order_By>;
  client_questionnaire?: InputMaybe<Client_Questionnaires_Order_By>;
  control?: InputMaybe<Controls_Order_By>;
  finding?: InputMaybe<Findings_Order_By>;
  has_entities?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_entities_aggregate?: InputMaybe<Notification_Entities_Aggregate_Order_By>;
  notifications_comment?: InputMaybe<Comments_Order_By>;
  notifications_evidence?: InputMaybe<Evidences_Order_By>;
  notifications_risk?: InputMaybe<Risks_Order_By>;
  notifications_vendor?: InputMaybe<Vendors_Order_By>;
  notifications_vendor_questionnaire?: InputMaybe<Vendor_Questionnaires_Order_By>;
  params?: InputMaybe<Order_By>;
  policy?: InputMaybe<Policies_Order_By>;
  policy_exception?: InputMaybe<Policy_Exceptions_Order_By>;
  policy_version?: InputMaybe<Policy_Versions_Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  trust_portal_access_request?: InputMaybe<Trust_Portal_Access_Requests_Order_By>;
  type?: InputMaybe<Order_By>;
  user_notifications_aggregate?: InputMaybe<User_Notifications_Aggregate_Order_By>;
};

/** select columns of table "notifications" */
export enum Notifications_Select_Column {
  /** column name */
  ActorUserId = 'actor_user_id',
  /** column name */
  HasEntities = 'has_entities',
  /** column name */
  Id = 'id',
  /** column name */
  Params = 'params',
  /** column name */
  Type = 'type',
}

/** Streaming cursor of the table "notifications" */
export type Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notifications_Stream_Cursor_Value_Input = {
  actor_user_id?: InputMaybe<Scalars['uuid']['input']>;
  has_entities?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Notification_Types_Enum>;
};

/** columns and relationships of "number_field_values" */
export type Number_Field_Values = {
  __typename?: 'number_field_values';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  fieldValueByFieldValueId: Field_Values;
  field_type: Scalars['String']['output'];
  /** An object relationship */
  field_value?: Maybe<Field_Values>;
  field_value_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  value: Scalars['numeric']['output'];
};

/** order by aggregate values of table "number_field_values" */
export type Number_Field_Values_Aggregate_Order_By = {
  avg?: InputMaybe<Number_Field_Values_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Number_Field_Values_Max_Order_By>;
  min?: InputMaybe<Number_Field_Values_Min_Order_By>;
  stddev?: InputMaybe<Number_Field_Values_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Number_Field_Values_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Number_Field_Values_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Number_Field_Values_Sum_Order_By>;
  var_pop?: InputMaybe<Number_Field_Values_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Number_Field_Values_Var_Samp_Order_By>;
  variance?: InputMaybe<Number_Field_Values_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "number_field_values" */
export type Number_Field_Values_Arr_Rel_Insert_Input = {
  data: Array<Number_Field_Values_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Number_Field_Values_On_Conflict>;
};

/** order by avg() on columns of table "number_field_values" */
export type Number_Field_Values_Avg_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "number_field_values". All fields are combined with a logical 'AND'. */
export type Number_Field_Values_Bool_Exp = {
  _and?: InputMaybe<Array<Number_Field_Values_Bool_Exp>>;
  _not?: InputMaybe<Number_Field_Values_Bool_Exp>;
  _or?: InputMaybe<Array<Number_Field_Values_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Bool_Exp>;
  field_type?: InputMaybe<String_Comparison_Exp>;
  field_value?: InputMaybe<Field_Values_Bool_Exp>;
  field_value_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "number_field_values" */
export enum Number_Field_Values_Constraint {
  /** unique or primary key constraint on columns "field_value_id" */
  NumberFieldValuesPkey = 'number_field_values_pkey',
}

/** input type for incrementing numeric columns in table "number_field_values" */
export type Number_Field_Values_Inc_Input = {
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "number_field_values" */
export type Number_Field_Values_Insert_Input = {
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Obj_Rel_Insert_Input>;
  field_value?: InputMaybe<Field_Values_Obj_Rel_Insert_Input>;
  field_value_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by max() on columns of table "number_field_values" */
export type Number_Field_Values_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "number_field_values" */
export type Number_Field_Values_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "number_field_values" */
export type Number_Field_Values_Mutation_Response = {
  __typename?: 'number_field_values_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Number_Field_Values>;
};

/** input type for inserting object relation for remote table "number_field_values" */
export type Number_Field_Values_Obj_Rel_Insert_Input = {
  data: Number_Field_Values_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Number_Field_Values_On_Conflict>;
};

/** on_conflict condition type for table "number_field_values" */
export type Number_Field_Values_On_Conflict = {
  constraint: Number_Field_Values_Constraint;
  update_columns?: Array<Number_Field_Values_Update_Column>;
  where?: InputMaybe<Number_Field_Values_Bool_Exp>;
};

/** Ordering options when selecting data from "number_field_values". */
export type Number_Field_Values_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value?: InputMaybe<Field_Values_Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: number_field_values */
export type Number_Field_Values_Pk_Columns_Input = {
  field_value_id: Scalars['uuid']['input'];
};

/** select columns of table "number_field_values" */
export enum Number_Field_Values_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  FieldValueId = 'field_value_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
}

/** input type for updating data in table "number_field_values" */
export type Number_Field_Values_Set_Input = {
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by stddev() on columns of table "number_field_values" */
export type Number_Field_Values_Stddev_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "number_field_values" */
export type Number_Field_Values_Stddev_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "number_field_values" */
export type Number_Field_Values_Stddev_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "number_field_values" */
export type Number_Field_Values_Sum_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** update columns of table "number_field_values" */
export enum Number_Field_Values_Update_Column {
  /** column name */
  Value = 'value',
}

export type Number_Field_Values_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Number_Field_Values_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Number_Field_Values_Set_Input>;
  /** filter the rows which have to be updated */
  where: Number_Field_Values_Bool_Exp;
};

/** order by var_pop() on columns of table "number_field_values" */
export type Number_Field_Values_Var_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "number_field_values" */
export type Number_Field_Values_Var_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "number_field_values" */
export type Number_Field_Values_Variance_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** Organization connections shared by sessions of a person, OAuth client, organization, and resource. */
export type Oauth_Organization_Grants = {
  __typename?: 'oauth_organization_grants';
  access: Scalars['String']['output'];
  audience: Scalars['String']['output'];
  /** Untrusted client display metadata, never an authorization input. */
  client_name?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  expires_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  granted_by_user: Users;
  granted_by_user_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  last_used_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  provider_client_id: Scalars['String']['output'];
  revoked_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "oauth.organization_grants" */
export type Oauth_Organization_Grants_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Oauth_Organization_Grants_Max_Order_By>;
  min?: InputMaybe<Oauth_Organization_Grants_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "oauth.organization_grants". All fields are combined with a logical 'AND'. */
export type Oauth_Organization_Grants_Bool_Exp = {
  _and?: InputMaybe<Array<Oauth_Organization_Grants_Bool_Exp>>;
  _not?: InputMaybe<Oauth_Organization_Grants_Bool_Exp>;
  _or?: InputMaybe<Array<Oauth_Organization_Grants_Bool_Exp>>;
  access?: InputMaybe<String_Comparison_Exp>;
  audience?: InputMaybe<String_Comparison_Exp>;
  client_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  granted_by_user?: InputMaybe<Users_Bool_Exp>;
  granted_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_used_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  provider_client_id?: InputMaybe<String_Comparison_Exp>;
  revoked_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "oauth.organization_grants" */
export type Oauth_Organization_Grants_Max_Order_By = {
  access?: InputMaybe<Order_By>;
  audience?: InputMaybe<Order_By>;
  /** Untrusted client display metadata, never an authorization input. */
  client_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  granted_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  provider_client_id?: InputMaybe<Order_By>;
  revoked_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "oauth.organization_grants" */
export type Oauth_Organization_Grants_Min_Order_By = {
  access?: InputMaybe<Order_By>;
  audience?: InputMaybe<Order_By>;
  /** Untrusted client display metadata, never an authorization input. */
  client_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  granted_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  provider_client_id?: InputMaybe<Order_By>;
  revoked_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "oauth.organization_grants". */
export type Oauth_Organization_Grants_Order_By = {
  access?: InputMaybe<Order_By>;
  audience?: InputMaybe<Order_By>;
  client_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  granted_by_user?: InputMaybe<Users_Order_By>;
  granted_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  provider_client_id?: InputMaybe<Order_By>;
  revoked_at?: InputMaybe<Order_By>;
};

/** select columns of table "oauth.organization_grants" */
export enum Oauth_Organization_Grants_Select_Column {
  /** column name */
  Access = 'access',
  /** column name */
  Audience = 'audience',
  /** column name */
  ClientName = 'client_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  GrantedByUserId = 'granted_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUsedAt = 'last_used_at',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ProviderClientId = 'provider_client_id',
  /** column name */
  RevokedAt = 'revoked_at',
}

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last',
}

/** Per-org assignment of an authenticated email domain and sender details */
export type Organization_Email_Domains = {
  __typename?: 'organization_email_domains';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  email_domain: Email_Domains;
  email_domain_id: Scalars['uuid']['output'];
  from_local_part: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "organization_email_domains" */
export type Organization_Email_Domains_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Email_Domains_Max_Order_By>;
  min?: InputMaybe<Organization_Email_Domains_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "organization_email_domains". All fields are combined with a logical 'AND'. */
export type Organization_Email_Domains_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Email_Domains_Bool_Exp>>;
  _not?: InputMaybe<Organization_Email_Domains_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Email_Domains_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_domain?: InputMaybe<Email_Domains_Bool_Exp>;
  email_domain_id?: InputMaybe<Uuid_Comparison_Exp>;
  from_local_part?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "organization_email_domains" */
export type Organization_Email_Domains_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_domain_id?: InputMaybe<Order_By>;
  from_local_part?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organization_email_domains" */
export type Organization_Email_Domains_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_domain_id?: InputMaybe<Order_By>;
  from_local_part?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "organization_email_domains". */
export type Organization_Email_Domains_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_domain?: InputMaybe<Email_Domains_Order_By>;
  email_domain_id?: InputMaybe<Order_By>;
  from_local_part?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "organization_email_domains" */
export enum Organization_Email_Domains_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailDomainId = 'email_domain_id',
  /** column name */
  FromLocalPart = 'from_local_part',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** columns and relationships of "organization_evidence_tags" */
export type Organization_Evidence_Tags = {
  __typename?: 'organization_evidence_tags';
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  evidence_tags: Array<Evidence_Tags>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "organization_evidence_tags" */
export type Organization_Evidence_TagsEvidence_TagsArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Tags_Order_By>>;
  where?: InputMaybe<Evidence_Tags_Bool_Exp>;
};

/** order by aggregate values of table "organization_evidence_tags" */
export type Organization_Evidence_Tags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Evidence_Tags_Max_Order_By>;
  min?: InputMaybe<Organization_Evidence_Tags_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "organization_evidence_tags". All fields are combined with a logical 'AND'. */
export type Organization_Evidence_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Evidence_Tags_Bool_Exp>>;
  _not?: InputMaybe<Organization_Evidence_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Evidence_Tags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  evidence_tags?: InputMaybe<Evidence_Tags_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_evidence_tags" */
export enum Organization_Evidence_Tags_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  OrganizationEvidenceTagsNameOrganizationIdKey = 'organization_evidence_tags_name_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationEvidenceTagsPkey = 'organization_evidence_tags_pkey',
}

/** input type for inserting data into table "organization_evidence_tags" */
export type Organization_Evidence_Tags_Insert_Input = {
  evidence_tags?: InputMaybe<Evidence_Tags_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "organization_evidence_tags" */
export type Organization_Evidence_Tags_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organization_evidence_tags" */
export type Organization_Evidence_Tags_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_evidence_tags" */
export type Organization_Evidence_Tags_Mutation_Response = {
  __typename?: 'organization_evidence_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Evidence_Tags>;
};

/** input type for inserting object relation for remote table "organization_evidence_tags" */
export type Organization_Evidence_Tags_Obj_Rel_Insert_Input = {
  data: Organization_Evidence_Tags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Evidence_Tags_On_Conflict>;
};

/** on_conflict condition type for table "organization_evidence_tags" */
export type Organization_Evidence_Tags_On_Conflict = {
  constraint: Organization_Evidence_Tags_Constraint;
  update_columns?: Array<Organization_Evidence_Tags_Update_Column>;
  where?: InputMaybe<Organization_Evidence_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_evidence_tags". */
export type Organization_Evidence_Tags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evidence_tags_aggregate?: InputMaybe<Evidence_Tags_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_evidence_tags */
export type Organization_Evidence_Tags_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_evidence_tags" */
export enum Organization_Evidence_Tags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "organization_evidence_tags" */
export type Organization_Evidence_Tags_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_evidence_tags" */
export type Organization_Evidence_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Evidence_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Evidence_Tags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_evidence_tags" */
export enum Organization_Evidence_Tags_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Organization_Evidence_Tags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Evidence_Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Evidence_Tags_Bool_Exp;
};

/** columns and relationships of "organization_finding_severities" */
export type Organization_Finding_Severities = {
  __typename?: 'organization_finding_severities';
  default_key?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  signal: Finding_Types_Enum;
  sort_order: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "organization_finding_severities". All fields are combined with a logical 'AND'. */
export type Organization_Finding_Severities_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Finding_Severities_Bool_Exp>>;
  _not?: InputMaybe<Organization_Finding_Severities_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Finding_Severities_Bool_Exp>>;
  default_key?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  signal?: InputMaybe<Finding_Types_Enum_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_finding_severities" */
export enum Organization_Finding_Severities_Constraint {
  /** unique or primary key constraint on columns "organization_id", "default_key" */
  OrganizationFindingSeveritiesOrganizationIdDefaultKeyKey = 'organization_finding_severities_organization_id_default_key_key',
  /** unique or primary key constraint on columns "id", "organization_id" */
  OrganizationFindingSeveritiesOrganizationIdIdKey = 'organization_finding_severities_organization_id_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationFindingSeveritiesPkey = 'organization_finding_severities_pkey',
}

/** input type for incrementing numeric columns in table "organization_finding_severities" */
export type Organization_Finding_Severities_Inc_Input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organization_finding_severities" */
export type Organization_Finding_Severities_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  signal?: InputMaybe<Finding_Types_Enum>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** response of any mutation on the table "organization_finding_severities" */
export type Organization_Finding_Severities_Mutation_Response = {
  __typename?: 'organization_finding_severities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Finding_Severities>;
};

/** on_conflict condition type for table "organization_finding_severities" */
export type Organization_Finding_Severities_On_Conflict = {
  constraint: Organization_Finding_Severities_Constraint;
  update_columns?: Array<Organization_Finding_Severities_Update_Column>;
  where?: InputMaybe<Organization_Finding_Severities_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_finding_severities". */
export type Organization_Finding_Severities_Order_By = {
  default_key?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  signal?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_finding_severities */
export type Organization_Finding_Severities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_finding_severities" */
export enum Organization_Finding_Severities_Select_Column {
  /** column name */
  DefaultKey = 'default_key',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Signal = 'signal',
  /** column name */
  SortOrder = 'sort_order',
}

/** input type for updating data in table "organization_finding_severities" */
export type Organization_Finding_Severities_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  signal?: InputMaybe<Finding_Types_Enum>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** Streaming cursor of the table "organization_finding_severities" */
export type Organization_Finding_Severities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Finding_Severities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Finding_Severities_Stream_Cursor_Value_Input = {
  default_key?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  signal?: InputMaybe<Finding_Types_Enum>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** update columns of table "organization_finding_severities" */
export enum Organization_Finding_Severities_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Label = 'label',
  /** column name */
  Signal = 'signal',
  /** column name */
  SortOrder = 'sort_order',
}

export type Organization_Finding_Severities_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Finding_Severities_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Finding_Severities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Finding_Severities_Bool_Exp;
};

/** columns and relationships of "organization_integrations" */
export type Organization_Integrations = {
  __typename?: 'organization_integrations';
  auth_name: Integration_Auth_Names_Enum;
  connected_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  connected_by_user?: Maybe<Users>;
  connection_revision: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  disabled: Scalars['Boolean']['output'];
  /** An array relationship */
  evidence_integrations: Array<Evidence_Integrations>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  integration: Integrations;
  is_configurable_by_user: Scalars['Boolean']['output'];
  is_connected: Scalars['Boolean']['output'];
  /** An object relationship */
  managed_credential?: Maybe<Integration_Managed_Credentials>;
  name: Scalars['citext']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  policy_integrations: Array<Policy_Integrations>;
  /** An object relationship */
  usage_stats?: Maybe<Integration_Usage_Stats_View>;
};

/** columns and relationships of "organization_integrations" */
export type Organization_IntegrationsEvidence_IntegrationsArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Integrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Integrations_Order_By>>;
  where?: InputMaybe<Evidence_Integrations_Bool_Exp>;
};

/** columns and relationships of "organization_integrations" */
export type Organization_IntegrationsPolicy_IntegrationsArgs = {
  distinct_on?: InputMaybe<Array<Policy_Integrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Integrations_Order_By>>;
  where?: InputMaybe<Policy_Integrations_Bool_Exp>;
};

/** order by aggregate values of table "organization_integrations" */
export type Organization_Integrations_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Integrations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Integrations_Max_Order_By>;
  min?: InputMaybe<Organization_Integrations_Min_Order_By>;
  stddev?: InputMaybe<Organization_Integrations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Integrations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Integrations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Integrations_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Integrations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Integrations_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Integrations_Variance_Order_By>;
};

/** order by avg() on columns of table "organization_integrations" */
export type Organization_Integrations_Avg_Order_By = {
  connection_revision?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization_integrations". All fields are combined with a logical 'AND'. */
export type Organization_Integrations_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Integrations_Bool_Exp>>;
  _not?: InputMaybe<Organization_Integrations_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Integrations_Bool_Exp>>;
  auth_name?: InputMaybe<Integration_Auth_Names_Enum_Comparison_Exp>;
  connected_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  connected_by_user?: InputMaybe<Users_Bool_Exp>;
  connection_revision?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  evidence_integrations?: InputMaybe<Evidence_Integrations_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  integration?: InputMaybe<Integrations_Bool_Exp>;
  is_configurable_by_user?: InputMaybe<Boolean_Comparison_Exp>;
  is_connected?: InputMaybe<Boolean_Comparison_Exp>;
  managed_credential?: InputMaybe<Integration_Managed_Credentials_Bool_Exp>;
  name?: InputMaybe<Citext_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  policy_integrations?: InputMaybe<Policy_Integrations_Bool_Exp>;
  usage_stats?: InputMaybe<Integration_Usage_Stats_View_Bool_Exp>;
};

/** order by max() on columns of table "organization_integrations" */
export type Organization_Integrations_Max_Order_By = {
  connected_at?: InputMaybe<Order_By>;
  connection_revision?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organization_integrations" */
export type Organization_Integrations_Min_Order_By = {
  connected_at?: InputMaybe<Order_By>;
  connection_revision?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_integrations" */
export type Organization_Integrations_Mutation_Response = {
  __typename?: 'organization_integrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Integrations>;
};

/** Ordering options when selecting data from "organization_integrations". */
export type Organization_Integrations_Order_By = {
  auth_name?: InputMaybe<Order_By>;
  connected_at?: InputMaybe<Order_By>;
  connected_by_user?: InputMaybe<Users_Order_By>;
  connection_revision?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  evidence_integrations_aggregate?: InputMaybe<Evidence_Integrations_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  integration?: InputMaybe<Integrations_Order_By>;
  is_configurable_by_user?: InputMaybe<Order_By>;
  is_connected?: InputMaybe<Order_By>;
  managed_credential?: InputMaybe<Integration_Managed_Credentials_Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  policy_integrations_aggregate?: InputMaybe<Policy_Integrations_Aggregate_Order_By>;
  usage_stats?: InputMaybe<Integration_Usage_Stats_View_Order_By>;
};

/** select columns of table "organization_integrations" */
export enum Organization_Integrations_Select_Column {
  /** column name */
  AuthName = 'auth_name',
  /** column name */
  ConnectedAt = 'connected_at',
  /** column name */
  ConnectionRevision = 'connection_revision',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsConfigurableByUser = 'is_configurable_by_user',
  /** column name */
  IsConnected = 'is_connected',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
}

/** order by stddev() on columns of table "organization_integrations" */
export type Organization_Integrations_Stddev_Order_By = {
  connection_revision?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "organization_integrations" */
export type Organization_Integrations_Stddev_Pop_Order_By = {
  connection_revision?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "organization_integrations" */
export type Organization_Integrations_Stddev_Samp_Order_By = {
  connection_revision?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization_integrations" */
export type Organization_Integrations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Integrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Integrations_Stream_Cursor_Value_Input = {
  auth_name?: InputMaybe<Integration_Auth_Names_Enum>;
  connected_at?: InputMaybe<Scalars['timestamptz']['input']>;
  connection_revision?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_configurable_by_user?: InputMaybe<Scalars['Boolean']['input']>;
  is_connected?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['citext']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "organization_integrations" */
export type Organization_Integrations_Sum_Order_By = {
  connection_revision?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "organization_integrations" */
export type Organization_Integrations_Var_Pop_Order_By = {
  connection_revision?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "organization_integrations" */
export type Organization_Integrations_Var_Samp_Order_By = {
  connection_revision?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "organization_integrations" */
export type Organization_Integrations_Variance_Order_By = {
  connection_revision?: InputMaybe<Order_By>;
};

/** Firmographic profile per organization (industry, size, revenue, country, currency). Self-reported, used to give Complyance AI context and to calibrate FAIR risk estimates. */
export type Organization_Profiles = {
  __typename?: 'organization_profiles';
  annual_revenue_max?: Maybe<Scalars['numeric']['output']>;
  annual_revenue_min?: Maybe<Scalars['numeric']['output']>;
  country_code: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  currency_code: Scalars['String']['output'];
  employee_count_max?: Maybe<Scalars['Int']['output']>;
  employee_count_min?: Maybe<Scalars['Int']['output']>;
  /** UI bucket key. employee_count_min/max are the source of truth. */
  employee_range?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** App-defined category key, not backed by a lookup table. See IndustryKey in organization-profile.constants.ts for the current valid set. */
  industry?: Maybe<Scalars['String']['output']>;
  /** App-defined BCP-47 locale tag, not backed by a lookup table. See LanguageCode in @main/i18next for the current valid set. Default interface language for the organization. */
  language: Scalars['String']['output'];
  /** An object relationship */
  logo_file?: Maybe<Files>;
  /** Company logo shown on exported policies. */
  logo_file_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** UI bucket key. annual_revenue_min/max are the source of truth. */
  revenue_range?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "organization_profiles" */
export type Organization_Profiles_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Profiles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Profiles_Max_Order_By>;
  min?: InputMaybe<Organization_Profiles_Min_Order_By>;
  stddev?: InputMaybe<Organization_Profiles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Profiles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Profiles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Profiles_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Profiles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Profiles_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Profiles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organization_profiles" */
export type Organization_Profiles_Arr_Rel_Insert_Input = {
  data: Array<Organization_Profiles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Profiles_On_Conflict>;
};

/** order by avg() on columns of table "organization_profiles" */
export type Organization_Profiles_Avg_Order_By = {
  annual_revenue_max?: InputMaybe<Order_By>;
  annual_revenue_min?: InputMaybe<Order_By>;
  employee_count_max?: InputMaybe<Order_By>;
  employee_count_min?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization_profiles". All fields are combined with a logical 'AND'. */
export type Organization_Profiles_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Profiles_Bool_Exp>>;
  _not?: InputMaybe<Organization_Profiles_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Profiles_Bool_Exp>>;
  annual_revenue_max?: InputMaybe<Numeric_Comparison_Exp>;
  annual_revenue_min?: InputMaybe<Numeric_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency_code?: InputMaybe<String_Comparison_Exp>;
  employee_count_max?: InputMaybe<Int_Comparison_Exp>;
  employee_count_min?: InputMaybe<Int_Comparison_Exp>;
  employee_range?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  industry?: InputMaybe<String_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  logo_file?: InputMaybe<Files_Bool_Exp>;
  logo_file_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  revenue_range?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_profiles" */
export enum Organization_Profiles_Constraint {
  /** unique or primary key constraint on columns "organization_id" */
  OrganizationProfilesOrganizationIdKey = 'organization_profiles_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationProfilesPkey = 'organization_profiles_pkey',
}

/** input type for incrementing numeric columns in table "organization_profiles" */
export type Organization_Profiles_Inc_Input = {
  annual_revenue_max?: InputMaybe<Scalars['numeric']['input']>;
  annual_revenue_min?: InputMaybe<Scalars['numeric']['input']>;
  employee_count_max?: InputMaybe<Scalars['Int']['input']>;
  employee_count_min?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organization_profiles" */
export type Organization_Profiles_Insert_Input = {
  annual_revenue_max?: InputMaybe<Scalars['numeric']['input']>;
  annual_revenue_min?: InputMaybe<Scalars['numeric']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  currency_code?: InputMaybe<Scalars['String']['input']>;
  employee_count_max?: InputMaybe<Scalars['Int']['input']>;
  employee_count_min?: InputMaybe<Scalars['Int']['input']>;
  /** UI bucket key. employee_count_min/max are the source of truth. */
  employee_range?: InputMaybe<Scalars['String']['input']>;
  /** App-defined category key, not backed by a lookup table. See IndustryKey in organization-profile.constants.ts for the current valid set. */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** App-defined BCP-47 locale tag, not backed by a lookup table. See LanguageCode in @main/i18next for the current valid set. Default interface language for the organization. */
  language?: InputMaybe<Scalars['String']['input']>;
  logo_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  /** Company logo shown on exported policies. */
  logo_file_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  /** UI bucket key. annual_revenue_min/max are the source of truth. */
  revenue_range?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "organization_profiles" */
export type Organization_Profiles_Max_Order_By = {
  annual_revenue_max?: InputMaybe<Order_By>;
  annual_revenue_min?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_code?: InputMaybe<Order_By>;
  employee_count_max?: InputMaybe<Order_By>;
  employee_count_min?: InputMaybe<Order_By>;
  /** UI bucket key. employee_count_min/max are the source of truth. */
  employee_range?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** App-defined category key, not backed by a lookup table. See IndustryKey in organization-profile.constants.ts for the current valid set. */
  industry?: InputMaybe<Order_By>;
  /** App-defined BCP-47 locale tag, not backed by a lookup table. See LanguageCode in @main/i18next for the current valid set. Default interface language for the organization. */
  language?: InputMaybe<Order_By>;
  /** Company logo shown on exported policies. */
  logo_file_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  /** UI bucket key. annual_revenue_min/max are the source of truth. */
  revenue_range?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organization_profiles" */
export type Organization_Profiles_Min_Order_By = {
  annual_revenue_max?: InputMaybe<Order_By>;
  annual_revenue_min?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_code?: InputMaybe<Order_By>;
  employee_count_max?: InputMaybe<Order_By>;
  employee_count_min?: InputMaybe<Order_By>;
  /** UI bucket key. employee_count_min/max are the source of truth. */
  employee_range?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** App-defined category key, not backed by a lookup table. See IndustryKey in organization-profile.constants.ts for the current valid set. */
  industry?: InputMaybe<Order_By>;
  /** App-defined BCP-47 locale tag, not backed by a lookup table. See LanguageCode in @main/i18next for the current valid set. Default interface language for the organization. */
  language?: InputMaybe<Order_By>;
  /** Company logo shown on exported policies. */
  logo_file_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  /** UI bucket key. annual_revenue_min/max are the source of truth. */
  revenue_range?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_profiles" */
export type Organization_Profiles_Mutation_Response = {
  __typename?: 'organization_profiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Profiles>;
};

/** on_conflict condition type for table "organization_profiles" */
export type Organization_Profiles_On_Conflict = {
  constraint: Organization_Profiles_Constraint;
  update_columns?: Array<Organization_Profiles_Update_Column>;
  where?: InputMaybe<Organization_Profiles_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_profiles". */
export type Organization_Profiles_Order_By = {
  annual_revenue_max?: InputMaybe<Order_By>;
  annual_revenue_min?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_code?: InputMaybe<Order_By>;
  employee_count_max?: InputMaybe<Order_By>;
  employee_count_min?: InputMaybe<Order_By>;
  employee_range?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  industry?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  logo_file?: InputMaybe<Files_Order_By>;
  logo_file_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  revenue_range?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_profiles */
export type Organization_Profiles_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_profiles" */
export enum Organization_Profiles_Select_Column {
  /** column name */
  AnnualRevenueMax = 'annual_revenue_max',
  /** column name */
  AnnualRevenueMin = 'annual_revenue_min',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyCode = 'currency_code',
  /** column name */
  EmployeeCountMax = 'employee_count_max',
  /** column name */
  EmployeeCountMin = 'employee_count_min',
  /** column name */
  EmployeeRange = 'employee_range',
  /** column name */
  Id = 'id',
  /** column name */
  Industry = 'industry',
  /** column name */
  Language = 'language',
  /** column name */
  LogoFileId = 'logo_file_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RevenueRange = 'revenue_range',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "organization_profiles" */
export type Organization_Profiles_Set_Input = {
  annual_revenue_max?: InputMaybe<Scalars['numeric']['input']>;
  annual_revenue_min?: InputMaybe<Scalars['numeric']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  currency_code?: InputMaybe<Scalars['String']['input']>;
  employee_count_max?: InputMaybe<Scalars['Int']['input']>;
  employee_count_min?: InputMaybe<Scalars['Int']['input']>;
  /** UI bucket key. employee_count_min/max are the source of truth. */
  employee_range?: InputMaybe<Scalars['String']['input']>;
  /** App-defined category key, not backed by a lookup table. See IndustryKey in organization-profile.constants.ts for the current valid set. */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** App-defined BCP-47 locale tag, not backed by a lookup table. See LanguageCode in @main/i18next for the current valid set. Default interface language for the organization. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Company logo shown on exported policies. */
  logo_file_id?: InputMaybe<Scalars['uuid']['input']>;
  /** UI bucket key. annual_revenue_min/max are the source of truth. */
  revenue_range?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "organization_profiles" */
export type Organization_Profiles_Stddev_Order_By = {
  annual_revenue_max?: InputMaybe<Order_By>;
  annual_revenue_min?: InputMaybe<Order_By>;
  employee_count_max?: InputMaybe<Order_By>;
  employee_count_min?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "organization_profiles" */
export type Organization_Profiles_Stddev_Pop_Order_By = {
  annual_revenue_max?: InputMaybe<Order_By>;
  annual_revenue_min?: InputMaybe<Order_By>;
  employee_count_max?: InputMaybe<Order_By>;
  employee_count_min?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "organization_profiles" */
export type Organization_Profiles_Stddev_Samp_Order_By = {
  annual_revenue_max?: InputMaybe<Order_By>;
  annual_revenue_min?: InputMaybe<Order_By>;
  employee_count_max?: InputMaybe<Order_By>;
  employee_count_min?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "organization_profiles" */
export type Organization_Profiles_Sum_Order_By = {
  annual_revenue_max?: InputMaybe<Order_By>;
  annual_revenue_min?: InputMaybe<Order_By>;
  employee_count_max?: InputMaybe<Order_By>;
  employee_count_min?: InputMaybe<Order_By>;
};

/** update columns of table "organization_profiles" */
export enum Organization_Profiles_Update_Column {
  /** column name */
  AnnualRevenueMax = 'annual_revenue_max',
  /** column name */
  AnnualRevenueMin = 'annual_revenue_min',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CurrencyCode = 'currency_code',
  /** column name */
  EmployeeCountMax = 'employee_count_max',
  /** column name */
  EmployeeCountMin = 'employee_count_min',
  /** column name */
  EmployeeRange = 'employee_range',
  /** column name */
  Industry = 'industry',
  /** column name */
  Language = 'language',
  /** column name */
  LogoFileId = 'logo_file_id',
  /** column name */
  RevenueRange = 'revenue_range',
}

export type Organization_Profiles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Profiles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Profiles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Profiles_Bool_Exp;
};

/** order by var_pop() on columns of table "organization_profiles" */
export type Organization_Profiles_Var_Pop_Order_By = {
  annual_revenue_max?: InputMaybe<Order_By>;
  annual_revenue_min?: InputMaybe<Order_By>;
  employee_count_max?: InputMaybe<Order_By>;
  employee_count_min?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "organization_profiles" */
export type Organization_Profiles_Var_Samp_Order_By = {
  annual_revenue_max?: InputMaybe<Order_By>;
  annual_revenue_min?: InputMaybe<Order_By>;
  employee_count_max?: InputMaybe<Order_By>;
  employee_count_min?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "organization_profiles" */
export type Organization_Profiles_Variance_Order_By = {
  annual_revenue_max?: InputMaybe<Order_By>;
  annual_revenue_min?: InputMaybe<Order_By>;
  employee_count_max?: InputMaybe<Order_By>;
  employee_count_min?: InputMaybe<Order_By>;
};

/** columns and relationships of "organization_risk_categories" */
export type Organization_Risk_Categories = {
  __typename?: 'organization_risk_categories';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  risk_categories: Array<Risk_Categories>;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "organization_risk_categories" */
export type Organization_Risk_CategoriesRisk_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Risk_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Categories_Order_By>>;
  where?: InputMaybe<Risk_Categories_Bool_Exp>;
};

/** order by aggregate values of table "organization_risk_categories" */
export type Organization_Risk_Categories_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Risk_Categories_Max_Order_By>;
  min?: InputMaybe<Organization_Risk_Categories_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "organization_risk_categories". All fields are combined with a logical 'AND'. */
export type Organization_Risk_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Risk_Categories_Bool_Exp>>;
  _not?: InputMaybe<Organization_Risk_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Risk_Categories_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  risk_categories?: InputMaybe<Risk_Categories_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_risk_categories" */
export enum Organization_Risk_Categories_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  OrganizationRiskCategoriesNameOrganizationIdKey = 'organization_risk_categories_name_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationRiskCategoriesPkey = 'organization_risk_categories_pkey',
}

/** input type for inserting data into table "organization_risk_categories" */
export type Organization_Risk_Categories_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  risk_categories?: InputMaybe<Risk_Categories_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "organization_risk_categories" */
export type Organization_Risk_Categories_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organization_risk_categories" */
export type Organization_Risk_Categories_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_risk_categories" */
export type Organization_Risk_Categories_Mutation_Response = {
  __typename?: 'organization_risk_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Risk_Categories>;
};

/** input type for inserting object relation for remote table "organization_risk_categories" */
export type Organization_Risk_Categories_Obj_Rel_Insert_Input = {
  data: Organization_Risk_Categories_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Risk_Categories_On_Conflict>;
};

/** on_conflict condition type for table "organization_risk_categories" */
export type Organization_Risk_Categories_On_Conflict = {
  constraint: Organization_Risk_Categories_Constraint;
  update_columns?: Array<Organization_Risk_Categories_Update_Column>;
  where?: InputMaybe<Organization_Risk_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_risk_categories". */
export type Organization_Risk_Categories_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  risk_categories_aggregate?: InputMaybe<Risk_Categories_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_risk_categories */
export type Organization_Risk_Categories_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_risk_categories" */
export enum Organization_Risk_Categories_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "organization_risk_categories" */
export type Organization_Risk_Categories_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_risk_categories" */
export type Organization_Risk_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Risk_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Risk_Categories_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_risk_categories" */
export enum Organization_Risk_Categories_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Organization_Risk_Categories_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Risk_Categories_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Risk_Categories_Bool_Exp;
};

/** columns and relationships of "organization_risk_levels" */
export type Organization_Risk_Levels = {
  __typename?: 'organization_risk_levels';
  color: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order: Scalars['String']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  risk_inherent_levels: Array<Risk_Inherent_Levels>;
  /** An array relationship */
  risk_residual_levels: Array<Risk_Residual_Levels>;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "organization_risk_levels" */
export type Organization_Risk_LevelsRisk_Inherent_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Inherent_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Inherent_Levels_Order_By>>;
  where?: InputMaybe<Risk_Inherent_Levels_Bool_Exp>;
};

/** columns and relationships of "organization_risk_levels" */
export type Organization_Risk_LevelsRisk_Residual_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Residual_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Residual_Levels_Order_By>>;
  where?: InputMaybe<Risk_Residual_Levels_Bool_Exp>;
};

/** order by aggregate values of table "organization_risk_levels" */
export type Organization_Risk_Levels_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Risk_Levels_Max_Order_By>;
  min?: InputMaybe<Organization_Risk_Levels_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "organization_risk_levels". All fields are combined with a logical 'AND'. */
export type Organization_Risk_Levels_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Risk_Levels_Bool_Exp>>;
  _not?: InputMaybe<Organization_Risk_Levels_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Risk_Levels_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  risk_inherent_levels?: InputMaybe<Risk_Inherent_Levels_Bool_Exp>;
  risk_residual_levels?: InputMaybe<Risk_Residual_Levels_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_risk_levels" */
export enum Organization_Risk_Levels_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  OrganizationRiskLevelsOrganizationIdNameKey = 'organization_risk_levels_organization_id_name_key',
  /** unique or primary key constraint on columns "organization_id", "order" */
  OrganizationRiskLevelsOrganizationIdOrderKey = 'organization_risk_levels_organization_id_order_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationRiskLevelsPkey = 'organization_risk_levels_pkey',
}

/** input type for inserting data into table "organization_risk_levels" */
export type Organization_Risk_Levels_Insert_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "organization_risk_levels" */
export type Organization_Risk_Levels_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organization_risk_levels" */
export type Organization_Risk_Levels_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_risk_levels" */
export type Organization_Risk_Levels_Mutation_Response = {
  __typename?: 'organization_risk_levels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Risk_Levels>;
};

/** on_conflict condition type for table "organization_risk_levels" */
export type Organization_Risk_Levels_On_Conflict = {
  constraint: Organization_Risk_Levels_Constraint;
  update_columns?: Array<Organization_Risk_Levels_Update_Column>;
  where?: InputMaybe<Organization_Risk_Levels_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_risk_levels". */
export type Organization_Risk_Levels_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  risk_inherent_levels_aggregate?: InputMaybe<Risk_Inherent_Levels_Aggregate_Order_By>;
  risk_residual_levels_aggregate?: InputMaybe<Risk_Residual_Levels_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_risk_levels */
export type Organization_Risk_Levels_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_risk_levels" */
export enum Organization_Risk_Levels_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "organization_risk_levels" */
export type Organization_Risk_Levels_Set_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_risk_levels" */
export type Organization_Risk_Levels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Risk_Levels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Risk_Levels_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_risk_levels" */
export enum Organization_Risk_Levels_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Organization_Risk_Levels_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Risk_Levels_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Risk_Levels_Bool_Exp;
};

/** columns and relationships of "organization_risk_tags" */
export type Organization_Risk_Tags = {
  __typename?: 'organization_risk_tags';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  risk_tags: Array<Risk_Tags>;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "organization_risk_tags" */
export type Organization_Risk_TagsRisk_TagsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Tags_Order_By>>;
  where?: InputMaybe<Risk_Tags_Bool_Exp>;
};

/** order by aggregate values of table "organization_risk_tags" */
export type Organization_Risk_Tags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Risk_Tags_Max_Order_By>;
  min?: InputMaybe<Organization_Risk_Tags_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "organization_risk_tags". All fields are combined with a logical 'AND'. */
export type Organization_Risk_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Risk_Tags_Bool_Exp>>;
  _not?: InputMaybe<Organization_Risk_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Risk_Tags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  risk_tags?: InputMaybe<Risk_Tags_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_risk_tags" */
export enum Organization_Risk_Tags_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  OrganizationRiskTagsNameOrganizationIdKey = 'organization_risk_tags_name_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationRiskTagsPkey = 'organization_risk_tags_pkey',
}

/** input type for inserting data into table "organization_risk_tags" */
export type Organization_Risk_Tags_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  risk_tags?: InputMaybe<Risk_Tags_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "organization_risk_tags" */
export type Organization_Risk_Tags_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organization_risk_tags" */
export type Organization_Risk_Tags_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_risk_tags" */
export type Organization_Risk_Tags_Mutation_Response = {
  __typename?: 'organization_risk_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Risk_Tags>;
};

/** input type for inserting object relation for remote table "organization_risk_tags" */
export type Organization_Risk_Tags_Obj_Rel_Insert_Input = {
  data: Organization_Risk_Tags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Risk_Tags_On_Conflict>;
};

/** on_conflict condition type for table "organization_risk_tags" */
export type Organization_Risk_Tags_On_Conflict = {
  constraint: Organization_Risk_Tags_Constraint;
  update_columns?: Array<Organization_Risk_Tags_Update_Column>;
  where?: InputMaybe<Organization_Risk_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_risk_tags". */
export type Organization_Risk_Tags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  risk_tags_aggregate?: InputMaybe<Risk_Tags_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_risk_tags */
export type Organization_Risk_Tags_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_risk_tags" */
export enum Organization_Risk_Tags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "organization_risk_tags" */
export type Organization_Risk_Tags_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_risk_tags" */
export type Organization_Risk_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Risk_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Risk_Tags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_risk_tags" */
export enum Organization_Risk_Tags_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Organization_Risk_Tags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Risk_Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Risk_Tags_Bool_Exp;
};

/** columns and relationships of "organization_template_frameworks" */
export type Organization_Template_Frameworks = {
  __typename?: 'organization_template_frameworks';
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  template_framework: Template_Frameworks;
  template_framework_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "organization_template_frameworks" */
export type Organization_Template_Frameworks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Template_Frameworks_Max_Order_By>;
  min?: InputMaybe<Organization_Template_Frameworks_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "organization_template_frameworks". All fields are combined with a logical 'AND'. */
export type Organization_Template_Frameworks_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Template_Frameworks_Bool_Exp>>;
  _not?: InputMaybe<Organization_Template_Frameworks_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Template_Frameworks_Bool_Exp>>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  template_framework?: InputMaybe<Template_Frameworks_Bool_Exp>;
  template_framework_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "organization_template_frameworks" */
export type Organization_Template_Frameworks_Max_Order_By = {
  organization_id?: InputMaybe<Order_By>;
  template_framework_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organization_template_frameworks" */
export type Organization_Template_Frameworks_Min_Order_By = {
  organization_id?: InputMaybe<Order_By>;
  template_framework_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "organization_template_frameworks". */
export type Organization_Template_Frameworks_Order_By = {
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  template_framework?: InputMaybe<Template_Frameworks_Order_By>;
  template_framework_id?: InputMaybe<Order_By>;
};

/** select columns of table "organization_template_frameworks" */
export enum Organization_Template_Frameworks_Select_Column {
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  TemplateFrameworkId = 'template_framework_id',
}

/** Streaming cursor of the table "organization_template_frameworks" */
export type Organization_Template_Frameworks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Template_Frameworks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Template_Frameworks_Stream_Cursor_Value_Input = {
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  template_framework_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** table consisting of tenants for an organization used for SSO */
export type Organization_Tenants = {
  __typename?: 'organization_tenants';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "organization_tenants" */
export type Organization_Tenants_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Tenants_Max_Order_By>;
  min?: InputMaybe<Organization_Tenants_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "organization_tenants". All fields are combined with a logical 'AND'. */
export type Organization_Tenants_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Tenants_Bool_Exp>>;
  _not?: InputMaybe<Organization_Tenants_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Tenants_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "organization_tenants" */
export type Organization_Tenants_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organization_tenants" */
export type Organization_Tenants_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "organization_tenants". */
export type Organization_Tenants_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "organization_tenants" */
export enum Organization_Tenants_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** Streaming cursor of the table "organization_tenants" */
export type Organization_Tenants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Tenants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Tenants_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** An organization can have multiple users. One user can belong to multiple organizations */
export type Organization_Users = {
  __typename?: 'organization_users';
  disabled: Scalars['Boolean']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  register_source: User_Register_Sources_Enum;
  /** An object relationship */
  role: Roles;
  role_id: Scalars['uuid']['output'];
  /** An array relationship */
  teams: Array<Team_Members>;
  /** An aggregate relationship */
  teams_aggregate: Team_Members_Aggregate;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** An organization can have multiple users. One user can belong to multiple organizations */
export type Organization_UsersTeamsArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

/** An organization can have multiple users. One user can belong to multiple organizations */
export type Organization_UsersTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

/** order by aggregate values of table "organization_users" */
export type Organization_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Users_Max_Order_By>;
  min?: InputMaybe<Organization_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "organization_users". All fields are combined with a logical 'AND'. */
export type Organization_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Users_Bool_Exp>>;
  _not?: InputMaybe<Organization_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Users_Bool_Exp>>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  register_source?: InputMaybe<User_Register_Sources_Enum_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Uuid_Comparison_Exp>;
  teams?: InputMaybe<Team_Members_Bool_Exp>;
  teams_aggregate?: InputMaybe<Team_Members_Aggregate_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "organization_users" */
export type Organization_Users_Max_Order_By = {
  organization_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organization_users" */
export type Organization_Users_Min_Order_By = {
  organization_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_users" */
export type Organization_Users_Mutation_Response = {
  __typename?: 'organization_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Users>;
};

/** Ordering options when selecting data from "organization_users". */
export type Organization_Users_Order_By = {
  disabled?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  register_source?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
  teams_aggregate?: InputMaybe<Team_Members_Aggregate_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_users */
export type Organization_Users_Pk_Columns_Input = {
  organization_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "organization_users" */
export enum Organization_Users_Select_Column {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RegisterSource = 'register_source',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "organization_users" */
export type Organization_Users_Set_Input = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organization_users" */
export type Organization_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Users_Stream_Cursor_Value_Input = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  register_source?: InputMaybe<User_Register_Sources_Enum>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Organization_Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Users_Bool_Exp;
};

/** columns and relationships of "organization_vendor_risk_levels" */
export type Organization_Vendor_Risk_Levels = {
  __typename?: 'organization_vendor_risk_levels';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  vendors: Array<Vendors>;
  /** An aggregate relationship */
  vendors_aggregate: Vendors_Aggregate;
};

/** columns and relationships of "organization_vendor_risk_levels" */
export type Organization_Vendor_Risk_LevelsVendorsArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

/** columns and relationships of "organization_vendor_risk_levels" */
export type Organization_Vendor_Risk_LevelsVendors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

/** order by aggregate values of table "organization_vendor_risk_levels" */
export type Organization_Vendor_Risk_Levels_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Vendor_Risk_Levels_Max_Order_By>;
  min?: InputMaybe<Organization_Vendor_Risk_Levels_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "organization_vendor_risk_levels". All fields are combined with a logical 'AND'. */
export type Organization_Vendor_Risk_Levels_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Vendor_Risk_Levels_Bool_Exp>>;
  _not?: InputMaybe<Organization_Vendor_Risk_Levels_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Vendor_Risk_Levels_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendors?: InputMaybe<Vendors_Bool_Exp>;
  vendors_aggregate?: InputMaybe<Vendors_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "organization_vendor_risk_levels" */
export enum Organization_Vendor_Risk_Levels_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  OrganizationVendorRiskLevelsOrganizationIdNameKey = 'organization_vendor_risk_levels_organization_id_name_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationVendorRiskLevelsPkey = 'organization_vendor_risk_levels_pkey',
}

/** input type for inserting data into table "organization_vendor_risk_levels" */
export type Organization_Vendor_Risk_Levels_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  vendors?: InputMaybe<Vendors_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "organization_vendor_risk_levels" */
export type Organization_Vendor_Risk_Levels_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organization_vendor_risk_levels" */
export type Organization_Vendor_Risk_Levels_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_vendor_risk_levels" */
export type Organization_Vendor_Risk_Levels_Mutation_Response = {
  __typename?: 'organization_vendor_risk_levels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Vendor_Risk_Levels>;
};

/** input type for inserting object relation for remote table "organization_vendor_risk_levels" */
export type Organization_Vendor_Risk_Levels_Obj_Rel_Insert_Input = {
  data: Organization_Vendor_Risk_Levels_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Vendor_Risk_Levels_On_Conflict>;
};

/** on_conflict condition type for table "organization_vendor_risk_levels" */
export type Organization_Vendor_Risk_Levels_On_Conflict = {
  constraint: Organization_Vendor_Risk_Levels_Constraint;
  update_columns?: Array<Organization_Vendor_Risk_Levels_Update_Column>;
  where?: InputMaybe<Organization_Vendor_Risk_Levels_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_vendor_risk_levels". */
export type Organization_Vendor_Risk_Levels_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendors_aggregate?: InputMaybe<Vendors_Aggregate_Order_By>;
};

/** primary key columns input for table: organization_vendor_risk_levels */
export type Organization_Vendor_Risk_Levels_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_vendor_risk_levels" */
export enum Organization_Vendor_Risk_Levels_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "organization_vendor_risk_levels" */
export type Organization_Vendor_Risk_Levels_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_vendor_risk_levels" */
export type Organization_Vendor_Risk_Levels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Vendor_Risk_Levels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Vendor_Risk_Levels_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_vendor_risk_levels" */
export enum Organization_Vendor_Risk_Levels_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Organization_Vendor_Risk_Levels_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Vendor_Risk_Levels_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Vendor_Risk_Levels_Bool_Exp;
};

/** columns and relationships of "organization_vendor_tiers" */
export type Organization_Vendor_Tiers = {
  __typename?: 'organization_vendor_tiers';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  vendors: Array<Vendors>;
  /** An aggregate relationship */
  vendors_aggregate: Vendors_Aggregate;
};

/** columns and relationships of "organization_vendor_tiers" */
export type Organization_Vendor_TiersVendorsArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

/** columns and relationships of "organization_vendor_tiers" */
export type Organization_Vendor_TiersVendors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

/** order by aggregate values of table "organization_vendor_tiers" */
export type Organization_Vendor_Tiers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Vendor_Tiers_Max_Order_By>;
  min?: InputMaybe<Organization_Vendor_Tiers_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "organization_vendor_tiers". All fields are combined with a logical 'AND'. */
export type Organization_Vendor_Tiers_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Vendor_Tiers_Bool_Exp>>;
  _not?: InputMaybe<Organization_Vendor_Tiers_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Vendor_Tiers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendors?: InputMaybe<Vendors_Bool_Exp>;
  vendors_aggregate?: InputMaybe<Vendors_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "organization_vendor_tiers" */
export enum Organization_Vendor_Tiers_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  OrganizationVendorTiersOrganizationIdNameKey = 'organization_vendor_tiers_organization_id_name_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationVendorTiersPkey = 'organization_vendor_tiers_pkey',
}

/** input type for inserting data into table "organization_vendor_tiers" */
export type Organization_Vendor_Tiers_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  vendors?: InputMaybe<Vendors_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "organization_vendor_tiers" */
export type Organization_Vendor_Tiers_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organization_vendor_tiers" */
export type Organization_Vendor_Tiers_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_vendor_tiers" */
export type Organization_Vendor_Tiers_Mutation_Response = {
  __typename?: 'organization_vendor_tiers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Vendor_Tiers>;
};

/** input type for inserting object relation for remote table "organization_vendor_tiers" */
export type Organization_Vendor_Tiers_Obj_Rel_Insert_Input = {
  data: Organization_Vendor_Tiers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Vendor_Tiers_On_Conflict>;
};

/** on_conflict condition type for table "organization_vendor_tiers" */
export type Organization_Vendor_Tiers_On_Conflict = {
  constraint: Organization_Vendor_Tiers_Constraint;
  update_columns?: Array<Organization_Vendor_Tiers_Update_Column>;
  where?: InputMaybe<Organization_Vendor_Tiers_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_vendor_tiers". */
export type Organization_Vendor_Tiers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendors_aggregate?: InputMaybe<Vendors_Aggregate_Order_By>;
};

/** primary key columns input for table: organization_vendor_tiers */
export type Organization_Vendor_Tiers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_vendor_tiers" */
export enum Organization_Vendor_Tiers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "organization_vendor_tiers" */
export type Organization_Vendor_Tiers_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_vendor_tiers" */
export type Organization_Vendor_Tiers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Vendor_Tiers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Vendor_Tiers_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_vendor_tiers" */
export enum Organization_Vendor_Tiers_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Organization_Vendor_Tiers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Vendor_Tiers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Vendor_Tiers_Bool_Exp;
};

/** Table to manage organizations */
export type Organizations = {
  __typename?: 'organizations';
  /** An array relationship */
  agent_instances: Array<Agent_Instances>;
  /** An array relationship */
  categories: Array<Categories>;
  /** An array relationship */
  client_questionnaires: Array<Client_Questionnaires>;
  /** An array relationship */
  controls_histories: Array<Controls_History_Stats>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  criteria: Array<Criteria>;
  default_user_role_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  /** An array relationship */
  documents: Array<Documents>;
  /** An array relationship */
  evidence_tags: Array<Organization_Evidence_Tags>;
  /** An array relationship */
  evidences: Array<Evidences>;
  /** An aggregate relationship */
  evidences_aggregate: Evidences_Aggregate;
  /** An array relationship */
  field_configs: Array<Field_Configs>;
  /** An array relationship */
  frameworks: Array<Frameworks>;
  /** An array relationship */
  groups: Array<Groups>;
  id: Scalars['uuid']['output'];
  /** Minutes of in-app inactivity after which a user is automatically logged out. NULL disables the timeout. Valid range is 1 to 35791 minutes. When a user belongs to multiple organizations, the shortest configured value applies. */
  inactivity_timeout_minutes?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  invitations: Array<Invitations>;
  is_agent_trace_enabled: Scalars['Boolean']['output'];
  is_api_module_enabled: Scalars['Boolean']['output'];
  is_audit_trail_enabled: Scalars['Boolean']['output'];
  is_client_questionnaires_enabled: Scalars['Boolean']['output'];
  is_control_ai_review_enabled: Scalars['Boolean']['output'];
  is_controls_module_enabled: Scalars['Boolean']['output'];
  is_day_zero_ai_features_enabled: Scalars['Boolean']['output'];
  is_grove_enabled: Scalars['Boolean']['output'];
  is_mcp_enabled: Scalars['Boolean']['output'];
  is_policies_module_enabled: Scalars['Boolean']['output'];
  is_policy_acknowledgements_enabled: Scalars['Boolean']['output'];
  is_program_creation_enabled: Scalars['Boolean']['output'];
  is_risk_approval_workflows_enabled: Scalars['Boolean']['output'];
  is_risks_module_enabled: Scalars['Boolean']['output'];
  is_trust_portal_enabled: Scalars['Boolean']['output'];
  is_vendor_approval_workflows_enabled: Scalars['Boolean']['output'];
  is_vendor_questionnaire_ai_review_enabled: Scalars['Boolean']['output'];
  is_vendors_module_enabled: Scalars['Boolean']['output'];
  /** Temporary MCP client availability policy; changing it preserves existing consent and sessions. */
  mcp_client_policy: Scalars['jsonb']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  oauth_grants: Array<Oauth_Organization_Grants>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  /** An array relationship */
  organization_controls: Array<Controls>;
  /** An aggregate relationship */
  organization_controls_aggregate: Controls_Aggregate;
  /** An object relationship */
  organization_email_domain?: Maybe<Organization_Email_Domains>;
  /** An array relationship */
  organization_integrations: Array<Organization_Integrations>;
  /** An object relationship */
  organization_profile?: Maybe<Organization_Profiles>;
  /** An array relationship */
  organization_risk_levels: Array<Organization_Risk_Levels>;
  /** An array relationship */
  organization_template_frameworks: Array<Organization_Template_Frameworks>;
  /** An array relationship */
  organization_tenants: Array<Organization_Tenants>;
  /** An array relationship */
  organization_users: Array<Organization_Users>;
  /** An array relationship */
  organizations: Array<Organizations>;
  parent_organization_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  policies: Array<Policies>;
  /** An array relationship */
  programs: Array<Programs>;
  /** An array relationship */
  questionnaires: Array<Questionnaires>;
  /** An array relationship */
  reports: Array<Reports>;
  /** An array relationship */
  risk_categories: Array<Organization_Risk_Categories>;
  /** An array relationship */
  risk_impacts: Array<Risk_Impacts>;
  /** An array relationship */
  risk_likelihoods: Array<Risk_Likelihoods>;
  /** An array relationship */
  risk_tags: Array<Organization_Risk_Tags>;
  /** An array relationship */
  risks: Array<Risks>;
  /** An aggregate relationship */
  risks_aggregate: Risks_Aggregate;
  /** An array relationship */
  roles: Array<Roles>;
  /** An array relationship */
  tags: Array<Tags>;
  /** An array relationship */
  tasks: Array<Tasks>;
  /** An aggregate relationship */
  tasks_aggregate: Tasks_Aggregate;
  /** An array relationship */
  teams: Array<Teams>;
  /** An object relationship */
  trust_portal_domain?: Maybe<Trust_Portal_Domains>;
  /** An object relationship */
  trust_portal_page?: Maybe<Trust_Portal_Pages>;
  /** An array relationship */
  vendor_risk_levels: Array<Organization_Vendor_Risk_Levels>;
  /** An array relationship */
  vendor_tiers: Array<Organization_Vendor_Tiers>;
  /** An array relationship */
  vendors: Array<Vendors>;
  /** An aggregate relationship */
  vendors_aggregate: Vendors_Aggregate;
  workos_organization_id?: Maybe<Scalars['String']['output']>;
};

/** Table to manage organizations */
export type OrganizationsAgent_InstancesArgs = {
  distinct_on?: InputMaybe<Array<Agent_Instances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Instances_Order_By>>;
  where?: InputMaybe<Agent_Instances_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsClient_QuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Client_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Questionnaires_Order_By>>;
  where?: InputMaybe<Client_Questionnaires_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsControls_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Controls_History_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_History_Stats_Order_By>>;
  where?: InputMaybe<Controls_History_Stats_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsCriteriaArgs = {
  distinct_on?: InputMaybe<Array<Criteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Criteria_Order_By>>;
  where?: InputMaybe<Criteria_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsEvidence_TagsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Evidence_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Evidence_Tags_Order_By>>;
  where?: InputMaybe<Organization_Evidence_Tags_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsEvidencesArgs = {
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsEvidences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsField_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Field_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Configs_Order_By>>;
  where?: InputMaybe<Field_Configs_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsFrameworksArgs = {
  distinct_on?: InputMaybe<Array<Frameworks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Frameworks_Order_By>>;
  where?: InputMaybe<Frameworks_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsGroupsArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsMcp_Client_PolicyArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Table to manage organizations */
export type OrganizationsOauth_GrantsArgs = {
  distinct_on?: InputMaybe<Array<Oauth_Organization_Grants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oauth_Organization_Grants_Order_By>>;
  where?: InputMaybe<Oauth_Organization_Grants_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsOrganization_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsOrganization_Controls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsOrganization_IntegrationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Integrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Integrations_Order_By>>;
  where?: InputMaybe<Organization_Integrations_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsOrganization_Risk_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Risk_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Risk_Levels_Order_By>>;
  where?: InputMaybe<Organization_Risk_Levels_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsOrganization_Template_FrameworksArgs = {
  distinct_on?: InputMaybe<Array<Organization_Template_Frameworks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Template_Frameworks_Order_By>>;
  where?: InputMaybe<Organization_Template_Frameworks_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsOrganization_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Tenants_Order_By>>;
  where?: InputMaybe<Organization_Tenants_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsOrganization_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Users_Order_By>>;
  where?: InputMaybe<Organization_Users_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsPoliciesArgs = {
  distinct_on?: InputMaybe<Array<Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policies_Order_By>>;
  where?: InputMaybe<Policies_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsProgramsArgs = {
  distinct_on?: InputMaybe<Array<Programs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programs_Order_By>>;
  where?: InputMaybe<Programs_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsQuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaires_Order_By>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsRisk_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Risk_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Risk_Categories_Order_By>>;
  where?: InputMaybe<Organization_Risk_Categories_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsRisk_ImpactsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Impacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Impacts_Order_By>>;
  where?: InputMaybe<Risk_Impacts_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsRisk_LikelihoodsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Likelihoods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Likelihoods_Order_By>>;
  where?: InputMaybe<Risk_Likelihoods_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsRisk_TagsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Risk_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Risk_Tags_Order_By>>;
  where?: InputMaybe<Organization_Risk_Tags_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsRisksArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsRisks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsVendor_Risk_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Vendor_Risk_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Vendor_Risk_Levels_Order_By>>;
  where?: InputMaybe<Organization_Vendor_Risk_Levels_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsVendor_TiersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Vendor_Tiers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Vendor_Tiers_Order_By>>;
  where?: InputMaybe<Organization_Vendor_Tiers_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsVendorsArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

/** Table to manage organizations */
export type OrganizationsVendors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

/** order by aggregate values of table "organizations" */
export type Organizations_Aggregate_Order_By = {
  avg?: InputMaybe<Organizations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organizations_Max_Order_By>;
  min?: InputMaybe<Organizations_Min_Order_By>;
  stddev?: InputMaybe<Organizations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organizations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organizations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organizations_Sum_Order_By>;
  var_pop?: InputMaybe<Organizations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organizations_Var_Samp_Order_By>;
  variance?: InputMaybe<Organizations_Variance_Order_By>;
};

/** order by avg() on columns of table "organizations" */
export type Organizations_Avg_Order_By = {
  /** Minutes of in-app inactivity after which a user is automatically logged out. NULL disables the timeout. Valid range is 1 to 35791 minutes. When a user belongs to multiple organizations, the shortest configured value applies. */
  inactivity_timeout_minutes?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type Organizations_Bool_Exp = {
  _and?: InputMaybe<Array<Organizations_Bool_Exp>>;
  _not?: InputMaybe<Organizations_Bool_Exp>;
  _or?: InputMaybe<Array<Organizations_Bool_Exp>>;
  agent_instances?: InputMaybe<Agent_Instances_Bool_Exp>;
  categories?: InputMaybe<Categories_Bool_Exp>;
  client_questionnaires?: InputMaybe<Client_Questionnaires_Bool_Exp>;
  controls_histories?: InputMaybe<Controls_History_Stats_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  criteria?: InputMaybe<Criteria_Bool_Exp>;
  default_user_role_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  documents?: InputMaybe<Documents_Bool_Exp>;
  evidence_tags?: InputMaybe<Organization_Evidence_Tags_Bool_Exp>;
  evidences?: InputMaybe<Evidences_Bool_Exp>;
  evidences_aggregate?: InputMaybe<Evidences_Aggregate_Bool_Exp>;
  field_configs?: InputMaybe<Field_Configs_Bool_Exp>;
  frameworks?: InputMaybe<Frameworks_Bool_Exp>;
  groups?: InputMaybe<Groups_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inactivity_timeout_minutes?: InputMaybe<Int_Comparison_Exp>;
  invitations?: InputMaybe<Invitations_Bool_Exp>;
  is_agent_trace_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_api_module_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_audit_trail_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_client_questionnaires_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_control_ai_review_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_controls_module_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_day_zero_ai_features_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_grove_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_mcp_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_policies_module_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_policy_acknowledgements_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_program_creation_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_risk_approval_workflows_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_risks_module_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_trust_portal_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_vendor_approval_workflows_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_vendor_questionnaire_ai_review_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_vendors_module_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  mcp_client_policy?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  oauth_grants?: InputMaybe<Oauth_Organization_Grants_Bool_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_controls?: InputMaybe<Controls_Bool_Exp>;
  organization_controls_aggregate?: InputMaybe<Controls_Aggregate_Bool_Exp>;
  organization_email_domain?: InputMaybe<Organization_Email_Domains_Bool_Exp>;
  organization_integrations?: InputMaybe<Organization_Integrations_Bool_Exp>;
  organization_profile?: InputMaybe<Organization_Profiles_Bool_Exp>;
  organization_risk_levels?: InputMaybe<Organization_Risk_Levels_Bool_Exp>;
  organization_template_frameworks?: InputMaybe<Organization_Template_Frameworks_Bool_Exp>;
  organization_tenants?: InputMaybe<Organization_Tenants_Bool_Exp>;
  organization_users?: InputMaybe<Organization_Users_Bool_Exp>;
  organizations?: InputMaybe<Organizations_Bool_Exp>;
  parent_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  policies?: InputMaybe<Policies_Bool_Exp>;
  programs?: InputMaybe<Programs_Bool_Exp>;
  questionnaires?: InputMaybe<Questionnaires_Bool_Exp>;
  reports?: InputMaybe<Reports_Bool_Exp>;
  risk_categories?: InputMaybe<Organization_Risk_Categories_Bool_Exp>;
  risk_impacts?: InputMaybe<Risk_Impacts_Bool_Exp>;
  risk_likelihoods?: InputMaybe<Risk_Likelihoods_Bool_Exp>;
  risk_tags?: InputMaybe<Organization_Risk_Tags_Bool_Exp>;
  risks?: InputMaybe<Risks_Bool_Exp>;
  risks_aggregate?: InputMaybe<Risks_Aggregate_Bool_Exp>;
  roles?: InputMaybe<Roles_Bool_Exp>;
  tags?: InputMaybe<Tags_Bool_Exp>;
  tasks?: InputMaybe<Tasks_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Tasks_Aggregate_Bool_Exp>;
  teams?: InputMaybe<Teams_Bool_Exp>;
  trust_portal_domain?: InputMaybe<Trust_Portal_Domains_Bool_Exp>;
  trust_portal_page?: InputMaybe<Trust_Portal_Pages_Bool_Exp>;
  vendor_risk_levels?: InputMaybe<Organization_Vendor_Risk_Levels_Bool_Exp>;
  vendor_tiers?: InputMaybe<Organization_Vendor_Tiers_Bool_Exp>;
  vendors?: InputMaybe<Vendors_Bool_Exp>;
  vendors_aggregate?: InputMaybe<Vendors_Aggregate_Bool_Exp>;
  workos_organization_id?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "organizations" */
export type Organizations_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_user_role_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Minutes of in-app inactivity after which a user is automatically logged out. NULL disables the timeout. Valid range is 1 to 35791 minutes. When a user belongs to multiple organizations, the shortest configured value applies. */
  inactivity_timeout_minutes?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_organization_id?: InputMaybe<Order_By>;
  workos_organization_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organizations" */
export type Organizations_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_user_role_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Minutes of in-app inactivity after which a user is automatically logged out. NULL disables the timeout. Valid range is 1 to 35791 minutes. When a user belongs to multiple organizations, the shortest configured value applies. */
  inactivity_timeout_minutes?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_organization_id?: InputMaybe<Order_By>;
  workos_organization_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organizations" */
export type Organizations_Mutation_Response = {
  __typename?: 'organizations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organizations>;
};

/** Ordering options when selecting data from "organizations". */
export type Organizations_Order_By = {
  agent_instances_aggregate?: InputMaybe<Agent_Instances_Aggregate_Order_By>;
  categories_aggregate?: InputMaybe<Categories_Aggregate_Order_By>;
  client_questionnaires_aggregate?: InputMaybe<Client_Questionnaires_Aggregate_Order_By>;
  controls_histories_aggregate?: InputMaybe<Controls_History_Stats_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  criteria_aggregate?: InputMaybe<Criteria_Aggregate_Order_By>;
  default_user_role_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Documents_Aggregate_Order_By>;
  evidence_tags_aggregate?: InputMaybe<Organization_Evidence_Tags_Aggregate_Order_By>;
  evidences_aggregate?: InputMaybe<Evidences_Aggregate_Order_By>;
  field_configs_aggregate?: InputMaybe<Field_Configs_Aggregate_Order_By>;
  frameworks_aggregate?: InputMaybe<Frameworks_Aggregate_Order_By>;
  groups_aggregate?: InputMaybe<Groups_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  inactivity_timeout_minutes?: InputMaybe<Order_By>;
  invitations_aggregate?: InputMaybe<Invitations_Aggregate_Order_By>;
  is_agent_trace_enabled?: InputMaybe<Order_By>;
  is_api_module_enabled?: InputMaybe<Order_By>;
  is_audit_trail_enabled?: InputMaybe<Order_By>;
  is_client_questionnaires_enabled?: InputMaybe<Order_By>;
  is_control_ai_review_enabled?: InputMaybe<Order_By>;
  is_controls_module_enabled?: InputMaybe<Order_By>;
  is_day_zero_ai_features_enabled?: InputMaybe<Order_By>;
  is_grove_enabled?: InputMaybe<Order_By>;
  is_mcp_enabled?: InputMaybe<Order_By>;
  is_policies_module_enabled?: InputMaybe<Order_By>;
  is_policy_acknowledgements_enabled?: InputMaybe<Order_By>;
  is_program_creation_enabled?: InputMaybe<Order_By>;
  is_risk_approval_workflows_enabled?: InputMaybe<Order_By>;
  is_risks_module_enabled?: InputMaybe<Order_By>;
  is_trust_portal_enabled?: InputMaybe<Order_By>;
  is_vendor_approval_workflows_enabled?: InputMaybe<Order_By>;
  is_vendor_questionnaire_ai_review_enabled?: InputMaybe<Order_By>;
  is_vendors_module_enabled?: InputMaybe<Order_By>;
  mcp_client_policy?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oauth_grants_aggregate?: InputMaybe<Oauth_Organization_Grants_Aggregate_Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_controls_aggregate?: InputMaybe<Controls_Aggregate_Order_By>;
  organization_email_domain?: InputMaybe<Organization_Email_Domains_Order_By>;
  organization_integrations_aggregate?: InputMaybe<Organization_Integrations_Aggregate_Order_By>;
  organization_profile?: InputMaybe<Organization_Profiles_Order_By>;
  organization_risk_levels_aggregate?: InputMaybe<Organization_Risk_Levels_Aggregate_Order_By>;
  organization_template_frameworks_aggregate?: InputMaybe<Organization_Template_Frameworks_Aggregate_Order_By>;
  organization_tenants_aggregate?: InputMaybe<Organization_Tenants_Aggregate_Order_By>;
  organization_users_aggregate?: InputMaybe<Organization_Users_Aggregate_Order_By>;
  organizations_aggregate?: InputMaybe<Organizations_Aggregate_Order_By>;
  parent_organization_id?: InputMaybe<Order_By>;
  policies_aggregate?: InputMaybe<Policies_Aggregate_Order_By>;
  programs_aggregate?: InputMaybe<Programs_Aggregate_Order_By>;
  questionnaires_aggregate?: InputMaybe<Questionnaires_Aggregate_Order_By>;
  reports_aggregate?: InputMaybe<Reports_Aggregate_Order_By>;
  risk_categories_aggregate?: InputMaybe<Organization_Risk_Categories_Aggregate_Order_By>;
  risk_impacts_aggregate?: InputMaybe<Risk_Impacts_Aggregate_Order_By>;
  risk_likelihoods_aggregate?: InputMaybe<Risk_Likelihoods_Aggregate_Order_By>;
  risk_tags_aggregate?: InputMaybe<Organization_Risk_Tags_Aggregate_Order_By>;
  risks_aggregate?: InputMaybe<Risks_Aggregate_Order_By>;
  roles_aggregate?: InputMaybe<Roles_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Tags_Aggregate_Order_By>;
  tasks_aggregate?: InputMaybe<Tasks_Aggregate_Order_By>;
  teams_aggregate?: InputMaybe<Teams_Aggregate_Order_By>;
  trust_portal_domain?: InputMaybe<Trust_Portal_Domains_Order_By>;
  trust_portal_page?: InputMaybe<Trust_Portal_Pages_Order_By>;
  vendor_risk_levels_aggregate?: InputMaybe<Organization_Vendor_Risk_Levels_Aggregate_Order_By>;
  vendor_tiers_aggregate?: InputMaybe<Organization_Vendor_Tiers_Aggregate_Order_By>;
  vendors_aggregate?: InputMaybe<Vendors_Aggregate_Order_By>;
  workos_organization_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organizations */
export type Organizations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organizations" */
export enum Organizations_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultUserRoleId = 'default_user_role_id',
  /** column name */
  Description = 'description',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Id = 'id',
  /** column name */
  InactivityTimeoutMinutes = 'inactivity_timeout_minutes',
  /** column name */
  IsAgentTraceEnabled = 'is_agent_trace_enabled',
  /** column name */
  IsApiModuleEnabled = 'is_api_module_enabled',
  /** column name */
  IsAuditTrailEnabled = 'is_audit_trail_enabled',
  /** column name */
  IsClientQuestionnairesEnabled = 'is_client_questionnaires_enabled',
  /** column name */
  IsControlAiReviewEnabled = 'is_control_ai_review_enabled',
  /** column name */
  IsControlsModuleEnabled = 'is_controls_module_enabled',
  /** column name */
  IsDayZeroAiFeaturesEnabled = 'is_day_zero_ai_features_enabled',
  /** column name */
  IsGroveEnabled = 'is_grove_enabled',
  /** column name */
  IsMcpEnabled = 'is_mcp_enabled',
  /** column name */
  IsPoliciesModuleEnabled = 'is_policies_module_enabled',
  /** column name */
  IsPolicyAcknowledgementsEnabled = 'is_policy_acknowledgements_enabled',
  /** column name */
  IsProgramCreationEnabled = 'is_program_creation_enabled',
  /** column name */
  IsRiskApprovalWorkflowsEnabled = 'is_risk_approval_workflows_enabled',
  /** column name */
  IsRisksModuleEnabled = 'is_risks_module_enabled',
  /** column name */
  IsTrustPortalEnabled = 'is_trust_portal_enabled',
  /** column name */
  IsVendorApprovalWorkflowsEnabled = 'is_vendor_approval_workflows_enabled',
  /** column name */
  IsVendorQuestionnaireAiReviewEnabled = 'is_vendor_questionnaire_ai_review_enabled',
  /** column name */
  IsVendorsModuleEnabled = 'is_vendors_module_enabled',
  /** column name */
  McpClientPolicy = 'mcp_client_policy',
  /** column name */
  Name = 'name',
  /** column name */
  ParentOrganizationId = 'parent_organization_id',
  /** column name */
  WorkosOrganizationId = 'workos_organization_id',
}

/** input type for updating data in table "organizations" */
export type Organizations_Set_Input = {
  is_mcp_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by stddev() on columns of table "organizations" */
export type Organizations_Stddev_Order_By = {
  /** Minutes of in-app inactivity after which a user is automatically logged out. NULL disables the timeout. Valid range is 1 to 35791 minutes. When a user belongs to multiple organizations, the shortest configured value applies. */
  inactivity_timeout_minutes?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "organizations" */
export type Organizations_Stddev_Pop_Order_By = {
  /** Minutes of in-app inactivity after which a user is automatically logged out. NULL disables the timeout. Valid range is 1 to 35791 minutes. When a user belongs to multiple organizations, the shortest configured value applies. */
  inactivity_timeout_minutes?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "organizations" */
export type Organizations_Stddev_Samp_Order_By = {
  /** Minutes of in-app inactivity after which a user is automatically logged out. NULL disables the timeout. Valid range is 1 to 35791 minutes. When a user belongs to multiple organizations, the shortest configured value applies. */
  inactivity_timeout_minutes?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organizations" */
export type Organizations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organizations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organizations_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  default_user_role_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Minutes of in-app inactivity after which a user is automatically logged out. NULL disables the timeout. Valid range is 1 to 35791 minutes. When a user belongs to multiple organizations, the shortest configured value applies. */
  inactivity_timeout_minutes?: InputMaybe<Scalars['Int']['input']>;
  is_agent_trace_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_api_module_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_audit_trail_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_client_questionnaires_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_control_ai_review_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_controls_module_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_day_zero_ai_features_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_grove_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_mcp_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_policies_module_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_policy_acknowledgements_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_program_creation_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_risk_approval_workflows_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_risks_module_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_trust_portal_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_vendor_approval_workflows_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_vendor_questionnaire_ai_review_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_vendors_module_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Temporary MCP client availability policy; changing it preserves existing consent and sessions. */
  mcp_client_policy?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  workos_organization_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "organizations" */
export type Organizations_Sum_Order_By = {
  /** Minutes of in-app inactivity after which a user is automatically logged out. NULL disables the timeout. Valid range is 1 to 35791 minutes. When a user belongs to multiple organizations, the shortest configured value applies. */
  inactivity_timeout_minutes?: InputMaybe<Order_By>;
};

export type Organizations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organizations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organizations_Bool_Exp;
};

/** order by var_pop() on columns of table "organizations" */
export type Organizations_Var_Pop_Order_By = {
  /** Minutes of in-app inactivity after which a user is automatically logged out. NULL disables the timeout. Valid range is 1 to 35791 minutes. When a user belongs to multiple organizations, the shortest configured value applies. */
  inactivity_timeout_minutes?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "organizations" */
export type Organizations_Var_Samp_Order_By = {
  /** Minutes of in-app inactivity after which a user is automatically logged out. NULL disables the timeout. Valid range is 1 to 35791 minutes. When a user belongs to multiple organizations, the shortest configured value applies. */
  inactivity_timeout_minutes?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "organizations" */
export type Organizations_Variance_Order_By = {
  /** Minutes of in-app inactivity after which a user is automatically logged out. NULL disables the timeout. Valid range is 1 to 35791 minutes. When a user belongs to multiple organizations, the shortest configured value applies. */
  inactivity_timeout_minutes?: InputMaybe<Order_By>;
};

export enum Permissions_Enum {
  /** Can acknowledge policies */
  AcknowledgePolicies = 'acknowledge_policies',
  /** ability to create or delete controls */
  CreateControls = 'create_controls',
  /** Create evidence */
  CreateEvidence = 'create_evidence',
  /** Create findings */
  CreateFindings = 'create_findings',
  /** ability to create programs */
  CreatePrograms = 'create_programs',
  /** Create risks */
  CreateRisks = 'create_risks',
  /** Create tasks */
  CreateTasks = 'create_tasks',
  /** Create vendors */
  CreateVendors = 'create_vendors',
  /** ability to delete programs */
  DeletePrograms = 'delete_programs',
  /** ability to grant access to trust portal users for restricted documents */
  GrantAccessForTpRestrictedDocuments = 'grant_access_for_tp_restricted_documents',
  /** ability to link evidence to controls */
  LinkControlsEvidence = 'link_controls_evidence',
  /** ability to link controls to programs */
  LinkControlsPrograms = 'link_controls_programs',
  /** ability to link controls to risks */
  LinkControlsRisks = 'link_controls_risks',
  /** Add and remove action-based entity relations */
  LinkEntityRelations = 'link_entity_relations',
  /** ability to link risks to vendors */
  LinkRisksVendors = 'link_risks_vendors',
  /** Create, list, revoke, and rotate API keys and service accounts */
  ManageApiKeys = 'manage_api_keys',
  /** ability to manage organization documents */
  ManageDocuments = 'manage_documents',
  /** ability to manage risk classification */
  ManageRiskClassification = 'manage_risk_classification',
  /** notified when control is at risk or moves to invalid */
  NotifyOnControlAtRisk = 'notify_on_control_at_risk',
  /** ability to get notified when policy version is expiring */
  NotifyOnPolicyExpiring = 'notify_on_policy_expiring',
  /** ability to get notified when questionnaire is overdue */
  NotifyOnQuestionnaireOverdue = 'notify_on_questionnaire_overdue',
  /** ability to get notified when risk is expiring */
  NotifyOnRiskExpiring = 'notify_on_risk_expiring',
  /** ability to get notified when vendor is expiring */
  NotifyOnVendorExpiring = 'notify_on_vendor_expiring',
  /** delete ownership constraint for controls */
  OwnDeleteControls = 'own_delete_controls',
  /** delete ownership constraint for evidences */
  OwnDeleteEvidence = 'own_delete_evidence',
  /** Remove owned manual findings */
  OwnDeleteFindings = 'own_delete_findings',
  /** delete ownership constraint for policies */
  OwnDeletePolicies = 'own_delete_policies',
  /** delete ownership constraint for risks */
  OwnDeleteRisks = 'own_delete_risks',
  /** delete ownership constraint for tasks */
  OwnDeleteTasks = 'own_delete_tasks',
  /** delete ownership constraint for vendors */
  OwnDeleteVendors = 'own_delete_vendors',
  /** edit ownership constraint for controls */
  OwnEditControls = 'own_edit_controls',
  /** edit ownership constraint for evidences */
  OwnEditEvidence = 'own_edit_evidence',
  /** Edit owned findings */
  OwnEditFindings = 'own_edit_findings',
  /** edit ownership constraint for policies */
  OwnEditPolicies = 'own_edit_policies',
  /** edit ownership constraint for risks */
  OwnEditRisks = 'own_edit_risks',
  /** edit ownership constraint for tasks */
  OwnEditTasks = 'own_edit_tasks',
  /** edit ownership constraint for vendors */
  OwnEditVendors = 'own_edit_vendors',
  /** ownership constraint for controls */
  OwnReadControls = 'own_read_controls',
  /** view ownership constraint for evidences */
  OwnReadEvidence = 'own_read_evidence',
  /** View owned findings */
  OwnReadFindings = 'own_read_findings',
  /** view ownership constraint for policies */
  OwnReadPolicies = 'own_read_policies',
  /** view ownership constraint for risks */
  OwnReadRisks = 'own_read_risks',
  /** ownership constraint for tasks */
  OwnReadTasks = 'own_read_tasks',
  /** view ownership constraint for vendors */
  OwnReadVendors = 'own_read_vendors',
  /** ability to view approved policies */
  ReadApprovedPolicies = 'read_approved_policies',
  /** ability to read assigned programs */
  ReadAssignedPrograms = 'read_assigned_programs',
  /** View client questionnaires */
  ReadClientQ = 'read_client_q',
  /** ability to read confidential evidence */
  ReadConfidentialEvidence = 'read_confidential_evidence',
  /** ability to read evidence linked to readable controls */
  ReadControlLinkedEvidence = 'read_control_linked_evidence',
  /** ability to read controls */
  ReadControls = 'read_controls',
  /** ability to read evidence */
  ReadEvidence = 'read_evidence',
  /** View all findings */
  ReadFindings = 'read_findings',
  /** Use MCP with read access within existing permissions */
  ReadMcp = 'read_mcp',
  /** ability to view policy */
  ReadPolicies = 'read_policies',
  /** ability to read all programs */
  ReadPrograms = 'read_programs',
  /** ability to read reports */
  ReadReports = 'read_reports',
  /** ability to read risks */
  ReadRisks = 'read_risks',
  /** ability to view tasks */
  ReadTasks = 'read_tasks',
  /** ability to view trust portal */
  ReadTrustPortal = 'read_trust_portal',
  /** ability to read vendors */
  ReadVendors = 'read_vendors',
  /** ability to update controls */
  UpdateControls = 'update_controls',
  /** Edit all general evidence */
  UpdateEvidence = 'update_evidence',
  /** Edit all findings */
  UpdateFindings = 'update_findings',
  /** ability to update programs */
  UpdatePrograms = 'update_programs',
  /** Edit all risks */
  UpdateRisks = 'update_risks',
  /** Edit all tasks */
  UpdateTasks = 'update_tasks',
  /** Edit all vendors and questionnaires */
  UpdateVendors = 'update_vendors',
  /** Configure per-organization Grove agent behavior (e.g. TPRM intake rules, custom prompt instructions) */
  WriteAgentSettings = 'write_agent_settings',
  /** Create and edit client questionnaires */
  WriteClientQ = 'write_client_q',
  /** ability to modify confidential evidence */
  WriteConfidentialEvidence = 'write_confidential_evidence',
  /** Create and edit custom fields for controls */
  WriteControlFieldConfigs = 'write_control_field_configs',
  /** Configure per-org email sending domain and sender address */
  WriteEmailSenderSettings = 'write_email_sender_settings',
  /** Create and edit custom fields for evidences */
  WriteEvidenceFieldConfigs = 'write_evidence_field_configs',
  /** Create and edit evidence integrations */
  WriteEvidenceIntegrations = 'write_evidence_integrations',
  /** Manage finding field definitions */
  WriteFindingFieldConfigs = 'write_finding_field_configs',
  /** Create and edit organization integration connectors */
  WriteIntegrationConnectors = 'write_integration_connectors',
  /** Use MCP with write access within existing permissions */
  WriteMcp = 'write_mcp',
  /** Manage organization profile settings */
  WriteOrganizationProfile = 'write_organization_profile',
  /** ability to modify policy */
  WritePolicies = 'write_policies',
  /** Create and edit custom fields for policies */
  WritePolicyFieldConfigs = 'write_policy_field_configs',
  /** ability to modify reports */
  WriteReports = 'write_reports',
  /** ability to modify risk custom field configs */
  WriteRiskFieldConfigs = 'write_risk_field_configs',
  /** ability to modify roles */
  WriteRoles = 'write_roles',
  /** Create and edit custom fields for tasks */
  WriteTaskFieldConfigs = 'write_task_field_configs',
  /** ability to manage teams */
  WriteTeams = 'write_teams',
  /** ability to create and edit trust portal sections */
  WriteTrustPortalSections = 'write_trust_portal_sections',
  /** ability to create and edit trust portal settings */
  WriteTrustPortalSettings = 'write_trust_portal_settings',
  /** ability to modify vendor custom field configs */
  WriteVendorFieldConfigs = 'write_vendor_field_configs',
}

/** Boolean expression to compare columns of type "permissions_enum". All fields are combined with logical 'AND'. */
export type Permissions_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Permissions_Enum>;
  _in?: InputMaybe<Array<Permissions_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Permissions_Enum>;
  _nin?: InputMaybe<Array<Permissions_Enum>>;
};

/** policies module */
export type Policies = {
  __typename?: 'policies';
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  evidence_policies: Array<Evidence_Policies>;
  /** An array relationship */
  field_values: Array<Field_Values>;
  frequency: Frequencies_Enum;
  id: Scalars['uuid']['output'];
  internal_id?: Maybe<Scalars['String']['output']>;
  /** Validity start of the latest approved policy version */
  last_approved_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Date the active policy version becomes overdue for re-approval, based on the policy frequency */
  next_approval_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  policies_comments: Array<Comments>;
  /** An array relationship */
  policies_policy_tasks: Array<Policy_Tasks>;
  /** An array relationship */
  policies_vector_stores: Array<Ai_Policies_Vector_Store>;
  /** An array relationship */
  policy_approvers: Array<Policy_Approvers>;
  /** An array relationship */
  policy_integrations: Array<Policy_Integrations>;
  /** An array relationship */
  policy_owners: Array<Policy_Owners>;
  /** An array relationship */
  policy_versions: Array<Policy_Versions>;
  similarity?: Maybe<Scalars['float8']['output']>;
  /** An array relationship */
  source_entity_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  source_entity_relations_aggregate: Entity_Relations_Aggregate;
  status: Policy_Statuses_Enum;
  /** An array relationship */
  target_entity_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  target_entity_relations_aggregate: Entity_Relations_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** policies module */
export type PoliciesEvidence_PoliciesArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Policies_Order_By>>;
  where?: InputMaybe<Evidence_Policies_Bool_Exp>;
};

/** policies module */
export type PoliciesField_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Values_Order_By>>;
  where?: InputMaybe<Field_Values_Bool_Exp>;
};

/** policies module */
export type PoliciesNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** policies module */
export type PoliciesPolicies_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** policies module */
export type PoliciesPolicies_Policy_TasksArgs = {
  distinct_on?: InputMaybe<Array<Policy_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Tasks_Order_By>>;
  where?: InputMaybe<Policy_Tasks_Bool_Exp>;
};

/** policies module */
export type PoliciesPolicies_Vector_StoresArgs = {
  distinct_on?: InputMaybe<Array<Ai_Policies_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Policies_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Policies_Vector_Store_Bool_Exp>;
};

/** policies module */
export type PoliciesPolicy_ApproversArgs = {
  distinct_on?: InputMaybe<Array<Policy_Approvers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Approvers_Order_By>>;
  where?: InputMaybe<Policy_Approvers_Bool_Exp>;
};

/** policies module */
export type PoliciesPolicy_IntegrationsArgs = {
  distinct_on?: InputMaybe<Array<Policy_Integrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Integrations_Order_By>>;
  where?: InputMaybe<Policy_Integrations_Bool_Exp>;
};

/** policies module */
export type PoliciesPolicy_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Policy_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Owners_Order_By>>;
  where?: InputMaybe<Policy_Owners_Bool_Exp>;
};

/** policies module */
export type PoliciesPolicy_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Policy_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Versions_Order_By>>;
  where?: InputMaybe<Policy_Versions_Bool_Exp>;
};

/** policies module */
export type PoliciesSource_Entity_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** policies module */
export type PoliciesSource_Entity_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** policies module */
export type PoliciesTarget_Entity_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** policies module */
export type PoliciesTarget_Entity_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** order by aggregate values of table "policies" */
export type Policies_Aggregate_Order_By = {
  avg?: InputMaybe<Policies_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policies_Max_Order_By>;
  min?: InputMaybe<Policies_Min_Order_By>;
  stddev?: InputMaybe<Policies_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Policies_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Policies_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Policies_Sum_Order_By>;
  var_pop?: InputMaybe<Policies_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Policies_Var_Samp_Order_By>;
  variance?: InputMaybe<Policies_Variance_Order_By>;
};

/** order by avg() on columns of table "policies" */
export type Policies_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "policies". All fields are combined with a logical 'AND'. */
export type Policies_Bool_Exp = {
  _and?: InputMaybe<Array<Policies_Bool_Exp>>;
  _not?: InputMaybe<Policies_Bool_Exp>;
  _or?: InputMaybe<Array<Policies_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  evidence_policies?: InputMaybe<Evidence_Policies_Bool_Exp>;
  field_values?: InputMaybe<Field_Values_Bool_Exp>;
  frequency?: InputMaybe<Frequencies_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_id?: InputMaybe<String_Comparison_Exp>;
  last_approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  next_approval_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  policies_comments?: InputMaybe<Comments_Bool_Exp>;
  policies_policy_tasks?: InputMaybe<Policy_Tasks_Bool_Exp>;
  policies_vector_stores?: InputMaybe<Ai_Policies_Vector_Store_Bool_Exp>;
  policy_approvers?: InputMaybe<Policy_Approvers_Bool_Exp>;
  policy_integrations?: InputMaybe<Policy_Integrations_Bool_Exp>;
  policy_owners?: InputMaybe<Policy_Owners_Bool_Exp>;
  policy_versions?: InputMaybe<Policy_Versions_Bool_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  source_entity_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  source_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  status?: InputMaybe<Policy_Statuses_Enum_Comparison_Exp>;
  target_entity_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  target_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "policies" */
export enum Policies_Constraint {
  /** unique or primary key constraint on columns "organization_id", "internal_id" */
  PoliciesOrganizationIdInternalIdKey = 'policies_organization_id_internal_id_key',
  /** unique or primary key constraint on columns "id" */
  PoliciesPkey = 'policies_pkey',
}

/** input type for inserting data into table "policies" */
export type Policies_Insert_Input = {
  evidence_policies?: InputMaybe<Evidence_Policies_Arr_Rel_Insert_Input>;
  field_values?: InputMaybe<Field_Values_Arr_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  policies_comments?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  policies_policy_tasks?: InputMaybe<Policy_Tasks_Arr_Rel_Insert_Input>;
  policy_approvers?: InputMaybe<Policy_Approvers_Arr_Rel_Insert_Input>;
  policy_integrations?: InputMaybe<Policy_Integrations_Arr_Rel_Insert_Input>;
  policy_owners?: InputMaybe<Policy_Owners_Arr_Rel_Insert_Input>;
  policy_versions?: InputMaybe<Policy_Versions_Arr_Rel_Insert_Input>;
  source_entity_relations?: InputMaybe<Entity_Relations_Arr_Rel_Insert_Input>;
  target_entity_relations?: InputMaybe<Entity_Relations_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "policies" */
export type Policies_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  /** Validity start of the latest approved policy version */
  last_approved_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Date the active policy version becomes overdue for re-approval, based on the policy frequency */
  next_approval_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "policies" */
export type Policies_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  /** Validity start of the latest approved policy version */
  last_approved_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Date the active policy version becomes overdue for re-approval, based on the policy frequency */
  next_approval_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "policies" */
export type Policies_Mutation_Response = {
  __typename?: 'policies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Policies>;
};

/** input type for inserting object relation for remote table "policies" */
export type Policies_Obj_Rel_Insert_Input = {
  data: Policies_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Policies_On_Conflict>;
};

/** on_conflict condition type for table "policies" */
export type Policies_On_Conflict = {
  constraint: Policies_Constraint;
  update_columns?: Array<Policies_Update_Column>;
  where?: InputMaybe<Policies_Bool_Exp>;
};

/** Ordering options when selecting data from "policies". */
export type Policies_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  evidence_policies_aggregate?: InputMaybe<Evidence_Policies_Aggregate_Order_By>;
  field_values_aggregate?: InputMaybe<Field_Values_Aggregate_Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_approved_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  next_approval_at?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  policies_comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  policies_policy_tasks_aggregate?: InputMaybe<Policy_Tasks_Aggregate_Order_By>;
  policies_vector_stores_aggregate?: InputMaybe<Ai_Policies_Vector_Store_Aggregate_Order_By>;
  policy_approvers_aggregate?: InputMaybe<Policy_Approvers_Aggregate_Order_By>;
  policy_integrations_aggregate?: InputMaybe<Policy_Integrations_Aggregate_Order_By>;
  policy_owners_aggregate?: InputMaybe<Policy_Owners_Aggregate_Order_By>;
  policy_versions_aggregate?: InputMaybe<Policy_Versions_Aggregate_Order_By>;
  similarity?: InputMaybe<Order_By>;
  source_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  target_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: policies */
export type Policies_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "policies" */
export enum Policies_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  LastApprovedAt = 'last_approved_at',
  /** column name */
  Name = 'name',
  /** column name */
  NextApprovalAt = 'next_approval_at',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "policies" */
export type Policies_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Frequencies_Enum>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "policies" */
export type Policies_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "policies" */
export type Policies_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "policies" */
export type Policies_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "policies" */
export type Policies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Policies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Policies_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Frequencies_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_id?: InputMaybe<Scalars['String']['input']>;
  /** Validity start of the latest approved policy version */
  last_approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Date the active policy version becomes overdue for re-approval, based on the policy frequency */
  next_approval_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  similarity?: InputMaybe<Scalars['float8']['input']>;
  status?: InputMaybe<Policy_Statuses_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "policies" */
export type Policies_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** update columns of table "policies" */
export enum Policies_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Name = 'name',
}

export type Policies_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Policies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Policies_Bool_Exp;
};

/** order by var_pop() on columns of table "policies" */
export type Policies_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "policies" */
export type Policies_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "policies" */
export type Policies_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

export enum Policy_Acknowledgement_Statuses_Enum {
  Acknowledged = 'Acknowledged',
  Expiring = 'Expiring',
  Overdue = 'Overdue',
  Pending = 'Pending',
  Retired = 'Retired',
}

/** Boolean expression to compare columns of type "policy_acknowledgement_statuses_enum". All fields are combined with logical 'AND'. */
export type Policy_Acknowledgement_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Policy_Acknowledgement_Statuses_Enum>;
  _in?: InputMaybe<Array<Policy_Acknowledgement_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Policy_Acknowledgement_Statuses_Enum>;
  _nin?: InputMaybe<Array<Policy_Acknowledgement_Statuses_Enum>>;
};

/** columns and relationships of "policy_acknowledgement_users" */
export type Policy_Acknowledgement_Users = {
  __typename?: 'policy_acknowledgement_users';
  acknowledged_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  policy_acknowledgement: Policy_Acknowledgements;
  policy_acknowledgement_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "policy_acknowledgement_users" */
export type Policy_Acknowledgement_Users_Aggregate = {
  __typename?: 'policy_acknowledgement_users_aggregate';
  aggregate?: Maybe<Policy_Acknowledgement_Users_Aggregate_Fields>;
  nodes: Array<Policy_Acknowledgement_Users>;
};

export type Policy_Acknowledgement_Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Policy_Acknowledgement_Users_Aggregate_Bool_Exp_Count>;
};

export type Policy_Acknowledgement_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Policy_Acknowledgement_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Policy_Acknowledgement_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "policy_acknowledgement_users" */
export type Policy_Acknowledgement_Users_Aggregate_Fields = {
  __typename?: 'policy_acknowledgement_users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Policy_Acknowledgement_Users_Max_Fields>;
  min?: Maybe<Policy_Acknowledgement_Users_Min_Fields>;
};

/** aggregate fields of "policy_acknowledgement_users" */
export type Policy_Acknowledgement_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Policy_Acknowledgement_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "policy_acknowledgement_users" */
export type Policy_Acknowledgement_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policy_Acknowledgement_Users_Max_Order_By>;
  min?: InputMaybe<Policy_Acknowledgement_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "policy_acknowledgement_users". All fields are combined with a logical 'AND'. */
export type Policy_Acknowledgement_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Acknowledgement_Users_Bool_Exp>>;
  _not?: InputMaybe<Policy_Acknowledgement_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Acknowledgement_Users_Bool_Exp>>;
  acknowledged_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_nudged_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  policy_acknowledgement?: InputMaybe<Policy_Acknowledgements_Bool_Exp>;
  policy_acknowledgement_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Policy_Acknowledgement_Users_Max_Fields = {
  __typename?: 'policy_acknowledgement_users_max_fields';
  acknowledged_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  policy_acknowledgement_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "policy_acknowledgement_users" */
export type Policy_Acknowledgement_Users_Max_Order_By = {
  acknowledged_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  policy_acknowledgement_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Policy_Acknowledgement_Users_Min_Fields = {
  __typename?: 'policy_acknowledgement_users_min_fields';
  acknowledged_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  policy_acknowledgement_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "policy_acknowledgement_users" */
export type Policy_Acknowledgement_Users_Min_Order_By = {
  acknowledged_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  policy_acknowledgement_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "policy_acknowledgement_users" */
export type Policy_Acknowledgement_Users_Mutation_Response = {
  __typename?: 'policy_acknowledgement_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy_Acknowledgement_Users>;
};

/** Ordering options when selecting data from "policy_acknowledgement_users". */
export type Policy_Acknowledgement_Users_Order_By = {
  acknowledged_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  policy_acknowledgement?: InputMaybe<Policy_Acknowledgements_Order_By>;
  policy_acknowledgement_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: policy_acknowledgement_users */
export type Policy_Acknowledgement_Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "policy_acknowledgement_users" */
export enum Policy_Acknowledgement_Users_Select_Column {
  /** column name */
  AcknowledgedAt = 'acknowledged_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastNudgedAt = 'last_nudged_at',
  /** column name */
  PolicyAcknowledgementId = 'policy_acknowledgement_id',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "policy_acknowledgement_users" */
export type Policy_Acknowledgement_Users_Set_Input = {
  acknowledged_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type Policy_Acknowledgement_Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Policy_Acknowledgement_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Policy_Acknowledgement_Users_Bool_Exp;
};

/** columns and relationships of "policy_acknowledgements" */
export type Policy_Acknowledgements = {
  __typename?: 'policy_acknowledgements';
  acknowledged_count: Scalars['Int']['output'];
  acknowledger_count: Scalars['Int']['output'];
  audience_ready?: Maybe<Scalars['Boolean']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['uuid']['output'];
  due_date: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_complete?: Maybe<Scalars['Boolean']['output']>;
  message: Scalars['String']['output'];
  /** An array relationship */
  policy_acknowledgement_users: Array<Policy_Acknowledgement_Users>;
  /** An aggregate relationship */
  policy_acknowledgement_users_aggregate: Policy_Acknowledgement_Users_Aggregate;
  /** An object relationship */
  policy_version: Policy_Versions;
  policy_version_id: Scalars['uuid']['output'];
  status: Policy_Acknowledgement_Statuses_Enum;
  subject: Scalars['String']['output'];
  target_acknowledger_count: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};

/** columns and relationships of "policy_acknowledgements" */
export type Policy_AcknowledgementsPolicy_Acknowledgement_UsersArgs = {
  distinct_on?: InputMaybe<Array<Policy_Acknowledgement_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Acknowledgement_Users_Order_By>>;
  where?: InputMaybe<Policy_Acknowledgement_Users_Bool_Exp>;
};

/** columns and relationships of "policy_acknowledgements" */
export type Policy_AcknowledgementsPolicy_Acknowledgement_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Policy_Acknowledgement_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Acknowledgement_Users_Order_By>>;
  where?: InputMaybe<Policy_Acknowledgement_Users_Bool_Exp>;
};

/** order by aggregate values of table "policy_acknowledgements" */
export type Policy_Acknowledgements_Aggregate_Order_By = {
  avg?: InputMaybe<Policy_Acknowledgements_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policy_Acknowledgements_Max_Order_By>;
  min?: InputMaybe<Policy_Acknowledgements_Min_Order_By>;
  stddev?: InputMaybe<Policy_Acknowledgements_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Policy_Acknowledgements_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Policy_Acknowledgements_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Policy_Acknowledgements_Sum_Order_By>;
  var_pop?: InputMaybe<Policy_Acknowledgements_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Policy_Acknowledgements_Var_Samp_Order_By>;
  variance?: InputMaybe<Policy_Acknowledgements_Variance_Order_By>;
};

/** order by avg() on columns of table "policy_acknowledgements" */
export type Policy_Acknowledgements_Avg_Order_By = {
  acknowledged_count?: InputMaybe<Order_By>;
  acknowledger_count?: InputMaybe<Order_By>;
  target_acknowledger_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "policy_acknowledgements". All fields are combined with a logical 'AND'. */
export type Policy_Acknowledgements_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Acknowledgements_Bool_Exp>>;
  _not?: InputMaybe<Policy_Acknowledgements_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Acknowledgements_Bool_Exp>>;
  acknowledged_count?: InputMaybe<Int_Comparison_Exp>;
  acknowledger_count?: InputMaybe<Int_Comparison_Exp>;
  audience_ready?: InputMaybe<Boolean_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_complete?: InputMaybe<Boolean_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  policy_acknowledgement_users?: InputMaybe<Policy_Acknowledgement_Users_Bool_Exp>;
  policy_acknowledgement_users_aggregate?: InputMaybe<Policy_Acknowledgement_Users_Aggregate_Bool_Exp>;
  policy_version?: InputMaybe<Policy_Versions_Bool_Exp>;
  policy_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Policy_Acknowledgement_Statuses_Enum_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  target_acknowledger_count?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "policy_acknowledgements" */
export type Policy_Acknowledgements_Max_Order_By = {
  acknowledged_count?: InputMaybe<Order_By>;
  acknowledger_count?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  target_acknowledger_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "policy_acknowledgements" */
export type Policy_Acknowledgements_Min_Order_By = {
  acknowledged_count?: InputMaybe<Order_By>;
  acknowledger_count?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  target_acknowledger_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "policy_acknowledgements" */
export type Policy_Acknowledgements_Mutation_Response = {
  __typename?: 'policy_acknowledgements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy_Acknowledgements>;
};

/** Ordering options when selecting data from "policy_acknowledgements". */
export type Policy_Acknowledgements_Order_By = {
  acknowledged_count?: InputMaybe<Order_By>;
  acknowledger_count?: InputMaybe<Order_By>;
  audience_ready?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_complete?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  policy_acknowledgement_users_aggregate?: InputMaybe<Policy_Acknowledgement_Users_Aggregate_Order_By>;
  policy_version?: InputMaybe<Policy_Versions_Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  target_acknowledger_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: policy_acknowledgements */
export type Policy_Acknowledgements_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "policy_acknowledgements" */
export enum Policy_Acknowledgements_Select_Column {
  /** column name */
  AcknowledgedCount = 'acknowledged_count',
  /** column name */
  AcknowledgerCount = 'acknowledger_count',
  /** column name */
  AudienceReady = 'audience_ready',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsComplete = 'is_complete',
  /** column name */
  Message = 'message',
  /** column name */
  PolicyVersionId = 'policy_version_id',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  TargetAcknowledgerCount = 'target_acknowledger_count',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "policy_acknowledgements" */
export type Policy_Acknowledgements_Set_Input = {
  status?: InputMaybe<Policy_Acknowledgement_Statuses_Enum>;
};

/** order by stddev() on columns of table "policy_acknowledgements" */
export type Policy_Acknowledgements_Stddev_Order_By = {
  acknowledged_count?: InputMaybe<Order_By>;
  acknowledger_count?: InputMaybe<Order_By>;
  target_acknowledger_count?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "policy_acknowledgements" */
export type Policy_Acknowledgements_Stddev_Pop_Order_By = {
  acknowledged_count?: InputMaybe<Order_By>;
  acknowledger_count?: InputMaybe<Order_By>;
  target_acknowledger_count?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "policy_acknowledgements" */
export type Policy_Acknowledgements_Stddev_Samp_Order_By = {
  acknowledged_count?: InputMaybe<Order_By>;
  acknowledger_count?: InputMaybe<Order_By>;
  target_acknowledger_count?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "policy_acknowledgements" */
export type Policy_Acknowledgements_Sum_Order_By = {
  acknowledged_count?: InputMaybe<Order_By>;
  acknowledger_count?: InputMaybe<Order_By>;
  target_acknowledger_count?: InputMaybe<Order_By>;
};

export type Policy_Acknowledgements_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Policy_Acknowledgements_Set_Input>;
  /** filter the rows which have to be updated */
  where: Policy_Acknowledgements_Bool_Exp;
};

/** order by var_pop() on columns of table "policy_acknowledgements" */
export type Policy_Acknowledgements_Var_Pop_Order_By = {
  acknowledged_count?: InputMaybe<Order_By>;
  acknowledger_count?: InputMaybe<Order_By>;
  target_acknowledger_count?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "policy_acknowledgements" */
export type Policy_Acknowledgements_Var_Samp_Order_By = {
  acknowledged_count?: InputMaybe<Order_By>;
  acknowledger_count?: InputMaybe<Order_By>;
  target_acknowledger_count?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "policy_acknowledgements" */
export type Policy_Acknowledgements_Variance_Order_By = {
  acknowledged_count?: InputMaybe<Order_By>;
  acknowledger_count?: InputMaybe<Order_By>;
  target_acknowledger_count?: InputMaybe<Order_By>;
};

export enum Policy_Approval_Statuses_Enum {
  Approved = 'Approved',
  Expiring = 'Expiring',
  Overdue = 'Overdue',
  Pending = 'Pending',
  Retired = 'Retired',
}

/** Boolean expression to compare columns of type "policy_approval_statuses_enum". All fields are combined with logical 'AND'. */
export type Policy_Approval_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Policy_Approval_Statuses_Enum>;
  _in?: InputMaybe<Array<Policy_Approval_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Policy_Approval_Statuses_Enum>;
  _nin?: InputMaybe<Array<Policy_Approval_Statuses_Enum>>;
};

/** users approving a policy */
export type Policy_Approval_Users = {
  __typename?: 'policy_approval_users';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  approved_by?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  policy_approval: Policy_Approvals;
  policy_approval_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "policy_approval_users" */
export type Policy_Approval_Users_Aggregate = {
  __typename?: 'policy_approval_users_aggregate';
  aggregate?: Maybe<Policy_Approval_Users_Aggregate_Fields>;
  nodes: Array<Policy_Approval_Users>;
};

export type Policy_Approval_Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Policy_Approval_Users_Aggregate_Bool_Exp_Count>;
};

export type Policy_Approval_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Policy_Approval_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Policy_Approval_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "policy_approval_users" */
export type Policy_Approval_Users_Aggregate_Fields = {
  __typename?: 'policy_approval_users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Policy_Approval_Users_Max_Fields>;
  min?: Maybe<Policy_Approval_Users_Min_Fields>;
};

/** aggregate fields of "policy_approval_users" */
export type Policy_Approval_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Policy_Approval_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "policy_approval_users" */
export type Policy_Approval_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policy_Approval_Users_Max_Order_By>;
  min?: InputMaybe<Policy_Approval_Users_Min_Order_By>;
};

/** input type for inserting array relation for remote table "policy_approval_users" */
export type Policy_Approval_Users_Arr_Rel_Insert_Input = {
  data: Array<Policy_Approval_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_Approval_Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "policy_approval_users". All fields are combined with a logical 'AND'. */
export type Policy_Approval_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Approval_Users_Bool_Exp>>;
  _not?: InputMaybe<Policy_Approval_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Approval_Users_Bool_Exp>>;
  approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  approved_by?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_nudged_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  policy_approval?: InputMaybe<Policy_Approvals_Bool_Exp>;
  policy_approval_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "policy_approval_users" */
export enum Policy_Approval_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyApprovalUsersPkey = 'policy_approval_users_pkey',
  /** unique or primary key constraint on columns "user_id", "policy_approval_id" */
  PolicyApprovalUsersPolicyApprovalIdUserIdKey = 'policy_approval_users_policy_approval_id_user_id_key',
}

/** input type for inserting data into table "policy_approval_users" */
export type Policy_Approval_Users_Insert_Input = {
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  policy_approval?: InputMaybe<Policy_Approvals_Obj_Rel_Insert_Input>;
  policy_approval_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Policy_Approval_Users_Max_Fields = {
  __typename?: 'policy_approval_users_max_fields';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  approved_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  policy_approval_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "policy_approval_users" */
export type Policy_Approval_Users_Max_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  policy_approval_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Policy_Approval_Users_Min_Fields = {
  __typename?: 'policy_approval_users_min_fields';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  approved_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  policy_approval_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "policy_approval_users" */
export type Policy_Approval_Users_Min_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  policy_approval_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "policy_approval_users" */
export type Policy_Approval_Users_Mutation_Response = {
  __typename?: 'policy_approval_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy_Approval_Users>;
};

/** on_conflict condition type for table "policy_approval_users" */
export type Policy_Approval_Users_On_Conflict = {
  constraint: Policy_Approval_Users_Constraint;
  update_columns?: Array<Policy_Approval_Users_Update_Column>;
  where?: InputMaybe<Policy_Approval_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "policy_approval_users". */
export type Policy_Approval_Users_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  policy_approval?: InputMaybe<Policy_Approvals_Order_By>;
  policy_approval_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: policy_approval_users */
export type Policy_Approval_Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "policy_approval_users" */
export enum Policy_Approval_Users_Select_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  Id = 'id',
  /** column name */
  LastNudgedAt = 'last_nudged_at',
  /** column name */
  PolicyApprovalId = 'policy_approval_id',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "policy_approval_users" */
export type Policy_Approval_Users_Set_Input = {
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "policy_approval_users" */
export enum Policy_Approval_Users_Update_Column {
  /** column name */
  ApprovedAt = 'approved_at',
}

export type Policy_Approval_Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Policy_Approval_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Policy_Approval_Users_Bool_Exp;
};

/** table for approvals */
export type Policy_Approvals = {
  __typename?: 'policy_approvals';
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['uuid']['output'];
  due_date: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  policy_approval_users: Array<Policy_Approval_Users>;
  /** An aggregate relationship */
  policy_approval_users_aggregate: Policy_Approval_Users_Aggregate;
  /** An object relationship */
  policy_version: Policy_Versions;
  policy_version_id: Scalars['uuid']['output'];
  status: Policy_Approval_Statuses_Enum;
  subject: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};

/** table for approvals */
export type Policy_ApprovalsPolicy_Approval_UsersArgs = {
  distinct_on?: InputMaybe<Array<Policy_Approval_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Approval_Users_Order_By>>;
  where?: InputMaybe<Policy_Approval_Users_Bool_Exp>;
};

/** table for approvals */
export type Policy_ApprovalsPolicy_Approval_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Policy_Approval_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Approval_Users_Order_By>>;
  where?: InputMaybe<Policy_Approval_Users_Bool_Exp>;
};

/** order by aggregate values of table "policy_approvals" */
export type Policy_Approvals_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policy_Approvals_Max_Order_By>;
  min?: InputMaybe<Policy_Approvals_Min_Order_By>;
};

/** input type for inserting array relation for remote table "policy_approvals" */
export type Policy_Approvals_Arr_Rel_Insert_Input = {
  data: Array<Policy_Approvals_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_Approvals_On_Conflict>;
};

/** Boolean expression to filter rows from the table "policy_approvals". All fields are combined with a logical 'AND'. */
export type Policy_Approvals_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Approvals_Bool_Exp>>;
  _not?: InputMaybe<Policy_Approvals_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Approvals_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  policy_approval_users?: InputMaybe<Policy_Approval_Users_Bool_Exp>;
  policy_approval_users_aggregate?: InputMaybe<Policy_Approval_Users_Aggregate_Bool_Exp>;
  policy_version?: InputMaybe<Policy_Versions_Bool_Exp>;
  policy_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Policy_Approval_Statuses_Enum_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "policy_approvals" */
export enum Policy_Approvals_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyApprovalsPkey = 'policy_approvals_pkey',
}

/** input type for inserting data into table "policy_approvals" */
export type Policy_Approvals_Insert_Input = {
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policy_approval_users?: InputMaybe<Policy_Approval_Users_Arr_Rel_Insert_Input>;
  policy_version?: InputMaybe<Policy_Versions_Obj_Rel_Insert_Input>;
  policy_version_id?: InputMaybe<Scalars['uuid']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "policy_approvals" */
export type Policy_Approvals_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "policy_approvals" */
export type Policy_Approvals_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "policy_approvals" */
export type Policy_Approvals_Mutation_Response = {
  __typename?: 'policy_approvals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy_Approvals>;
};

/** input type for inserting object relation for remote table "policy_approvals" */
export type Policy_Approvals_Obj_Rel_Insert_Input = {
  data: Policy_Approvals_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_Approvals_On_Conflict>;
};

/** on_conflict condition type for table "policy_approvals" */
export type Policy_Approvals_On_Conflict = {
  constraint: Policy_Approvals_Constraint;
  update_columns?: Array<Policy_Approvals_Update_Column>;
  where?: InputMaybe<Policy_Approvals_Bool_Exp>;
};

/** Ordering options when selecting data from "policy_approvals". */
export type Policy_Approvals_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  policy_approval_users_aggregate?: InputMaybe<Policy_Approval_Users_Aggregate_Order_By>;
  policy_version?: InputMaybe<Policy_Versions_Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: policy_approvals */
export type Policy_Approvals_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "policy_approvals" */
export enum Policy_Approvals_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Name = 'name',
  /** column name */
  PolicyVersionId = 'policy_version_id',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "policy_approvals" */
export type Policy_Approvals_Set_Input = {
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Policy_Approval_Statuses_Enum>;
};

/** update columns of table "policy_approvals" */
export enum Policy_Approvals_Update_Column {
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
}

export type Policy_Approvals_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Policy_Approvals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Policy_Approvals_Bool_Exp;
};

/** list of users that would approve a policy, a snapshot of this instance is taken when approval is sent */
export type Policy_Approvers = {
  __typename?: 'policy_approvers';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  policy: Policies;
  policy_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "policy_approvers" */
export type Policy_Approvers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policy_Approvers_Max_Order_By>;
  min?: InputMaybe<Policy_Approvers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "policy_approvers" */
export type Policy_Approvers_Arr_Rel_Insert_Input = {
  data: Array<Policy_Approvers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_Approvers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "policy_approvers". All fields are combined with a logical 'AND'. */
export type Policy_Approvers_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Approvers_Bool_Exp>>;
  _not?: InputMaybe<Policy_Approvers_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Approvers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  policy?: InputMaybe<Policies_Bool_Exp>;
  policy_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "policy_approvers" */
export enum Policy_Approvers_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyApproversPkey = 'policy_approvers_pkey',
  /** unique or primary key constraint on columns "user_id", "policy_id" */
  PolicyApproversPolicyIdUserIdKey = 'policy_approvers_policy_id_user_id_key',
}

/** input type for inserting data into table "policy_approvers" */
export type Policy_Approvers_Insert_Input = {
  policy?: InputMaybe<Policies_Obj_Rel_Insert_Input>;
  policy_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "policy_approvers" */
export type Policy_Approvers_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "policy_approvers" */
export type Policy_Approvers_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "policy_approvers" */
export type Policy_Approvers_Mutation_Response = {
  __typename?: 'policy_approvers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy_Approvers>;
};

/** on_conflict condition type for table "policy_approvers" */
export type Policy_Approvers_On_Conflict = {
  constraint: Policy_Approvers_Constraint;
  update_columns?: Array<Policy_Approvers_Update_Column>;
  where?: InputMaybe<Policy_Approvers_Bool_Exp>;
};

/** Ordering options when selecting data from "policy_approvers". */
export type Policy_Approvers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy?: InputMaybe<Policies_Order_By>;
  policy_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "policy_approvers" */
export enum Policy_Approvers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyId = 'policy_id',
  /** column name */
  UserId = 'user_id',
}

/** placeholder for update columns of table "policy_approvers" (current role has no relevant permissions) */
export enum Policy_Approvers_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "policy_exception_approvers" */
export type Policy_Exception_Approvers = {
  __typename?: 'policy_exception_approvers';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  approver: Users;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  policy_exception: Policy_Exceptions;
  policy_exception_id: Scalars['uuid']['output'];
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "policy_exception_approvers" */
export type Policy_Exception_Approvers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policy_Exception_Approvers_Max_Order_By>;
  min?: InputMaybe<Policy_Exception_Approvers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "policy_exception_approvers" */
export type Policy_Exception_Approvers_Arr_Rel_Insert_Input = {
  data: Array<Policy_Exception_Approvers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_Exception_Approvers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "policy_exception_approvers". All fields are combined with a logical 'AND'. */
export type Policy_Exception_Approvers_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Exception_Approvers_Bool_Exp>>;
  _not?: InputMaybe<Policy_Exception_Approvers_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Exception_Approvers_Bool_Exp>>;
  approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  approver?: InputMaybe<Users_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_nudged_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  policy_exception?: InputMaybe<Policy_Exceptions_Bool_Exp>;
  policy_exception_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "policy_exception_approvers" */
export enum Policy_Exception_Approvers_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyExceptionApproversPkey = 'policy_exception_approvers_pkey',
  /** unique or primary key constraint on columns "user_id", "policy_exception_id" */
  PolicyExceptionApproversPolicyExceptionIdUserIdKey = 'policy_exception_approvers_policy_exception_id_user_id_key',
}

/** input type for inserting data into table "policy_exception_approvers" */
export type Policy_Exception_Approvers_Insert_Input = {
  policy_exception?: InputMaybe<Policy_Exceptions_Obj_Rel_Insert_Input>;
  policy_exception_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "policy_exception_approvers" */
export type Policy_Exception_Approvers_Max_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  policy_exception_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "policy_exception_approvers" */
export type Policy_Exception_Approvers_Min_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  policy_exception_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "policy_exception_approvers" */
export type Policy_Exception_Approvers_Mutation_Response = {
  __typename?: 'policy_exception_approvers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy_Exception_Approvers>;
};

/** on_conflict condition type for table "policy_exception_approvers" */
export type Policy_Exception_Approvers_On_Conflict = {
  constraint: Policy_Exception_Approvers_Constraint;
  update_columns?: Array<Policy_Exception_Approvers_Update_Column>;
  where?: InputMaybe<Policy_Exception_Approvers_Bool_Exp>;
};

/** Ordering options when selecting data from "policy_exception_approvers". */
export type Policy_Exception_Approvers_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  approver?: InputMaybe<Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  policy_exception?: InputMaybe<Policy_Exceptions_Order_By>;
  policy_exception_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: policy_exception_approvers */
export type Policy_Exception_Approvers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "policy_exception_approvers" */
export enum Policy_Exception_Approvers_Select_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastNudgedAt = 'last_nudged_at',
  /** column name */
  PolicyExceptionId = 'policy_exception_id',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "policy_exception_approvers" */
export type Policy_Exception_Approvers_Set_Input = {
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "policy_exception_approvers" */
export enum Policy_Exception_Approvers_Update_Column {
  /** column name */
  ApprovedAt = 'approved_at',
}

export type Policy_Exception_Approvers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Policy_Exception_Approvers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Policy_Exception_Approvers_Bool_Exp;
};

/** columns and relationships of "policy_exception_files" */
export type Policy_Exception_Files = {
  __typename?: 'policy_exception_files';
  created_at: Scalars['timestamptz']['output'];
  exception_id: Scalars['uuid']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  policy_exception: Policy_Exceptions;
};

/** order by aggregate values of table "policy_exception_files" */
export type Policy_Exception_Files_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policy_Exception_Files_Max_Order_By>;
  min?: InputMaybe<Policy_Exception_Files_Min_Order_By>;
};

/** input type for inserting array relation for remote table "policy_exception_files" */
export type Policy_Exception_Files_Arr_Rel_Insert_Input = {
  data: Array<Policy_Exception_Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_Exception_Files_On_Conflict>;
};

/** Boolean expression to filter rows from the table "policy_exception_files". All fields are combined with a logical 'AND'. */
export type Policy_Exception_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Exception_Files_Bool_Exp>>;
  _not?: InputMaybe<Policy_Exception_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Exception_Files_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  exception_id?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  policy_exception?: InputMaybe<Policy_Exceptions_Bool_Exp>;
};

/** unique or primary key constraints on table "policy_exception_files" */
export enum Policy_Exception_Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyExceptionFilesPkey = 'policy_exception_files_pkey',
}

/** input type for inserting data into table "policy_exception_files" */
export type Policy_Exception_Files_Insert_Input = {
  exception_id?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  policy_exception?: InputMaybe<Policy_Exceptions_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "policy_exception_files" */
export type Policy_Exception_Files_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  exception_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "policy_exception_files" */
export type Policy_Exception_Files_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  exception_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "policy_exception_files" */
export type Policy_Exception_Files_Mutation_Response = {
  __typename?: 'policy_exception_files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy_Exception_Files>;
};

/** on_conflict condition type for table "policy_exception_files" */
export type Policy_Exception_Files_On_Conflict = {
  constraint: Policy_Exception_Files_Constraint;
  update_columns?: Array<Policy_Exception_Files_Update_Column>;
  where?: InputMaybe<Policy_Exception_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "policy_exception_files". */
export type Policy_Exception_Files_Order_By = {
  created_at?: InputMaybe<Order_By>;
  exception_id?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_exception?: InputMaybe<Policy_Exceptions_Order_By>;
};

/** select columns of table "policy_exception_files" */
export enum Policy_Exception_Files_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExceptionId = 'exception_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
}

/** placeholder for update columns of table "policy_exception_files" (current role has no relevant permissions) */
export enum Policy_Exception_Files_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

export enum Policy_Exception_Statuses_Enum {
  Approved = 'Approved',
  AwaitingApproval = 'Awaiting_approval',
  Outdated = 'Outdated',
}

/** Boolean expression to compare columns of type "policy_exception_statuses_enum". All fields are combined with logical 'AND'. */
export type Policy_Exception_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Policy_Exception_Statuses_Enum>;
  _in?: InputMaybe<Array<Policy_Exception_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Policy_Exception_Statuses_Enum>;
  _nin?: InputMaybe<Array<Policy_Exception_Statuses_Enum>>;
};

/** columns and relationships of "policy_exceptions" */
export type Policy_Exceptions = {
  __typename?: 'policy_exceptions';
  action_plan?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  approvers: Array<Policy_Exception_Approvers>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  exception_files: Array<Policy_Exception_Files>;
  id: Scalars['uuid']['output'];
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  notifications: Array<Notifications>;
  policy_section: Scalars['String']['output'];
  /** An object relationship */
  policy_version: Policy_Versions;
  policy_version_id: Scalars['uuid']['output'];
  reason: Scalars['String']['output'];
  risk?: Maybe<Scalars['String']['output']>;
  status: Policy_Exception_Statuses_Enum;
  subject?: Maybe<Scalars['String']['output']>;
  timeframe?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** columns and relationships of "policy_exceptions" */
export type Policy_ExceptionsApproversArgs = {
  distinct_on?: InputMaybe<Array<Policy_Exception_Approvers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Exception_Approvers_Order_By>>;
  where?: InputMaybe<Policy_Exception_Approvers_Bool_Exp>;
};

/** columns and relationships of "policy_exceptions" */
export type Policy_ExceptionsException_FilesArgs = {
  distinct_on?: InputMaybe<Array<Policy_Exception_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Exception_Files_Order_By>>;
  where?: InputMaybe<Policy_Exception_Files_Bool_Exp>;
};

/** columns and relationships of "policy_exceptions" */
export type Policy_ExceptionsNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** order by aggregate values of table "policy_exceptions" */
export type Policy_Exceptions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policy_Exceptions_Max_Order_By>;
  min?: InputMaybe<Policy_Exceptions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "policy_exceptions" */
export type Policy_Exceptions_Arr_Rel_Insert_Input = {
  data: Array<Policy_Exceptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_Exceptions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "policy_exceptions". All fields are combined with a logical 'AND'. */
export type Policy_Exceptions_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Exceptions_Bool_Exp>>;
  _not?: InputMaybe<Policy_Exceptions_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Exceptions_Bool_Exp>>;
  action_plan?: InputMaybe<String_Comparison_Exp>;
  approvers?: InputMaybe<Policy_Exception_Approvers_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  exception_files?: InputMaybe<Policy_Exception_Files_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  policy_section?: InputMaybe<String_Comparison_Exp>;
  policy_version?: InputMaybe<Policy_Versions_Bool_Exp>;
  policy_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  risk?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Policy_Exception_Statuses_Enum_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  timeframe?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "policy_exceptions" */
export enum Policy_Exceptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyExceptionsPkey = 'policy_exceptions_pkey',
}

/** input type for inserting data into table "policy_exceptions" */
export type Policy_Exceptions_Insert_Input = {
  approvers?: InputMaybe<Policy_Exception_Approvers_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  exception_files?: InputMaybe<Policy_Exception_Files_Arr_Rel_Insert_Input>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  policy_section?: InputMaybe<Scalars['String']['input']>;
  policy_version?: InputMaybe<Policy_Versions_Obj_Rel_Insert_Input>;
  policy_version_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  timeframe?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "policy_exceptions" */
export type Policy_Exceptions_Max_Order_By = {
  action_plan?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  policy_section?: InputMaybe<Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  risk?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  timeframe?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "policy_exceptions" */
export type Policy_Exceptions_Min_Order_By = {
  action_plan?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  policy_section?: InputMaybe<Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  risk?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  timeframe?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "policy_exceptions" */
export type Policy_Exceptions_Mutation_Response = {
  __typename?: 'policy_exceptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy_Exceptions>;
};

/** input type for inserting object relation for remote table "policy_exceptions" */
export type Policy_Exceptions_Obj_Rel_Insert_Input = {
  data: Policy_Exceptions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_Exceptions_On_Conflict>;
};

/** on_conflict condition type for table "policy_exceptions" */
export type Policy_Exceptions_On_Conflict = {
  constraint: Policy_Exceptions_Constraint;
  update_columns?: Array<Policy_Exceptions_Update_Column>;
  where?: InputMaybe<Policy_Exceptions_Bool_Exp>;
};

/** Ordering options when selecting data from "policy_exceptions". */
export type Policy_Exceptions_Order_By = {
  action_plan?: InputMaybe<Order_By>;
  approvers_aggregate?: InputMaybe<Policy_Exception_Approvers_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  exception_files_aggregate?: InputMaybe<Policy_Exception_Files_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  policy_section?: InputMaybe<Order_By>;
  policy_version?: InputMaybe<Policy_Versions_Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  risk?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  timeframe?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: policy_exceptions */
export type Policy_Exceptions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "policy_exceptions" */
export enum Policy_Exceptions_Select_Column {
  /** column name */
  ActionPlan = 'action_plan',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PolicySection = 'policy_section',
  /** column name */
  PolicyVersionId = 'policy_version_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  Risk = 'risk',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  Timeframe = 'timeframe',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "policy_exceptions" */
export type Policy_Exceptions_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  policy_section?: InputMaybe<Scalars['String']['input']>;
  policy_version_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  timeframe?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "policy_exceptions" */
export enum Policy_Exceptions_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PolicySection = 'policy_section',
  /** column name */
  PolicyVersionId = 'policy_version_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  Timeframe = 'timeframe',
}

export type Policy_Exceptions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Policy_Exceptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Policy_Exceptions_Bool_Exp;
};

export enum Policy_Integration_Error_Statuses_Enum {
  Forbidden = 'forbidden',
  Internal = 'internal',
  NotFound = 'not_found',
  Unauthenticated = 'unauthenticated',
}

/** Boolean expression to compare columns of type "policy_integration_error_statuses_enum". All fields are combined with logical 'AND'. */
export type Policy_Integration_Error_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Policy_Integration_Error_Statuses_Enum>;
  _in?: InputMaybe<Array<Policy_Integration_Error_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Policy_Integration_Error_Statuses_Enum>;
  _nin?: InputMaybe<Array<Policy_Integration_Error_Statuses_Enum>>;
};

/** columns and relationships of "policy_integrations" */
export type Policy_Integrations = {
  __typename?: 'policy_integrations';
  config: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  last_error_status?: Maybe<Policy_Integration_Error_Statuses_Enum>;
  /** An object relationship */
  organization_integration: Organization_Integrations;
  organization_integration_id: Scalars['uuid']['output'];
  /** An object relationship */
  policy: Policies;
  policy_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "policy_integrations" */
export type Policy_IntegrationsConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "policy_integrations" */
export type Policy_Integrations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policy_Integrations_Max_Order_By>;
  min?: InputMaybe<Policy_Integrations_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Policy_Integrations_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "policy_integrations" */
export type Policy_Integrations_Arr_Rel_Insert_Input = {
  data: Array<Policy_Integrations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_Integrations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "policy_integrations". All fields are combined with a logical 'AND'. */
export type Policy_Integrations_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Integrations_Bool_Exp>>;
  _not?: InputMaybe<Policy_Integrations_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Integrations_Bool_Exp>>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_error_status?: InputMaybe<Policy_Integration_Error_Statuses_Enum_Comparison_Exp>;
  organization_integration?: InputMaybe<Organization_Integrations_Bool_Exp>;
  organization_integration_id?: InputMaybe<Uuid_Comparison_Exp>;
  policy?: InputMaybe<Policies_Bool_Exp>;
  policy_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "policy_integrations" */
export enum Policy_Integrations_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyIntegrationsPkey = 'policy_integrations_pkey',
  /** unique or primary key constraint on columns "policy_id" */
  PolicyIntegrationsPolicyIdKey = 'policy_integrations_policy_id_key',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Policy_Integrations_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Policy_Integrations_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Policy_Integrations_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "policy_integrations" */
export type Policy_Integrations_Insert_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  organization_integration_id?: InputMaybe<Scalars['uuid']['input']>;
  policy?: InputMaybe<Policies_Obj_Rel_Insert_Input>;
  policy_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "policy_integrations" */
export type Policy_Integrations_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_integration_id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "policy_integrations" */
export type Policy_Integrations_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_integration_id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "policy_integrations" */
export type Policy_Integrations_Mutation_Response = {
  __typename?: 'policy_integrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy_Integrations>;
};

/** on_conflict condition type for table "policy_integrations" */
export type Policy_Integrations_On_Conflict = {
  constraint: Policy_Integrations_Constraint;
  update_columns?: Array<Policy_Integrations_Update_Column>;
  where?: InputMaybe<Policy_Integrations_Bool_Exp>;
};

/** Ordering options when selecting data from "policy_integrations". */
export type Policy_Integrations_Order_By = {
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_error_status?: InputMaybe<Order_By>;
  organization_integration?: InputMaybe<Organization_Integrations_Order_By>;
  organization_integration_id?: InputMaybe<Order_By>;
  policy?: InputMaybe<Policies_Order_By>;
  policy_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: policy_integrations */
export type Policy_Integrations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Policy_Integrations_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "policy_integrations" */
export enum Policy_Integrations_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastErrorStatus = 'last_error_status',
  /** column name */
  OrganizationIntegrationId = 'organization_integration_id',
  /** column name */
  PolicyId = 'policy_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "policy_integrations" */
export type Policy_Integrations_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  organization_integration_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "policy_integrations" */
export type Policy_Integrations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Policy_Integrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Policy_Integrations_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_error_status?: InputMaybe<Policy_Integration_Error_Statuses_Enum>;
  organization_integration_id?: InputMaybe<Scalars['uuid']['input']>;
  policy_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "policy_integrations" */
export enum Policy_Integrations_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  OrganizationIntegrationId = 'organization_integration_id',
}

export type Policy_Integrations_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Policy_Integrations_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Policy_Integrations_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Policy_Integrations_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Policy_Integrations_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Policy_Integrations_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Policy_Integrations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Policy_Integrations_Bool_Exp;
};

/** users responsible for policy */
export type Policy_Owners = {
  __typename?: 'policy_owners';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  owner_id: Scalars['uuid']['output'];
  /** An object relationship */
  policy: Policies;
  policy_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
};

/** order by aggregate values of table "policy_owners" */
export type Policy_Owners_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policy_Owners_Max_Order_By>;
  min?: InputMaybe<Policy_Owners_Min_Order_By>;
};

/** input type for inserting array relation for remote table "policy_owners" */
export type Policy_Owners_Arr_Rel_Insert_Input = {
  data: Array<Policy_Owners_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_Owners_On_Conflict>;
};

/** Boolean expression to filter rows from the table "policy_owners". All fields are combined with a logical 'AND'. */
export type Policy_Owners_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Owners_Bool_Exp>>;
  _not?: InputMaybe<Policy_Owners_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Owners_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  policy?: InputMaybe<Policies_Bool_Exp>;
  policy_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "policy_owners" */
export enum Policy_Owners_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyOwnersPkey = 'policy_owners_pkey',
  /** unique or primary key constraint on columns "policy_id", "owner_id" */
  PolicyOwnersPolicyIdOwnerIdKey = 'policy_owners_policy_id_owner_id_key',
}

/** input type for inserting data into table "policy_owners" */
export type Policy_Owners_Insert_Input = {
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
  policy?: InputMaybe<Policies_Obj_Rel_Insert_Input>;
  policy_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "policy_owners" */
export type Policy_Owners_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "policy_owners" */
export type Policy_Owners_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "policy_owners" */
export type Policy_Owners_Mutation_Response = {
  __typename?: 'policy_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy_Owners>;
};

/** on_conflict condition type for table "policy_owners" */
export type Policy_Owners_On_Conflict = {
  constraint: Policy_Owners_Constraint;
  update_columns?: Array<Policy_Owners_Update_Column>;
  where?: InputMaybe<Policy_Owners_Bool_Exp>;
};

/** Ordering options when selecting data from "policy_owners". */
export type Policy_Owners_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  policy?: InputMaybe<Policies_Order_By>;
  policy_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "policy_owners" */
export enum Policy_Owners_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  PolicyId = 'policy_id',
}

/** placeholder for update columns of table "policy_owners" (current role has no relevant permissions) */
export enum Policy_Owners_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

export enum Policy_Statuses_Enum {
  Approved = 'Approved',
  AwaitingApproval = 'Awaiting_approval',
  Draft = 'Draft',
  Expiring = 'Expiring',
  Overdue = 'Overdue',
  Retired = 'Retired',
}

/** Boolean expression to compare columns of type "policy_statuses_enum". All fields are combined with logical 'AND'. */
export type Policy_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Policy_Statuses_Enum>;
  _in?: InputMaybe<Array<Policy_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Policy_Statuses_Enum>;
  _nin?: InputMaybe<Array<Policy_Statuses_Enum>>;
};

/** Stores list of tasks linked to policies */
export type Policy_Tasks = {
  __typename?: 'policy_tasks';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  policy?: Maybe<Policies>;
  policy_id: Scalars['uuid']['output'];
  /** An object relationship */
  policy_tasks_policy: Policies;
  /** An object relationship */
  policy_tasks_task: Tasks;
  task?: Maybe<Tasks>;
  task_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "policy_tasks" */
export type Policy_Tasks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policy_Tasks_Max_Order_By>;
  min?: InputMaybe<Policy_Tasks_Min_Order_By>;
};

/** input type for inserting array relation for remote table "policy_tasks" */
export type Policy_Tasks_Arr_Rel_Insert_Input = {
  data: Array<Policy_Tasks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_Tasks_On_Conflict>;
};

/** Boolean expression to filter rows from the table "policy_tasks". All fields are combined with a logical 'AND'. */
export type Policy_Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Tasks_Bool_Exp>>;
  _not?: InputMaybe<Policy_Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Tasks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  policy_id?: InputMaybe<Uuid_Comparison_Exp>;
  policy_tasks_policy?: InputMaybe<Policies_Bool_Exp>;
  policy_tasks_task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "policy_tasks" */
export enum Policy_Tasks_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyTasksPkey = 'policy_tasks_pkey',
  /** unique or primary key constraint on columns "task_id", "policy_id" */
  PolicyTasksPolicyIdTaskIdKey = 'policy_tasks_policy_id_task_id_key',
}

/** input type for inserting data into table "policy_tasks" */
export type Policy_Tasks_Insert_Input = {
  policy_id?: InputMaybe<Scalars['uuid']['input']>;
  policy_tasks_policy?: InputMaybe<Policies_Obj_Rel_Insert_Input>;
  policy_tasks_task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "policy_tasks" */
export type Policy_Tasks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "policy_tasks" */
export type Policy_Tasks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "policy_tasks" */
export type Policy_Tasks_Mutation_Response = {
  __typename?: 'policy_tasks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy_Tasks>;
};

/** on_conflict condition type for table "policy_tasks" */
export type Policy_Tasks_On_Conflict = {
  constraint: Policy_Tasks_Constraint;
  update_columns?: Array<Policy_Tasks_Update_Column>;
  where?: InputMaybe<Policy_Tasks_Bool_Exp>;
};

/** Ordering options when selecting data from "policy_tasks". */
export type Policy_Tasks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  policy_tasks_policy?: InputMaybe<Policies_Order_By>;
  policy_tasks_task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** select columns of table "policy_tasks" */
export enum Policy_Tasks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyId = 'policy_id',
  /** column name */
  TaskId = 'task_id',
}

/** placeholder for update columns of table "policy_tasks" (current role has no relevant permissions) */
export enum Policy_Tasks_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "policy_version_content_files" */
export type Policy_Version_Content_Files = {
  __typename?: 'policy_version_content_files';
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  policy_version: Policy_Versions;
  policy_version_id: Scalars['uuid']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** order by aggregate values of table "policy_version_content_files" */
export type Policy_Version_Content_Files_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policy_Version_Content_Files_Max_Order_By>;
  min?: InputMaybe<Policy_Version_Content_Files_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "policy_version_content_files". All fields are combined with a logical 'AND'. */
export type Policy_Version_Content_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Version_Content_Files_Bool_Exp>>;
  _not?: InputMaybe<Policy_Version_Content_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Version_Content_Files_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  policy_version?: InputMaybe<Policy_Versions_Bool_Exp>;
  policy_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "policy_version_content_files" */
export type Policy_Version_Content_Files_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "policy_version_content_files" */
export type Policy_Version_Content_Files_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "policy_version_content_files". */
export type Policy_Version_Content_Files_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_version?: InputMaybe<Policy_Versions_Order_By>;
  policy_version_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "policy_version_content_files" */
export enum Policy_Version_Content_Files_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyVersionId = 'policy_version_id',
}

export enum Policy_Version_Statuses_Enum {
  Approved = 'Approved',
  AwaitingApproval = 'Awaiting_approval',
  Draft = 'Draft',
  Expiring = 'Expiring',
  Overdue = 'Overdue',
  Retired = 'Retired',
}

/** Boolean expression to compare columns of type "policy_version_statuses_enum". All fields are combined with logical 'AND'. */
export type Policy_Version_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Policy_Version_Statuses_Enum>;
  _in?: InputMaybe<Array<Policy_Version_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Policy_Version_Statuses_Enum>;
  _nin?: InputMaybe<Array<Policy_Version_Statuses_Enum>>;
};

export enum Policy_Version_Types_Enum {
  Custom = 'Custom',
  Template = 'Template',
  Upload = 'Upload',
}

/** Boolean expression to compare columns of type "policy_version_types_enum". All fields are combined with logical 'AND'. */
export type Policy_Version_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Policy_Version_Types_Enum>;
  _in?: InputMaybe<Array<Policy_Version_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Policy_Version_Types_Enum>;
  _nin?: InputMaybe<Array<Policy_Version_Types_Enum>>;
};

/** columns and relationships of "policy_versions" */
export type Policy_Versions = {
  __typename?: 'policy_versions';
  /** An array relationship */
  content_files: Array<Policy_Version_Content_Files>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  file?: Maybe<Files>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An object relationship */
  policy: Policies;
  /** An array relationship */
  policy_acknowledgements: Array<Policy_Acknowledgements>;
  /** An array relationship */
  policy_approvals: Array<Policy_Approvals>;
  /** An array relationship */
  policy_exceptions: Array<Policy_Exceptions>;
  policy_id: Scalars['uuid']['output'];
  /** Rich-text policy body stored as Lexical editor-state JSON, not markdown or plain text. To set policy content from markdown, call the update_policy_version_content action with policy_markdown and let the platform convert it, rather than writing this column directly. */
  policy_text?: Maybe<Scalars['String']['output']>;
  revision_details?: Maybe<Scalars['String']['output']>;
  status: Policy_Version_Statuses_Enum;
  type: Policy_Version_Types_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  validity_start?: Maybe<Scalars['timestamptz']['output']>;
  version_id: Scalars['String']['output'];
  version_id_for_sort?: Maybe<Array<Scalars['Int']['output']>>;
};

/** columns and relationships of "policy_versions" */
export type Policy_VersionsContent_FilesArgs = {
  distinct_on?: InputMaybe<Array<Policy_Version_Content_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Version_Content_Files_Order_By>>;
  where?: InputMaybe<Policy_Version_Content_Files_Bool_Exp>;
};

/** columns and relationships of "policy_versions" */
export type Policy_VersionsNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** columns and relationships of "policy_versions" */
export type Policy_VersionsPolicy_AcknowledgementsArgs = {
  distinct_on?: InputMaybe<Array<Policy_Acknowledgements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Acknowledgements_Order_By>>;
  where?: InputMaybe<Policy_Acknowledgements_Bool_Exp>;
};

/** columns and relationships of "policy_versions" */
export type Policy_VersionsPolicy_ApprovalsArgs = {
  distinct_on?: InputMaybe<Array<Policy_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Approvals_Order_By>>;
  where?: InputMaybe<Policy_Approvals_Bool_Exp>;
};

/** columns and relationships of "policy_versions" */
export type Policy_VersionsPolicy_ExceptionsArgs = {
  distinct_on?: InputMaybe<Array<Policy_Exceptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Exceptions_Order_By>>;
  where?: InputMaybe<Policy_Exceptions_Bool_Exp>;
};

/** order by aggregate values of table "policy_versions" */
export type Policy_Versions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Policy_Versions_Max_Order_By>;
  min?: InputMaybe<Policy_Versions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "policy_versions" */
export type Policy_Versions_Arr_Rel_Insert_Input = {
  data: Array<Policy_Versions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_Versions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "policy_versions". All fields are combined with a logical 'AND'. */
export type Policy_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Versions_Bool_Exp>>;
  _not?: InputMaybe<Policy_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Versions_Bool_Exp>>;
  content_files?: InputMaybe<Policy_Version_Content_Files_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  policy?: InputMaybe<Policies_Bool_Exp>;
  policy_acknowledgements?: InputMaybe<Policy_Acknowledgements_Bool_Exp>;
  policy_approvals?: InputMaybe<Policy_Approvals_Bool_Exp>;
  policy_exceptions?: InputMaybe<Policy_Exceptions_Bool_Exp>;
  policy_id?: InputMaybe<Uuid_Comparison_Exp>;
  policy_text?: InputMaybe<String_Comparison_Exp>;
  revision_details?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Policy_Version_Statuses_Enum_Comparison_Exp>;
  type?: InputMaybe<Policy_Version_Types_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  validity_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  version_id?: InputMaybe<String_Comparison_Exp>;
  version_id_for_sort?: InputMaybe<Int_Array_Comparison_Exp>;
};

/** unique or primary key constraints on table "policy_versions" */
export enum Policy_Versions_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyVersionsPkey = 'policy_versions_pkey',
  /** unique or primary key constraint on columns "version_id", "policy_id" */
  PolicyVersionsPolicyIdVersionIdKey = 'policy_versions_policy_id_version_id_key',
}

/** input type for inserting data into table "policy_versions" */
export type Policy_Versions_Insert_Input = {
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  policy?: InputMaybe<Policies_Obj_Rel_Insert_Input>;
  policy_approvals?: InputMaybe<Policy_Approvals_Arr_Rel_Insert_Input>;
  policy_exceptions?: InputMaybe<Policy_Exceptions_Arr_Rel_Insert_Input>;
  policy_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Rich-text policy body stored as Lexical editor-state JSON, not markdown or plain text. To set policy content from markdown, call the update_policy_version_content action with policy_markdown and let the platform convert it, rather than writing this column directly. */
  policy_text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Policy_Version_Types_Enum>;
  validity_start?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "policy_versions" */
export type Policy_Versions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  /** Rich-text policy body stored as Lexical editor-state JSON, not markdown or plain text. To set policy content from markdown, call the update_policy_version_content action with policy_markdown and let the platform convert it, rather than writing this column directly. */
  policy_text?: InputMaybe<Order_By>;
  revision_details?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  validity_start?: InputMaybe<Order_By>;
  version_id?: InputMaybe<Order_By>;
  version_id_for_sort?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "policy_versions" */
export type Policy_Versions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policy_id?: InputMaybe<Order_By>;
  /** Rich-text policy body stored as Lexical editor-state JSON, not markdown or plain text. To set policy content from markdown, call the update_policy_version_content action with policy_markdown and let the platform convert it, rather than writing this column directly. */
  policy_text?: InputMaybe<Order_By>;
  revision_details?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  validity_start?: InputMaybe<Order_By>;
  version_id?: InputMaybe<Order_By>;
  version_id_for_sort?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "policy_versions" */
export type Policy_Versions_Mutation_Response = {
  __typename?: 'policy_versions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy_Versions>;
};

/** input type for inserting object relation for remote table "policy_versions" */
export type Policy_Versions_Obj_Rel_Insert_Input = {
  data: Policy_Versions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_Versions_On_Conflict>;
};

/** on_conflict condition type for table "policy_versions" */
export type Policy_Versions_On_Conflict = {
  constraint: Policy_Versions_Constraint;
  update_columns?: Array<Policy_Versions_Update_Column>;
  where?: InputMaybe<Policy_Versions_Bool_Exp>;
};

/** Ordering options when selecting data from "policy_versions". */
export type Policy_Versions_Order_By = {
  content_files_aggregate?: InputMaybe<Policy_Version_Content_Files_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  policy?: InputMaybe<Policies_Order_By>;
  policy_acknowledgements_aggregate?: InputMaybe<Policy_Acknowledgements_Aggregate_Order_By>;
  policy_approvals_aggregate?: InputMaybe<Policy_Approvals_Aggregate_Order_By>;
  policy_exceptions_aggregate?: InputMaybe<Policy_Exceptions_Aggregate_Order_By>;
  policy_id?: InputMaybe<Order_By>;
  policy_text?: InputMaybe<Order_By>;
  revision_details?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  validity_start?: InputMaybe<Order_By>;
  version_id?: InputMaybe<Order_By>;
  version_id_for_sort?: InputMaybe<Order_By>;
};

/** primary key columns input for table: policy_versions */
export type Policy_Versions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "policy_versions" */
export enum Policy_Versions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyId = 'policy_id',
  /** column name */
  PolicyText = 'policy_text',
  /** column name */
  RevisionDetails = 'revision_details',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidityStart = 'validity_start',
  /** column name */
  VersionId = 'version_id',
  /** column name */
  VersionIdForSort = 'version_id_for_sort',
}

/** input type for updating data in table "policy_versions" */
export type Policy_Versions_Set_Input = {
  revision_details?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Policy_Version_Statuses_Enum>;
  validity_start?: InputMaybe<Scalars['timestamptz']['input']>;
  version_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "policy_versions" */
export enum Policy_Versions_Update_Column {
  /** column name */
  RevisionDetails = 'revision_details',
  /** column name */
  Status = 'status',
  /** column name */
  ValidityStart = 'validity_start',
  /** column name */
  VersionId = 'version_id',
}

export type Policy_Versions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Policy_Versions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Policy_Versions_Bool_Exp;
};

/** users assigned to program */
export type Program_Assignees = {
  __typename?: 'program_assignees';
  /** An object relationship */
  program: Programs;
  program_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "program_assignees" */
export type Program_Assignees_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Program_Assignees_Max_Order_By>;
  min?: InputMaybe<Program_Assignees_Min_Order_By>;
};

/** input type for inserting array relation for remote table "program_assignees" */
export type Program_Assignees_Arr_Rel_Insert_Input = {
  data: Array<Program_Assignees_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Program_Assignees_On_Conflict>;
};

/** Boolean expression to filter rows from the table "program_assignees". All fields are combined with a logical 'AND'. */
export type Program_Assignees_Bool_Exp = {
  _and?: InputMaybe<Array<Program_Assignees_Bool_Exp>>;
  _not?: InputMaybe<Program_Assignees_Bool_Exp>;
  _or?: InputMaybe<Array<Program_Assignees_Bool_Exp>>;
  program?: InputMaybe<Programs_Bool_Exp>;
  program_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "program_assignees" */
export enum Program_Assignees_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProgramAssigneesPkey = 'program_assignees_pkey',
  /** unique or primary key constraint on columns "user_id", "program_id" */
  ProgramAssigneesProgramIdUserIdKey = 'program_assignees_program_id_user_id_key',
}

/** input type for inserting data into table "program_assignees" */
export type Program_Assignees_Insert_Input = {
  program?: InputMaybe<Programs_Obj_Rel_Insert_Input>;
  program_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "program_assignees" */
export type Program_Assignees_Max_Order_By = {
  program_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "program_assignees" */
export type Program_Assignees_Min_Order_By = {
  program_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "program_assignees" */
export type Program_Assignees_Mutation_Response = {
  __typename?: 'program_assignees_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Program_Assignees>;
};

/** on_conflict condition type for table "program_assignees" */
export type Program_Assignees_On_Conflict = {
  constraint: Program_Assignees_Constraint;
  update_columns?: Array<Program_Assignees_Update_Column>;
  where?: InputMaybe<Program_Assignees_Bool_Exp>;
};

/** Ordering options when selecting data from "program_assignees". */
export type Program_Assignees_Order_By = {
  program?: InputMaybe<Programs_Order_By>;
  program_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "program_assignees" */
export enum Program_Assignees_Select_Column {
  /** column name */
  ProgramId = 'program_id',
  /** column name */
  UserId = 'user_id',
}

/** placeholder for update columns of table "program_assignees" (current role has no relevant permissions) */
export enum Program_Assignees_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "program_controls" */
export type Program_Controls = {
  __typename?: 'program_controls';
  /** An object relationship */
  control?: Maybe<Controls>;
  control_id: Scalars['uuid']['output'];
  /** An object relationship */
  program?: Maybe<Programs>;
  program_id: Scalars['uuid']['output'];
};

/** aggregated selection of "program_controls" */
export type Program_Controls_Aggregate = {
  __typename?: 'program_controls_aggregate';
  aggregate?: Maybe<Program_Controls_Aggregate_Fields>;
  nodes: Array<Program_Controls>;
};

export type Program_Controls_Aggregate_Bool_Exp = {
  count?: InputMaybe<Program_Controls_Aggregate_Bool_Exp_Count>;
};

export type Program_Controls_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Program_Controls_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Program_Controls_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "program_controls" */
export type Program_Controls_Aggregate_Fields = {
  __typename?: 'program_controls_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Program_Controls_Max_Fields>;
  min?: Maybe<Program_Controls_Min_Fields>;
};

/** aggregate fields of "program_controls" */
export type Program_Controls_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Program_Controls_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "program_controls" */
export type Program_Controls_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Program_Controls_Max_Order_By>;
  min?: InputMaybe<Program_Controls_Min_Order_By>;
};

/** input type for inserting array relation for remote table "program_controls" */
export type Program_Controls_Arr_Rel_Insert_Input = {
  data: Array<Program_Controls_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Program_Controls_On_Conflict>;
};

/** Boolean expression to filter rows from the table "program_controls". All fields are combined with a logical 'AND'. */
export type Program_Controls_Bool_Exp = {
  _and?: InputMaybe<Array<Program_Controls_Bool_Exp>>;
  _not?: InputMaybe<Program_Controls_Bool_Exp>;
  _or?: InputMaybe<Array<Program_Controls_Bool_Exp>>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  program?: InputMaybe<Programs_Bool_Exp>;
  program_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "program_controls" */
export enum Program_Controls_Constraint {
  /** unique or primary key constraint on columns "program_id", "control_id" */
  ProgramOrganizationControlsPkey = 'program_organization_controls_pkey',
}

/** input type for inserting data into table "program_controls" */
export type Program_Controls_Insert_Input = {
  control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  program?: InputMaybe<Programs_Obj_Rel_Insert_Input>;
  program_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Program_Controls_Max_Fields = {
  __typename?: 'program_controls_max_fields';
  control_id?: Maybe<Scalars['uuid']['output']>;
  program_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "program_controls" */
export type Program_Controls_Max_Order_By = {
  control_id?: InputMaybe<Order_By>;
  program_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Program_Controls_Min_Fields = {
  __typename?: 'program_controls_min_fields';
  control_id?: Maybe<Scalars['uuid']['output']>;
  program_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "program_controls" */
export type Program_Controls_Min_Order_By = {
  control_id?: InputMaybe<Order_By>;
  program_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "program_controls" */
export type Program_Controls_Mutation_Response = {
  __typename?: 'program_controls_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Program_Controls>;
};

/** on_conflict condition type for table "program_controls" */
export type Program_Controls_On_Conflict = {
  constraint: Program_Controls_Constraint;
  update_columns?: Array<Program_Controls_Update_Column>;
  where?: InputMaybe<Program_Controls_Bool_Exp>;
};

/** Ordering options when selecting data from "program_controls". */
export type Program_Controls_Order_By = {
  control?: InputMaybe<Controls_Order_By>;
  control_id?: InputMaybe<Order_By>;
  program?: InputMaybe<Programs_Order_By>;
  program_id?: InputMaybe<Order_By>;
};

/** select columns of table "program_controls" */
export enum Program_Controls_Select_Column {
  /** column name */
  ControlId = 'control_id',
  /** column name */
  ProgramId = 'program_id',
}

/** placeholder for update columns of table "program_controls" (current role has no relevant permissions) */
export enum Program_Controls_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** Determines which custom field is shown in a control belonging to a program */
export type Program_Field_Configs = {
  __typename?: 'program_field_configs';
  created_at: Scalars['timestamptz']['output'];
  entity_name: Scalars['String']['output'];
  /** An object relationship */
  field_config?: Maybe<Field_Configs>;
  field_config_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  program: Programs;
  program_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "program_field_configs" */
export type Program_Field_Configs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Program_Field_Configs_Max_Order_By>;
  min?: InputMaybe<Program_Field_Configs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "program_field_configs" */
export type Program_Field_Configs_Arr_Rel_Insert_Input = {
  data: Array<Program_Field_Configs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Program_Field_Configs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "program_field_configs". All fields are combined with a logical 'AND'. */
export type Program_Field_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<Program_Field_Configs_Bool_Exp>>;
  _not?: InputMaybe<Program_Field_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<Program_Field_Configs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entity_name?: InputMaybe<String_Comparison_Exp>;
  field_config?: InputMaybe<Field_Configs_Bool_Exp>;
  field_config_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  program?: InputMaybe<Programs_Bool_Exp>;
  program_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "program_field_configs" */
export enum Program_Field_Configs_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProgramFieldConfigsPkey = 'program_field_configs_pkey',
  /** unique or primary key constraint on columns "field_config_id", "program_id" */
  ProgramFieldConfigsProgramIdFieldConfigIdKey = 'program_field_configs_program_id_field_config_id_key',
}

/** input type for inserting data into table "program_field_configs" */
export type Program_Field_Configs_Insert_Input = {
  field_config?: InputMaybe<Field_Configs_Obj_Rel_Insert_Input>;
  field_config_id?: InputMaybe<Scalars['uuid']['input']>;
  program?: InputMaybe<Programs_Obj_Rel_Insert_Input>;
  program_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "program_field_configs" */
export type Program_Field_Configs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_name?: InputMaybe<Order_By>;
  field_config_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  program_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "program_field_configs" */
export type Program_Field_Configs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_name?: InputMaybe<Order_By>;
  field_config_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  program_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "program_field_configs" */
export type Program_Field_Configs_Mutation_Response = {
  __typename?: 'program_field_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Program_Field_Configs>;
};

/** on_conflict condition type for table "program_field_configs" */
export type Program_Field_Configs_On_Conflict = {
  constraint: Program_Field_Configs_Constraint;
  update_columns?: Array<Program_Field_Configs_Update_Column>;
  where?: InputMaybe<Program_Field_Configs_Bool_Exp>;
};

/** Ordering options when selecting data from "program_field_configs". */
export type Program_Field_Configs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_name?: InputMaybe<Order_By>;
  field_config?: InputMaybe<Field_Configs_Order_By>;
  field_config_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  program?: InputMaybe<Programs_Order_By>;
  program_id?: InputMaybe<Order_By>;
};

/** select columns of table "program_field_configs" */
export enum Program_Field_Configs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityName = 'entity_name',
  /** column name */
  FieldConfigId = 'field_config_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProgramId = 'program_id',
}

/** placeholder for update columns of table "program_field_configs" (current role has no relevant permissions) */
export enum Program_Field_Configs_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "programs" */
export type Programs = {
  __typename?: 'programs';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  framework?: Maybe<Frameworks>;
  framework_id?: Maybe<Scalars['uuid']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  program_assignees: Array<Program_Assignees>;
  /** An array relationship */
  program_controls: Array<Program_Controls>;
  /** An aggregate relationship */
  program_controls_aggregate: Program_Controls_Aggregate;
  /** An array relationship */
  program_field_configs: Array<Program_Field_Configs>;
  /** An array relationship */
  programs_vector_stores: Array<Ai_Programs_Vector_Store>;
  similarity?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  template_framework?: Maybe<Template_Frameworks>;
  template_framework_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
};

/** columns and relationships of "programs" */
export type ProgramsProgram_AssigneesArgs = {
  distinct_on?: InputMaybe<Array<Program_Assignees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Program_Assignees_Order_By>>;
  where?: InputMaybe<Program_Assignees_Bool_Exp>;
};

/** columns and relationships of "programs" */
export type ProgramsProgram_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Program_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Program_Controls_Order_By>>;
  where?: InputMaybe<Program_Controls_Bool_Exp>;
};

/** columns and relationships of "programs" */
export type ProgramsProgram_Controls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Program_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Program_Controls_Order_By>>;
  where?: InputMaybe<Program_Controls_Bool_Exp>;
};

/** columns and relationships of "programs" */
export type ProgramsProgram_Field_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Program_Field_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Program_Field_Configs_Order_By>>;
  where?: InputMaybe<Program_Field_Configs_Bool_Exp>;
};

/** columns and relationships of "programs" */
export type ProgramsPrograms_Vector_StoresArgs = {
  distinct_on?: InputMaybe<Array<Ai_Programs_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Programs_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Programs_Vector_Store_Bool_Exp>;
};

/** order by aggregate values of table "programs" */
export type Programs_Aggregate_Order_By = {
  avg?: InputMaybe<Programs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Programs_Max_Order_By>;
  min?: InputMaybe<Programs_Min_Order_By>;
  stddev?: InputMaybe<Programs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Programs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Programs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Programs_Sum_Order_By>;
  var_pop?: InputMaybe<Programs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Programs_Var_Samp_Order_By>;
  variance?: InputMaybe<Programs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "programs" */
export type Programs_Arr_Rel_Insert_Input = {
  data: Array<Programs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Programs_On_Conflict>;
};

/** order by avg() on columns of table "programs" */
export type Programs_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "programs". All fields are combined with a logical 'AND'. */
export type Programs_Bool_Exp = {
  _and?: InputMaybe<Array<Programs_Bool_Exp>>;
  _not?: InputMaybe<Programs_Bool_Exp>;
  _or?: InputMaybe<Array<Programs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  framework?: InputMaybe<Frameworks_Bool_Exp>;
  framework_id?: InputMaybe<Uuid_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  program_assignees?: InputMaybe<Program_Assignees_Bool_Exp>;
  program_controls?: InputMaybe<Program_Controls_Bool_Exp>;
  program_controls_aggregate?: InputMaybe<Program_Controls_Aggregate_Bool_Exp>;
  program_field_configs?: InputMaybe<Program_Field_Configs_Bool_Exp>;
  programs_vector_stores?: InputMaybe<Ai_Programs_Vector_Store_Bool_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  template_framework?: InputMaybe<Template_Frameworks_Bool_Exp>;
  template_framework_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "programs" */
export enum Programs_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProgramsIdKey = 'programs_id_key',
  /** unique or primary key constraint on columns "id" */
  ProgramsPkey = 'programs_pkey',
}

/** input type for inserting data into table "programs" */
export type Programs_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  framework?: InputMaybe<Frameworks_Obj_Rel_Insert_Input>;
  framework_id?: InputMaybe<Scalars['uuid']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  program_assignees?: InputMaybe<Program_Assignees_Arr_Rel_Insert_Input>;
  program_controls?: InputMaybe<Program_Controls_Arr_Rel_Insert_Input>;
  program_field_configs?: InputMaybe<Program_Field_Configs_Arr_Rel_Insert_Input>;
  template_framework_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "programs" */
export type Programs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  framework_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  template_framework_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "programs" */
export type Programs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  framework_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  template_framework_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "programs" */
export type Programs_Mutation_Response = {
  __typename?: 'programs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Programs>;
};

/** input type for inserting object relation for remote table "programs" */
export type Programs_Obj_Rel_Insert_Input = {
  data: Programs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Programs_On_Conflict>;
};

/** on_conflict condition type for table "programs" */
export type Programs_On_Conflict = {
  constraint: Programs_Constraint;
  update_columns?: Array<Programs_Update_Column>;
  where?: InputMaybe<Programs_Bool_Exp>;
};

/** Ordering options when selecting data from "programs". */
export type Programs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  framework?: InputMaybe<Frameworks_Order_By>;
  framework_id?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  program_assignees_aggregate?: InputMaybe<Program_Assignees_Aggregate_Order_By>;
  program_controls_aggregate?: InputMaybe<Program_Controls_Aggregate_Order_By>;
  program_field_configs_aggregate?: InputMaybe<Program_Field_Configs_Aggregate_Order_By>;
  programs_vector_stores_aggregate?: InputMaybe<Ai_Programs_Vector_Store_Aggregate_Order_By>;
  similarity?: InputMaybe<Order_By>;
  template_framework?: InputMaybe<Template_Frameworks_Order_By>;
  template_framework_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: programs */
export type Programs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "programs" */
export enum Programs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  FrameworkId = 'framework_id',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  TemplateFrameworkId = 'template_framework_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "programs" */
export type Programs_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "programs" */
export type Programs_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "programs" */
export type Programs_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "programs" */
export type Programs_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "programs" */
export type Programs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Programs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Programs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  framework_id?: InputMaybe<Scalars['uuid']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  similarity?: InputMaybe<Scalars['float8']['input']>;
  template_framework_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "programs" */
export type Programs_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** update columns of table "programs" */
export enum Programs_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Programs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Programs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Programs_Bool_Exp;
};

/** order by var_pop() on columns of table "programs" */
export type Programs_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "programs" */
export type Programs_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "programs" */
export type Programs_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** An array relationship */
  agent_instances: Array<Agent_Instances>;
  /** fetch data from the table: "agent_instances" using primary key columns */
  agent_instances_by_pk?: Maybe<Agent_Instances>;
  /** execute function "ai.control_evidences_suggestions" which returns "evidences" */
  ai_control_evidences_suggestions: Array<Evidences>;
  /** execute function "ai.control_evidences_suggestions" and query aggregates on result of table type "evidences" */
  ai_control_evidences_suggestions_aggregate: Evidences_Aggregate;
  /** execute function "ai.control_evidences_suggestions_with_chunks" which returns "ai.evidence_suggestion_chunk" */
  ai_control_evidences_suggestions_with_chunks: Array<Ai_Evidence_Suggestion_Chunk>;
  /** AI controls suggestions for evidence */
  ai_control_suggestions_for_evidence?: Maybe<AiEvidenceControlSuggestionsOutput>;
  /** ai_control_suggestions_for_risk */
  ai_control_suggestions_for_risk?: Maybe<AiRiskControlSuggestionsOutput>;
  /** execute function "ai.controls_text_search" which returns "controls" */
  ai_controls_text_search: Array<Controls>;
  /** execute function "ai.controls_text_search" and query aggregates on result of table type "controls" */
  ai_controls_text_search_aggregate: Controls_Aggregate;
  /** execute function "ai.controls_vector_store_search" which returns "controls" */
  ai_controls_vector_store_search: Array<Controls>;
  /** execute function "ai.controls_vector_store_search" and query aggregates on result of table type "controls" */
  ai_controls_vector_store_search_aggregate: Controls_Aggregate;
  /** execute function "ai.documents_text_search" which returns "documents" */
  ai_documents_text_search: Array<Documents>;
  /** fetch data from the table: "ai.documents_vector_store" */
  ai_documents_vector_store: Array<Ai_Documents_Vector_Store>;
  /** fetch data from the table: "ai.documents_vector_store" using primary key columns */
  ai_documents_vector_store_by_pk?: Maybe<Ai_Documents_Vector_Store>;
  /** execute function "ai.documents_vector_store_search" which returns "ai.documents_vector_store" */
  ai_documents_vector_store_search: Array<Ai_Documents_Vector_Store>;
  /** execute function "ai.evidence_controls_suggestions" which returns "controls" */
  ai_evidence_controls_suggestions: Array<Controls>;
  /** execute function "ai.evidence_controls_suggestions" and query aggregates on result of table type "controls" */
  ai_evidence_controls_suggestions_aggregate: Controls_Aggregate;
  /** ai_evidence_suggestions_for_control */
  ai_evidence_suggestions_for_control?: Maybe<AiControlEvidenceSuggestionsOutput>;
  /** execute function "ai.evidences_text_search" which returns "evidences" */
  ai_evidences_text_search: Array<Evidences>;
  /** execute function "ai.evidences_text_search" and query aggregates on result of table type "evidences" */
  ai_evidences_text_search_aggregate: Evidences_Aggregate;
  /** execute function "ai.evidences_vector_store_search" which returns "ai.evidences_vector_store" */
  ai_evidences_vector_store_search: Array<Ai_Evidences_Vector_Store>;
  /** execute function "ai.policies_text_search" which returns "policies" */
  ai_policies_text_search: Array<Policies>;
  /** fetch data from the table: "ai.policies_vector_store" */
  ai_policies_vector_store: Array<Ai_Policies_Vector_Store>;
  /** fetch data from the table: "ai.policies_vector_store" using primary key columns */
  ai_policies_vector_store_by_pk?: Maybe<Ai_Policies_Vector_Store>;
  /** execute function "ai.policies_vector_store_search" which returns "ai.policies_vector_store" */
  ai_policies_vector_store_search: Array<Ai_Policies_Vector_Store>;
  /** execute function "ai.programs_text_search" which returns "programs" */
  ai_programs_text_search: Array<Programs>;
  /** execute function "ai.programs_vector_store_search" which returns "programs" */
  ai_programs_vector_store_search: Array<Programs>;
  /** execute function "ai.relevant_policy_controls" which returns "controls" */
  ai_relevant_policy_controls: Array<Controls>;
  /** execute function "ai.relevant_policy_controls" and query aggregates on result of table type "controls" */
  ai_relevant_policy_controls_aggregate: Controls_Aggregate;
  /** execute function "ai.risk_controls_suggestions" which returns "controls" */
  ai_risk_controls_suggestions: Array<Controls>;
  /** execute function "ai.risk_controls_suggestions" and query aggregates on result of table type "controls" */
  ai_risk_controls_suggestions_aggregate: Controls_Aggregate;
  /** execute function "ai.risks_text_search" which returns "risks" */
  ai_risks_text_search: Array<Risks>;
  /** execute function "ai.risks_text_search" and query aggregates on result of table type "risks" */
  ai_risks_text_search_aggregate: Risks_Aggregate;
  /** execute function "ai.risks_vector_store_search" which returns "risks" */
  ai_risks_vector_store_search: Array<Risks>;
  /** execute function "ai.risks_vector_store_search" and query aggregates on result of table type "risks" */
  ai_risks_vector_store_search_aggregate: Risks_Aggregate;
  /** execute function "ai.tasks_text_search" which returns "tasks" */
  ai_tasks_text_search: Array<Tasks>;
  /** execute function "ai.tasks_text_search" and query aggregates on result of table type "tasks" */
  ai_tasks_text_search_aggregate: Tasks_Aggregate;
  /** execute function "ai.tasks_vector_store_search" which returns "tasks" */
  ai_tasks_vector_store_search: Array<Tasks>;
  /** execute function "ai.tasks_vector_store_search" and query aggregates on result of table type "tasks" */
  ai_tasks_vector_store_search_aggregate: Tasks_Aggregate;
  /** execute function "ai.vendors_text_search" which returns "vendors" */
  ai_vendors_text_search: Array<Vendors>;
  /** execute function "ai.vendors_text_search" and query aggregates on result of table type "vendors" */
  ai_vendors_text_search_aggregate: Vendors_Aggregate;
  /** execute function "ai.vendors_vector_store_search" which returns "vendors" */
  ai_vendors_vector_store_search: Array<Vendors>;
  /** execute function "ai.vendors_vector_store_search" and query aggregates on result of table type "vendors" */
  ai_vendors_vector_store_search_aggregate: Vendors_Aggregate;
  /** fetch data from the table: "api_key_usage_logs" */
  api_key_usage_logs: Array<Api_Key_Usage_Logs>;
  /** fetch aggregated fields from the table: "api_key_usage_logs" */
  api_key_usage_logs_aggregate: Api_Key_Usage_Logs_Aggregate;
  /** fetch data from the table: "api_key_usage_logs" using primary key columns */
  api_key_usage_logs_by_pk?: Maybe<Api_Key_Usage_Logs>;
  /** fetch data from the table: "audit.control_history" */
  audit_control_history: Array<Audit_Control_History>;
  /** fetch data from the table: "audit.evidence_history" */
  audit_evidence_history: Array<Audit_Evidence_History>;
  /** fetch data from the table: "audit.evidence_history" using primary key columns */
  audit_evidence_history_by_pk?: Maybe<Audit_Evidence_History>;
  /** fetch data from the table: "audit.finding_history" */
  audit_finding_history: Array<Audit_Finding_History>;
  /** fetch aggregated fields from the table: "audit.finding_history" */
  audit_finding_history_aggregate: Audit_Finding_History_Aggregate;
  /** fetch data from the table: "audit.finding_history" using primary key columns */
  audit_finding_history_by_pk?: Maybe<Audit_Finding_History>;
  /** fetch data from the table: "audit.policy_history" */
  audit_policy_history: Array<Audit_Policy_History>;
  /** fetch data from the table: "audit.policy_history" using primary key columns */
  audit_policy_history_by_pk?: Maybe<Audit_Policy_History>;
  /** fetch data from the table: "audit.risk_history" */
  audit_risk_history: Array<Audit_Risk_History>;
  /** fetch data from the table: "audit.task_history" */
  audit_task_history: Array<Audit_Task_History>;
  /** fetch data from the table: "audit.vendor_history" */
  audit_vendor_history: Array<Audit_Vendor_History>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** An array relationship */
  categories: Array<Categories>;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>;
  /** An array relationship */
  client_questionnaire_questions: Array<Client_Questionnaire_Questions>;
  /** An aggregate relationship */
  client_questionnaire_questions_aggregate: Client_Questionnaire_Questions_Aggregate;
  /** fetch data from the table: "client_questionnaire_questions" using primary key columns */
  client_questionnaire_questions_by_pk?: Maybe<Client_Questionnaire_Questions>;
  /** An array relationship */
  client_questionnaires: Array<Client_Questionnaires>;
  /** fetch data from the table: "client_questionnaires" using primary key columns */
  client_questionnaires_by_pk?: Maybe<Client_Questionnaires>;
  /** An array relationship */
  control_categories: Array<Control_Categories>;
  /** An array relationship */
  control_criteria: Array<Control_Criteria>;
  /** An array relationship */
  control_findings: Array<Control_Findings>;
  /** fetch data from the table: "control_findings" using primary key columns */
  control_findings_by_pk?: Maybe<Control_Findings>;
  /** An array relationship */
  control_groups: Array<Control_Groups>;
  /** An array relationship */
  control_tags: Array<Control_Tags>;
  /** An array relationship */
  controls: Array<Controls>;
  /** An aggregate relationship */
  controls_aggregate: Controls_Aggregate;
  /** fetch data from the table: "controls" using primary key columns */
  controls_by_pk?: Maybe<Controls>;
  /** An array relationship */
  criteria: Array<Criteria>;
  /** fetch data from the table: "criteria" using primary key columns */
  criteria_by_pk?: Maybe<Criteria>;
  /** fetch data from the table: "daily_control_stats_view" */
  daily_control_stats_view: Array<Daily_Control_Stats_View>;
  /** fetch data from the table: "daily_control_user_stats_view" */
  daily_control_user_stats_view: Array<Daily_Control_User_Stats_View>;
  /** fetch data from the table: "daily_risk_stats_view" */
  daily_risk_stats_view: Array<Daily_Risk_Stats_View>;
  /** An array relationship */
  documents: Array<Documents>;
  /** fetch data from the table: "documents" using primary key columns */
  documents_by_pk?: Maybe<Documents>;
  /** An array relationship */
  evidence_integrations: Array<Evidence_Integrations>;
  /** fetch data from the table: "evidence_integrations" using primary key columns */
  evidence_integrations_by_pk?: Maybe<Evidence_Integrations>;
  /** An array relationship */
  evidence_tags: Array<Evidence_Tags>;
  /** An array relationship */
  evidences: Array<Evidences>;
  /** An aggregate relationship */
  evidences_aggregate: Evidences_Aggregate;
  /** fetch data from the table: "evidences" using primary key columns */
  evidences_by_pk?: Maybe<Evidences>;
  /** An array relationship */
  field_configs: Array<Field_Configs>;
  /** fetch data from the table: "field_configs" using primary key columns */
  field_configs_by_pk?: Maybe<Field_Configs>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** fetch data from the table: "findings" */
  findings: Array<Findings>;
  /** fetch aggregated fields from the table: "findings" */
  findings_aggregate: Findings_Aggregate;
  /** fetch data from the table: "findings" using primary key columns */
  findings_by_pk?: Maybe<Findings>;
  /** An array relationship */
  frameworks: Array<Frameworks>;
  /** fetch data from the table: "frameworks" using primary key columns */
  frameworks_by_pk?: Maybe<Frameworks>;
  /** An array relationship */
  frameworks_controls: Array<Frameworks_Controls>;
  /** fetch data from the table: "frameworks_controls" using primary key columns */
  frameworks_controls_by_pk?: Maybe<Frameworks_Controls>;
  /** Execute a global search */
  global_search?: Maybe<SearchOutput>;
  /** An array relationship */
  groups: Array<Groups>;
  /** fetch data from the table: "groups" using primary key columns */
  groups_by_pk?: Maybe<Groups>;
  /** fetch data from the table: "grove.agents" */
  grove_agents: Array<Grove_Agents>;
  /** fetch data from the table: "grove.agents" using primary key columns */
  grove_agents_by_pk?: Maybe<Grove_Agents>;
  /** fetch data from the table: "grove.chats" */
  grove_chats: Array<Grove_Chats>;
  /** fetch aggregated fields from the table: "grove.chats" */
  grove_chats_aggregate: Grove_Chats_Aggregate;
  /** fetch data from the table: "grove.chats" using primary key columns */
  grove_chats_by_pk?: Maybe<Grove_Chats>;
  /** fetch data from the table: "grove.messages" */
  grove_messages: Array<Grove_Messages>;
  /** fetch aggregated fields from the table: "grove.messages" */
  grove_messages_aggregate: Grove_Messages_Aggregate;
  /** fetch data from the table: "grove.messages" using primary key columns */
  grove_messages_by_pk?: Maybe<Grove_Messages>;
  /** An array relationship */
  integration_runs: Array<Integration_Runs>;
  /** An aggregate relationship */
  integration_runs_aggregate: Integration_Runs_Aggregate;
  /** fetch data from the table: "integrations" */
  integrations: Array<Integrations>;
  /** fetch data from the table: "integrations" using primary key columns */
  integrations_by_pk?: Maybe<Integrations>;
  /** An array relationship */
  invitations: Array<Invitations>;
  /** fetch data from the table: "invitations" using primary key columns */
  invitations_by_pk?: Maybe<Invitations>;
  /** An array relationship */
  notification_disabled_settings: Array<Notification_Disabled_Settings>;
  /** fetch data from the table: "notification_disabled_settings" using primary key columns */
  notification_disabled_settings_by_pk?: Maybe<Notification_Disabled_Settings>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  org_integration_config_state?: Maybe<OrgIntegrationConfigState>;
  /** fetch data from the table: "organization_evidence_tags" */
  organization_evidence_tags: Array<Organization_Evidence_Tags>;
  /** fetch data from the table: "organization_evidence_tags" using primary key columns */
  organization_evidence_tags_by_pk?: Maybe<Organization_Evidence_Tags>;
  /** fetch data from the table: "organization_finding_severities" */
  organization_finding_severities: Array<Organization_Finding_Severities>;
  /** fetch data from the table: "organization_finding_severities" using primary key columns */
  organization_finding_severities_by_pk?: Maybe<Organization_Finding_Severities>;
  /** An array relationship */
  organization_integrations: Array<Organization_Integrations>;
  /** fetch data from the table: "organization_integrations" using primary key columns */
  organization_integrations_by_pk?: Maybe<Organization_Integrations>;
  /** fetch data from the table: "organization_risk_categories" */
  organization_risk_categories: Array<Organization_Risk_Categories>;
  /** fetch data from the table: "organization_risk_categories" using primary key columns */
  organization_risk_categories_by_pk?: Maybe<Organization_Risk_Categories>;
  /** An array relationship */
  organization_risk_levels: Array<Organization_Risk_Levels>;
  /** fetch data from the table: "organization_risk_levels" using primary key columns */
  organization_risk_levels_by_pk?: Maybe<Organization_Risk_Levels>;
  /** fetch data from the table: "organization_risk_tags" */
  organization_risk_tags: Array<Organization_Risk_Tags>;
  /** fetch data from the table: "organization_risk_tags" using primary key columns */
  organization_risk_tags_by_pk?: Maybe<Organization_Risk_Tags>;
  /** An array relationship */
  organization_template_frameworks: Array<Organization_Template_Frameworks>;
  /** fetch data from the table: "organization_template_frameworks" using primary key columns */
  organization_template_frameworks_by_pk?: Maybe<Organization_Template_Frameworks>;
  /** An array relationship */
  organization_tenants: Array<Organization_Tenants>;
  /** fetch data from the table: "organization_tenants" using primary key columns */
  organization_tenants_by_pk?: Maybe<Organization_Tenants>;
  /** An array relationship */
  organization_users: Array<Organization_Users>;
  /** fetch data from the table: "organization_users" using primary key columns */
  organization_users_by_pk?: Maybe<Organization_Users>;
  /** fetch data from the table: "organization_vendor_risk_levels" */
  organization_vendor_risk_levels: Array<Organization_Vendor_Risk_Levels>;
  /** fetch data from the table: "organization_vendor_risk_levels" using primary key columns */
  organization_vendor_risk_levels_by_pk?: Maybe<Organization_Vendor_Risk_Levels>;
  /** fetch data from the table: "organization_vendor_tiers" */
  organization_vendor_tiers: Array<Organization_Vendor_Tiers>;
  /** fetch data from the table: "organization_vendor_tiers" using primary key columns */
  organization_vendor_tiers_by_pk?: Maybe<Organization_Vendor_Tiers>;
  /** An array relationship */
  organizations: Array<Organizations>;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** An array relationship */
  policies: Array<Policies>;
  /** fetch data from the table: "policies" using primary key columns */
  policies_by_pk?: Maybe<Policies>;
  /** An array relationship */
  policy_approval_users: Array<Policy_Approval_Users>;
  /** fetch data from the table: "policy_approval_users" using primary key columns */
  policy_approval_users_by_pk?: Maybe<Policy_Approval_Users>;
  /** An array relationship */
  policy_integrations: Array<Policy_Integrations>;
  /** fetch data from the table: "policy_integrations" using primary key columns */
  policy_integrations_by_pk?: Maybe<Policy_Integrations>;
  /** An array relationship */
  programs: Array<Programs>;
  /** fetch data from the table: "programs" using primary key columns */
  programs_by_pk?: Maybe<Programs>;
  /** An array relationship */
  questionnaires: Array<Questionnaires>;
  /** fetch data from the table: "questionnaires" using primary key columns */
  questionnaires_by_pk?: Maybe<Questionnaires>;
  /** An array relationship */
  reports: Array<Reports>;
  /** fetch data from the table: "reports" using primary key columns */
  reports_by_pk?: Maybe<Reports>;
  /** fetch data from the table: "retained_findings" */
  retained_findings: Array<Retained_Findings>;
  /** fetch aggregated fields from the table: "retained_findings" */
  retained_findings_aggregate: Retained_Findings_Aggregate;
  /** An array relationship */
  risk_approvers: Array<Risk_Approvers>;
  /** fetch data from the table: "risk_approvers" using primary key columns */
  risk_approvers_by_pk?: Maybe<Risk_Approvers>;
  /** An array relationship */
  risk_categories: Array<Risk_Categories>;
  /** An array relationship */
  risk_impacts: Array<Risk_Impacts>;
  /** fetch data from the table: "risk_impacts" using primary key columns */
  risk_impacts_by_pk?: Maybe<Risk_Impacts>;
  /** An array relationship */
  risk_inherent_levels: Array<Risk_Inherent_Levels>;
  /** fetch data from the table: "risk_inherent_levels" using primary key columns */
  risk_inherent_levels_by_pk?: Maybe<Risk_Inherent_Levels>;
  /** An array relationship */
  risk_likelihoods: Array<Risk_Likelihoods>;
  /** fetch data from the table: "risk_likelihoods" using primary key columns */
  risk_likelihoods_by_pk?: Maybe<Risk_Likelihoods>;
  /** An array relationship */
  risk_residual_levels: Array<Risk_Residual_Levels>;
  /** fetch data from the table: "risk_residual_levels" using primary key columns */
  risk_residual_levels_by_pk?: Maybe<Risk_Residual_Levels>;
  /** An array relationship */
  risk_tags: Array<Risk_Tags>;
  /** An array relationship */
  risks: Array<Risks>;
  /** An aggregate relationship */
  risks_aggregate: Risks_Aggregate;
  /** fetch data from the table: "risks" using primary key columns */
  risks_by_pk?: Maybe<Risks>;
  /** An array relationship */
  role_permissions: Array<Role_Permissions>;
  /** fetch data from the table: "role_permissions" using primary key columns */
  role_permissions_by_pk?: Maybe<Role_Permissions>;
  /** An array relationship */
  roles: Array<Roles>;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table: "service_accounts" */
  service_accounts: Array<Service_Accounts>;
  /** fetch aggregated fields from the table: "service_accounts" */
  service_accounts_aggregate: Service_Accounts_Aggregate;
  /** fetch data from the table: "service_accounts" using primary key columns */
  service_accounts_by_pk?: Maybe<Service_Accounts>;
  sharepoint_file_metadata?: Maybe<SharepointFileMetadata>;
  /** An array relationship */
  tags: Array<Tags>;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** An array relationship */
  tasks: Array<Tasks>;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: Maybe<Tasks>;
  /** An array relationship */
  team_members: Array<Team_Members>;
  /** An aggregate relationship */
  team_members_aggregate: Team_Members_Aggregate;
  /** fetch data from the table: "team_members" using primary key columns */
  team_members_by_pk?: Maybe<Team_Members>;
  /** An array relationship */
  teams: Array<Teams>;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** fetch data from the table: "template_controls" */
  template_controls: Array<Template_Controls>;
  /** fetch aggregated fields from the table: "template_controls" */
  template_controls_aggregate: Template_Controls_Aggregate;
  /** fetch data from the table: "template_controls" using primary key columns */
  template_controls_by_pk?: Maybe<Template_Controls>;
  /** fetch data from the table: "template_frameworks" */
  template_frameworks: Array<Template_Frameworks>;
  /** fetch data from the table: "template_frameworks" using primary key columns */
  template_frameworks_by_pk?: Maybe<Template_Frameworks>;
  /** An array relationship */
  template_frameworks_controls: Array<Template_Frameworks_Controls>;
  /** fetch data from the table: "template_frameworks_controls" using primary key columns */
  template_frameworks_controls_by_pk?: Maybe<Template_Frameworks_Controls>;
  /** An array relationship */
  template_tasks: Array<Template_Tasks>;
  /** An aggregate relationship */
  template_tasks_aggregate: Template_Tasks_Aggregate;
  /** fetch data from the table: "template_tasks" using primary key columns */
  template_tasks_by_pk?: Maybe<Template_Tasks>;
  /** fetch data from the table: "trust_portal.categories" */
  trust_portal_categories: Array<Trust_Portal_Categories>;
  /** fetch data from the table: "trust_portal.categories" using primary key columns */
  trust_portal_categories_by_pk?: Maybe<Trust_Portal_Categories>;
  trust_portal_nda_gate_provider_data: TrustPortalNdaGateProviderDataOutput;
  /** fetch data from the table: "trust_portal.resource_sections" */
  trust_portal_resource_sections: Array<Trust_Portal_Resource_Sections>;
  /** fetch data from the table: "trust_portal.resource_sections" using primary key columns */
  trust_portal_resource_sections_by_pk?: Maybe<Trust_Portal_Resource_Sections>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** fetch data from the table: "user_controls_stats_view" */
  user_controls_stats_view: Array<User_Controls_Stats_View>;
  /** An array relationship */
  user_notifications: Array<User_Notifications>;
  /** An aggregate relationship */
  user_notifications_aggregate: User_Notifications_Aggregate;
  /** fetch data from the table: "user_notifications" using primary key columns */
  user_notifications_by_pk?: Maybe<User_Notifications>;
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** fetch data from the table: "user_tasks_stats_view" */
  user_tasks_stats_view: Array<User_Tasks_Stats_View>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** An array relationship */
  vendor_approvers: Array<Vendor_Approvers>;
  /** fetch data from the table: "vendor_approvers" using primary key columns */
  vendor_approvers_by_pk?: Maybe<Vendor_Approvers>;
  /** fetch data from the table: "vendor_questionnaire_schedules" */
  vendor_questionnaire_schedules: Array<Vendor_Questionnaire_Schedules>;
  /** fetch data from the table: "vendor_questionnaire_schedules" using primary key columns */
  vendor_questionnaire_schedules_by_pk?: Maybe<Vendor_Questionnaire_Schedules>;
  /** An array relationship */
  vendor_questionnaires: Array<Vendor_Questionnaires>;
  /** fetch data from the table: "vendor_questionnaires" using primary key columns */
  vendor_questionnaires_by_pk?: Maybe<Vendor_Questionnaires>;
  /** An array relationship */
  vendors: Array<Vendors>;
  /** An aggregate relationship */
  vendors_aggregate: Vendors_Aggregate;
  /** fetch data from the table: "vendors" using primary key columns */
  vendors_by_pk?: Maybe<Vendors>;
  /** An array relationship */
  vq_custom_fields: Array<Vq_Custom_Fields>;
  /** fetch data from the table: "vq_custom_fields" using primary key columns */
  vq_custom_fields_by_pk?: Maybe<Vq_Custom_Fields>;
};

export type Query_RootAgent_InstancesArgs = {
  distinct_on?: InputMaybe<Array<Agent_Instances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Instances_Order_By>>;
  where?: InputMaybe<Agent_Instances_Bool_Exp>;
};

export type Query_RootAgent_Instances_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootAi_Control_Evidences_SuggestionsArgs = {
  args: Ai_Control_Evidences_Suggestions_Args;
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

export type Query_RootAi_Control_Evidences_Suggestions_AggregateArgs = {
  args: Ai_Control_Evidences_Suggestions_Args;
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

export type Query_RootAi_Control_Evidences_Suggestions_With_ChunksArgs = {
  args: Ai_Control_Evidences_Suggestions_With_Chunks_Args;
  distinct_on?: InputMaybe<Array<Ai_Evidence_Suggestion_Chunk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Evidence_Suggestion_Chunk_Order_By>>;
  where?: InputMaybe<Ai_Evidence_Suggestion_Chunk_Bool_Exp>;
};

export type Query_RootAi_Control_Suggestions_For_EvidenceArgs = {
  input: AiEvidenceControlSuggestionsInput;
};

export type Query_RootAi_Control_Suggestions_For_RiskArgs = {
  input: AiRiskControlSuggestionsInput;
};

export type Query_RootAi_Controls_Text_SearchArgs = {
  args: Ai_Controls_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Query_RootAi_Controls_Text_Search_AggregateArgs = {
  args: Ai_Controls_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Query_RootAi_Controls_Vector_Store_SearchArgs = {
  args: Ai_Controls_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Query_RootAi_Controls_Vector_Store_Search_AggregateArgs = {
  args: Ai_Controls_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Query_RootAi_Documents_Text_SearchArgs = {
  args: Ai_Documents_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};

export type Query_RootAi_Documents_Vector_StoreArgs = {
  distinct_on?: InputMaybe<Array<Ai_Documents_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Documents_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Documents_Vector_Store_Bool_Exp>;
};

export type Query_RootAi_Documents_Vector_Store_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootAi_Documents_Vector_Store_SearchArgs = {
  args: Ai_Documents_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Ai_Documents_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Documents_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Documents_Vector_Store_Bool_Exp>;
};

export type Query_RootAi_Evidence_Controls_SuggestionsArgs = {
  args: Ai_Evidence_Controls_Suggestions_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Query_RootAi_Evidence_Controls_Suggestions_AggregateArgs = {
  args: Ai_Evidence_Controls_Suggestions_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Query_RootAi_Evidence_Suggestions_For_ControlArgs = {
  input: AiControlEvidenceSuggestionsInput;
};

export type Query_RootAi_Evidences_Text_SearchArgs = {
  args: Ai_Evidences_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

export type Query_RootAi_Evidences_Text_Search_AggregateArgs = {
  args: Ai_Evidences_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

export type Query_RootAi_Evidences_Vector_Store_SearchArgs = {
  args: Ai_Evidences_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Ai_Evidences_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Evidences_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Evidences_Vector_Store_Bool_Exp>;
};

export type Query_RootAi_Policies_Text_SearchArgs = {
  args: Ai_Policies_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policies_Order_By>>;
  where?: InputMaybe<Policies_Bool_Exp>;
};

export type Query_RootAi_Policies_Vector_StoreArgs = {
  distinct_on?: InputMaybe<Array<Ai_Policies_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Policies_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Policies_Vector_Store_Bool_Exp>;
};

export type Query_RootAi_Policies_Vector_Store_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootAi_Policies_Vector_Store_SearchArgs = {
  args: Ai_Policies_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Ai_Policies_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Policies_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Policies_Vector_Store_Bool_Exp>;
};

export type Query_RootAi_Programs_Text_SearchArgs = {
  args: Ai_Programs_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Programs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programs_Order_By>>;
  where?: InputMaybe<Programs_Bool_Exp>;
};

export type Query_RootAi_Programs_Vector_Store_SearchArgs = {
  args: Ai_Programs_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Programs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programs_Order_By>>;
  where?: InputMaybe<Programs_Bool_Exp>;
};

export type Query_RootAi_Relevant_Policy_ControlsArgs = {
  args: Ai_Relevant_Policy_Controls_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Query_RootAi_Relevant_Policy_Controls_AggregateArgs = {
  args: Ai_Relevant_Policy_Controls_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Query_RootAi_Risk_Controls_SuggestionsArgs = {
  args: Ai_Risk_Controls_Suggestions_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Query_RootAi_Risk_Controls_Suggestions_AggregateArgs = {
  args: Ai_Risk_Controls_Suggestions_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Query_RootAi_Risks_Text_SearchArgs = {
  args: Ai_Risks_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

export type Query_RootAi_Risks_Text_Search_AggregateArgs = {
  args: Ai_Risks_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

export type Query_RootAi_Risks_Vector_Store_SearchArgs = {
  args: Ai_Risks_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

export type Query_RootAi_Risks_Vector_Store_Search_AggregateArgs = {
  args: Ai_Risks_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

export type Query_RootAi_Tasks_Text_SearchArgs = {
  args: Ai_Tasks_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

export type Query_RootAi_Tasks_Text_Search_AggregateArgs = {
  args: Ai_Tasks_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

export type Query_RootAi_Tasks_Vector_Store_SearchArgs = {
  args: Ai_Tasks_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

export type Query_RootAi_Tasks_Vector_Store_Search_AggregateArgs = {
  args: Ai_Tasks_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

export type Query_RootAi_Vendors_Text_SearchArgs = {
  args: Ai_Vendors_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

export type Query_RootAi_Vendors_Text_Search_AggregateArgs = {
  args: Ai_Vendors_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

export type Query_RootAi_Vendors_Vector_Store_SearchArgs = {
  args: Ai_Vendors_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

export type Query_RootAi_Vendors_Vector_Store_Search_AggregateArgs = {
  args: Ai_Vendors_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

export type Query_RootApi_Key_Usage_LogsArgs = {
  distinct_on?: InputMaybe<Array<Api_Key_Usage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Key_Usage_Logs_Order_By>>;
  where?: InputMaybe<Api_Key_Usage_Logs_Bool_Exp>;
};

export type Query_RootApi_Key_Usage_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Api_Key_Usage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Key_Usage_Logs_Order_By>>;
  where?: InputMaybe<Api_Key_Usage_Logs_Bool_Exp>;
};

export type Query_RootApi_Key_Usage_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootAudit_Control_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Control_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Control_History_Order_By>>;
  where?: InputMaybe<Audit_Control_History_Bool_Exp>;
};

export type Query_RootAudit_Evidence_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Evidence_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Evidence_History_Order_By>>;
  where?: InputMaybe<Audit_Evidence_History_Bool_Exp>;
};

export type Query_RootAudit_Evidence_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootAudit_Finding_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Finding_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Finding_History_Order_By>>;
  where?: InputMaybe<Audit_Finding_History_Bool_Exp>;
};

export type Query_RootAudit_Finding_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Finding_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Finding_History_Order_By>>;
  where?: InputMaybe<Audit_Finding_History_Bool_Exp>;
};

export type Query_RootAudit_Finding_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootAudit_Policy_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Policy_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Policy_History_Order_By>>;
  where?: InputMaybe<Audit_Policy_History_Bool_Exp>;
};

export type Query_RootAudit_Policy_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootAudit_Risk_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Risk_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Risk_History_Order_By>>;
  where?: InputMaybe<Audit_Risk_History_Bool_Exp>;
};

export type Query_RootAudit_Task_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Task_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Task_History_Order_By>>;
  where?: InputMaybe<Audit_Task_History_Bool_Exp>;
};

export type Query_RootAudit_Vendor_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Vendor_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Vendor_History_Order_By>>;
  where?: InputMaybe<Audit_Vendor_History_Bool_Exp>;
};

export type Query_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

export type Query_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};

export type Query_RootCategories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootClient_Questionnaire_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Client_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Client_Questionnaire_Questions_Bool_Exp>;
};

export type Query_RootClient_Questionnaire_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Client_Questionnaire_Questions_Bool_Exp>;
};

export type Query_RootClient_Questionnaire_Questions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootClient_QuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Client_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Questionnaires_Order_By>>;
  where?: InputMaybe<Client_Questionnaires_Bool_Exp>;
};

export type Query_RootClient_Questionnaires_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootControl_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Control_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Categories_Order_By>>;
  where?: InputMaybe<Control_Categories_Bool_Exp>;
};

export type Query_RootControl_CriteriaArgs = {
  distinct_on?: InputMaybe<Array<Control_Criteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Criteria_Order_By>>;
  where?: InputMaybe<Control_Criteria_Bool_Exp>;
};

export type Query_RootControl_FindingsArgs = {
  distinct_on?: InputMaybe<Array<Control_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Findings_Order_By>>;
  where?: InputMaybe<Control_Findings_Bool_Exp>;
};

export type Query_RootControl_Findings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootControl_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Control_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Groups_Order_By>>;
  where?: InputMaybe<Control_Groups_Bool_Exp>;
};

export type Query_RootControl_TagsArgs = {
  distinct_on?: InputMaybe<Array<Control_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Tags_Order_By>>;
  where?: InputMaybe<Control_Tags_Bool_Exp>;
};

export type Query_RootControlsArgs = {
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Query_RootControls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Query_RootControls_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootCriteriaArgs = {
  distinct_on?: InputMaybe<Array<Criteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Criteria_Order_By>>;
  where?: InputMaybe<Criteria_Bool_Exp>;
};

export type Query_RootCriteria_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootDaily_Control_Stats_ViewArgs = {
  distinct_on?: InputMaybe<Array<Daily_Control_Stats_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Control_Stats_View_Order_By>>;
  where?: InputMaybe<Daily_Control_Stats_View_Bool_Exp>;
};

export type Query_RootDaily_Control_User_Stats_ViewArgs = {
  distinct_on?: InputMaybe<Array<Daily_Control_User_Stats_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Control_User_Stats_View_Order_By>>;
  where?: InputMaybe<Daily_Control_User_Stats_View_Bool_Exp>;
};

export type Query_RootDaily_Risk_Stats_ViewArgs = {
  distinct_on?: InputMaybe<Array<Daily_Risk_Stats_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Risk_Stats_View_Order_By>>;
  where?: InputMaybe<Daily_Risk_Stats_View_Bool_Exp>;
};

export type Query_RootDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};

export type Query_RootDocuments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootEvidence_IntegrationsArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Integrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Integrations_Order_By>>;
  where?: InputMaybe<Evidence_Integrations_Bool_Exp>;
};

export type Query_RootEvidence_Integrations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootEvidence_TagsArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Tags_Order_By>>;
  where?: InputMaybe<Evidence_Tags_Bool_Exp>;
};

export type Query_RootEvidencesArgs = {
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

export type Query_RootEvidences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

export type Query_RootEvidences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootField_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Field_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Configs_Order_By>>;
  where?: InputMaybe<Field_Configs_Bool_Exp>;
};

export type Query_RootField_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFileArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFindingsArgs = {
  distinct_on?: InputMaybe<Array<Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Findings_Order_By>>;
  where?: InputMaybe<Findings_Bool_Exp>;
};

export type Query_RootFindings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Findings_Order_By>>;
  where?: InputMaybe<Findings_Bool_Exp>;
};

export type Query_RootFindings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFrameworksArgs = {
  distinct_on?: InputMaybe<Array<Frameworks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Frameworks_Order_By>>;
  where?: InputMaybe<Frameworks_Bool_Exp>;
};

export type Query_RootFrameworks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFrameworks_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Frameworks_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Frameworks_Controls_Order_By>>;
  where?: InputMaybe<Frameworks_Controls_Bool_Exp>;
};

export type Query_RootFrameworks_Controls_By_PkArgs = {
  control_id: Scalars['uuid']['input'];
  framework_id: Scalars['uuid']['input'];
};

export type Query_RootGlobal_SearchArgs = {
  input: SearchInput;
};

export type Query_RootGroupsArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};

export type Query_RootGroups_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootGrove_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Grove_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grove_Agents_Order_By>>;
  where?: InputMaybe<Grove_Agents_Bool_Exp>;
};

export type Query_RootGrove_Agents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootGrove_ChatsArgs = {
  distinct_on?: InputMaybe<Array<Grove_Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grove_Chats_Order_By>>;
  where?: InputMaybe<Grove_Chats_Bool_Exp>;
};

export type Query_RootGrove_Chats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grove_Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grove_Chats_Order_By>>;
  where?: InputMaybe<Grove_Chats_Bool_Exp>;
};

export type Query_RootGrove_Chats_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootGrove_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Grove_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grove_Messages_Order_By>>;
  where?: InputMaybe<Grove_Messages_Bool_Exp>;
};

export type Query_RootGrove_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grove_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grove_Messages_Order_By>>;
  where?: InputMaybe<Grove_Messages_Bool_Exp>;
};

export type Query_RootGrove_Messages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootIntegration_RunsArgs = {
  distinct_on?: InputMaybe<Array<Integration_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integration_Runs_Order_By>>;
  where?: InputMaybe<Integration_Runs_Bool_Exp>;
};

export type Query_RootIntegration_Runs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integration_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integration_Runs_Order_By>>;
  where?: InputMaybe<Integration_Runs_Bool_Exp>;
};

export type Query_RootIntegrationsArgs = {
  distinct_on?: InputMaybe<Array<Integrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integrations_Order_By>>;
  where?: InputMaybe<Integrations_Bool_Exp>;
};

export type Query_RootIntegrations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};

export type Query_RootInvitations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootNotification_Disabled_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Notification_Disabled_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Disabled_Settings_Order_By>>;
  where?: InputMaybe<Notification_Disabled_Settings_Bool_Exp>;
};

export type Query_RootNotification_Disabled_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

export type Query_RootNotifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootOrg_Integration_Config_StateArgs = {
  orgIntegrationId: Scalars['uuid']['input'];
};

export type Query_RootOrganization_Evidence_TagsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Evidence_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Evidence_Tags_Order_By>>;
  where?: InputMaybe<Organization_Evidence_Tags_Bool_Exp>;
};

export type Query_RootOrganization_Evidence_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootOrganization_Finding_SeveritiesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Finding_Severities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Finding_Severities_Order_By>>;
  where?: InputMaybe<Organization_Finding_Severities_Bool_Exp>;
};

export type Query_RootOrganization_Finding_Severities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootOrganization_IntegrationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Integrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Integrations_Order_By>>;
  where?: InputMaybe<Organization_Integrations_Bool_Exp>;
};

export type Query_RootOrganization_Integrations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootOrganization_Risk_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Risk_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Risk_Categories_Order_By>>;
  where?: InputMaybe<Organization_Risk_Categories_Bool_Exp>;
};

export type Query_RootOrganization_Risk_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootOrganization_Risk_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Risk_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Risk_Levels_Order_By>>;
  where?: InputMaybe<Organization_Risk_Levels_Bool_Exp>;
};

export type Query_RootOrganization_Risk_Levels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootOrganization_Risk_TagsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Risk_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Risk_Tags_Order_By>>;
  where?: InputMaybe<Organization_Risk_Tags_Bool_Exp>;
};

export type Query_RootOrganization_Risk_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootOrganization_Template_FrameworksArgs = {
  distinct_on?: InputMaybe<Array<Organization_Template_Frameworks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Template_Frameworks_Order_By>>;
  where?: InputMaybe<Organization_Template_Frameworks_Bool_Exp>;
};

export type Query_RootOrganization_Template_Frameworks_By_PkArgs = {
  organization_id: Scalars['uuid']['input'];
  template_framework_id: Scalars['uuid']['input'];
};

export type Query_RootOrganization_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Tenants_Order_By>>;
  where?: InputMaybe<Organization_Tenants_Bool_Exp>;
};

export type Query_RootOrganization_Tenants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootOrganization_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Users_Order_By>>;
  where?: InputMaybe<Organization_Users_Bool_Exp>;
};

export type Query_RootOrganization_Users_By_PkArgs = {
  organization_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};

export type Query_RootOrganization_Vendor_Risk_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Vendor_Risk_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Vendor_Risk_Levels_Order_By>>;
  where?: InputMaybe<Organization_Vendor_Risk_Levels_Bool_Exp>;
};

export type Query_RootOrganization_Vendor_Risk_Levels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootOrganization_Vendor_TiersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Vendor_Tiers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Vendor_Tiers_Order_By>>;
  where?: InputMaybe<Organization_Vendor_Tiers_Bool_Exp>;
};

export type Query_RootOrganization_Vendor_Tiers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};

export type Query_RootOrganizations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootPoliciesArgs = {
  distinct_on?: InputMaybe<Array<Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policies_Order_By>>;
  where?: InputMaybe<Policies_Bool_Exp>;
};

export type Query_RootPolicies_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootPolicy_Approval_UsersArgs = {
  distinct_on?: InputMaybe<Array<Policy_Approval_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Approval_Users_Order_By>>;
  where?: InputMaybe<Policy_Approval_Users_Bool_Exp>;
};

export type Query_RootPolicy_Approval_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootPolicy_IntegrationsArgs = {
  distinct_on?: InputMaybe<Array<Policy_Integrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Integrations_Order_By>>;
  where?: InputMaybe<Policy_Integrations_Bool_Exp>;
};

export type Query_RootPolicy_Integrations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootProgramsArgs = {
  distinct_on?: InputMaybe<Array<Programs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programs_Order_By>>;
  where?: InputMaybe<Programs_Bool_Exp>;
};

export type Query_RootPrograms_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootQuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaires_Order_By>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};

export type Query_RootQuestionnaires_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};

export type Query_RootReports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootRetained_FindingsArgs = {
  distinct_on?: InputMaybe<Array<Retained_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Retained_Findings_Order_By>>;
  where?: InputMaybe<Retained_Findings_Bool_Exp>;
};

export type Query_RootRetained_Findings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retained_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Retained_Findings_Order_By>>;
  where?: InputMaybe<Retained_Findings_Bool_Exp>;
};

export type Query_RootRisk_ApproversArgs = {
  distinct_on?: InputMaybe<Array<Risk_Approvers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Approvers_Order_By>>;
  where?: InputMaybe<Risk_Approvers_Bool_Exp>;
};

export type Query_RootRisk_Approvers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootRisk_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Risk_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Categories_Order_By>>;
  where?: InputMaybe<Risk_Categories_Bool_Exp>;
};

export type Query_RootRisk_ImpactsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Impacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Impacts_Order_By>>;
  where?: InputMaybe<Risk_Impacts_Bool_Exp>;
};

export type Query_RootRisk_Impacts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootRisk_Inherent_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Inherent_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Inherent_Levels_Order_By>>;
  where?: InputMaybe<Risk_Inherent_Levels_Bool_Exp>;
};

export type Query_RootRisk_Inherent_Levels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootRisk_LikelihoodsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Likelihoods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Likelihoods_Order_By>>;
  where?: InputMaybe<Risk_Likelihoods_Bool_Exp>;
};

export type Query_RootRisk_Likelihoods_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootRisk_Residual_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Residual_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Residual_Levels_Order_By>>;
  where?: InputMaybe<Risk_Residual_Levels_Bool_Exp>;
};

export type Query_RootRisk_Residual_Levels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootRisk_TagsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Tags_Order_By>>;
  where?: InputMaybe<Risk_Tags_Bool_Exp>;
};

export type Query_RootRisksArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

export type Query_RootRisks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

export type Query_RootRisks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootRole_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};

export type Query_RootRole_Permissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

export type Query_RootRoles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootService_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Service_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Accounts_Order_By>>;
  where?: InputMaybe<Service_Accounts_Bool_Exp>;
};

export type Query_RootService_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Accounts_Order_By>>;
  where?: InputMaybe<Service_Accounts_Bool_Exp>;
};

export type Query_RootService_Accounts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootSharepoint_File_MetadataArgs = {
  fileUrl: Scalars['String']['input'];
  orgIntegrationId: Scalars['uuid']['input'];
};

export type Query_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};

export type Query_RootTags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

export type Query_RootTasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootTeam_MembersArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

export type Query_RootTeam_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

export type Query_RootTeam_Members_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

export type Query_RootTeams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootTemplate_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Template_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Controls_Order_By>>;
  where?: InputMaybe<Template_Controls_Bool_Exp>;
};

export type Query_RootTemplate_Controls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Controls_Order_By>>;
  where?: InputMaybe<Template_Controls_Bool_Exp>;
};

export type Query_RootTemplate_Controls_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootTemplate_FrameworksArgs = {
  distinct_on?: InputMaybe<Array<Template_Frameworks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Frameworks_Order_By>>;
  where?: InputMaybe<Template_Frameworks_Bool_Exp>;
};

export type Query_RootTemplate_Frameworks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootTemplate_Frameworks_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Template_Frameworks_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Frameworks_Controls_Order_By>>;
  where?: InputMaybe<Template_Frameworks_Controls_Bool_Exp>;
};

export type Query_RootTemplate_Frameworks_Controls_By_PkArgs = {
  control_id: Scalars['uuid']['input'];
  framework_id: Scalars['uuid']['input'];
};

export type Query_RootTemplate_TasksArgs = {
  distinct_on?: InputMaybe<Array<Template_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Tasks_Order_By>>;
  where?: InputMaybe<Template_Tasks_Bool_Exp>;
};

export type Query_RootTemplate_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Tasks_Order_By>>;
  where?: InputMaybe<Template_Tasks_Bool_Exp>;
};

export type Query_RootTemplate_Tasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootTrust_Portal_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Categories_Order_By>>;
  where?: InputMaybe<Trust_Portal_Categories_Bool_Exp>;
};

export type Query_RootTrust_Portal_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootTrust_Portal_Nda_Gate_Provider_DataArgs = {
  organizationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  pageId: Scalars['uuid']['input'];
};

export type Query_RootTrust_Portal_Resource_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Resource_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Resource_Sections_Order_By>>;
  where?: InputMaybe<Trust_Portal_Resource_Sections_Bool_Exp>;
};

export type Query_RootTrust_Portal_Resource_Sections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootUserArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootUser_Controls_Stats_ViewArgs = {
  distinct_on?: InputMaybe<Array<User_Controls_Stats_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Controls_Stats_View_Order_By>>;
  where?: InputMaybe<User_Controls_Stats_View_Bool_Exp>;
};

export type Query_RootUser_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};

export type Query_RootUser_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};

export type Query_RootUser_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootUser_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};

export type Query_RootUser_Profiles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootUser_Tasks_Stats_ViewArgs = {
  distinct_on?: InputMaybe<Array<User_Tasks_Stats_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tasks_Stats_View_Order_By>>;
  where?: InputMaybe<User_Tasks_Stats_View_Bool_Exp>;
};

export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

export type Query_RootVendor_ApproversArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Approvers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Approvers_Order_By>>;
  where?: InputMaybe<Vendor_Approvers_Bool_Exp>;
};

export type Query_RootVendor_Approvers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootVendor_Questionnaire_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaire_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaire_Schedules_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaire_Schedules_Bool_Exp>;
};

export type Query_RootVendor_Questionnaire_Schedules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootVendor_QuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaires_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
};

export type Query_RootVendor_Questionnaires_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootVendorsArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

export type Query_RootVendors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

export type Query_RootVendors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootVq_Custom_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Vq_Custom_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vq_Custom_Fields_Order_By>>;
  where?: InputMaybe<Vq_Custom_Fields_Bool_Exp>;
};

export type Query_RootVq_Custom_Fields_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** File uploads for questionnaires */
export type Questionnaire_Uploads = {
  __typename?: 'questionnaire_uploads';
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  questionnaire?: Maybe<Questionnaires>;
  questionnaire_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  vendor_questionnaire?: Maybe<Vendor_Questionnaires>;
};

/** order by aggregate values of table "questionnaire_uploads" */
export type Questionnaire_Uploads_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questionnaire_Uploads_Max_Order_By>;
  min?: InputMaybe<Questionnaire_Uploads_Min_Order_By>;
};

/** input type for inserting array relation for remote table "questionnaire_uploads" */
export type Questionnaire_Uploads_Arr_Rel_Insert_Input = {
  data: Array<Questionnaire_Uploads_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Uploads_On_Conflict>;
};

/** Boolean expression to filter rows from the table "questionnaire_uploads". All fields are combined with a logical 'AND'. */
export type Questionnaire_Uploads_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaire_Uploads_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Uploads_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Uploads_Bool_Exp>>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  questionnaire?: InputMaybe<Questionnaires_Bool_Exp>;
  questionnaire_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_questionnaire?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
};

/** unique or primary key constraints on table "questionnaire_uploads" */
export enum Questionnaire_Uploads_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionnaireUploadsPkey = 'questionnaire_uploads_pkey',
}

/** input type for inserting data into table "questionnaire_uploads" */
export type Questionnaire_Uploads_Insert_Input = {
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire?: InputMaybe<Questionnaires_Obj_Rel_Insert_Input>;
  questionnaire_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "questionnaire_uploads" */
export type Questionnaire_Uploads_Max_Order_By = {
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "questionnaire_uploads" */
export type Questionnaire_Uploads_Min_Order_By = {
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questionnaire_uploads" */
export type Questionnaire_Uploads_Mutation_Response = {
  __typename?: 'questionnaire_uploads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Uploads>;
};

/** on_conflict condition type for table "questionnaire_uploads" */
export type Questionnaire_Uploads_On_Conflict = {
  constraint: Questionnaire_Uploads_Constraint;
  update_columns?: Array<Questionnaire_Uploads_Update_Column>;
  where?: InputMaybe<Questionnaire_Uploads_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaire_uploads". */
export type Questionnaire_Uploads_Order_By = {
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire?: InputMaybe<Questionnaires_Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  vendor_questionnaire?: InputMaybe<Vendor_Questionnaires_Order_By>;
};

/** primary key columns input for table: questionnaire_uploads */
export type Questionnaire_Uploads_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "questionnaire_uploads" */
export enum Questionnaire_Uploads_Select_Column {
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
}

/** input type for updating data in table "questionnaire_uploads" */
export type Questionnaire_Uploads_Set_Input = {
  file_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "questionnaire_uploads" */
export enum Questionnaire_Uploads_Update_Column {
  /** column name */
  FileId = 'file_id',
}

export type Questionnaire_Uploads_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaire_Uploads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaire_Uploads_Bool_Exp;
};

/** columns and relationships of "questionnaires" */
export type Questionnaires = {
  __typename?: 'questionnaires';
  /** An array relationship */
  comments: Array<Comments>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  default_recurrence_frequency: Frequencies_Enum;
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  file?: Maybe<Files>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  form?: Maybe<Forms>;
  form_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  owner?: Maybe<Users>;
  owner_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  questionnaire_uploads: Array<Questionnaire_Uploads>;
  /** An array relationship */
  vendor_questionnaires: Array<Vendor_Questionnaires>;
  /** An array relationship */
  vq_custom_fields: Array<Vq_Custom_Fields>;
};

/** columns and relationships of "questionnaires" */
export type QuestionnairesCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** columns and relationships of "questionnaires" */
export type QuestionnairesQuestionnaire_UploadsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Uploads_Order_By>>;
  where?: InputMaybe<Questionnaire_Uploads_Bool_Exp>;
};

/** columns and relationships of "questionnaires" */
export type QuestionnairesVendor_QuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaires_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
};

/** columns and relationships of "questionnaires" */
export type QuestionnairesVq_Custom_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Vq_Custom_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vq_Custom_Fields_Order_By>>;
  where?: InputMaybe<Vq_Custom_Fields_Bool_Exp>;
};

/** order by aggregate values of table "questionnaires" */
export type Questionnaires_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questionnaires_Max_Order_By>;
  min?: InputMaybe<Questionnaires_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "questionnaires". All fields are combined with a logical 'AND'. */
export type Questionnaires_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaires_Bool_Exp>>;
  _not?: InputMaybe<Questionnaires_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaires_Bool_Exp>>;
  comments?: InputMaybe<Comments_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  default_recurrence_frequency?: InputMaybe<Frequencies_Enum_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  form?: InputMaybe<Forms_Bool_Exp>;
  form_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  owner?: InputMaybe<Users_Bool_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  questionnaire_uploads?: InputMaybe<Questionnaire_Uploads_Bool_Exp>;
  vendor_questionnaires?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
  vq_custom_fields?: InputMaybe<Vq_Custom_Fields_Bool_Exp>;
};

/** unique or primary key constraints on table "questionnaires" */
export enum Questionnaires_Constraint {
  /** unique or primary key constraint on columns "file_id" */
  QuestionnairesFileIdKey = 'questionnaires_file_id_key',
  /** unique or primary key constraint on columns "form_id" */
  QuestionnairesFormIdKey = 'questionnaires_form_id_key',
  /** unique or primary key constraint on columns "id", "organization_id" */
  QuestionnairesIdOrganizationIdKey = 'questionnaires_id_organization_id_key',
  /** unique or primary key constraint on columns "organization_id", "internal_id" */
  QuestionnairesOrganizationIdInternalIdKey = 'questionnaires_organization_id_internal_id_key',
  /** unique or primary key constraint on columns "id" */
  QuestionnairesPkey = 'questionnaires_pkey',
}

/** input type for inserting data into table "questionnaires" */
export type Questionnaires_Insert_Input = {
  comments?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  form?: InputMaybe<Forms_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire_uploads?: InputMaybe<Questionnaire_Uploads_Arr_Rel_Insert_Input>;
  vq_custom_fields?: InputMaybe<Vq_Custom_Fields_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "questionnaires" */
export type Questionnaires_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  form_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "questionnaires" */
export type Questionnaires_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  form_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questionnaires" */
export type Questionnaires_Mutation_Response = {
  __typename?: 'questionnaires_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaires>;
};

/** input type for inserting object relation for remote table "questionnaires" */
export type Questionnaires_Obj_Rel_Insert_Input = {
  data: Questionnaires_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaires_On_Conflict>;
};

/** on_conflict condition type for table "questionnaires" */
export type Questionnaires_On_Conflict = {
  constraint: Questionnaires_Constraint;
  update_columns?: Array<Questionnaires_Update_Column>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaires". */
export type Questionnaires_Order_By = {
  comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  default_recurrence_frequency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  form?: InputMaybe<Forms_Order_By>;
  form_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Users_Order_By>;
  owner_id?: InputMaybe<Order_By>;
  questionnaire_uploads_aggregate?: InputMaybe<Questionnaire_Uploads_Aggregate_Order_By>;
  vendor_questionnaires_aggregate?: InputMaybe<Vendor_Questionnaires_Aggregate_Order_By>;
  vq_custom_fields_aggregate?: InputMaybe<Vq_Custom_Fields_Aggregate_Order_By>;
};

/** primary key columns input for table: questionnaires */
export type Questionnaires_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "questionnaires" */
export enum Questionnaires_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DefaultRecurrenceFrequency = 'default_recurrence_frequency',
  /** column name */
  Description = 'description',
  /** column name */
  FileId = 'file_id',
  /** column name */
  FormId = 'form_id',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OwnerId = 'owner_id',
}

/** input type for updating data in table "questionnaires" */
export type Questionnaires_Set_Input = {
  default_recurrence_frequency?: InputMaybe<Frequencies_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "questionnaires" */
export type Questionnaires_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaires_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaires_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  default_recurrence_frequency?: InputMaybe<Frequencies_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  form_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "questionnaires" */
export enum Questionnaires_Update_Column {
  /** column name */
  DefaultRecurrenceFrequency = 'default_recurrence_frequency',
  /** column name */
  Description = 'description',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
}

export type Questionnaires_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaires_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaires_Bool_Exp;
};

export enum Relation_Actions_Enum {
  /** Aggregate finding includes a member finding */
  Aggregates = 'aggregates',
  /** A source entity applies to a target entity. */
  AppliesTo = 'applies_to',
  /** Compensating relation */
  CompensatesFor = 'compensates_for',
  /** Finding escalated to a risk */
  Escalation = 'escalation',
  /** A source entity exception creates a target entity. */
  ExceptionCreates = 'exception_creates',
  /** A source entity implements a target entity. */
  Implements = 'implements',
  /** A source entity is the parent of a target entity. */
  IsParentTo = 'is_parent_to',
  /** A source entity is required by a target entity. */
  IsRequiredBy = 'is_required_by',
  /** A source vendor is a subprocessor of a target vendor. */
  IsSubprocessorOf = 'is_subprocessor_of',
  /** A source entity mitigates a risk. */
  Mitigates = 'mitigates',
  /** Task remediates a finding */
  Remediation = 'remediation',
  /** New finding repeats a prior finding */
  RepeatOf = 'repeat_of',
  /** A source entity supersedes a target entity. */
  Supersedes = 'supersedes',
  /** A source entity tests a target entity. */
  Tests = 'tests',
}

/** Boolean expression to compare columns of type "relation_actions_enum". All fields are combined with logical 'AND'. */
export type Relation_Actions_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Relation_Actions_Enum>;
  _in?: InputMaybe<Array<Relation_Actions_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Relation_Actions_Enum>;
  _nin?: InputMaybe<Array<Relation_Actions_Enum>>;
};

export enum Report_Types_Enum {
  Approvals = 'approvals',
  Controls = 'controls',
  Evidence = 'evidence',
  Findings = 'findings',
  Policies = 'policies',
  Risks = 'risks',
  Tasks = 'tasks',
  Vendors = 'vendors',
}

/** Boolean expression to compare columns of type "report_types_enum". All fields are combined with logical 'AND'. */
export type Report_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Report_Types_Enum>;
  _in?: InputMaybe<Array<Report_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Report_Types_Enum>;
  _nin?: InputMaybe<Array<Report_Types_Enum>>;
};

/** columns and relationships of "reports" */
export type Reports = {
  __typename?: 'reports';
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['uuid']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Saved table column filters, a JSON array of {id, value}. id is the table column id; for a custom field it is the field_configs.id UUID (findings reports use field:<uuid>). */
  filters?: Maybe<Scalars['ColumnFiltersState']['output']>;
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  parameters?: Maybe<Scalars['jsonb']['output']>;
  /** Saved table sort, a JSON array of {id, desc} in priority order. id is the table column id; for a custom field it is the field_configs.id UUID. */
  sorting?: Maybe<Scalars['SortingState']['output']>;
  template_id?: Maybe<Scalars['String']['output']>;
  type: Report_Types_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};

/** columns and relationships of "reports" */
export type ReportsFiltersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "reports" */
export type ReportsParametersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "reports" */
export type ReportsSortingArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "reports" */
export type Reports_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reports_Max_Order_By>;
  min?: InputMaybe<Reports_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Reports_Append_Input = {
  /** Saved table column filters, a JSON array of {id, value}. id is the table column id; for a custom field it is the field_configs.id UUID (findings reports use field:<uuid>). */
  filters?: InputMaybe<Scalars['jsonb']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  /** Saved table sort, a JSON array of {id, desc} in priority order. id is the table column id; for a custom field it is the field_configs.id UUID. */
  sorting?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "reports". All fields are combined with a logical 'AND'. */
export type Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Reports_Bool_Exp>>;
  _not?: InputMaybe<Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Reports_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  filters?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  parameters?: InputMaybe<Jsonb_Comparison_Exp>;
  sorting?: InputMaybe<Jsonb_Comparison_Exp>;
  template_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Report_Types_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "reports" */
export enum Reports_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReportsPkey = 'reports_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Reports_Delete_At_Path_Input = {
  /** Saved table column filters, a JSON array of {id, value}. id is the table column id; for a custom field it is the field_configs.id UUID (findings reports use field:<uuid>). */
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  parameters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Saved table sort, a JSON array of {id, desc} in priority order. id is the table column id; for a custom field it is the field_configs.id UUID. */
  sorting?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Reports_Delete_Elem_Input = {
  /** Saved table column filters, a JSON array of {id, value}. id is the table column id; for a custom field it is the field_configs.id UUID (findings reports use field:<uuid>). */
  filters?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<Scalars['Int']['input']>;
  /** Saved table sort, a JSON array of {id, desc} in priority order. id is the table column id; for a custom field it is the field_configs.id UUID. */
  sorting?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Reports_Delete_Key_Input = {
  /** Saved table column filters, a JSON array of {id, value}. id is the table column id; for a custom field it is the field_configs.id UUID (findings reports use field:<uuid>). */
  filters?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  /** Saved table sort, a JSON array of {id, desc} in priority order. id is the table column id; for a custom field it is the field_configs.id UUID. */
  sorting?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "reports" */
export type Reports_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Saved table column filters, a JSON array of {id, value}. id is the table column id; for a custom field it is the field_configs.id UUID (findings reports use field:<uuid>). */
  filters?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  /** Saved table sort, a JSON array of {id, desc} in priority order. id is the table column id; for a custom field it is the field_configs.id UUID. */
  sorting?: InputMaybe<Scalars['jsonb']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Report_Types_Enum>;
};

/** order by max() on columns of table "reports" */
export type Reports_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "reports" */
export type Reports_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reports" */
export type Reports_Mutation_Response = {
  __typename?: 'reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reports>;
};

/** on_conflict condition type for table "reports" */
export type Reports_On_Conflict = {
  constraint: Reports_Constraint;
  update_columns?: Array<Reports_Update_Column>;
  where?: InputMaybe<Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "reports". */
export type Reports_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  filters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parameters?: InputMaybe<Order_By>;
  sorting?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: reports */
export type Reports_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Reports_Prepend_Input = {
  /** Saved table column filters, a JSON array of {id, value}. id is the table column id; for a custom field it is the field_configs.id UUID (findings reports use field:<uuid>). */
  filters?: InputMaybe<Scalars['jsonb']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  /** Saved table sort, a JSON array of {id, desc} in priority order. id is the table column id; for a custom field it is the field_configs.id UUID. */
  sorting?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "reports" */
export enum Reports_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Filters = 'filters',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  Sorting = 'sorting',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "reports" */
export type Reports_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Saved table column filters, a JSON array of {id, value}. id is the table column id; for a custom field it is the field_configs.id UUID (findings reports use field:<uuid>). */
  filters?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  /** Saved table sort, a JSON array of {id, desc} in priority order. id is the table column id; for a custom field it is the field_configs.id UUID. */
  sorting?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "reports" */
export type Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reports_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Saved table column filters, a JSON array of {id, value}. id is the table column id; for a custom field it is the field_configs.id UUID (findings reports use field:<uuid>). */
  filters?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  /** Saved table sort, a JSON array of {id, desc} in priority order. id is the table column id; for a custom field it is the field_configs.id UUID. */
  sorting?: InputMaybe<Scalars['jsonb']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Report_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "reports" */
export enum Reports_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Filters = 'filters',
  /** column name */
  Name = 'name',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  Sorting = 'sorting',
}

export type Reports_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Reports_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Reports_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Reports_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Reports_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Reports_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reports_Bool_Exp;
};

/** columns and relationships of "retained_findings" */
export type Retained_Findings = {
  __typename?: 'retained_findings';
  acceptance_reason?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  anchors: Array<Finding_Anchors>;
  /** An aggregate relationship */
  anchors_aggregate: Finding_Anchors_Aggregate;
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  archived_by?: Maybe<Scalars['uuid']['output']>;
  closure_reason?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  comments: Array<Comments>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  creation_kind?: Maybe<Scalars['String']['output']>;
  cycle_year?: Maybe<Scalars['Int']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  field_values: Array<Field_Values>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  lifecycle_note?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  observations: Array<Finding_Observations>;
  /** An aggregate relationship */
  observations_aggregate: Finding_Observations_Aggregate;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  owners: Array<Finding_Owners>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  published_by?: Maybe<Scalars['uuid']['output']>;
  revision?: Maybe<Scalars['bigint']['output']>;
  severity_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** columns and relationships of "retained_findings" */
export type Retained_FindingsAnchorsArgs = {
  distinct_on?: InputMaybe<Array<Finding_Anchors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Finding_Anchors_Order_By>>;
  where?: InputMaybe<Finding_Anchors_Bool_Exp>;
};

/** columns and relationships of "retained_findings" */
export type Retained_FindingsAnchors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Finding_Anchors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Finding_Anchors_Order_By>>;
  where?: InputMaybe<Finding_Anchors_Bool_Exp>;
};

/** columns and relationships of "retained_findings" */
export type Retained_FindingsCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** columns and relationships of "retained_findings" */
export type Retained_FindingsField_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Values_Order_By>>;
  where?: InputMaybe<Field_Values_Bool_Exp>;
};

/** columns and relationships of "retained_findings" */
export type Retained_FindingsObservationsArgs = {
  distinct_on?: InputMaybe<Array<Finding_Observations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Finding_Observations_Order_By>>;
  where?: InputMaybe<Finding_Observations_Bool_Exp>;
};

/** columns and relationships of "retained_findings" */
export type Retained_FindingsObservations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Finding_Observations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Finding_Observations_Order_By>>;
  where?: InputMaybe<Finding_Observations_Bool_Exp>;
};

/** columns and relationships of "retained_findings" */
export type Retained_FindingsOwnersArgs = {
  distinct_on?: InputMaybe<Array<Finding_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Finding_Owners_Order_By>>;
  where?: InputMaybe<Finding_Owners_Bool_Exp>;
};

/** aggregated selection of "retained_findings" */
export type Retained_Findings_Aggregate = {
  __typename?: 'retained_findings_aggregate';
  aggregate?: Maybe<Retained_Findings_Aggregate_Fields>;
  nodes: Array<Retained_Findings>;
};

/** aggregate fields of "retained_findings" */
export type Retained_Findings_Aggregate_Fields = {
  __typename?: 'retained_findings_aggregate_fields';
  avg?: Maybe<Retained_Findings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Retained_Findings_Max_Fields>;
  min?: Maybe<Retained_Findings_Min_Fields>;
  stddev?: Maybe<Retained_Findings_Stddev_Fields>;
  stddev_pop?: Maybe<Retained_Findings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Retained_Findings_Stddev_Samp_Fields>;
  sum?: Maybe<Retained_Findings_Sum_Fields>;
  var_pop?: Maybe<Retained_Findings_Var_Pop_Fields>;
  var_samp?: Maybe<Retained_Findings_Var_Samp_Fields>;
  variance?: Maybe<Retained_Findings_Variance_Fields>;
};

/** aggregate fields of "retained_findings" */
export type Retained_Findings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Retained_Findings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Retained_Findings_Avg_Fields = {
  __typename?: 'retained_findings_avg_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "retained_findings". All fields are combined with a logical 'AND'. */
export type Retained_Findings_Bool_Exp = {
  _and?: InputMaybe<Array<Retained_Findings_Bool_Exp>>;
  _not?: InputMaybe<Retained_Findings_Bool_Exp>;
  _or?: InputMaybe<Array<Retained_Findings_Bool_Exp>>;
  acceptance_reason?: InputMaybe<String_Comparison_Exp>;
  anchors?: InputMaybe<Finding_Anchors_Bool_Exp>;
  anchors_aggregate?: InputMaybe<Finding_Anchors_Aggregate_Bool_Exp>;
  archived_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  archived_by?: InputMaybe<Uuid_Comparison_Exp>;
  closure_reason?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<Comments_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creation_kind?: InputMaybe<String_Comparison_Exp>;
  cycle_year?: InputMaybe<Int_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  field_values?: InputMaybe<Field_Values_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_id?: InputMaybe<String_Comparison_Exp>;
  lifecycle_note?: InputMaybe<String_Comparison_Exp>;
  observations?: InputMaybe<Finding_Observations_Bool_Exp>;
  observations_aggregate?: InputMaybe<Finding_Observations_Aggregate_Bool_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  owners?: InputMaybe<Finding_Owners_Bool_Exp>;
  published_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  published_by?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<Bigint_Comparison_Exp>;
  severity_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Retained_Findings_Max_Fields = {
  __typename?: 'retained_findings_max_fields';
  acceptance_reason?: Maybe<Scalars['String']['output']>;
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  archived_by?: Maybe<Scalars['uuid']['output']>;
  closure_reason?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  creation_kind?: Maybe<Scalars['String']['output']>;
  cycle_year?: Maybe<Scalars['Int']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  lifecycle_note?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  published_by?: Maybe<Scalars['uuid']['output']>;
  revision?: Maybe<Scalars['bigint']['output']>;
  severity_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Retained_Findings_Min_Fields = {
  __typename?: 'retained_findings_min_fields';
  acceptance_reason?: Maybe<Scalars['String']['output']>;
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  archived_by?: Maybe<Scalars['uuid']['output']>;
  closure_reason?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  creation_kind?: Maybe<Scalars['String']['output']>;
  cycle_year?: Maybe<Scalars['Int']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  lifecycle_note?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  published_by?: Maybe<Scalars['uuid']['output']>;
  revision?: Maybe<Scalars['bigint']['output']>;
  severity_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "retained_findings". */
export type Retained_Findings_Order_By = {
  acceptance_reason?: InputMaybe<Order_By>;
  anchors_aggregate?: InputMaybe<Finding_Anchors_Aggregate_Order_By>;
  archived_at?: InputMaybe<Order_By>;
  archived_by?: InputMaybe<Order_By>;
  closure_reason?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creation_kind?: InputMaybe<Order_By>;
  cycle_year?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  field_values_aggregate?: InputMaybe<Field_Values_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  lifecycle_note?: InputMaybe<Order_By>;
  observations_aggregate?: InputMaybe<Finding_Observations_Aggregate_Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owners_aggregate?: InputMaybe<Finding_Owners_Aggregate_Order_By>;
  published_at?: InputMaybe<Order_By>;
  published_by?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  severity_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "retained_findings" */
export enum Retained_Findings_Select_Column {
  /** column name */
  AcceptanceReason = 'acceptance_reason',
  /** column name */
  ArchivedAt = 'archived_at',
  /** column name */
  ArchivedBy = 'archived_by',
  /** column name */
  ClosureReason = 'closure_reason',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreationKind = 'creation_kind',
  /** column name */
  CycleYear = 'cycle_year',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  LifecycleNote = 'lifecycle_note',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  PublishedBy = 'published_by',
  /** column name */
  Revision = 'revision',
  /** column name */
  SeverityId = 'severity_id',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** aggregate stddev on columns */
export type Retained_Findings_Stddev_Fields = {
  __typename?: 'retained_findings_stddev_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Retained_Findings_Stddev_Pop_Fields = {
  __typename?: 'retained_findings_stddev_pop_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Retained_Findings_Stddev_Samp_Fields = {
  __typename?: 'retained_findings_stddev_samp_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "retained_findings" */
export type Retained_Findings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Retained_Findings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Retained_Findings_Stream_Cursor_Value_Input = {
  acceptance_reason?: InputMaybe<Scalars['String']['input']>;
  archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  archived_by?: InputMaybe<Scalars['uuid']['input']>;
  closure_reason?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creation_kind?: InputMaybe<Scalars['String']['input']>;
  cycle_year?: InputMaybe<Scalars['Int']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_id?: InputMaybe<Scalars['String']['input']>;
  lifecycle_note?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  published_by?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<Scalars['bigint']['input']>;
  severity_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Retained_Findings_Sum_Fields = {
  __typename?: 'retained_findings_sum_fields';
  cycle_year?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Retained_Findings_Var_Pop_Fields = {
  __typename?: 'retained_findings_var_pop_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Retained_Findings_Var_Samp_Fields = {
  __typename?: 'retained_findings_var_samp_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Retained_Findings_Variance_Fields = {
  __typename?: 'retained_findings_variance_fields';
  cycle_year?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "review_files" */
export type Review_Files = {
  __typename?: 'review_files';
  created_at: Scalars['timestamptz']['output'];
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  review_files_file: Files;
  /** An object relationship */
  review_files_review: Reviews;
  review_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "review_files" */
export type Review_Files_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Review_Files_Max_Order_By>;
  min?: InputMaybe<Review_Files_Min_Order_By>;
};

/** input type for inserting array relation for remote table "review_files" */
export type Review_Files_Arr_Rel_Insert_Input = {
  data: Array<Review_Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Review_Files_On_Conflict>;
};

/** Boolean expression to filter rows from the table "review_files". All fields are combined with a logical 'AND'. */
export type Review_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Review_Files_Bool_Exp>>;
  _not?: InputMaybe<Review_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Review_Files_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  review_files_file?: InputMaybe<Files_Bool_Exp>;
  review_files_review?: InputMaybe<Reviews_Bool_Exp>;
  review_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "review_files" */
export enum Review_Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReviewFilesPkey = 'review_files_pkey',
}

/** input type for inserting data into table "review_files" */
export type Review_Files_Insert_Input = {
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  review_files_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  review_files_review?: InputMaybe<Reviews_Obj_Rel_Insert_Input>;
  review_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "review_files" */
export type Review_Files_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  review_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "review_files" */
export type Review_Files_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  review_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "review_files" */
export type Review_Files_Mutation_Response = {
  __typename?: 'review_files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Review_Files>;
};

/** on_conflict condition type for table "review_files" */
export type Review_Files_On_Conflict = {
  constraint: Review_Files_Constraint;
  update_columns?: Array<Review_Files_Update_Column>;
  where?: InputMaybe<Review_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "review_files". */
export type Review_Files_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  review_files_file?: InputMaybe<Files_Order_By>;
  review_files_review?: InputMaybe<Reviews_Order_By>;
  review_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: review_files */
export type Review_Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "review_files" */
export enum Review_Files_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  ReviewId = 'review_id',
}

/** input type for updating data in table "review_files" */
export type Review_Files_Set_Input = {
  file_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "review_files" */
export enum Review_Files_Update_Column {
  /** column name */
  FileId = 'file_id',
}

export type Review_Files_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Review_Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Review_Files_Bool_Exp;
};

/** stores review information related to risks and vendors */
export type Reviews = {
  __typename?: 'reviews';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  review_date: Scalars['timestamptz']['output'];
  reviewed_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  reviews_review_files: Array<Review_Files>;
  /** An object relationship */
  reviews_risk?: Maybe<Risks>;
  /** An object relationship */
  reviews_user?: Maybe<Users>;
  /** An object relationship */
  reviews_vendor?: Maybe<Vendors>;
  updated_at: Scalars['timestamptz']['output'];
};

/** stores review information related to risks and vendors */
export type ReviewsReviews_Review_FilesArgs = {
  distinct_on?: InputMaybe<Array<Review_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Review_Files_Order_By>>;
  where?: InputMaybe<Review_Files_Bool_Exp>;
};

/** order by aggregate values of table "reviews" */
export type Reviews_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reviews_Max_Order_By>;
  min?: InputMaybe<Reviews_Min_Order_By>;
};

/** input type for inserting array relation for remote table "reviews" */
export type Reviews_Arr_Rel_Insert_Input = {
  data: Array<Reviews_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};

/** Boolean expression to filter rows from the table "reviews". All fields are combined with a logical 'AND'. */
export type Reviews_Bool_Exp = {
  _and?: InputMaybe<Array<Reviews_Bool_Exp>>;
  _not?: InputMaybe<Reviews_Bool_Exp>;
  _or?: InputMaybe<Array<Reviews_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  review_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewed_by?: InputMaybe<Uuid_Comparison_Exp>;
  reviews_review_files?: InputMaybe<Review_Files_Bool_Exp>;
  reviews_risk?: InputMaybe<Risks_Bool_Exp>;
  reviews_user?: InputMaybe<Users_Bool_Exp>;
  reviews_vendor?: InputMaybe<Vendors_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "reviews" */
export enum Reviews_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReviewsPkey = 'reviews_pkey',
}

/** input type for inserting data into table "reviews" */
export type Reviews_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  review_date?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by?: InputMaybe<Scalars['uuid']['input']>;
  reviews_review_files?: InputMaybe<Review_Files_Arr_Rel_Insert_Input>;
  reviews_risk?: InputMaybe<Risks_Obj_Rel_Insert_Input>;
  reviews_vendor?: InputMaybe<Vendors_Obj_Rel_Insert_Input>;
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "reviews" */
export type Reviews_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  review_date?: InputMaybe<Order_By>;
  reviewed_by?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "reviews" */
export type Reviews_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  review_date?: InputMaybe<Order_By>;
  reviewed_by?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reviews" */
export type Reviews_Mutation_Response = {
  __typename?: 'reviews_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reviews>;
};

/** input type for inserting object relation for remote table "reviews" */
export type Reviews_Obj_Rel_Insert_Input = {
  data: Reviews_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};

/** on_conflict condition type for table "reviews" */
export type Reviews_On_Conflict = {
  constraint: Reviews_Constraint;
  update_columns?: Array<Reviews_Update_Column>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};

/** Ordering options when selecting data from "reviews". */
export type Reviews_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  review_date?: InputMaybe<Order_By>;
  reviewed_by?: InputMaybe<Order_By>;
  reviews_review_files_aggregate?: InputMaybe<Review_Files_Aggregate_Order_By>;
  reviews_risk?: InputMaybe<Risks_Order_By>;
  reviews_user?: InputMaybe<Users_Order_By>;
  reviews_vendor?: InputMaybe<Vendors_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reviews */
export type Reviews_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "reviews" */
export enum Reviews_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  ReviewDate = 'review_date',
  /** column name */
  ReviewedBy = 'reviewed_by',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "reviews" */
export type Reviews_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  review_date?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "reviews" */
export enum Reviews_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  ReviewDate = 'review_date',
  /** column name */
  ReviewedBy = 'reviewed_by',
}

export type Reviews_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reviews_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reviews_Bool_Exp;
};

/** columns and relationships of "risk_approval_files" */
export type Risk_Approval_Files = {
  __typename?: 'risk_approval_files';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  risk_approval: Risk_Approvals;
  risk_approval_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "risk_approval_files" */
export type Risk_Approval_Files_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Approval_Files_Max_Order_By>;
  min?: InputMaybe<Risk_Approval_Files_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risk_approval_files" */
export type Risk_Approval_Files_Arr_Rel_Insert_Input = {
  data: Array<Risk_Approval_Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Approval_Files_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risk_approval_files". All fields are combined with a logical 'AND'. */
export type Risk_Approval_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Approval_Files_Bool_Exp>>;
  _not?: InputMaybe<Risk_Approval_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Approval_Files_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  risk_approval?: InputMaybe<Risk_Approvals_Bool_Exp>;
  risk_approval_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risk_approval_files" */
export enum Risk_Approval_Files_Constraint {
  /** unique or primary key constraint on columns "file_id" */
  RiskApprovalFilesFileIdKey = 'risk_approval_files_file_id_key',
  /** unique or primary key constraint on columns "id" */
  RiskApprovalFilesPkey = 'risk_approval_files_pkey',
}

/** input type for inserting data into table "risk_approval_files" */
export type Risk_Approval_Files_Insert_Input = {
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  risk_approval?: InputMaybe<Risk_Approvals_Obj_Rel_Insert_Input>;
  risk_approval_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "risk_approval_files" */
export type Risk_Approval_Files_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_approval_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risk_approval_files" */
export type Risk_Approval_Files_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_approval_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_approval_files" */
export type Risk_Approval_Files_Mutation_Response = {
  __typename?: 'risk_approval_files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Approval_Files>;
};

/** on_conflict condition type for table "risk_approval_files" */
export type Risk_Approval_Files_On_Conflict = {
  constraint: Risk_Approval_Files_Constraint;
  update_columns?: Array<Risk_Approval_Files_Update_Column>;
  where?: InputMaybe<Risk_Approval_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_approval_files". */
export type Risk_Approval_Files_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_approval?: InputMaybe<Risk_Approvals_Order_By>;
  risk_approval_id?: InputMaybe<Order_By>;
};

/** select columns of table "risk_approval_files" */
export enum Risk_Approval_Files_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  RiskApprovalId = 'risk_approval_id',
}

/** placeholder for update columns of table "risk_approval_files" (current role has no relevant permissions) */
export enum Risk_Approval_Files_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "risk_approval_reason_entries" */
export type Risk_Approval_Reason_Entries = {
  __typename?: 'risk_approval_reason_entries';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  reason: Risk_Approval_Reasons_Enum;
  /** An object relationship */
  risk_approval: Risk_Approvals;
  risk_approval_id: Scalars['uuid']['output'];
};

/** aggregated selection of "risk_approval_reason_entries" */
export type Risk_Approval_Reason_Entries_Aggregate = {
  __typename?: 'risk_approval_reason_entries_aggregate';
  aggregate?: Maybe<Risk_Approval_Reason_Entries_Aggregate_Fields>;
  nodes: Array<Risk_Approval_Reason_Entries>;
};

export type Risk_Approval_Reason_Entries_Aggregate_Bool_Exp = {
  count?: InputMaybe<Risk_Approval_Reason_Entries_Aggregate_Bool_Exp_Count>;
};

export type Risk_Approval_Reason_Entries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Risk_Approval_Reason_Entries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risk_Approval_Reason_Entries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risk_approval_reason_entries" */
export type Risk_Approval_Reason_Entries_Aggregate_Fields = {
  __typename?: 'risk_approval_reason_entries_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Risk_Approval_Reason_Entries_Max_Fields>;
  min?: Maybe<Risk_Approval_Reason_Entries_Min_Fields>;
};

/** aggregate fields of "risk_approval_reason_entries" */
export type Risk_Approval_Reason_Entries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risk_Approval_Reason_Entries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risk_approval_reason_entries" */
export type Risk_Approval_Reason_Entries_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Approval_Reason_Entries_Max_Order_By>;
  min?: InputMaybe<Risk_Approval_Reason_Entries_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risk_approval_reason_entries" */
export type Risk_Approval_Reason_Entries_Arr_Rel_Insert_Input = {
  data: Array<Risk_Approval_Reason_Entries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Approval_Reason_Entries_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risk_approval_reason_entries". All fields are combined with a logical 'AND'. */
export type Risk_Approval_Reason_Entries_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Approval_Reason_Entries_Bool_Exp>>;
  _not?: InputMaybe<Risk_Approval_Reason_Entries_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Approval_Reason_Entries_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  reason?: InputMaybe<Risk_Approval_Reasons_Enum_Comparison_Exp>;
  risk_approval?: InputMaybe<Risk_Approvals_Bool_Exp>;
  risk_approval_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risk_approval_reason_entries" */
export enum Risk_Approval_Reason_Entries_Constraint {
  /** unique or primary key constraint on columns "id" */
  RiskApprovalReasonEntriesPkey = 'risk_approval_reason_entries_pkey',
}

/** input type for inserting data into table "risk_approval_reason_entries" */
export type Risk_Approval_Reason_Entries_Insert_Input = {
  reason?: InputMaybe<Risk_Approval_Reasons_Enum>;
  risk_approval?: InputMaybe<Risk_Approvals_Obj_Rel_Insert_Input>;
  risk_approval_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Risk_Approval_Reason_Entries_Max_Fields = {
  __typename?: 'risk_approval_reason_entries_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  risk_approval_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risk_approval_reason_entries" */
export type Risk_Approval_Reason_Entries_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_approval_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Risk_Approval_Reason_Entries_Min_Fields = {
  __typename?: 'risk_approval_reason_entries_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  risk_approval_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risk_approval_reason_entries" */
export type Risk_Approval_Reason_Entries_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_approval_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_approval_reason_entries" */
export type Risk_Approval_Reason_Entries_Mutation_Response = {
  __typename?: 'risk_approval_reason_entries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Approval_Reason_Entries>;
};

/** on_conflict condition type for table "risk_approval_reason_entries" */
export type Risk_Approval_Reason_Entries_On_Conflict = {
  constraint: Risk_Approval_Reason_Entries_Constraint;
  update_columns?: Array<Risk_Approval_Reason_Entries_Update_Column>;
  where?: InputMaybe<Risk_Approval_Reason_Entries_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_approval_reason_entries". */
export type Risk_Approval_Reason_Entries_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  risk_approval?: InputMaybe<Risk_Approvals_Order_By>;
  risk_approval_id?: InputMaybe<Order_By>;
};

/** select columns of table "risk_approval_reason_entries" */
export enum Risk_Approval_Reason_Entries_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  RiskApprovalId = 'risk_approval_id',
}

/** placeholder for update columns of table "risk_approval_reason_entries" (current role has no relevant permissions) */
export enum Risk_Approval_Reason_Entries_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

export enum Risk_Approval_Reasons_Enum {
  AdditionOfRiskToRiskRegister = 'Addition_of_risk_to_risk_register',
  ClosingTheRisk = 'Closing_the_risk',
  InherentRiskLevel = 'Inherent_risk_level',
  Other = 'Other',
  ResidualRiskLevel = 'Residual_risk_level',
  Treatment = 'Treatment',
}

/** Boolean expression to compare columns of type "risk_approval_reasons_enum". All fields are combined with logical 'AND'. */
export type Risk_Approval_Reasons_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Risk_Approval_Reasons_Enum>;
  _in?: InputMaybe<Array<Risk_Approval_Reasons_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Risk_Approval_Reasons_Enum>;
  _nin?: InputMaybe<Array<Risk_Approval_Reasons_Enum>>;
};

export enum Risk_Approval_Statuses_Enum {
  Approved = 'Approved',
  AwaitingApproval = 'Awaiting_approval',
  DueSoon = 'Due_soon',
  Expiring = 'Expiring',
  NeedMoreInformation = 'Need_more_information',
  Outdated = 'Outdated',
  Overdue = 'Overdue',
  Rejected = 'Rejected',
  TentativelyApproved = 'Tentatively_approved',
}

/** Boolean expression to compare columns of type "risk_approval_statuses_enum". All fields are combined with logical 'AND'. */
export type Risk_Approval_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Risk_Approval_Statuses_Enum>;
  _in?: InputMaybe<Array<Risk_Approval_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Risk_Approval_Statuses_Enum>;
  _nin?: InputMaybe<Array<Risk_Approval_Statuses_Enum>>;
};

/** Approval requests for risks */
export type Risk_Approvals = {
  __typename?: 'risk_approvals';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** If true, all approvers must respond. If false, only one approver needs to approve. */
  require_all_approvers: Scalars['Boolean']['output'];
  /** An object relationship */
  risk: Risks;
  /** An array relationship */
  risk_approval_files: Array<Risk_Approval_Files>;
  /** An array relationship */
  risk_approval_reason_entries: Array<Risk_Approval_Reason_Entries>;
  /** An aggregate relationship */
  risk_approval_reason_entries_aggregate: Risk_Approval_Reason_Entries_Aggregate;
  /** An array relationship */
  risk_approvers: Array<Risk_Approvers>;
  /** An aggregate relationship */
  risk_approvers_aggregate: Risk_Approvers_Aggregate;
  risk_id: Scalars['uuid']['output'];
  status: Risk_Approval_Statuses_Enum;
  subject: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** Approval requests for risks */
export type Risk_ApprovalsRisk_Approval_FilesArgs = {
  distinct_on?: InputMaybe<Array<Risk_Approval_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Approval_Files_Order_By>>;
  where?: InputMaybe<Risk_Approval_Files_Bool_Exp>;
};

/** Approval requests for risks */
export type Risk_ApprovalsRisk_Approval_Reason_EntriesArgs = {
  distinct_on?: InputMaybe<Array<Risk_Approval_Reason_Entries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Approval_Reason_Entries_Order_By>>;
  where?: InputMaybe<Risk_Approval_Reason_Entries_Bool_Exp>;
};

/** Approval requests for risks */
export type Risk_ApprovalsRisk_Approval_Reason_Entries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Approval_Reason_Entries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Approval_Reason_Entries_Order_By>>;
  where?: InputMaybe<Risk_Approval_Reason_Entries_Bool_Exp>;
};

/** Approval requests for risks */
export type Risk_ApprovalsRisk_ApproversArgs = {
  distinct_on?: InputMaybe<Array<Risk_Approvers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Approvers_Order_By>>;
  where?: InputMaybe<Risk_Approvers_Bool_Exp>;
};

/** Approval requests for risks */
export type Risk_ApprovalsRisk_Approvers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Approvers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Approvers_Order_By>>;
  where?: InputMaybe<Risk_Approvers_Bool_Exp>;
};

/** aggregated selection of "risk_approvals" */
export type Risk_Approvals_Aggregate = {
  __typename?: 'risk_approvals_aggregate';
  aggregate?: Maybe<Risk_Approvals_Aggregate_Fields>;
  nodes: Array<Risk_Approvals>;
};

export type Risk_Approvals_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Risk_Approvals_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Risk_Approvals_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Risk_Approvals_Aggregate_Bool_Exp_Count>;
};

export type Risk_Approvals_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risk_Approvals_Select_Column_Risk_Approvals_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risk_Approvals_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risk_Approvals_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risk_Approvals_Select_Column_Risk_Approvals_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risk_Approvals_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risk_Approvals_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Risk_Approvals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risk_Approvals_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risk_approvals" */
export type Risk_Approvals_Aggregate_Fields = {
  __typename?: 'risk_approvals_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Risk_Approvals_Max_Fields>;
  min?: Maybe<Risk_Approvals_Min_Fields>;
};

/** aggregate fields of "risk_approvals" */
export type Risk_Approvals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risk_Approvals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risk_approvals" */
export type Risk_Approvals_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Approvals_Max_Order_By>;
  min?: InputMaybe<Risk_Approvals_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risk_approvals" */
export type Risk_Approvals_Arr_Rel_Insert_Input = {
  data: Array<Risk_Approvals_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Approvals_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risk_approvals". All fields are combined with a logical 'AND'. */
export type Risk_Approvals_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Approvals_Bool_Exp>>;
  _not?: InputMaybe<Risk_Approvals_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Approvals_Bool_Exp>>;
  approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiry_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  require_all_approvers?: InputMaybe<Boolean_Comparison_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risk_approval_files?: InputMaybe<Risk_Approval_Files_Bool_Exp>;
  risk_approval_reason_entries?: InputMaybe<Risk_Approval_Reason_Entries_Bool_Exp>;
  risk_approval_reason_entries_aggregate?: InputMaybe<Risk_Approval_Reason_Entries_Aggregate_Bool_Exp>;
  risk_approvers?: InputMaybe<Risk_Approvers_Bool_Exp>;
  risk_approvers_aggregate?: InputMaybe<Risk_Approvers_Aggregate_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Risk_Approval_Statuses_Enum_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "risk_approvals" */
export enum Risk_Approvals_Constraint {
  /** unique or primary key constraint on columns "id" */
  RiskApprovalsPkey = 'risk_approvals_pkey',
}

/** input type for inserting data into table "risk_approvals" */
export type Risk_Approvals_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** If true, all approvers must respond. If false, only one approver needs to approve. */
  require_all_approvers?: InputMaybe<Scalars['Boolean']['input']>;
  risk?: InputMaybe<Risks_Obj_Rel_Insert_Input>;
  risk_approval_files?: InputMaybe<Risk_Approval_Files_Arr_Rel_Insert_Input>;
  risk_approval_reason_entries?: InputMaybe<Risk_Approval_Reason_Entries_Arr_Rel_Insert_Input>;
  risk_approvers?: InputMaybe<Risk_Approvers_Arr_Rel_Insert_Input>;
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Risk_Approvals_Max_Fields = {
  __typename?: 'risk_approvals_max_fields';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  risk_id?: Maybe<Scalars['uuid']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "risk_approvals" */
export type Risk_Approvals_Max_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Risk_Approvals_Min_Fields = {
  __typename?: 'risk_approvals_min_fields';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  risk_id?: Maybe<Scalars['uuid']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "risk_approvals" */
export type Risk_Approvals_Min_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_approvals" */
export type Risk_Approvals_Mutation_Response = {
  __typename?: 'risk_approvals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Approvals>;
};

/** input type for inserting object relation for remote table "risk_approvals" */
export type Risk_Approvals_Obj_Rel_Insert_Input = {
  data: Risk_Approvals_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Approvals_On_Conflict>;
};

/** on_conflict condition type for table "risk_approvals" */
export type Risk_Approvals_On_Conflict = {
  constraint: Risk_Approvals_Constraint;
  update_columns?: Array<Risk_Approvals_Update_Column>;
  where?: InputMaybe<Risk_Approvals_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_approvals". */
export type Risk_Approvals_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  require_all_approvers?: InputMaybe<Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risk_approval_files_aggregate?: InputMaybe<Risk_Approval_Files_Aggregate_Order_By>;
  risk_approval_reason_entries_aggregate?: InputMaybe<Risk_Approval_Reason_Entries_Aggregate_Order_By>;
  risk_approvers_aggregate?: InputMaybe<Risk_Approvers_Aggregate_Order_By>;
  risk_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: risk_approvals */
export type Risk_Approvals_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_approvals" */
export enum Risk_Approvals_Select_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Name = 'name',
  /** column name */
  RequireAllApprovers = 'require_all_approvers',
  /** column name */
  RiskId = 'risk_id',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** select "risk_approvals_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risk_approvals" */
export enum Risk_Approvals_Select_Column_Risk_Approvals_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  RequireAllApprovers = 'require_all_approvers',
}

/** select "risk_approvals_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risk_approvals" */
export enum Risk_Approvals_Select_Column_Risk_Approvals_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  RequireAllApprovers = 'require_all_approvers',
}

/** input type for updating data in table "risk_approvals" */
export type Risk_Approvals_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** If true, all approvers must respond. If false, only one approver needs to approve. */
  require_all_approvers?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risk_approvals" */
export enum Risk_Approvals_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Message = 'message',
  /** column name */
  Name = 'name',
  /** column name */
  RequireAllApprovers = 'require_all_approvers',
  /** column name */
  Subject = 'subject',
}

export type Risk_Approvals_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risk_Approvals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risk_Approvals_Bool_Exp;
};

export enum Risk_Approver_Responses_Enum {
  Approved = 'Approved',
  DueSoon = 'Due_soon',
  NeedMoreInformation = 'Need_more_information',
  Overdue = 'Overdue',
  Pending = 'Pending',
  Rejected = 'Rejected',
  TentativelyApproved = 'Tentatively_approved',
  Withdrawn = 'Withdrawn',
}

/** Boolean expression to compare columns of type "risk_approver_responses_enum". All fields are combined with logical 'AND'. */
export type Risk_Approver_Responses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Risk_Approver_Responses_Enum>;
  _in?: InputMaybe<Array<Risk_Approver_Responses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Risk_Approver_Responses_Enum>;
  _nin?: InputMaybe<Array<Risk_Approver_Responses_Enum>>;
};

/** Individual approvers for risk approval requests */
export type Risk_Approvers = {
  __typename?: 'risk_approvers';
  /** Optional comment from the approver */
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  responded_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The approver's response: Pending, Approved, Rejected, etc. */
  response?: Maybe<Risk_Approver_Responses_Enum>;
  /** An object relationship */
  risk_approval: Risk_Approvals;
  risk_approval_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "risk_approvers" */
export type Risk_Approvers_Aggregate = {
  __typename?: 'risk_approvers_aggregate';
  aggregate?: Maybe<Risk_Approvers_Aggregate_Fields>;
  nodes: Array<Risk_Approvers>;
};

export type Risk_Approvers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Risk_Approvers_Aggregate_Bool_Exp_Count>;
};

export type Risk_Approvers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Risk_Approvers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risk_Approvers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risk_approvers" */
export type Risk_Approvers_Aggregate_Fields = {
  __typename?: 'risk_approvers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Risk_Approvers_Max_Fields>;
  min?: Maybe<Risk_Approvers_Min_Fields>;
};

/** aggregate fields of "risk_approvers" */
export type Risk_Approvers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risk_Approvers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risk_approvers" */
export type Risk_Approvers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Approvers_Max_Order_By>;
  min?: InputMaybe<Risk_Approvers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risk_approvers" */
export type Risk_Approvers_Arr_Rel_Insert_Input = {
  data: Array<Risk_Approvers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Approvers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risk_approvers". All fields are combined with a logical 'AND'. */
export type Risk_Approvers_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Approvers_Bool_Exp>>;
  _not?: InputMaybe<Risk_Approvers_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Approvers_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_nudged_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  responded_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  response?: InputMaybe<Risk_Approver_Responses_Enum_Comparison_Exp>;
  risk_approval?: InputMaybe<Risk_Approvals_Bool_Exp>;
  risk_approval_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risk_approvers" */
export enum Risk_Approvers_Constraint {
  /** unique or primary key constraint on columns "id" */
  RiskApproversPkey = 'risk_approvers_pkey',
  /** unique or primary key constraint on columns "user_id", "risk_approval_id" */
  RiskApproversRiskApprovalIdUserIdKey = 'risk_approvers_risk_approval_id_user_id_key',
}

/** input type for inserting data into table "risk_approvers" */
export type Risk_Approvers_Insert_Input = {
  risk_approval?: InputMaybe<Risk_Approvals_Obj_Rel_Insert_Input>;
  risk_approval_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Risk_Approvers_Max_Fields = {
  __typename?: 'risk_approvers_max_fields';
  /** Optional comment from the approver */
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  responded_at?: Maybe<Scalars['timestamptz']['output']>;
  risk_approval_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risk_approvers" */
export type Risk_Approvers_Max_Order_By = {
  /** Optional comment from the approver */
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  responded_at?: InputMaybe<Order_By>;
  risk_approval_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Risk_Approvers_Min_Fields = {
  __typename?: 'risk_approvers_min_fields';
  /** Optional comment from the approver */
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  responded_at?: Maybe<Scalars['timestamptz']['output']>;
  risk_approval_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risk_approvers" */
export type Risk_Approvers_Min_Order_By = {
  /** Optional comment from the approver */
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  responded_at?: InputMaybe<Order_By>;
  risk_approval_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_approvers" */
export type Risk_Approvers_Mutation_Response = {
  __typename?: 'risk_approvers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Approvers>;
};

/** on_conflict condition type for table "risk_approvers" */
export type Risk_Approvers_On_Conflict = {
  constraint: Risk_Approvers_Constraint;
  update_columns?: Array<Risk_Approvers_Update_Column>;
  where?: InputMaybe<Risk_Approvers_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_approvers". */
export type Risk_Approvers_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  responded_at?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  risk_approval?: InputMaybe<Risk_Approvals_Order_By>;
  risk_approval_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: risk_approvers */
export type Risk_Approvers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_approvers" */
export enum Risk_Approvers_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastNudgedAt = 'last_nudged_at',
  /** column name */
  RespondedAt = 'responded_at',
  /** column name */
  Response = 'response',
  /** column name */
  RiskApprovalId = 'risk_approval_id',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "risk_approvers" */
export type Risk_Approvers_Set_Input = {
  /** Optional comment from the approver */
  comment?: InputMaybe<Scalars['String']['input']>;
  responded_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The approver's response: Pending, Approved, Rejected, etc. */
  response?: InputMaybe<Risk_Approver_Responses_Enum>;
};

/** update columns of table "risk_approvers" */
export enum Risk_Approvers_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  RespondedAt = 'responded_at',
  /** column name */
  Response = 'response',
}

export type Risk_Approvers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risk_Approvers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risk_Approvers_Bool_Exp;
};

/** columns and relationships of "risk_categories" */
export type Risk_Categories = {
  __typename?: 'risk_categories';
  /** An object relationship */
  category: Organization_Risk_Categories;
  category_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  risk: Risks;
  risk_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "risk_categories" */
export type Risk_Categories_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Categories_Max_Order_By>;
  min?: InputMaybe<Risk_Categories_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risk_categories" */
export type Risk_Categories_Arr_Rel_Insert_Input = {
  data: Array<Risk_Categories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Categories_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risk_categories". All fields are combined with a logical 'AND'. */
export type Risk_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Categories_Bool_Exp>>;
  _not?: InputMaybe<Risk_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Categories_Bool_Exp>>;
  category?: InputMaybe<Organization_Risk_Categories_Bool_Exp>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risk_categories" */
export enum Risk_Categories_Constraint {
  /** unique or primary key constraint on columns "risk_id", "category_id" */
  RiskCategoriesCategoryIdRiskIdKey = 'risk_categories_category_id_risk_id_key',
  /** unique or primary key constraint on columns "id" */
  RiskCategoriesPkey = 'risk_categories_pkey',
}

/** input type for inserting data into table "risk_categories" */
export type Risk_Categories_Insert_Input = {
  category?: InputMaybe<Organization_Risk_Categories_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  risk?: InputMaybe<Risks_Obj_Rel_Insert_Input>;
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "risk_categories" */
export type Risk_Categories_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risk_categories" */
export type Risk_Categories_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_categories" */
export type Risk_Categories_Mutation_Response = {
  __typename?: 'risk_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Categories>;
};

/** on_conflict condition type for table "risk_categories" */
export type Risk_Categories_On_Conflict = {
  constraint: Risk_Categories_Constraint;
  update_columns?: Array<Risk_Categories_Update_Column>;
  where?: InputMaybe<Risk_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_categories". */
export type Risk_Categories_Order_By = {
  category?: InputMaybe<Organization_Risk_Categories_Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risk_id?: InputMaybe<Order_By>;
};

/** select columns of table "risk_categories" */
export enum Risk_Categories_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Id = 'id',
  /** column name */
  RiskId = 'risk_id',
}

/** placeholder for update columns of table "risk_categories" (current role has no relevant permissions) */
export enum Risk_Categories_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** join table for controls associated with risk */
export type Risk_Controls = {
  __typename?: 'risk_controls';
  /** An object relationship */
  control?: Maybe<Controls>;
  control_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_control_primary: Scalars['Boolean']['output'];
  /** An object relationship */
  risk?: Maybe<Risks>;
  risk_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "risk_controls" */
export type Risk_Controls_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Controls_Max_Order_By>;
  min?: InputMaybe<Risk_Controls_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risk_controls" */
export type Risk_Controls_Arr_Rel_Insert_Input = {
  data: Array<Risk_Controls_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Controls_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risk_controls". All fields are combined with a logical 'AND'. */
export type Risk_Controls_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Controls_Bool_Exp>>;
  _not?: InputMaybe<Risk_Controls_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Controls_Bool_Exp>>;
  control?: InputMaybe<Controls_Bool_Exp>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_control_primary?: InputMaybe<Boolean_Comparison_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risk_controls" */
export enum Risk_Controls_Constraint {
  /** unique or primary key constraint on columns "id" */
  RiskControlsPkey = 'risk_controls_pkey',
  /** unique or primary key constraint on columns "risk_id", "control_id" */
  RiskControlsRiskIdControlIdKey = 'risk_controls_risk_id_control_id_key',
}

/** input type for inserting data into table "risk_controls" */
export type Risk_Controls_Insert_Input = {
  control?: InputMaybe<Controls_Obj_Rel_Insert_Input>;
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  is_control_primary?: InputMaybe<Scalars['Boolean']['input']>;
  risk?: InputMaybe<Risks_Obj_Rel_Insert_Input>;
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "risk_controls" */
export type Risk_Controls_Max_Order_By = {
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risk_controls" */
export type Risk_Controls_Min_Order_By = {
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_controls" */
export type Risk_Controls_Mutation_Response = {
  __typename?: 'risk_controls_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Controls>;
};

/** on_conflict condition type for table "risk_controls" */
export type Risk_Controls_On_Conflict = {
  constraint: Risk_Controls_Constraint;
  update_columns?: Array<Risk_Controls_Update_Column>;
  where?: InputMaybe<Risk_Controls_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_controls". */
export type Risk_Controls_Order_By = {
  control?: InputMaybe<Controls_Order_By>;
  control_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_control_primary?: InputMaybe<Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risk_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "risk_controls" */
export enum Risk_Controls_Select_Column {
  /** column name */
  ControlId = 'control_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsControlPrimary = 'is_control_primary',
  /** column name */
  RiskId = 'risk_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** placeholder for update columns of table "risk_controls" (current role has no relevant permissions) */
export enum Risk_Controls_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "risk_documents" */
export type Risk_Documents = {
  __typename?: 'risk_documents';
  /** An object relationship */
  file?: Maybe<Files>;
  file_id: Scalars['uuid']['output'];
  /** An object relationship */
  risk?: Maybe<Risks>;
  risk_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "risk_documents" */
export type Risk_Documents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Documents_Max_Order_By>;
  min?: InputMaybe<Risk_Documents_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risk_documents" */
export type Risk_Documents_Arr_Rel_Insert_Input = {
  data: Array<Risk_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Documents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risk_documents". All fields are combined with a logical 'AND'. */
export type Risk_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Documents_Bool_Exp>>;
  _not?: InputMaybe<Risk_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Documents_Bool_Exp>>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risk_documents" */
export enum Risk_Documents_Constraint {
  /** unique or primary key constraint on columns "file_id" */
  RiskDocumentsFileIdKey = 'risk_documents_file_id_key',
  /** unique or primary key constraint on columns "risk_id", "file_id" */
  RiskDocumentsPkey = 'risk_documents_pkey',
}

/** input type for inserting data into table "risk_documents" */
export type Risk_Documents_Insert_Input = {
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  risk?: InputMaybe<Risks_Obj_Rel_Insert_Input>;
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "risk_documents" */
export type Risk_Documents_Max_Order_By = {
  file_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risk_documents" */
export type Risk_Documents_Min_Order_By = {
  file_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_documents" */
export type Risk_Documents_Mutation_Response = {
  __typename?: 'risk_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Documents>;
};

/** input type for inserting object relation for remote table "risk_documents" */
export type Risk_Documents_Obj_Rel_Insert_Input = {
  data: Risk_Documents_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Documents_On_Conflict>;
};

/** on_conflict condition type for table "risk_documents" */
export type Risk_Documents_On_Conflict = {
  constraint: Risk_Documents_Constraint;
  update_columns?: Array<Risk_Documents_Update_Column>;
  where?: InputMaybe<Risk_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_documents". */
export type Risk_Documents_Order_By = {
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risk_id?: InputMaybe<Order_By>;
};

/** select columns of table "risk_documents" */
export enum Risk_Documents_Select_Column {
  /** column name */
  FileId = 'file_id',
  /** column name */
  RiskId = 'risk_id',
}

/** placeholder for update columns of table "risk_documents" (current role has no relevant permissions) */
export enum Risk_Documents_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "risk_impacts" */
export type Risk_Impacts = {
  __typename?: 'risk_impacts';
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  inherent_risk_impacts: Array<Risks>;
  /** An aggregate relationship */
  inherent_risk_impacts_aggregate: Risks_Aggregate;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  residual_risk_impacts: Array<Risks>;
  /** An aggregate relationship */
  residual_risk_impacts_aggregate: Risks_Aggregate;
  /** An array relationship */
  risk_inherent_levels: Array<Risk_Inherent_Levels>;
  /** An array relationship */
  risk_residual_levels: Array<Risk_Residual_Levels>;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "risk_impacts" */
export type Risk_ImpactsInherent_Risk_ImpactsArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

/** columns and relationships of "risk_impacts" */
export type Risk_ImpactsInherent_Risk_Impacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

/** columns and relationships of "risk_impacts" */
export type Risk_ImpactsResidual_Risk_ImpactsArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

/** columns and relationships of "risk_impacts" */
export type Risk_ImpactsResidual_Risk_Impacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

/** columns and relationships of "risk_impacts" */
export type Risk_ImpactsRisk_Inherent_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Inherent_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Inherent_Levels_Order_By>>;
  where?: InputMaybe<Risk_Inherent_Levels_Bool_Exp>;
};

/** columns and relationships of "risk_impacts" */
export type Risk_ImpactsRisk_Residual_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Residual_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Residual_Levels_Order_By>>;
  where?: InputMaybe<Risk_Residual_Levels_Bool_Exp>;
};

/** order by aggregate values of table "risk_impacts" */
export type Risk_Impacts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Impacts_Max_Order_By>;
  min?: InputMaybe<Risk_Impacts_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risk_impacts". All fields are combined with a logical 'AND'. */
export type Risk_Impacts_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Impacts_Bool_Exp>>;
  _not?: InputMaybe<Risk_Impacts_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Impacts_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inherent_risk_impacts?: InputMaybe<Risks_Bool_Exp>;
  inherent_risk_impacts_aggregate?: InputMaybe<Risks_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  residual_risk_impacts?: InputMaybe<Risks_Bool_Exp>;
  residual_risk_impacts_aggregate?: InputMaybe<Risks_Aggregate_Bool_Exp>;
  risk_inherent_levels?: InputMaybe<Risk_Inherent_Levels_Bool_Exp>;
  risk_residual_levels?: InputMaybe<Risk_Residual_Levels_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risk_impacts" */
export enum Risk_Impacts_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationRiskImpactsPkey = 'organization_risk_impacts_pkey',
  /** unique or primary key constraint on columns "organization_id", "name" */
  RiskImpactsNameOrganizationIdKey = 'risk_impacts_name_organization_id_key',
  /** unique or primary key constraint on columns "organization_id", "order" */
  RiskImpactsOrganizationIdOrderKey = 'risk_impacts_organization_id_order_key',
}

/** input type for inserting data into table "risk_impacts" */
export type Risk_Impacts_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  inherent_risk_impacts?: InputMaybe<Risks_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  residual_risk_impacts?: InputMaybe<Risks_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "risk_impacts" */
export type Risk_Impacts_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risk_impacts" */
export type Risk_Impacts_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_impacts" */
export type Risk_Impacts_Mutation_Response = {
  __typename?: 'risk_impacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Impacts>;
};

/** input type for inserting object relation for remote table "risk_impacts" */
export type Risk_Impacts_Obj_Rel_Insert_Input = {
  data: Risk_Impacts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Impacts_On_Conflict>;
};

/** on_conflict condition type for table "risk_impacts" */
export type Risk_Impacts_On_Conflict = {
  constraint: Risk_Impacts_Constraint;
  update_columns?: Array<Risk_Impacts_Update_Column>;
  where?: InputMaybe<Risk_Impacts_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_impacts". */
export type Risk_Impacts_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inherent_risk_impacts_aggregate?: InputMaybe<Risks_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  residual_risk_impacts_aggregate?: InputMaybe<Risks_Aggregate_Order_By>;
  risk_inherent_levels_aggregate?: InputMaybe<Risk_Inherent_Levels_Aggregate_Order_By>;
  risk_residual_levels_aggregate?: InputMaybe<Risk_Residual_Levels_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: risk_impacts */
export type Risk_Impacts_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_impacts" */
export enum Risk_Impacts_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "risk_impacts" */
export type Risk_Impacts_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "risk_impacts" */
export type Risk_Impacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Impacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Impacts_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "risk_impacts" */
export enum Risk_Impacts_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Risk_Impacts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risk_Impacts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risk_Impacts_Bool_Exp;
};

/** columns and relationships of "risk_inherent_levels" */
export type Risk_Inherent_Levels = {
  __typename?: 'risk_inherent_levels';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization_risk_level: Organization_Risk_Levels;
  organization_risk_level_id: Scalars['uuid']['output'];
  /** An object relationship */
  risk_impact: Risk_Impacts;
  /** An object relationship */
  risk_likelihood: Risk_Likelihoods;
};

/** order by aggregate values of table "risk_inherent_levels" */
export type Risk_Inherent_Levels_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Inherent_Levels_Max_Order_By>;
  min?: InputMaybe<Risk_Inherent_Levels_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risk_inherent_levels". All fields are combined with a logical 'AND'. */
export type Risk_Inherent_Levels_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Inherent_Levels_Bool_Exp>>;
  _not?: InputMaybe<Risk_Inherent_Levels_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Inherent_Levels_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_risk_level?: InputMaybe<Organization_Risk_Levels_Bool_Exp>;
  organization_risk_level_id?: InputMaybe<Uuid_Comparison_Exp>;
  risk_impact?: InputMaybe<Risk_Impacts_Bool_Exp>;
  risk_likelihood?: InputMaybe<Risk_Likelihoods_Bool_Exp>;
};

/** order by max() on columns of table "risk_inherent_levels" */
export type Risk_Inherent_Levels_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_risk_level_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risk_inherent_levels" */
export type Risk_Inherent_Levels_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_risk_level_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_inherent_levels" */
export type Risk_Inherent_Levels_Mutation_Response = {
  __typename?: 'risk_inherent_levels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Inherent_Levels>;
};

/** Ordering options when selecting data from "risk_inherent_levels". */
export type Risk_Inherent_Levels_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_risk_level?: InputMaybe<Organization_Risk_Levels_Order_By>;
  organization_risk_level_id?: InputMaybe<Order_By>;
  risk_impact?: InputMaybe<Risk_Impacts_Order_By>;
  risk_likelihood?: InputMaybe<Risk_Likelihoods_Order_By>;
};

/** primary key columns input for table: risk_inherent_levels */
export type Risk_Inherent_Levels_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_inherent_levels" */
export enum Risk_Inherent_Levels_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationRiskLevelId = 'organization_risk_level_id',
}

/** input type for updating data in table "risk_inherent_levels" */
export type Risk_Inherent_Levels_Set_Input = {
  organization_risk_level_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "risk_inherent_levels" */
export type Risk_Inherent_Levels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Inherent_Levels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Inherent_Levels_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_risk_level_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Risk_Inherent_Levels_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risk_Inherent_Levels_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risk_Inherent_Levels_Bool_Exp;
};

/** columns and relationships of "risk_likelihoods" */
export type Risk_Likelihoods = {
  __typename?: 'risk_likelihoods';
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  inherent_risk_likelihoods: Array<Risks>;
  /** An aggregate relationship */
  inherent_risk_likelihoods_aggregate: Risks_Aggregate;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  residual_risk_likelihoods: Array<Risks>;
  /** An aggregate relationship */
  residual_risk_likelihoods_aggregate: Risks_Aggregate;
  /** An array relationship */
  risk_inherent_levels: Array<Risk_Inherent_Levels>;
  /** An array relationship */
  risk_residual_levels: Array<Risk_Residual_Levels>;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "risk_likelihoods" */
export type Risk_LikelihoodsInherent_Risk_LikelihoodsArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

/** columns and relationships of "risk_likelihoods" */
export type Risk_LikelihoodsInherent_Risk_Likelihoods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

/** columns and relationships of "risk_likelihoods" */
export type Risk_LikelihoodsResidual_Risk_LikelihoodsArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

/** columns and relationships of "risk_likelihoods" */
export type Risk_LikelihoodsResidual_Risk_Likelihoods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

/** columns and relationships of "risk_likelihoods" */
export type Risk_LikelihoodsRisk_Inherent_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Inherent_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Inherent_Levels_Order_By>>;
  where?: InputMaybe<Risk_Inherent_Levels_Bool_Exp>;
};

/** columns and relationships of "risk_likelihoods" */
export type Risk_LikelihoodsRisk_Residual_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Residual_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Residual_Levels_Order_By>>;
  where?: InputMaybe<Risk_Residual_Levels_Bool_Exp>;
};

/** order by aggregate values of table "risk_likelihoods" */
export type Risk_Likelihoods_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Likelihoods_Max_Order_By>;
  min?: InputMaybe<Risk_Likelihoods_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risk_likelihoods". All fields are combined with a logical 'AND'. */
export type Risk_Likelihoods_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Likelihoods_Bool_Exp>>;
  _not?: InputMaybe<Risk_Likelihoods_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Likelihoods_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inherent_risk_likelihoods?: InputMaybe<Risks_Bool_Exp>;
  inherent_risk_likelihoods_aggregate?: InputMaybe<Risks_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  residual_risk_likelihoods?: InputMaybe<Risks_Bool_Exp>;
  residual_risk_likelihoods_aggregate?: InputMaybe<Risks_Aggregate_Bool_Exp>;
  risk_inherent_levels?: InputMaybe<Risk_Inherent_Levels_Bool_Exp>;
  risk_residual_levels?: InputMaybe<Risk_Residual_Levels_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risk_likelihoods" */
export enum Risk_Likelihoods_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationRiskLikelihoodsPkey = 'organization_risk_likelihoods_pkey',
  /** unique or primary key constraint on columns "organization_id", "name" */
  RiskLikelihoodsNameOrganizationIdKey = 'risk_likelihoods_name_organization_id_key',
  /** unique or primary key constraint on columns "organization_id", "order" */
  RiskLikelihoodsOrganizationIdOrderKey = 'risk_likelihoods_organization_id_order_key',
}

/** input type for inserting data into table "risk_likelihoods" */
export type Risk_Likelihoods_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  inherent_risk_likelihoods?: InputMaybe<Risks_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  residual_risk_likelihoods?: InputMaybe<Risks_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "risk_likelihoods" */
export type Risk_Likelihoods_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risk_likelihoods" */
export type Risk_Likelihoods_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_likelihoods" */
export type Risk_Likelihoods_Mutation_Response = {
  __typename?: 'risk_likelihoods_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Likelihoods>;
};

/** input type for inserting object relation for remote table "risk_likelihoods" */
export type Risk_Likelihoods_Obj_Rel_Insert_Input = {
  data: Risk_Likelihoods_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Likelihoods_On_Conflict>;
};

/** on_conflict condition type for table "risk_likelihoods" */
export type Risk_Likelihoods_On_Conflict = {
  constraint: Risk_Likelihoods_Constraint;
  update_columns?: Array<Risk_Likelihoods_Update_Column>;
  where?: InputMaybe<Risk_Likelihoods_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_likelihoods". */
export type Risk_Likelihoods_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inherent_risk_likelihoods_aggregate?: InputMaybe<Risks_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  residual_risk_likelihoods_aggregate?: InputMaybe<Risks_Aggregate_Order_By>;
  risk_inherent_levels_aggregate?: InputMaybe<Risk_Inherent_Levels_Aggregate_Order_By>;
  risk_residual_levels_aggregate?: InputMaybe<Risk_Residual_Levels_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: risk_likelihoods */
export type Risk_Likelihoods_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_likelihoods" */
export enum Risk_Likelihoods_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "risk_likelihoods" */
export type Risk_Likelihoods_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "risk_likelihoods" */
export type Risk_Likelihoods_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Likelihoods_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Likelihoods_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "risk_likelihoods" */
export enum Risk_Likelihoods_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Risk_Likelihoods_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risk_Likelihoods_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risk_Likelihoods_Bool_Exp;
};

/** users responsible for risk */
export type Risk_Owners = {
  __typename?: 'risk_owners';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  owner_id: Scalars['uuid']['output'];
  /** An object relationship */
  risk: Risks;
  risk_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
};

/** order by aggregate values of table "risk_owners" */
export type Risk_Owners_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Owners_Max_Order_By>;
  min?: InputMaybe<Risk_Owners_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risk_owners" */
export type Risk_Owners_Arr_Rel_Insert_Input = {
  data: Array<Risk_Owners_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Owners_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risk_owners". All fields are combined with a logical 'AND'. */
export type Risk_Owners_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Owners_Bool_Exp>>;
  _not?: InputMaybe<Risk_Owners_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Owners_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "risk_owners" */
export enum Risk_Owners_Constraint {
  /** unique or primary key constraint on columns "id" */
  RiskOwnersPkey = 'risk_owners_pkey',
  /** unique or primary key constraint on columns "risk_id", "owner_id" */
  RiskOwnersRiskIdOwnerIdKey = 'risk_owners_risk_id_owner_id_key',
}

/** input type for inserting data into table "risk_owners" */
export type Risk_Owners_Insert_Input = {
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
  risk?: InputMaybe<Risks_Obj_Rel_Insert_Input>;
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "risk_owners" */
export type Risk_Owners_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risk_owners" */
export type Risk_Owners_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_owners" */
export type Risk_Owners_Mutation_Response = {
  __typename?: 'risk_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Owners>;
};

/** on_conflict condition type for table "risk_owners" */
export type Risk_Owners_On_Conflict = {
  constraint: Risk_Owners_Constraint;
  update_columns?: Array<Risk_Owners_Update_Column>;
  where?: InputMaybe<Risk_Owners_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_owners". */
export type Risk_Owners_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risk_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "risk_owners" */
export enum Risk_Owners_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  RiskId = 'risk_id',
}

/** placeholder for update columns of table "risk_owners" (current role has no relevant permissions) */
export enum Risk_Owners_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "risk_residual_levels" */
export type Risk_Residual_Levels = {
  __typename?: 'risk_residual_levels';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization_risk_level: Organization_Risk_Levels;
  organization_risk_level_id: Scalars['uuid']['output'];
  /** An object relationship */
  risk_impact: Risk_Impacts;
  /** An object relationship */
  risk_likelihood: Risk_Likelihoods;
};

/** order by aggregate values of table "risk_residual_levels" */
export type Risk_Residual_Levels_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Residual_Levels_Max_Order_By>;
  min?: InputMaybe<Risk_Residual_Levels_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risk_residual_levels". All fields are combined with a logical 'AND'. */
export type Risk_Residual_Levels_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Residual_Levels_Bool_Exp>>;
  _not?: InputMaybe<Risk_Residual_Levels_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Residual_Levels_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_risk_level?: InputMaybe<Organization_Risk_Levels_Bool_Exp>;
  organization_risk_level_id?: InputMaybe<Uuid_Comparison_Exp>;
  risk_impact?: InputMaybe<Risk_Impacts_Bool_Exp>;
  risk_likelihood?: InputMaybe<Risk_Likelihoods_Bool_Exp>;
};

/** order by max() on columns of table "risk_residual_levels" */
export type Risk_Residual_Levels_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_risk_level_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risk_residual_levels" */
export type Risk_Residual_Levels_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_risk_level_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_residual_levels" */
export type Risk_Residual_Levels_Mutation_Response = {
  __typename?: 'risk_residual_levels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Residual_Levels>;
};

/** Ordering options when selecting data from "risk_residual_levels". */
export type Risk_Residual_Levels_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_risk_level?: InputMaybe<Organization_Risk_Levels_Order_By>;
  organization_risk_level_id?: InputMaybe<Order_By>;
  risk_impact?: InputMaybe<Risk_Impacts_Order_By>;
  risk_likelihood?: InputMaybe<Risk_Likelihoods_Order_By>;
};

/** primary key columns input for table: risk_residual_levels */
export type Risk_Residual_Levels_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_residual_levels" */
export enum Risk_Residual_Levels_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationRiskLevelId = 'organization_risk_level_id',
}

/** input type for updating data in table "risk_residual_levels" */
export type Risk_Residual_Levels_Set_Input = {
  organization_risk_level_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "risk_residual_levels" */
export type Risk_Residual_Levels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Residual_Levels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Residual_Levels_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_risk_level_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Risk_Residual_Levels_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risk_Residual_Levels_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risk_Residual_Levels_Bool_Exp;
};

/** columns and relationships of "risk_tags" */
export type Risk_Tags = {
  __typename?: 'risk_tags';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  risk: Risks;
  risk_id: Scalars['uuid']['output'];
  /** An object relationship */
  tag: Organization_Risk_Tags;
  tag_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "risk_tags" */
export type Risk_Tags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Tags_Max_Order_By>;
  min?: InputMaybe<Risk_Tags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risk_tags" */
export type Risk_Tags_Arr_Rel_Insert_Input = {
  data: Array<Risk_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Tags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risk_tags". All fields are combined with a logical 'AND'. */
export type Risk_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Tags_Bool_Exp>>;
  _not?: InputMaybe<Risk_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Tags_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  tag?: InputMaybe<Organization_Risk_Tags_Bool_Exp>;
  tag_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risk_tags" */
export enum Risk_Tags_Constraint {
  /** unique or primary key constraint on columns "id" */
  RiskTagsPkey = 'risk_tags_pkey',
  /** unique or primary key constraint on columns "risk_id", "tag_id" */
  RiskTagsTagIdRiskIdKey = 'risk_tags_tag_id_risk_id_key',
}

/** input type for inserting data into table "risk_tags" */
export type Risk_Tags_Insert_Input = {
  risk?: InputMaybe<Risks_Obj_Rel_Insert_Input>;
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
  tag?: InputMaybe<Organization_Risk_Tags_Obj_Rel_Insert_Input>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "risk_tags" */
export type Risk_Tags_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risk_tags" */
export type Risk_Tags_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_tags" */
export type Risk_Tags_Mutation_Response = {
  __typename?: 'risk_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Tags>;
};

/** on_conflict condition type for table "risk_tags" */
export type Risk_Tags_On_Conflict = {
  constraint: Risk_Tags_Constraint;
  update_columns?: Array<Risk_Tags_Update_Column>;
  where?: InputMaybe<Risk_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_tags". */
export type Risk_Tags_Order_By = {
  id?: InputMaybe<Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risk_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Organization_Risk_Tags_Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** select columns of table "risk_tags" */
export enum Risk_Tags_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RiskId = 'risk_id',
  /** column name */
  TagId = 'tag_id',
}

/** placeholder for update columns of table "risk_tags" (current role has no relevant permissions) */
export enum Risk_Tags_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** Stores list of tasks linked to risks */
export type Risk_Tasks = {
  __typename?: 'risk_tasks';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  risk?: Maybe<Risks>;
  risk_id: Scalars['uuid']['output'];
  /** An object relationship */
  task?: Maybe<Tasks>;
  task_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "risk_tasks" */
export type Risk_Tasks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Tasks_Max_Order_By>;
  min?: InputMaybe<Risk_Tasks_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risk_tasks" */
export type Risk_Tasks_Arr_Rel_Insert_Input = {
  data: Array<Risk_Tasks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Tasks_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risk_tasks". All fields are combined with a logical 'AND'. */
export type Risk_Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Tasks_Bool_Exp>>;
  _not?: InputMaybe<Risk_Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Tasks_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risk_tasks" */
export enum Risk_Tasks_Constraint {
  /** unique or primary key constraint on columns "id" */
  RiskTasksPkey = 'risk_tasks_pkey',
  /** unique or primary key constraint on columns "task_id", "risk_id" */
  RiskTasksRiskIdTaskIdKey = 'risk_tasks_risk_id_task_id_key',
}

/** input type for inserting data into table "risk_tasks" */
export type Risk_Tasks_Insert_Input = {
  risk?: InputMaybe<Risks_Obj_Rel_Insert_Input>;
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
  task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "risk_tasks" */
export type Risk_Tasks_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risk_tasks" */
export type Risk_Tasks_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_tasks" */
export type Risk_Tasks_Mutation_Response = {
  __typename?: 'risk_tasks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Tasks>;
};

/** on_conflict condition type for table "risk_tasks" */
export type Risk_Tasks_On_Conflict = {
  constraint: Risk_Tasks_Constraint;
  update_columns?: Array<Risk_Tasks_Update_Column>;
  where?: InputMaybe<Risk_Tasks_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_tasks". */
export type Risk_Tasks_Order_By = {
  id?: InputMaybe<Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** select columns of table "risk_tasks" */
export enum Risk_Tasks_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RiskId = 'risk_id',
  /** column name */
  TaskId = 'task_id',
}

/** placeholder for update columns of table "risk_tasks" (current role has no relevant permissions) */
export enum Risk_Tasks_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** table contains list of risks related to organizations */
export type Risks = {
  __typename?: 'risks';
  /** System-managed effective user-visible status of the Addition_of_risk_to_risk_register approval reason bucket. */
  approval_status_addition_of_risk_to_risk_register?: Maybe<Scalars['String']['output']>;
  /** System-managed effective user-visible status of the Closing_the_risk approval reason bucket. */
  approval_status_closing_the_risk?: Maybe<Scalars['String']['output']>;
  /** System-managed effective user-visible status of the Inherent_risk_level approval reason bucket. */
  approval_status_inherent_risk_level?: Maybe<Scalars['String']['output']>;
  /** System-managed effective user-visible status of the Residual_risk_level approval reason bucket. */
  approval_status_residual_risk_level?: Maybe<Scalars['String']['output']>;
  /** System-managed effective user-visible status of the Treatment approval reason bucket. */
  approval_status_treatment?: Maybe<Scalars['String']['output']>;
  /** System-managed union of bucket-effective user-visible risk approval statuses for this risk. */
  approval_statuses: Array<Scalars['String']['output']>;
  assessment_status: Scalars['RiskAssessmentStatus']['output'];
  /** An array relationship */
  categories: Array<Risk_Categories>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  control_findings: Array<Control_Findings>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  documents: Array<Risk_Documents>;
  /** An array relationship */
  field_values: Array<Field_Values>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  inherent_impact?: Maybe<Risk_Impacts>;
  inherent_impact_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  inherent_likelihood?: Maybe<Risk_Likelihoods>;
  inherent_likelihood_id?: Maybe<Scalars['uuid']['output']>;
  inherent_score?: Maybe<Scalars['Int']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_risk_last_review_date" */
  last_review_date?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** System-managed union of bucket-effective user-visible statuses of Other-reason approvals, bucketed by approval name. */
  other_approval_statuses: Array<Scalars['String']['output']>;
  /** An object relationship */
  residual_impact?: Maybe<Risk_Impacts>;
  residual_impact_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  residual_likelihood?: Maybe<Risk_Likelihoods>;
  residual_likelihood_id?: Maybe<Scalars['uuid']['output']>;
  residual_score?: Maybe<Scalars['Int']['output']>;
  review_frequency: Frequencies_Enum;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** An array relationship */
  risk_approvals: Array<Risk_Approvals>;
  /** An aggregate relationship */
  risk_approvals_aggregate: Risk_Approvals_Aggregate;
  /** An array relationship */
  risk_controls: Array<Risk_Controls>;
  /** An array relationship */
  risk_owners: Array<Risk_Owners>;
  /** An array relationship */
  risks_comments: Array<Comments>;
  /** An array relationship */
  risks_notifications: Array<Notifications>;
  /** An array relationship */
  risks_vector_stores: Array<Ai_Risks_Vector_Store>;
  similarity?: Maybe<Scalars['float8']['output']>;
  /** An array relationship */
  source_entity_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  source_entity_relations_aggregate: Entity_Relations_Aggregate;
  /** An array relationship */
  tags: Array<Risk_Tags>;
  /** An array relationship */
  target_entity_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  target_entity_relations_aggregate: Entity_Relations_Aggregate;
  /** An array relationship */
  tasks: Array<Risk_Tasks>;
  treatment_details?: Maybe<Scalars['String']['output']>;
  treatment_plan: Treatment_Plan_Enum;
  treatment_strategy: Treatment_Strategy_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  vendor_findings: Array<Vendor_Findings>;
  /** An array relationship */
  vendor_risks: Array<Vendor_Risks>;
};

/** table contains list of risks related to organizations */
export type RisksCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Risk_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Categories_Order_By>>;
  where?: InputMaybe<Risk_Categories_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksControl_FindingsArgs = {
  distinct_on?: InputMaybe<Array<Control_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Findings_Order_By>>;
  where?: InputMaybe<Control_Findings_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Documents_Order_By>>;
  where?: InputMaybe<Risk_Documents_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksField_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Values_Order_By>>;
  where?: InputMaybe<Field_Values_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksRisk_ApprovalsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Approvals_Order_By>>;
  where?: InputMaybe<Risk_Approvals_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksRisk_Approvals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Approvals_Order_By>>;
  where?: InputMaybe<Risk_Approvals_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksRisk_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Controls_Order_By>>;
  where?: InputMaybe<Risk_Controls_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksRisk_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Risk_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Owners_Order_By>>;
  where?: InputMaybe<Risk_Owners_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksRisks_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksRisks_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksRisks_Vector_StoresArgs = {
  distinct_on?: InputMaybe<Array<Ai_Risks_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Risks_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Risks_Vector_Store_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksSource_Entity_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksSource_Entity_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksTagsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Tags_Order_By>>;
  where?: InputMaybe<Risk_Tags_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksTarget_Entity_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksTarget_Entity_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksTasksArgs = {
  distinct_on?: InputMaybe<Array<Risk_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Tasks_Order_By>>;
  where?: InputMaybe<Risk_Tasks_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksVendor_FindingsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Findings_Order_By>>;
  where?: InputMaybe<Vendor_Findings_Bool_Exp>;
};

/** table contains list of risks related to organizations */
export type RisksVendor_RisksArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Risks_Order_By>>;
  where?: InputMaybe<Vendor_Risks_Bool_Exp>;
};

/** aggregated selection of "risks" */
export type Risks_Aggregate = {
  __typename?: 'risks_aggregate';
  aggregate?: Maybe<Risks_Aggregate_Fields>;
  nodes: Array<Risks>;
};

export type Risks_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Risks_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Risks_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Risks_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Risks_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Risks_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Risks_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Risks_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Risks_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Risks_Aggregate_Bool_Exp_Var_Samp>;
};

export type Risks_Aggregate_Bool_Exp_Avg = {
  arguments: Risks_Select_Column_Risks_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Risks_Aggregate_Bool_Exp_Corr = {
  arguments: Risks_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Risks_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Risks_Select_Column_Risks_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Risks_Select_Column_Risks_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Risks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Risks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Risks_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Risks_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Risks_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Risks_Select_Column_Risks_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Risks_Select_Column_Risks_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Risks_Aggregate_Bool_Exp_Max = {
  arguments: Risks_Select_Column_Risks_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Risks_Aggregate_Bool_Exp_Min = {
  arguments: Risks_Select_Column_Risks_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Risks_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Risks_Select_Column_Risks_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Risks_Aggregate_Bool_Exp_Sum = {
  arguments: Risks_Select_Column_Risks_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Risks_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Risks_Select_Column_Risks_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "risks" */
export type Risks_Aggregate_Fields = {
  __typename?: 'risks_aggregate_fields';
  avg?: Maybe<Risks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Risks_Max_Fields>;
  min?: Maybe<Risks_Min_Fields>;
  stddev?: Maybe<Risks_Stddev_Fields>;
  stddev_pop?: Maybe<Risks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risks_Stddev_Samp_Fields>;
  sum?: Maybe<Risks_Sum_Fields>;
  var_pop?: Maybe<Risks_Var_Pop_Fields>;
  var_samp?: Maybe<Risks_Var_Samp_Fields>;
  variance?: Maybe<Risks_Variance_Fields>;
};

/** aggregate fields of "risks" */
export type Risks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risks" */
export type Risks_Aggregate_Order_By = {
  avg?: InputMaybe<Risks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risks_Max_Order_By>;
  min?: InputMaybe<Risks_Min_Order_By>;
  stddev?: InputMaybe<Risks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Risks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Risks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Risks_Sum_Order_By>;
  var_pop?: InputMaybe<Risks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Risks_Var_Samp_Order_By>;
  variance?: InputMaybe<Risks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risks" */
export type Risks_Arr_Rel_Insert_Input = {
  data: Array<Risks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risks_On_Conflict>;
};

/** aggregate avg on columns */
export type Risks_Avg_Fields = {
  __typename?: 'risks_avg_fields';
  inherent_score?: Maybe<Scalars['Float']['output']>;
  residual_score?: Maybe<Scalars['Float']['output']>;
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "risks" */
export type Risks_Avg_Order_By = {
  inherent_score?: InputMaybe<Order_By>;
  residual_score?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risks". All fields are combined with a logical 'AND'. */
export type Risks_Bool_Exp = {
  _and?: InputMaybe<Array<Risks_Bool_Exp>>;
  _not?: InputMaybe<Risks_Bool_Exp>;
  _or?: InputMaybe<Array<Risks_Bool_Exp>>;
  approval_status_addition_of_risk_to_risk_register?: InputMaybe<String_Comparison_Exp>;
  approval_status_closing_the_risk?: InputMaybe<String_Comparison_Exp>;
  approval_status_inherent_risk_level?: InputMaybe<String_Comparison_Exp>;
  approval_status_residual_risk_level?: InputMaybe<String_Comparison_Exp>;
  approval_status_treatment?: InputMaybe<String_Comparison_Exp>;
  approval_statuses?: InputMaybe<String_Array_Comparison_Exp>;
  assessment_status?: InputMaybe<String_Comparison_Exp>;
  categories?: InputMaybe<Risk_Categories_Bool_Exp>;
  closed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  control_findings?: InputMaybe<Control_Findings_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  documents?: InputMaybe<Risk_Documents_Bool_Exp>;
  field_values?: InputMaybe<Field_Values_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inherent_impact?: InputMaybe<Risk_Impacts_Bool_Exp>;
  inherent_impact_id?: InputMaybe<Uuid_Comparison_Exp>;
  inherent_likelihood?: InputMaybe<Risk_Likelihoods_Bool_Exp>;
  inherent_likelihood_id?: InputMaybe<Uuid_Comparison_Exp>;
  inherent_score?: InputMaybe<Int_Comparison_Exp>;
  internal_id?: InputMaybe<String_Comparison_Exp>;
  last_review_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  other_approval_statuses?: InputMaybe<String_Array_Comparison_Exp>;
  residual_impact?: InputMaybe<Risk_Impacts_Bool_Exp>;
  residual_impact_id?: InputMaybe<Uuid_Comparison_Exp>;
  residual_likelihood?: InputMaybe<Risk_Likelihoods_Bool_Exp>;
  residual_likelihood_id?: InputMaybe<Uuid_Comparison_Exp>;
  residual_score?: InputMaybe<Int_Comparison_Exp>;
  review_frequency?: InputMaybe<Frequencies_Enum_Comparison_Exp>;
  reviews?: InputMaybe<Reviews_Bool_Exp>;
  risk_approvals?: InputMaybe<Risk_Approvals_Bool_Exp>;
  risk_approvals_aggregate?: InputMaybe<Risk_Approvals_Aggregate_Bool_Exp>;
  risk_controls?: InputMaybe<Risk_Controls_Bool_Exp>;
  risk_owners?: InputMaybe<Risk_Owners_Bool_Exp>;
  risks_comments?: InputMaybe<Comments_Bool_Exp>;
  risks_notifications?: InputMaybe<Notifications_Bool_Exp>;
  risks_vector_stores?: InputMaybe<Ai_Risks_Vector_Store_Bool_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  source_entity_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  source_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Risk_Tags_Bool_Exp>;
  target_entity_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  target_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  tasks?: InputMaybe<Risk_Tasks_Bool_Exp>;
  treatment_details?: InputMaybe<String_Comparison_Exp>;
  treatment_plan?: InputMaybe<Treatment_Plan_Enum_Comparison_Exp>;
  treatment_strategy?: InputMaybe<Treatment_Strategy_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor_findings?: InputMaybe<Vendor_Findings_Bool_Exp>;
  vendor_risks?: InputMaybe<Vendor_Risks_Bool_Exp>;
};

/** unique or primary key constraints on table "risks" */
export enum Risks_Constraint {
  /** unique or primary key constraint on columns "organization_id", "internal_id" */
  RisksOrganizationIdInternalIdKey = 'risks_organization_id_internal_id_key',
  /** unique or primary key constraint on columns "id" */
  RisksPkey = 'risks_pkey',
}

/** input type for inserting data into table "risks" */
export type Risks_Insert_Input = {
  categories?: InputMaybe<Risk_Categories_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Risk_Documents_Arr_Rel_Insert_Input>;
  field_values?: InputMaybe<Field_Values_Arr_Rel_Insert_Input>;
  inherent_impact?: InputMaybe<Risk_Impacts_Obj_Rel_Insert_Input>;
  inherent_likelihood?: InputMaybe<Risk_Likelihoods_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  residual_impact?: InputMaybe<Risk_Impacts_Obj_Rel_Insert_Input>;
  residual_likelihood?: InputMaybe<Risk_Likelihoods_Obj_Rel_Insert_Input>;
  reviews?: InputMaybe<Reviews_Arr_Rel_Insert_Input>;
  risk_approvals?: InputMaybe<Risk_Approvals_Arr_Rel_Insert_Input>;
  risk_controls?: InputMaybe<Risk_Controls_Arr_Rel_Insert_Input>;
  risk_owners?: InputMaybe<Risk_Owners_Arr_Rel_Insert_Input>;
  risks_comments?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  source_entity_relations?: InputMaybe<Entity_Relations_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Risk_Tags_Arr_Rel_Insert_Input>;
  target_entity_relations?: InputMaybe<Entity_Relations_Arr_Rel_Insert_Input>;
  tasks?: InputMaybe<Risk_Tasks_Arr_Rel_Insert_Input>;
  treatment_details?: InputMaybe<Scalars['String']['input']>;
  vendor_risks?: InputMaybe<Vendor_Risks_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Risks_Max_Fields = {
  __typename?: 'risks_max_fields';
  /** System-managed effective user-visible status of the Addition_of_risk_to_risk_register approval reason bucket. */
  approval_status_addition_of_risk_to_risk_register?: Maybe<Scalars['String']['output']>;
  /** System-managed effective user-visible status of the Closing_the_risk approval reason bucket. */
  approval_status_closing_the_risk?: Maybe<Scalars['String']['output']>;
  /** System-managed effective user-visible status of the Inherent_risk_level approval reason bucket. */
  approval_status_inherent_risk_level?: Maybe<Scalars['String']['output']>;
  /** System-managed effective user-visible status of the Residual_risk_level approval reason bucket. */
  approval_status_residual_risk_level?: Maybe<Scalars['String']['output']>;
  /** System-managed effective user-visible status of the Treatment approval reason bucket. */
  approval_status_treatment?: Maybe<Scalars['String']['output']>;
  /** System-managed union of bucket-effective user-visible risk approval statuses for this risk. */
  approval_statuses?: Maybe<Array<Scalars['String']['output']>>;
  assessment_status?: Maybe<Scalars['String']['output']>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inherent_impact_id?: Maybe<Scalars['uuid']['output']>;
  inherent_likelihood_id?: Maybe<Scalars['uuid']['output']>;
  inherent_score?: Maybe<Scalars['Int']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_risk_last_review_date" */
  last_review_date?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  /** System-managed union of bucket-effective user-visible statuses of Other-reason approvals, bucketed by approval name. */
  other_approval_statuses?: Maybe<Array<Scalars['String']['output']>>;
  residual_impact_id?: Maybe<Scalars['uuid']['output']>;
  residual_likelihood_id?: Maybe<Scalars['uuid']['output']>;
  residual_score?: Maybe<Scalars['Int']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  treatment_details?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "risks" */
export type Risks_Max_Order_By = {
  /** System-managed effective user-visible status of the Addition_of_risk_to_risk_register approval reason bucket. */
  approval_status_addition_of_risk_to_risk_register?: InputMaybe<Order_By>;
  /** System-managed effective user-visible status of the Closing_the_risk approval reason bucket. */
  approval_status_closing_the_risk?: InputMaybe<Order_By>;
  /** System-managed effective user-visible status of the Inherent_risk_level approval reason bucket. */
  approval_status_inherent_risk_level?: InputMaybe<Order_By>;
  /** System-managed effective user-visible status of the Residual_risk_level approval reason bucket. */
  approval_status_residual_risk_level?: InputMaybe<Order_By>;
  /** System-managed effective user-visible status of the Treatment approval reason bucket. */
  approval_status_treatment?: InputMaybe<Order_By>;
  /** System-managed union of bucket-effective user-visible risk approval statuses for this risk. */
  approval_statuses?: InputMaybe<Order_By>;
  assessment_status?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inherent_impact_id?: InputMaybe<Order_By>;
  inherent_likelihood_id?: InputMaybe<Order_By>;
  inherent_score?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  /** System-managed union of bucket-effective user-visible statuses of Other-reason approvals, bucketed by approval name. */
  other_approval_statuses?: InputMaybe<Order_By>;
  residual_impact_id?: InputMaybe<Order_By>;
  residual_likelihood_id?: InputMaybe<Order_By>;
  residual_score?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  treatment_details?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Risks_Min_Fields = {
  __typename?: 'risks_min_fields';
  /** System-managed effective user-visible status of the Addition_of_risk_to_risk_register approval reason bucket. */
  approval_status_addition_of_risk_to_risk_register?: Maybe<Scalars['String']['output']>;
  /** System-managed effective user-visible status of the Closing_the_risk approval reason bucket. */
  approval_status_closing_the_risk?: Maybe<Scalars['String']['output']>;
  /** System-managed effective user-visible status of the Inherent_risk_level approval reason bucket. */
  approval_status_inherent_risk_level?: Maybe<Scalars['String']['output']>;
  /** System-managed effective user-visible status of the Residual_risk_level approval reason bucket. */
  approval_status_residual_risk_level?: Maybe<Scalars['String']['output']>;
  /** System-managed effective user-visible status of the Treatment approval reason bucket. */
  approval_status_treatment?: Maybe<Scalars['String']['output']>;
  /** System-managed union of bucket-effective user-visible risk approval statuses for this risk. */
  approval_statuses?: Maybe<Array<Scalars['String']['output']>>;
  assessment_status?: Maybe<Scalars['String']['output']>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inherent_impact_id?: Maybe<Scalars['uuid']['output']>;
  inherent_likelihood_id?: Maybe<Scalars['uuid']['output']>;
  inherent_score?: Maybe<Scalars['Int']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_risk_last_review_date" */
  last_review_date?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  /** System-managed union of bucket-effective user-visible statuses of Other-reason approvals, bucketed by approval name. */
  other_approval_statuses?: Maybe<Array<Scalars['String']['output']>>;
  residual_impact_id?: Maybe<Scalars['uuid']['output']>;
  residual_likelihood_id?: Maybe<Scalars['uuid']['output']>;
  residual_score?: Maybe<Scalars['Int']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  treatment_details?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "risks" */
export type Risks_Min_Order_By = {
  /** System-managed effective user-visible status of the Addition_of_risk_to_risk_register approval reason bucket. */
  approval_status_addition_of_risk_to_risk_register?: InputMaybe<Order_By>;
  /** System-managed effective user-visible status of the Closing_the_risk approval reason bucket. */
  approval_status_closing_the_risk?: InputMaybe<Order_By>;
  /** System-managed effective user-visible status of the Inherent_risk_level approval reason bucket. */
  approval_status_inherent_risk_level?: InputMaybe<Order_By>;
  /** System-managed effective user-visible status of the Residual_risk_level approval reason bucket. */
  approval_status_residual_risk_level?: InputMaybe<Order_By>;
  /** System-managed effective user-visible status of the Treatment approval reason bucket. */
  approval_status_treatment?: InputMaybe<Order_By>;
  /** System-managed union of bucket-effective user-visible risk approval statuses for this risk. */
  approval_statuses?: InputMaybe<Order_By>;
  assessment_status?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inherent_impact_id?: InputMaybe<Order_By>;
  inherent_likelihood_id?: InputMaybe<Order_By>;
  inherent_score?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  /** System-managed union of bucket-effective user-visible statuses of Other-reason approvals, bucketed by approval name. */
  other_approval_statuses?: InputMaybe<Order_By>;
  residual_impact_id?: InputMaybe<Order_By>;
  residual_likelihood_id?: InputMaybe<Order_By>;
  residual_score?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  treatment_details?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risks" */
export type Risks_Mutation_Response = {
  __typename?: 'risks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risks>;
};

/** input type for inserting object relation for remote table "risks" */
export type Risks_Obj_Rel_Insert_Input = {
  data: Risks_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Risks_On_Conflict>;
};

/** on_conflict condition type for table "risks" */
export type Risks_On_Conflict = {
  constraint: Risks_Constraint;
  update_columns?: Array<Risks_Update_Column>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

/** Ordering options when selecting data from "risks". */
export type Risks_Order_By = {
  approval_status_addition_of_risk_to_risk_register?: InputMaybe<Order_By>;
  approval_status_closing_the_risk?: InputMaybe<Order_By>;
  approval_status_inherent_risk_level?: InputMaybe<Order_By>;
  approval_status_residual_risk_level?: InputMaybe<Order_By>;
  approval_status_treatment?: InputMaybe<Order_By>;
  approval_statuses?: InputMaybe<Order_By>;
  assessment_status?: InputMaybe<Order_By>;
  categories_aggregate?: InputMaybe<Risk_Categories_Aggregate_Order_By>;
  closed_at?: InputMaybe<Order_By>;
  control_findings_aggregate?: InputMaybe<Control_Findings_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Risk_Documents_Aggregate_Order_By>;
  field_values_aggregate?: InputMaybe<Field_Values_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  inherent_impact?: InputMaybe<Risk_Impacts_Order_By>;
  inherent_impact_id?: InputMaybe<Order_By>;
  inherent_likelihood?: InputMaybe<Risk_Likelihoods_Order_By>;
  inherent_likelihood_id?: InputMaybe<Order_By>;
  inherent_score?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_review_date?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  other_approval_statuses?: InputMaybe<Order_By>;
  residual_impact?: InputMaybe<Risk_Impacts_Order_By>;
  residual_impact_id?: InputMaybe<Order_By>;
  residual_likelihood?: InputMaybe<Risk_Likelihoods_Order_By>;
  residual_likelihood_id?: InputMaybe<Order_By>;
  residual_score?: InputMaybe<Order_By>;
  review_frequency?: InputMaybe<Order_By>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Order_By>;
  risk_approvals_aggregate?: InputMaybe<Risk_Approvals_Aggregate_Order_By>;
  risk_controls_aggregate?: InputMaybe<Risk_Controls_Aggregate_Order_By>;
  risk_owners_aggregate?: InputMaybe<Risk_Owners_Aggregate_Order_By>;
  risks_comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  risks_notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  risks_vector_stores_aggregate?: InputMaybe<Ai_Risks_Vector_Store_Aggregate_Order_By>;
  similarity?: InputMaybe<Order_By>;
  source_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Risk_Tags_Aggregate_Order_By>;
  target_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  tasks_aggregate?: InputMaybe<Risk_Tasks_Aggregate_Order_By>;
  treatment_details?: InputMaybe<Order_By>;
  treatment_plan?: InputMaybe<Order_By>;
  treatment_strategy?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_findings_aggregate?: InputMaybe<Vendor_Findings_Aggregate_Order_By>;
  vendor_risks_aggregate?: InputMaybe<Vendor_Risks_Aggregate_Order_By>;
};

/** primary key columns input for table: risks */
export type Risks_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risks" */
export enum Risks_Select_Column {
  /** column name */
  ApprovalStatusAdditionOfRiskToRiskRegister = 'approval_status_addition_of_risk_to_risk_register',
  /** column name */
  ApprovalStatusClosingTheRisk = 'approval_status_closing_the_risk',
  /** column name */
  ApprovalStatusInherentRiskLevel = 'approval_status_inherent_risk_level',
  /** column name */
  ApprovalStatusResidualRiskLevel = 'approval_status_residual_risk_level',
  /** column name */
  ApprovalStatusTreatment = 'approval_status_treatment',
  /** column name */
  ApprovalStatuses = 'approval_statuses',
  /** column name */
  AssessmentStatus = 'assessment_status',
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InherentImpactId = 'inherent_impact_id',
  /** column name */
  InherentLikelihoodId = 'inherent_likelihood_id',
  /** column name */
  InherentScore = 'inherent_score',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OtherApprovalStatuses = 'other_approval_statuses',
  /** column name */
  ResidualImpactId = 'residual_impact_id',
  /** column name */
  ResidualLikelihoodId = 'residual_likelihood_id',
  /** column name */
  ResidualScore = 'residual_score',
  /** column name */
  ReviewFrequency = 'review_frequency',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  TreatmentDetails = 'treatment_details',
  /** column name */
  TreatmentPlan = 'treatment_plan',
  /** column name */
  TreatmentStrategy = 'treatment_strategy',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** select "risks_aggregate_bool_exp_avg_arguments_columns" columns of table "risks" */
export enum Risks_Select_Column_Risks_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "risks_aggregate_bool_exp_corr_arguments_columns" columns of table "risks" */
export enum Risks_Select_Column_Risks_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "risks_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "risks" */
export enum Risks_Select_Column_Risks_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "risks_aggregate_bool_exp_max_arguments_columns" columns of table "risks" */
export enum Risks_Select_Column_Risks_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "risks_aggregate_bool_exp_min_arguments_columns" columns of table "risks" */
export enum Risks_Select_Column_Risks_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "risks_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "risks" */
export enum Risks_Select_Column_Risks_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "risks_aggregate_bool_exp_sum_arguments_columns" columns of table "risks" */
export enum Risks_Select_Column_Risks_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "risks_aggregate_bool_exp_var_samp_arguments_columns" columns of table "risks" */
export enum Risks_Select_Column_Risks_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** input type for updating data in table "risks" */
export type Risks_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  inherent_impact_id?: InputMaybe<Scalars['uuid']['input']>;
  inherent_likelihood_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  residual_impact_id?: InputMaybe<Scalars['uuid']['input']>;
  residual_likelihood_id?: InputMaybe<Scalars['uuid']['input']>;
  review_frequency?: InputMaybe<Frequencies_Enum>;
  treatment_details?: InputMaybe<Scalars['String']['input']>;
  treatment_plan?: InputMaybe<Treatment_Plan_Enum>;
  treatment_strategy?: InputMaybe<Treatment_Strategy_Enum>;
};

/** aggregate stddev on columns */
export type Risks_Stddev_Fields = {
  __typename?: 'risks_stddev_fields';
  inherent_score?: Maybe<Scalars['Float']['output']>;
  residual_score?: Maybe<Scalars['Float']['output']>;
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "risks" */
export type Risks_Stddev_Order_By = {
  inherent_score?: InputMaybe<Order_By>;
  residual_score?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risks_Stddev_Pop_Fields = {
  __typename?: 'risks_stddev_pop_fields';
  inherent_score?: Maybe<Scalars['Float']['output']>;
  residual_score?: Maybe<Scalars['Float']['output']>;
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "risks" */
export type Risks_Stddev_Pop_Order_By = {
  inherent_score?: InputMaybe<Order_By>;
  residual_score?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risks_Stddev_Samp_Fields = {
  __typename?: 'risks_stddev_samp_fields';
  inherent_score?: Maybe<Scalars['Float']['output']>;
  residual_score?: Maybe<Scalars['Float']['output']>;
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "risks" */
export type Risks_Stddev_Samp_Order_By = {
  inherent_score?: InputMaybe<Order_By>;
  residual_score?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "risks" */
export type Risks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risks_Stream_Cursor_Value_Input = {
  /** System-managed effective user-visible status of the Addition_of_risk_to_risk_register approval reason bucket. */
  approval_status_addition_of_risk_to_risk_register?: InputMaybe<Scalars['String']['input']>;
  /** System-managed effective user-visible status of the Closing_the_risk approval reason bucket. */
  approval_status_closing_the_risk?: InputMaybe<Scalars['String']['input']>;
  /** System-managed effective user-visible status of the Inherent_risk_level approval reason bucket. */
  approval_status_inherent_risk_level?: InputMaybe<Scalars['String']['input']>;
  /** System-managed effective user-visible status of the Residual_risk_level approval reason bucket. */
  approval_status_residual_risk_level?: InputMaybe<Scalars['String']['input']>;
  /** System-managed effective user-visible status of the Treatment approval reason bucket. */
  approval_status_treatment?: InputMaybe<Scalars['String']['input']>;
  /** System-managed union of bucket-effective user-visible risk approval statuses for this risk. */
  approval_statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  assessment_status?: InputMaybe<Scalars['String']['input']>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inherent_impact_id?: InputMaybe<Scalars['uuid']['input']>;
  inherent_likelihood_id?: InputMaybe<Scalars['uuid']['input']>;
  inherent_score?: InputMaybe<Scalars['Int']['input']>;
  internal_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  /** System-managed union of bucket-effective user-visible statuses of Other-reason approvals, bucketed by approval name. */
  other_approval_statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  residual_impact_id?: InputMaybe<Scalars['uuid']['input']>;
  residual_likelihood_id?: InputMaybe<Scalars['uuid']['input']>;
  residual_score?: InputMaybe<Scalars['Int']['input']>;
  review_frequency?: InputMaybe<Frequencies_Enum>;
  similarity?: InputMaybe<Scalars['float8']['input']>;
  treatment_details?: InputMaybe<Scalars['String']['input']>;
  treatment_plan?: InputMaybe<Treatment_Plan_Enum>;
  treatment_strategy?: InputMaybe<Treatment_Strategy_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Risks_Sum_Fields = {
  __typename?: 'risks_sum_fields';
  inherent_score?: Maybe<Scalars['Int']['output']>;
  residual_score?: Maybe<Scalars['Int']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "risks" */
export type Risks_Sum_Order_By = {
  inherent_score?: InputMaybe<Order_By>;
  residual_score?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
};

/** update columns of table "risks" */
export enum Risks_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  InherentImpactId = 'inherent_impact_id',
  /** column name */
  InherentLikelihoodId = 'inherent_likelihood_id',
  /** column name */
  Name = 'name',
  /** column name */
  ResidualImpactId = 'residual_impact_id',
  /** column name */
  ResidualLikelihoodId = 'residual_likelihood_id',
  /** column name */
  ReviewFrequency = 'review_frequency',
  /** column name */
  TreatmentDetails = 'treatment_details',
  /** column name */
  TreatmentPlan = 'treatment_plan',
  /** column name */
  TreatmentStrategy = 'treatment_strategy',
}

export type Risks_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risks_Var_Pop_Fields = {
  __typename?: 'risks_var_pop_fields';
  inherent_score?: Maybe<Scalars['Float']['output']>;
  residual_score?: Maybe<Scalars['Float']['output']>;
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "risks" */
export type Risks_Var_Pop_Order_By = {
  inherent_score?: InputMaybe<Order_By>;
  residual_score?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risks_Var_Samp_Fields = {
  __typename?: 'risks_var_samp_fields';
  inherent_score?: Maybe<Scalars['Float']['output']>;
  residual_score?: Maybe<Scalars['Float']['output']>;
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "risks" */
export type Risks_Var_Samp_Order_By = {
  inherent_score?: InputMaybe<Order_By>;
  residual_score?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Risks_Variance_Fields = {
  __typename?: 'risks_variance_fields';
  inherent_score?: Maybe<Scalars['Float']['output']>;
  residual_score?: Maybe<Scalars['Float']['output']>;
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "risks" */
export type Risks_Variance_Order_By = {
  inherent_score?: InputMaybe<Order_By>;
  residual_score?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
};

/** set of permissions which make a role */
export type Role_Permissions = {
  __typename?: 'role_permissions';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  permission: Permissions_Enum;
  /** An object relationship */
  role: Roles;
  role_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "role_permissions" */
export type Role_Permissions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Role_Permissions_Max_Order_By>;
  min?: InputMaybe<Role_Permissions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "role_permissions" */
export type Role_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Role_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_Permissions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "role_permissions". All fields are combined with a logical 'AND'. */
export type Role_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Role_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Permissions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  permission?: InputMaybe<Permissions_Enum_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "role_permissions" */
export enum Role_Permissions_Constraint {
  /** unique or primary key constraint on columns "id" */
  RolePermissionsPkey = 'role_permissions_pkey',
  /** unique or primary key constraint on columns "role_id", "permission" */
  RolePermissionsRoleIdPermissionKey = 'role_permissions_role_id_permission_key',
}

/** input type for inserting data into table "role_permissions" */
export type Role_Permissions_Insert_Input = {
  permission?: InputMaybe<Permissions_Enum>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "role_permissions" */
export type Role_Permissions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "role_permissions" */
export type Role_Permissions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "role_permissions" */
export type Role_Permissions_Mutation_Response = {
  __typename?: 'role_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Role_Permissions>;
};

/** on_conflict condition type for table "role_permissions" */
export type Role_Permissions_On_Conflict = {
  constraint: Role_Permissions_Constraint;
  update_columns?: Array<Role_Permissions_Update_Column>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "role_permissions". */
export type Role_Permissions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** select columns of table "role_permissions" */
export enum Role_Permissions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Permission = 'permission',
  /** column name */
  RoleId = 'role_id',
}

/** Streaming cursor of the table "role_permissions" */
export type Role_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Permissions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  permission?: InputMaybe<Permissions_Enum>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "role_permissions" (current role has no relevant permissions) */
export enum Role_Permissions_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** different roles managed by organization  */
export type Roles = {
  __typename?: 'roles';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  invitations: Array<Invitations>;
  name: Scalars['String']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  organization_users: Array<Organization_Users>;
  /** An array relationship */
  role_permissions: Array<Role_Permissions>;
  system_role?: Maybe<System_Roles_Enum>;
  updated_at: Scalars['timestamptz']['output'];
};

/** different roles managed by organization  */
export type RolesInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};

/** different roles managed by organization  */
export type RolesOrganization_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Users_Order_By>>;
  where?: InputMaybe<Organization_Users_Bool_Exp>;
};

/** different roles managed by organization  */
export type RolesRole_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};

/** order by aggregate values of table "roles" */
export type Roles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Roles_Max_Order_By>;
  min?: InputMaybe<Roles_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Bool_Exp>>;
  _not?: InputMaybe<Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invitations?: InputMaybe<Invitations_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_users?: InputMaybe<Organization_Users_Bool_Exp>;
  role_permissions?: InputMaybe<Role_Permissions_Bool_Exp>;
  system_role?: InputMaybe<System_Roles_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint on columns "organization_id", "system_role" */
  RolesOrganizationIdSystemRoleKey = 'roles_organization_id_system_role_key',
  /** unique or primary key constraint on columns "id" */
  RolesPkey = 'roles_pkey',
}

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  invitations?: InputMaybe<Invitations_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  role_permissions?: InputMaybe<Role_Permissions_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "roles" */
export type Roles_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "roles" */
export type Roles_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** input type for inserting object relation for remote table "roles" */
export type Roles_Obj_Rel_Insert_Input = {
  data: Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};

/** on_conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns?: Array<Roles_Update_Column>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "roles". */
export type Roles_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invitations_aggregate?: InputMaybe<Invitations_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_users_aggregate?: InputMaybe<Organization_Users_Aggregate_Order_By>;
  role_permissions_aggregate?: InputMaybe<Role_Permissions_Aggregate_Order_By>;
  system_role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roles */
export type Roles_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "roles" */
export enum Roles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  SystemRole = 'system_role',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "roles" */
export type Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Roles_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  system_role?: InputMaybe<System_Roles_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "roles" */
export enum Roles_Update_Column {
  /** column name */
  Name = 'name',
}

export type Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Roles_Bool_Exp;
};

/** columns and relationships of "select_field_configs" */
export type Select_Field_Configs = {
  __typename?: 'select_field_configs';
  /** An object relationship */
  fieldConfigByFieldConfigId: Field_Configs;
  /** An object relationship */
  field_config?: Maybe<Field_Configs>;
  field_config_id: Scalars['uuid']['output'];
  field_type: Scalars['String']['output'];
  is_creatable: Scalars['Boolean']['output'];
  is_multi: Scalars['Boolean']['output'];
  /** An array relationship */
  select_field_options: Array<Select_Field_Options>;
};

/** columns and relationships of "select_field_configs" */
export type Select_Field_ConfigsSelect_Field_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Select_Field_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Select_Field_Options_Order_By>>;
  where?: InputMaybe<Select_Field_Options_Bool_Exp>;
};

/** order by aggregate values of table "select_field_configs" */
export type Select_Field_Configs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Select_Field_Configs_Max_Order_By>;
  min?: InputMaybe<Select_Field_Configs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "select_field_configs" */
export type Select_Field_Configs_Arr_Rel_Insert_Input = {
  data: Array<Select_Field_Configs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Select_Field_Configs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "select_field_configs". All fields are combined with a logical 'AND'. */
export type Select_Field_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<Select_Field_Configs_Bool_Exp>>;
  _not?: InputMaybe<Select_Field_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<Select_Field_Configs_Bool_Exp>>;
  fieldConfigByFieldConfigId?: InputMaybe<Field_Configs_Bool_Exp>;
  field_config?: InputMaybe<Field_Configs_Bool_Exp>;
  field_config_id?: InputMaybe<Uuid_Comparison_Exp>;
  field_type?: InputMaybe<String_Comparison_Exp>;
  is_creatable?: InputMaybe<Boolean_Comparison_Exp>;
  is_multi?: InputMaybe<Boolean_Comparison_Exp>;
  select_field_options?: InputMaybe<Select_Field_Options_Bool_Exp>;
};

/** unique or primary key constraints on table "select_field_configs" */
export enum Select_Field_Configs_Constraint {
  /** unique or primary key constraint on columns "field_config_id" */
  SelectFieldConfigsPkey = 'select_field_configs_pkey',
}

/** input type for inserting data into table "select_field_configs" */
export type Select_Field_Configs_Insert_Input = {
  fieldConfigByFieldConfigId?: InputMaybe<Field_Configs_Obj_Rel_Insert_Input>;
  field_config?: InputMaybe<Field_Configs_Obj_Rel_Insert_Input>;
  field_config_id?: InputMaybe<Scalars['uuid']['input']>;
  is_creatable?: InputMaybe<Scalars['Boolean']['input']>;
  is_multi?: InputMaybe<Scalars['Boolean']['input']>;
  select_field_options?: InputMaybe<Select_Field_Options_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "select_field_configs" */
export type Select_Field_Configs_Max_Order_By = {
  field_config_id?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "select_field_configs" */
export type Select_Field_Configs_Min_Order_By = {
  field_config_id?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "select_field_configs" */
export type Select_Field_Configs_Mutation_Response = {
  __typename?: 'select_field_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Select_Field_Configs>;
};

/** input type for inserting object relation for remote table "select_field_configs" */
export type Select_Field_Configs_Obj_Rel_Insert_Input = {
  data: Select_Field_Configs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Select_Field_Configs_On_Conflict>;
};

/** on_conflict condition type for table "select_field_configs" */
export type Select_Field_Configs_On_Conflict = {
  constraint: Select_Field_Configs_Constraint;
  update_columns?: Array<Select_Field_Configs_Update_Column>;
  where?: InputMaybe<Select_Field_Configs_Bool_Exp>;
};

/** Ordering options when selecting data from "select_field_configs". */
export type Select_Field_Configs_Order_By = {
  fieldConfigByFieldConfigId?: InputMaybe<Field_Configs_Order_By>;
  field_config?: InputMaybe<Field_Configs_Order_By>;
  field_config_id?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  is_creatable?: InputMaybe<Order_By>;
  is_multi?: InputMaybe<Order_By>;
  select_field_options_aggregate?: InputMaybe<Select_Field_Options_Aggregate_Order_By>;
};

/** primary key columns input for table: select_field_configs */
export type Select_Field_Configs_Pk_Columns_Input = {
  field_config_id: Scalars['uuid']['input'];
};

/** select columns of table "select_field_configs" */
export enum Select_Field_Configs_Select_Column {
  /** column name */
  FieldConfigId = 'field_config_id',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  IsCreatable = 'is_creatable',
  /** column name */
  IsMulti = 'is_multi',
}

/** input type for updating data in table "select_field_configs" */
export type Select_Field_Configs_Set_Input = {
  is_creatable?: InputMaybe<Scalars['Boolean']['input']>;
  is_multi?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "select_field_configs" */
export enum Select_Field_Configs_Update_Column {
  /** column name */
  IsCreatable = 'is_creatable',
  /** column name */
  IsMulti = 'is_multi',
}

export type Select_Field_Configs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Select_Field_Configs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Select_Field_Configs_Bool_Exp;
};

/** columns and relationships of "select_field_options" */
export type Select_Field_Options = {
  __typename?: 'select_field_options';
  field_config_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  select_field_config: Select_Field_Configs;
  /** An array relationship */
  select_field_values: Array<Select_Field_Values>;
  value: Scalars['String']['output'];
};

/** columns and relationships of "select_field_options" */
export type Select_Field_OptionsSelect_Field_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Select_Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Select_Field_Values_Order_By>>;
  where?: InputMaybe<Select_Field_Values_Bool_Exp>;
};

/** order by aggregate values of table "select_field_options" */
export type Select_Field_Options_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Select_Field_Options_Max_Order_By>;
  min?: InputMaybe<Select_Field_Options_Min_Order_By>;
};

/** input type for inserting array relation for remote table "select_field_options" */
export type Select_Field_Options_Arr_Rel_Insert_Input = {
  data: Array<Select_Field_Options_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Select_Field_Options_On_Conflict>;
};

/** Boolean expression to filter rows from the table "select_field_options". All fields are combined with a logical 'AND'. */
export type Select_Field_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Select_Field_Options_Bool_Exp>>;
  _not?: InputMaybe<Select_Field_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Select_Field_Options_Bool_Exp>>;
  field_config_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  select_field_config?: InputMaybe<Select_Field_Configs_Bool_Exp>;
  select_field_values?: InputMaybe<Select_Field_Values_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "select_field_options" */
export enum Select_Field_Options_Constraint {
  /** unique or primary key constraint on columns "field_config_id", "id" */
  SelectFieldOptionsFieldConfigIdIdKey = 'select_field_options_field_config_id_id_key',
  /** unique or primary key constraint on columns "id" */
  SelectFieldOptionsPkey = 'select_field_options_pkey',
  /** unique or primary key constraint on columns "field_config_id", "value" */
  SelectFieldOptionsValueFieldConfigIdKey = 'select_field_options_value_field_config_id_key',
}

/** input type for inserting data into table "select_field_options" */
export type Select_Field_Options_Insert_Input = {
  field_config_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  select_field_config?: InputMaybe<Select_Field_Configs_Obj_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "select_field_options" */
export type Select_Field_Options_Max_Order_By = {
  field_config_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "select_field_options" */
export type Select_Field_Options_Min_Order_By = {
  field_config_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "select_field_options" */
export type Select_Field_Options_Mutation_Response = {
  __typename?: 'select_field_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Select_Field_Options>;
};

/** on_conflict condition type for table "select_field_options" */
export type Select_Field_Options_On_Conflict = {
  constraint: Select_Field_Options_Constraint;
  update_columns?: Array<Select_Field_Options_Update_Column>;
  where?: InputMaybe<Select_Field_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "select_field_options". */
export type Select_Field_Options_Order_By = {
  field_config_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  select_field_config?: InputMaybe<Select_Field_Configs_Order_By>;
  select_field_values_aggregate?: InputMaybe<Select_Field_Values_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: select_field_options */
export type Select_Field_Options_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "select_field_options" */
export enum Select_Field_Options_Select_Column {
  /** column name */
  FieldConfigId = 'field_config_id',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value',
}

/** input type for updating data in table "select_field_options" */
export type Select_Field_Options_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "select_field_options" */
export enum Select_Field_Options_Update_Column {
  /** column name */
  Value = 'value',
}

export type Select_Field_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Select_Field_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Select_Field_Options_Bool_Exp;
};

/** columns and relationships of "select_field_values" */
export type Select_Field_Values = {
  __typename?: 'select_field_values';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  fieldValueByFieldValueId: Field_Values;
  field_config_id: Scalars['uuid']['output'];
  field_type: Scalars['String']['output'];
  /** An object relationship */
  field_value?: Maybe<Field_Values>;
  field_value_id: Scalars['uuid']['output'];
  /** An object relationship */
  select_field_option?: Maybe<Select_Field_Options>;
  select_field_option_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "select_field_values" */
export type Select_Field_Values_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Select_Field_Values_Max_Order_By>;
  min?: InputMaybe<Select_Field_Values_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "select_field_values". All fields are combined with a logical 'AND'. */
export type Select_Field_Values_Bool_Exp = {
  _and?: InputMaybe<Array<Select_Field_Values_Bool_Exp>>;
  _not?: InputMaybe<Select_Field_Values_Bool_Exp>;
  _or?: InputMaybe<Array<Select_Field_Values_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Bool_Exp>;
  field_config_id?: InputMaybe<Uuid_Comparison_Exp>;
  field_type?: InputMaybe<String_Comparison_Exp>;
  field_value?: InputMaybe<Field_Values_Bool_Exp>;
  field_value_id?: InputMaybe<Uuid_Comparison_Exp>;
  select_field_option?: InputMaybe<Select_Field_Options_Bool_Exp>;
  select_field_option_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "select_field_values" */
export type Select_Field_Values_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_config_id?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  select_field_option_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "select_field_values" */
export type Select_Field_Values_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_config_id?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  select_field_option_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "select_field_values". */
export type Select_Field_Values_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Order_By>;
  field_config_id?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value?: InputMaybe<Field_Values_Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  select_field_option?: InputMaybe<Select_Field_Options_Order_By>;
  select_field_option_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "select_field_values" */
export enum Select_Field_Values_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FieldConfigId = 'field_config_id',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  FieldValueId = 'field_value_id',
  /** column name */
  SelectFieldOptionId = 'select_field_option_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** Service accounts for API integrations. Each service account is backed by a dedicated auth.users record with an organization_users membership and a controlled role. */
export type Service_Accounts = {
  __typename?: 'service_accounts';
  /** An array relationship */
  api_keys: Array<Api_Keys>;
  /** An aggregate relationship */
  api_keys_aggregate: Api_Keys_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** The human user who created this service account (for audit trail only). SET NULL on user deletion to avoid blocking deletes. */
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  organization_user?: Maybe<Organization_Users>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** The dedicated auth.users record for this service account. This user_id is passed as x-hasura-user-id for RLS enforcement. */
  user_id: Scalars['uuid']['output'];
};

/** Service accounts for API integrations. Each service account is backed by a dedicated auth.users record with an organization_users membership and a controlled role. */
export type Service_AccountsApi_KeysArgs = {
  distinct_on?: InputMaybe<Array<Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Keys_Order_By>>;
  where?: InputMaybe<Api_Keys_Bool_Exp>;
};

/** Service accounts for API integrations. Each service account is backed by a dedicated auth.users record with an organization_users membership and a controlled role. */
export type Service_AccountsApi_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Keys_Order_By>>;
  where?: InputMaybe<Api_Keys_Bool_Exp>;
};

/** aggregated selection of "service_accounts" */
export type Service_Accounts_Aggregate = {
  __typename?: 'service_accounts_aggregate';
  aggregate?: Maybe<Service_Accounts_Aggregate_Fields>;
  nodes: Array<Service_Accounts>;
};

/** aggregate fields of "service_accounts" */
export type Service_Accounts_Aggregate_Fields = {
  __typename?: 'service_accounts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Service_Accounts_Max_Fields>;
  min?: Maybe<Service_Accounts_Min_Fields>;
};

/** aggregate fields of "service_accounts" */
export type Service_Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Service_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "service_accounts". All fields are combined with a logical 'AND'. */
export type Service_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Accounts_Bool_Exp>>;
  _not?: InputMaybe<Service_Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Accounts_Bool_Exp>>;
  api_keys?: InputMaybe<Api_Keys_Bool_Exp>;
  api_keys_aggregate?: InputMaybe<Api_Keys_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_Users_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Service_Accounts_Max_Fields = {
  __typename?: 'service_accounts_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The human user who created this service account (for audit trail only). SET NULL on user deletion to avoid blocking deletes. */
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The dedicated auth.users record for this service account. This user_id is passed as x-hasura-user-id for RLS enforcement. */
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Service_Accounts_Min_Fields = {
  __typename?: 'service_accounts_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The human user who created this service account (for audit trail only). SET NULL on user deletion to avoid blocking deletes. */
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The dedicated auth.users record for this service account. This user_id is passed as x-hasura-user-id for RLS enforcement. */
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "service_accounts" */
export type Service_Accounts_Mutation_Response = {
  __typename?: 'service_accounts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Service_Accounts>;
};

/** Ordering options when selecting data from "service_accounts". */
export type Service_Accounts_Order_By = {
  api_keys_aggregate?: InputMaybe<Api_Keys_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_Users_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: service_accounts */
export type Service_Accounts_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "service_accounts" */
export enum Service_Accounts_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "service_accounts" */
export type Service_Accounts_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Service_Accounts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Service_Accounts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Service_Accounts_Bool_Exp;
};

/** Boolean expression to compare columns of type "sparsevec". All fields are combined with logical 'AND'. */
export type Sparsevec_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['sparsevec']['input']>;
  _gt?: InputMaybe<Scalars['sparsevec']['input']>;
  _gte?: InputMaybe<Scalars['sparsevec']['input']>;
  _in?: InputMaybe<Array<Scalars['sparsevec']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['sparsevec']['input']>;
  _lte?: InputMaybe<Scalars['sparsevec']['input']>;
  _neq?: InputMaybe<Scalars['sparsevec']['input']>;
  _nin?: InputMaybe<Array<Scalars['sparsevec']['input']>>;
};

export enum Storage_File_Processing_Reasons_Enum {
  FileTooLarge = 'File_too_large',
  FileUnsupported = 'File_unsupported',
  RetryLimitReached = 'Retry_limit_reached',
  Timeout = 'Timeout',
}

/** Boolean expression to compare columns of type "storage_file_processing_reasons_enum". All fields are combined with logical 'AND'. */
export type Storage_File_Processing_Reasons_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Storage_File_Processing_Reasons_Enum>;
  _in?: InputMaybe<Array<Storage_File_Processing_Reasons_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Storage_File_Processing_Reasons_Enum>;
  _nin?: InputMaybe<Array<Storage_File_Processing_Reasons_Enum>>;
};

/** columns and relationships of "storage.file_processings" */
export type Storage_File_Processings = {
  __typename?: 'storage_file_processings';
  /** An object relationship */
  file: Files;
  reason?: Maybe<Storage_File_Processing_Reasons_Enum>;
};

/** order by aggregate values of table "storage.file_processings" */
export type Storage_File_Processings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage.file_processings". All fields are combined with a logical 'AND'. */
export type Storage_File_Processings_Bool_Exp = {
  _and?: InputMaybe<Array<Storage_File_Processings_Bool_Exp>>;
  _not?: InputMaybe<Storage_File_Processings_Bool_Exp>;
  _or?: InputMaybe<Array<Storage_File_Processings_Bool_Exp>>;
  file?: InputMaybe<Files_Bool_Exp>;
  reason?: InputMaybe<Storage_File_Processing_Reasons_Enum_Comparison_Exp>;
};

/** Ordering options when selecting data from "storage.file_processings". */
export type Storage_File_Processings_Order_By = {
  file?: InputMaybe<Files_Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** select columns of table "storage.file_processings" */
export enum Storage_File_Processings_Select_Column {
  /** column name */
  Reason = 'reason',
}

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** An array relationship */
  agent_instances: Array<Agent_Instances>;
  /** fetch data from the table: "agent_instances" using primary key columns */
  agent_instances_by_pk?: Maybe<Agent_Instances>;
  /** fetch data from the table in a streaming manner: "agent_instances" */
  agent_instances_stream: Array<Agent_Instances>;
  /** execute function "ai.control_evidences_suggestions" which returns "evidences" */
  ai_control_evidences_suggestions: Array<Evidences>;
  /** execute function "ai.control_evidences_suggestions" and query aggregates on result of table type "evidences" */
  ai_control_evidences_suggestions_aggregate: Evidences_Aggregate;
  /** execute function "ai.control_evidences_suggestions_with_chunks" which returns "ai.evidence_suggestion_chunk" */
  ai_control_evidences_suggestions_with_chunks: Array<Ai_Evidence_Suggestion_Chunk>;
  /** execute function "ai.controls_text_search" which returns "controls" */
  ai_controls_text_search: Array<Controls>;
  /** execute function "ai.controls_text_search" and query aggregates on result of table type "controls" */
  ai_controls_text_search_aggregate: Controls_Aggregate;
  /** execute function "ai.controls_vector_store_search" which returns "controls" */
  ai_controls_vector_store_search: Array<Controls>;
  /** execute function "ai.controls_vector_store_search" and query aggregates on result of table type "controls" */
  ai_controls_vector_store_search_aggregate: Controls_Aggregate;
  /** execute function "ai.documents_text_search" which returns "documents" */
  ai_documents_text_search: Array<Documents>;
  /** fetch data from the table: "ai.documents_vector_store" */
  ai_documents_vector_store: Array<Ai_Documents_Vector_Store>;
  /** fetch data from the table: "ai.documents_vector_store" using primary key columns */
  ai_documents_vector_store_by_pk?: Maybe<Ai_Documents_Vector_Store>;
  /** execute function "ai.documents_vector_store_search" which returns "ai.documents_vector_store" */
  ai_documents_vector_store_search: Array<Ai_Documents_Vector_Store>;
  /** fetch data from the table in a streaming manner: "ai.documents_vector_store" */
  ai_documents_vector_store_stream: Array<Ai_Documents_Vector_Store>;
  /** execute function "ai.evidence_controls_suggestions" which returns "controls" */
  ai_evidence_controls_suggestions: Array<Controls>;
  /** execute function "ai.evidence_controls_suggestions" and query aggregates on result of table type "controls" */
  ai_evidence_controls_suggestions_aggregate: Controls_Aggregate;
  /** execute function "ai.evidences_text_search" which returns "evidences" */
  ai_evidences_text_search: Array<Evidences>;
  /** execute function "ai.evidences_text_search" and query aggregates on result of table type "evidences" */
  ai_evidences_text_search_aggregate: Evidences_Aggregate;
  /** execute function "ai.evidences_vector_store_search" which returns "ai.evidences_vector_store" */
  ai_evidences_vector_store_search: Array<Ai_Evidences_Vector_Store>;
  /** execute function "ai.policies_text_search" which returns "policies" */
  ai_policies_text_search: Array<Policies>;
  /** fetch data from the table: "ai.policies_vector_store" */
  ai_policies_vector_store: Array<Ai_Policies_Vector_Store>;
  /** fetch data from the table: "ai.policies_vector_store" using primary key columns */
  ai_policies_vector_store_by_pk?: Maybe<Ai_Policies_Vector_Store>;
  /** execute function "ai.policies_vector_store_search" which returns "ai.policies_vector_store" */
  ai_policies_vector_store_search: Array<Ai_Policies_Vector_Store>;
  /** fetch data from the table in a streaming manner: "ai.policies_vector_store" */
  ai_policies_vector_store_stream: Array<Ai_Policies_Vector_Store>;
  /** execute function "ai.programs_text_search" which returns "programs" */
  ai_programs_text_search: Array<Programs>;
  /** execute function "ai.programs_vector_store_search" which returns "programs" */
  ai_programs_vector_store_search: Array<Programs>;
  /** execute function "ai.relevant_policy_controls" which returns "controls" */
  ai_relevant_policy_controls: Array<Controls>;
  /** execute function "ai.relevant_policy_controls" and query aggregates on result of table type "controls" */
  ai_relevant_policy_controls_aggregate: Controls_Aggregate;
  /** execute function "ai.risk_controls_suggestions" which returns "controls" */
  ai_risk_controls_suggestions: Array<Controls>;
  /** execute function "ai.risk_controls_suggestions" and query aggregates on result of table type "controls" */
  ai_risk_controls_suggestions_aggregate: Controls_Aggregate;
  /** execute function "ai.risks_text_search" which returns "risks" */
  ai_risks_text_search: Array<Risks>;
  /** execute function "ai.risks_text_search" and query aggregates on result of table type "risks" */
  ai_risks_text_search_aggregate: Risks_Aggregate;
  /** execute function "ai.risks_vector_store_search" which returns "risks" */
  ai_risks_vector_store_search: Array<Risks>;
  /** execute function "ai.risks_vector_store_search" and query aggregates on result of table type "risks" */
  ai_risks_vector_store_search_aggregate: Risks_Aggregate;
  /** execute function "ai.tasks_text_search" which returns "tasks" */
  ai_tasks_text_search: Array<Tasks>;
  /** execute function "ai.tasks_text_search" and query aggregates on result of table type "tasks" */
  ai_tasks_text_search_aggregate: Tasks_Aggregate;
  /** execute function "ai.tasks_vector_store_search" which returns "tasks" */
  ai_tasks_vector_store_search: Array<Tasks>;
  /** execute function "ai.tasks_vector_store_search" and query aggregates on result of table type "tasks" */
  ai_tasks_vector_store_search_aggregate: Tasks_Aggregate;
  /** execute function "ai.vendors_text_search" which returns "vendors" */
  ai_vendors_text_search: Array<Vendors>;
  /** execute function "ai.vendors_text_search" and query aggregates on result of table type "vendors" */
  ai_vendors_text_search_aggregate: Vendors_Aggregate;
  /** execute function "ai.vendors_vector_store_search" which returns "vendors" */
  ai_vendors_vector_store_search: Array<Vendors>;
  /** execute function "ai.vendors_vector_store_search" and query aggregates on result of table type "vendors" */
  ai_vendors_vector_store_search_aggregate: Vendors_Aggregate;
  /** fetch data from the table: "api_key_usage_logs" */
  api_key_usage_logs: Array<Api_Key_Usage_Logs>;
  /** fetch aggregated fields from the table: "api_key_usage_logs" */
  api_key_usage_logs_aggregate: Api_Key_Usage_Logs_Aggregate;
  /** fetch data from the table: "api_key_usage_logs" using primary key columns */
  api_key_usage_logs_by_pk?: Maybe<Api_Key_Usage_Logs>;
  /** fetch data from the table in a streaming manner: "api_key_usage_logs" */
  api_key_usage_logs_stream: Array<Api_Key_Usage_Logs>;
  /** fetch data from the table: "audit.control_history" */
  audit_control_history: Array<Audit_Control_History>;
  /** fetch data from the table in a streaming manner: "audit.control_history" */
  audit_control_history_stream: Array<Audit_Control_History>;
  /** fetch data from the table: "audit.evidence_history" */
  audit_evidence_history: Array<Audit_Evidence_History>;
  /** fetch data from the table: "audit.evidence_history" using primary key columns */
  audit_evidence_history_by_pk?: Maybe<Audit_Evidence_History>;
  /** fetch data from the table in a streaming manner: "audit.evidence_history" */
  audit_evidence_history_stream: Array<Audit_Evidence_History>;
  /** fetch data from the table: "audit.finding_history" */
  audit_finding_history: Array<Audit_Finding_History>;
  /** fetch aggregated fields from the table: "audit.finding_history" */
  audit_finding_history_aggregate: Audit_Finding_History_Aggregate;
  /** fetch data from the table: "audit.finding_history" using primary key columns */
  audit_finding_history_by_pk?: Maybe<Audit_Finding_History>;
  /** fetch data from the table in a streaming manner: "audit.finding_history" */
  audit_finding_history_stream: Array<Audit_Finding_History>;
  /** fetch data from the table: "audit.policy_history" */
  audit_policy_history: Array<Audit_Policy_History>;
  /** fetch data from the table: "audit.policy_history" using primary key columns */
  audit_policy_history_by_pk?: Maybe<Audit_Policy_History>;
  /** fetch data from the table in a streaming manner: "audit.policy_history" */
  audit_policy_history_stream: Array<Audit_Policy_History>;
  /** fetch data from the table: "audit.risk_history" */
  audit_risk_history: Array<Audit_Risk_History>;
  /** fetch data from the table in a streaming manner: "audit.risk_history" */
  audit_risk_history_stream: Array<Audit_Risk_History>;
  /** fetch data from the table: "audit.task_history" */
  audit_task_history: Array<Audit_Task_History>;
  /** fetch data from the table in a streaming manner: "audit.task_history" */
  audit_task_history_stream: Array<Audit_Task_History>;
  /** fetch data from the table: "audit.vendor_history" */
  audit_vendor_history: Array<Audit_Vendor_History>;
  /** fetch data from the table in a streaming manner: "audit.vendor_history" */
  audit_vendor_history_stream: Array<Audit_Vendor_History>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** fetch data from the table in a streaming manner: "auth.refresh_tokens" */
  authRefreshTokens_stream: Array<AuthRefreshTokens>;
  /** An array relationship */
  categories: Array<Categories>;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>;
  /** fetch data from the table in a streaming manner: "categories" */
  categories_stream: Array<Categories>;
  /** An array relationship */
  client_questionnaire_questions: Array<Client_Questionnaire_Questions>;
  /** An aggregate relationship */
  client_questionnaire_questions_aggregate: Client_Questionnaire_Questions_Aggregate;
  /** fetch data from the table: "client_questionnaire_questions" using primary key columns */
  client_questionnaire_questions_by_pk?: Maybe<Client_Questionnaire_Questions>;
  /** fetch data from the table in a streaming manner: "client_questionnaire_questions" */
  client_questionnaire_questions_stream: Array<Client_Questionnaire_Questions>;
  /** An array relationship */
  client_questionnaires: Array<Client_Questionnaires>;
  /** fetch data from the table: "client_questionnaires" using primary key columns */
  client_questionnaires_by_pk?: Maybe<Client_Questionnaires>;
  /** fetch data from the table in a streaming manner: "client_questionnaires" */
  client_questionnaires_stream: Array<Client_Questionnaires>;
  /** An array relationship */
  controls: Array<Controls>;
  /** An aggregate relationship */
  controls_aggregate: Controls_Aggregate;
  /** fetch data from the table: "controls" using primary key columns */
  controls_by_pk?: Maybe<Controls>;
  /** fetch data from the table in a streaming manner: "controls" */
  controls_stream: Array<Controls>;
  /** An array relationship */
  criteria: Array<Criteria>;
  /** fetch data from the table: "criteria" using primary key columns */
  criteria_by_pk?: Maybe<Criteria>;
  /** fetch data from the table in a streaming manner: "criteria" */
  criteria_stream: Array<Criteria>;
  /** fetch data from the table: "daily_control_stats_view" */
  daily_control_stats_view: Array<Daily_Control_Stats_View>;
  /** fetch data from the table in a streaming manner: "daily_control_stats_view" */
  daily_control_stats_view_stream: Array<Daily_Control_Stats_View>;
  /** fetch data from the table: "daily_control_user_stats_view" */
  daily_control_user_stats_view: Array<Daily_Control_User_Stats_View>;
  /** fetch data from the table in a streaming manner: "daily_control_user_stats_view" */
  daily_control_user_stats_view_stream: Array<Daily_Control_User_Stats_View>;
  /** fetch data from the table: "daily_risk_stats_view" */
  daily_risk_stats_view: Array<Daily_Risk_Stats_View>;
  /** fetch data from the table in a streaming manner: "daily_risk_stats_view" */
  daily_risk_stats_view_stream: Array<Daily_Risk_Stats_View>;
  /** An array relationship */
  documents: Array<Documents>;
  /** fetch data from the table: "documents" using primary key columns */
  documents_by_pk?: Maybe<Documents>;
  /** fetch data from the table in a streaming manner: "documents" */
  documents_stream: Array<Documents>;
  /** An array relationship */
  evidence_integrations: Array<Evidence_Integrations>;
  /** fetch data from the table: "evidence_integrations" using primary key columns */
  evidence_integrations_by_pk?: Maybe<Evidence_Integrations>;
  /** fetch data from the table in a streaming manner: "evidence_integrations" */
  evidence_integrations_stream: Array<Evidence_Integrations>;
  /** An array relationship */
  evidences: Array<Evidences>;
  /** An aggregate relationship */
  evidences_aggregate: Evidences_Aggregate;
  /** fetch data from the table: "evidences" using primary key columns */
  evidences_by_pk?: Maybe<Evidences>;
  /** fetch data from the table in a streaming manner: "evidences" */
  evidences_stream: Array<Evidences>;
  /** An array relationship */
  field_configs: Array<Field_Configs>;
  /** fetch data from the table: "field_configs" using primary key columns */
  field_configs_by_pk?: Maybe<Field_Configs>;
  /** fetch data from the table in a streaming manner: "field_configs" */
  field_configs_stream: Array<Field_Configs>;
  /** fetch data from the table: "findings" */
  findings: Array<Findings>;
  /** fetch aggregated fields from the table: "findings" */
  findings_aggregate: Findings_Aggregate;
  /** fetch data from the table: "findings" using primary key columns */
  findings_by_pk?: Maybe<Findings>;
  /** fetch data from the table in a streaming manner: "findings" */
  findings_stream: Array<Findings>;
  /** An array relationship */
  frameworks: Array<Frameworks>;
  /** fetch data from the table: "frameworks" using primary key columns */
  frameworks_by_pk?: Maybe<Frameworks>;
  /** An array relationship */
  frameworks_controls: Array<Frameworks_Controls>;
  /** fetch data from the table: "frameworks_controls" using primary key columns */
  frameworks_controls_by_pk?: Maybe<Frameworks_Controls>;
  /** fetch data from the table in a streaming manner: "frameworks_controls" */
  frameworks_controls_stream: Array<Frameworks_Controls>;
  /** fetch data from the table in a streaming manner: "frameworks" */
  frameworks_stream: Array<Frameworks>;
  /** An array relationship */
  groups: Array<Groups>;
  /** fetch data from the table: "groups" using primary key columns */
  groups_by_pk?: Maybe<Groups>;
  /** fetch data from the table in a streaming manner: "groups" */
  groups_stream: Array<Groups>;
  /** fetch data from the table: "grove.agents" */
  grove_agents: Array<Grove_Agents>;
  /** fetch data from the table: "grove.agents" using primary key columns */
  grove_agents_by_pk?: Maybe<Grove_Agents>;
  /** fetch data from the table in a streaming manner: "grove.agents" */
  grove_agents_stream: Array<Grove_Agents>;
  /** fetch data from the table: "grove.chats" */
  grove_chats: Array<Grove_Chats>;
  /** fetch aggregated fields from the table: "grove.chats" */
  grove_chats_aggregate: Grove_Chats_Aggregate;
  /** fetch data from the table: "grove.chats" using primary key columns */
  grove_chats_by_pk?: Maybe<Grove_Chats>;
  /** fetch data from the table in a streaming manner: "grove.chats" */
  grove_chats_stream: Array<Grove_Chats>;
  /** fetch data from the table: "grove.messages" */
  grove_messages: Array<Grove_Messages>;
  /** fetch aggregated fields from the table: "grove.messages" */
  grove_messages_aggregate: Grove_Messages_Aggregate;
  /** fetch data from the table: "grove.messages" using primary key columns */
  grove_messages_by_pk?: Maybe<Grove_Messages>;
  /** fetch data from the table in a streaming manner: "grove.messages" */
  grove_messages_stream: Array<Grove_Messages>;
  /** fetch data from the table: "integrations" */
  integrations: Array<Integrations>;
  /** fetch data from the table: "integrations" using primary key columns */
  integrations_by_pk?: Maybe<Integrations>;
  /** fetch data from the table in a streaming manner: "integrations" */
  integrations_stream: Array<Integrations>;
  /** An array relationship */
  invitations: Array<Invitations>;
  /** fetch data from the table: "invitations" using primary key columns */
  invitations_by_pk?: Maybe<Invitations>;
  /** fetch data from the table in a streaming manner: "invitations" */
  invitations_stream: Array<Invitations>;
  /** An array relationship */
  notification_disabled_settings: Array<Notification_Disabled_Settings>;
  /** fetch data from the table: "notification_disabled_settings" using primary key columns */
  notification_disabled_settings_by_pk?: Maybe<Notification_Disabled_Settings>;
  /** fetch data from the table in a streaming manner: "notification_disabled_settings" */
  notification_disabled_settings_stream: Array<Notification_Disabled_Settings>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table in a streaming manner: "notifications" */
  notifications_stream: Array<Notifications>;
  /** fetch data from the table: "organization_evidence_tags" */
  organization_evidence_tags: Array<Organization_Evidence_Tags>;
  /** fetch data from the table: "organization_evidence_tags" using primary key columns */
  organization_evidence_tags_by_pk?: Maybe<Organization_Evidence_Tags>;
  /** fetch data from the table in a streaming manner: "organization_evidence_tags" */
  organization_evidence_tags_stream: Array<Organization_Evidence_Tags>;
  /** fetch data from the table: "organization_finding_severities" */
  organization_finding_severities: Array<Organization_Finding_Severities>;
  /** fetch data from the table: "organization_finding_severities" using primary key columns */
  organization_finding_severities_by_pk?: Maybe<Organization_Finding_Severities>;
  /** fetch data from the table in a streaming manner: "organization_finding_severities" */
  organization_finding_severities_stream: Array<Organization_Finding_Severities>;
  /** An array relationship */
  organization_integrations: Array<Organization_Integrations>;
  /** fetch data from the table: "organization_integrations" using primary key columns */
  organization_integrations_by_pk?: Maybe<Organization_Integrations>;
  /** fetch data from the table in a streaming manner: "organization_integrations" */
  organization_integrations_stream: Array<Organization_Integrations>;
  /** fetch data from the table: "organization_risk_categories" */
  organization_risk_categories: Array<Organization_Risk_Categories>;
  /** fetch data from the table: "organization_risk_categories" using primary key columns */
  organization_risk_categories_by_pk?: Maybe<Organization_Risk_Categories>;
  /** fetch data from the table in a streaming manner: "organization_risk_categories" */
  organization_risk_categories_stream: Array<Organization_Risk_Categories>;
  /** An array relationship */
  organization_risk_levels: Array<Organization_Risk_Levels>;
  /** fetch data from the table: "organization_risk_levels" using primary key columns */
  organization_risk_levels_by_pk?: Maybe<Organization_Risk_Levels>;
  /** fetch data from the table in a streaming manner: "organization_risk_levels" */
  organization_risk_levels_stream: Array<Organization_Risk_Levels>;
  /** fetch data from the table: "organization_risk_tags" */
  organization_risk_tags: Array<Organization_Risk_Tags>;
  /** fetch data from the table: "organization_risk_tags" using primary key columns */
  organization_risk_tags_by_pk?: Maybe<Organization_Risk_Tags>;
  /** fetch data from the table in a streaming manner: "organization_risk_tags" */
  organization_risk_tags_stream: Array<Organization_Risk_Tags>;
  /** An array relationship */
  organization_template_frameworks: Array<Organization_Template_Frameworks>;
  /** fetch data from the table: "organization_template_frameworks" using primary key columns */
  organization_template_frameworks_by_pk?: Maybe<Organization_Template_Frameworks>;
  /** fetch data from the table in a streaming manner: "organization_template_frameworks" */
  organization_template_frameworks_stream: Array<Organization_Template_Frameworks>;
  /** An array relationship */
  organization_tenants: Array<Organization_Tenants>;
  /** fetch data from the table: "organization_tenants" using primary key columns */
  organization_tenants_by_pk?: Maybe<Organization_Tenants>;
  /** fetch data from the table in a streaming manner: "organization_tenants" */
  organization_tenants_stream: Array<Organization_Tenants>;
  /** An array relationship */
  organization_users: Array<Organization_Users>;
  /** fetch data from the table: "organization_users" using primary key columns */
  organization_users_by_pk?: Maybe<Organization_Users>;
  /** fetch data from the table in a streaming manner: "organization_users" */
  organization_users_stream: Array<Organization_Users>;
  /** fetch data from the table: "organization_vendor_risk_levels" */
  organization_vendor_risk_levels: Array<Organization_Vendor_Risk_Levels>;
  /** fetch data from the table: "organization_vendor_risk_levels" using primary key columns */
  organization_vendor_risk_levels_by_pk?: Maybe<Organization_Vendor_Risk_Levels>;
  /** fetch data from the table in a streaming manner: "organization_vendor_risk_levels" */
  organization_vendor_risk_levels_stream: Array<Organization_Vendor_Risk_Levels>;
  /** fetch data from the table: "organization_vendor_tiers" */
  organization_vendor_tiers: Array<Organization_Vendor_Tiers>;
  /** fetch data from the table: "organization_vendor_tiers" using primary key columns */
  organization_vendor_tiers_by_pk?: Maybe<Organization_Vendor_Tiers>;
  /** fetch data from the table in a streaming manner: "organization_vendor_tiers" */
  organization_vendor_tiers_stream: Array<Organization_Vendor_Tiers>;
  /** An array relationship */
  organizations: Array<Organizations>;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** fetch data from the table in a streaming manner: "organizations" */
  organizations_stream: Array<Organizations>;
  /** An array relationship */
  policies: Array<Policies>;
  /** fetch data from the table: "policies" using primary key columns */
  policies_by_pk?: Maybe<Policies>;
  /** fetch data from the table in a streaming manner: "policies" */
  policies_stream: Array<Policies>;
  /** An array relationship */
  policy_integrations: Array<Policy_Integrations>;
  /** fetch data from the table: "policy_integrations" using primary key columns */
  policy_integrations_by_pk?: Maybe<Policy_Integrations>;
  /** fetch data from the table in a streaming manner: "policy_integrations" */
  policy_integrations_stream: Array<Policy_Integrations>;
  /** An array relationship */
  programs: Array<Programs>;
  /** fetch data from the table: "programs" using primary key columns */
  programs_by_pk?: Maybe<Programs>;
  /** fetch data from the table in a streaming manner: "programs" */
  programs_stream: Array<Programs>;
  /** An array relationship */
  questionnaires: Array<Questionnaires>;
  /** fetch data from the table: "questionnaires" using primary key columns */
  questionnaires_by_pk?: Maybe<Questionnaires>;
  /** fetch data from the table in a streaming manner: "questionnaires" */
  questionnaires_stream: Array<Questionnaires>;
  /** An array relationship */
  reports: Array<Reports>;
  /** fetch data from the table: "reports" using primary key columns */
  reports_by_pk?: Maybe<Reports>;
  /** fetch data from the table in a streaming manner: "reports" */
  reports_stream: Array<Reports>;
  /** fetch data from the table: "retained_findings" */
  retained_findings: Array<Retained_Findings>;
  /** fetch aggregated fields from the table: "retained_findings" */
  retained_findings_aggregate: Retained_Findings_Aggregate;
  /** fetch data from the table in a streaming manner: "retained_findings" */
  retained_findings_stream: Array<Retained_Findings>;
  /** An array relationship */
  risk_impacts: Array<Risk_Impacts>;
  /** fetch data from the table: "risk_impacts" using primary key columns */
  risk_impacts_by_pk?: Maybe<Risk_Impacts>;
  /** fetch data from the table in a streaming manner: "risk_impacts" */
  risk_impacts_stream: Array<Risk_Impacts>;
  /** An array relationship */
  risk_inherent_levels: Array<Risk_Inherent_Levels>;
  /** fetch data from the table: "risk_inherent_levels" using primary key columns */
  risk_inherent_levels_by_pk?: Maybe<Risk_Inherent_Levels>;
  /** fetch data from the table in a streaming manner: "risk_inherent_levels" */
  risk_inherent_levels_stream: Array<Risk_Inherent_Levels>;
  /** An array relationship */
  risk_likelihoods: Array<Risk_Likelihoods>;
  /** fetch data from the table: "risk_likelihoods" using primary key columns */
  risk_likelihoods_by_pk?: Maybe<Risk_Likelihoods>;
  /** fetch data from the table in a streaming manner: "risk_likelihoods" */
  risk_likelihoods_stream: Array<Risk_Likelihoods>;
  /** An array relationship */
  risk_residual_levels: Array<Risk_Residual_Levels>;
  /** fetch data from the table: "risk_residual_levels" using primary key columns */
  risk_residual_levels_by_pk?: Maybe<Risk_Residual_Levels>;
  /** fetch data from the table in a streaming manner: "risk_residual_levels" */
  risk_residual_levels_stream: Array<Risk_Residual_Levels>;
  /** An array relationship */
  risks: Array<Risks>;
  /** An aggregate relationship */
  risks_aggregate: Risks_Aggregate;
  /** fetch data from the table: "risks" using primary key columns */
  risks_by_pk?: Maybe<Risks>;
  /** fetch data from the table in a streaming manner: "risks" */
  risks_stream: Array<Risks>;
  /** An array relationship */
  role_permissions: Array<Role_Permissions>;
  /** fetch data from the table: "role_permissions" using primary key columns */
  role_permissions_by_pk?: Maybe<Role_Permissions>;
  /** fetch data from the table in a streaming manner: "role_permissions" */
  role_permissions_stream: Array<Role_Permissions>;
  /** An array relationship */
  roles: Array<Roles>;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table in a streaming manner: "roles" */
  roles_stream: Array<Roles>;
  /** An array relationship */
  tags: Array<Tags>;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** fetch data from the table in a streaming manner: "tags" */
  tags_stream: Array<Tags>;
  /** An array relationship */
  tasks: Array<Tasks>;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: Maybe<Tasks>;
  /** An array relationship */
  team_members: Array<Team_Members>;
  /** An aggregate relationship */
  team_members_aggregate: Team_Members_Aggregate;
  /** fetch data from the table: "team_members" using primary key columns */
  team_members_by_pk?: Maybe<Team_Members>;
  /** fetch data from the table in a streaming manner: "team_members" */
  team_members_stream: Array<Team_Members>;
  /** An array relationship */
  teams: Array<Teams>;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** fetch data from the table in a streaming manner: "teams" */
  teams_stream: Array<Teams>;
  /** fetch data from the table: "template_controls" */
  template_controls: Array<Template_Controls>;
  /** fetch aggregated fields from the table: "template_controls" */
  template_controls_aggregate: Template_Controls_Aggregate;
  /** fetch data from the table: "template_controls" using primary key columns */
  template_controls_by_pk?: Maybe<Template_Controls>;
  /** fetch data from the table in a streaming manner: "template_controls" */
  template_controls_stream: Array<Template_Controls>;
  /** fetch data from the table: "template_frameworks" */
  template_frameworks: Array<Template_Frameworks>;
  /** fetch data from the table: "template_frameworks" using primary key columns */
  template_frameworks_by_pk?: Maybe<Template_Frameworks>;
  /** An array relationship */
  template_frameworks_controls: Array<Template_Frameworks_Controls>;
  /** fetch data from the table: "template_frameworks_controls" using primary key columns */
  template_frameworks_controls_by_pk?: Maybe<Template_Frameworks_Controls>;
  /** fetch data from the table in a streaming manner: "template_frameworks_controls" */
  template_frameworks_controls_stream: Array<Template_Frameworks_Controls>;
  /** fetch data from the table in a streaming manner: "template_frameworks" */
  template_frameworks_stream: Array<Template_Frameworks>;
  /** An array relationship */
  template_tasks: Array<Template_Tasks>;
  /** An aggregate relationship */
  template_tasks_aggregate: Template_Tasks_Aggregate;
  /** fetch data from the table: "template_tasks" using primary key columns */
  template_tasks_by_pk?: Maybe<Template_Tasks>;
  /** fetch data from the table in a streaming manner: "template_tasks" */
  template_tasks_stream: Array<Template_Tasks>;
  /** fetch data from the table: "trust_portal.categories" */
  trust_portal_categories: Array<Trust_Portal_Categories>;
  /** fetch data from the table: "trust_portal.categories" using primary key columns */
  trust_portal_categories_by_pk?: Maybe<Trust_Portal_Categories>;
  /** fetch data from the table in a streaming manner: "trust_portal.categories" */
  trust_portal_categories_stream: Array<Trust_Portal_Categories>;
  /** fetch data from the table: "trust_portal.resource_sections" */
  trust_portal_resource_sections: Array<Trust_Portal_Resource_Sections>;
  /** fetch data from the table: "trust_portal.resource_sections" using primary key columns */
  trust_portal_resource_sections_by_pk?: Maybe<Trust_Portal_Resource_Sections>;
  /** fetch data from the table in a streaming manner: "trust_portal.resource_sections" */
  trust_portal_resource_sections_stream: Array<Trust_Portal_Resource_Sections>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** fetch data from the table: "user_controls_stats_view" */
  user_controls_stats_view: Array<User_Controls_Stats_View>;
  /** fetch data from the table in a streaming manner: "user_controls_stats_view" */
  user_controls_stats_view_stream: Array<User_Controls_Stats_View>;
  /** An array relationship */
  user_notifications: Array<User_Notifications>;
  /** An aggregate relationship */
  user_notifications_aggregate: User_Notifications_Aggregate;
  /** fetch data from the table: "user_notifications" using primary key columns */
  user_notifications_by_pk?: Maybe<User_Notifications>;
  /** fetch data from the table in a streaming manner: "user_notifications" */
  user_notifications_stream: Array<User_Notifications>;
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** fetch data from the table in a streaming manner: "user_profiles" */
  user_profiles_stream: Array<User_Profiles>;
  /** fetch data from the table: "user_tasks_stats_view" */
  user_tasks_stats_view: Array<User_Tasks_Stats_View>;
  /** fetch data from the table in a streaming manner: "user_tasks_stats_view" */
  user_tasks_stats_view_stream: Array<User_Tasks_Stats_View>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** fetch data from the table in a streaming manner: "auth.users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "vendor_questionnaire_schedules" */
  vendor_questionnaire_schedules: Array<Vendor_Questionnaire_Schedules>;
  /** fetch data from the table: "vendor_questionnaire_schedules" using primary key columns */
  vendor_questionnaire_schedules_by_pk?: Maybe<Vendor_Questionnaire_Schedules>;
  /** fetch data from the table in a streaming manner: "vendor_questionnaire_schedules" */
  vendor_questionnaire_schedules_stream: Array<Vendor_Questionnaire_Schedules>;
  /** An array relationship */
  vendor_questionnaires: Array<Vendor_Questionnaires>;
  /** fetch data from the table: "vendor_questionnaires" using primary key columns */
  vendor_questionnaires_by_pk?: Maybe<Vendor_Questionnaires>;
  /** fetch data from the table in a streaming manner: "vendor_questionnaires" */
  vendor_questionnaires_stream: Array<Vendor_Questionnaires>;
  /** An array relationship */
  vendors: Array<Vendors>;
  /** An aggregate relationship */
  vendors_aggregate: Vendors_Aggregate;
  /** fetch data from the table: "vendors" using primary key columns */
  vendors_by_pk?: Maybe<Vendors>;
  /** fetch data from the table in a streaming manner: "vendors" */
  vendors_stream: Array<Vendors>;
  /** An array relationship */
  vq_custom_fields: Array<Vq_Custom_Fields>;
  /** fetch data from the table: "vq_custom_fields" using primary key columns */
  vq_custom_fields_by_pk?: Maybe<Vq_Custom_Fields>;
  /** fetch data from the table in a streaming manner: "vq_custom_fields" */
  vq_custom_fields_stream: Array<Vq_Custom_Fields>;
};

export type Subscription_RootAgent_InstancesArgs = {
  distinct_on?: InputMaybe<Array<Agent_Instances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Instances_Order_By>>;
  where?: InputMaybe<Agent_Instances_Bool_Exp>;
};

export type Subscription_RootAgent_Instances_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootAgent_Instances_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agent_Instances_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_Instances_Bool_Exp>;
};

export type Subscription_RootAi_Control_Evidences_SuggestionsArgs = {
  args: Ai_Control_Evidences_Suggestions_Args;
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

export type Subscription_RootAi_Control_Evidences_Suggestions_AggregateArgs = {
  args: Ai_Control_Evidences_Suggestions_Args;
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

export type Subscription_RootAi_Control_Evidences_Suggestions_With_ChunksArgs = {
  args: Ai_Control_Evidences_Suggestions_With_Chunks_Args;
  distinct_on?: InputMaybe<Array<Ai_Evidence_Suggestion_Chunk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Evidence_Suggestion_Chunk_Order_By>>;
  where?: InputMaybe<Ai_Evidence_Suggestion_Chunk_Bool_Exp>;
};

export type Subscription_RootAi_Controls_Text_SearchArgs = {
  args: Ai_Controls_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Subscription_RootAi_Controls_Text_Search_AggregateArgs = {
  args: Ai_Controls_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Subscription_RootAi_Controls_Vector_Store_SearchArgs = {
  args: Ai_Controls_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Subscription_RootAi_Controls_Vector_Store_Search_AggregateArgs = {
  args: Ai_Controls_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Subscription_RootAi_Documents_Text_SearchArgs = {
  args: Ai_Documents_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};

export type Subscription_RootAi_Documents_Vector_StoreArgs = {
  distinct_on?: InputMaybe<Array<Ai_Documents_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Documents_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Documents_Vector_Store_Bool_Exp>;
};

export type Subscription_RootAi_Documents_Vector_Store_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootAi_Documents_Vector_Store_SearchArgs = {
  args: Ai_Documents_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Ai_Documents_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Documents_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Documents_Vector_Store_Bool_Exp>;
};

export type Subscription_RootAi_Documents_Vector_Store_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ai_Documents_Vector_Store_Stream_Cursor_Input>>;
  where?: InputMaybe<Ai_Documents_Vector_Store_Bool_Exp>;
};

export type Subscription_RootAi_Evidence_Controls_SuggestionsArgs = {
  args: Ai_Evidence_Controls_Suggestions_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Subscription_RootAi_Evidence_Controls_Suggestions_AggregateArgs = {
  args: Ai_Evidence_Controls_Suggestions_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Subscription_RootAi_Evidences_Text_SearchArgs = {
  args: Ai_Evidences_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

export type Subscription_RootAi_Evidences_Text_Search_AggregateArgs = {
  args: Ai_Evidences_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

export type Subscription_RootAi_Evidences_Vector_Store_SearchArgs = {
  args: Ai_Evidences_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Ai_Evidences_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Evidences_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Evidences_Vector_Store_Bool_Exp>;
};

export type Subscription_RootAi_Policies_Text_SearchArgs = {
  args: Ai_Policies_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policies_Order_By>>;
  where?: InputMaybe<Policies_Bool_Exp>;
};

export type Subscription_RootAi_Policies_Vector_StoreArgs = {
  distinct_on?: InputMaybe<Array<Ai_Policies_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Policies_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Policies_Vector_Store_Bool_Exp>;
};

export type Subscription_RootAi_Policies_Vector_Store_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootAi_Policies_Vector_Store_SearchArgs = {
  args: Ai_Policies_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Ai_Policies_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Policies_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Policies_Vector_Store_Bool_Exp>;
};

export type Subscription_RootAi_Policies_Vector_Store_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ai_Policies_Vector_Store_Stream_Cursor_Input>>;
  where?: InputMaybe<Ai_Policies_Vector_Store_Bool_Exp>;
};

export type Subscription_RootAi_Programs_Text_SearchArgs = {
  args: Ai_Programs_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Programs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programs_Order_By>>;
  where?: InputMaybe<Programs_Bool_Exp>;
};

export type Subscription_RootAi_Programs_Vector_Store_SearchArgs = {
  args: Ai_Programs_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Programs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programs_Order_By>>;
  where?: InputMaybe<Programs_Bool_Exp>;
};

export type Subscription_RootAi_Relevant_Policy_ControlsArgs = {
  args: Ai_Relevant_Policy_Controls_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Subscription_RootAi_Relevant_Policy_Controls_AggregateArgs = {
  args: Ai_Relevant_Policy_Controls_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Subscription_RootAi_Risk_Controls_SuggestionsArgs = {
  args: Ai_Risk_Controls_Suggestions_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Subscription_RootAi_Risk_Controls_Suggestions_AggregateArgs = {
  args: Ai_Risk_Controls_Suggestions_Args;
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Subscription_RootAi_Risks_Text_SearchArgs = {
  args: Ai_Risks_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

export type Subscription_RootAi_Risks_Text_Search_AggregateArgs = {
  args: Ai_Risks_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

export type Subscription_RootAi_Risks_Vector_Store_SearchArgs = {
  args: Ai_Risks_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

export type Subscription_RootAi_Risks_Vector_Store_Search_AggregateArgs = {
  args: Ai_Risks_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

export type Subscription_RootAi_Tasks_Text_SearchArgs = {
  args: Ai_Tasks_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

export type Subscription_RootAi_Tasks_Text_Search_AggregateArgs = {
  args: Ai_Tasks_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

export type Subscription_RootAi_Tasks_Vector_Store_SearchArgs = {
  args: Ai_Tasks_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

export type Subscription_RootAi_Tasks_Vector_Store_Search_AggregateArgs = {
  args: Ai_Tasks_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

export type Subscription_RootAi_Vendors_Text_SearchArgs = {
  args: Ai_Vendors_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

export type Subscription_RootAi_Vendors_Text_Search_AggregateArgs = {
  args: Ai_Vendors_Text_Search_Args;
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

export type Subscription_RootAi_Vendors_Vector_Store_SearchArgs = {
  args: Ai_Vendors_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

export type Subscription_RootAi_Vendors_Vector_Store_Search_AggregateArgs = {
  args: Ai_Vendors_Vector_Store_Search_Args;
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

export type Subscription_RootApi_Key_Usage_LogsArgs = {
  distinct_on?: InputMaybe<Array<Api_Key_Usage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Key_Usage_Logs_Order_By>>;
  where?: InputMaybe<Api_Key_Usage_Logs_Bool_Exp>;
};

export type Subscription_RootApi_Key_Usage_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Api_Key_Usage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Key_Usage_Logs_Order_By>>;
  where?: InputMaybe<Api_Key_Usage_Logs_Bool_Exp>;
};

export type Subscription_RootApi_Key_Usage_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootApi_Key_Usage_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Api_Key_Usage_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Api_Key_Usage_Logs_Bool_Exp>;
};

export type Subscription_RootAudit_Control_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Control_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Control_History_Order_By>>;
  where?: InputMaybe<Audit_Control_History_Bool_Exp>;
};

export type Subscription_RootAudit_Control_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Audit_Control_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Control_History_Bool_Exp>;
};

export type Subscription_RootAudit_Evidence_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Evidence_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Evidence_History_Order_By>>;
  where?: InputMaybe<Audit_Evidence_History_Bool_Exp>;
};

export type Subscription_RootAudit_Evidence_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootAudit_Evidence_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Audit_Evidence_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Evidence_History_Bool_Exp>;
};

export type Subscription_RootAudit_Finding_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Finding_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Finding_History_Order_By>>;
  where?: InputMaybe<Audit_Finding_History_Bool_Exp>;
};

export type Subscription_RootAudit_Finding_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Finding_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Finding_History_Order_By>>;
  where?: InputMaybe<Audit_Finding_History_Bool_Exp>;
};

export type Subscription_RootAudit_Finding_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootAudit_Finding_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Audit_Finding_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Finding_History_Bool_Exp>;
};

export type Subscription_RootAudit_Policy_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Policy_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Policy_History_Order_By>>;
  where?: InputMaybe<Audit_Policy_History_Bool_Exp>;
};

export type Subscription_RootAudit_Policy_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootAudit_Policy_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Audit_Policy_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Policy_History_Bool_Exp>;
};

export type Subscription_RootAudit_Risk_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Risk_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Risk_History_Order_By>>;
  where?: InputMaybe<Audit_Risk_History_Bool_Exp>;
};

export type Subscription_RootAudit_Risk_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Audit_Risk_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Risk_History_Bool_Exp>;
};

export type Subscription_RootAudit_Task_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Task_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Task_History_Order_By>>;
  where?: InputMaybe<Audit_Task_History_Bool_Exp>;
};

export type Subscription_RootAudit_Task_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Audit_Task_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Task_History_Bool_Exp>;
};

export type Subscription_RootAudit_Vendor_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Audit_Vendor_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Vendor_History_Order_By>>;
  where?: InputMaybe<Audit_Vendor_History_Bool_Exp>;
};

export type Subscription_RootAudit_Vendor_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Audit_Vendor_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Vendor_History_Bool_Exp>;
};

export type Subscription_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

export type Subscription_RootAuthRefreshTokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRefreshTokens_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

export type Subscription_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};

export type Subscription_RootCategories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootCategories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};

export type Subscription_RootClient_Questionnaire_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Client_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Client_Questionnaire_Questions_Bool_Exp>;
};

export type Subscription_RootClient_Questionnaire_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Client_Questionnaire_Questions_Bool_Exp>;
};

export type Subscription_RootClient_Questionnaire_Questions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootClient_Questionnaire_Questions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Client_Questionnaire_Questions_Stream_Cursor_Input>>;
  where?: InputMaybe<Client_Questionnaire_Questions_Bool_Exp>;
};

export type Subscription_RootClient_QuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Client_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Questionnaires_Order_By>>;
  where?: InputMaybe<Client_Questionnaires_Bool_Exp>;
};

export type Subscription_RootClient_Questionnaires_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootClient_Questionnaires_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Client_Questionnaires_Stream_Cursor_Input>>;
  where?: InputMaybe<Client_Questionnaires_Bool_Exp>;
};

export type Subscription_RootControlsArgs = {
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Subscription_RootControls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Subscription_RootControls_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootControls_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Controls_Stream_Cursor_Input>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

export type Subscription_RootCriteriaArgs = {
  distinct_on?: InputMaybe<Array<Criteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Criteria_Order_By>>;
  where?: InputMaybe<Criteria_Bool_Exp>;
};

export type Subscription_RootCriteria_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootCriteria_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Criteria_Stream_Cursor_Input>>;
  where?: InputMaybe<Criteria_Bool_Exp>;
};

export type Subscription_RootDaily_Control_Stats_ViewArgs = {
  distinct_on?: InputMaybe<Array<Daily_Control_Stats_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Control_Stats_View_Order_By>>;
  where?: InputMaybe<Daily_Control_Stats_View_Bool_Exp>;
};

export type Subscription_RootDaily_Control_Stats_View_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Daily_Control_Stats_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Daily_Control_Stats_View_Bool_Exp>;
};

export type Subscription_RootDaily_Control_User_Stats_ViewArgs = {
  distinct_on?: InputMaybe<Array<Daily_Control_User_Stats_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Control_User_Stats_View_Order_By>>;
  where?: InputMaybe<Daily_Control_User_Stats_View_Bool_Exp>;
};

export type Subscription_RootDaily_Control_User_Stats_View_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Daily_Control_User_Stats_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Daily_Control_User_Stats_View_Bool_Exp>;
};

export type Subscription_RootDaily_Risk_Stats_ViewArgs = {
  distinct_on?: InputMaybe<Array<Daily_Risk_Stats_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Risk_Stats_View_Order_By>>;
  where?: InputMaybe<Daily_Risk_Stats_View_Bool_Exp>;
};

export type Subscription_RootDaily_Risk_Stats_View_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Daily_Risk_Stats_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Daily_Risk_Stats_View_Bool_Exp>;
};

export type Subscription_RootDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};

export type Subscription_RootDocuments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootDocuments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};

export type Subscription_RootEvidence_IntegrationsArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Integrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Integrations_Order_By>>;
  where?: InputMaybe<Evidence_Integrations_Bool_Exp>;
};

export type Subscription_RootEvidence_Integrations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootEvidence_Integrations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Evidence_Integrations_Stream_Cursor_Input>>;
  where?: InputMaybe<Evidence_Integrations_Bool_Exp>;
};

export type Subscription_RootEvidencesArgs = {
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

export type Subscription_RootEvidences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Evidences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidences_Order_By>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

export type Subscription_RootEvidences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootEvidences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Evidences_Stream_Cursor_Input>>;
  where?: InputMaybe<Evidences_Bool_Exp>;
};

export type Subscription_RootField_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Field_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Configs_Order_By>>;
  where?: InputMaybe<Field_Configs_Bool_Exp>;
};

export type Subscription_RootField_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootField_Configs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Field_Configs_Stream_Cursor_Input>>;
  where?: InputMaybe<Field_Configs_Bool_Exp>;
};

export type Subscription_RootFindingsArgs = {
  distinct_on?: InputMaybe<Array<Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Findings_Order_By>>;
  where?: InputMaybe<Findings_Bool_Exp>;
};

export type Subscription_RootFindings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Findings_Order_By>>;
  where?: InputMaybe<Findings_Bool_Exp>;
};

export type Subscription_RootFindings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFindings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Findings_Stream_Cursor_Input>>;
  where?: InputMaybe<Findings_Bool_Exp>;
};

export type Subscription_RootFrameworksArgs = {
  distinct_on?: InputMaybe<Array<Frameworks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Frameworks_Order_By>>;
  where?: InputMaybe<Frameworks_Bool_Exp>;
};

export type Subscription_RootFrameworks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFrameworks_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Frameworks_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Frameworks_Controls_Order_By>>;
  where?: InputMaybe<Frameworks_Controls_Bool_Exp>;
};

export type Subscription_RootFrameworks_Controls_By_PkArgs = {
  control_id: Scalars['uuid']['input'];
  framework_id: Scalars['uuid']['input'];
};

export type Subscription_RootFrameworks_Controls_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Frameworks_Controls_Stream_Cursor_Input>>;
  where?: InputMaybe<Frameworks_Controls_Bool_Exp>;
};

export type Subscription_RootFrameworks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Frameworks_Stream_Cursor_Input>>;
  where?: InputMaybe<Frameworks_Bool_Exp>;
};

export type Subscription_RootGroupsArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};

export type Subscription_RootGroups_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootGroups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};

export type Subscription_RootGrove_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Grove_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grove_Agents_Order_By>>;
  where?: InputMaybe<Grove_Agents_Bool_Exp>;
};

export type Subscription_RootGrove_Agents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootGrove_Agents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Grove_Agents_Stream_Cursor_Input>>;
  where?: InputMaybe<Grove_Agents_Bool_Exp>;
};

export type Subscription_RootGrove_ChatsArgs = {
  distinct_on?: InputMaybe<Array<Grove_Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grove_Chats_Order_By>>;
  where?: InputMaybe<Grove_Chats_Bool_Exp>;
};

export type Subscription_RootGrove_Chats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grove_Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grove_Chats_Order_By>>;
  where?: InputMaybe<Grove_Chats_Bool_Exp>;
};

export type Subscription_RootGrove_Chats_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootGrove_Chats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Grove_Chats_Stream_Cursor_Input>>;
  where?: InputMaybe<Grove_Chats_Bool_Exp>;
};

export type Subscription_RootGrove_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Grove_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grove_Messages_Order_By>>;
  where?: InputMaybe<Grove_Messages_Bool_Exp>;
};

export type Subscription_RootGrove_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grove_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grove_Messages_Order_By>>;
  where?: InputMaybe<Grove_Messages_Bool_Exp>;
};

export type Subscription_RootGrove_Messages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootGrove_Messages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Grove_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Grove_Messages_Bool_Exp>;
};

export type Subscription_RootIntegrationsArgs = {
  distinct_on?: InputMaybe<Array<Integrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integrations_Order_By>>;
  where?: InputMaybe<Integrations_Bool_Exp>;
};

export type Subscription_RootIntegrations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootIntegrations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Integrations_Stream_Cursor_Input>>;
  where?: InputMaybe<Integrations_Bool_Exp>;
};

export type Subscription_RootInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};

export type Subscription_RootInvitations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootInvitations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invitations_Stream_Cursor_Input>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};

export type Subscription_RootNotification_Disabled_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Notification_Disabled_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Disabled_Settings_Order_By>>;
  where?: InputMaybe<Notification_Disabled_Settings_Bool_Exp>;
};

export type Subscription_RootNotification_Disabled_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootNotification_Disabled_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notification_Disabled_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Disabled_Settings_Bool_Exp>;
};

export type Subscription_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

export type Subscription_RootNotifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootNotifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

export type Subscription_RootOrganization_Evidence_TagsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Evidence_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Evidence_Tags_Order_By>>;
  where?: InputMaybe<Organization_Evidence_Tags_Bool_Exp>;
};

export type Subscription_RootOrganization_Evidence_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootOrganization_Evidence_Tags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Evidence_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Evidence_Tags_Bool_Exp>;
};

export type Subscription_RootOrganization_Finding_SeveritiesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Finding_Severities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Finding_Severities_Order_By>>;
  where?: InputMaybe<Organization_Finding_Severities_Bool_Exp>;
};

export type Subscription_RootOrganization_Finding_Severities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootOrganization_Finding_Severities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Finding_Severities_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Finding_Severities_Bool_Exp>;
};

export type Subscription_RootOrganization_IntegrationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Integrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Integrations_Order_By>>;
  where?: InputMaybe<Organization_Integrations_Bool_Exp>;
};

export type Subscription_RootOrganization_Integrations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootOrganization_Integrations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Integrations_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Integrations_Bool_Exp>;
};

export type Subscription_RootOrganization_Risk_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Risk_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Risk_Categories_Order_By>>;
  where?: InputMaybe<Organization_Risk_Categories_Bool_Exp>;
};

export type Subscription_RootOrganization_Risk_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootOrganization_Risk_Categories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Risk_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Risk_Categories_Bool_Exp>;
};

export type Subscription_RootOrganization_Risk_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Risk_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Risk_Levels_Order_By>>;
  where?: InputMaybe<Organization_Risk_Levels_Bool_Exp>;
};

export type Subscription_RootOrganization_Risk_Levels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootOrganization_Risk_Levels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Risk_Levels_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Risk_Levels_Bool_Exp>;
};

export type Subscription_RootOrganization_Risk_TagsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Risk_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Risk_Tags_Order_By>>;
  where?: InputMaybe<Organization_Risk_Tags_Bool_Exp>;
};

export type Subscription_RootOrganization_Risk_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootOrganization_Risk_Tags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Risk_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Risk_Tags_Bool_Exp>;
};

export type Subscription_RootOrganization_Template_FrameworksArgs = {
  distinct_on?: InputMaybe<Array<Organization_Template_Frameworks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Template_Frameworks_Order_By>>;
  where?: InputMaybe<Organization_Template_Frameworks_Bool_Exp>;
};

export type Subscription_RootOrganization_Template_Frameworks_By_PkArgs = {
  organization_id: Scalars['uuid']['input'];
  template_framework_id: Scalars['uuid']['input'];
};

export type Subscription_RootOrganization_Template_Frameworks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Template_Frameworks_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Template_Frameworks_Bool_Exp>;
};

export type Subscription_RootOrganization_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Tenants_Order_By>>;
  where?: InputMaybe<Organization_Tenants_Bool_Exp>;
};

export type Subscription_RootOrganization_Tenants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootOrganization_Tenants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Tenants_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Tenants_Bool_Exp>;
};

export type Subscription_RootOrganization_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Users_Order_By>>;
  where?: InputMaybe<Organization_Users_Bool_Exp>;
};

export type Subscription_RootOrganization_Users_By_PkArgs = {
  organization_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};

export type Subscription_RootOrganization_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Users_Bool_Exp>;
};

export type Subscription_RootOrganization_Vendor_Risk_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Vendor_Risk_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Vendor_Risk_Levels_Order_By>>;
  where?: InputMaybe<Organization_Vendor_Risk_Levels_Bool_Exp>;
};

export type Subscription_RootOrganization_Vendor_Risk_Levels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootOrganization_Vendor_Risk_Levels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Vendor_Risk_Levels_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Vendor_Risk_Levels_Bool_Exp>;
};

export type Subscription_RootOrganization_Vendor_TiersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Vendor_Tiers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Vendor_Tiers_Order_By>>;
  where?: InputMaybe<Organization_Vendor_Tiers_Bool_Exp>;
};

export type Subscription_RootOrganization_Vendor_Tiers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootOrganization_Vendor_Tiers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Vendor_Tiers_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Vendor_Tiers_Bool_Exp>;
};

export type Subscription_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};

export type Subscription_RootOrganizations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootOrganizations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organizations_Stream_Cursor_Input>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};

export type Subscription_RootPoliciesArgs = {
  distinct_on?: InputMaybe<Array<Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policies_Order_By>>;
  where?: InputMaybe<Policies_Bool_Exp>;
};

export type Subscription_RootPolicies_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootPolicies_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Policies_Stream_Cursor_Input>>;
  where?: InputMaybe<Policies_Bool_Exp>;
};

export type Subscription_RootPolicy_IntegrationsArgs = {
  distinct_on?: InputMaybe<Array<Policy_Integrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Integrations_Order_By>>;
  where?: InputMaybe<Policy_Integrations_Bool_Exp>;
};

export type Subscription_RootPolicy_Integrations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootPolicy_Integrations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Policy_Integrations_Stream_Cursor_Input>>;
  where?: InputMaybe<Policy_Integrations_Bool_Exp>;
};

export type Subscription_RootProgramsArgs = {
  distinct_on?: InputMaybe<Array<Programs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programs_Order_By>>;
  where?: InputMaybe<Programs_Bool_Exp>;
};

export type Subscription_RootPrograms_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootPrograms_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Programs_Stream_Cursor_Input>>;
  where?: InputMaybe<Programs_Bool_Exp>;
};

export type Subscription_RootQuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaires_Order_By>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};

export type Subscription_RootQuestionnaires_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootQuestionnaires_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Questionnaires_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};

export type Subscription_RootReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};

export type Subscription_RootReports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootReports_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};

export type Subscription_RootRetained_FindingsArgs = {
  distinct_on?: InputMaybe<Array<Retained_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Retained_Findings_Order_By>>;
  where?: InputMaybe<Retained_Findings_Bool_Exp>;
};

export type Subscription_RootRetained_Findings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retained_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Retained_Findings_Order_By>>;
  where?: InputMaybe<Retained_Findings_Bool_Exp>;
};

export type Subscription_RootRetained_Findings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Retained_Findings_Stream_Cursor_Input>>;
  where?: InputMaybe<Retained_Findings_Bool_Exp>;
};

export type Subscription_RootRisk_ImpactsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Impacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Impacts_Order_By>>;
  where?: InputMaybe<Risk_Impacts_Bool_Exp>;
};

export type Subscription_RootRisk_Impacts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootRisk_Impacts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Impacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Impacts_Bool_Exp>;
};

export type Subscription_RootRisk_Inherent_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Inherent_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Inherent_Levels_Order_By>>;
  where?: InputMaybe<Risk_Inherent_Levels_Bool_Exp>;
};

export type Subscription_RootRisk_Inherent_Levels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootRisk_Inherent_Levels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Inherent_Levels_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Inherent_Levels_Bool_Exp>;
};

export type Subscription_RootRisk_LikelihoodsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Likelihoods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Likelihoods_Order_By>>;
  where?: InputMaybe<Risk_Likelihoods_Bool_Exp>;
};

export type Subscription_RootRisk_Likelihoods_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootRisk_Likelihoods_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Likelihoods_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Likelihoods_Bool_Exp>;
};

export type Subscription_RootRisk_Residual_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Residual_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Residual_Levels_Order_By>>;
  where?: InputMaybe<Risk_Residual_Levels_Bool_Exp>;
};

export type Subscription_RootRisk_Residual_Levels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootRisk_Residual_Levels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Residual_Levels_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Residual_Levels_Bool_Exp>;
};

export type Subscription_RootRisksArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

export type Subscription_RootRisks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risks_Order_By>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

export type Subscription_RootRisks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootRisks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risks_Stream_Cursor_Input>>;
  where?: InputMaybe<Risks_Bool_Exp>;
};

export type Subscription_RootRole_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};

export type Subscription_RootRole_Permissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootRole_Permissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Role_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};

export type Subscription_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

export type Subscription_RootRoles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootRoles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

export type Subscription_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};

export type Subscription_RootTags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootTags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};

export type Subscription_RootTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

export type Subscription_RootTasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootTeam_MembersArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

export type Subscription_RootTeam_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

export type Subscription_RootTeam_Members_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootTeam_Members_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Team_Members_Stream_Cursor_Input>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

export type Subscription_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

export type Subscription_RootTeams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootTeams_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Teams_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

export type Subscription_RootTemplate_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Template_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Controls_Order_By>>;
  where?: InputMaybe<Template_Controls_Bool_Exp>;
};

export type Subscription_RootTemplate_Controls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Controls_Order_By>>;
  where?: InputMaybe<Template_Controls_Bool_Exp>;
};

export type Subscription_RootTemplate_Controls_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootTemplate_Controls_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Template_Controls_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Controls_Bool_Exp>;
};

export type Subscription_RootTemplate_FrameworksArgs = {
  distinct_on?: InputMaybe<Array<Template_Frameworks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Frameworks_Order_By>>;
  where?: InputMaybe<Template_Frameworks_Bool_Exp>;
};

export type Subscription_RootTemplate_Frameworks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootTemplate_Frameworks_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Template_Frameworks_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Frameworks_Controls_Order_By>>;
  where?: InputMaybe<Template_Frameworks_Controls_Bool_Exp>;
};

export type Subscription_RootTemplate_Frameworks_Controls_By_PkArgs = {
  control_id: Scalars['uuid']['input'];
  framework_id: Scalars['uuid']['input'];
};

export type Subscription_RootTemplate_Frameworks_Controls_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Template_Frameworks_Controls_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Frameworks_Controls_Bool_Exp>;
};

export type Subscription_RootTemplate_Frameworks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Template_Frameworks_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Frameworks_Bool_Exp>;
};

export type Subscription_RootTemplate_TasksArgs = {
  distinct_on?: InputMaybe<Array<Template_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Tasks_Order_By>>;
  where?: InputMaybe<Template_Tasks_Bool_Exp>;
};

export type Subscription_RootTemplate_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Tasks_Order_By>>;
  where?: InputMaybe<Template_Tasks_Bool_Exp>;
};

export type Subscription_RootTemplate_Tasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootTemplate_Tasks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Template_Tasks_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Tasks_Bool_Exp>;
};

export type Subscription_RootTrust_Portal_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Categories_Order_By>>;
  where?: InputMaybe<Trust_Portal_Categories_Bool_Exp>;
};

export type Subscription_RootTrust_Portal_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootTrust_Portal_Categories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trust_Portal_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Trust_Portal_Categories_Bool_Exp>;
};

export type Subscription_RootTrust_Portal_Resource_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Resource_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Resource_Sections_Order_By>>;
  where?: InputMaybe<Trust_Portal_Resource_Sections_Bool_Exp>;
};

export type Subscription_RootTrust_Portal_Resource_Sections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootTrust_Portal_Resource_Sections_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trust_Portal_Resource_Sections_Stream_Cursor_Input>>;
  where?: InputMaybe<Trust_Portal_Resource_Sections_Bool_Exp>;
};

export type Subscription_RootUserArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootUser_Controls_Stats_ViewArgs = {
  distinct_on?: InputMaybe<Array<User_Controls_Stats_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Controls_Stats_View_Order_By>>;
  where?: InputMaybe<User_Controls_Stats_View_Bool_Exp>;
};

export type Subscription_RootUser_Controls_Stats_View_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Controls_Stats_View_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Controls_Stats_View_Bool_Exp>;
};

export type Subscription_RootUser_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};

export type Subscription_RootUser_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};

export type Subscription_RootUser_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootUser_Notifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};

export type Subscription_RootUser_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};

export type Subscription_RootUser_Profiles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootUser_Profiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Profiles_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};

export type Subscription_RootUser_Tasks_Stats_ViewArgs = {
  distinct_on?: InputMaybe<Array<User_Tasks_Stats_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tasks_Stats_View_Order_By>>;
  where?: InputMaybe<User_Tasks_Stats_View_Bool_Exp>;
};

export type Subscription_RootUser_Tasks_Stats_View_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Tasks_Stats_View_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Tasks_Stats_View_Bool_Exp>;
};

export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

export type Subscription_RootVendor_Questionnaire_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaire_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaire_Schedules_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaire_Schedules_Bool_Exp>;
};

export type Subscription_RootVendor_Questionnaire_Schedules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootVendor_Questionnaire_Schedules_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vendor_Questionnaire_Schedules_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendor_Questionnaire_Schedules_Bool_Exp>;
};

export type Subscription_RootVendor_QuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaires_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
};

export type Subscription_RootVendor_Questionnaires_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootVendor_Questionnaires_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vendor_Questionnaires_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
};

export type Subscription_RootVendorsArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

export type Subscription_RootVendors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

export type Subscription_RootVendors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootVendors_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vendors_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

export type Subscription_RootVq_Custom_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Vq_Custom_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vq_Custom_Fields_Order_By>>;
  where?: InputMaybe<Vq_Custom_Fields_Bool_Exp>;
};

export type Subscription_RootVq_Custom_Fields_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootVq_Custom_Fields_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vq_Custom_Fields_Stream_Cursor_Input>>;
  where?: InputMaybe<Vq_Custom_Fields_Bool_Exp>;
};

export enum System_Fields_Enum {
  Approval = 'approval',
  ApprovalAdditionOfRiskToRiskRegister = 'approval_addition_of_risk_to_risk_register',
  ApprovalClosingTheRisk = 'approval_closing_the_risk',
  ApprovalInherentRiskLevel = 'approval_inherent_risk_level',
  ApprovalResidualRiskLevel = 'approval_residual_risk_level',
  ApprovalTreatment = 'approval_treatment',
  Approvers = 'approvers',
  Assignee = 'assignee',
  Category = 'category',
  CompletedDate = 'completed_date',
  CreatedBy = 'created_by',
  Criteria = 'criteria',
  CurrentVersion = 'current_version',
  Description = 'description',
  DueDate = 'due_date',
  FindingAnchors = 'finding_anchors',
  FindingArchive = 'finding_archive',
  FindingCycleYear = 'finding_cycle_year',
  FindingPublication = 'finding_publication',
  FindingRelations = 'finding_relations',
  FindingSeverity = 'finding_severity',
  FindingSource = 'finding_source',
  FindingStatus = 'finding_status',
  FindingTitle = 'finding_title',
  Frequency = 'frequency',
  Group = 'group',
  InherentRisk = 'inherent_risk',
  InherentScore = 'inherent_score',
  LastApproved = 'last_approved',
  LastReviewed = 'last_reviewed',
  NextApproval = 'next_approval',
  NextReviewDate = 'next_review_date',
  OtherApprovals = 'other_approvals',
  Owner = 'owner',
  Priority = 'priority',
  Programs = 'programs',
  RequestedBy = 'requested_by',
  ResidualRisk = 'residual_risk',
  ResidualScore = 'residual_score',
  RiskLevel = 'risk_level',
  Tags = 'tags',
  Tier = 'tier',
  Treatment = 'treatment',
  TreatmentDetails = 'treatment_details',
  TreatmentStrategy = 'treatment_strategy',
  VendorContact = 'vendor_contact',
}

/** Boolean expression to compare columns of type "system_fields_enum". All fields are combined with logical 'AND'. */
export type System_Fields_Enum_Comparison_Exp = {
  _eq?: InputMaybe<System_Fields_Enum>;
  _in?: InputMaybe<Array<System_Fields_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<System_Fields_Enum>;
  _nin?: InputMaybe<Array<System_Fields_Enum>>;
};

export enum System_Roles_Enum {
  Admin = 'admin',
  Auditor = 'auditor',
  Member = 'member',
}

/** Boolean expression to compare columns of type "system_roles_enum". All fields are combined with logical 'AND'. */
export type System_Roles_Enum_Comparison_Exp = {
  _eq?: InputMaybe<System_Roles_Enum>;
  _in?: InputMaybe<Array<System_Roles_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<System_Roles_Enum>;
  _nin?: InputMaybe<Array<System_Roles_Enum>>;
};

/** stores custom tags related to organization */
export type Tags = {
  __typename?: 'tags';
  /** An array relationship */
  control_tags: Array<Control_Tags>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** stores custom tags related to organization */
export type TagsControl_TagsArgs = {
  distinct_on?: InputMaybe<Array<Control_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Tags_Order_By>>;
  where?: InputMaybe<Control_Tags_Bool_Exp>;
};

/** order by aggregate values of table "tags" */
export type Tags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tags_Max_Order_By>;
  min?: InputMaybe<Tags_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "tags". All fields are combined with a logical 'AND'. */
export type Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Tags_Bool_Exp>>;
  _not?: InputMaybe<Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Tags_Bool_Exp>>;
  control_tags?: InputMaybe<Control_Tags_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "tags" */
export enum Tags_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  TagsNameOrganizationIdKey = 'tags_name_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  TagsPkey = 'tags_pkey',
}

/** input type for inserting data into table "tags" */
export type Tags_Insert_Input = {
  control_tags?: InputMaybe<Control_Tags_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "tags" */
export type Tags_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tags" */
export type Tags_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tags" */
export type Tags_Mutation_Response = {
  __typename?: 'tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tags>;
};

/** input type for inserting object relation for remote table "tags" */
export type Tags_Obj_Rel_Insert_Input = {
  data: Tags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};

/** on_conflict condition type for table "tags" */
export type Tags_On_Conflict = {
  constraint: Tags_Constraint;
  update_columns?: Array<Tags_Update_Column>;
  where?: InputMaybe<Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "tags". */
export type Tags_Order_By = {
  control_tags_aggregate?: InputMaybe<Control_Tags_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tags */
export type Tags_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tags" */
export enum Tags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "tags" */
export type Tags_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tags" */
export type Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "tags" */
export enum Tags_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Tags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tags_Bool_Exp;
};

/** users responsible for task */
export type Task_Owners = {
  __typename?: 'task_owners';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  owner_id: Scalars['uuid']['output'];
  /** An object relationship */
  task: Tasks;
  task_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};

/** order by aggregate values of table "task_owners" */
export type Task_Owners_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Owners_Max_Order_By>;
  min?: InputMaybe<Task_Owners_Min_Order_By>;
};

/** input type for inserting array relation for remote table "task_owners" */
export type Task_Owners_Arr_Rel_Insert_Input = {
  data: Array<Task_Owners_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_Owners_On_Conflict>;
};

/** Boolean expression to filter rows from the table "task_owners". All fields are combined with a logical 'AND'. */
export type Task_Owners_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Owners_Bool_Exp>>;
  _not?: InputMaybe<Task_Owners_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Owners_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "task_owners" */
export enum Task_Owners_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaskOwnersPkey = 'task_owners_pkey',
  /** unique or primary key constraint on columns "task_id", "owner_id" */
  TaskOwnersTaskIdOwnerIdKey = 'task_owners_task_id_owner_id_key',
}

/** input type for inserting data into table "task_owners" */
export type Task_Owners_Insert_Input = {
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
  task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "task_owners" */
export type Task_Owners_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "task_owners" */
export type Task_Owners_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "task_owners" */
export type Task_Owners_Mutation_Response = {
  __typename?: 'task_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_Owners>;
};

/** on_conflict condition type for table "task_owners" */
export type Task_Owners_On_Conflict = {
  constraint: Task_Owners_Constraint;
  update_columns?: Array<Task_Owners_Update_Column>;
  where?: InputMaybe<Task_Owners_Bool_Exp>;
};

/** Ordering options when selecting data from "task_owners". */
export type Task_Owners_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "task_owners" */
export enum Task_Owners_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** placeholder for update columns of table "task_owners" (current role has no relevant permissions) */
export enum Task_Owners_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type Tasks = {
  __typename?: 'tasks';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  control_findings: Array<Control_Findings>;
  /** An array relationship */
  controls: Array<Control_Tasks>;
  /** An aggregate relationship */
  controls_aggregate: Control_Tasks_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  evidence: Array<Evidence_Tasks>;
  /** An array relationship */
  field_values: Array<Field_Values>;
  id: Scalars['uuid']['output'];
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  risks: Array<Risk_Tasks>;
  similarity?: Maybe<Scalars['float8']['output']>;
  /** An array relationship */
  source_entity_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  source_entity_relations_aggregate: Entity_Relations_Aggregate;
  status: Scalars['TaskStatus']['output'];
  /** An array relationship */
  target_entity_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  target_entity_relations_aggregate: Entity_Relations_Aggregate;
  /** An array relationship */
  task_owners: Array<Task_Owners>;
  /** An array relationship */
  tasks_comments: Array<Comments>;
  /** An array relationship */
  tasks_policy_tasks: Array<Policy_Tasks>;
  /** An array relationship */
  tasks_vector_stores: Array<Ai_Tasks_Vector_Store>;
  /** An object relationship */
  template_task?: Maybe<Template_Tasks>;
  template_task_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  vendor_findings: Array<Vendor_Findings>;
  /** An array relationship */
  vendors: Array<Vendor_Tasks>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksControl_FindingsArgs = {
  distinct_on?: InputMaybe<Array<Control_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Findings_Order_By>>;
  where?: InputMaybe<Control_Findings_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksControlsArgs = {
  distinct_on?: InputMaybe<Array<Control_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Tasks_Order_By>>;
  where?: InputMaybe<Control_Tasks_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksControls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Tasks_Order_By>>;
  where?: InputMaybe<Control_Tasks_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksEvidenceArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Tasks_Order_By>>;
  where?: InputMaybe<Evidence_Tasks_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksField_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Values_Order_By>>;
  where?: InputMaybe<Field_Values_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksRisksArgs = {
  distinct_on?: InputMaybe<Array<Risk_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Tasks_Order_By>>;
  where?: InputMaybe<Risk_Tasks_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksSource_Entity_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksSource_Entity_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksTarget_Entity_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksTarget_Entity_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksTask_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Task_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Owners_Order_By>>;
  where?: InputMaybe<Task_Owners_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksTasks_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksTasks_Policy_TasksArgs = {
  distinct_on?: InputMaybe<Array<Policy_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Tasks_Order_By>>;
  where?: InputMaybe<Policy_Tasks_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksTasks_Vector_StoresArgs = {
  distinct_on?: InputMaybe<Array<Ai_Tasks_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Tasks_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Tasks_Vector_Store_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksVendor_FindingsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Findings_Order_By>>;
  where?: InputMaybe<Vendor_Findings_Bool_Exp>;
};

/** Stores programs' tasks, specific to one organization. Tasks are customized here. */
export type TasksVendorsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Tasks_Order_By>>;
  where?: InputMaybe<Vendor_Tasks_Bool_Exp>;
};

/** aggregated selection of "tasks" */
export type Tasks_Aggregate = {
  __typename?: 'tasks_aggregate';
  aggregate?: Maybe<Tasks_Aggregate_Fields>;
  nodes: Array<Tasks>;
};

export type Tasks_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Tasks_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Tasks_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Tasks_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Tasks_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Tasks_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Tasks_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Tasks_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Tasks_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Tasks_Aggregate_Bool_Exp_Var_Samp>;
};

export type Tasks_Aggregate_Bool_Exp_Avg = {
  arguments: Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tasks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tasks_Aggregate_Bool_Exp_Corr = {
  arguments: Tasks_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tasks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tasks_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Tasks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tasks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tasks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Tasks_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Tasks_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tasks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tasks_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Tasks_Aggregate_Bool_Exp_Max = {
  arguments: Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tasks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tasks_Aggregate_Bool_Exp_Min = {
  arguments: Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tasks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tasks_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tasks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tasks_Aggregate_Bool_Exp_Sum = {
  arguments: Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tasks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tasks_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tasks_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "tasks" */
export type Tasks_Aggregate_Fields = {
  __typename?: 'tasks_aggregate_fields';
  avg?: Maybe<Tasks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tasks_Max_Fields>;
  min?: Maybe<Tasks_Min_Fields>;
  stddev?: Maybe<Tasks_Stddev_Fields>;
  stddev_pop?: Maybe<Tasks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tasks_Stddev_Samp_Fields>;
  sum?: Maybe<Tasks_Sum_Fields>;
  var_pop?: Maybe<Tasks_Var_Pop_Fields>;
  var_samp?: Maybe<Tasks_Var_Samp_Fields>;
  variance?: Maybe<Tasks_Variance_Fields>;
};

/** aggregate fields of "tasks" */
export type Tasks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tasks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tasks" */
export type Tasks_Aggregate_Order_By = {
  avg?: InputMaybe<Tasks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tasks_Max_Order_By>;
  min?: InputMaybe<Tasks_Min_Order_By>;
  stddev?: InputMaybe<Tasks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tasks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tasks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tasks_Sum_Order_By>;
  var_pop?: InputMaybe<Tasks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tasks_Var_Samp_Order_By>;
  variance?: InputMaybe<Tasks_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Tasks_Avg_Fields = {
  __typename?: 'tasks_avg_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tasks" */
export type Tasks_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tasks". All fields are combined with a logical 'AND'. */
export type Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Tasks_Bool_Exp>>;
  _not?: InputMaybe<Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Tasks_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  control_findings?: InputMaybe<Control_Findings_Bool_Exp>;
  controls?: InputMaybe<Control_Tasks_Bool_Exp>;
  controls_aggregate?: InputMaybe<Control_Tasks_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  evidence?: InputMaybe<Evidence_Tasks_Bool_Exp>;
  field_values?: InputMaybe<Field_Values_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  risks?: InputMaybe<Risk_Tasks_Bool_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  source_entity_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  source_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  target_entity_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  target_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  task_owners?: InputMaybe<Task_Owners_Bool_Exp>;
  tasks_comments?: InputMaybe<Comments_Bool_Exp>;
  tasks_policy_tasks?: InputMaybe<Policy_Tasks_Bool_Exp>;
  tasks_vector_stores?: InputMaybe<Ai_Tasks_Vector_Store_Bool_Exp>;
  template_task?: InputMaybe<Template_Tasks_Bool_Exp>;
  template_task_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor_findings?: InputMaybe<Vendor_Findings_Bool_Exp>;
  vendors?: InputMaybe<Vendor_Tasks_Bool_Exp>;
};

/** unique or primary key constraints on table "tasks" */
export enum Tasks_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProgramTasksPkey = 'program_tasks_pkey',
  /** unique or primary key constraint on columns "id", "organization_id" */
  TasksIdOrganizationIdKey = 'tasks_id_organization_id_key',
  /** unique or primary key constraint on columns "organization_id", "internal_id" */
  TasksOrganizationIdInternalIdKey = 'tasks_organization_id_internal_id_key',
}

/** input type for inserting data into table "tasks" */
export type Tasks_Insert_Input = {
  controls?: InputMaybe<Control_Tasks_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  evidence?: InputMaybe<Evidence_Tasks_Arr_Rel_Insert_Input>;
  field_values?: InputMaybe<Field_Values_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['uuid']['input'];
  risks?: InputMaybe<Risk_Tasks_Arr_Rel_Insert_Input>;
  source_entity_relations?: InputMaybe<Entity_Relations_Arr_Rel_Insert_Input>;
  target_entity_relations?: InputMaybe<Entity_Relations_Arr_Rel_Insert_Input>;
  task_owners?: InputMaybe<Task_Owners_Arr_Rel_Insert_Input>;
  tasks_comments?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  tasks_policy_tasks?: InputMaybe<Policy_Tasks_Arr_Rel_Insert_Input>;
  template_task_id?: InputMaybe<Scalars['uuid']['input']>;
  vendors?: InputMaybe<Vendor_Tasks_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tasks_Max_Fields = {
  __typename?: 'tasks_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  template_task_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "tasks" */
export type Tasks_Max_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  template_task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tasks_Min_Fields = {
  __typename?: 'tasks_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  template_task_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "tasks" */
export type Tasks_Min_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  template_task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tasks" */
export type Tasks_Mutation_Response = {
  __typename?: 'tasks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tasks>;
};

/** input type for inserting object relation for remote table "tasks" */
export type Tasks_Obj_Rel_Insert_Input = {
  data: Tasks_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tasks_On_Conflict>;
};

/** on_conflict condition type for table "tasks" */
export type Tasks_On_Conflict = {
  constraint: Tasks_Constraint;
  update_columns?: Array<Tasks_Update_Column>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

/** Ordering options when selecting data from "tasks". */
export type Tasks_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  control_findings_aggregate?: InputMaybe<Control_Findings_Aggregate_Order_By>;
  controls_aggregate?: InputMaybe<Control_Tasks_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  evidence_aggregate?: InputMaybe<Evidence_Tasks_Aggregate_Order_By>;
  field_values_aggregate?: InputMaybe<Field_Values_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  risks_aggregate?: InputMaybe<Risk_Tasks_Aggregate_Order_By>;
  similarity?: InputMaybe<Order_By>;
  source_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  target_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  task_owners_aggregate?: InputMaybe<Task_Owners_Aggregate_Order_By>;
  tasks_comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  tasks_policy_tasks_aggregate?: InputMaybe<Policy_Tasks_Aggregate_Order_By>;
  tasks_vector_stores_aggregate?: InputMaybe<Ai_Tasks_Vector_Store_Aggregate_Order_By>;
  template_task?: InputMaybe<Template_Tasks_Order_By>;
  template_task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_findings_aggregate?: InputMaybe<Vendor_Findings_Aggregate_Order_By>;
  vendors_aggregate?: InputMaybe<Vendor_Tasks_Aggregate_Order_By>;
};

/** primary key columns input for table: tasks */
export type Tasks_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tasks" */
export enum Tasks_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Status = 'status',
  /** column name */
  TemplateTaskId = 'template_task_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** select "tasks_aggregate_bool_exp_avg_arguments_columns" columns of table "tasks" */
export enum Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "tasks_aggregate_bool_exp_corr_arguments_columns" columns of table "tasks" */
export enum Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "tasks_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "tasks" */
export enum Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "tasks_aggregate_bool_exp_max_arguments_columns" columns of table "tasks" */
export enum Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "tasks_aggregate_bool_exp_min_arguments_columns" columns of table "tasks" */
export enum Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "tasks_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "tasks" */
export enum Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "tasks_aggregate_bool_exp_sum_arguments_columns" columns of table "tasks" */
export enum Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "tasks_aggregate_bool_exp_var_samp_arguments_columns" columns of table "tasks" */
export enum Tasks_Select_Column_Tasks_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** input type for updating data in table "tasks" */
export type Tasks_Set_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  template_task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Tasks_Stddev_Fields = {
  __typename?: 'tasks_stddev_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tasks" */
export type Tasks_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tasks_Stddev_Pop_Fields = {
  __typename?: 'tasks_stddev_pop_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tasks" */
export type Tasks_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tasks_Stddev_Samp_Fields = {
  __typename?: 'tasks_stddev_samp_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tasks" */
export type Tasks_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Tasks_Sum_Fields = {
  __typename?: 'tasks_sum_fields';
  similarity?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "tasks" */
export type Tasks_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** update columns of table "tasks" */
export enum Tasks_Update_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  Description = 'description',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  TemplateTaskId = 'template_task_id',
}

export type Tasks_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tasks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tasks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tasks_Var_Pop_Fields = {
  __typename?: 'tasks_var_pop_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tasks" */
export type Tasks_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tasks_Var_Samp_Fields = {
  __typename?: 'tasks_var_samp_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tasks" */
export type Tasks_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tasks_Variance_Fields = {
  __typename?: 'tasks_variance_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tasks" */
export type Tasks_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** users that are members of a team */
export type Team_Members = {
  __typename?: 'team_members';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "team_members" */
export type Team_Members_Aggregate = {
  __typename?: 'team_members_aggregate';
  aggregate?: Maybe<Team_Members_Aggregate_Fields>;
  nodes: Array<Team_Members>;
};

export type Team_Members_Aggregate_Bool_Exp = {
  count?: InputMaybe<Team_Members_Aggregate_Bool_Exp_Count>;
};

export type Team_Members_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Team_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Team_Members_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "team_members" */
export type Team_Members_Aggregate_Fields = {
  __typename?: 'team_members_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Team_Members_Max_Fields>;
  min?: Maybe<Team_Members_Min_Fields>;
};

/** aggregate fields of "team_members" */
export type Team_Members_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Team_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "team_members" */
export type Team_Members_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Team_Members_Max_Order_By>;
  min?: InputMaybe<Team_Members_Min_Order_By>;
};

/** input type for inserting array relation for remote table "team_members" */
export type Team_Members_Arr_Rel_Insert_Input = {
  data: Array<Team_Members_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Team_Members_On_Conflict>;
};

/** Boolean expression to filter rows from the table "team_members". All fields are combined with a logical 'AND'. */
export type Team_Members_Bool_Exp = {
  _and?: InputMaybe<Array<Team_Members_Bool_Exp>>;
  _not?: InputMaybe<Team_Members_Bool_Exp>;
  _or?: InputMaybe<Array<Team_Members_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "team_members" */
export enum Team_Members_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamMembersPkey = 'team_members_pkey',
  /** unique or primary key constraint on columns "user_id", "team_id" */
  TeamMembersTeamIdUserIdKey = 'team_members_team_id_user_id_key',
}

/** input type for inserting data into table "team_members" */
export type Team_Members_Insert_Input = {
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Team_Members_Max_Fields = {
  __typename?: 'team_members_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "team_members" */
export type Team_Members_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Team_Members_Min_Fields = {
  __typename?: 'team_members_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "team_members" */
export type Team_Members_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "team_members" */
export type Team_Members_Mutation_Response = {
  __typename?: 'team_members_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Team_Members>;
};

/** on_conflict condition type for table "team_members" */
export type Team_Members_On_Conflict = {
  constraint: Team_Members_Constraint;
  update_columns?: Array<Team_Members_Update_Column>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

/** Ordering options when selecting data from "team_members". */
export type Team_Members_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "team_members" */
export enum Team_Members_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UserId = 'user_id',
}

/** Streaming cursor of the table "team_members" */
export type Team_Members_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Members_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Members_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "team_members" (current role has no relevant permissions) */
export enum Team_Members_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** persistent groups of users within an organization */
export type Teams = {
  __typename?: 'teams';
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  team_members: Array<Team_Members>;
  /** An aggregate relationship */
  team_members_aggregate: Team_Members_Aggregate;
};

/** persistent groups of users within an organization */
export type TeamsTeam_MembersArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

/** persistent groups of users within an organization */
export type TeamsTeam_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

/** order by aggregate values of table "teams" */
export type Teams_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_Max_Order_By>;
  min?: InputMaybe<Teams_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "teams". All fields are combined with a logical 'AND'. */
export type Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Bool_Exp>>;
  _not?: InputMaybe<Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  team_members?: InputMaybe<Team_Members_Bool_Exp>;
  team_members_aggregate?: InputMaybe<Team_Members_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "teams" */
export enum Teams_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  TeamsOrganizationIdNameKey = 'teams_organization_id_name_key',
  /** unique or primary key constraint on columns "id" */
  TeamsPkey = 'teams_pkey',
}

/** input type for inserting data into table "teams" */
export type Teams_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  team_members?: InputMaybe<Team_Members_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "teams" */
export type Teams_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "teams" */
export type Teams_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teams" */
export type Teams_Mutation_Response = {
  __typename?: 'teams_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams>;
};

/** input type for inserting object relation for remote table "teams" */
export type Teams_Obj_Rel_Insert_Input = {
  data: Teams_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};

/** on_conflict condition type for table "teams" */
export type Teams_On_Conflict = {
  constraint: Teams_Constraint;
  update_columns?: Array<Teams_Update_Column>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

/** Ordering options when selecting data from "teams". */
export type Teams_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  team_members_aggregate?: InputMaybe<Team_Members_Aggregate_Order_By>;
};

/** primary key columns input for table: teams */
export type Teams_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "teams" */
export enum Teams_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
}

/** input type for updating data in table "teams" */
export type Teams_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "teams" */
export type Teams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "teams" */
export enum Teams_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
}

export type Teams_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Bool_Exp;
};

/** columns and relationships of "template_controls" */
export type Template_Controls = {
  __typename?: 'template_controls';
  /** An array relationship */
  controls: Array<Controls>;
  /** An aggregate relationship */
  controls_aggregate: Controls_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  frequency: Control_Frequencies_Enum;
  id: Scalars['uuid']['output'];
  internal_id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  priority?: Maybe<Control_Priorities_Enum>;
  tags: Scalars['ControlTags']['output'];
  /** An array relationship */
  template_frameworks_controls: Array<Template_Frameworks_Controls>;
  /** An array relationship */
  template_tasks: Array<Template_Tasks>;
  /** An aggregate relationship */
  template_tasks_aggregate: Template_Tasks_Aggregate;
};

/** columns and relationships of "template_controls" */
export type Template_ControlsControlsArgs = {
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

/** columns and relationships of "template_controls" */
export type Template_ControlsControls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_Order_By>>;
  where?: InputMaybe<Controls_Bool_Exp>;
};

/** columns and relationships of "template_controls" */
export type Template_ControlsTagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "template_controls" */
export type Template_ControlsTemplate_Frameworks_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Template_Frameworks_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Frameworks_Controls_Order_By>>;
  where?: InputMaybe<Template_Frameworks_Controls_Bool_Exp>;
};

/** columns and relationships of "template_controls" */
export type Template_ControlsTemplate_TasksArgs = {
  distinct_on?: InputMaybe<Array<Template_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Tasks_Order_By>>;
  where?: InputMaybe<Template_Tasks_Bool_Exp>;
};

/** columns and relationships of "template_controls" */
export type Template_ControlsTemplate_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Tasks_Order_By>>;
  where?: InputMaybe<Template_Tasks_Bool_Exp>;
};

/** aggregated selection of "template_controls" */
export type Template_Controls_Aggregate = {
  __typename?: 'template_controls_aggregate';
  aggregate?: Maybe<Template_Controls_Aggregate_Fields>;
  nodes: Array<Template_Controls>;
};

/** aggregate fields of "template_controls" */
export type Template_Controls_Aggregate_Fields = {
  __typename?: 'template_controls_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Template_Controls_Max_Fields>;
  min?: Maybe<Template_Controls_Min_Fields>;
};

/** aggregate fields of "template_controls" */
export type Template_Controls_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Controls_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "template_controls". All fields are combined with a logical 'AND'. */
export type Template_Controls_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Controls_Bool_Exp>>;
  _not?: InputMaybe<Template_Controls_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Controls_Bool_Exp>>;
  controls?: InputMaybe<Controls_Bool_Exp>;
  controls_aggregate?: InputMaybe<Controls_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  frequency?: InputMaybe<Control_Frequencies_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  priority?: InputMaybe<Control_Priorities_Enum_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  template_frameworks_controls?: InputMaybe<Template_Frameworks_Controls_Bool_Exp>;
  template_tasks?: InputMaybe<Template_Tasks_Bool_Exp>;
  template_tasks_aggregate?: InputMaybe<Template_Tasks_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Template_Controls_Max_Fields = {
  __typename?: 'template_controls_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Template_Controls_Min_Fields = {
  __typename?: 'template_controls_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "template_controls". */
export type Template_Controls_Order_By = {
  controls_aggregate?: InputMaybe<Controls_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  template_frameworks_controls_aggregate?: InputMaybe<Template_Frameworks_Controls_Aggregate_Order_By>;
  template_tasks_aggregate?: InputMaybe<Template_Tasks_Aggregate_Order_By>;
};

/** select columns of table "template_controls" */
export enum Template_Controls_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  Name = 'name',
  /** column name */
  Priority = 'priority',
  /** column name */
  Tags = 'tags',
}

/** Streaming cursor of the table "template_controls" */
export type Template_Controls_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Controls_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Controls_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Control_Frequencies_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Control_Priorities_Enum>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "template_frameworks" */
export type Template_Frameworks = {
  __typename?: 'template_frameworks';
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  organization_template_frameworks: Array<Organization_Template_Frameworks>;
  /** An array relationship */
  programs: Array<Programs>;
  /** An array relationship */
  template_frameworks_controls: Array<Template_Frameworks_Controls>;
};

/** columns and relationships of "template_frameworks" */
export type Template_FrameworksOrganization_Template_FrameworksArgs = {
  distinct_on?: InputMaybe<Array<Organization_Template_Frameworks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Template_Frameworks_Order_By>>;
  where?: InputMaybe<Organization_Template_Frameworks_Bool_Exp>;
};

/** columns and relationships of "template_frameworks" */
export type Template_FrameworksProgramsArgs = {
  distinct_on?: InputMaybe<Array<Programs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programs_Order_By>>;
  where?: InputMaybe<Programs_Bool_Exp>;
};

/** columns and relationships of "template_frameworks" */
export type Template_FrameworksTemplate_Frameworks_ControlsArgs = {
  distinct_on?: InputMaybe<Array<Template_Frameworks_Controls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Template_Frameworks_Controls_Order_By>>;
  where?: InputMaybe<Template_Frameworks_Controls_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "template_frameworks". All fields are combined with a logical 'AND'. */
export type Template_Frameworks_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Frameworks_Bool_Exp>>;
  _not?: InputMaybe<Template_Frameworks_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Frameworks_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_template_frameworks?: InputMaybe<Organization_Template_Frameworks_Bool_Exp>;
  programs?: InputMaybe<Programs_Bool_Exp>;
  template_frameworks_controls?: InputMaybe<Template_Frameworks_Controls_Bool_Exp>;
};

/** columns and relationships of "template_frameworks_controls" */
export type Template_Frameworks_Controls = {
  __typename?: 'template_frameworks_controls';
  control_id: Scalars['uuid']['output'];
  framework_id: Scalars['uuid']['output'];
  /** An object relationship */
  template_control: Template_Controls;
  /** An object relationship */
  template_framework: Template_Frameworks;
};

/** order by aggregate values of table "template_frameworks_controls" */
export type Template_Frameworks_Controls_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Template_Frameworks_Controls_Max_Order_By>;
  min?: InputMaybe<Template_Frameworks_Controls_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "template_frameworks_controls". All fields are combined with a logical 'AND'. */
export type Template_Frameworks_Controls_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Frameworks_Controls_Bool_Exp>>;
  _not?: InputMaybe<Template_Frameworks_Controls_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Frameworks_Controls_Bool_Exp>>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  framework_id?: InputMaybe<Uuid_Comparison_Exp>;
  template_control?: InputMaybe<Template_Controls_Bool_Exp>;
  template_framework?: InputMaybe<Template_Frameworks_Bool_Exp>;
};

/** order by max() on columns of table "template_frameworks_controls" */
export type Template_Frameworks_Controls_Max_Order_By = {
  control_id?: InputMaybe<Order_By>;
  framework_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "template_frameworks_controls" */
export type Template_Frameworks_Controls_Min_Order_By = {
  control_id?: InputMaybe<Order_By>;
  framework_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "template_frameworks_controls". */
export type Template_Frameworks_Controls_Order_By = {
  control_id?: InputMaybe<Order_By>;
  framework_id?: InputMaybe<Order_By>;
  template_control?: InputMaybe<Template_Controls_Order_By>;
  template_framework?: InputMaybe<Template_Frameworks_Order_By>;
};

/** select columns of table "template_frameworks_controls" */
export enum Template_Frameworks_Controls_Select_Column {
  /** column name */
  ControlId = 'control_id',
  /** column name */
  FrameworkId = 'framework_id',
}

/** Streaming cursor of the table "template_frameworks_controls" */
export type Template_Frameworks_Controls_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Frameworks_Controls_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Frameworks_Controls_Stream_Cursor_Value_Input = {
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  framework_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Ordering options when selecting data from "template_frameworks". */
export type Template_Frameworks_Order_By = {
  active?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_template_frameworks_aggregate?: InputMaybe<Organization_Template_Frameworks_Aggregate_Order_By>;
  programs_aggregate?: InputMaybe<Programs_Aggregate_Order_By>;
  template_frameworks_controls_aggregate?: InputMaybe<Template_Frameworks_Controls_Aggregate_Order_By>;
};

/** select columns of table "template_frameworks" */
export enum Template_Frameworks_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
}

/** Streaming cursor of the table "template_frameworks" */
export type Template_Frameworks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Frameworks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Frameworks_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "template_tasks" */
export type Template_Tasks = {
  __typename?: 'template_tasks';
  control_id: Scalars['uuid']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  internal_id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  tasks: Array<Tasks>;
  /** An aggregate relationship */
  tasks_aggregate: Tasks_Aggregate;
  /** An object relationship */
  template_control: Template_Controls;
};

/** columns and relationships of "template_tasks" */
export type Template_TasksTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

/** columns and relationships of "template_tasks" */
export type Template_TasksTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

/** aggregated selection of "template_tasks" */
export type Template_Tasks_Aggregate = {
  __typename?: 'template_tasks_aggregate';
  aggregate?: Maybe<Template_Tasks_Aggregate_Fields>;
  nodes: Array<Template_Tasks>;
};

export type Template_Tasks_Aggregate_Bool_Exp = {
  count?: InputMaybe<Template_Tasks_Aggregate_Bool_Exp_Count>;
};

export type Template_Tasks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Template_Tasks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Template_Tasks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "template_tasks" */
export type Template_Tasks_Aggregate_Fields = {
  __typename?: 'template_tasks_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Template_Tasks_Max_Fields>;
  min?: Maybe<Template_Tasks_Min_Fields>;
};

/** aggregate fields of "template_tasks" */
export type Template_Tasks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Tasks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "template_tasks" */
export type Template_Tasks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Template_Tasks_Max_Order_By>;
  min?: InputMaybe<Template_Tasks_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "template_tasks". All fields are combined with a logical 'AND'. */
export type Template_Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Tasks_Bool_Exp>>;
  _not?: InputMaybe<Template_Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Tasks_Bool_Exp>>;
  control_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  tasks?: InputMaybe<Tasks_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Tasks_Aggregate_Bool_Exp>;
  template_control?: InputMaybe<Template_Controls_Bool_Exp>;
};

/** aggregate max on columns */
export type Template_Tasks_Max_Fields = {
  __typename?: 'template_tasks_max_fields';
  control_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "template_tasks" */
export type Template_Tasks_Max_Order_By = {
  control_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Template_Tasks_Min_Fields = {
  __typename?: 'template_tasks_min_fields';
  control_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "template_tasks" */
export type Template_Tasks_Min_Order_By = {
  control_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "template_tasks". */
export type Template_Tasks_Order_By = {
  control_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Tasks_Aggregate_Order_By>;
  template_control?: InputMaybe<Template_Controls_Order_By>;
};

/** select columns of table "template_tasks" */
export enum Template_Tasks_Select_Column {
  /** column name */
  ControlId = 'control_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  Name = 'name',
}

/** Streaming cursor of the table "template_tasks" */
export type Template_Tasks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Tasks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Tasks_Stream_Cursor_Value_Input = {
  control_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "text_field_values" */
export type Text_Field_Values = {
  __typename?: 'text_field_values';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  fieldValueByFieldValueId: Field_Values;
  field_type: Scalars['String']['output'];
  /** An object relationship */
  field_value?: Maybe<Field_Values>;
  field_value_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  value: Scalars['String']['output'];
};

/** order by aggregate values of table "text_field_values" */
export type Text_Field_Values_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Text_Field_Values_Max_Order_By>;
  min?: InputMaybe<Text_Field_Values_Min_Order_By>;
};

/** input type for inserting array relation for remote table "text_field_values" */
export type Text_Field_Values_Arr_Rel_Insert_Input = {
  data: Array<Text_Field_Values_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Text_Field_Values_On_Conflict>;
};

/** Boolean expression to filter rows from the table "text_field_values". All fields are combined with a logical 'AND'. */
export type Text_Field_Values_Bool_Exp = {
  _and?: InputMaybe<Array<Text_Field_Values_Bool_Exp>>;
  _not?: InputMaybe<Text_Field_Values_Bool_Exp>;
  _or?: InputMaybe<Array<Text_Field_Values_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Bool_Exp>;
  field_type?: InputMaybe<String_Comparison_Exp>;
  field_value?: InputMaybe<Field_Values_Bool_Exp>;
  field_value_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "text_field_values" */
export enum Text_Field_Values_Constraint {
  /** unique or primary key constraint on columns "field_value_id" */
  TextFieldValuesPkey = 'text_field_values_pkey',
}

/** input type for inserting data into table "text_field_values" */
export type Text_Field_Values_Insert_Input = {
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Obj_Rel_Insert_Input>;
  field_value?: InputMaybe<Field_Values_Obj_Rel_Insert_Input>;
  field_value_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "text_field_values" */
export type Text_Field_Values_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "text_field_values" */
export type Text_Field_Values_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "text_field_values" */
export type Text_Field_Values_Mutation_Response = {
  __typename?: 'text_field_values_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Text_Field_Values>;
};

/** input type for inserting object relation for remote table "text_field_values" */
export type Text_Field_Values_Obj_Rel_Insert_Input = {
  data: Text_Field_Values_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Text_Field_Values_On_Conflict>;
};

/** on_conflict condition type for table "text_field_values" */
export type Text_Field_Values_On_Conflict = {
  constraint: Text_Field_Values_Constraint;
  update_columns?: Array<Text_Field_Values_Update_Column>;
  where?: InputMaybe<Text_Field_Values_Bool_Exp>;
};

/** Ordering options when selecting data from "text_field_values". */
export type Text_Field_Values_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value?: InputMaybe<Field_Values_Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: text_field_values */
export type Text_Field_Values_Pk_Columns_Input = {
  field_value_id: Scalars['uuid']['input'];
};

/** select columns of table "text_field_values" */
export enum Text_Field_Values_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  FieldValueId = 'field_value_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
}

/** input type for updating data in table "text_field_values" */
export type Text_Field_Values_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "text_field_values" */
export enum Text_Field_Values_Update_Column {
  /** column name */
  Value = 'value',
}

export type Text_Field_Values_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Text_Field_Values_Set_Input>;
  /** filter the rows which have to be updated */
  where: Text_Field_Values_Bool_Exp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

export enum Treatment_Plan_Enum {
  Accepted = 'Accepted',
  Avoided = 'Avoided',
  Mitigated = 'Mitigated',
  Pending = 'Pending',
  Transferred = 'Transferred',
}

/** Boolean expression to compare columns of type "treatment_plan_enum". All fields are combined with logical 'AND'. */
export type Treatment_Plan_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Treatment_Plan_Enum>;
  _in?: InputMaybe<Array<Treatment_Plan_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Treatment_Plan_Enum>;
  _nin?: InputMaybe<Array<Treatment_Plan_Enum>>;
};

export enum Treatment_Strategy_Enum {
  Accept = 'Accept',
  Avoid = 'Avoid',
  Mitigate = 'Mitigate',
  Monitor = 'Monitor',
  Pending = 'Pending',
  Transfer = 'Transfer',
}

/** Boolean expression to compare columns of type "treatment_strategy_enum". All fields are combined with logical 'AND'. */
export type Treatment_Strategy_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Treatment_Strategy_Enum>;
  _in?: InputMaybe<Array<Treatment_Strategy_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Treatment_Strategy_Enum>;
  _nin?: InputMaybe<Array<Treatment_Strategy_Enum>>;
};

/** columns and relationships of "trust_portal.access_blocks" */
export type Trust_Portal_Access_Blocks = {
  __typename?: 'trust_portal_access_blocks';
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  id: Scalars['uuid']['output'];
  matching_key: Scalars['String']['output'];
  /** An object relationship */
  page: Trust_Portal_Pages;
  page_id: Scalars['uuid']['output'];
  reason: Scalars['String']['output'];
  scope: Scalars['String']['output'];
};

/** order by aggregate values of table "trust_portal.access_blocks" */
export type Trust_Portal_Access_Blocks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trust_Portal_Access_Blocks_Max_Order_By>;
  min?: InputMaybe<Trust_Portal_Access_Blocks_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "trust_portal.access_blocks". All fields are combined with a logical 'AND'. */
export type Trust_Portal_Access_Blocks_Bool_Exp = {
  _and?: InputMaybe<Array<Trust_Portal_Access_Blocks_Bool_Exp>>;
  _not?: InputMaybe<Trust_Portal_Access_Blocks_Bool_Exp>;
  _or?: InputMaybe<Array<Trust_Portal_Access_Blocks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  matching_key?: InputMaybe<String_Comparison_Exp>;
  page?: InputMaybe<Trust_Portal_Pages_Bool_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "trust_portal.access_blocks" */
export type Trust_Portal_Access_Blocks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matching_key?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "trust_portal.access_blocks" */
export type Trust_Portal_Access_Blocks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matching_key?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "trust_portal.access_blocks". */
export type Trust_Portal_Access_Blocks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  matching_key?: InputMaybe<Order_By>;
  page?: InputMaybe<Trust_Portal_Pages_Order_By>;
  page_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
};

/** select columns of table "trust_portal.access_blocks" */
export enum Trust_Portal_Access_Blocks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  MatchingKey = 'matching_key',
  /** column name */
  PageId = 'page_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  Scope = 'scope',
}

export enum Trust_Portal_Access_Grant_Sources_Enum {
  AgreementGate = 'agreement_gate',
  Manual = 'manual',
}

/** Boolean expression to compare columns of type "trust_portal_access_grant_sources_enum". All fields are combined with logical 'AND'. */
export type Trust_Portal_Access_Grant_Sources_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Trust_Portal_Access_Grant_Sources_Enum>;
  _in?: InputMaybe<Array<Trust_Portal_Access_Grant_Sources_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Trust_Portal_Access_Grant_Sources_Enum>;
  _nin?: InputMaybe<Array<Trust_Portal_Access_Grant_Sources_Enum>>;
};

export enum Trust_Portal_Access_Request_Reasons_Enum {
  Customer = 'customer',
  Other = 'other',
  Partner = 'partner',
  ProspectCustomer = 'prospect_customer',
  Vendor = 'vendor',
}

/** Boolean expression to compare columns of type "trust_portal_access_request_reasons_enum". All fields are combined with logical 'AND'. */
export type Trust_Portal_Access_Request_Reasons_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Trust_Portal_Access_Request_Reasons_Enum>;
  _in?: InputMaybe<Array<Trust_Portal_Access_Request_Reasons_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Trust_Portal_Access_Request_Reasons_Enum>;
  _nin?: InputMaybe<Array<Trust_Portal_Access_Request_Reasons_Enum>>;
};

export enum Trust_Portal_Access_Request_Statuses_Enum {
  Denied = 'denied',
  Granted = 'granted',
  Pending = 'pending',
  Revoked = 'revoked',
}

/** Boolean expression to compare columns of type "trust_portal_access_request_statuses_enum". All fields are combined with logical 'AND'. */
export type Trust_Portal_Access_Request_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Trust_Portal_Access_Request_Statuses_Enum>;
  _in?: InputMaybe<Array<Trust_Portal_Access_Request_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Trust_Portal_Access_Request_Statuses_Enum>;
  _nin?: InputMaybe<Array<Trust_Portal_Access_Request_Statuses_Enum>>;
};

/** columns and relationships of "trust_portal.access_requests" */
export type Trust_Portal_Access_Requests = {
  __typename?: 'trust_portal_access_requests';
  /** An object relationship */
  access_block?: Maybe<Trust_Portal_Access_Blocks>;
  access_block_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  access_request_approver?: Maybe<Users>;
  /** An object relationship */
  access_request_revoker?: Maybe<Users>;
  /** An object relationship */
  access_requester?: Maybe<Users>;
  address?: Maybe<Scalars['String']['output']>;
  approved_by?: Maybe<Scalars['uuid']['output']>;
  company: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  email: Scalars['citext']['output'];
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  grant_source?: Maybe<Trust_Portal_Access_Grant_Sources_Enum>;
  id: Scalars['uuid']['output'];
  matching_domain?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nda_gate_processing_status?: Maybe<Trust_Portal_Nda_Gate_Processing_Statuses_Enum>;
  /** An object relationship */
  organization_integration?: Maybe<Organization_Integrations>;
  /** An object relationship */
  page: Trust_Portal_Pages;
  page_id: Scalars['uuid']['output'];
  provider_agreement_id?: Maybe<Scalars['String']['output']>;
  provider_signing_id?: Maybe<Scalars['String']['output']>;
  reason: Trust_Portal_Access_Request_Reasons_Enum;
  requester_id?: Maybe<Scalars['uuid']['output']>;
  status: Trust_Portal_Access_Request_Statuses_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "trust_portal.access_requests" */
export type Trust_Portal_Access_Requests_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trust_Portal_Access_Requests_Max_Order_By>;
  min?: InputMaybe<Trust_Portal_Access_Requests_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "trust_portal.access_requests". All fields are combined with a logical 'AND'. */
export type Trust_Portal_Access_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Trust_Portal_Access_Requests_Bool_Exp>>;
  _not?: InputMaybe<Trust_Portal_Access_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Trust_Portal_Access_Requests_Bool_Exp>>;
  access_block?: InputMaybe<Trust_Portal_Access_Blocks_Bool_Exp>;
  access_block_id?: InputMaybe<Uuid_Comparison_Exp>;
  access_request_approver?: InputMaybe<Users_Bool_Exp>;
  access_request_revoker?: InputMaybe<Users_Bool_Exp>;
  access_requester?: InputMaybe<Users_Bool_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  approved_by?: InputMaybe<Uuid_Comparison_Exp>;
  company?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  grant_source?: InputMaybe<Trust_Portal_Access_Grant_Sources_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  matching_domain?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nda_gate_processing_status?: InputMaybe<Trust_Portal_Nda_Gate_Processing_Statuses_Enum_Comparison_Exp>;
  organization_integration?: InputMaybe<Organization_Integrations_Bool_Exp>;
  page?: InputMaybe<Trust_Portal_Pages_Bool_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  provider_agreement_id?: InputMaybe<String_Comparison_Exp>;
  provider_signing_id?: InputMaybe<String_Comparison_Exp>;
  reason?: InputMaybe<Trust_Portal_Access_Request_Reasons_Enum_Comparison_Exp>;
  requester_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Trust_Portal_Access_Request_Statuses_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "trust_portal.access_requests" */
export type Trust_Portal_Access_Requests_Max_Order_By = {
  access_block_id?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  company?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matching_domain?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  provider_agreement_id?: InputMaybe<Order_By>;
  provider_signing_id?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "trust_portal.access_requests" */
export type Trust_Portal_Access_Requests_Min_Order_By = {
  access_block_id?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  company?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matching_domain?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  provider_agreement_id?: InputMaybe<Order_By>;
  provider_signing_id?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trust_portal.access_requests" */
export type Trust_Portal_Access_Requests_Mutation_Response = {
  __typename?: 'trust_portal_access_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trust_Portal_Access_Requests>;
};

/** Ordering options when selecting data from "trust_portal.access_requests". */
export type Trust_Portal_Access_Requests_Order_By = {
  access_block?: InputMaybe<Trust_Portal_Access_Blocks_Order_By>;
  access_block_id?: InputMaybe<Order_By>;
  access_request_approver?: InputMaybe<Users_Order_By>;
  access_request_revoker?: InputMaybe<Users_Order_By>;
  access_requester?: InputMaybe<Users_Order_By>;
  address?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  company?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  grant_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matching_domain?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nda_gate_processing_status?: InputMaybe<Order_By>;
  organization_integration?: InputMaybe<Organization_Integrations_Order_By>;
  page?: InputMaybe<Trust_Portal_Pages_Order_By>;
  page_id?: InputMaybe<Order_By>;
  provider_agreement_id?: InputMaybe<Order_By>;
  provider_signing_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trust_portal.access_requests */
export type Trust_Portal_Access_Requests_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "trust_portal.access_requests" */
export enum Trust_Portal_Access_Requests_Select_Column {
  /** column name */
  AccessBlockId = 'access_block_id',
  /** column name */
  Address = 'address',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  Company = 'company',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  GrantSource = 'grant_source',
  /** column name */
  Id = 'id',
  /** column name */
  MatchingDomain = 'matching_domain',
  /** column name */
  Name = 'name',
  /** column name */
  NdaGateProcessingStatus = 'nda_gate_processing_status',
  /** column name */
  PageId = 'page_id',
  /** column name */
  ProviderAgreementId = 'provider_agreement_id',
  /** column name */
  ProviderSigningId = 'provider_signing_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  RequesterId = 'requester_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "trust_portal.access_requests" */
export type Trust_Portal_Access_Requests_Set_Input = {
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Trust_Portal_Access_Request_Statuses_Enum>;
};

export type Trust_Portal_Access_Requests_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trust_Portal_Access_Requests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trust_Portal_Access_Requests_Bool_Exp;
};

/** columns and relationships of "trust_portal.categories" */
export type Trust_Portal_Categories = {
  __typename?: 'trust_portal_categories';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order: Scalars['String']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  update_categories: Array<Trust_Portal_Update_Categories>;
};

/** columns and relationships of "trust_portal.categories" */
export type Trust_Portal_CategoriesUpdate_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Update_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Update_Categories_Order_By>>;
  where?: InputMaybe<Trust_Portal_Update_Categories_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "trust_portal.categories". All fields are combined with a logical 'AND'. */
export type Trust_Portal_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Trust_Portal_Categories_Bool_Exp>>;
  _not?: InputMaybe<Trust_Portal_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Trust_Portal_Categories_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  update_categories?: InputMaybe<Trust_Portal_Update_Categories_Bool_Exp>;
};

/** unique or primary key constraints on table "trust_portal.categories" */
export enum Trust_Portal_Categories_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  CategoriesNameOrganizationIdKey = 'categories_name_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  CategoriesPkey = 'categories_pkey',
}

/** input type for inserting data into table "trust_portal.categories" */
export type Trust_Portal_Categories_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  update_categories?: InputMaybe<Trust_Portal_Update_Categories_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "trust_portal.categories" */
export type Trust_Portal_Categories_Mutation_Response = {
  __typename?: 'trust_portal_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trust_Portal_Categories>;
};

/** input type for inserting object relation for remote table "trust_portal.categories" */
export type Trust_Portal_Categories_Obj_Rel_Insert_Input = {
  data: Trust_Portal_Categories_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trust_Portal_Categories_On_Conflict>;
};

/** on_conflict condition type for table "trust_portal.categories" */
export type Trust_Portal_Categories_On_Conflict = {
  constraint: Trust_Portal_Categories_Constraint;
  update_columns?: Array<Trust_Portal_Categories_Update_Column>;
  where?: InputMaybe<Trust_Portal_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "trust_portal.categories". */
export type Trust_Portal_Categories_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  update_categories_aggregate?: InputMaybe<Trust_Portal_Update_Categories_Aggregate_Order_By>;
};

/** primary key columns input for table: trust_portal.categories */
export type Trust_Portal_Categories_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "trust_portal.categories" */
export enum Trust_Portal_Categories_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
}

/** input type for updating data in table "trust_portal.categories" */
export type Trust_Portal_Categories_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "trust_portal_categories" */
export type Trust_Portal_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trust_Portal_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trust_Portal_Categories_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "trust_portal.categories" */
export enum Trust_Portal_Categories_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Trust_Portal_Categories_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trust_Portal_Categories_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trust_Portal_Categories_Bool_Exp;
};

/** columns and relationships of "trust_portal.document_resource_sections" */
export type Trust_Portal_Document_Resource_Sections = {
  __typename?: 'trust_portal_document_resource_sections';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  document: Trust_Portal_Documents;
  document_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  section: Trust_Portal_Resource_Sections;
  section_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "trust_portal.document_resource_sections" */
export type Trust_Portal_Document_Resource_Sections_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trust_Portal_Document_Resource_Sections_Max_Order_By>;
  min?: InputMaybe<Trust_Portal_Document_Resource_Sections_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trust_portal.document_resource_sections" */
export type Trust_Portal_Document_Resource_Sections_Arr_Rel_Insert_Input = {
  data: Array<Trust_Portal_Document_Resource_Sections_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trust_Portal_Document_Resource_Sections_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trust_portal.document_resource_sections". All fields are combined with a logical 'AND'. */
export type Trust_Portal_Document_Resource_Sections_Bool_Exp = {
  _and?: InputMaybe<Array<Trust_Portal_Document_Resource_Sections_Bool_Exp>>;
  _not?: InputMaybe<Trust_Portal_Document_Resource_Sections_Bool_Exp>;
  _or?: InputMaybe<Array<Trust_Portal_Document_Resource_Sections_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Trust_Portal_Documents_Bool_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  section?: InputMaybe<Trust_Portal_Resource_Sections_Bool_Exp>;
  section_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "trust_portal.document_resource_sections" */
export enum Trust_Portal_Document_Resource_Sections_Constraint {
  /** unique or primary key constraint on columns "section_id", "document_id" */
  DocumentResourceSectionsDocumentIdSectionIdKey = 'document_resource_sections_document_id_section_id_key',
  /** unique or primary key constraint on columns "id" */
  DocumentResourceSectionsPkey = 'document_resource_sections_pkey',
}

/** input type for inserting data into table "trust_portal.document_resource_sections" */
export type Trust_Portal_Document_Resource_Sections_Insert_Input = {
  document?: InputMaybe<Trust_Portal_Documents_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  section?: InputMaybe<Trust_Portal_Resource_Sections_Obj_Rel_Insert_Input>;
  section_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "trust_portal.document_resource_sections" */
export type Trust_Portal_Document_Resource_Sections_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "trust_portal.document_resource_sections" */
export type Trust_Portal_Document_Resource_Sections_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trust_portal.document_resource_sections" */
export type Trust_Portal_Document_Resource_Sections_Mutation_Response = {
  __typename?: 'trust_portal_document_resource_sections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trust_Portal_Document_Resource_Sections>;
};

/** on_conflict condition type for table "trust_portal.document_resource_sections" */
export type Trust_Portal_Document_Resource_Sections_On_Conflict = {
  constraint: Trust_Portal_Document_Resource_Sections_Constraint;
  update_columns?: Array<Trust_Portal_Document_Resource_Sections_Update_Column>;
  where?: InputMaybe<Trust_Portal_Document_Resource_Sections_Bool_Exp>;
};

/** Ordering options when selecting data from "trust_portal.document_resource_sections". */
export type Trust_Portal_Document_Resource_Sections_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Trust_Portal_Documents_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  section?: InputMaybe<Trust_Portal_Resource_Sections_Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** select columns of table "trust_portal.document_resource_sections" */
export enum Trust_Portal_Document_Resource_Sections_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  SectionId = 'section_id',
}

/** placeholder for update columns of table "trust_portal.document_resource_sections" (current role has no relevant permissions) */
export enum Trust_Portal_Document_Resource_Sections_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "trust_portal.documents" */
export type Trust_Portal_Documents = {
  __typename?: 'trust_portal_documents';
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  document_resource_sections: Array<Trust_Portal_Document_Resource_Sections>;
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order: Scalars['String']['output'];
  /** An object relationship */
  page: Trust_Portal_Pages;
  page_id: Scalars['uuid']['output'];
  requires_access: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** columns and relationships of "trust_portal.documents" */
export type Trust_Portal_DocumentsDocument_Resource_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Document_Resource_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Document_Resource_Sections_Order_By>>;
  where?: InputMaybe<Trust_Portal_Document_Resource_Sections_Bool_Exp>;
};

/** order by aggregate values of table "trust_portal.documents" */
export type Trust_Portal_Documents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trust_Portal_Documents_Max_Order_By>;
  min?: InputMaybe<Trust_Portal_Documents_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trust_portal.documents" */
export type Trust_Portal_Documents_Arr_Rel_Insert_Input = {
  data: Array<Trust_Portal_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trust_Portal_Documents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trust_portal.documents". All fields are combined with a logical 'AND'. */
export type Trust_Portal_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Trust_Portal_Documents_Bool_Exp>>;
  _not?: InputMaybe<Trust_Portal_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Trust_Portal_Documents_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  document_resource_sections?: InputMaybe<Trust_Portal_Document_Resource_Sections_Bool_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  page?: InputMaybe<Trust_Portal_Pages_Bool_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  requires_access?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "trust_portal.documents" */
export enum Trust_Portal_Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentsPkey = 'documents_pkey',
}

/** input type for inserting data into table "trust_portal.documents" */
export type Trust_Portal_Documents_Insert_Input = {
  document_resource_sections?: InputMaybe<Trust_Portal_Document_Resource_Sections_Arr_Rel_Insert_Input>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Trust_Portal_Pages_Obj_Rel_Insert_Input>;
  page_id?: InputMaybe<Scalars['uuid']['input']>;
  requires_access?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by max() on columns of table "trust_portal.documents" */
export type Trust_Portal_Documents_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "trust_portal.documents" */
export type Trust_Portal_Documents_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trust_portal.documents" */
export type Trust_Portal_Documents_Mutation_Response = {
  __typename?: 'trust_portal_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trust_Portal_Documents>;
};

/** input type for inserting object relation for remote table "trust_portal.documents" */
export type Trust_Portal_Documents_Obj_Rel_Insert_Input = {
  data: Trust_Portal_Documents_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trust_Portal_Documents_On_Conflict>;
};

/** on_conflict condition type for table "trust_portal.documents" */
export type Trust_Portal_Documents_On_Conflict = {
  constraint: Trust_Portal_Documents_Constraint;
  update_columns?: Array<Trust_Portal_Documents_Update_Column>;
  where?: InputMaybe<Trust_Portal_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "trust_portal.documents". */
export type Trust_Portal_Documents_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  document_resource_sections_aggregate?: InputMaybe<Trust_Portal_Document_Resource_Sections_Aggregate_Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  page?: InputMaybe<Trust_Portal_Pages_Order_By>;
  page_id?: InputMaybe<Order_By>;
  requires_access?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: trust_portal.documents */
export type Trust_Portal_Documents_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "trust_portal.documents" */
export enum Trust_Portal_Documents_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  PageId = 'page_id',
  /** column name */
  RequiresAccess = 'requires_access',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "trust_portal.documents" */
export type Trust_Portal_Documents_Set_Input = {
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  requires_access?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "trust_portal.documents" */
export enum Trust_Portal_Documents_Update_Column {
  /** column name */
  FileId = 'file_id',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  RequiresAccess = 'requires_access',
}

export type Trust_Portal_Documents_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trust_Portal_Documents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trust_Portal_Documents_Bool_Exp;
};

export enum Trust_Portal_Domain_Providers_Enum {
  /** Vercel project domains */
  Vercel = 'vercel',
}

/** Boolean expression to compare columns of type "trust_portal_domain_providers_enum". All fields are combined with logical 'AND'. */
export type Trust_Portal_Domain_Providers_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Trust_Portal_Domain_Providers_Enum>;
  _in?: InputMaybe<Array<Trust_Portal_Domain_Providers_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Trust_Portal_Domain_Providers_Enum>;
  _nin?: InputMaybe<Array<Trust_Portal_Domain_Providers_Enum>>;
};

export enum Trust_Portal_Domain_Statuses_Enum {
  /** Disabled at complyance level */
  Disabled = 'disabled',
  /** DNS validation failed */
  Failed = 'failed',
  /** Domain created at the provider, awaiting DNS verification */
  Pending = 'pending',
  /** Domain is no longer assignable and is waiting for provider deprovisioning */
  PendingDelete = 'pending_delete',
  /** DNS verified; the domain can serve the Trust Portal */
  Verified = 'verified',
}

/** Boolean expression to compare columns of type "trust_portal_domain_statuses_enum". All fields are combined with logical 'AND'. */
export type Trust_Portal_Domain_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Trust_Portal_Domain_Statuses_Enum>;
  _in?: InputMaybe<Array<Trust_Portal_Domain_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Trust_Portal_Domain_Statuses_Enum>;
  _nin?: InputMaybe<Array<Trust_Portal_Domain_Statuses_Enum>>;
};

/** Custom hostnames assigned to Trust Portal pages */
export type Trust_Portal_Domains = {
  __typename?: 'trust_portal_domains';
  created_at: Scalars['timestamptz']['output'];
  /** Provider-agnostic, normalized DNS records the customer must publish: [{ type, host, value, valid, reason }] */
  dns_records?: Maybe<Scalars['jsonb']['output']>;
  domain: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  last_checked_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  page: Trust_Portal_Pages;
  page_id: Scalars['uuid']['output'];
  provider: Trust_Portal_Domain_Providers_Enum;
  provider_domain_id?: Maybe<Scalars['String']['output']>;
  status: Trust_Portal_Domain_Statuses_Enum;
  updated_at: Scalars['timestamptz']['output'];
  verified_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Custom hostnames assigned to Trust Portal pages */
export type Trust_Portal_DomainsDns_RecordsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "trust_portal.domains". All fields are combined with a logical 'AND'. */
export type Trust_Portal_Domains_Bool_Exp = {
  _and?: InputMaybe<Array<Trust_Portal_Domains_Bool_Exp>>;
  _not?: InputMaybe<Trust_Portal_Domains_Bool_Exp>;
  _or?: InputMaybe<Array<Trust_Portal_Domains_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dns_records?: InputMaybe<Jsonb_Comparison_Exp>;
  domain?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_checked_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  page?: InputMaybe<Trust_Portal_Pages_Bool_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Trust_Portal_Domain_Providers_Enum_Comparison_Exp>;
  provider_domain_id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Trust_Portal_Domain_Statuses_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "trust_portal.domains". */
export type Trust_Portal_Domains_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dns_records?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_checked_at?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  page?: InputMaybe<Trust_Portal_Pages_Order_By>;
  page_id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_domain_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "trust_portal.faqs" */
export type Trust_Portal_Faqs = {
  __typename?: 'trust_portal_faqs';
  answer: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  order: Scalars['String']['output'];
  /** An object relationship */
  page: Trust_Portal_Pages;
  page_id: Scalars['uuid']['output'];
  question: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** order by aggregate values of table "trust_portal.faqs" */
export type Trust_Portal_Faqs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trust_Portal_Faqs_Max_Order_By>;
  min?: InputMaybe<Trust_Portal_Faqs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trust_portal.faqs" */
export type Trust_Portal_Faqs_Arr_Rel_Insert_Input = {
  data: Array<Trust_Portal_Faqs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trust_Portal_Faqs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trust_portal.faqs". All fields are combined with a logical 'AND'. */
export type Trust_Portal_Faqs_Bool_Exp = {
  _and?: InputMaybe<Array<Trust_Portal_Faqs_Bool_Exp>>;
  _not?: InputMaybe<Trust_Portal_Faqs_Bool_Exp>;
  _or?: InputMaybe<Array<Trust_Portal_Faqs_Bool_Exp>>;
  answer?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  page?: InputMaybe<Trust_Portal_Pages_Bool_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  question?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "trust_portal.faqs" */
export enum Trust_Portal_Faqs_Constraint {
  /** unique or primary key constraint on columns "id" */
  FaqsPkey = 'faqs_pkey',
}

/** input type for inserting data into table "trust_portal.faqs" */
export type Trust_Portal_Faqs_Insert_Input = {
  answer?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Trust_Portal_Pages_Obj_Rel_Insert_Input>;
  page_id?: InputMaybe<Scalars['uuid']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "trust_portal.faqs" */
export type Trust_Portal_Faqs_Max_Order_By = {
  answer?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "trust_portal.faqs" */
export type Trust_Portal_Faqs_Min_Order_By = {
  answer?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trust_portal.faqs" */
export type Trust_Portal_Faqs_Mutation_Response = {
  __typename?: 'trust_portal_faqs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trust_Portal_Faqs>;
};

/** on_conflict condition type for table "trust_portal.faqs" */
export type Trust_Portal_Faqs_On_Conflict = {
  constraint: Trust_Portal_Faqs_Constraint;
  update_columns?: Array<Trust_Portal_Faqs_Update_Column>;
  where?: InputMaybe<Trust_Portal_Faqs_Bool_Exp>;
};

/** Ordering options when selecting data from "trust_portal.faqs". */
export type Trust_Portal_Faqs_Order_By = {
  answer?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  page?: InputMaybe<Trust_Portal_Pages_Order_By>;
  page_id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: trust_portal.faqs */
export type Trust_Portal_Faqs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "trust_portal.faqs" */
export enum Trust_Portal_Faqs_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PageId = 'page_id',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "trust_portal.faqs" */
export type Trust_Portal_Faqs_Set_Input = {
  answer?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "trust_portal.faqs" */
export enum Trust_Portal_Faqs_Update_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Order = 'order',
  /** column name */
  Question = 'question',
}

export type Trust_Portal_Faqs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trust_Portal_Faqs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trust_Portal_Faqs_Bool_Exp;
};

/** columns and relationships of "trust_portal.frameworks" */
export type Trust_Portal_Frameworks = {
  __typename?: 'trust_portal_frameworks';
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  logo_file?: Maybe<Files>;
  logo_file_id?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['String']['output'];
  /** An object relationship */
  page: Trust_Portal_Pages;
  page_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** order by aggregate values of table "trust_portal.frameworks" */
export type Trust_Portal_Frameworks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trust_Portal_Frameworks_Max_Order_By>;
  min?: InputMaybe<Trust_Portal_Frameworks_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trust_portal.frameworks" */
export type Trust_Portal_Frameworks_Arr_Rel_Insert_Input = {
  data: Array<Trust_Portal_Frameworks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trust_Portal_Frameworks_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trust_portal.frameworks". All fields are combined with a logical 'AND'. */
export type Trust_Portal_Frameworks_Bool_Exp = {
  _and?: InputMaybe<Array<Trust_Portal_Frameworks_Bool_Exp>>;
  _not?: InputMaybe<Trust_Portal_Frameworks_Bool_Exp>;
  _or?: InputMaybe<Array<Trust_Portal_Frameworks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logo_file?: InputMaybe<Files_Bool_Exp>;
  logo_file_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  page?: InputMaybe<Trust_Portal_Pages_Bool_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "trust_portal.frameworks" */
export enum Trust_Portal_Frameworks_Constraint {
  /** unique or primary key constraint on columns "id" */
  FrameworksPkey = 'frameworks_pkey',
}

/** input type for inserting data into table "trust_portal.frameworks" */
export type Trust_Portal_Frameworks_Insert_Input = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  logo_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  logo_file_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Trust_Portal_Pages_Obj_Rel_Insert_Input>;
  page_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "trust_portal.frameworks" */
export type Trust_Portal_Frameworks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_file_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "trust_portal.frameworks" */
export type Trust_Portal_Frameworks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_file_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trust_portal.frameworks" */
export type Trust_Portal_Frameworks_Mutation_Response = {
  __typename?: 'trust_portal_frameworks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trust_Portal_Frameworks>;
};

/** on_conflict condition type for table "trust_portal.frameworks" */
export type Trust_Portal_Frameworks_On_Conflict = {
  constraint: Trust_Portal_Frameworks_Constraint;
  update_columns?: Array<Trust_Portal_Frameworks_Update_Column>;
  where?: InputMaybe<Trust_Portal_Frameworks_Bool_Exp>;
};

/** Ordering options when selecting data from "trust_portal.frameworks". */
export type Trust_Portal_Frameworks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_file?: InputMaybe<Files_Order_By>;
  logo_file_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  page?: InputMaybe<Trust_Portal_Pages_Order_By>;
  page_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: trust_portal.frameworks */
export type Trust_Portal_Frameworks_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "trust_portal.frameworks" */
export enum Trust_Portal_Frameworks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  LogoFileId = 'logo_file_id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  PageId = 'page_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "trust_portal.frameworks" */
export type Trust_Portal_Frameworks_Set_Input = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  logo_file_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "trust_portal.frameworks" */
export enum Trust_Portal_Frameworks_Update_Column {
  /** column name */
  Hidden = 'hidden',
  /** column name */
  LogoFileId = 'logo_file_id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Trust_Portal_Frameworks_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trust_Portal_Frameworks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trust_Portal_Frameworks_Bool_Exp;
};

export enum Trust_Portal_Nda_Gate_Processing_Statuses_Enum {
  Active = 'active',
  HandingOff = 'handing_off',
  Stopped = 'stopped',
}

/** Boolean expression to compare columns of type "trust_portal_nda_gate_processing_statuses_enum". All fields are combined with logical 'AND'. */
export type Trust_Portal_Nda_Gate_Processing_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Trust_Portal_Nda_Gate_Processing_Statuses_Enum>;
  _in?: InputMaybe<Array<Trust_Portal_Nda_Gate_Processing_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Trust_Portal_Nda_Gate_Processing_Statuses_Enum>;
  _nin?: InputMaybe<Array<Trust_Portal_Nda_Gate_Processing_Statuses_Enum>>;
};

/** columns and relationships of "trust_portal.pages" */
export type Trust_Portal_Pages = {
  __typename?: 'trust_portal_pages';
  /** An array relationship */
  access_blocks: Array<Trust_Portal_Access_Blocks>;
  /** An array relationship */
  access_requests: Array<Trust_Portal_Access_Requests>;
  access_token: Scalars['uuid']['output'];
  company_name?: Maybe<Scalars['String']['output']>;
  contact_email: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  /** An array relationship */
  documents: Array<Trust_Portal_Documents>;
  /** An object relationship */
  domain?: Maybe<Trust_Portal_Domains>;
  /** An array relationship */
  faqs: Array<Trust_Portal_Faqs>;
  /** An array relationship */
  frameworks: Array<Trust_Portal_Frameworks>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  logo_file?: Maybe<Files>;
  logo_file_id?: Maybe<Scalars['uuid']['output']>;
  nda_domain_sharing: Scalars['Boolean']['output'];
  nda_provider_configuration?: Maybe<Scalars['jsonb']['output']>;
  nda_require_signed: Scalars['Boolean']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  organization_integration?: Maybe<Organization_Integrations>;
  organization_integration_id?: Maybe<Scalars['uuid']['output']>;
  request_form: Scalars['jsonb']['output'];
  slug?: Maybe<Scalars['citext']['output']>;
  theme?: Maybe<Scalars['TrustPortalTheme']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  updates: Array<Trust_Portal_Updates>;
  /** An object relationship */
  user?: Maybe<Users>;
  website?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "trust_portal.pages" */
export type Trust_Portal_PagesAccess_BlocksArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Access_Blocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Access_Blocks_Order_By>>;
  where?: InputMaybe<Trust_Portal_Access_Blocks_Bool_Exp>;
};

/** columns and relationships of "trust_portal.pages" */
export type Trust_Portal_PagesAccess_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Access_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Access_Requests_Order_By>>;
  where?: InputMaybe<Trust_Portal_Access_Requests_Bool_Exp>;
};

/** columns and relationships of "trust_portal.pages" */
export type Trust_Portal_PagesDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Documents_Order_By>>;
  where?: InputMaybe<Trust_Portal_Documents_Bool_Exp>;
};

/** columns and relationships of "trust_portal.pages" */
export type Trust_Portal_PagesFaqsArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Faqs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Faqs_Order_By>>;
  where?: InputMaybe<Trust_Portal_Faqs_Bool_Exp>;
};

/** columns and relationships of "trust_portal.pages" */
export type Trust_Portal_PagesFrameworksArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Frameworks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Frameworks_Order_By>>;
  where?: InputMaybe<Trust_Portal_Frameworks_Bool_Exp>;
};

/** columns and relationships of "trust_portal.pages" */
export type Trust_Portal_PagesNda_Provider_ConfigurationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "trust_portal.pages" */
export type Trust_Portal_PagesRequest_FormArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "trust_portal.pages" */
export type Trust_Portal_PagesThemeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "trust_portal.pages" */
export type Trust_Portal_PagesUpdatesArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Updates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Updates_Order_By>>;
  where?: InputMaybe<Trust_Portal_Updates_Bool_Exp>;
};

/** order by aggregate values of table "trust_portal.pages" */
export type Trust_Portal_Pages_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trust_Portal_Pages_Max_Order_By>;
  min?: InputMaybe<Trust_Portal_Pages_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Trust_Portal_Pages_Append_Input = {
  theme?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "trust_portal.pages" */
export type Trust_Portal_Pages_Arr_Rel_Insert_Input = {
  data: Array<Trust_Portal_Pages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trust_Portal_Pages_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trust_portal.pages". All fields are combined with a logical 'AND'. */
export type Trust_Portal_Pages_Bool_Exp = {
  _and?: InputMaybe<Array<Trust_Portal_Pages_Bool_Exp>>;
  _not?: InputMaybe<Trust_Portal_Pages_Bool_Exp>;
  _or?: InputMaybe<Array<Trust_Portal_Pages_Bool_Exp>>;
  access_blocks?: InputMaybe<Trust_Portal_Access_Blocks_Bool_Exp>;
  access_requests?: InputMaybe<Trust_Portal_Access_Requests_Bool_Exp>;
  access_token?: InputMaybe<Uuid_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  documents?: InputMaybe<Trust_Portal_Documents_Bool_Exp>;
  domain?: InputMaybe<Trust_Portal_Domains_Bool_Exp>;
  faqs?: InputMaybe<Trust_Portal_Faqs_Bool_Exp>;
  frameworks?: InputMaybe<Trust_Portal_Frameworks_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logo_file?: InputMaybe<Files_Bool_Exp>;
  logo_file_id?: InputMaybe<Uuid_Comparison_Exp>;
  nda_domain_sharing?: InputMaybe<Boolean_Comparison_Exp>;
  nda_provider_configuration?: InputMaybe<Jsonb_Comparison_Exp>;
  nda_require_signed?: InputMaybe<Boolean_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_integration?: InputMaybe<Organization_Integrations_Bool_Exp>;
  organization_integration_id?: InputMaybe<Uuid_Comparison_Exp>;
  request_form?: InputMaybe<Jsonb_Comparison_Exp>;
  slug?: InputMaybe<Citext_Comparison_Exp>;
  theme?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updates?: InputMaybe<Trust_Portal_Updates_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trust_portal.pages" */
export enum Trust_Portal_Pages_Constraint {
  /** unique or primary key constraint on columns "access_token" */
  PagesAccessTokenKey = 'pages_access_token_key',
  /** unique or primary key constraint on columns "organization_id" */
  PagesOrganizationIdKey = 'pages_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  PagesPkey = 'pages_pkey',
  /** unique or primary key constraint on columns "slug" */
  PagesSlugKey = 'pages_slug_key',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Trust_Portal_Pages_Delete_At_Path_Input = {
  theme?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Trust_Portal_Pages_Delete_Elem_Input = {
  theme?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Trust_Portal_Pages_Delete_Key_Input = {
  theme?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "trust_portal.pages" */
export type Trust_Portal_Pages_Insert_Input = {
  company_name?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  documents?: InputMaybe<Trust_Portal_Documents_Arr_Rel_Insert_Input>;
  faqs?: InputMaybe<Trust_Portal_Faqs_Arr_Rel_Insert_Input>;
  frameworks?: InputMaybe<Trust_Portal_Frameworks_Arr_Rel_Insert_Input>;
  logo_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  logo_file_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['citext']['input']>;
  theme?: InputMaybe<Scalars['jsonb']['input']>;
  updates?: InputMaybe<Trust_Portal_Updates_Arr_Rel_Insert_Input>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "trust_portal.pages" */
export type Trust_Portal_Pages_Max_Order_By = {
  access_token?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_file_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_integration_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "trust_portal.pages" */
export type Trust_Portal_Pages_Min_Order_By = {
  access_token?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_file_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_integration_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trust_portal.pages" */
export type Trust_Portal_Pages_Mutation_Response = {
  __typename?: 'trust_portal_pages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trust_Portal_Pages>;
};

/** input type for inserting object relation for remote table "trust_portal.pages" */
export type Trust_Portal_Pages_Obj_Rel_Insert_Input = {
  data: Trust_Portal_Pages_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trust_Portal_Pages_On_Conflict>;
};

/** on_conflict condition type for table "trust_portal.pages" */
export type Trust_Portal_Pages_On_Conflict = {
  constraint: Trust_Portal_Pages_Constraint;
  update_columns?: Array<Trust_Portal_Pages_Update_Column>;
  where?: InputMaybe<Trust_Portal_Pages_Bool_Exp>;
};

/** Ordering options when selecting data from "trust_portal.pages". */
export type Trust_Portal_Pages_Order_By = {
  access_blocks_aggregate?: InputMaybe<Trust_Portal_Access_Blocks_Aggregate_Order_By>;
  access_requests_aggregate?: InputMaybe<Trust_Portal_Access_Requests_Aggregate_Order_By>;
  access_token?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Trust_Portal_Documents_Aggregate_Order_By>;
  domain?: InputMaybe<Trust_Portal_Domains_Order_By>;
  faqs_aggregate?: InputMaybe<Trust_Portal_Faqs_Aggregate_Order_By>;
  frameworks_aggregate?: InputMaybe<Trust_Portal_Frameworks_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  logo_file?: InputMaybe<Files_Order_By>;
  logo_file_id?: InputMaybe<Order_By>;
  nda_domain_sharing?: InputMaybe<Order_By>;
  nda_provider_configuration?: InputMaybe<Order_By>;
  nda_require_signed?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_integration?: InputMaybe<Organization_Integrations_Order_By>;
  organization_integration_id?: InputMaybe<Order_By>;
  request_form?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  theme?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updates_aggregate?: InputMaybe<Trust_Portal_Updates_Aggregate_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trust_portal.pages */
export type Trust_Portal_Pages_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Trust_Portal_Pages_Prepend_Input = {
  theme?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "trust_portal.pages" */
export enum Trust_Portal_Pages_Select_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Id = 'id',
  /** column name */
  LogoFileId = 'logo_file_id',
  /** column name */
  NdaDomainSharing = 'nda_domain_sharing',
  /** column name */
  NdaProviderConfiguration = 'nda_provider_configuration',
  /** column name */
  NdaRequireSigned = 'nda_require_signed',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationIntegrationId = 'organization_integration_id',
  /** column name */
  RequestForm = 'request_form',
  /** column name */
  Slug = 'slug',
  /** column name */
  Theme = 'theme',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website',
}

/** input type for updating data in table "trust_portal.pages" */
export type Trust_Portal_Pages_Set_Input = {
  company_name?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo_file_id?: InputMaybe<Scalars['uuid']['input']>;
  nda_domain_sharing?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['citext']['input']>;
  theme?: InputMaybe<Scalars['jsonb']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "trust_portal.pages" */
export enum Trust_Portal_Pages_Update_Column {
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  Description = 'description',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  LogoFileId = 'logo_file_id',
  /** column name */
  NdaDomainSharing = 'nda_domain_sharing',
  /** column name */
  Slug = 'slug',
  /** column name */
  Theme = 'theme',
  /** column name */
  Website = 'website',
}

export type Trust_Portal_Pages_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Trust_Portal_Pages_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Trust_Portal_Pages_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Trust_Portal_Pages_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Trust_Portal_Pages_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Trust_Portal_Pages_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trust_Portal_Pages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trust_Portal_Pages_Bool_Exp;
};

/** columns and relationships of "trust_portal.resource_sections" */
export type Trust_Portal_Resource_Sections = {
  __typename?: 'trust_portal_resource_sections';
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  document_resource_sections: Array<Trust_Portal_Document_Resource_Sections>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order: Scalars['String']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "trust_portal.resource_sections" */
export type Trust_Portal_Resource_SectionsDocument_Resource_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Document_Resource_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Document_Resource_Sections_Order_By>>;
  where?: InputMaybe<Trust_Portal_Document_Resource_Sections_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "trust_portal.resource_sections". All fields are combined with a logical 'AND'. */
export type Trust_Portal_Resource_Sections_Bool_Exp = {
  _and?: InputMaybe<Array<Trust_Portal_Resource_Sections_Bool_Exp>>;
  _not?: InputMaybe<Trust_Portal_Resource_Sections_Bool_Exp>;
  _or?: InputMaybe<Array<Trust_Portal_Resource_Sections_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_resource_sections?: InputMaybe<Trust_Portal_Document_Resource_Sections_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "trust_portal.resource_sections" */
export enum Trust_Portal_Resource_Sections_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  ResourceSectionsOrganizationIdNameKey = 'resource_sections_organization_id_name_key',
  /** unique or primary key constraint on columns "id" */
  ResourceSectionsPkey = 'resource_sections_pkey',
}

/** input type for inserting data into table "trust_portal.resource_sections" */
export type Trust_Portal_Resource_Sections_Insert_Input = {
  document_resource_sections?: InputMaybe<Trust_Portal_Document_Resource_Sections_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "trust_portal.resource_sections" */
export type Trust_Portal_Resource_Sections_Mutation_Response = {
  __typename?: 'trust_portal_resource_sections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trust_Portal_Resource_Sections>;
};

/** input type for inserting object relation for remote table "trust_portal.resource_sections" */
export type Trust_Portal_Resource_Sections_Obj_Rel_Insert_Input = {
  data: Trust_Portal_Resource_Sections_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trust_Portal_Resource_Sections_On_Conflict>;
};

/** on_conflict condition type for table "trust_portal.resource_sections" */
export type Trust_Portal_Resource_Sections_On_Conflict = {
  constraint: Trust_Portal_Resource_Sections_Constraint;
  update_columns?: Array<Trust_Portal_Resource_Sections_Update_Column>;
  where?: InputMaybe<Trust_Portal_Resource_Sections_Bool_Exp>;
};

/** Ordering options when selecting data from "trust_portal.resource_sections". */
export type Trust_Portal_Resource_Sections_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_resource_sections_aggregate?: InputMaybe<Trust_Portal_Document_Resource_Sections_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trust_portal.resource_sections */
export type Trust_Portal_Resource_Sections_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "trust_portal.resource_sections" */
export enum Trust_Portal_Resource_Sections_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "trust_portal.resource_sections" */
export type Trust_Portal_Resource_Sections_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "trust_portal_resource_sections" */
export type Trust_Portal_Resource_Sections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trust_Portal_Resource_Sections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trust_Portal_Resource_Sections_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "trust_portal.resource_sections" */
export enum Trust_Portal_Resource_Sections_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
}

export type Trust_Portal_Resource_Sections_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trust_Portal_Resource_Sections_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trust_Portal_Resource_Sections_Bool_Exp;
};

/** columns and relationships of "trust_portal.update_categories" */
export type Trust_Portal_Update_Categories = {
  __typename?: 'trust_portal_update_categories';
  /** An object relationship */
  category: Trust_Portal_Categories;
  category_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  update: Trust_Portal_Updates;
  update_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "trust_portal.update_categories" */
export type Trust_Portal_Update_Categories_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trust_Portal_Update_Categories_Max_Order_By>;
  min?: InputMaybe<Trust_Portal_Update_Categories_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trust_portal.update_categories" */
export type Trust_Portal_Update_Categories_Arr_Rel_Insert_Input = {
  data: Array<Trust_Portal_Update_Categories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trust_Portal_Update_Categories_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trust_portal.update_categories". All fields are combined with a logical 'AND'. */
export type Trust_Portal_Update_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Trust_Portal_Update_Categories_Bool_Exp>>;
  _not?: InputMaybe<Trust_Portal_Update_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Trust_Portal_Update_Categories_Bool_Exp>>;
  category?: InputMaybe<Trust_Portal_Categories_Bool_Exp>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  update?: InputMaybe<Trust_Portal_Updates_Bool_Exp>;
  update_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "trust_portal.update_categories" */
export enum Trust_Portal_Update_Categories_Constraint {
  /** unique or primary key constraint on columns "id" */
  UpdateCategoriesPkey = 'update_categories_pkey',
  /** unique or primary key constraint on columns "category_id", "update_id" */
  UpdateCategoriesUpdateIdCategoryIdKey = 'update_categories_update_id_category_id_key',
}

/** input type for inserting data into table "trust_portal.update_categories" */
export type Trust_Portal_Update_Categories_Insert_Input = {
  category?: InputMaybe<Trust_Portal_Categories_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  update?: InputMaybe<Trust_Portal_Updates_Obj_Rel_Insert_Input>;
  update_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "trust_portal.update_categories" */
export type Trust_Portal_Update_Categories_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  update_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "trust_portal.update_categories" */
export type Trust_Portal_Update_Categories_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  update_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trust_portal.update_categories" */
export type Trust_Portal_Update_Categories_Mutation_Response = {
  __typename?: 'trust_portal_update_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trust_Portal_Update_Categories>;
};

/** on_conflict condition type for table "trust_portal.update_categories" */
export type Trust_Portal_Update_Categories_On_Conflict = {
  constraint: Trust_Portal_Update_Categories_Constraint;
  update_columns?: Array<Trust_Portal_Update_Categories_Update_Column>;
  where?: InputMaybe<Trust_Portal_Update_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "trust_portal.update_categories". */
export type Trust_Portal_Update_Categories_Order_By = {
  category?: InputMaybe<Trust_Portal_Categories_Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  update?: InputMaybe<Trust_Portal_Updates_Order_By>;
  update_id?: InputMaybe<Order_By>;
};

/** select columns of table "trust_portal.update_categories" */
export enum Trust_Portal_Update_Categories_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdateId = 'update_id',
}

/** placeholder for update columns of table "trust_portal.update_categories" (current role has no relevant permissions) */
export enum Trust_Portal_Update_Categories_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "trust_portal.updates" */
export type Trust_Portal_Updates = {
  __typename?: 'trust_portal_updates';
  content: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  page: Trust_Portal_Pages;
  page_id: Scalars['uuid']['output'];
  published_date: Scalars['timestamptz']['output'];
  title: Scalars['String']['output'];
  /** An array relationship */
  update_categories: Array<Trust_Portal_Update_Categories>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** columns and relationships of "trust_portal.updates" */
export type Trust_Portal_UpdatesUpdate_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Update_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Update_Categories_Order_By>>;
  where?: InputMaybe<Trust_Portal_Update_Categories_Bool_Exp>;
};

/** order by aggregate values of table "trust_portal.updates" */
export type Trust_Portal_Updates_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trust_Portal_Updates_Max_Order_By>;
  min?: InputMaybe<Trust_Portal_Updates_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trust_portal.updates" */
export type Trust_Portal_Updates_Arr_Rel_Insert_Input = {
  data: Array<Trust_Portal_Updates_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trust_Portal_Updates_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trust_portal.updates". All fields are combined with a logical 'AND'. */
export type Trust_Portal_Updates_Bool_Exp = {
  _and?: InputMaybe<Array<Trust_Portal_Updates_Bool_Exp>>;
  _not?: InputMaybe<Trust_Portal_Updates_Bool_Exp>;
  _or?: InputMaybe<Array<Trust_Portal_Updates_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  page?: InputMaybe<Trust_Portal_Pages_Bool_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  published_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  update_categories?: InputMaybe<Trust_Portal_Update_Categories_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "trust_portal.updates" */
export enum Trust_Portal_Updates_Constraint {
  /** unique or primary key constraint on columns "id" */
  UpdatesPkey = 'updates_pkey',
}

/** input type for inserting data into table "trust_portal.updates" */
export type Trust_Portal_Updates_Insert_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Trust_Portal_Pages_Obj_Rel_Insert_Input>;
  page_id?: InputMaybe<Scalars['uuid']['input']>;
  published_date?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  update_categories?: InputMaybe<Trust_Portal_Update_Categories_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "trust_portal.updates" */
export type Trust_Portal_Updates_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  published_date?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "trust_portal.updates" */
export type Trust_Portal_Updates_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  published_date?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trust_portal.updates" */
export type Trust_Portal_Updates_Mutation_Response = {
  __typename?: 'trust_portal_updates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trust_Portal_Updates>;
};

/** input type for inserting object relation for remote table "trust_portal.updates" */
export type Trust_Portal_Updates_Obj_Rel_Insert_Input = {
  data: Trust_Portal_Updates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trust_Portal_Updates_On_Conflict>;
};

/** on_conflict condition type for table "trust_portal.updates" */
export type Trust_Portal_Updates_On_Conflict = {
  constraint: Trust_Portal_Updates_Constraint;
  update_columns?: Array<Trust_Portal_Updates_Update_Column>;
  where?: InputMaybe<Trust_Portal_Updates_Bool_Exp>;
};

/** Ordering options when selecting data from "trust_portal.updates". */
export type Trust_Portal_Updates_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  page?: InputMaybe<Trust_Portal_Pages_Order_By>;
  page_id?: InputMaybe<Order_By>;
  published_date?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  update_categories_aggregate?: InputMaybe<Trust_Portal_Update_Categories_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: trust_portal.updates */
export type Trust_Portal_Updates_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "trust_portal.updates" */
export enum Trust_Portal_Updates_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  PublishedDate = 'published_date',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** input type for updating data in table "trust_portal.updates" */
export type Trust_Portal_Updates_Set_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  published_date?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "trust_portal.updates" */
export enum Trust_Portal_Updates_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  PublishedDate = 'published_date',
  /** column name */
  Title = 'title',
}

export type Trust_Portal_Updates_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trust_Portal_Updates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trust_Portal_Updates_Bool_Exp;
};

/** columns and relationships of "url_field_values" */
export type Url_Field_Values = {
  __typename?: 'url_field_values';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  fieldValueByFieldValueId: Field_Values;
  field_type: Scalars['String']['output'];
  /** An object relationship */
  field_value?: Maybe<Field_Values>;
  field_value_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  value: Scalars['String']['output'];
};

/** order by aggregate values of table "url_field_values" */
export type Url_Field_Values_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Url_Field_Values_Max_Order_By>;
  min?: InputMaybe<Url_Field_Values_Min_Order_By>;
};

/** input type for inserting array relation for remote table "url_field_values" */
export type Url_Field_Values_Arr_Rel_Insert_Input = {
  data: Array<Url_Field_Values_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Url_Field_Values_On_Conflict>;
};

/** Boolean expression to filter rows from the table "url_field_values". All fields are combined with a logical 'AND'. */
export type Url_Field_Values_Bool_Exp = {
  _and?: InputMaybe<Array<Url_Field_Values_Bool_Exp>>;
  _not?: InputMaybe<Url_Field_Values_Bool_Exp>;
  _or?: InputMaybe<Array<Url_Field_Values_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Bool_Exp>;
  field_type?: InputMaybe<String_Comparison_Exp>;
  field_value?: InputMaybe<Field_Values_Bool_Exp>;
  field_value_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "url_field_values" */
export enum Url_Field_Values_Constraint {
  /** unique or primary key constraint on columns "field_value_id" */
  UrlFieldValuesPkey = 'url_field_values_pkey',
}

/** input type for inserting data into table "url_field_values" */
export type Url_Field_Values_Insert_Input = {
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Obj_Rel_Insert_Input>;
  field_value?: InputMaybe<Field_Values_Obj_Rel_Insert_Input>;
  field_value_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "url_field_values" */
export type Url_Field_Values_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "url_field_values" */
export type Url_Field_Values_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "url_field_values" */
export type Url_Field_Values_Mutation_Response = {
  __typename?: 'url_field_values_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Url_Field_Values>;
};

/** input type for inserting object relation for remote table "url_field_values" */
export type Url_Field_Values_Obj_Rel_Insert_Input = {
  data: Url_Field_Values_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Url_Field_Values_On_Conflict>;
};

/** on_conflict condition type for table "url_field_values" */
export type Url_Field_Values_On_Conflict = {
  constraint: Url_Field_Values_Constraint;
  update_columns?: Array<Url_Field_Values_Update_Column>;
  where?: InputMaybe<Url_Field_Values_Bool_Exp>;
};

/** Ordering options when selecting data from "url_field_values". */
export type Url_Field_Values_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fieldValueByFieldValueId?: InputMaybe<Field_Values_Order_By>;
  field_type?: InputMaybe<Order_By>;
  field_value?: InputMaybe<Field_Values_Order_By>;
  field_value_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: url_field_values */
export type Url_Field_Values_Pk_Columns_Input = {
  field_value_id: Scalars['uuid']['input'];
};

/** select columns of table "url_field_values" */
export enum Url_Field_Values_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  FieldValueId = 'field_value_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
}

/** input type for updating data in table "url_field_values" */
export type Url_Field_Values_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "url_field_values" */
export enum Url_Field_Values_Update_Column {
  /** column name */
  Value = 'value',
}

export type Url_Field_Values_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Url_Field_Values_Set_Input>;
  /** filter the rows which have to be updated */
  where: Url_Field_Values_Bool_Exp;
};

/** columns and relationships of "user_controls_stats_view" */
export type User_Controls_Stats_View = {
  __typename?: 'user_controls_stats_view';
  controls_count?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  valid_controls_count?: Maybe<Scalars['Int']['output']>;
  valid_controls_ratio?: Maybe<Scalars['float8']['output']>;
};

/** Boolean expression to filter rows from the table "user_controls_stats_view". All fields are combined with a logical 'AND'. */
export type User_Controls_Stats_View_Bool_Exp = {
  _and?: InputMaybe<Array<User_Controls_Stats_View_Bool_Exp>>;
  _not?: InputMaybe<User_Controls_Stats_View_Bool_Exp>;
  _or?: InputMaybe<Array<User_Controls_Stats_View_Bool_Exp>>;
  controls_count?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  valid_controls_count?: InputMaybe<Int_Comparison_Exp>;
  valid_controls_ratio?: InputMaybe<Float8_Comparison_Exp>;
};

/** Ordering options when selecting data from "user_controls_stats_view". */
export type User_Controls_Stats_View_Order_By = {
  controls_count?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  valid_controls_count?: InputMaybe<Order_By>;
  valid_controls_ratio?: InputMaybe<Order_By>;
};

/** select columns of table "user_controls_stats_view" */
export enum User_Controls_Stats_View_Select_Column {
  /** column name */
  ControlsCount = 'controls_count',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ValidControlsCount = 'valid_controls_count',
  /** column name */
  ValidControlsRatio = 'valid_controls_ratio',
}

/** Streaming cursor of the table "user_controls_stats_view" */
export type User_Controls_Stats_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Controls_Stats_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Controls_Stats_View_Stream_Cursor_Value_Input = {
  controls_count?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  valid_controls_count?: InputMaybe<Scalars['Int']['input']>;
  valid_controls_ratio?: InputMaybe<Scalars['float8']['input']>;
};

/** this table contains actual notification entry for a user for different delivery type */
export type User_Notifications = {
  __typename?: 'user_notifications';
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  delivery_type: Notification_Delivery_Types_Enum;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  notification: Notifications;
  notification_id: Scalars['uuid']['output'];
  read_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_notifications" */
export type User_Notifications_Aggregate = {
  __typename?: 'user_notifications_aggregate';
  aggregate?: Maybe<User_Notifications_Aggregate_Fields>;
  nodes: Array<User_Notifications>;
};

export type User_Notifications_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Notifications_Aggregate_Bool_Exp_Count>;
};

export type User_Notifications_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Notifications_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_notifications" */
export type User_Notifications_Aggregate_Fields = {
  __typename?: 'user_notifications_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Notifications_Max_Fields>;
  min?: Maybe<User_Notifications_Min_Fields>;
};

/** aggregate fields of "user_notifications" */
export type User_Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_notifications" */
export type User_Notifications_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Notifications_Max_Order_By>;
  min?: InputMaybe<User_Notifications_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "user_notifications". All fields are combined with a logical 'AND'. */
export type User_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<User_Notifications_Bool_Exp>>;
  _not?: InputMaybe<User_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<User_Notifications_Bool_Exp>>;
  archived_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_type?: InputMaybe<Notification_Delivery_Types_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notification?: InputMaybe<Notifications_Bool_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  read_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type User_Notifications_Max_Fields = {
  __typename?: 'user_notifications_max_fields';
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notification_id?: Maybe<Scalars['uuid']['output']>;
  read_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_notifications" */
export type User_Notifications_Max_Order_By = {
  archived_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Notifications_Min_Fields = {
  __typename?: 'user_notifications_min_fields';
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notification_id?: Maybe<Scalars['uuid']['output']>;
  read_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_notifications" */
export type User_Notifications_Min_Order_By = {
  archived_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_notifications" */
export type User_Notifications_Mutation_Response = {
  __typename?: 'user_notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Notifications>;
};

/** Ordering options when selecting data from "user_notifications". */
export type User_Notifications_Order_By = {
  archived_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification?: InputMaybe<Notifications_Order_By>;
  notification_id?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_notifications */
export type User_Notifications_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_notifications" */
export enum User_Notifications_Select_Column {
  /** column name */
  ArchivedAt = 'archived_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveryType = 'delivery_type',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  ReadAt = 'read_at',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "user_notifications" */
export type User_Notifications_Set_Input = {
  archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  read_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "user_notifications" */
export type User_Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Notifications_Stream_Cursor_Value_Input = {
  archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_type?: InputMaybe<Notification_Delivery_Types_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  read_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type User_Notifications_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Notifications_Bool_Exp;
};

/** Per-user app preferences, distinct from auth.users which is owned by the Nhost auth service. */
export type User_Profiles = {
  __typename?: 'user_profiles';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** App-defined BCP-47 locale tag, not backed by a lookup table. See LanguageCode in @main/i18next for the current valid set. Personal UI language override; NULL means no override, fall back to the organization default. */
  language?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "user_profiles". All fields are combined with a logical 'AND'. */
export type User_Profiles_Bool_Exp = {
  _and?: InputMaybe<Array<User_Profiles_Bool_Exp>>;
  _not?: InputMaybe<User_Profiles_Bool_Exp>;
  _or?: InputMaybe<Array<User_Profiles_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_profiles" */
export enum User_Profiles_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProfilesPkey = 'user_profiles_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserProfilesUserIdKey = 'user_profiles_user_id_key',
}

/** input type for inserting data into table "user_profiles" */
export type User_Profiles_Insert_Input = {
  /** App-defined BCP-47 locale tag, not backed by a lookup table. See LanguageCode in @main/i18next for the current valid set. Personal UI language override; NULL means no override, fall back to the organization default. */
  language?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "user_profiles" */
export type User_Profiles_Mutation_Response = {
  __typename?: 'user_profiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Profiles>;
};

/** on_conflict condition type for table "user_profiles" */
export type User_Profiles_On_Conflict = {
  constraint: User_Profiles_Constraint;
  update_columns?: Array<User_Profiles_Update_Column>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};

/** Ordering options when selecting data from "user_profiles". */
export type User_Profiles_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_profiles */
export type User_Profiles_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_profiles" */
export enum User_Profiles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "user_profiles" */
export type User_Profiles_Set_Input = {
  /** App-defined BCP-47 locale tag, not backed by a lookup table. See LanguageCode in @main/i18next for the current valid set. Personal UI language override; NULL means no override, fall back to the organization default. */
  language?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "user_profiles" */
export type User_Profiles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Profiles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Profiles_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** App-defined BCP-47 locale tag, not backed by a lookup table. See LanguageCode in @main/i18next for the current valid set. Personal UI language override; NULL means no override, fall back to the organization default. */
  language?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_profiles" */
export enum User_Profiles_Update_Column {
  /** column name */
  Language = 'language',
}

export type User_Profiles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Profiles_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Profiles_Bool_Exp;
};

export enum User_Register_Sources_Enum {
  /** existing user joined when invited to a new org/sub org */
  ExistingUserInvite = 'existing_user_invite',
  /** user joined via creating password */
  Password = 'password',
  /** user joined via saml just in time */
  SamlJit = 'saml_jit',
  /** user joined via scim provisioning */
  Scim = 'scim',
  /** user created as a service account */
  ServiceAccount = 'service_account',
}

/** Boolean expression to compare columns of type "user_register_sources_enum". All fields are combined with logical 'AND'. */
export type User_Register_Sources_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Register_Sources_Enum>;
  _in?: InputMaybe<Array<User_Register_Sources_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<User_Register_Sources_Enum>;
  _nin?: InputMaybe<Array<User_Register_Sources_Enum>>;
};

export type User_Roles = {
  __typename?: 'user_roles';
  role: Scalars['UserRole']['output'];
};

/** columns and relationships of "user_tasks_stats_view" */
export type User_Tasks_Stats_View = {
  __typename?: 'user_tasks_stats_view';
  completed_tasks_count?: Maybe<Scalars['Int']['output']>;
  completed_tasks_ratio?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  tasks_count?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "user_tasks_stats_view". All fields are combined with a logical 'AND'. */
export type User_Tasks_Stats_View_Bool_Exp = {
  _and?: InputMaybe<Array<User_Tasks_Stats_View_Bool_Exp>>;
  _not?: InputMaybe<User_Tasks_Stats_View_Bool_Exp>;
  _or?: InputMaybe<Array<User_Tasks_Stats_View_Bool_Exp>>;
  completed_tasks_count?: InputMaybe<Int_Comparison_Exp>;
  completed_tasks_ratio?: InputMaybe<Float8_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  tasks_count?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "user_tasks_stats_view". */
export type User_Tasks_Stats_View_Order_By = {
  completed_tasks_count?: InputMaybe<Order_By>;
  completed_tasks_ratio?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  tasks_count?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "user_tasks_stats_view" */
export enum User_Tasks_Stats_View_Select_Column {
  /** column name */
  CompletedTasksCount = 'completed_tasks_count',
  /** column name */
  CompletedTasksRatio = 'completed_tasks_ratio',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  TasksCount = 'tasks_count',
  /** column name */
  UserId = 'user_id',
}

/** Streaming cursor of the table "user_tasks_stats_view" */
export type User_Tasks_Stats_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Tasks_Stats_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Tasks_Stats_View_Stream_Cursor_Value_Input = {
  completed_tasks_count?: InputMaybe<Scalars['Int']['input']>;
  completed_tasks_ratio?: InputMaybe<Scalars['float8']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  tasks_count?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type Users = {
  __typename?: 'users';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl: Scalars['String']['output'];
  /** An array relationship */
  client_questionnaire_answers: Array<Client_Questionnaire_Answers>;
  /** An array relationship */
  client_questionnaires: Array<Client_Questionnaires>;
  /** An array relationship */
  control_owners: Array<Control_Owners>;
  /** An array relationship */
  controls_history_stats: Array<Controls_History_Stats>;
  createdAt: Scalars['timestamptz']['output'];
  defaultRole: Scalars['UserRole']['output'];
  disabled: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['citext']['output']>;
  /** An array relationship */
  evidence_acls: Array<Evidence_Acl>;
  /** An array relationship */
  evidence_owners: Array<Evidence_Owners>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  invitations: Array<Invitations>;
  /** Indicates if user has ever joined any organization via SSO registration (saml_jit or scim) - maintained by triggers */
  joined_with_sso: Scalars['Boolean']['output'];
  metadata: Scalars['UserMetaData']['output'];
  /** An array relationship */
  notification_disabled_settings: Array<Notification_Disabled_Settings>;
  /** An array relationship */
  oauth_grants: Array<Oauth_Organization_Grants>;
  /** An array relationship */
  organization_users: Array<Organization_Users>;
  /** Explicitly disable password authentication for this user (admin controlled) */
  password_disabled: Scalars['Boolean']['output'];
  /** An array relationship */
  policy_acknowledgement_users: Array<Policy_Acknowledgement_Users>;
  /** An aggregate relationship */
  policy_acknowledgement_users_aggregate: Policy_Acknowledgement_Users_Aggregate;
  /** An array relationship */
  policy_acknowledgements: Array<Policy_Acknowledgements>;
  /** An array relationship */
  policy_approval_users: Array<Policy_Approval_Users>;
  /** An aggregate relationship */
  policy_approval_users_aggregate: Policy_Approval_Users_Aggregate;
  /** An array relationship */
  policy_approvals: Array<Policy_Approvals>;
  /** An array relationship */
  policy_approvers: Array<Policy_Approvers>;
  /** An array relationship */
  policy_owners: Array<Policy_Owners>;
  /** An array relationship */
  policy_versions: Array<Policy_Versions>;
  /**
   * Hard boundary between human users and non-interactive service accounts.
   *    Service accounts cannot log in, cannot receive tokens, cannot set passwords,
   *    and cannot be invited to other orgs. Enforced in hasura-auth webhooks and
   *    workload action handlers.
   */
  principalType: AuthPrincipalTypes_Enum;
  /** An array relationship */
  questionnaires: Array<Questionnaires>;
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>;
  /** An array relationship */
  reports: Array<Reports>;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** An array relationship */
  task_owners: Array<Task_Owners>;
  /** An array relationship */
  team_members: Array<Team_Members>;
  /** An aggregate relationship */
  team_members_aggregate: Team_Members_Aggregate;
  /** An array relationship */
  trust_access_requester: Array<Trust_Portal_Access_Requests>;
  /** An array relationship */
  user_notifications: Array<User_Notifications>;
  /** An aggregate relationship */
  user_notifications_aggregate: User_Notifications_Aggregate;
  /** An object relationship */
  user_profile?: Maybe<User_Profiles>;
  /** An array relationship */
  users_comments: Array<Comments>;
  /** An array relationship */
  vendor_owners: Array<Vendor_Owners>;
  /** An array relationship */
  vendor_questionnaires_sent_by: Array<Vendor_Questionnaires>;
  /** An array relationship */
  vendor_questionnaires_sent_to: Array<Vendor_Questionnaires>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersClient_Questionnaire_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Client_Questionnaire_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Questionnaire_Answers_Order_By>>;
  where?: InputMaybe<Client_Questionnaire_Answers_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersClient_QuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Client_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Questionnaires_Order_By>>;
  where?: InputMaybe<Client_Questionnaires_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersControl_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Control_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Owners_Order_By>>;
  where?: InputMaybe<Control_Owners_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersControls_History_StatsArgs = {
  distinct_on?: InputMaybe<Array<Controls_History_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Controls_History_Stats_Order_By>>;
  where?: InputMaybe<Controls_History_Stats_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersEvidence_AclsArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Acl_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Acl_Order_By>>;
  where?: InputMaybe<Evidence_Acl_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersEvidence_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Evidence_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evidence_Owners_Order_By>>;
  where?: InputMaybe<Evidence_Owners_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersNotification_Disabled_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Notification_Disabled_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Disabled_Settings_Order_By>>;
  where?: InputMaybe<Notification_Disabled_Settings_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersOauth_GrantsArgs = {
  distinct_on?: InputMaybe<Array<Oauth_Organization_Grants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oauth_Organization_Grants_Order_By>>;
  where?: InputMaybe<Oauth_Organization_Grants_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersOrganization_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Users_Order_By>>;
  where?: InputMaybe<Organization_Users_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersPolicy_Acknowledgement_UsersArgs = {
  distinct_on?: InputMaybe<Array<Policy_Acknowledgement_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Acknowledgement_Users_Order_By>>;
  where?: InputMaybe<Policy_Acknowledgement_Users_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersPolicy_Acknowledgement_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Policy_Acknowledgement_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Acknowledgement_Users_Order_By>>;
  where?: InputMaybe<Policy_Acknowledgement_Users_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersPolicy_AcknowledgementsArgs = {
  distinct_on?: InputMaybe<Array<Policy_Acknowledgements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Acknowledgements_Order_By>>;
  where?: InputMaybe<Policy_Acknowledgements_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersPolicy_Approval_UsersArgs = {
  distinct_on?: InputMaybe<Array<Policy_Approval_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Approval_Users_Order_By>>;
  where?: InputMaybe<Policy_Approval_Users_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersPolicy_Approval_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Policy_Approval_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Approval_Users_Order_By>>;
  where?: InputMaybe<Policy_Approval_Users_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersPolicy_ApprovalsArgs = {
  distinct_on?: InputMaybe<Array<Policy_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Approvals_Order_By>>;
  where?: InputMaybe<Policy_Approvals_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersPolicy_ApproversArgs = {
  distinct_on?: InputMaybe<Array<Policy_Approvers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Approvers_Order_By>>;
  where?: InputMaybe<Policy_Approvers_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersPolicy_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Policy_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Owners_Order_By>>;
  where?: InputMaybe<Policy_Owners_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersPolicy_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Policy_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Policy_Versions_Order_By>>;
  where?: InputMaybe<Policy_Versions_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersQuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaires_Order_By>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersTask_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Task_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Owners_Order_By>>;
  where?: InputMaybe<Task_Owners_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersTeam_MembersArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersTeam_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersTrust_Access_RequesterArgs = {
  distinct_on?: InputMaybe<Array<Trust_Portal_Access_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trust_Portal_Access_Requests_Order_By>>;
  where?: InputMaybe<Trust_Portal_Access_Requests_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUser_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUser_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUsers_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersVendor_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Owners_Order_By>>;
  where?: InputMaybe<Vendor_Owners_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersVendor_Questionnaires_Sent_ByArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaires_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersVendor_Questionnaires_Sent_ToArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaires_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  metadata?: InputMaybe<Scalars['UserMetaData']['input']>;
};

/** Boolean expression to filter rows from the table "auth.users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  activeMfaType?: InputMaybe<String_Comparison_Exp>;
  avatarUrl?: InputMaybe<String_Comparison_Exp>;
  client_questionnaire_answers?: InputMaybe<Client_Questionnaire_Answers_Bool_Exp>;
  client_questionnaires?: InputMaybe<Client_Questionnaires_Bool_Exp>;
  control_owners?: InputMaybe<Control_Owners_Bool_Exp>;
  controls_history_stats?: InputMaybe<Controls_History_Stats_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  evidence_acls?: InputMaybe<Evidence_Acl_Bool_Exp>;
  evidence_owners?: InputMaybe<Evidence_Owners_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invitations?: InputMaybe<Invitations_Bool_Exp>;
  joined_with_sso?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  notification_disabled_settings?: InputMaybe<Notification_Disabled_Settings_Bool_Exp>;
  oauth_grants?: InputMaybe<Oauth_Organization_Grants_Bool_Exp>;
  organization_users?: InputMaybe<Organization_Users_Bool_Exp>;
  password_disabled?: InputMaybe<Boolean_Comparison_Exp>;
  policy_acknowledgement_users?: InputMaybe<Policy_Acknowledgement_Users_Bool_Exp>;
  policy_acknowledgement_users_aggregate?: InputMaybe<Policy_Acknowledgement_Users_Aggregate_Bool_Exp>;
  policy_acknowledgements?: InputMaybe<Policy_Acknowledgements_Bool_Exp>;
  policy_approval_users?: InputMaybe<Policy_Approval_Users_Bool_Exp>;
  policy_approval_users_aggregate?: InputMaybe<Policy_Approval_Users_Aggregate_Bool_Exp>;
  policy_approvals?: InputMaybe<Policy_Approvals_Bool_Exp>;
  policy_approvers?: InputMaybe<Policy_Approvers_Bool_Exp>;
  policy_owners?: InputMaybe<Policy_Owners_Bool_Exp>;
  policy_versions?: InputMaybe<Policy_Versions_Bool_Exp>;
  principalType?: InputMaybe<AuthPrincipalTypes_Enum_Comparison_Exp>;
  questionnaires?: InputMaybe<Questionnaires_Bool_Exp>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  reports?: InputMaybe<Reports_Bool_Exp>;
  reviews?: InputMaybe<Reviews_Bool_Exp>;
  task_owners?: InputMaybe<Task_Owners_Bool_Exp>;
  team_members?: InputMaybe<Team_Members_Bool_Exp>;
  team_members_aggregate?: InputMaybe<Team_Members_Aggregate_Bool_Exp>;
  trust_access_requester?: InputMaybe<Trust_Portal_Access_Requests_Bool_Exp>;
  user_notifications?: InputMaybe<User_Notifications_Bool_Exp>;
  user_notifications_aggregate?: InputMaybe<User_Notifications_Aggregate_Bool_Exp>;
  user_profile?: InputMaybe<User_Profiles_Bool_Exp>;
  users_comments?: InputMaybe<Comments_Bool_Exp>;
  vendor_owners?: InputMaybe<Vendor_Owners_Bool_Exp>;
  vendor_questionnaires_sent_by?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
  vendor_questionnaires_sent_to?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "auth.users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** Ordering options when selecting data from "auth.users". */
export type Users_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  client_questionnaire_answers_aggregate?: InputMaybe<Client_Questionnaire_Answers_Aggregate_Order_By>;
  client_questionnaires_aggregate?: InputMaybe<Client_Questionnaires_Aggregate_Order_By>;
  control_owners_aggregate?: InputMaybe<Control_Owners_Aggregate_Order_By>;
  controls_history_stats_aggregate?: InputMaybe<Controls_History_Stats_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  evidence_acls_aggregate?: InputMaybe<Evidence_Acl_Aggregate_Order_By>;
  evidence_owners_aggregate?: InputMaybe<Evidence_Owners_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  invitations_aggregate?: InputMaybe<Invitations_Aggregate_Order_By>;
  joined_with_sso?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  notification_disabled_settings_aggregate?: InputMaybe<Notification_Disabled_Settings_Aggregate_Order_By>;
  oauth_grants_aggregate?: InputMaybe<Oauth_Organization_Grants_Aggregate_Order_By>;
  organization_users_aggregate?: InputMaybe<Organization_Users_Aggregate_Order_By>;
  password_disabled?: InputMaybe<Order_By>;
  policy_acknowledgement_users_aggregate?: InputMaybe<Policy_Acknowledgement_Users_Aggregate_Order_By>;
  policy_acknowledgements_aggregate?: InputMaybe<Policy_Acknowledgements_Aggregate_Order_By>;
  policy_approval_users_aggregate?: InputMaybe<Policy_Approval_Users_Aggregate_Order_By>;
  policy_approvals_aggregate?: InputMaybe<Policy_Approvals_Aggregate_Order_By>;
  policy_approvers_aggregate?: InputMaybe<Policy_Approvers_Aggregate_Order_By>;
  policy_owners_aggregate?: InputMaybe<Policy_Owners_Aggregate_Order_By>;
  policy_versions_aggregate?: InputMaybe<Policy_Versions_Aggregate_Order_By>;
  principalType?: InputMaybe<Order_By>;
  questionnaires_aggregate?: InputMaybe<Questionnaires_Aggregate_Order_By>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By>;
  reports_aggregate?: InputMaybe<Reports_Aggregate_Order_By>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Order_By>;
  task_owners_aggregate?: InputMaybe<Task_Owners_Aggregate_Order_By>;
  team_members_aggregate?: InputMaybe<Team_Members_Aggregate_Order_By>;
  trust_access_requester_aggregate?: InputMaybe<Trust_Portal_Access_Requests_Aggregate_Order_By>;
  user_notifications_aggregate?: InputMaybe<User_Notifications_Aggregate_Order_By>;
  user_profile?: InputMaybe<User_Profiles_Order_By>;
  users_comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  vendor_owners_aggregate?: InputMaybe<Vendor_Owners_Aggregate_Order_By>;
  vendor_questionnaires_sent_by_aggregate?: InputMaybe<Vendor_Questionnaires_Aggregate_Order_By>;
  vendor_questionnaires_sent_to_aggregate?: InputMaybe<Vendor_Questionnaires_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.users" */
export enum Users_Select_Column {
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  JoinedWithSso = 'joined_with_sso',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PasswordDisabled = 'password_disabled',
  /** column name */
  PrincipalType = 'principalType',
}

/** input type for updating data in table "auth.users" */
export type Users_Set_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Indicates if user has ever joined any organization via SSO registration (saml_jit or scim) - maintained by triggers */
  joined_with_sso?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  /** Explicitly disable password authentication for this user (admin controlled) */
  password_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Hard boundary between human users and non-interactive service accounts.
   *    Service accounts cannot log in, cannot receive tokens, cannot set passwords,
   *    and cannot be invited to other orgs. Enforced in hasura-auth webhooks and
   *    workload action handlers.
   */
  principalType?: InputMaybe<AuthPrincipalTypes_Enum>;
};

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Boolean expression to compare columns of type "vector". All fields are combined with logical 'AND'. */
export type Vector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['vector']['input']>;
  _gt?: InputMaybe<Scalars['vector']['input']>;
  _gte?: InputMaybe<Scalars['vector']['input']>;
  _in?: InputMaybe<Array<Scalars['vector']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['vector']['input']>;
  _lte?: InputMaybe<Scalars['vector']['input']>;
  _neq?: InputMaybe<Scalars['vector']['input']>;
  _nin?: InputMaybe<Array<Scalars['vector']['input']>>;
};

/** columns and relationships of "vendor_approval_files" */
export type Vendor_Approval_Files = {
  __typename?: 'vendor_approval_files';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  vendor_approval: Vendor_Approvals;
  vendor_approval_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "vendor_approval_files" */
export type Vendor_Approval_Files_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Approval_Files_Max_Order_By>;
  min?: InputMaybe<Vendor_Approval_Files_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vendor_approval_files" */
export type Vendor_Approval_Files_Arr_Rel_Insert_Input = {
  data: Array<Vendor_Approval_Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_Approval_Files_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vendor_approval_files". All fields are combined with a logical 'AND'. */
export type Vendor_Approval_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Approval_Files_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Approval_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Approval_Files_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_approval?: InputMaybe<Vendor_Approvals_Bool_Exp>;
  vendor_approval_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_approval_files" */
export enum Vendor_Approval_Files_Constraint {
  /** unique or primary key constraint on columns "file_id" */
  VendorApprovalFilesFileIdKey = 'vendor_approval_files_file_id_key',
  /** unique or primary key constraint on columns "id" */
  VendorApprovalFilesPkey = 'vendor_approval_files_pkey',
}

/** input type for inserting data into table "vendor_approval_files" */
export type Vendor_Approval_Files_Insert_Input = {
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_approval?: InputMaybe<Vendor_Approvals_Obj_Rel_Insert_Input>;
  vendor_approval_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "vendor_approval_files" */
export type Vendor_Approval_Files_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vendor_approval_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendor_approval_files" */
export type Vendor_Approval_Files_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vendor_approval_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendor_approval_files" */
export type Vendor_Approval_Files_Mutation_Response = {
  __typename?: 'vendor_approval_files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Approval_Files>;
};

/** on_conflict condition type for table "vendor_approval_files" */
export type Vendor_Approval_Files_On_Conflict = {
  constraint: Vendor_Approval_Files_Constraint;
  update_columns?: Array<Vendor_Approval_Files_Update_Column>;
  where?: InputMaybe<Vendor_Approval_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_approval_files". */
export type Vendor_Approval_Files_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vendor_approval?: InputMaybe<Vendor_Approvals_Order_By>;
  vendor_approval_id?: InputMaybe<Order_By>;
};

/** select columns of table "vendor_approval_files" */
export enum Vendor_Approval_Files_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  VendorApprovalId = 'vendor_approval_id',
}

/** placeholder for update columns of table "vendor_approval_files" (current role has no relevant permissions) */
export enum Vendor_Approval_Files_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

export enum Vendor_Approval_Reasons_Enum {
  InitialApproval = 'Initial_approval',
  Other = 'Other',
  ReassessmentApproval = 'Reassessment_approval',
}

/** Boolean expression to compare columns of type "vendor_approval_reasons_enum". All fields are combined with logical 'AND'. */
export type Vendor_Approval_Reasons_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Vendor_Approval_Reasons_Enum>;
  _in?: InputMaybe<Array<Vendor_Approval_Reasons_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Vendor_Approval_Reasons_Enum>;
  _nin?: InputMaybe<Array<Vendor_Approval_Reasons_Enum>>;
};

export enum Vendor_Approval_Statuses_Enum {
  Approved = 'Approved',
  AwaitingApproval = 'Awaiting_approval',
  DueSoon = 'Due_soon',
  Expiring = 'Expiring',
  NeedMoreInformation = 'Need_more_information',
  Outdated = 'Outdated',
  Overdue = 'Overdue',
  TentativelyApproved = 'Tentatively_approved',
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected',
}

/** Boolean expression to compare columns of type "vendor_approval_statuses_enum". All fields are combined with logical 'AND'. */
export type Vendor_Approval_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Vendor_Approval_Statuses_Enum>;
  _in?: InputMaybe<Array<Vendor_Approval_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Vendor_Approval_Statuses_Enum>;
  _nin?: InputMaybe<Array<Vendor_Approval_Statuses_Enum>>;
};

/** Approval requests for vendors */
export type Vendor_Approvals = {
  __typename?: 'vendor_approvals';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reason: Vendor_Approval_Reasons_Enum;
  /** If true, all approvers must respond. If false, only one approver needs to approve. */
  require_all_approvers: Scalars['Boolean']['output'];
  status: Vendor_Approval_Statuses_Enum;
  subject: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  vendor: Vendors;
  /** An array relationship */
  vendor_approval_files: Array<Vendor_Approval_Files>;
  /** An array relationship */
  vendor_approvers: Array<Vendor_Approvers>;
  /** An aggregate relationship */
  vendor_approvers_aggregate: Vendor_Approvers_Aggregate;
  vendor_id: Scalars['uuid']['output'];
};

/** Approval requests for vendors */
export type Vendor_ApprovalsVendor_Approval_FilesArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Approval_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Approval_Files_Order_By>>;
  where?: InputMaybe<Vendor_Approval_Files_Bool_Exp>;
};

/** Approval requests for vendors */
export type Vendor_ApprovalsVendor_ApproversArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Approvers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Approvers_Order_By>>;
  where?: InputMaybe<Vendor_Approvers_Bool_Exp>;
};

/** Approval requests for vendors */
export type Vendor_ApprovalsVendor_Approvers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Approvers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Approvers_Order_By>>;
  where?: InputMaybe<Vendor_Approvers_Bool_Exp>;
};

/** aggregated selection of "vendor_approvals" */
export type Vendor_Approvals_Aggregate = {
  __typename?: 'vendor_approvals_aggregate';
  aggregate?: Maybe<Vendor_Approvals_Aggregate_Fields>;
  nodes: Array<Vendor_Approvals>;
};

export type Vendor_Approvals_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vendor_Approvals_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vendor_Approvals_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vendor_Approvals_Aggregate_Bool_Exp_Count>;
};

export type Vendor_Approvals_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vendor_Approvals_Select_Column_Vendor_Approvals_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendor_Approvals_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vendor_Approvals_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vendor_Approvals_Select_Column_Vendor_Approvals_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendor_Approvals_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vendor_Approvals_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vendor_Approvals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendor_Approvals_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vendor_approvals" */
export type Vendor_Approvals_Aggregate_Fields = {
  __typename?: 'vendor_approvals_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vendor_Approvals_Max_Fields>;
  min?: Maybe<Vendor_Approvals_Min_Fields>;
};

/** aggregate fields of "vendor_approvals" */
export type Vendor_Approvals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vendor_Approvals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vendor_approvals" */
export type Vendor_Approvals_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Approvals_Max_Order_By>;
  min?: InputMaybe<Vendor_Approvals_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vendor_approvals" */
export type Vendor_Approvals_Arr_Rel_Insert_Input = {
  data: Array<Vendor_Approvals_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_Approvals_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vendor_approvals". All fields are combined with a logical 'AND'. */
export type Vendor_Approvals_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Approvals_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Approvals_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Approvals_Bool_Exp>>;
  approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiry_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  reason?: InputMaybe<Vendor_Approval_Reasons_Enum_Comparison_Exp>;
  require_all_approvers?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<Vendor_Approval_Statuses_Enum_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_approval_files?: InputMaybe<Vendor_Approval_Files_Bool_Exp>;
  vendor_approvers?: InputMaybe<Vendor_Approvers_Bool_Exp>;
  vendor_approvers_aggregate?: InputMaybe<Vendor_Approvers_Aggregate_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_approvals" */
export enum Vendor_Approvals_Constraint {
  /** unique or primary key constraint on columns "id" */
  VendorApprovalsPkey = 'vendor_approvals_pkey',
}

/** input type for inserting data into table "vendor_approvals" */
export type Vendor_Approvals_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Vendor_Approval_Reasons_Enum>;
  /** If true, all approvers must respond. If false, only one approver needs to approve. */
  require_all_approvers?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Vendors_Obj_Rel_Insert_Input>;
  vendor_approval_files?: InputMaybe<Vendor_Approval_Files_Arr_Rel_Insert_Input>;
  vendor_approvers?: InputMaybe<Vendor_Approvers_Arr_Rel_Insert_Input>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vendor_Approvals_Max_Fields = {
  __typename?: 'vendor_approvals_max_fields';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vendor_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vendor_approvals" */
export type Vendor_Approvals_Max_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vendor_Approvals_Min_Fields = {
  __typename?: 'vendor_approvals_min_fields';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vendor_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vendor_approvals" */
export type Vendor_Approvals_Min_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendor_approvals" */
export type Vendor_Approvals_Mutation_Response = {
  __typename?: 'vendor_approvals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Approvals>;
};

/** input type for inserting object relation for remote table "vendor_approvals" */
export type Vendor_Approvals_Obj_Rel_Insert_Input = {
  data: Vendor_Approvals_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_Approvals_On_Conflict>;
};

/** on_conflict condition type for table "vendor_approvals" */
export type Vendor_Approvals_On_Conflict = {
  constraint: Vendor_Approvals_Constraint;
  update_columns?: Array<Vendor_Approvals_Update_Column>;
  where?: InputMaybe<Vendor_Approvals_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_approvals". */
export type Vendor_Approvals_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  require_all_approvers?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_approval_files_aggregate?: InputMaybe<Vendor_Approval_Files_Aggregate_Order_By>;
  vendor_approvers_aggregate?: InputMaybe<Vendor_Approvers_Aggregate_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vendor_approvals */
export type Vendor_Approvals_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vendor_approvals" */
export enum Vendor_Approvals_Select_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Name = 'name',
  /** column name */
  Reason = 'reason',
  /** column name */
  RequireAllApprovers = 'require_all_approvers',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorId = 'vendor_id',
}

/** select "vendor_approvals_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vendor_approvals" */
export enum Vendor_Approvals_Select_Column_Vendor_Approvals_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  RequireAllApprovers = 'require_all_approvers',
}

/** select "vendor_approvals_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vendor_approvals" */
export enum Vendor_Approvals_Select_Column_Vendor_Approvals_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  RequireAllApprovers = 'require_all_approvers',
}

/** input type for updating data in table "vendor_approvals" */
export type Vendor_Approvals_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Vendor_Approval_Reasons_Enum>;
  /** If true, all approvers must respond. If false, only one approver needs to approve. */
  require_all_approvers?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "vendor_approvals" */
export enum Vendor_Approvals_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Message = 'message',
  /** column name */
  Name = 'name',
  /** column name */
  Reason = 'reason',
  /** column name */
  RequireAllApprovers = 'require_all_approvers',
  /** column name */
  Subject = 'subject',
}

export type Vendor_Approvals_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vendor_Approvals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vendor_Approvals_Bool_Exp;
};

export enum Vendor_Approver_Responses_Enum {
  Approved = 'Approved',
  DueSoon = 'Due_soon',
  NeedMoreInformation = 'Need_more_information',
  Overdue = 'Overdue',
  Pending = 'Pending',
  Rejected = 'Rejected',
  TentativelyApproved = 'Tentatively_approved',
  Withdrawn = 'Withdrawn',
}

/** Boolean expression to compare columns of type "vendor_approver_responses_enum". All fields are combined with logical 'AND'. */
export type Vendor_Approver_Responses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Vendor_Approver_Responses_Enum>;
  _in?: InputMaybe<Array<Vendor_Approver_Responses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Vendor_Approver_Responses_Enum>;
  _nin?: InputMaybe<Array<Vendor_Approver_Responses_Enum>>;
};

/** Individual approvers for vendor approval requests */
export type Vendor_Approvers = {
  __typename?: 'vendor_approvers';
  /** Optional comment from the approver */
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  responded_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The approver's response: Pending, Approved, Rejected, etc. */
  response?: Maybe<Vendor_Approver_Responses_Enum>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  /** An object relationship */
  vendor_approval: Vendor_Approvals;
  vendor_approval_id: Scalars['uuid']['output'];
};

/** aggregated selection of "vendor_approvers" */
export type Vendor_Approvers_Aggregate = {
  __typename?: 'vendor_approvers_aggregate';
  aggregate?: Maybe<Vendor_Approvers_Aggregate_Fields>;
  nodes: Array<Vendor_Approvers>;
};

export type Vendor_Approvers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vendor_Approvers_Aggregate_Bool_Exp_Count>;
};

export type Vendor_Approvers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vendor_Approvers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendor_Approvers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vendor_approvers" */
export type Vendor_Approvers_Aggregate_Fields = {
  __typename?: 'vendor_approvers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vendor_Approvers_Max_Fields>;
  min?: Maybe<Vendor_Approvers_Min_Fields>;
};

/** aggregate fields of "vendor_approvers" */
export type Vendor_Approvers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vendor_Approvers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vendor_approvers" */
export type Vendor_Approvers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Approvers_Max_Order_By>;
  min?: InputMaybe<Vendor_Approvers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vendor_approvers" */
export type Vendor_Approvers_Arr_Rel_Insert_Input = {
  data: Array<Vendor_Approvers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_Approvers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vendor_approvers". All fields are combined with a logical 'AND'. */
export type Vendor_Approvers_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Approvers_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Approvers_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Approvers_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_nudged_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  responded_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  response?: InputMaybe<Vendor_Approver_Responses_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_approval?: InputMaybe<Vendor_Approvals_Bool_Exp>;
  vendor_approval_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_approvers" */
export enum Vendor_Approvers_Constraint {
  /** unique or primary key constraint on columns "id" */
  VendorApproversPkey = 'vendor_approvers_pkey',
  /** unique or primary key constraint on columns "user_id", "vendor_approval_id" */
  VendorApproversVendorApprovalIdUserIdKey = 'vendor_approvers_vendor_approval_id_user_id_key',
}

/** input type for inserting data into table "vendor_approvers" */
export type Vendor_Approvers_Insert_Input = {
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_approval?: InputMaybe<Vendor_Approvals_Obj_Rel_Insert_Input>;
  vendor_approval_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vendor_Approvers_Max_Fields = {
  __typename?: 'vendor_approvers_max_fields';
  /** Optional comment from the approver */
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  responded_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  vendor_approval_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vendor_approvers" */
export type Vendor_Approvers_Max_Order_By = {
  /** Optional comment from the approver */
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  responded_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vendor_approval_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vendor_Approvers_Min_Fields = {
  __typename?: 'vendor_approvers_min_fields';
  /** Optional comment from the approver */
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  responded_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  vendor_approval_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vendor_approvers" */
export type Vendor_Approvers_Min_Order_By = {
  /** Optional comment from the approver */
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  responded_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vendor_approval_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendor_approvers" */
export type Vendor_Approvers_Mutation_Response = {
  __typename?: 'vendor_approvers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Approvers>;
};

/** on_conflict condition type for table "vendor_approvers" */
export type Vendor_Approvers_On_Conflict = {
  constraint: Vendor_Approvers_Constraint;
  update_columns?: Array<Vendor_Approvers_Update_Column>;
  where?: InputMaybe<Vendor_Approvers_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_approvers". */
export type Vendor_Approvers_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  responded_at?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  vendor_approval?: InputMaybe<Vendor_Approvals_Order_By>;
  vendor_approval_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vendor_approvers */
export type Vendor_Approvers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vendor_approvers" */
export enum Vendor_Approvers_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastNudgedAt = 'last_nudged_at',
  /** column name */
  RespondedAt = 'responded_at',
  /** column name */
  Response = 'response',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VendorApprovalId = 'vendor_approval_id',
}

/** input type for updating data in table "vendor_approvers" */
export type Vendor_Approvers_Set_Input = {
  /** Optional comment from the approver */
  comment?: InputMaybe<Scalars['String']['input']>;
  responded_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The approver's response: Pending, Approved, Rejected, etc. */
  response?: InputMaybe<Vendor_Approver_Responses_Enum>;
};

/** update columns of table "vendor_approvers" */
export enum Vendor_Approvers_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  RespondedAt = 'responded_at',
  /** column name */
  Response = 'response',
}

export type Vendor_Approvers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vendor_Approvers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vendor_Approvers_Bool_Exp;
};

/** columns and relationships of "vendor_documents" */
export type Vendor_Documents = {
  __typename?: 'vendor_documents';
  /** An object relationship */
  file?: Maybe<Files>;
  file_id: Scalars['uuid']['output'];
  /** An object relationship */
  vendor?: Maybe<Vendors>;
  vendor_id: Scalars['uuid']['output'];
  /** An object relationship */
  vq_form_upload?: Maybe<Vendor_Questionnaire_Form_Uploads>;
  vq_upload_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by aggregate values of table "vendor_documents" */
export type Vendor_Documents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Documents_Max_Order_By>;
  min?: InputMaybe<Vendor_Documents_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vendor_documents" */
export type Vendor_Documents_Arr_Rel_Insert_Input = {
  data: Array<Vendor_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_Documents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vendor_documents". All fields are combined with a logical 'AND'. */
export type Vendor_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Documents_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Documents_Bool_Exp>>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
  vq_form_upload?: InputMaybe<Vendor_Questionnaire_Form_Uploads_Bool_Exp>;
  vq_upload_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_documents" */
export enum Vendor_Documents_Constraint {
  /** unique or primary key constraint on columns "file_id" */
  VendorDocumentsFileIdKey = 'vendor_documents_file_id_key',
  /** unique or primary key constraint on columns "vendor_id", "file_id" */
  VendorDocumentsPkey = 'vendor_documents_pkey',
}

/** input type for inserting data into table "vendor_documents" */
export type Vendor_Documents_Insert_Input = {
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor?: InputMaybe<Vendors_Obj_Rel_Insert_Input>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
  vq_upload_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "vendor_documents" */
export type Vendor_Documents_Max_Order_By = {
  file_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vq_upload_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendor_documents" */
export type Vendor_Documents_Min_Order_By = {
  file_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vq_upload_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendor_documents" */
export type Vendor_Documents_Mutation_Response = {
  __typename?: 'vendor_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Documents>;
};

/** input type for inserting object relation for remote table "vendor_documents" */
export type Vendor_Documents_Obj_Rel_Insert_Input = {
  data: Vendor_Documents_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_Documents_On_Conflict>;
};

/** on_conflict condition type for table "vendor_documents" */
export type Vendor_Documents_On_Conflict = {
  constraint: Vendor_Documents_Constraint;
  update_columns?: Array<Vendor_Documents_Update_Column>;
  where?: InputMaybe<Vendor_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_documents". */
export type Vendor_Documents_Order_By = {
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vq_form_upload?: InputMaybe<Vendor_Questionnaire_Form_Uploads_Order_By>;
  vq_upload_id?: InputMaybe<Order_By>;
};

/** select columns of table "vendor_documents" */
export enum Vendor_Documents_Select_Column {
  /** column name */
  FileId = 'file_id',
  /** column name */
  VendorId = 'vendor_id',
  /** column name */
  VqUploadId = 'vq_upload_id',
}

/** placeholder for update columns of table "vendor_documents" (current role has no relevant permissions) */
export enum Vendor_Documents_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** Set of relevant findings from humans and AI that need to be highlighted for vendors */
export type Vendor_Findings = {
  __typename?: 'vendor_findings';
  cause: Finding_Causes_Enum;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  manual_finding?: Maybe<Manual_Findings>;
  manual_finding_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  resolution?: Maybe<Finding_Resolutions>;
  /** An object relationship */
  risk?: Maybe<Risks>;
  risk_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  task?: Maybe<Tasks>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  type: Finding_Types_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor: Vendors;
  vendor_id: Scalars['uuid']['output'];
  /** An object relationship */
  vendor_questionnaire?: Maybe<Vendor_Questionnaires>;
  /** An object relationship */
  vendor_questionnaire_ai_review_assessment?: Maybe<Vendor_Questionnaire_Ai_Review_Assessments>;
  vendor_questionnaire_ai_review_assessment_id?: Maybe<Scalars['uuid']['output']>;
  vendor_questionnaire_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by aggregate values of table "vendor_findings" */
export type Vendor_Findings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Findings_Max_Order_By>;
  min?: InputMaybe<Vendor_Findings_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "vendor_findings". All fields are combined with a logical 'AND'. */
export type Vendor_Findings_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Findings_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Findings_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Findings_Bool_Exp>>;
  cause?: InputMaybe<Finding_Causes_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  manual_finding?: InputMaybe<Manual_Findings_Bool_Exp>;
  manual_finding_id?: InputMaybe<Uuid_Comparison_Exp>;
  resolution?: InputMaybe<Finding_Resolutions_Bool_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Finding_Types_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_questionnaire?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
  vendor_questionnaire_ai_review_assessment?: InputMaybe<Vendor_Questionnaire_Ai_Review_Assessments_Bool_Exp>;
  vendor_questionnaire_ai_review_assessment_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_questionnaire_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "vendor_findings" */
export type Vendor_Findings_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manual_finding_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_questionnaire_ai_review_assessment_id?: InputMaybe<Order_By>;
  vendor_questionnaire_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendor_findings" */
export type Vendor_Findings_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manual_finding_id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_questionnaire_ai_review_assessment_id?: InputMaybe<Order_By>;
  vendor_questionnaire_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendor_findings" */
export type Vendor_Findings_Mutation_Response = {
  __typename?: 'vendor_findings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Findings>;
};

/** Ordering options when selecting data from "vendor_findings". */
export type Vendor_Findings_Order_By = {
  cause?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manual_finding?: InputMaybe<Manual_Findings_Order_By>;
  manual_finding_id?: InputMaybe<Order_By>;
  resolution?: InputMaybe<Finding_Resolutions_Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risk_id?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_questionnaire?: InputMaybe<Vendor_Questionnaires_Order_By>;
  vendor_questionnaire_ai_review_assessment?: InputMaybe<Vendor_Questionnaire_Ai_Review_Assessments_Order_By>;
  vendor_questionnaire_ai_review_assessment_id?: InputMaybe<Order_By>;
  vendor_questionnaire_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vendor_findings */
export type Vendor_Findings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vendor_findings" */
export enum Vendor_Findings_Select_Column {
  /** column name */
  Cause = 'cause',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManualFindingId = 'manual_finding_id',
  /** column name */
  RiskId = 'risk_id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorId = 'vendor_id',
  /** column name */
  VendorQuestionnaireAiReviewAssessmentId = 'vendor_questionnaire_ai_review_assessment_id',
  /** column name */
  VendorQuestionnaireId = 'vendor_questionnaire_id',
}

/** input type for updating data in table "vendor_findings" */
export type Vendor_Findings_Set_Input = {
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Vendor_Findings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vendor_Findings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vendor_Findings_Bool_Exp;
};

/** users responsible for vendor */
export type Vendor_Owners = {
  __typename?: 'vendor_owners';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  owner_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  /** An object relationship */
  vendor: Vendors;
  vendor_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "vendor_owners" */
export type Vendor_Owners_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Owners_Max_Order_By>;
  min?: InputMaybe<Vendor_Owners_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vendor_owners" */
export type Vendor_Owners_Arr_Rel_Insert_Input = {
  data: Array<Vendor_Owners_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_Owners_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vendor_owners". All fields are combined with a logical 'AND'. */
export type Vendor_Owners_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Owners_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Owners_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Owners_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_owners" */
export enum Vendor_Owners_Constraint {
  /** unique or primary key constraint on columns "id" */
  VendorOwnersPkey = 'vendor_owners_pkey',
  /** unique or primary key constraint on columns "owner_id", "vendor_id" */
  VendorOwnersVendorIdOwnerIdKey = 'vendor_owners_vendor_id_owner_id_key',
}

/** input type for inserting data into table "vendor_owners" */
export type Vendor_Owners_Insert_Input = {
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor?: InputMaybe<Vendors_Obj_Rel_Insert_Input>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "vendor_owners" */
export type Vendor_Owners_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendor_owners" */
export type Vendor_Owners_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendor_owners" */
export type Vendor_Owners_Mutation_Response = {
  __typename?: 'vendor_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Owners>;
};

/** on_conflict condition type for table "vendor_owners" */
export type Vendor_Owners_On_Conflict = {
  constraint: Vendor_Owners_Constraint;
  update_columns?: Array<Vendor_Owners_Update_Column>;
  where?: InputMaybe<Vendor_Owners_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_owners". */
export type Vendor_Owners_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** select columns of table "vendor_owners" */
export enum Vendor_Owners_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  VendorId = 'vendor_id',
}

/** placeholder for update columns of table "vendor_owners" (current role has no relevant permissions) */
export enum Vendor_Owners_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** Assessments to individual questions based on AI Criteria */
export type Vendor_Questionnaire_Ai_Review_Assessments = {
  __typename?: 'vendor_questionnaire_ai_review_assessments';
  assessment: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  criteria: Scalars['String']['output'];
  criteria_heading: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  meets_criteria: Scalars['Boolean']['output'];
  /** An object relationship */
  vendor_finding?: Maybe<Vendor_Findings>;
  vendor_questionnaire_ai_review_run_id: Scalars['uuid']['output'];
  /** An object relationship */
  vendor_questionnaire_form_answer: Vendor_Questionnaire_Form_Answers;
  vendor_questionnaire_form_answer_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "vendor_questionnaire_ai_review_assessments" */
export type Vendor_Questionnaire_Ai_Review_Assessments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Questionnaire_Ai_Review_Assessments_Max_Order_By>;
  min?: InputMaybe<Vendor_Questionnaire_Ai_Review_Assessments_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "vendor_questionnaire_ai_review_assessments". All fields are combined with a logical 'AND'. */
export type Vendor_Questionnaire_Ai_Review_Assessments_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Questionnaire_Ai_Review_Assessments_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Questionnaire_Ai_Review_Assessments_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Questionnaire_Ai_Review_Assessments_Bool_Exp>>;
  assessment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  criteria?: InputMaybe<String_Comparison_Exp>;
  criteria_heading?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  meets_criteria?: InputMaybe<Boolean_Comparison_Exp>;
  vendor_finding?: InputMaybe<Vendor_Findings_Bool_Exp>;
  vendor_questionnaire_ai_review_run_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_questionnaire_form_answer?: InputMaybe<Vendor_Questionnaire_Form_Answers_Bool_Exp>;
  vendor_questionnaire_form_answer_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "vendor_questionnaire_ai_review_assessments" */
export type Vendor_Questionnaire_Ai_Review_Assessments_Max_Order_By = {
  assessment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  criteria?: InputMaybe<Order_By>;
  criteria_heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vendor_questionnaire_ai_review_run_id?: InputMaybe<Order_By>;
  vendor_questionnaire_form_answer_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendor_questionnaire_ai_review_assessments" */
export type Vendor_Questionnaire_Ai_Review_Assessments_Min_Order_By = {
  assessment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  criteria?: InputMaybe<Order_By>;
  criteria_heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vendor_questionnaire_ai_review_run_id?: InputMaybe<Order_By>;
  vendor_questionnaire_form_answer_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vendor_questionnaire_ai_review_assessments". */
export type Vendor_Questionnaire_Ai_Review_Assessments_Order_By = {
  assessment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  criteria?: InputMaybe<Order_By>;
  criteria_heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meets_criteria?: InputMaybe<Order_By>;
  vendor_finding?: InputMaybe<Vendor_Findings_Order_By>;
  vendor_questionnaire_ai_review_run_id?: InputMaybe<Order_By>;
  vendor_questionnaire_form_answer?: InputMaybe<Vendor_Questionnaire_Form_Answers_Order_By>;
  vendor_questionnaire_form_answer_id?: InputMaybe<Order_By>;
};

/** select columns of table "vendor_questionnaire_ai_review_assessments" */
export enum Vendor_Questionnaire_Ai_Review_Assessments_Select_Column {
  /** column name */
  Assessment = 'assessment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Criteria = 'criteria',
  /** column name */
  CriteriaHeading = 'criteria_heading',
  /** column name */
  Id = 'id',
  /** column name */
  MeetsCriteria = 'meets_criteria',
  /** column name */
  VendorQuestionnaireAiReviewRunId = 'vendor_questionnaire_ai_review_run_id',
  /** column name */
  VendorQuestionnaireFormAnswerId = 'vendor_questionnaire_form_answer_id',
}

export enum Vendor_Questionnaire_Form_Answer_Statuses_Enum {
  /** An answer which has been marked as completed */
  Completed = 'completed',
  /** An answer which may have data but not marked as completed yet */
  Pending = 'pending',
}

/** Boolean expression to compare columns of type "vendor_questionnaire_form_answer_statuses_enum". All fields are combined with logical 'AND'. */
export type Vendor_Questionnaire_Form_Answer_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Vendor_Questionnaire_Form_Answer_Statuses_Enum>;
  _in?: InputMaybe<Array<Vendor_Questionnaire_Form_Answer_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Vendor_Questionnaire_Form_Answer_Statuses_Enum>;
  _nin?: InputMaybe<Array<Vendor_Questionnaire_Form_Answer_Statuses_Enum>>;
};

/** columns and relationships of "vendor_questionnaire_form_answers" */
export type Vendor_Questionnaire_Form_Answers = {
  __typename?: 'vendor_questionnaire_form_answers';
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  field_name: Scalars['String']['output'];
  /** An object relationship */
  form: Vendor_Questionnaire_Forms;
  /** An array relationship */
  form_uploads: Array<Vendor_Questionnaire_Form_Uploads>;
  id: Scalars['uuid']['output'];
  status: Vendor_Questionnaire_Form_Answer_Statuses_Enum;
  updated_at: Scalars['timestamptz']['output'];
  value?: Maybe<Scalars['VendorQuestionnaireFormAnswerValue']['output']>;
  /** An array relationship */
  vendor_questionnaire_ai_review_assessments: Array<Vendor_Questionnaire_Ai_Review_Assessments>;
  vendor_questionnaire_form_id: Scalars['uuid']['output'];
};

/** columns and relationships of "vendor_questionnaire_form_answers" */
export type Vendor_Questionnaire_Form_AnswersForm_UploadsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaire_Form_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaire_Form_Uploads_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaire_Form_Uploads_Bool_Exp>;
};

/** columns and relationships of "vendor_questionnaire_form_answers" */
export type Vendor_Questionnaire_Form_AnswersValueArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "vendor_questionnaire_form_answers" */
export type Vendor_Questionnaire_Form_AnswersVendor_Questionnaire_Ai_Review_AssessmentsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaire_Ai_Review_Assessments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaire_Ai_Review_Assessments_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaire_Ai_Review_Assessments_Bool_Exp>;
};

/** order by aggregate values of table "vendor_questionnaire_form_answers" */
export type Vendor_Questionnaire_Form_Answers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Questionnaire_Form_Answers_Max_Order_By>;
  min?: InputMaybe<Vendor_Questionnaire_Form_Answers_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "vendor_questionnaire_form_answers". All fields are combined with a logical 'AND'. */
export type Vendor_Questionnaire_Form_Answers_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Questionnaire_Form_Answers_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Questionnaire_Form_Answers_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Questionnaire_Form_Answers_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  field_name?: InputMaybe<String_Comparison_Exp>;
  form?: InputMaybe<Vendor_Questionnaire_Forms_Bool_Exp>;
  form_uploads?: InputMaybe<Vendor_Questionnaire_Form_Uploads_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Vendor_Questionnaire_Form_Answer_Statuses_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
  vendor_questionnaire_ai_review_assessments?: InputMaybe<Vendor_Questionnaire_Ai_Review_Assessments_Bool_Exp>;
  vendor_questionnaire_form_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "vendor_questionnaire_form_answers" */
export type Vendor_Questionnaire_Form_Answers_Max_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  field_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_questionnaire_form_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendor_questionnaire_form_answers" */
export type Vendor_Questionnaire_Form_Answers_Min_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  field_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_questionnaire_form_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vendor_questionnaire_form_answers". */
export type Vendor_Questionnaire_Form_Answers_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  field_name?: InputMaybe<Order_By>;
  form?: InputMaybe<Vendor_Questionnaire_Forms_Order_By>;
  form_uploads_aggregate?: InputMaybe<Vendor_Questionnaire_Form_Uploads_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vendor_questionnaire_ai_review_assessments_aggregate?: InputMaybe<Vendor_Questionnaire_Ai_Review_Assessments_Aggregate_Order_By>;
  vendor_questionnaire_form_id?: InputMaybe<Order_By>;
};

/** select columns of table "vendor_questionnaire_form_answers" */
export enum Vendor_Questionnaire_Form_Answers_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FieldName = 'field_name',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  VendorQuestionnaireFormId = 'vendor_questionnaire_form_id',
}

/** columns and relationships of "vendor_questionnaire_form_uploads" */
export type Vendor_Questionnaire_Form_Uploads = {
  __typename?: 'vendor_questionnaire_form_uploads';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  /** An object relationship */
  form_answer: Vendor_Questionnaire_Form_Answers;
  id: Scalars['uuid']['output'];
  type: Vq_Form_Upload_Types_Enum;
  updated_at: Scalars['timestamptz']['output'];
  vendor_questionnaire_form_answer_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "vendor_questionnaire_form_uploads" */
export type Vendor_Questionnaire_Form_Uploads_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Questionnaire_Form_Uploads_Max_Order_By>;
  min?: InputMaybe<Vendor_Questionnaire_Form_Uploads_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "vendor_questionnaire_form_uploads". All fields are combined with a logical 'AND'. */
export type Vendor_Questionnaire_Form_Uploads_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Questionnaire_Form_Uploads_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Questionnaire_Form_Uploads_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Questionnaire_Form_Uploads_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  form_answer?: InputMaybe<Vendor_Questionnaire_Form_Answers_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Vq_Form_Upload_Types_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor_questionnaire_form_answer_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "vendor_questionnaire_form_uploads" */
export type Vendor_Questionnaire_Form_Uploads_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_questionnaire_form_answer_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendor_questionnaire_form_uploads" */
export type Vendor_Questionnaire_Form_Uploads_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_questionnaire_form_answer_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vendor_questionnaire_form_uploads". */
export type Vendor_Questionnaire_Form_Uploads_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  form_answer?: InputMaybe<Vendor_Questionnaire_Form_Answers_Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_questionnaire_form_answer_id?: InputMaybe<Order_By>;
};

/** select columns of table "vendor_questionnaire_form_uploads" */
export enum Vendor_Questionnaire_Form_Uploads_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorQuestionnaireFormAnswerId = 'vendor_questionnaire_form_answer_id',
}

/** columns and relationships of "vendor_questionnaire_forms" */
export type Vendor_Questionnaire_Forms = {
  __typename?: 'vendor_questionnaire_forms';
  /** An array relationship */
  answers: Array<Vendor_Questionnaire_Form_Answers>;
  config_snapshot?: Maybe<Scalars['FormConfig']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor_questionnaire: Vendor_Questionnaires;
  vendor_questionnaire_id: Scalars['uuid']['output'];
};

/** columns and relationships of "vendor_questionnaire_forms" */
export type Vendor_Questionnaire_FormsAnswersArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaire_Form_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaire_Form_Answers_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaire_Form_Answers_Bool_Exp>;
};

/** columns and relationships of "vendor_questionnaire_forms" */
export type Vendor_Questionnaire_FormsConfig_SnapshotArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "vendor_questionnaire_forms". All fields are combined with a logical 'AND'. */
export type Vendor_Questionnaire_Forms_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Questionnaire_Forms_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Questionnaire_Forms_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Questionnaire_Forms_Bool_Exp>>;
  answers?: InputMaybe<Vendor_Questionnaire_Form_Answers_Bool_Exp>;
  config_snapshot?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor_questionnaire?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
  vendor_questionnaire_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_questionnaire_forms" */
export enum Vendor_Questionnaire_Forms_Constraint {
  /** unique or primary key constraint on columns "id" */
  VendorQuestionnaireFormsPkey = 'vendor_questionnaire_forms_pkey',
  /** unique or primary key constraint on columns "vendor_questionnaire_id" */
  VendorQuestionnaireFormsVendorQuestionnaireIdKey = 'vendor_questionnaire_forms_vendor_questionnaire_id_key',
  /** unique or primary key constraint on columns "vendor_questionnaire_id", "id" */
  VqFormsIdVendorQuestionnaireIdKey = 'vq_forms_id_vendor_questionnaire_id_key',
}

/** input type for inserting data into table "vendor_questionnaire_forms" */
export type Vendor_Questionnaire_Forms_Insert_Input = {
  config_snapshot?: InputMaybe<Scalars['jsonb']['input']>;
  vendor_questionnaire_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "vendor_questionnaire_forms" */
export type Vendor_Questionnaire_Forms_Mutation_Response = {
  __typename?: 'vendor_questionnaire_forms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Questionnaire_Forms>;
};

/** on_conflict condition type for table "vendor_questionnaire_forms" */
export type Vendor_Questionnaire_Forms_On_Conflict = {
  constraint: Vendor_Questionnaire_Forms_Constraint;
  update_columns?: Array<Vendor_Questionnaire_Forms_Update_Column>;
  where?: InputMaybe<Vendor_Questionnaire_Forms_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_questionnaire_forms". */
export type Vendor_Questionnaire_Forms_Order_By = {
  answers_aggregate?: InputMaybe<Vendor_Questionnaire_Form_Answers_Aggregate_Order_By>;
  config_snapshot?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_questionnaire?: InputMaybe<Vendor_Questionnaires_Order_By>;
  vendor_questionnaire_id?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "vendor_questionnaire_forms" (current role has no relevant permissions) */
export enum Vendor_Questionnaire_Forms_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "vendor_questionnaire_schedules" */
export type Vendor_Questionnaire_Schedules = {
  __typename?: 'vendor_questionnaire_schedules';
  custom_message?: Maybe<Scalars['String']['output']>;
  due_date_offset_ms: Scalars['bigint']['output'];
  frequency: Frequencies_Enum;
  id: Scalars['uuid']['output'];
  last_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  next_send_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  questionnaire: Questionnaires;
  questionnaire_id: Scalars['uuid']['output'];
  /** An object relationship */
  sent_by_user: Users;
  sent_by_user_id: Scalars['uuid']['output'];
  sent_to_email: Scalars['citext']['output'];
  subject: Scalars['String']['output'];
  /** An object relationship */
  vendor: Vendors;
  vendor_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "vendor_questionnaire_schedules". All fields are combined with a logical 'AND'. */
export type Vendor_Questionnaire_Schedules_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Questionnaire_Schedules_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Questionnaire_Schedules_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Questionnaire_Schedules_Bool_Exp>>;
  custom_message?: InputMaybe<String_Comparison_Exp>;
  due_date_offset_ms?: InputMaybe<Bigint_Comparison_Exp>;
  frequency?: InputMaybe<Frequencies_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  next_send_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  questionnaire?: InputMaybe<Questionnaires_Bool_Exp>;
  questionnaire_id?: InputMaybe<Uuid_Comparison_Exp>;
  sent_by_user?: InputMaybe<Users_Bool_Exp>;
  sent_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  sent_to_email?: InputMaybe<Citext_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** response of any mutation on the table "vendor_questionnaire_schedules" */
export type Vendor_Questionnaire_Schedules_Mutation_Response = {
  __typename?: 'vendor_questionnaire_schedules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Questionnaire_Schedules>;
};

/** Ordering options when selecting data from "vendor_questionnaire_schedules". */
export type Vendor_Questionnaire_Schedules_Order_By = {
  custom_message?: InputMaybe<Order_By>;
  due_date_offset_ms?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_sent_at?: InputMaybe<Order_By>;
  next_send_at?: InputMaybe<Order_By>;
  questionnaire?: InputMaybe<Questionnaires_Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  sent_by_user?: InputMaybe<Users_Order_By>;
  sent_by_user_id?: InputMaybe<Order_By>;
  sent_to_email?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vendor_questionnaire_schedules */
export type Vendor_Questionnaire_Schedules_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vendor_questionnaire_schedules" */
export enum Vendor_Questionnaire_Schedules_Select_Column {
  /** column name */
  CustomMessage = 'custom_message',
  /** column name */
  DueDateOffsetMs = 'due_date_offset_ms',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  LastSentAt = 'last_sent_at',
  /** column name */
  NextSendAt = 'next_send_at',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  SentByUserId = 'sent_by_user_id',
  /** column name */
  SentToEmail = 'sent_to_email',
  /** column name */
  Subject = 'subject',
  /** column name */
  VendorId = 'vendor_id',
}

/** input type for updating data in table "vendor_questionnaire_schedules" */
export type Vendor_Questionnaire_Schedules_Set_Input = {
  frequency?: InputMaybe<Frequencies_Enum>;
  next_send_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sent_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  sent_to_email?: InputMaybe<Scalars['citext']['input']>;
};

/** Streaming cursor of the table "vendor_questionnaire_schedules" */
export type Vendor_Questionnaire_Schedules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendor_Questionnaire_Schedules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendor_Questionnaire_Schedules_Stream_Cursor_Value_Input = {
  custom_message?: InputMaybe<Scalars['String']['input']>;
  due_date_offset_ms?: InputMaybe<Scalars['bigint']['input']>;
  frequency?: InputMaybe<Frequencies_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  next_send_at?: InputMaybe<Scalars['timestamptz']['input']>;
  questionnaire_id?: InputMaybe<Scalars['uuid']['input']>;
  sent_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  sent_to_email?: InputMaybe<Scalars['citext']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Vendor_Questionnaire_Schedules_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vendor_Questionnaire_Schedules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vendor_Questionnaire_Schedules_Bool_Exp;
};

export enum Vendor_Questionnaire_Statuses_Enum {
  /** The questionnaire has been created for a vendor and awaiting to be sent */
  Created = 'created',
  /** The questionnaire is due to expire */
  Expiring = 'expiring',
  /** The questionnaire is overdue and not submitted */
  Overdue = 'overdue',
  /** The questionnaire has been submitted to a vendor and awaiting their answer */
  Pending = 'pending',
  /** pending questionnaire are revoked when vendor is terminated or retired */
  Revoked = 'revoked',
  /** The questionnaire answer has been submitted by a vendor */
  Submitted = 'submitted',
}

/** Boolean expression to compare columns of type "vendor_questionnaire_statuses_enum". All fields are combined with logical 'AND'. */
export type Vendor_Questionnaire_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Vendor_Questionnaire_Statuses_Enum>;
  _in?: InputMaybe<Array<Vendor_Questionnaire_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Vendor_Questionnaire_Statuses_Enum>;
  _nin?: InputMaybe<Array<Vendor_Questionnaire_Statuses_Enum>>;
};

/** columns and relationships of "vendor_questionnaire_uploads" */
export type Vendor_Questionnaire_Uploads = {
  __typename?: 'vendor_questionnaire_uploads';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor_questionnaire: Vendor_Questionnaires;
  vendor_questionnaire_id: Scalars['uuid']['output'];
  /** An array relationship */
  vendor_questionnaires_answers: Array<Vendor_Questionnaires>;
};

/** columns and relationships of "vendor_questionnaire_uploads" */
export type Vendor_Questionnaire_UploadsVendor_Questionnaires_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaires_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
};

/** order by aggregate values of table "vendor_questionnaire_uploads" */
export type Vendor_Questionnaire_Uploads_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Questionnaire_Uploads_Max_Order_By>;
  min?: InputMaybe<Vendor_Questionnaire_Uploads_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "vendor_questionnaire_uploads". All fields are combined with a logical 'AND'. */
export type Vendor_Questionnaire_Uploads_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Questionnaire_Uploads_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Questionnaire_Uploads_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Questionnaire_Uploads_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor_questionnaire?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
  vendor_questionnaire_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_questionnaires_answers?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
};

/** order by max() on columns of table "vendor_questionnaire_uploads" */
export type Vendor_Questionnaire_Uploads_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_questionnaire_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendor_questionnaire_uploads" */
export type Vendor_Questionnaire_Uploads_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_questionnaire_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendor_questionnaire_uploads" */
export type Vendor_Questionnaire_Uploads_Mutation_Response = {
  __typename?: 'vendor_questionnaire_uploads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Questionnaire_Uploads>;
};

/** Ordering options when selecting data from "vendor_questionnaire_uploads". */
export type Vendor_Questionnaire_Uploads_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_questionnaire?: InputMaybe<Vendor_Questionnaires_Order_By>;
  vendor_questionnaire_id?: InputMaybe<Order_By>;
  vendor_questionnaires_answers_aggregate?: InputMaybe<Vendor_Questionnaires_Aggregate_Order_By>;
};

/** select columns of table "vendor_questionnaire_uploads" */
export enum Vendor_Questionnaire_Uploads_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorQuestionnaireId = 'vendor_questionnaire_id',
}

/** columns and relationships of "vendor_questionnaires" */
export type Vendor_Questionnaires = {
  __typename?: 'vendor_questionnaires';
  /** An object relationship */
  answer_upload?: Maybe<Vendor_Questionnaire_Uploads>;
  answer_upload_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  comments: Array<Comments>;
  created_at: Scalars['timestamptz']['output'];
  custom_message?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  form?: Maybe<Vendor_Questionnaire_Forms>;
  id: Scalars['uuid']['output'];
  is_disabled: Scalars['Boolean']['output'];
  last_nudged_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  questionnaire: Questionnaires;
  questionnaire_id: Scalars['uuid']['output'];
  /** An array relationship */
  questionnaire_uploads: Array<Questionnaire_Uploads>;
  /** An object relationship */
  schedule?: Maybe<Vendor_Questionnaire_Schedules>;
  send_source: Scalars['String']['output'];
  /** An object relationship */
  sent_by_user: Users;
  sent_by_user_id: Scalars['uuid']['output'];
  sent_to_email: Scalars['citext']['output'];
  /** An object relationship */
  sent_to_user?: Maybe<Users>;
  sent_to_user_id?: Maybe<Scalars['uuid']['output']>;
  status: Vendor_Questionnaire_Statuses_Enum;
  subject?: Maybe<Scalars['String']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  uploads: Array<Vendor_Questionnaire_Uploads>;
  /** An object relationship */
  vendor: Vendors;
  /** An array relationship */
  vendor_findings: Array<Vendor_Findings>;
  vendor_id: Scalars['uuid']['output'];
  /** An array relationship */
  vendor_questionnaires_notifications: Array<Notifications>;
};

/** columns and relationships of "vendor_questionnaires" */
export type Vendor_QuestionnairesCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** columns and relationships of "vendor_questionnaires" */
export type Vendor_QuestionnairesQuestionnaire_UploadsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Uploads_Order_By>>;
  where?: InputMaybe<Questionnaire_Uploads_Bool_Exp>;
};

/** columns and relationships of "vendor_questionnaires" */
export type Vendor_QuestionnairesUploadsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaire_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaire_Uploads_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaire_Uploads_Bool_Exp>;
};

/** columns and relationships of "vendor_questionnaires" */
export type Vendor_QuestionnairesVendor_FindingsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Findings_Order_By>>;
  where?: InputMaybe<Vendor_Findings_Bool_Exp>;
};

/** columns and relationships of "vendor_questionnaires" */
export type Vendor_QuestionnairesVendor_Questionnaires_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** order by aggregate values of table "vendor_questionnaires" */
export type Vendor_Questionnaires_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Questionnaires_Max_Order_By>;
  min?: InputMaybe<Vendor_Questionnaires_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "vendor_questionnaires". All fields are combined with a logical 'AND'. */
export type Vendor_Questionnaires_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Questionnaires_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Questionnaires_Bool_Exp>>;
  answer_upload?: InputMaybe<Vendor_Questionnaire_Uploads_Bool_Exp>;
  answer_upload_id?: InputMaybe<Uuid_Comparison_Exp>;
  comments?: InputMaybe<Comments_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  custom_message?: InputMaybe<String_Comparison_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  form?: InputMaybe<Vendor_Questionnaire_Forms_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_disabled?: InputMaybe<Boolean_Comparison_Exp>;
  last_nudged_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  questionnaire?: InputMaybe<Questionnaires_Bool_Exp>;
  questionnaire_id?: InputMaybe<Uuid_Comparison_Exp>;
  questionnaire_uploads?: InputMaybe<Questionnaire_Uploads_Bool_Exp>;
  schedule?: InputMaybe<Vendor_Questionnaire_Schedules_Bool_Exp>;
  send_source?: InputMaybe<String_Comparison_Exp>;
  sent_by_user?: InputMaybe<Users_Bool_Exp>;
  sent_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  sent_to_email?: InputMaybe<Citext_Comparison_Exp>;
  sent_to_user?: InputMaybe<Users_Bool_Exp>;
  sent_to_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Vendor_Questionnaire_Statuses_Enum_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploads?: InputMaybe<Vendor_Questionnaire_Uploads_Bool_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_findings?: InputMaybe<Vendor_Findings_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_questionnaires_notifications?: InputMaybe<Notifications_Bool_Exp>;
};

/** order by max() on columns of table "vendor_questionnaires" */
export type Vendor_Questionnaires_Max_Order_By = {
  answer_upload_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_message?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  send_source?: InputMaybe<Order_By>;
  sent_by_user_id?: InputMaybe<Order_By>;
  sent_to_email?: InputMaybe<Order_By>;
  sent_to_user_id?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendor_questionnaires" */
export type Vendor_Questionnaires_Min_Order_By = {
  answer_upload_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_message?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  send_source?: InputMaybe<Order_By>;
  sent_by_user_id?: InputMaybe<Order_By>;
  sent_to_email?: InputMaybe<Order_By>;
  sent_to_user_id?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendor_questionnaires" */
export type Vendor_Questionnaires_Mutation_Response = {
  __typename?: 'vendor_questionnaires_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Questionnaires>;
};

/** Ordering options when selecting data from "vendor_questionnaires". */
export type Vendor_Questionnaires_Order_By = {
  answer_upload?: InputMaybe<Vendor_Questionnaire_Uploads_Order_By>;
  answer_upload_id?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_message?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  form?: InputMaybe<Vendor_Questionnaire_Forms_Order_By>;
  id?: InputMaybe<Order_By>;
  is_disabled?: InputMaybe<Order_By>;
  last_nudged_at?: InputMaybe<Order_By>;
  questionnaire?: InputMaybe<Questionnaires_Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_uploads_aggregate?: InputMaybe<Questionnaire_Uploads_Aggregate_Order_By>;
  schedule?: InputMaybe<Vendor_Questionnaire_Schedules_Order_By>;
  send_source?: InputMaybe<Order_By>;
  sent_by_user?: InputMaybe<Users_Order_By>;
  sent_by_user_id?: InputMaybe<Order_By>;
  sent_to_email?: InputMaybe<Order_By>;
  sent_to_user?: InputMaybe<Users_Order_By>;
  sent_to_user_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploads_aggregate?: InputMaybe<Vendor_Questionnaire_Uploads_Aggregate_Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_findings_aggregate?: InputMaybe<Vendor_Findings_Aggregate_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_questionnaires_notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
};

/** primary key columns input for table: vendor_questionnaires */
export type Vendor_Questionnaires_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vendor_questionnaires" */
export enum Vendor_Questionnaires_Select_Column {
  /** column name */
  AnswerUploadId = 'answer_upload_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomMessage = 'custom_message',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsDisabled = 'is_disabled',
  /** column name */
  LastNudgedAt = 'last_nudged_at',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  SendSource = 'send_source',
  /** column name */
  SentByUserId = 'sent_by_user_id',
  /** column name */
  SentToEmail = 'sent_to_email',
  /** column name */
  SentToUserId = 'sent_to_user_id',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorId = 'vendor_id',
}

/** input type for updating data in table "vendor_questionnaires" */
export type Vendor_Questionnaires_Set_Input = {
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  last_nudged_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Vendor_Questionnaire_Statuses_Enum>;
};

/** Streaming cursor of the table "vendor_questionnaires" */
export type Vendor_Questionnaires_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendor_Questionnaires_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendor_Questionnaires_Stream_Cursor_Value_Input = {
  answer_upload_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_message?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_nudged_at?: InputMaybe<Scalars['timestamptz']['input']>;
  questionnaire_id?: InputMaybe<Scalars['uuid']['input']>;
  send_source?: InputMaybe<Scalars['String']['input']>;
  sent_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  sent_to_email?: InputMaybe<Scalars['citext']['input']>;
  sent_to_user_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Vendor_Questionnaire_Statuses_Enum>;
  subject?: InputMaybe<Scalars['String']['input']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Vendor_Questionnaires_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vendor_Questionnaires_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vendor_Questionnaires_Bool_Exp;
};

/** columns and relationships of "vendor_risks" */
export type Vendor_Risks = {
  __typename?: 'vendor_risks';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  risk?: Maybe<Risks>;
  risk_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor?: Maybe<Vendors>;
  vendor_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "vendor_risks" */
export type Vendor_Risks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Risks_Max_Order_By>;
  min?: InputMaybe<Vendor_Risks_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vendor_risks" */
export type Vendor_Risks_Arr_Rel_Insert_Input = {
  data: Array<Vendor_Risks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_Risks_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vendor_risks". All fields are combined with a logical 'AND'. */
export type Vendor_Risks_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Risks_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Risks_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Risks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  risk?: InputMaybe<Risks_Bool_Exp>;
  risk_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_risks" */
export enum Vendor_Risks_Constraint {
  /** unique or primary key constraint on columns "id" */
  VendorRisksPkey = 'vendor_risks_pkey',
  /** unique or primary key constraint on columns "risk_id", "vendor_id" */
  VendorRisksVendorIdRiskIdKey = 'vendor_risks_vendor_id_risk_id_key',
}

/** input type for inserting data into table "vendor_risks" */
export type Vendor_Risks_Insert_Input = {
  risk?: InputMaybe<Risks_Obj_Rel_Insert_Input>;
  risk_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor?: InputMaybe<Vendors_Obj_Rel_Insert_Input>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "vendor_risks" */
export type Vendor_Risks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendor_risks" */
export type Vendor_Risks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendor_risks" */
export type Vendor_Risks_Mutation_Response = {
  __typename?: 'vendor_risks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Risks>;
};

/** on_conflict condition type for table "vendor_risks" */
export type Vendor_Risks_On_Conflict = {
  constraint: Vendor_Risks_Constraint;
  update_columns?: Array<Vendor_Risks_Update_Column>;
  where?: InputMaybe<Vendor_Risks_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_risks". */
export type Vendor_Risks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk?: InputMaybe<Risks_Order_By>;
  risk_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** select columns of table "vendor_risks" */
export enum Vendor_Risks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RiskId = 'risk_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorId = 'vendor_id',
}

/** placeholder for update columns of table "vendor_risks" (current role has no relevant permissions) */
export enum Vendor_Risks_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** Stores list of tasks linked with vendors */
export type Vendor_Tasks = {
  __typename?: 'vendor_tasks';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  task?: Maybe<Tasks>;
  task_id: Scalars['uuid']['output'];
  /** An object relationship */
  vendor?: Maybe<Vendors>;
  vendor_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "vendor_tasks" */
export type Vendor_Tasks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Tasks_Max_Order_By>;
  min?: InputMaybe<Vendor_Tasks_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vendor_tasks" */
export type Vendor_Tasks_Arr_Rel_Insert_Input = {
  data: Array<Vendor_Tasks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_Tasks_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vendor_tasks". All fields are combined with a logical 'AND'. */
export type Vendor_Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Tasks_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Tasks_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_tasks" */
export enum Vendor_Tasks_Constraint {
  /** unique or primary key constraint on columns "id" */
  VendorTasksPkey = 'vendor_tasks_pkey',
  /** unique or primary key constraint on columns "task_id", "vendor_id" */
  VendorTasksVendorIdTaskIdKey = 'vendor_tasks_vendor_id_task_id_key',
}

/** input type for inserting data into table "vendor_tasks" */
export type Vendor_Tasks_Insert_Input = {
  task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor?: InputMaybe<Vendors_Obj_Rel_Insert_Input>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "vendor_tasks" */
export type Vendor_Tasks_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendor_tasks" */
export type Vendor_Tasks_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendor_tasks" */
export type Vendor_Tasks_Mutation_Response = {
  __typename?: 'vendor_tasks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Tasks>;
};

/** on_conflict condition type for table "vendor_tasks" */
export type Vendor_Tasks_On_Conflict = {
  constraint: Vendor_Tasks_Constraint;
  update_columns?: Array<Vendor_Tasks_Update_Column>;
  where?: InputMaybe<Vendor_Tasks_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_tasks". */
export type Vendor_Tasks_Order_By = {
  id?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** select columns of table "vendor_tasks" */
export enum Vendor_Tasks_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  VendorId = 'vendor_id',
}

/** placeholder for update columns of table "vendor_tasks" (current role has no relevant permissions) */
export enum Vendor_Tasks_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER',
}

/** columns and relationships of "vendors" */
export type Vendors = {
  __typename?: 'vendors';
  approval_status?: Maybe<Vendor_Approval_Statuses_Enum>;
  assessment_status: Scalars['VendorAssessmentStatus']['output'];
  contact_email?: Maybe<Scalars['citext']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  documents: Array<Vendor_Documents>;
  /** An array relationship */
  field_values: Array<Field_Values>;
  id: Scalars['uuid']['output'];
  internal_id?: Maybe<Scalars['String']['output']>;
  /** Date of the latest completed approval */
  last_approved_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "get_vendor_last_review_date" */
  last_review_date?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Next scheduled approval date based on expiration of latest completed approval */
  next_approval_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  questionnaires: Array<Vendor_Questionnaires>;
  requested_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  requested_by_user?: Maybe<Users>;
  review_frequency: Frequencies_Enum;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** An object relationship */
  risk_level?: Maybe<Organization_Vendor_Risk_Levels>;
  risk_level_id?: Maybe<Scalars['uuid']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  /** An array relationship */
  source_entity_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  source_entity_relations_aggregate: Entity_Relations_Aggregate;
  /** An array relationship */
  target_entity_relations: Array<Entity_Relations>;
  /** An aggregate relationship */
  target_entity_relations_aggregate: Entity_Relations_Aggregate;
  /** An array relationship */
  tasks: Array<Vendor_Tasks>;
  terminated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  tier?: Maybe<Organization_Vendor_Tiers>;
  tier_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  vendor_approvals: Array<Vendor_Approvals>;
  /** An aggregate relationship */
  vendor_approvals_aggregate: Vendor_Approvals_Aggregate;
  /** An array relationship */
  vendor_findings: Array<Vendor_Findings>;
  /** An array relationship */
  vendor_owners: Array<Vendor_Owners>;
  /** An array relationship */
  vendor_risks: Array<Vendor_Risks>;
  /** An array relationship */
  vendors_comments: Array<Comments>;
  /** An array relationship */
  vendors_notifications: Array<Notifications>;
  /** An array relationship */
  vendors_vector_stores: Array<Ai_Vendors_Vector_Store>;
};

/** columns and relationships of "vendors" */
export type VendorsDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Documents_Order_By>>;
  where?: InputMaybe<Vendor_Documents_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsField_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Field_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Values_Order_By>>;
  where?: InputMaybe<Field_Values_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsQuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Questionnaires_Order_By>>;
  where?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsSource_Entity_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsSource_Entity_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsTarget_Entity_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsTarget_Entity_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Relations_Order_By>>;
  where?: InputMaybe<Entity_Relations_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsTasksArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Tasks_Order_By>>;
  where?: InputMaybe<Vendor_Tasks_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsVendor_ApprovalsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Approvals_Order_By>>;
  where?: InputMaybe<Vendor_Approvals_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsVendor_Approvals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Approvals_Order_By>>;
  where?: InputMaybe<Vendor_Approvals_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsVendor_FindingsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Findings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Findings_Order_By>>;
  where?: InputMaybe<Vendor_Findings_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsVendor_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Owners_Order_By>>;
  where?: InputMaybe<Vendor_Owners_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsVendor_RisksArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Risks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Risks_Order_By>>;
  where?: InputMaybe<Vendor_Risks_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsVendors_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsVendors_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** columns and relationships of "vendors" */
export type VendorsVendors_Vector_StoresArgs = {
  distinct_on?: InputMaybe<Array<Ai_Vendors_Vector_Store_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Vendors_Vector_Store_Order_By>>;
  where?: InputMaybe<Ai_Vendors_Vector_Store_Bool_Exp>;
};

/** aggregated selection of "vendors" */
export type Vendors_Aggregate = {
  __typename?: 'vendors_aggregate';
  aggregate?: Maybe<Vendors_Aggregate_Fields>;
  nodes: Array<Vendors>;
};

export type Vendors_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Vendors_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Vendors_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Vendors_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Vendors_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Vendors_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Vendors_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Vendors_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Vendors_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Vendors_Aggregate_Bool_Exp_Var_Samp>;
};

export type Vendors_Aggregate_Bool_Exp_Avg = {
  arguments: Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendors_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vendors_Aggregate_Bool_Exp_Corr = {
  arguments: Vendors_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendors_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vendors_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Vendors_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vendors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Vendors_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Vendors_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendors_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vendors_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Vendors_Aggregate_Bool_Exp_Max = {
  arguments: Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendors_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vendors_Aggregate_Bool_Exp_Min = {
  arguments: Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendors_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vendors_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendors_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vendors_Aggregate_Bool_Exp_Sum = {
  arguments: Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendors_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vendors_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendors_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "vendors" */
export type Vendors_Aggregate_Fields = {
  __typename?: 'vendors_aggregate_fields';
  avg?: Maybe<Vendors_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vendors_Max_Fields>;
  min?: Maybe<Vendors_Min_Fields>;
  stddev?: Maybe<Vendors_Stddev_Fields>;
  stddev_pop?: Maybe<Vendors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vendors_Stddev_Samp_Fields>;
  sum?: Maybe<Vendors_Sum_Fields>;
  var_pop?: Maybe<Vendors_Var_Pop_Fields>;
  var_samp?: Maybe<Vendors_Var_Samp_Fields>;
  variance?: Maybe<Vendors_Variance_Fields>;
};

/** aggregate fields of "vendors" */
export type Vendors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vendors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vendors" */
export type Vendors_Aggregate_Order_By = {
  avg?: InputMaybe<Vendors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendors_Max_Order_By>;
  min?: InputMaybe<Vendors_Min_Order_By>;
  stddev?: InputMaybe<Vendors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vendors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vendors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vendors_Sum_Order_By>;
  var_pop?: InputMaybe<Vendors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vendors_Var_Samp_Order_By>;
  variance?: InputMaybe<Vendors_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vendors" */
export type Vendors_Arr_Rel_Insert_Input = {
  data: Array<Vendors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendors_On_Conflict>;
};

/** aggregate avg on columns */
export type Vendors_Avg_Fields = {
  __typename?: 'vendors_avg_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vendors" */
export type Vendors_Avg_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vendors". All fields are combined with a logical 'AND'. */
export type Vendors_Bool_Exp = {
  _and?: InputMaybe<Array<Vendors_Bool_Exp>>;
  _not?: InputMaybe<Vendors_Bool_Exp>;
  _or?: InputMaybe<Array<Vendors_Bool_Exp>>;
  approval_status?: InputMaybe<Vendor_Approval_Statuses_Enum_Comparison_Exp>;
  assessment_status?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<Citext_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  documents?: InputMaybe<Vendor_Documents_Bool_Exp>;
  field_values?: InputMaybe<Field_Values_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_id?: InputMaybe<String_Comparison_Exp>;
  last_approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_review_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  next_approval_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  questionnaires?: InputMaybe<Vendor_Questionnaires_Bool_Exp>;
  requested_by?: InputMaybe<Uuid_Comparison_Exp>;
  requested_by_user?: InputMaybe<Users_Bool_Exp>;
  review_frequency?: InputMaybe<Frequencies_Enum_Comparison_Exp>;
  reviews?: InputMaybe<Reviews_Bool_Exp>;
  risk_level?: InputMaybe<Organization_Vendor_Risk_Levels_Bool_Exp>;
  risk_level_id?: InputMaybe<Uuid_Comparison_Exp>;
  similarity?: InputMaybe<Float8_Comparison_Exp>;
  source_entity_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  source_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  target_entity_relations?: InputMaybe<Entity_Relations_Bool_Exp>;
  target_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Bool_Exp>;
  tasks?: InputMaybe<Vendor_Tasks_Bool_Exp>;
  terminated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  tier?: InputMaybe<Organization_Vendor_Tiers_Bool_Exp>;
  tier_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor_approvals?: InputMaybe<Vendor_Approvals_Bool_Exp>;
  vendor_approvals_aggregate?: InputMaybe<Vendor_Approvals_Aggregate_Bool_Exp>;
  vendor_findings?: InputMaybe<Vendor_Findings_Bool_Exp>;
  vendor_owners?: InputMaybe<Vendor_Owners_Bool_Exp>;
  vendor_risks?: InputMaybe<Vendor_Risks_Bool_Exp>;
  vendors_comments?: InputMaybe<Comments_Bool_Exp>;
  vendors_notifications?: InputMaybe<Notifications_Bool_Exp>;
  vendors_vector_stores?: InputMaybe<Ai_Vendors_Vector_Store_Bool_Exp>;
};

/** unique or primary key constraints on table "vendors" */
export enum Vendors_Constraint {
  /** unique or primary key constraint on columns "id", "organization_id" */
  VendorsIdOrganizationIdKey = 'vendors_id_organization_id_key',
  /** unique or primary key constraint on columns "organization_id", "internal_id" */
  VendorsOrganizationIdInternalIdKey = 'vendors_organization_id_internal_id_key',
  /** unique or primary key constraint on columns "id" */
  VendorsPkey = 'vendors_pkey',
}

/** input type for inserting data into table "vendors" */
export type Vendors_Insert_Input = {
  contact_email?: InputMaybe<Scalars['citext']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Vendor_Documents_Arr_Rel_Insert_Input>;
  field_values?: InputMaybe<Field_Values_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  requested_by?: InputMaybe<Scalars['uuid']['input']>;
  review_frequency?: InputMaybe<Frequencies_Enum>;
  reviews?: InputMaybe<Reviews_Arr_Rel_Insert_Input>;
  risk_level?: InputMaybe<Organization_Vendor_Risk_Levels_Obj_Rel_Insert_Input>;
  risk_level_id?: InputMaybe<Scalars['uuid']['input']>;
  source_entity_relations?: InputMaybe<Entity_Relations_Arr_Rel_Insert_Input>;
  target_entity_relations?: InputMaybe<Entity_Relations_Arr_Rel_Insert_Input>;
  tasks?: InputMaybe<Vendor_Tasks_Arr_Rel_Insert_Input>;
  tier?: InputMaybe<Organization_Vendor_Tiers_Obj_Rel_Insert_Input>;
  tier_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_approvals?: InputMaybe<Vendor_Approvals_Arr_Rel_Insert_Input>;
  vendor_owners?: InputMaybe<Vendor_Owners_Arr_Rel_Insert_Input>;
  vendor_risks?: InputMaybe<Vendor_Risks_Arr_Rel_Insert_Input>;
  vendors_comments?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Vendors_Max_Fields = {
  __typename?: 'vendors_max_fields';
  assessment_status?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['citext']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  /** Date of the latest completed approval */
  last_approved_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "get_vendor_last_review_date" */
  last_review_date?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Next scheduled approval date based on expiration of latest completed approval */
  next_approval_at?: Maybe<Scalars['timestamptz']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  requested_by?: Maybe<Scalars['uuid']['output']>;
  risk_level_id?: Maybe<Scalars['uuid']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  terminated_at?: Maybe<Scalars['timestamptz']['output']>;
  tier_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "vendors" */
export type Vendors_Max_Order_By = {
  assessment_status?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  /** Date of the latest completed approval */
  last_approved_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Next scheduled approval date based on expiration of latest completed approval */
  next_approval_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  requested_by?: InputMaybe<Order_By>;
  risk_level_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  terminated_at?: InputMaybe<Order_By>;
  tier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vendors_Min_Fields = {
  __typename?: 'vendors_min_fields';
  assessment_status?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['citext']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['String']['output']>;
  /** Date of the latest completed approval */
  last_approved_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "get_vendor_last_review_date" */
  last_review_date?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Next scheduled approval date based on expiration of latest completed approval */
  next_approval_at?: Maybe<Scalars['timestamptz']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  requested_by?: Maybe<Scalars['uuid']['output']>;
  risk_level_id?: Maybe<Scalars['uuid']['output']>;
  similarity?: Maybe<Scalars['float8']['output']>;
  terminated_at?: Maybe<Scalars['timestamptz']['output']>;
  tier_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "vendors" */
export type Vendors_Min_Order_By = {
  assessment_status?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  /** Date of the latest completed approval */
  last_approved_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Next scheduled approval date based on expiration of latest completed approval */
  next_approval_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  requested_by?: InputMaybe<Order_By>;
  risk_level_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  terminated_at?: InputMaybe<Order_By>;
  tier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendors" */
export type Vendors_Mutation_Response = {
  __typename?: 'vendors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendors>;
};

/** input type for inserting object relation for remote table "vendors" */
export type Vendors_Obj_Rel_Insert_Input = {
  data: Vendors_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendors_On_Conflict>;
};

/** on_conflict condition type for table "vendors" */
export type Vendors_On_Conflict = {
  constraint: Vendors_Constraint;
  update_columns?: Array<Vendors_Update_Column>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};

/** Ordering options when selecting data from "vendors". */
export type Vendors_Order_By = {
  approval_status?: InputMaybe<Order_By>;
  assessment_status?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Vendor_Documents_Aggregate_Order_By>;
  field_values_aggregate?: InputMaybe<Field_Values_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_approved_at?: InputMaybe<Order_By>;
  last_review_date?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  next_approval_at?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  questionnaires_aggregate?: InputMaybe<Vendor_Questionnaires_Aggregate_Order_By>;
  requested_by?: InputMaybe<Order_By>;
  requested_by_user?: InputMaybe<Users_Order_By>;
  review_frequency?: InputMaybe<Order_By>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Order_By>;
  risk_level?: InputMaybe<Organization_Vendor_Risk_Levels_Order_By>;
  risk_level_id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  source_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  target_entity_relations_aggregate?: InputMaybe<Entity_Relations_Aggregate_Order_By>;
  tasks_aggregate?: InputMaybe<Vendor_Tasks_Aggregate_Order_By>;
  terminated_at?: InputMaybe<Order_By>;
  tier?: InputMaybe<Organization_Vendor_Tiers_Order_By>;
  tier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_approvals_aggregate?: InputMaybe<Vendor_Approvals_Aggregate_Order_By>;
  vendor_findings_aggregate?: InputMaybe<Vendor_Findings_Aggregate_Order_By>;
  vendor_owners_aggregate?: InputMaybe<Vendor_Owners_Aggregate_Order_By>;
  vendor_risks_aggregate?: InputMaybe<Vendor_Risks_Aggregate_Order_By>;
  vendors_comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  vendors_notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  vendors_vector_stores_aggregate?: InputMaybe<Ai_Vendors_Vector_Store_Aggregate_Order_By>;
};

/** primary key columns input for table: vendors */
export type Vendors_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vendors" */
export enum Vendors_Select_Column {
  /** column name */
  ApprovalStatus = 'approval_status',
  /** column name */
  AssessmentStatus = 'assessment_status',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  LastApprovedAt = 'last_approved_at',
  /** column name */
  Name = 'name',
  /** column name */
  NextApprovalAt = 'next_approval_at',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RequestedBy = 'requested_by',
  /** column name */
  ReviewFrequency = 'review_frequency',
  /** column name */
  RiskLevelId = 'risk_level_id',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  TerminatedAt = 'terminated_at',
  /** column name */
  TierId = 'tier_id',
  /** column name */
  UpdatedAt = 'updated_at',
}

/** select "vendors_aggregate_bool_exp_avg_arguments_columns" columns of table "vendors" */
export enum Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "vendors_aggregate_bool_exp_corr_arguments_columns" columns of table "vendors" */
export enum Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "vendors_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "vendors" */
export enum Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "vendors_aggregate_bool_exp_max_arguments_columns" columns of table "vendors" */
export enum Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "vendors_aggregate_bool_exp_min_arguments_columns" columns of table "vendors" */
export enum Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "vendors_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "vendors" */
export enum Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "vendors_aggregate_bool_exp_sum_arguments_columns" columns of table "vendors" */
export enum Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** select "vendors_aggregate_bool_exp_var_samp_arguments_columns" columns of table "vendors" */
export enum Vendors_Select_Column_Vendors_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Similarity = 'similarity',
}

/** input type for updating data in table "vendors" */
export type Vendors_Set_Input = {
  contact_email?: InputMaybe<Scalars['citext']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  review_frequency?: InputMaybe<Frequencies_Enum>;
  risk_level_id?: InputMaybe<Scalars['uuid']['input']>;
  terminated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  tier_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Vendors_Stddev_Fields = {
  __typename?: 'vendors_stddev_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vendors" */
export type Vendors_Stddev_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vendors_Stddev_Pop_Fields = {
  __typename?: 'vendors_stddev_pop_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vendors" */
export type Vendors_Stddev_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vendors_Stddev_Samp_Fields = {
  __typename?: 'vendors_stddev_samp_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vendors" */
export type Vendors_Stddev_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vendors" */
export type Vendors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendors_Stream_Cursor_Value_Input = {
  approval_status?: InputMaybe<Vendor_Approval_Statuses_Enum>;
  assessment_status?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['citext']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_id?: InputMaybe<Scalars['String']['input']>;
  /** Date of the latest completed approval */
  last_approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Next scheduled approval date based on expiration of latest completed approval */
  next_approval_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  requested_by?: InputMaybe<Scalars['uuid']['input']>;
  review_frequency?: InputMaybe<Frequencies_Enum>;
  risk_level_id?: InputMaybe<Scalars['uuid']['input']>;
  similarity?: InputMaybe<Scalars['float8']['input']>;
  terminated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  tier_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Vendors_Sum_Fields = {
  __typename?: 'vendors_sum_fields';
  similarity?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "vendors" */
export type Vendors_Sum_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** update columns of table "vendors" */
export enum Vendors_Update_Column {
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  ReviewFrequency = 'review_frequency',
  /** column name */
  RiskLevelId = 'risk_level_id',
  /** column name */
  TerminatedAt = 'terminated_at',
  /** column name */
  TierId = 'tier_id',
}

export type Vendors_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vendors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vendors_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Vendors_Var_Pop_Fields = {
  __typename?: 'vendors_var_pop_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vendors" */
export type Vendors_Var_Pop_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vendors_Var_Samp_Fields = {
  __typename?: 'vendors_var_samp_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vendors" */
export type Vendors_Var_Samp_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vendors_Variance_Fields = {
  __typename?: 'vendors_variance_fields';
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vendors" */
export type Vendors_Variance_Order_By = {
  similarity?: InputMaybe<Order_By>;
};

/** columns and relationships of "vq_custom_fields" */
export type Vq_Custom_Fields = {
  __typename?: 'vq_custom_fields';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  field_config: Field_Configs;
  field_config_id: Scalars['uuid']['output'];
  field_entity_name: Scalars['String']['output'];
  field_name: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  questionnaire: Questionnaires;
  questionnaire_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "vq_custom_fields" */
export type Vq_Custom_Fields_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vq_Custom_Fields_Max_Order_By>;
  min?: InputMaybe<Vq_Custom_Fields_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vq_custom_fields" */
export type Vq_Custom_Fields_Arr_Rel_Insert_Input = {
  data: Array<Vq_Custom_Fields_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vq_Custom_Fields_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vq_custom_fields". All fields are combined with a logical 'AND'. */
export type Vq_Custom_Fields_Bool_Exp = {
  _and?: InputMaybe<Array<Vq_Custom_Fields_Bool_Exp>>;
  _not?: InputMaybe<Vq_Custom_Fields_Bool_Exp>;
  _or?: InputMaybe<Array<Vq_Custom_Fields_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  field_config?: InputMaybe<Field_Configs_Bool_Exp>;
  field_config_id?: InputMaybe<Uuid_Comparison_Exp>;
  field_entity_name?: InputMaybe<String_Comparison_Exp>;
  field_name?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  questionnaire?: InputMaybe<Questionnaires_Bool_Exp>;
  questionnaire_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vq_custom_fields" */
export enum Vq_Custom_Fields_Constraint {
  /** unique or primary key constraint on columns "id" */
  VqCustomFieldsPkey = 'vq_custom_fields_pkey',
  /** unique or primary key constraint on columns "field_config_id", "field_entity_name", "questionnaire_id" */
  VqCustomFieldsQuestionnaireIdFieldConfigIdFieldEntKey = 'vq_custom_fields_questionnaire_id_field_config_id_field_ent_key',
  /** unique or primary key constraint on columns "questionnaire_id", "field_name" */
  VqCustomFieldsQuestionnaireIdFieldNameKey = 'vq_custom_fields_questionnaire_id_field_name_key',
}

/** input type for inserting data into table "vq_custom_fields" */
export type Vq_Custom_Fields_Insert_Input = {
  field_config?: InputMaybe<Field_Configs_Obj_Rel_Insert_Input>;
  field_config_id?: InputMaybe<Scalars['uuid']['input']>;
  field_entity_name?: InputMaybe<Scalars['String']['input']>;
  field_name?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire?: InputMaybe<Questionnaires_Obj_Rel_Insert_Input>;
  questionnaire_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "vq_custom_fields" */
export type Vq_Custom_Fields_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_config_id?: InputMaybe<Order_By>;
  field_entity_name?: InputMaybe<Order_By>;
  field_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vq_custom_fields" */
export type Vq_Custom_Fields_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_config_id?: InputMaybe<Order_By>;
  field_entity_name?: InputMaybe<Order_By>;
  field_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vq_custom_fields" */
export type Vq_Custom_Fields_Mutation_Response = {
  __typename?: 'vq_custom_fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vq_Custom_Fields>;
};

/** on_conflict condition type for table "vq_custom_fields" */
export type Vq_Custom_Fields_On_Conflict = {
  constraint: Vq_Custom_Fields_Constraint;
  update_columns?: Array<Vq_Custom_Fields_Update_Column>;
  where?: InputMaybe<Vq_Custom_Fields_Bool_Exp>;
};

/** Ordering options when selecting data from "vq_custom_fields". */
export type Vq_Custom_Fields_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_config?: InputMaybe<Field_Configs_Order_By>;
  field_config_id?: InputMaybe<Order_By>;
  field_entity_name?: InputMaybe<Order_By>;
  field_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire?: InputMaybe<Questionnaires_Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vq_custom_fields */
export type Vq_Custom_Fields_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vq_custom_fields" */
export enum Vq_Custom_Fields_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FieldConfigId = 'field_config_id',
  /** column name */
  FieldEntityName = 'field_entity_name',
  /** column name */
  FieldName = 'field_name',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
}

/** input type for updating data in table "vq_custom_fields" */
export type Vq_Custom_Fields_Set_Input = {
  field_config_id?: InputMaybe<Scalars['uuid']['input']>;
  field_entity_name?: InputMaybe<Scalars['String']['input']>;
  field_name?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "vq_custom_fields" */
export type Vq_Custom_Fields_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vq_Custom_Fields_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vq_Custom_Fields_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  field_config_id?: InputMaybe<Scalars['uuid']['input']>;
  field_entity_name?: InputMaybe<Scalars['String']['input']>;
  field_name?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "vq_custom_fields" */
export enum Vq_Custom_Fields_Update_Column {
  /** column name */
  FieldConfigId = 'field_config_id',
  /** column name */
  FieldEntityName = 'field_entity_name',
  /** column name */
  FieldName = 'field_name',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
}

export type Vq_Custom_Fields_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vq_Custom_Fields_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vq_Custom_Fields_Bool_Exp;
};

export enum Vq_Form_Upload_Types_Enum {
  /** File upload is a question answer */
  Answer = 'Answer',
  /** File upload is a supporting document */
  Support = 'Support',
}

/** Boolean expression to compare columns of type "vq_form_upload_types_enum". All fields are combined with logical 'AND'. */
export type Vq_Form_Upload_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Vq_Form_Upload_Types_Enum>;
  _in?: InputMaybe<Array<Vq_Form_Upload_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Vq_Form_Upload_Types_Enum>;
  _nin?: InputMaybe<Array<Vq_Form_Upload_Types_Enum>>;
};
